import React__default, { createElement, useState, useEffect, useMemo, forwardRef, cloneElement, useContext } from 'react';
import { createMuiTheme, MuiThemeProvider, withStyles, makeStyles, emphasize } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import 'typeface-roboto';
import clsx from 'clsx';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import grey from '@material-ui/core/colors/grey';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import Avatar from '@material-ui/core/Avatar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ButtonBase from '@material-ui/core/ButtonBase';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Select from '@material-ui/core/Select';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import MovieIcon from '@material-ui/icons/Movie';
import AudioTrackIcon from '@material-ui/icons/Audiotrack';
import ImageIcon from '@material-ui/icons/Image';
import FolderIcon from '@material-ui/icons/Folder';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import { Dialog, DialogTitle, DialogActions, Button, FormControl as FormControl$1, FormHelperText as FormHelperText$1, withStyles as withStyles$1, Typography as Typography$1, Divider, DialogContent, LinearProgress, useFormControl, Box as Box$1, Tooltip as Tooltip$1, IconButton as IconButton$1, TableRow as TableRow$3, TableCell, CircularProgress as CircularProgress$1, TableContainer, Table, TableHead as TableHead$1, TableBody, AppBar, Accordion as Accordion$1, AccordionSummary as AccordionSummary$1, Select as Select$1, MenuItem as MenuItem$1, AccordionDetails as AccordionDetails$1, InputBase, InputAdornment, Menu as Menu$1, Card, CardHeader, Collapse as Collapse$1, CardContent, ButtonBase as ButtonBase$1, ListItemIcon, ListItemText as ListItemText$1, ListItem, List, RootRef, ListItemAvatar, ListItemSecondaryAction, Paper as Paper$1, DialogContentText as DialogContentText$1, ListSubheader as ListSubheader$1, TextField as TextField$3 } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { Field, Form, FormSpy } from 'react-final-form';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import InputLabel from '@material-ui/core/InputLabel';
import TextField$2 from '@material-ui/core/TextField';
import MUISlider from '@material-ui/core/Slider';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { Autocomplete as Autocomplete$1 } from '@material-ui/lab';
import { analyzepreset, resource, item, shape, vidinet, utils, user, job, taskdefinition, shapetag, metadata, access, group, fieldgroup, collection, subtitle, vsimport, metadatafield, file, storage, globalmetadata, search } from '@vidispine/vdt-api';
import { useApi, HasRole, GetItem, useEntityAccess, useAddMetadataFieldAttributes, MetadataType as MetadataType$1, useThumbnailScrub, useMouseDownPosition, compose, GetCollection, useSearch, SearchCollection, useGetEntity, useGetCollection, SearchItem, useSavedSearch, handleMoveEntity, useUploadFiles } from '@vidispine/vdt-react';
import Box from '@material-ui/core/Box';
import Button$1 from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FORM_ERROR } from 'final-form';
import Paper from '@material-ui/core/Paper';
import { parseFacetType, parseNowDate, formatSeconds, roles, parseShapeType, parseTranscodePreset, formatTimeBase, formatSmpte, createMetadataType, formatTimeCodeText, formatTimeCodeType, parseTimespan, sortTimespanList, metadataTypeToWebVtt, filterShapeSource, getShapeMediaType, parseMetadataType, parseContainerComponent, parseAudioComponent, parseVideoComponent, parseSimpleMetadataType, findTimespan, findNearestThumbnail, parseHighlightTimespanList } from '@vidispine/vdt-js';
import CancelIcon from '@material-ui/icons/Cancel';
import { Cancel, CheckCircle, Replay, ExpandLess, Label, Search, Delete, Block, ExpandMore, Folder, Add, Visibility as Visibility$1, VisibilityOff as VisibilityOff$1 } from '@material-ui/icons';
import moment from 'moment';
import { red, green, grey as grey$1 } from '@material-ui/core/colors';
import Chip$1 from '@material-ui/core/Chip';
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import { fade } from '@material-ui/core/styles/colorManipulator';
import ListItemText from '@material-ui/core/ListItemText';
import Table$1 from '@material-ui/core/Table';
import TableBody$1 from '@material-ui/core/TableBody';
import TableCell$1 from '@material-ui/core/TableCell';
import TableRow$3$1 from '@material-ui/core/TableRow';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DialogTitle$1 from '@material-ui/core/DialogTitle';
import DialogContent$1 from '@material-ui/core/DialogContent';
import Tabs$1 from '@material-ui/core/Tabs';
import Tab$1 from '@material-ui/core/Tab';
import ClearIcon from '@material-ui/icons/Clear';
import InputAdornment$1 from '@material-ui/core/InputAdornment';
import SvgIcon from '@material-ui/core/SvgIcon';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import LinearProgress$1 from '@material-ui/core/LinearProgress';
import Divider$1 from '@material-ui/core/Divider';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import debounce from 'lodash.debounce';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import Skeleton from '@material-ui/lab/Skeleton';
import { VideoPlayer } from '@vidispine/vdt-videojs-react';
import UserIcon from '@material-ui/icons/Person';
import GroupIcon from '@material-ui/icons/Group';
import ListItemIcon$1 from '@material-ui/core/ListItemIcon';
import TableHead$1$1 from '@material-ui/core/TableHead';
import Hidden from '@material-ui/core/Hidden';
import CloudDownload from '@material-ui/icons/CloudDownload';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Dialog$1 from '@material-ui/core/Dialog';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import ForwardIcon from '@material-ui/icons/Forward';
import Card$1 from '@material-ui/core/Card';
import CardHeader$1 from '@material-ui/core/CardHeader';
import truncate from 'lodash.truncate';
import CardContent$1 from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Visibility from '@material-ui/icons/Visibility';
import ShareIcon from '@material-ui/icons/Share';
import TreeItem from '@material-ui/lab/TreeItem';
import { useDrag, useDrop, DndContext, useDragLayer, DndProvider } from 'react-dnd';
import { getEmptyImage, HTML5Backend } from 'react-dnd-html5-backend';
import DialogActions$1 from '@material-ui/core/DialogActions';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import InputBase$1 from '@material-ui/core/InputBase';
import List$1 from '@material-ui/core/List';
import get$1 from 'lodash.get';
import { Droppable, Draggable, DragDropContext } from 'react-beautiful-dnd';
import ListItem$1 from '@material-ui/core/ListItem';
import ListItemSecondaryAction$1 from '@material-ui/core/ListItemSecondaryAction';
import ListItemAvatar$1 from '@material-ui/core/ListItemAvatar';
import { useDropzone } from 'react-dropzone';
import ListSubheader from '@material-ui/core/ListSubheader';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import ScheduleIcon from '@material-ui/icons/Schedule';
import TodayIcon from '@material-ui/icons/Today';
import LooksOneIcon from '@material-ui/icons/LooksOne';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Filter9PlusIcon from '@material-ui/icons/Filter9Plus';
import TreeView from '@material-ui/lab/TreeView';
import FolderIcon$1 from '@material-ui/icons/FolderOpen';
import MenuList from '@material-ui/core/MenuList';
import Popper from '@material-ui/core/Popper';
import LockIcon from '@material-ui/icons/Lock';
import CheckIcon from '@material-ui/icons/Check';
import YoutubeSearchedForIcon from '@material-ui/icons/YoutubeSearchedFor';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import BlockIcon from '@material-ui/icons/Block';
import CallSplitIcon from '@material-ui/icons/CallSplit';
import CallMergeIcon from '@material-ui/icons/CallMerge';
import updateWith from 'lodash.updatewith';
import constant from 'lodash.constant';
import cloneDeep from 'lodash.clonedeep';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import parseFileSize from 'filesize';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import merge from 'lodash.merge';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FilledInput from '@material-ui/core/FilledInput';
import Grow from '@material-ui/core/Grow';
import RoleIcon from '@material-ui/icons/VerifiedUser';
import DescriptionIcon from '@material-ui/icons/Description';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var check = function check(it) {
  return it && it.Math == Math && it;
}; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


var global_1 = // eslint-disable-next-line no-undef
check((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) == 'object' && globalThis) || check((typeof window === "undefined" ? "undefined" : _typeof(window)) == 'object' && window) || check((typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self) || check(_typeof(commonjsGlobal) == 'object' && commonjsGlobal) || // eslint-disable-next-line no-new-func
function () {
  return this;
}() || Function('return this')();

var fails = function fails(exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var descriptors = !fails(function () {
  return Object.defineProperty({}, 1, {
    get: function get() {
      return 7;
    }
  })[1] != 7;
});

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({
  1: 2
}, 1); // `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;
var objectPropertyIsEnumerable = {
  f: f
};

var createPropertyDescriptor = function createPropertyDescriptor(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function classofRaw(it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split; // fallback for non-array-like ES3 and non-enumerable old V8 strings

var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function requireObjectCoercible(it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

var toIndexedObject = function toIndexedObject(it) {
  return indexedObject(requireObjectCoercible(it));
};

var isObject = function isObject(it) {
  return _typeof(it) === 'object' ? it !== null : typeof it === 'function';
};

// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string

var toPrimitive = function toPrimitive(input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has = function has(it, key) {
  return hasOwnProperty.call(it, key);
};

var document$1 = global_1.document; // typeof document.createElement is 'object' in old IE

var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function documentCreateElement(it) {
  return EXISTS ? document$1.createElement(it) : {};
};

var ie8DomDefine = !descriptors && !fails(function () {
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

var f$1 = descriptors ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) {
    /* empty */
  }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};
var objectGetOwnPropertyDescriptor = {
  f: f$1
};

var anObject = function anObject(it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  }

  return it;
};

var nativeDefineProperty = Object.defineProperty; // `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty

var f$2 = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var objectDefineProperty = {
  f: f$2
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var setGlobal = function setGlobal(key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  }

  return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});
var sharedStore = store;

var functionToString = Function.toString; // this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper

if (typeof sharedStore.inspectSource != 'function') {
  sharedStore.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;
var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

var shared = createCommonjsModule(function (module) {
  (module.exports = function (key, value) {
    return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.8.3',
    mode:  'global',
    copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
  });
});

var id$1 = 0;
var postfix = Math.random();

var uid = function uid(key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id$1 + postfix).toString(36);
};

var keys = shared('keys');

var sharedKey = function sharedKey(key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function enforce(it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function getterFor(TYPE) {
  return function (it) {
    var state;

    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    }

    return state;
  };
};

if (nativeWeakMap) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$1());
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;

  set = function set(it, metadata) {
    metadata.facade = it;
    wmset.call(store$1, it, metadata);
    return metadata;
  };

  get = function get(it) {
    return wmget.call(store$1, it) || {};
  };

  has$1 = function has(it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;

  set = function set(it, metadata) {
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };

  get = function get(it) {
    return has(it, STATE) ? it[STATE] : {};
  };

  has$1 = function has$1(it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var redefine = createCommonjsModule(function (module) {
  var getInternalState = internalState.get;
  var enforceInternalState = internalState.enforce;
  var TEMPLATE = String(String).split('String');
  (module.exports = function (O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    var state;

    if (typeof value == 'function') {
      if (typeof key == 'string' && !has(value, 'name')) {
        createNonEnumerableProperty(value, 'name', key);
      }

      state = enforceInternalState(value);

      if (!state.source) {
        state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
      }
    }

    if (O === global_1) {
      if (simple) O[key] = value;else setGlobal(key, value);
      return;
    } else if (!unsafe) {
      delete O[key];
    } else if (!noTargetGet && O[key]) {
      simple = true;
    }

    if (simple) O[key] = value;else createNonEnumerableProperty(O, key, value); // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  })(Function.prototype, 'toString', function toString() {
    return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
  });
});

var path = global_1;

var aFunction = function aFunction(variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function getBuiltIn(namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace]) : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var ceil = Math.ceil;
var floor = Math.floor; // `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger

var toInteger = function toInteger(argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min; // `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength

var toLength = function toLength(argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min; // Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

var toAbsoluteIndex = function toAbsoluteIndex(index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var createMethod = function createMethod(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;

var objectKeysInternal = function objectKeysInternal(object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;

  for (key in O) {
    !has(hiddenKeys, key) && has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys


  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~indexOf(result, key) || result.push(key);
    }
  }

  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames

var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
  f: f$3
};

var f$4 = Object.getOwnPropertySymbols;
var objectGetOwnPropertySymbols = {
  f: f$4
};

var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function copyConstructorProperties(target, source) {
  var keys = ownKeys$1(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function isForced(feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';
var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/

var _export = function _export(options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;

  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }

  if (target) for (key in source) {
    sourceProperty = source[key];

    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];

    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

    if (!FORCED && targetProperty !== undefined) {
      if (_typeof(sourceProperty) === _typeof(targetProperty)) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    } // add a flag to not completely full polyfills


    if (options.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    } // extend global


    redefine(target, key, sourceProperty, options);
  }
};

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var useSymbolAsUid = nativeSymbol // eslint-disable-next-line no-undef
&& !Symbol.sham // eslint-disable-next-line no-undef
&& _typeof(Symbol.iterator) == 'symbol';

var WellKnownSymbolsStore = shared('wks');
var _Symbol = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? _Symbol : _Symbol && _Symbol.withoutSetter || uid;

var wellKnownSymbol = function wellKnownSymbol(name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (nativeSymbol && has(_Symbol, name)) WellKnownSymbolsStore[name] = _Symbol[name];else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  }

  return WellKnownSymbolsStore[name];
};

var MATCH = wellKnownSymbol('match'); // `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp

var isRegexp = function isRegexp(it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags


var regexpFlags = function regexpFlags() {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

// https://tc39.es/ecma262/#sec-toobject

var toObject = function toObject(argument) {
  return Object(requireObjectCoercible(argument));
};

var floor$1 = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g; // https://tc39.es/ecma262/#sec-getsubstitution

var getSubstitution = function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;

  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }

  return replace.call(replacement, symbols, function (match, ch) {
    var capture;

    switch (ch.charAt(0)) {
      case '$':
        return '$';

      case '&':
        return matched;

      case '`':
        return str.slice(0, position);

      case "'":
        return str.slice(tailPos);

      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;

      default:
        // \d\d?
        var n = +ch;
        if (n === 0) return match;

        if (n > m) {
          var f = floor$1(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }

        capture = captures[n - 1];
    }

    return capture === undefined ? '' : capture;
  });
};

var REPLACE = wellKnownSymbol('replace');
var RegExpPrototype = RegExp.prototype;
var max$1 = Math.max;

var stringIndexOf = function stringIndexOf(string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return string.indexOf(searchValue, fromIndex);
}; // `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall


_export({
  target: 'String',
  proto: true
}, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';

    if (searchValue != null) {
      IS_REG_EXP = isRegexp(searchValue);

      if (IS_REG_EXP) {
        flags = String(requireObjectCoercible('flags' in RegExpPrototype ? searchValue.flags : regexpFlags.call(searchValue)));
        if (!~flags.indexOf('g')) throw TypeError('`.replaceAll` does not allow non-global regexes');
      }

      replacer = searchValue[REPLACE];

      if (replacer !== undefined) {
        return replacer.call(searchValue, O, replaceValue);
      }
    }

    string = String(O);
    searchString = String(searchValue);
    functionalReplace = typeof replaceValue === 'function';
    if (!functionalReplace) replaceValue = String(replaceValue);
    searchLength = searchString.length;
    advanceBy = max$1(1, searchLength);
    position = stringIndexOf(string, searchString, 0);

    while (position !== -1) {
      if (functionalReplace) {
        replacement = String(replaceValue(searchString, position, string));
      } else {
        replacement = getSubstitution(searchString, string, position, [], undefined, replaceValue);
      }

      result += string.slice(endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf(string, searchString, position + advanceBy);
    }

    if (endOfLastMatch < string.length) {
      result += string.slice(endOfLastMatch);
    }

    return result;
  }
});

var aFunction$1 = function aFunction(it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  }

  return it;
};

var functionBindContext = function functionBindContext(fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;

  switch (length) {
    case 0:
      return function () {
        return fn.call(that);
      };

    case 1:
      return function (a) {
        return fn.call(that, a);
      };

    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };

    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }

  return function ()
  /* ...args */
  {
    return fn.apply(that, arguments);
  };
};

var call = Function.call;

var entryUnbind = function entryUnbind(CONSTRUCTOR, METHOD, length) {
  return functionBindContext(call, global_1[CONSTRUCTOR].prototype[METHOD], length);
};

var replaceAll = entryUnbind('String', 'replaceAll');

var light = createMuiTheme({
  palette: {
    type: 'light'
  }
});
var dark = createMuiTheme({
  palette: {
    type: 'dark'
  }
});
var ThemeContext = /*#__PURE__*/React__default.createContext({
  theme: undefined,
  palette: undefined,
  togglePalette: function togglePalette() {
    return null;
  }
});

var ThemeProvider = function ThemeProvider(_ref) {
  var _ref$themes = _ref.themes,
      themes = _ref$themes === void 0 ? {
    light: light,
    dark: dark
  } : _ref$themes,
      _ref$defaultPaletteKe = _ref.defaultPaletteKey,
      defaultPaletteKey = _ref$defaultPaletteKe === void 0 ? 'light' : _ref$defaultPaletteKe,
      _ref$localStoragePale = _ref.localStoragePaletteKey,
      localStoragePaletteKey = _ref$localStoragePale === void 0 ? 'DEFAULT_PALETTE' : _ref$localStoragePale,
      _ref$props = _ref.props,
      props = _ref$props === void 0 ? {} : _ref$props,
      children = _ref.children;
  var initialPaletteKey = localStorage.getItem(localStoragePaletteKey) || defaultPaletteKey;

  var _React$useState = React__default.useState(initialPaletteKey),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      palette = _React$useState2[0],
      setPalette = _React$useState2[1];

  var initialPalette = themes[initialPaletteKey];

  var _React$useState3 = React__default.useState(initialPalette),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      theme = _React$useState4[0],
      setTheme = _React$useState4[1];

  var updatePalette = function updatePalette(newPaletteKey) {
    var newTheme = themes[newPaletteKey];
    setTheme(newTheme);
    setPalette(newPaletteKey);
    localStorage.setItem(localStoragePaletteKey, newPaletteKey);
  };

  var togglePalette = function togglePalette() {
    var paletteKeys = Object.keys(themes);
    var newPaletteKey = paletteKeys[0];

    if (paletteKeys.length > 0 && palette === paletteKeys[0]) {
      var _paletteKeys = _slicedToArray(paletteKeys, 2);

      newPaletteKey = _paletteKeys[1];
    }

    updatePalette(newPaletteKey);
  };

  var isDefaultPalette = palette === defaultPaletteKey;
  return /*#__PURE__*/React__default.createElement(ThemeContext.Provider, {
    value: {
      theme: theme,
      palette: palette,
      togglePalette: togglePalette,
      isDefaultPalette: isDefaultPalette
    }
  }, /*#__PURE__*/React__default.createElement(MuiThemeProvider, {
    theme: createMuiTheme(theme, {
      props: props
    })
  }, /*#__PURE__*/React__default.createElement(CssBaseline, null, children)));
};

function useThemeContext() {
  var context = React__default.useContext(ThemeContext);

  if (context === undefined) {
    throw new Error('useThemeContext must be used within a ThemeProvider');
  }

  return context;
}

var styles = function styles(theme) {
  return {
    button: {
      borderRadius: 0,
      paddingTop: 4,
      paddingBottom: 4,
      borderColor: grey[400],
      borderStyle: theme.palette.type === 'light' ? 'solid' : 'none',
      height: 32
    }
  };
};

function LayoutButtonGroup(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      onChangeViewLayout = _ref.onChangeViewLayout,
      viewLayout = _ref.viewLayout,
      _ref$gridView = _ref.gridView,
      gridView = _ref$gridView === void 0 ? 'GRID_VIEW' : _ref$gridView,
      _ref$rowView = _ref.rowView,
      rowView = _ref$rowView === void 0 ? 'ROW_VIEW' : _ref$rowView;
  return /*#__PURE__*/React__default.createElement(ToggleButtonGroup, {
    className: clsx(classes.root, 'VdtLayoutToggleButtonGroup', className),
    exclusive: true,
    onChange: onChangeViewLayout,
    value: viewLayout,
    size: "small"
  }, /*#__PURE__*/React__default.createElement(ToggleButton, {
    className: clsx(classes.button, 'VdtLayoutToggleButton'),
    value: gridView
  }, /*#__PURE__*/React__default.createElement(ViewModuleIcon, null)), /*#__PURE__*/React__default.createElement(ToggleButton, {
    className: clsx(classes.button, 'VdtLayoutToggleButton'),
    value: rowView
  }, /*#__PURE__*/React__default.createElement(ViewHeadlineIcon, null)));
}

var LayoutButtonGroup$1 = withStyles(styles, {
  name: 'VdtLayoutButtonGroup'
})(LayoutButtonGroup);

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = "function" === typeof Symbol && Symbol["for"],
    c = b ? Symbol["for"]("react.element") : 60103,
    d = b ? Symbol["for"]("react.portal") : 60106,
    e = b ? Symbol["for"]("react.fragment") : 60107,
    f$5 = b ? Symbol["for"]("react.strict_mode") : 60108,
    g = b ? Symbol["for"]("react.profiler") : 60114,
    h = b ? Symbol["for"]("react.provider") : 60109,
    k = b ? Symbol["for"]("react.context") : 60110,
    l = b ? Symbol["for"]("react.async_mode") : 60111,
    m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
    n = b ? Symbol["for"]("react.forward_ref") : 60112,
    p = b ? Symbol["for"]("react.suspense") : 60113,
    q = b ? Symbol["for"]("react.suspense_list") : 60120,
    r = b ? Symbol["for"]("react.memo") : 60115,
    t = b ? Symbol["for"]("react.lazy") : 60116,
    v = b ? Symbol["for"]("react.block") : 60121,
    w = b ? Symbol["for"]("react.fundamental") : 60117,
    x = b ? Symbol["for"]("react.responder") : 60118,
    y = b ? Symbol["for"]("react.scope") : 60119;

function z(a) {
  if ("object" === _typeof(a) && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f$5:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element$1 = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f$5;
var Suspense = p;

var isAsyncMode = function isAsyncMode(a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k;
};

var isContextProvider = function isContextProvider(a) {
  return z(a) === h;
};

var isElement = function isElement(a) {
  return "object" === _typeof(a) && null !== a && a.$$typeof === c;
};

var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};

var isFragment = function isFragment(a) {
  return z(a) === e;
};

var isLazy = function isLazy(a) {
  return z(a) === t;
};

var isMemo = function isMemo(a) {
  return z(a) === r;
};

var isPortal = function isPortal(a) {
  return z(a) === d;
};

var isProfiler = function isProfiler(a) {
  return z(a) === g;
};

var isStrictMode = function isStrictMode(a) {
  return z(a) === f$5;
};

var isSuspense = function isSuspense(a) {
  return z(a) === p;
};

var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f$5 || a === p || a === q || "object" === _typeof(a) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element$1,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof(type) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (_typeof(object) === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return _typeof(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs_development_1 = reactIs_development.AsyncMode;
var reactIs_development_2 = reactIs_development.ConcurrentMode;
var reactIs_development_3 = reactIs_development.ContextConsumer;
var reactIs_development_4 = reactIs_development.ContextProvider;
var reactIs_development_5 = reactIs_development.Element;
var reactIs_development_6 = reactIs_development.ForwardRef;
var reactIs_development_7 = reactIs_development.Fragment;
var reactIs_development_8 = reactIs_development.Lazy;
var reactIs_development_9 = reactIs_development.Memo;
var reactIs_development_10 = reactIs_development.Portal;
var reactIs_development_11 = reactIs_development.Profiler;
var reactIs_development_12 = reactIs_development.StrictMode;
var reactIs_development_13 = reactIs_development.Suspense;
var reactIs_development_14 = reactIs_development.isAsyncMode;
var reactIs_development_15 = reactIs_development.isConcurrentMode;
var reactIs_development_16 = reactIs_development.isContextConsumer;
var reactIs_development_17 = reactIs_development.isContextProvider;
var reactIs_development_18 = reactIs_development.isElement;
var reactIs_development_19 = reactIs_development.isForwardRef;
var reactIs_development_20 = reactIs_development.isFragment;
var reactIs_development_21 = reactIs_development.isLazy;
var reactIs_development_22 = reactIs_development.isMemo;
var reactIs_development_23 = reactIs_development.isPortal;
var reactIs_development_24 = reactIs_development.isProfiler;
var reactIs_development_25 = reactIs_development.isStrictMode;
var reactIs_development_26 = reactIs_development.isSuspense;
var reactIs_development_27 = reactIs_development.isValidElementType;
var reactIs_development_28 = reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject$1(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject$1(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty$1.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$2(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof(typeSpecs[typeSpecName]) + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + _typeof(error) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$3 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1 = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$3(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (_typeof(propValue)) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = _typeof(propValue);

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});

var actions = {
  DELETE: 'DELETE',
  DOWNLOAD: 'DOWNLOAD',
  ADD_TO_LIBRARY: 'ADD_TO_LIBRARY',
  SHARE_EMAIL: 'SHARE_EMAIL',
  SHARE_LINK: 'SHARE_LINK',
  SHARE_FACEBOOK: 'SHARE_FACEBOOK'
};

var styles$1 = function styles(theme) {
  return {
    root: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.common.black
    }
  };
};

function SelectedToolbar(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      selected = _ref.selected,
      onClear = _ref.onClear,
      selectedLabel = _ref.selectedLabel,
      onClickAction = _ref.onClickAction;

  var handleActionClick = function handleActionClick(action) {
    return function () {
      if (onClickAction) onClickAction(action, selected);
    };
  };

  return /*#__PURE__*/React__default.createElement(Collapse, {
    "in": selected.length > 0
  }, /*#__PURE__*/React__default.createElement(Toolbar, {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    justify: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Typography, null, "".concat(selected.length, " ").concat(selectedLabel || '', " Selected"))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    alignItems: "center"
  }, onClickAction && /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    title: "Delete Selected"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: handleActionClick(actions.DELETE),
    color: "inherit"
  }, /*#__PURE__*/React__default.createElement(DeleteIcon, null))), /*#__PURE__*/React__default.createElement(Tooltip, {
    title: "Download Selected"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: handleActionClick(actions.DOWNLOAD),
    color: "inherit"
  }, /*#__PURE__*/React__default.createElement(GetAppIcon, null))), /*#__PURE__*/React__default.createElement(Tooltip, {
    title: "Add to Library"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: handleActionClick(actions.ADD_TO_LIBRARY),
    color: "inherit"
  }, /*#__PURE__*/React__default.createElement(AddIcon, null)))), onClear && /*#__PURE__*/React__default.createElement(Tooltip, {
    title: "Clear Selection"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: onClear,
    color: "inherit"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null))))))));
}

SelectedToolbar.propTypes = {
  selected: propTypes.arrayOf(propTypes.any),
  selectedLabel: propTypes.string,
  onClear: propTypes.func,
  onClickAction: propTypes.func,
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.any).isRequired
};
SelectedToolbar.defaultProps = {
  selected: [],
  selectedLabel: undefined,
  onClickAction: undefined,
  onClear: undefined,
  className: undefined
};
var SelectedToolbar$1 = withStyles(styles$1, {
  name: 'VdtSelectedToolbar'
})(SelectedToolbar);

var styles$2 = function styles(theme) {
  return {
    avatar: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.background.main
    },
    localeSelect: {
      width: '100%'
    }
  };
};

function UserAvatarButton(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      userName = _ref.userName,
      onLogout = _ref.onLogout,
      togglePalette = _ref.togglePalette,
      isDefaultPalette = _ref.isDefaultPalette,
      locale = _ref.locale,
      children = _ref.children,
      signOutText = _ref.signOutText,
      toggleThemeText = _ref.toggleThemeText,
      AvatarProps = _ref.AvatarProps,
      ButtonBaseProps = _ref.ButtonBaseProps,
      MenuProps = _ref.MenuProps,
      localeSelectProps = _ref.localeSelectProps;

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleMenuClick = function handleMenuClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleMenuClose = function handleMenuClose() {
    setAnchorEl(null);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(className, classes.root, 'VdtUserAvatarButton-root')
  }, /*#__PURE__*/React__default.createElement(ButtonBase, _extends({
    className: clsx(classes.ButtonBase, 'VdtUserAvatarButton-ButtonBase'),
    onClick: handleMenuClick,
    disableRipple: true
  }, ButtonBaseProps), /*#__PURE__*/React__default.createElement(Avatar, _extends({
    className: classes.avatar
  }, AvatarProps), userName[0]), /*#__PURE__*/React__default.createElement(ArrowDropDownIcon, null)), /*#__PURE__*/React__default.createElement(Menu, _extends({
    className: clsx(classes.Menu, 'VdtUserAvatarButton-Menu'),
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleMenuClose,
    elevation: 1,
    PaperProps: {
      square: true
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, MenuProps), /*#__PURE__*/React__default.createElement(MenuItem, {
    disabled: true
  }, userName), togglePalette && /*#__PURE__*/React__default.createElement(MenuItem, {
    className: clsx(classes.paletteMenuItem, 'VdtUserAvatarButton-paletteMenuItem')
  }, /*#__PURE__*/React__default.createElement(FormControlLabel, {
    className: clsx(classes.paletteFormControlLabel, 'VdtUserAvatarButton-paletteFormControlLabel'),
    label: toggleThemeText,
    control: /*#__PURE__*/React__default.createElement(Switch, {
      className: clsx(classes.paletteSwitch, 'VdtUserAvatarButton-paletteSwitch'),
      onChange: togglePalette,
      checked: isDefaultPalette
    })
  })), locale.options && /*#__PURE__*/React__default.createElement(MenuItem, {
    className: clsx(classes.localeMenuItemRoot, 'VdtUserAvatarButton-localeMenuItemRoot')
  }, /*#__PURE__*/React__default.createElement(Select, _extends({
    className: clsx(classes.localeSelect, 'VdtUserAvatarButton-localeSelect'),
    value: locale.curr,
    onChange: function onChange(_ref2) {
      var loc = _ref2.target.value;
      return locale.set(loc);
    }
  }, localeSelectProps), locale.options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      value: option.value,
      key: option.value,
      className: clsx(classes.localeMenuItem, 'VdtUserAvatarButton-localeMenuItem')
    }, option.label);
  }))), children, /*#__PURE__*/React__default.createElement(MenuItem, {
    className: clsx(classes.signOutMenuItem, 'VdtUserAvatarButton-signOutMenuItem'),
    button: true,
    onClick: onLogout
  }, signOutText)));
}

var UserAvatarButton$1 = withStyles(styles$2, {
  name: 'VdtUserAvatarButton'
})(UserAvatarButton);
UserAvatarButton.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.string).isRequired,
  userName: propTypes.string,
  onLogout: propTypes.func,
  togglePalette: propTypes.func,
  isDefaultPalette: propTypes.bool,
  locale: propTypes.shape({
    set: propTypes.func,
    curr: propTypes.string,
    options: propTypes.arrayOf(propTypes.any)
  }),
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.element), propTypes.element]),
  signOutText: propTypes.string,
  toggleThemeText: propTypes.string,
  AvatarProps: propTypes.objectOf(propTypes.any),
  ButtonBaseProps: propTypes.objectOf(propTypes.any),
  MenuProps: propTypes.objectOf(propTypes.any),
  localeSelectProps: propTypes.objectOf(propTypes.any)
};
UserAvatarButton.defaultProps = {
  className: undefined,
  userName: undefined,
  onLogout: undefined,
  togglePalette: undefined,
  isDefaultPalette: true,
  locale: {
    set: function set() {},
    curr: undefined,
    options: []
  },
  children: undefined,
  signOutText: 'Sign Out',
  toggleThemeText: 'Toggle Theme',
  AvatarProps: {},
  ButtonBaseProps: {},
  MenuProps: {},
  localeSelectProps: {}
};

var AUDIO_MIMETYPE_PREFIX = 'audio';
var VIDEO_MIMETYPE_PREFIX = 'video';
var IMAGE_MIMETYPE_PREFIX = 'image';
var COLLECTION = 'collection';
var styles$3 = {};
function MimeTypeIcon(_ref) {
  var mimeType = _ref.mimeType,
      _ref$audioIcon = _ref.audioIcon,
      audioIcon = _ref$audioIcon === void 0 ? AudioTrackIcon : _ref$audioIcon,
      _ref$videoIcon = _ref.videoIcon,
      videoIcon = _ref$videoIcon === void 0 ? MovieIcon : _ref$videoIcon,
      _ref$imageIcon = _ref.imageIcon,
      imageIcon = _ref$imageIcon === void 0 ? ImageIcon : _ref$imageIcon,
      _ref$fileIcon = _ref.fileIcon,
      fileIcon = _ref$fileIcon === void 0 ? InsertDriveFileIcon : _ref$fileIcon,
      _ref$placeholderIcon = _ref.placeholderIcon,
      placeholderIcon = _ref$placeholderIcon === void 0 ? NoteAddIcon : _ref$placeholderIcon,
      _ref$collectionIcon = _ref.collectionIcon,
      collectionIcon = _ref$collectionIcon === void 0 ? FolderIcon : _ref$collectionIcon,
      props = _objectWithoutProperties(_ref, ["mimeType", "audioIcon", "videoIcon", "imageIcon", "fileIcon", "placeholderIcon", "collectionIcon"]);

  var IconComponent = fileIcon;
  if (!mimeType) IconComponent = placeholderIcon;else if (mimeType.toLowerCase().startsWith(AUDIO_MIMETYPE_PREFIX)) IconComponent = audioIcon;else if (mimeType.toLowerCase().startsWith(VIDEO_MIMETYPE_PREFIX)) IconComponent = videoIcon;else if (mimeType.toLowerCase().startsWith(IMAGE_MIMETYPE_PREFIX)) IconComponent = imageIcon;else if (mimeType.toLowerCase() === COLLECTION) IconComponent = collectionIcon;
  return /*#__PURE__*/React__default.createElement(IconComponent, props); // eslint-disable-line react/jsx-props-no-spreading
}
MimeTypeIcon.propTypes = {
  mimeType: propTypes.string,
  audioIcon: propTypes.elementType,
  videoIcon: propTypes.elementType,
  imageIcon: propTypes.elementType,
  fileIcon: propTypes.elementType,
  placeholderIcon: propTypes.elementType,
  collectionIcon: propTypes.elementType
};
MimeTypeIcon.defaultProps = {
  mimeType: undefined,
  audioIcon: AudioTrackIcon,
  videoIcon: MovieIcon,
  imageIcon: ImageIcon,
  fileIcon: InsertDriveFileIcon,
  placeholderIcon: NoteAddIcon,
  collectionIcon: FolderIcon
};

var MimeTypeIcon$1 = withStyles(styles$3, {
  name: 'VdtMimeTypeIcon'
})(MimeTypeIcon);

var ConfirmationDialog = function ConfirmationDialog(_ref) {
  var open = _ref.open,
      _ref$titleText = _ref.titleText,
      titleText = _ref$titleText === void 0 ? 'Confirm' : _ref$titleText,
      _ref$rejectText = _ref.rejectText,
      rejectText = _ref$rejectText === void 0 ? 'No' : _ref$rejectText,
      _ref$confirmText = _ref.confirmText,
      confirmText = _ref$confirmText === void 0 ? 'Yes' : _ref$confirmText,
      onConfirm = _ref.onConfirm,
      onReject = _ref.onReject,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["open", "titleText", "rejectText", "confirmText", "onConfirm", "onReject", "children"]);

  return /*#__PURE__*/React__default.createElement(Dialog, {
    open: open,
    onClose: onReject
  }, /*#__PURE__*/React__default.createElement(DialogTitle, null, titleText), typeof children === 'function' ? children(props) : children, /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button, {
    onClick: onReject,
    color: "primary"
  }, rejectText), /*#__PURE__*/React__default.createElement(Button, {
    variant: "contained",
    onClick: onConfirm,
    color: "secondary"
  }, confirmText)));
};

function useConfirmationDialog() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$throwOnReject = _ref.throwOnReject,
      throwOnReject = _ref$throwOnReject === void 0 ? true : _ref$throwOnReject,
      _ref$DialogComponent = _ref.DialogComponent,
      DialogComponent = _ref$DialogComponent === void 0 ? ConfirmationDialog : _ref$DialogComponent;

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      ActiveDialog = _React$useState2[0],
      setActiveDialog = _React$useState2[1];

  var confirm = function confirm(confirmProps) {
    return new Promise(function (resolve, reject) {
      var close = function close() {
        setActiveDialog(null);
      };

      var onConfirm = function onConfirm() {
        close();
        resolve(true);
      };

      var onReject = function onReject() {
        close();
        if (throwOnReject) reject();else resolve(false);
      };

      setActiveDialog(function () {
        return function (dialogProps) {
          return /*#__PURE__*/React__default.createElement(DialogComponent, _extends({
            open: true,
            onConfirm: onConfirm,
            onReject: onReject // eslint-disable-next-line react/jsx-props-no-spreading

          }, dialogProps, confirmProps));
        };
      });
    });
  };

  return [ActiveDialog, confirm];
}

var useMenu = function useMenu() {
  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var onOpen = function onOpen(e) {
    if (e.stopPropagation) e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
    setAnchorEl(e.currentTarget);
  };

  var onClose = function onClose() {
    return setAnchorEl(null);
  };

  var onClick = function onClick(action) {
    return function (e) {
      if (e.stopPropagation) e.stopPropagation();
      if (e.preventDefault) e.preventDefault();
      onClose();
      action(e);
    };
  };

  var isOpen = Boolean(anchorEl);
  return {
    anchorEl: anchorEl,
    onOpen: onOpen,
    onClose: onClose,
    onClick: onClick,
    isOpen: isOpen
  };
};

var styles$4 = function styles() {
  return {};
}; // eslint-disable-next-line react/jsx-fragments


var EmptyComponent = function EmptyComponent() {
  return function () {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  };
};

function useSnackbarAlert() {
  var _React$useState = React__default.useState(EmptyComponent),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      Alert$1 = _React$useState2[0],
      setAlert = _React$useState2[1];

  var showAlert = function showAlert(_ref) {
    var severity = _ref.severity,
        message = _ref.message;
    setAlert(function () {
      return withStyles(styles$4)(function (_ref2) {
        var AlertProps = _ref2.AlertProps,
            props = _objectWithoutProperties(_ref2, ["AlertProps"]);

        return /*#__PURE__*/React__default.createElement(Snackbar, _extends({
          open: true,
          autoHideDuration: 6000,
          onClose: function onClose() {
            return setAlert(EmptyComponent);
          } // eslint-disable-next-line react/jsx-props-no-spreading

        }, props), /*#__PURE__*/React__default.createElement(Alert, _extends({
          severity: severity // eslint-disable-next-line react/jsx-props-no-spreading

        }, AlertProps), message.toString ? message.toString() : message));
      });
    });
  };

  return [Alert$1, showAlert];
}

var styles$5 = function styles(theme) {
  return {
    root: {
      marginTop: theme.spacing(1),
      width: '100%'
    }
  };
};

var CheckboxField = function CheckboxField(_ref) {
  var _ref$input = _ref.input;
  _ref$input = _ref$input === void 0 ? {} : _ref$input;

  var checked = _ref$input.checked,
      name = _ref$input.name,
      onChange = _ref$input.onChange,
      inputProps = _objectWithoutProperties(_ref$input, ["checked", "name", "onChange"]),
      _ref$meta = _ref.meta;

  _ref$meta = _ref$meta === void 0 ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      submitError = _ref$meta.submitError,
      label = _ref.label,
      classes = _ref.classes,
      className = _ref.className,
      _ref$FormControlProps = _ref.FormControlProps,
      FormControlProps = _ref$FormControlProps === void 0 ? {} : _ref$FormControlProps,
      _ref$FormControlLabel = _ref.FormControlLabelProps,
      FormControlLabelProps = _ref$FormControlLabel === void 0 ? {} : _ref$FormControlLabel,
      _ref$FormControlHelpe = _ref.FormControlHelperTextProps,
      FormControlHelperTextProps = _ref$FormControlHelpe === void 0 ? {} : _ref$FormControlHelpe,
      props = _objectWithoutProperties(_ref, ["input", "meta", "label", "classes", "className", "FormControlProps", "FormControlLabelProps", "FormControlHelperTextProps"]);

  return /*#__PURE__*/createElement(FormControl, _extends({
    error: (error || submitError) && touched,
    hiddenLabel: true,
    className: clsx(classes.root, 'VdtCheckboxField-root', className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormControlProps), /*#__PURE__*/createElement(FormControlLabel, _extends({
    label: label,
    control: /*#__PURE__*/createElement(Checkbox // eslint-disable-next-line react/jsx-props-no-spreading
    , _extends({}, props, {
      name: name,
      inputProps: inputProps,
      onChange: onChange,
      checked: checked,
      className: clsx(classes.checkbox, 'VdtCheckboxField-checkbox')
    })),
    className: clsx(classes.formControlLabel, 'VdtCheckboxField-formControlLabel') // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormControlLabelProps)), /*#__PURE__*/createElement(FormHelperText, _extends({
    margin: "dense",
    className: clsx(classes.formHelperText, 'VdtCheckboxField-formHelperText') // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormControlHelperTextProps), error || submitError));
};

var CheckboxField$1 = withStyles(styles$5, {
  name: 'VdtCheckboxField'
})(CheckboxField);

var styles$6 = function styles(theme) {
  return {
    root: {
      marginTop: theme.spacing(2),
      width: '100%'
    }
  };
};

var CheckboxGroupField = function CheckboxGroupField(_ref) {
  var _ref$input = _ref.input;
  _ref$input = _ref$input === void 0 ? {} : _ref$input;

  var value = _ref$input.value,
      name = _ref$input.name,
      onChange = _ref$input.onChange,
      inputProps = _objectWithoutProperties(_ref$input, ["value", "name", "onChange"]),
      _ref$meta = _ref.meta;

  _ref$meta = _ref$meta === void 0 ? {} : _ref$meta;
  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      submitError = _ref$meta.submitError,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      label = _ref.label,
      classes = _ref.classes,
      className = _ref.className,
      selectAllValue = _ref.selectAllValue,
      _ref$FormControlProps = _ref.FormControlProps,
      FormControlProps = _ref$FormControlProps === void 0 ? {} : _ref$FormControlProps,
      _ref$FormLabelProps = _ref.FormLabelProps,
      FormLabelProps = _ref$FormLabelProps === void 0 ? {} : _ref$FormLabelProps,
      _ref$FormGroupProps = _ref.FormGroupProps,
      FormGroupProps = _ref$FormGroupProps === void 0 ? {} : _ref$FormGroupProps,
      _ref$FormControlLabel = _ref.FormControlLabelProps,
      FormControlLabelProps = _ref$FormControlLabel === void 0 ? {} : _ref$FormControlLabel,
      _ref$CheckboxProps = _ref.CheckboxProps,
      CheckboxProps = _ref$CheckboxProps === void 0 ? {} : _ref$CheckboxProps,
      _ref$FormHelperTextPr = _ref.FormHelperTextProps,
      FormHelperTextProps = _ref$FormHelperTextPr === void 0 ? {} : _ref$FormHelperTextPr,
      _ref$FormControlLabel2 = _ref.FormControlLabelComponent,
      FormControlLabelComponent = _ref$FormControlLabel2 === void 0 ? FormControlLabel : _ref$FormControlLabel2;

  var _React$useState = useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      checkedValues = _React$useState2[0],
      setCheckedValues = _React$useState2[1];

  var handleOnChange = function handleOnChange(event) {
    var checkboxValue = event.target.value;
    var isChecked = !value.includes(checkboxValue);

    var addOrRemoveCheckboxName = function addOrRemoveCheckboxName(values) {
      if (!selectAllValue) {
        return isChecked ? [].concat(_toConsumableArray(values), [checkboxValue]) : values.filter(function (v) {
          return checkboxValue !== v;
        });
      }

      if (checkboxValue === selectAllValue) {
        return isChecked ? options.map(function (opt) {
          return opt.value;
        }) : [];
      }

      return isChecked ? [].concat(_toConsumableArray(values), [checkboxValue]) : values.filter(function (v) {
        return ![selectAllValue, checkboxValue].includes(v);
      });
    };

    onChange(addOrRemoveCheckboxName(checkedValues));
    setCheckedValues(function (values) {
      return addOrRemoveCheckboxName(values);
    });
  };

  useEffect(function () {
    var shouldReset = (!value || !value.length) && checkedValues.length > 0;

    if (shouldReset) {
      onChange([]);
      setCheckedValues(function () {
        return [];
      });
    } else if (value) {
      setCheckedValues(function () {
        return value;
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [checkedValues.length, value]);
  return /*#__PURE__*/createElement(FormControl, _extends({
    component: "fieldset",
    error: (error || submitError) && touched,
    className: clsx(classes.root, 'VdtCheckboxGroupField-root', className)
  }, FormControlProps), /*#__PURE__*/createElement(FormLabel, _extends({
    component: "legend",
    className: clsx(classes.formLabel, 'VdtCheckboxGroupField-formLabel')
  }, FormLabelProps), label), /*#__PURE__*/createElement(FormGroup, _extends({
    name: name,
    onChange: handleOnChange,
    className: clsx(classes.formGroup, 'VdtCheckboxGroupField-formGroup')
  }, FormGroupProps), options.map(function (_ref2) {
    var optionValue = _ref2.value,
        optionLabel = _ref2.label,
        optionProps = _objectWithoutProperties(_ref2, ["value", "label"]);

    return /*#__PURE__*/createElement(FormControlLabelComponent, _extends({
      label: optionLabel,
      key: "".concat(name, "-").concat(optionValue),
      control: /*#__PURE__*/createElement(Checkbox, _extends({
        name: optionValue,
        value: optionValue,
        inputProps: inputProps,
        checked: checkedValues.includes(optionValue),
        className: clsx(classes.checkbox, 'VdtCheckboxGroupField-checkbox')
      }, CheckboxProps)),
      className: clsx(classes.formControlLabel, 'VdtCheckboxGroupField-formControlLabel')
    }, FormControlLabelProps, optionProps));
  })), /*#__PURE__*/createElement(FormHelperText, _extends({
    className: clsx(classes.formHelperText, 'VdtCheckboxGroupField-formHelperText')
  }, FormHelperTextProps), error || submitError));
};

var CheckboxGroupField$1 = withStyles(styles$6, {
  name: 'VdtCheckboxGroupField'
})(CheckboxGroupField);

var styles$7 = function styles(theme) {
  return {
    root: {
      marginTop: theme.spacing(2),
      width: '100%'
    }
  };
};

var RadioField = function RadioField(_ref) {
  var _ref$input = _ref.input;
  _ref$input = _ref$input === void 0 ? {} : _ref$input;
  var value = _ref$input.value,
      name = _ref$input.name,
      onChange = _ref$input.onChange,
      _ref$meta = _ref.meta;
  _ref$meta = _ref$meta === void 0 ? {} : _ref$meta;
  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      submitError = _ref$meta.submitError,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      label = _ref.label,
      classes = _ref.classes,
      className = _ref.className,
      _ref$FormControlProps = _ref.FormControlProps,
      FormControlProps = _ref$FormControlProps === void 0 ? {} : _ref$FormControlProps,
      _ref$FormLabelProps = _ref.FormLabelProps,
      FormLabelProps = _ref$FormLabelProps === void 0 ? {} : _ref$FormLabelProps,
      _ref$RadioGroupProps = _ref.RadioGroupProps,
      RadioGroupProps = _ref$RadioGroupProps === void 0 ? {} : _ref$RadioGroupProps,
      _ref$FormControlLabel = _ref.FormControlLabelProps,
      FormControlLabelProps = _ref$FormControlLabel === void 0 ? {} : _ref$FormControlLabel,
      _ref$RadioProps = _ref.RadioProps,
      RadioProps = _ref$RadioProps === void 0 ? {} : _ref$RadioProps,
      _ref$FormHelperTextPr = _ref.FormHelperTextProps,
      FormHelperTextProps = _ref$FormHelperTextPr === void 0 ? {} : _ref$FormHelperTextPr,
      _ref$FormControlLabel2 = _ref.FormControlLabelComponent,
      FormControlLabelComponent = _ref$FormControlLabel2 === void 0 ? FormControlLabel : _ref$FormControlLabel2;
  return /*#__PURE__*/createElement(FormControl, _extends({
    component: "fieldset",
    error: (error || submitError) && touched,
    className: clsx(classes.root, 'VdtRadioField-root', className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormControlProps), /*#__PURE__*/createElement(FormLabel, _extends({
    component: "legend",
    className: clsx(classes.formLabel, 'VdtRadioField-formLabel') // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormLabelProps), label), /*#__PURE__*/createElement(RadioGroup, _extends({
    name: name,
    value: value,
    onChange: onChange,
    className: clsx(classes.radioGroup, 'VdtRadioField-radioGroup') // eslint-disable-next-line react/jsx-props-no-spreading

  }, RadioGroupProps), options.map(function (_ref2) {
    var optionValue = _ref2.value,
        optionLabel = _ref2.label,
        optionProps = _objectWithoutProperties(_ref2, ["value", "label"]);

    return /*#__PURE__*/createElement(FormControlLabelComponent, _extends({
      key: optionValue,
      label: optionLabel,
      control: /*#__PURE__*/createElement(Radio, _extends({
        value: optionValue,
        className: clsx(classes.radio, 'VdtRadioField-radio') // eslint-disable-next-line react/jsx-props-no-spreading

      }, RadioProps)),
      className: clsx(classes.formControlLabel, 'VdtRadioField-formControlLabel') // eslint-disable-next-line react/jsx-props-no-spreading

    }, FormControlLabelProps, optionProps));
  })), /*#__PURE__*/createElement(FormHelperText, _extends({
    className: clsx(classes.formHelperTextProps, 'VdtRadioField-formHelperTextProps') // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormHelperTextProps), error || submitError));
};

var RadioField$1 = withStyles(styles$7, {
  name: 'VdtRadioField'
})(RadioField);

var styles$8 = function styles(theme) {
  return {
    root: {
      marginTop: theme.spacing(1),
      width: '100%',
      '& .MuiInputBase-root': {
        fontSize: '.75rem'
      },
      '& .MuiInputBase-input': {
        fontWeight: 500,
        fontSize: '0.875rem'
      }
    },
    inputLabel: {},
    select: {},
    menuItem: {},
    formHelperText: {}
  };
};

var SelectField = function SelectField(_ref) {
  var _ref$input = _ref.input;
  _ref$input = _ref$input === void 0 ? {} : _ref$input;
  var value = _ref$input.value,
      name = _ref$input.name,
      onChange = _ref$input.onChange,
      multiple = _ref$input.multiple,
      _ref$meta = _ref.meta;
  _ref$meta = _ref$meta === void 0 ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      submitError = _ref$meta.submitError,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      label = _ref.label,
      classes = _ref.classes,
      className = _ref.className,
      _ref$FormControlProps = _ref.FormControlProps,
      FormControlProps = _ref$FormControlProps === void 0 ? {} : _ref$FormControlProps,
      _ref$InputLabelProps = _ref.InputLabelProps,
      InputLabelProps = _ref$InputLabelProps === void 0 ? {} : _ref$InputLabelProps,
      _ref$MenuItemProps = _ref.MenuItemProps,
      MenuItemProps = _ref$MenuItemProps === void 0 ? {} : _ref$MenuItemProps,
      _ref$FormHelperTextPr = _ref.FormHelperTextProps,
      FormHelperTextProps = _ref$FormHelperTextPr === void 0 ? {} : _ref$FormHelperTextPr,
      props = _objectWithoutProperties(_ref, ["input", "meta", "options", "label", "classes", "className", "FormControlProps", "InputLabelProps", "MenuItemProps", "FormHelperTextProps"]);

  return /*#__PURE__*/createElement(FormControl, _extends({
    error: (error || submitError) && touched,
    className: clsx(classes.root, 'VdtSelectField-root', className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormControlProps), /*#__PURE__*/createElement(InputLabel, _extends({
    htmlFor: name,
    className: clsx(classes.inputLabel, 'VdtSelectField-inputLabel') // eslint-disable-next-line react/jsx-props-no-spreading

  }, InputLabelProps), label), /*#__PURE__*/createElement(Select, _extends({
    name: name,
    onChange: onChange,
    value: multiple && !value ? [] : value,
    multiple: multiple,
    className: clsx(classes.select, 'VdtSelectField-select') // eslint-disable-next-line react/jsx-props-no-spreading

  }, props), options.map(function (_ref2) {
    var optionValue = _ref2.value,
        optionLabel = _ref2.label,
        optionProps = _objectWithoutProperties(_ref2, ["value", "label"]);

    return /*#__PURE__*/createElement(MenuItem, _extends({
      key: optionValue,
      value: optionValue,
      className: clsx(classes.menuItem, 'VdtSelectField-menuItem') // eslint-disable-next-line react/jsx-props-no-spreading

    }, MenuItemProps, optionProps), optionLabel);
  })), /*#__PURE__*/createElement(FormHelperText, _extends({
    className: clsx(classes.formHelperText, 'VdtSelectField-formHelperText') // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormHelperTextProps), touched && (error || submitError) ? error || submitError : ''));
};

var SelectField$1 = withStyles(styles$8, {
  name: 'VdtSelectField'
})(SelectField);

var styles$9 = function styles(theme) {
  return {
    root: {
      marginTop: theme.spacing(1),
      width: '100%',
      '& .MuiInputBase-root': {
        fontSize: '.75rem'
      },
      '& .MuiInputBase-input': {
        fontWeight: 500,
        fontSize: '0.875rem'
      }
    }
  };
};

var TextField = function TextField(_ref) {
  var _ref$input = _ref.input;
  _ref$input = _ref$input === void 0 ? {} : _ref$input;

  var name = _ref$input.name,
      onChange = _ref$input.onChange,
      value = _ref$input.value,
      inputProps = _objectWithoutProperties(_ref$input, ["name", "onChange", "value"]),
      _ref$meta = _ref.meta;

  _ref$meta = _ref$meta === void 0 ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      submitError = _ref$meta.submitError,
      _ref$helperText = _ref.helperText,
      helperText = _ref$helperText === void 0 ? "\xA0" : _ref$helperText,
      classes = _ref.classes,
      className = _ref.className,
      _ref$FormControlProps = _ref.FormControlProps,
      FormControlProps = _ref$FormControlProps === void 0 ? {} : _ref$FormControlProps,
      props = _objectWithoutProperties(_ref, ["input", "meta", "helperText", "classes", "className", "FormControlProps"]);

  return /*#__PURE__*/React__default.createElement(FormControl, _extends({
    className: clsx(classes.root, 'VdtTextField-root', className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormControlProps), /*#__PURE__*/React__default.createElement(TextField$2, _extends({
    className: clsx(classes.text, 'VdtTextField-text'),
    name: name,
    helperText: touched && (error || submitError) ? error || submitError : helperText,
    error: (error || submitError) && touched,
    inputProps: inputProps,
    onChange: onChange,
    value: value // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)));
};

var TextField$1 = withStyles(styles$9, {
  name: 'VdtTextField'
})(TextField);

var styles$a = function styles(theme) {
  return {
    root: {
      marginTop: theme.spacing(2),
      width: '100%'
    },
    sliderWithoutThumb: {
      '& .MuiSlider-thumb': {
        visibility: 'hidden'
      }
    }
  };
};

var Slider = function Slider(_ref) {
  var _clsx;

  var _ref$input = _ref.input;
  _ref$input = _ref$input === void 0 ? {} : _ref$input;
  var value = _ref$input.value,
      name = _ref$input.name,
      _onChange = _ref$input.onChange,
      _ref$meta = _ref.meta;
  _ref$meta = _ref$meta === void 0 ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      submitError = _ref$meta.submitError,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      label = _ref.label,
      min = _ref.min,
      max = _ref.max,
      isRange = _ref.isRange,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? null : _ref$step,
      _ref$showMarks = _ref.showMarks,
      showMarks = _ref$showMarks === void 0 ? true : _ref$showMarks,
      classes = _ref.classes,
      className = _ref.className,
      _ref$FormControlProps = _ref.FormControlProps,
      FormControlProps = _ref$FormControlProps === void 0 ? {} : _ref$FormControlProps,
      _ref$FormLabelProps = _ref.FormLabelProps,
      FormLabelProps = _ref$FormLabelProps === void 0 ? {} : _ref$FormLabelProps,
      _ref$FormHelperTextPr = _ref.FormHelperTextProps,
      FormHelperTextProps = _ref$FormHelperTextPr === void 0 ? {} : _ref$FormHelperTextPr,
      exclude = _ref.exclude,
      props = _objectWithoutProperties(_ref, ["input", "meta", "options", "label", "min", "max", "isRange", "step", "showMarks", "classes", "className", "FormControlProps", "FormLabelProps", "FormHelperTextProps", "exclude"]);

  var numberOptions = useMemo(function () {
    return options.filter(function (o) {
      return !Number.isNaN(o.value);
    }).map(function (o) {
      return {
        value: Number(o.value),
        label: showMarks ? o.label : undefined
      };
    });
  }, [showMarks, options]);

  var _React$useMemo = useMemo(function () {
    var values = numberOptions.map(function (o) {
      return o.value;
    }).sort(function (a, b) {
      return a - b;
    });
    return [values[0], values[values.length - 1]];
  }, [numberOptions]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      optionsMin = _React$useMemo2[0],
      optionsMax = _React$useMemo2[1];

  var sliderMin = Number(min) || optionsMin;
  var sliderMax = Number(max) || optionsMax; // value = '' || undefined => error

  var initialValue = isRange ? [sliderMin, sliderMax] : null;
  return /*#__PURE__*/createElement(FormControl, _extends({
    error: (error || submitError) && touched,
    className: clsx(classes.root, 'VdtSliderField-root', className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormControlProps), /*#__PURE__*/createElement(FormLabel, _extends({
    component: "legend",
    className: clsx(classes.FormLabel, 'VdtSliderField-formLabel') // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormLabelProps), label), /*#__PURE__*/createElement(MUISlider, _extends({
    name: name,
    value: value || initialValue,
    min: sliderMin,
    max: sliderMax,
    marks: numberOptions,
    step: step,
    disabled: !numberOptions.length,
    valueLabelDisplay: numberOptions.length > 0 ? 'auto' : undefined,
    onChange: function onChange(e, v) {
      return _onChange(v);
    },
    className: clsx((_clsx = {}, _defineProperty(_clsx, classes.slider, true), _defineProperty(_clsx, 'VdtSliderField-slider', true), _defineProperty(_clsx, classes.sliderWithoutThumb, !value), _clsx)) // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)), /*#__PURE__*/createElement(FormHelperText, _extends({
    className: clsx(classes.formHelperText, 'VdtSliderField-formHelperText') // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormHelperTextProps), error || submitError));
};

var SliderField = withStyles(styles$a, {
  name: 'VdtSliderField'
})(Slider);

var styles$b = function styles(theme) {
  return {
    root: {
      marginTop: theme.spacing(1),
      width: '100%'
    }
  };
};

var TagField = function TagField(_ref) {
  var _ref$input = _ref.input;
  _ref$input = _ref$input === void 0 ? {} : _ref$input;
  var value = _ref$input.value,
      name = _ref$input.name,
      onChange = _ref$input.onChange,
      _ref$meta = _ref.meta;
  _ref$meta = _ref$meta === void 0 ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      submitError = _ref$meta.submitError,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      label = _ref.label,
      classes = _ref.classes,
      className = _ref.className,
      _ref$FormControlProps = _ref.FormControlProps,
      FormControlProps = _ref$FormControlProps === void 0 ? {} : _ref$FormControlProps,
      _ref$TextFieldProps = _ref.TextFieldProps,
      TextFieldProps = _ref$TextFieldProps === void 0 ? {} : _ref$TextFieldProps,
      _ref$InputLabelProps = _ref.InputLabelProps,
      InputLabelProps = _ref$InputLabelProps === void 0 ? {} : _ref$InputLabelProps,
      _ref$FormHelperTextPr = _ref.FormHelperTextProps,
      FormHelperTextProps = _ref$FormHelperTextPr === void 0 ? {} : _ref$FormHelperTextPr,
      _ref$AutocompleteProp = _ref.AutocompleteProps,
      AutocompleteProps = _ref$AutocompleteProp === void 0 ? {} : _ref$AutocompleteProp,
      props = _objectWithoutProperties(_ref, ["input", "meta", "options", "label", "classes", "className", "FormControlProps", "TextFieldProps", "InputLabelProps", "FormHelperTextProps", "AutocompleteProps"]);

  var freeSolo = AutocompleteProps.freeSolo,
      multiple = AutocompleteProps.multiple;
  var initialState = multiple ? [] : null;

  var _React$useState = React__default.useState(initialState),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedValues = _React$useState2[0],
      setSelectedValues = _React$useState2[1];

  var handleChange = function handleChange(event, values) {
    if (multiple) {
      if (freeSolo) {
        setSelectedValues(values.map(function (v) {
          return v.value ? v : {
            value: v,
            label: v
          };
        }));
        onChange(values.map(function (v) {
          return v.value ? v.value : v;
        }));
      } else {
        setSelectedValues(values);
        onChange(values.map(function (v) {
          return v.value;
        }));
      }
    } else {
      setSelectedValues(values);
      onChange(values.value);
    }
  };

  React__default.useEffect(function () {
    if (multiple) {
      if ((!value || !value.length) && selectedValues.length > 0) {
        setSelectedValues(function () {
          return initialState;
        });
      } else if (Array.isArray(value) && value.length > 0 && selectedValues.length === 0 && touched === false) {
        setSelectedValues(function () {
          return value.map(function (initialValue) {
            return {
              value: initialValue,
              label: initialValue
            };
          });
        });
      }
    } else if (!value && selectedValues) {
      setSelectedValues(function () {
        return initialState;
      });
      onChange([]);
    } else if (value && value.length && !selectedValues) {
      var initialValue = value.length ? value[0] : value;
      setSelectedValues(function () {
        return {
          value: initialValue,
          label: initialValue
        };
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [selectedValues, value]);
  return /*#__PURE__*/React__default.createElement(FormControl$1, _extends({
    component: "fieldset",
    className: clsx(classes.root, 'VdtTagField-root', className),
    error: (error || submitError) && touched // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormControlProps), /*#__PURE__*/React__default.createElement(Autocomplete, _extends({
    className: clsx(classes.root, 'VdtTagField-root', className),
    id: name,
    value: selectedValues,
    options: options,
    getOptionLabel: function getOptionLabel(o) {
      return o.label || o.value || '';
    },
    getOptionSelected: function getOptionSelected(o, v) {
      return o.value === v.value;
    },
    onChange: handleChange,
    disableClearable: true,
    freeSolo: freeSolo,
    multiple: multiple,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$2, _extends({
        label: label,
        className: clsx(classes.text, 'VdtTagField-text'),
        error: (error || submitError) && touched,
        InputLabelProps: InputLabelProps // eslint-disable-next-line react/jsx-props-no-spreading

      }, params, TextFieldProps));
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, AutocompleteProps, props)), /*#__PURE__*/React__default.createElement(FormHelperText$1, _extends({
    className: clsx(classes.helperText, 'VdtTagField-helperText') // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormHelperTextProps), error || submitError));
};

var TagField$1 = withStyles(styles$b, {
  name: 'VdtTagField'
})(TagField);

var styles$c = function styles(theme) {
  return {
    root: {
      marginTop: theme.spacing(2),
      width: '100%'
    },
    date: {
      '& ::-webkit-calendar-picker-indicator': {
        // Make date-icon white for dark theme
        filter: theme.palette.type === 'dark' && 'invert(1)'
      }
    }
  };
};

var DateField = function DateField(_ref) {
  var _ref$input = _ref.input;
  _ref$input = _ref$input === void 0 ? {} : _ref$input;
  var value = _ref$input.value,
      name = _ref$input.name,
      onChange = _ref$input.onChange,
      _ref$meta = _ref.meta;
  _ref$meta = _ref$meta === void 0 ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      submitError = _ref$meta.submitError,
      label = _ref.label,
      helperText = _ref.helperText,
      _ref$dateType = _ref.dateType,
      dateType = _ref$dateType === void 0 ? 'date' : _ref$dateType,
      classes = _ref.classes,
      className = _ref.className,
      _ref$FormControlProps = _ref.FormControlProps,
      FormControlProps = _ref$FormControlProps === void 0 ? {} : _ref$FormControlProps,
      _ref$InputLabelProps = _ref.InputLabelProps,
      InputLabelProps = _ref$InputLabelProps === void 0 ? {} : _ref$InputLabelProps,
      props = _objectWithoutProperties(_ref, ["input", "meta", "label", "helperText", "dateType", "classes", "className", "FormControlProps", "InputLabelProps"]);

  return /*#__PURE__*/createElement(FormControl, _extends({
    className: clsx(classes.root, 'VdtDateField-root', className),
    error: (error || submitError) && touched // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormControlProps), /*#__PURE__*/createElement(TextField$2, _extends({
    id: name,
    label: label,
    value: value,
    type: dateType,
    onChange: onChange,
    helperText: touched && (error || submitError) ? error || submitError : helperText,
    error: (error || submitError) && touched,
    InputLabelProps: _objectSpread2({
      shrink: true
    }, InputLabelProps),
    className: clsx(classes.date, 'VdtDateField-date') // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)));
};

var DateField$1 = withStyles$1(styles$c, {
  name: 'VdtDateField'
})(DateField);

var styles$d = function styles(theme) {
  return {
    root: {
      marginTop: theme.spacing(1),
      width: '100%'
    }
  };
};

var SwitchField = function SwitchField(_ref) {
  var _ref$input = _ref.input;
  _ref$input = _ref$input === void 0 ? {} : _ref$input;
  var name = _ref$input.name,
      onChange = _ref$input.onChange,
      value = _ref$input.value,
      label = _ref.label,
      classes = _ref.classes,
      className = _ref.className,
      _ref$FormControlProps = _ref.FormControlProps,
      FormControlProps = _ref$FormControlProps === void 0 ? {} : _ref$FormControlProps,
      _ref$FormControlLabel = _ref.FormControlLabelProps,
      FormControlLabelProps = _ref$FormControlLabel === void 0 ? {} : _ref$FormControlLabel,
      _ref$SwitchProps = _ref.SwitchProps,
      SwitchProps = _ref$SwitchProps === void 0 ? {} : _ref$SwitchProps,
      checkedValue = _ref.checkedValue,
      uncheckedValue = _ref.uncheckedValue;
  var handleChange = checkedValue && uncheckedValue ? function (event) {
    var checked = event.target.checked;
    onChange(checked ? checkedValue : uncheckedValue);
  } : onChange;
  var checked = checkedValue && uncheckedValue ? checkedValue === value : value;
  return /*#__PURE__*/React__default.createElement(FormControl, _extends({
    className: clsx(classes.root, 'VdtSwitchField-root', className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormControlProps), /*#__PURE__*/React__default.createElement(FormControlLabel, _extends({
    label: label,
    className: clsx(classes.label, 'VdtSwitchField-FormControlLabel'),
    control: /*#__PURE__*/React__default.createElement(Switch, _extends({
      className: clsx(classes["switch"], 'VdtSwitchField-Switch'),
      checked: checked,
      onChange: handleChange,
      name: name // eslint-disable-next-line react/jsx-props-no-spreading

    }, SwitchProps)) // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormControlLabelProps)));
};

var SwitchField$1 = withStyles(styles$d, {
  name: 'VdtSwitchField'
})(SwitchField);

var styles$e = function styles() {};

var defaultGetOptionLabel = function defaultGetOptionLabel(opt) {
  return opt.label || opt;
};

var defaultGetOptionSelected = function defaultGetOptionSelected(opt, val) {
  var _opt$value = opt.value,
      option = _opt$value === void 0 ? opt : _opt$value;
  var _val$value = val.value,
      value = _val$value === void 0 ? val : _val$value;
  return value === option;
};

var defaultGetValue = function defaultGetValue(_ref) {
  var value = _ref.value,
      multiple = _ref.multiple;
  if (multiple && !Array.isArray(value)) return [value];
  if (!multiple && Array.isArray(value)) return value.join(', ');
  return value;
};

var AutocompleteField = function AutocompleteField(_ref2) {
  var _ref2$input = _ref2.input,
      input = _ref2$input === void 0 ? {} : _ref2$input,
      _ref2$meta = _ref2.meta,
      meta = _ref2$meta === void 0 ? {} : _ref2$meta,
      _ref2$helperText = _ref2.helperText,
      helperText = _ref2$helperText === void 0 ? "\xA0" : _ref2$helperText,
      label = _ref2.label,
      loading = _ref2.loading,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options,
      noOptionsText = _ref2.noOptionsText,
      _ref2$getOptionLabel = _ref2.getOptionLabel,
      getOptionLabel = _ref2$getOptionLabel === void 0 ? defaultGetOptionLabel : _ref2$getOptionLabel,
      _ref2$getOptionSelect = _ref2.getOptionSelected,
      getOptionSelected = _ref2$getOptionSelect === void 0 ? defaultGetOptionSelected : _ref2$getOptionSelect,
      _ref2$getValue = _ref2.getValue,
      getValue = _ref2$getValue === void 0 ? defaultGetValue : _ref2$getValue,
      FormControlProps = _ref2.FormControlProps,
      _ref2$clearOnBlur = _ref2.clearOnBlur,
      clearOnBlur = _ref2$clearOnBlur === void 0 ? true : _ref2$clearOnBlur,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'small' : _ref2$size,
      FormHelperTextProps = _ref2.FormHelperTextProps,
      props = _objectWithoutProperties(_ref2, ["input", "meta", "helperText", "label", "loading", "options", "noOptionsText", "getOptionLabel", "getOptionSelected", "getValue", "FormControlProps", "clearOnBlur", "size", "FormHelperTextProps"]);

  var name = input.name,
      multiple = input.multiple;
  var value = getValue(input);
  var touched = meta.touched,
      error = meta.error,
      submitError = meta.submitError;

  var onChange = function onChange(event, newValue) {
    if (!newValue) return input.onChange(null);
    var _newValue$value = newValue.value,
        val = _newValue$value === void 0 ? newValue : _newValue$value;
    return input.onChange(val);
  };

  return /*#__PURE__*/React__default.createElement(Autocomplete$1, _extends({
    onChange: onChange,
    options: options,
    renderInput: function renderInput(inputProps) {
      return /*#__PURE__*/React__default.createElement(TextField$1, _extends({
        label: label,
        input: {
          name: name
        },
        meta: {
          touched: touched,
          error: error,
          submitError: submitError
        },
        helperText: helperText,
        FormControlProps: FormControlProps // eslint-disable-next-line react/jsx-props-no-spreading

      }, inputProps));
    },
    loading: loading,
    value: value,
    getOptionLabel: getOptionLabel,
    getOptionSelected: getOptionSelected,
    noOptionsText: noOptionsText,
    multiple: multiple,
    clearOnBlur: clearOnBlur,
    size: size // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
};

var AutocompleteField$1 = withStyles$1(styles$e, {
  name: 'VdtAutocompleteField'
})(AutocompleteField);

function BatonAnalysisForm(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      testplans = _ref.testplans,
      testplansLabel = _ref.testplansLabel,
      noTestplansText = _ref.noTestplansText,
      resources = _ref.resources,
      resourcesLabel = _ref.resourcesLabel,
      shapes = _ref.shapes,
      shapesLabel = _ref.shapesLabel,
      dynamicParamsLabel = _ref.dynamicParamsLabel,
      validation = _ref.validation,
      showDynamicParams = _ref.showDynamicParams,
      FieldProps = _ref.FieldProps;
  return /*#__PURE__*/React__default.createElement("form", {
    className: clsx(classes.root, 'VdtBatonAnalysisForm-root', className)
  }, /*#__PURE__*/React__default.createElement(Field, _extends({
    validate: validation,
    name: "shapeId",
    component: SelectField$1,
    options: shapes,
    label: shapesLabel // eslint-disable-next-line react/jsx-props-no-spreading

  }, FieldProps)), /*#__PURE__*/React__default.createElement(Field, _extends({
    validate: validation,
    allowNull: true,
    name: "preset",
    component: AutocompleteField$1,
    label: testplansLabel,
    options: testplans,
    noOptionsText: noTestplansText,
    helperText: "" // eslint-disable-next-line react/jsx-props-no-spreading

  }, FieldProps)), /*#__PURE__*/React__default.createElement(Field, _extends({
    name: "resourceId",
    component: SelectField$1,
    label: resourcesLabel,
    options: resources // eslint-disable-next-line react/jsx-props-no-spreading

  }, FieldProps)), showDynamicParams && /*#__PURE__*/React__default.createElement(Field, _extends({
    name: "batonDynamicParams",
    component: TextField$1,
    label: dynamicParamsLabel,
    multiline: true // eslint-disable-next-line react/jsx-props-no-spreading

  }, FieldProps)));
}

BatonAnalysisForm.propTypes = {
  classes: propTypes.objectOf(propTypes.any),
  className: propTypes.string,
  testplans: propTypes.arrayOf(propTypes.shape({
    label: propTypes.string,
    value: propTypes.string
  })),
  testplansLabel: propTypes.string,
  noTestplansText: propTypes.string,
  resources: propTypes.arrayOf(propTypes.shape({
    label: propTypes.string,
    value: propTypes.string
  })),
  resourcesLabel: propTypes.string,
  shapes: propTypes.arrayOf(propTypes.shape({
    label: propTypes.string,
    value: propTypes.string
  })),
  shapesLabel: propTypes.string,
  dynamicParamsLabel: propTypes.string,
  validation: propTypes.func,
  showDynamicParams: propTypes.bool,
  FieldProps: propTypes.objectOf(propTypes.any)
};
BatonAnalysisForm.defaultProps = {
  classes: {},
  className: 'VdtBatonAnalysisDialog',
  testplans: [],
  testplansLabel: 'Select testplan',
  noTestplansText: 'No matching testplans',
  resources: [],
  resourcesLabel: 'Select resource',
  shapes: [],
  shapesLabel: 'Select shape',
  dynamicParamsLabel: 'Dynamic parameters',
  validation: function validation(value) {
    return !value ? 'Required' : undefined;
  },
  showDynamicParams: false,
  FieldProps: {
    FormControlProps: {
      margin: 'normal'
    }
  }
};
var BatonFormComponent = withStyles$1({}, {
  name: 'VdtBatonAnalysisForm'
})(BatonAnalysisForm);

var useBatonHook = function useBatonHook(itemId) {
  // GET ANALYZE PRESETS
  var _useApi = useApi(analyzepreset.listAnalyzePreset),
      getPresets = _useApi.request,
      _useApi$data = _useApi.data;

  _useApi$data = _useApi$data === void 0 ? {} : _useApi$data;
  var _useApi$data$preset = _useApi$data.preset,
      preset = _useApi$data$preset === void 0 ? [] : _useApi$data$preset,
      isLoading = _useApi.isLoading;
  React__default.useEffect(function () {
    getPresets();
  }, [getPresets]);
  var testplans = React__default.useMemo(function () {
    return preset.map(function (_ref) {
      var name = _ref.name;
      return {
        label: name,
        value: name
      };
    });
  }, [preset]); // GET RESOURCES

  var _useApi2 = useApi(resource.listResourceType),
      getRss = _useApi2.request,
      _useApi2$data = _useApi2.data;

  _useApi2$data = _useApi2$data === void 0 ? {} : _useApi2$data;
  var _useApi2$data$resourc = _useApi2$data.resource,
      resource$1 = _useApi2$data$resourc === void 0 ? [] : _useApi2$data$resourc;
  React__default.useEffect(function () {
    getRss({
      resourceType: 'vidinet'
    });
  }, [getRss]);
  var resources = React__default.useMemo(function () {
    return resource$1.map(function (_ref2) {
      var id = _ref2.id,
          vidinet = _ref2.vidinet;
      return {
        label: vidinet.name || id,
        value: id
      };
    });
  }, [resource$1]); // GET SHAPES

  var _useApi3 = useApi(item.getItem),
      getItem = _useApi3.request,
      _useApi3$data = _useApi3.data;

  _useApi3$data = _useApi3$data === void 0 ? {} : _useApi3$data;
  var _useApi3$data$shape = _useApi3$data.shape,
      shape$1 = _useApi3$data$shape === void 0 ? [] : _useApi3$data$shape;
  React__default.useEffect(function () {
    getItem({
      itemId: itemId,
      queryParams: {
        p: ['shape.id', 'shape.tag']
      }
    });
  }, [getItem, itemId]);
  var shapes = React__default.useMemo(function () {
    var media = shape$1.filter(function (_ref3) {
      var _ref3$tag = _slicedToArray(_ref3.tag, 1),
          shapeTag = _ref3$tag[0];

      var tag = shapeTag.toLowerCase();
      return !tag.includes('pdf') && !tag.includes('xml');
    });
    return media.map(function (_ref4) {
      var value = _ref4.id,
          _ref4$tag = _slicedToArray(_ref4.tag, 1),
          tag = _ref4$tag[0];

      return {
        value: value,
        tag: tag,
        label: "".concat(tag, " (").concat(value, ")")
      };
    });
  }, [shape$1]);

  var startBatonJob = function startBatonJob(shapeId, queryParams) {
    return shape.createShapeAnalyze({
      itemId: itemId,
      shapeId: shapeId,
      queryParams: queryParams
    });
  };

  return {
    shapes: shapes,
    startBatonJob: startBatonJob,
    resources: resources,
    testplans: testplans,
    isLoading: isLoading
  };
};

var FormWrapper = function FormWrapper(_ref5) {
  var itemId = _ref5.itemId,
      FormComponent = _ref5.FormComponent,
      FormComponentProps = _ref5.FormComponentProps,
      handleSubmit = _ref5.handleSubmit,
      submitText = _ref5.submitText,
      costEstimate = _ref5.costEstimate,
      props = _objectWithoutProperties(_ref5, ["itemId", "FormComponent", "FormComponentProps", "handleSubmit", "submitText", "costEstimate"]);

  var _React$useState = React__default.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      _React$useState2$ = _React$useState2[0],
      value = _React$useState2$.value,
      error = _React$useState2$.error,
      setCostEstimate = _React$useState2[1];

  var _React$useState3 = React__default.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      loading = _React$useState4[0],
      setLoading = _React$useState4[1];

  var onPoll = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(costEstimateId) {
      var _yield$VidinetApi$get, _yield$VidinetApi$get2, data, state, _data$service, service, _service, cost;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return vidinet.getCostEstimate({
                costEstimateId: costEstimateId
              });

            case 2:
              _yield$VidinetApi$get = _context.sent;
              _yield$VidinetApi$get2 = _yield$VidinetApi$get.data;
              data = _yield$VidinetApi$get2 === void 0 ? {} : _yield$VidinetApi$get2;
              state = data.state, _data$service = data.service, service = _data$service === void 0 ? [] : _data$service;

              if (!(state !== 'FINISHED')) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", setTimeout(function () {
                return onPoll(costEstimateId);
              }, 1000));

            case 8:
              _service = _slicedToArray(service, 1), cost = _service[0].cost;
              setLoading(false);
              return _context.abrupt("return", setCostEstimate(cost));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onPoll(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  var onChange = function onChange(_ref7) {
    var _ref7$values = _ref7.values,
        values = _ref7$values === void 0 ? {} : _ref7$values;
    setCostEstimate({});
    var shapeId = values.shapeId,
        resourceId = values.resourceId,
        preset = values.preset;
    if (!shapeId || !resourceId || !preset) return;
    shape.createShapeAnalyze({
      itemId: itemId,
      shapeId: shapeId,
      queryParams: {
        resourceId: resourceId,
        preset: preset
      },
      costEstimate: true
    }).then(function (_ref8) {
      var _ref8$data = _ref8.data;
      _ref8$data = _ref8$data === void 0 ? {} : _ref8$data;
      var id = _ref8$data.id;
      setLoading(true);
      onPoll(id);
    })["catch"](function () {
      return setCostEstimate({
        error: "Couldn't get cost estimate, please choose another resource"
      });
    });
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(FormComponent // eslint-disable-next-line react/jsx-props-no-spreading
  , _extends({}, props, FormComponentProps)), costEstimate && /*#__PURE__*/React__default.createElement(FormSpy, {
    subscription: {
      values: true
    },
    onChange: onChange
  })), loading ? /*#__PURE__*/React__default.createElement(LinearProgress, null) : /*#__PURE__*/React__default.createElement(Divider, {
    light: true
  }), /*#__PURE__*/React__default.createElement(DialogActions, null, value && /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "caption"
  }, "Estimated cost: $".concat(value)), error && /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "caption",
    color: "error"
  }, error), /*#__PURE__*/React__default.createElement(Button, {
    disabled: costEstimate && (loading || !value),
    onClick: handleSubmit,
    color: "primary",
    variant: "contained"
  }, submitText)));
};

function BatonAnalysisDialog(_ref9) {
  var classes = _ref9.classes,
      className = _ref9.className,
      titleText = _ref9.titleText,
      submitText = _ref9.submitText,
      errorText = _ref9.errorText,
      itemId = _ref9.itemId,
      onClose = _ref9.onClose,
      onSuccess = _ref9.onSuccess,
      onFailure = _ref9.onFailure,
      InitialFormValues = _ref9.InitialFormValues,
      FormComponent = _ref9.FormComponent,
      FormComponentProps = _ref9.FormComponentProps,
      costEstimate = _ref9.costEstimate,
      showDynamicParams = _ref9.showDynamicParams;

  var _useBatonHook = useBatonHook(itemId),
      shapes = _useBatonHook.shapes,
      testplans = _useBatonHook.testplans,
      resources = _useBatonHook.resources,
      startBatonJob = _useBatonHook.startBatonJob,
      isLoading = _useBatonHook.isLoading;

  var onSubmit = function onSubmit(form) {
    var preset = form.preset,
        shapeId = form.shapeId,
        resourceId = form.resourceId,
        batonDynamicParams = form.batonDynamicParams;
    var queryParams = {
      preset: preset,
      resourceId: resourceId,
      jobmetadata: batonDynamicParams && [{
        key: 'batonDynamicParams',
        value: batonDynamicParams
      }]
    };
    startBatonJob(shapeId, queryParams).then(onSuccess)["catch"](onFailure);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtBatonAnalysisDialog-root', className)
  }, /*#__PURE__*/React__default.createElement(DialogTitle, {
    disableTypography: true
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6"
  }, titleText), !isLoading && !testplans.length && /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "subtitle1",
    color: "error"
  }, errorText)), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(Form, {
    itemId: itemId,
    FormComponent: FormComponent,
    FormComponentProps: FormComponentProps,
    initialValues: InitialFormValues,
    onSubmit: onSubmit,
    render: FormWrapper,
    resources: resources,
    testplans: testplans,
    onClose: onClose,
    shapes: shapes,
    submitText: submitText,
    subscription: {
      submitting: true,
      pristine: true
    },
    costEstimate: costEstimate,
    showDynamicParams: showDynamicParams
  }));
}
BatonAnalysisDialog.propTypes = {
  classes: propTypes.objectOf(propTypes.any),
  className: propTypes.string,
  itemId: propTypes.string.isRequired,
  onClose: propTypes.func,
  onSuccess: propTypes.func,
  onFailure: propTypes.func,
  titleText: propTypes.string,
  errorText: propTypes.string,
  submitText: propTypes.string,
  costEstimate: propTypes.bool,
  showDynamicParams: propTypes.bool,
  InitialFormValues: propTypes.objectOf(propTypes.any),
  FormComponent: propTypes.oneOfType([propTypes.element, propTypes.elementType]),
  FormComponentProps: propTypes.objectOf(propTypes.any)
};
BatonAnalysisDialog.defaultProps = {
  classes: {},
  className: 'VdtBatonAnalysisDialog',
  onClose: function onClose() {},
  onSuccess: function onSuccess() {},
  onFailure: function onFailure() {},
  titleText: 'Baton QC',
  errorText: 'Please configure testplans',
  submitText: 'Start QC',
  costEstimate: true,
  showDynamicParams: false,
  InitialFormValues: {
    preset: null,
    shapeId: ''
  },
  FormComponent: BatonFormComponent,
  FormComponentProps: {}
};
var BatonAnalysisDialog$1 = withStyles$1({}, {
  name: 'VdtBatonAnalysisDialog'
})(BatonAnalysisDialog);

var SubmitButton = (function (_ref) {
  var children = _ref.children,
      _ref$submitting = _ref.submitting,
      submitting = _ref$submitting === void 0 ? false : _ref$submitting,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["children", "submitting", "disabled"]);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React__default.createElement(Button$1, _extends({}, props, {
      disabled: disabled || submitting
    }), /*#__PURE__*/React__default.createElement(Box, {
      position: "relative"
    }, /*#__PURE__*/React__default.createElement(Box, {
      position: "absolute",
      height: 1,
      width: 1,
      display: submitting ? 'inherit' : 'none'
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 24
    })), /*#__PURE__*/React__default.createElement(Box, null, children)))
  );
});

var isUrl = function isUrl() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var helperText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Not a URL';
  var expression = /https?:\/\/[-a-zA-Z0-9@:%._+~#=]{2,256}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gi;
  var regex = new RegExp(expression);
  var matches = value.match(regex);
  return matches ? undefined : helperText;
};

var UrlField = withStyles({}, {
  name: 'VdtUrlField'
})(function (_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'serverUrl' : _ref$name,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Vidispine API Server' : _ref$label,
      _ref$FieldProps = _ref.FieldProps,
      FieldProps = _ref$FieldProps === void 0 ? {} : _ref$FieldProps,
      props = _objectWithoutProperties(_ref, ["name", "label", "FieldProps"]);

  return /*#__PURE__*/React__default.createElement(Field, _extends({
    name: name,
    component: TextField$1,
    type: "text",
    label: label,
    validate: isUrl,
    fullWidth: true // eslint-disable-next-line react/jsx-props-no-spreading

  }, FieldProps, props));
});
var UsernameField = withStyles({}, {
  name: 'VdtUsernameField'
})(function (_ref2) {
  var _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? 'userName' : _ref2$name,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? 'Username' : _ref2$label,
      _ref2$requiredText = _ref2.requiredText,
      requiredText = _ref2$requiredText === void 0 ? 'Required' : _ref2$requiredText,
      _ref2$FieldProps = _ref2.FieldProps,
      FieldProps = _ref2$FieldProps === void 0 ? {} : _ref2$FieldProps,
      props = _objectWithoutProperties(_ref2, ["name", "label", "requiredText", "FieldProps"]);

  return /*#__PURE__*/React__default.createElement(Field, _extends({
    name: name,
    component: TextField$1,
    type: "text",
    label: label,
    validate: function validate(value) {
      return value ? undefined : requiredText;
    },
    fullWidth: true // eslint-disable-next-line react/jsx-props-no-spreading

  }, FieldProps, props));
});
var PasswordField = withStyles({}, {
  name: 'VdtPasswordField'
})(function (_ref3) {
  var _ref3$name = _ref3.name,
      name = _ref3$name === void 0 ? 'password' : _ref3$name,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? 'Password' : _ref3$label,
      _ref3$requiredText = _ref3.requiredText,
      requiredText = _ref3$requiredText === void 0 ? 'Required' : _ref3$requiredText,
      _ref3$FieldProps = _ref3.FieldProps,
      FieldProps = _ref3$FieldProps === void 0 ? {} : _ref3$FieldProps,
      props = _objectWithoutProperties(_ref3, ["name", "label", "requiredText", "FieldProps"]);

  return /*#__PURE__*/React__default.createElement(Field, _extends({
    name: name,
    component: TextField$1,
    type: "password",
    label: label,
    validate: function validate(value) {
      return value ? undefined : requiredText;
    },
    fullWidth: true // eslint-disable-next-line react/jsx-props-no-spreading

  }, FieldProps, props));
});
var RememberMeField = withStyles({}, {
  name: 'VdtRememberMeField'
})(function (_ref4) {
  var _ref4$name = _ref4.name,
      name = _ref4$name === void 0 ? 'rememberMe' : _ref4$name,
      _ref4$label = _ref4.label,
      label = _ref4$label === void 0 ? 'Remember Me' : _ref4$label,
      _ref4$FieldProps = _ref4.FieldProps,
      FieldProps = _ref4$FieldProps === void 0 ? {} : _ref4$FieldProps,
      props = _objectWithoutProperties(_ref4, ["name", "label", "FieldProps"]);

  return /*#__PURE__*/React__default.createElement(Field, _extends({
    name: name,
    label: label,
    component: CheckboxField$1,
    type: "checkbox" // eslint-disable-next-line react/jsx-props-no-spreading

  }, FieldProps, props));
});

var FormFields = function FormFields(_ref5) {
  var _ref5$UrlFieldCompone = _ref5.UrlFieldComponent,
      UrlFieldComponent = _ref5$UrlFieldCompone === void 0 ? UrlField : _ref5$UrlFieldCompone,
      _ref5$UrlFieldProps = _ref5.UrlFieldProps,
      UrlFieldProps = _ref5$UrlFieldProps === void 0 ? {} : _ref5$UrlFieldProps,
      _ref5$UsernameFieldCo = _ref5.UsernameFieldComponent,
      UsernameFieldComponent = _ref5$UsernameFieldCo === void 0 ? UsernameField : _ref5$UsernameFieldCo,
      _ref5$UsernameFieldPr = _ref5.UsernameFieldProps,
      UsernameFieldProps = _ref5$UsernameFieldPr === void 0 ? {} : _ref5$UsernameFieldPr,
      _ref5$PasswordFieldCo = _ref5.PasswordFieldComponent,
      PasswordFieldComponent = _ref5$PasswordFieldCo === void 0 ? PasswordField : _ref5$PasswordFieldCo,
      _ref5$PasswordFieldPr = _ref5.PasswordFieldProps,
      PasswordFieldProps = _ref5$PasswordFieldPr === void 0 ? {} : _ref5$PasswordFieldPr,
      _ref5$RememberMeField = _ref5.RememberMeFieldComponent,
      RememberMeFieldComponent = _ref5$RememberMeField === void 0 ? RememberMeField : _ref5$RememberMeField,
      _ref5$RememberMeField2 = _ref5.RememberMeFieldProps,
      RememberMeFieldProps = _ref5$RememberMeField2 === void 0 ? {} : _ref5$RememberMeField2,
      FieldProps = _ref5.FieldProps;
  return /*#__PURE__*/React__default.createElement(Box, null, UrlFieldComponent && /*#__PURE__*/React__default.createElement(UrlFieldComponent, _extends({
    FieldProps: FieldProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, UrlFieldProps)), UsernameFieldComponent && /*#__PURE__*/React__default.createElement(UsernameFieldComponent, _extends({
    FieldProps: FieldProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, UsernameFieldProps)), PasswordFieldComponent && /*#__PURE__*/React__default.createElement(PasswordFieldComponent, _extends({
    FieldProps: FieldProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, PasswordFieldProps)), RememberMeFieldComponent && /*#__PURE__*/React__default.createElement(RememberMeFieldComponent, _extends({
    FieldProps: FieldProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, RememberMeFieldProps)));
};

var FormText = function FormText(_ref6) {
  var helperText = _ref6.helperText,
      submitError = _ref6.submitError;
  return /*#__PURE__*/React__default.createElement(Box, {
    py: helperText || submitError ? 0 : 0.8,
    my: 1
  }, (helperText || submitError) && /*#__PURE__*/React__default.createElement(FormHelperText, {
    error: Boolean(submitError)
  }, submitError || helperText));
};

var FormButtons = withStyles({}, {
  name: 'VdtLoginFormButtons'
})(function (_ref7) {
  var submitting = _ref7.submitting,
      _ref7$SubmitButtonPro = _ref7.SubmitButtonProps,
      SubmitButtonProps = _ref7$SubmitButtonPro === void 0 ? {} : _ref7$SubmitButtonPro,
      _ref7$loginText = _ref7.loginText,
      loginText = _ref7$loginText === void 0 ? 'Login' : _ref7$loginText;
  return /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(SubmitButton, _extends({
    type: "submit",
    submitting: submitting,
    fullWidth: true // eslint-disable-next-line react/jsx-props-no-spreading

  }, SubmitButtonProps), loginText));
});
function LoginForm(_ref8) {
  var _ref8$onSubmit = _ref8.onSubmit,
      onSubmit = _ref8$onSubmit === void 0 ? function () {
    return null;
  } : _ref8$onSubmit,
      helperText = _ref8.helperText,
      _ref8$SubmitButtonPro = _ref8.SubmitButtonProps,
      SubmitButtonProps = _ref8$SubmitButtonPro === void 0 ? {} : _ref8$SubmitButtonPro,
      _ref8$FormProps = _ref8.FormProps,
      FormProps = _ref8$FormProps === void 0 ? {} : _ref8$FormProps,
      _ref8$FieldProps = _ref8.FieldProps,
      FieldProps = _ref8$FieldProps === void 0 ? {} : _ref8$FieldProps,
      _ref8$UrlFieldCompone = _ref8.UrlFieldComponent,
      UrlFieldComponent = _ref8$UrlFieldCompone === void 0 ? UrlField : _ref8$UrlFieldCompone,
      _ref8$UsernameFieldCo = _ref8.UsernameFieldComponent,
      UsernameFieldComponent = _ref8$UsernameFieldCo === void 0 ? UsernameField : _ref8$UsernameFieldCo,
      _ref8$PasswordFieldCo = _ref8.PasswordFieldComponent,
      PasswordFieldComponent = _ref8$PasswordFieldCo === void 0 ? PasswordField : _ref8$PasswordFieldCo,
      _ref8$RememberMeField = _ref8.RememberMeFieldComponent,
      RememberMeFieldComponent = _ref8$RememberMeField === void 0 ? RememberMeField : _ref8$RememberMeField,
      _ref8$FormFieldsCompo = _ref8.FormFieldsComponent,
      FormFieldsComponent = _ref8$FormFieldsCompo === void 0 ? FormFields : _ref8$FormFieldsCompo,
      _ref8$FormFieldsProps = _ref8.FormFieldsProps,
      FormFieldsProps = _ref8$FormFieldsProps === void 0 ? {} : _ref8$FormFieldsProps,
      _ref8$FormTextCompone = _ref8.FormTextComponent,
      FormTextComponent = _ref8$FormTextCompone === void 0 ? FormText : _ref8$FormTextCompone,
      _ref8$FormTextProps = _ref8.FormTextProps,
      FormTextProps = _ref8$FormTextProps === void 0 ? {} : _ref8$FormTextProps,
      _ref8$FormButtonsComp = _ref8.FormButtonsComponent,
      FormButtonsComponent = _ref8$FormButtonsComp === void 0 ? FormButtons : _ref8$FormButtonsComp,
      _ref8$FormButtonsProp = _ref8.FormButtonsProps,
      FormButtonsProps = _ref8$FormButtonsProp === void 0 ? {} : _ref8$FormButtonsProp;
  return /*#__PURE__*/React__default.createElement(Form, _extends({
    onSubmit: onSubmit // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormProps, {
    render: function render(_ref9) {
      var handleSubmit = _ref9.handleSubmit,
          submitting = _ref9.submitting,
          submitError = _ref9.submitError;
      return /*#__PURE__*/React__default.createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/React__default.createElement(FormFieldsComponent, _extends({
        FieldProps: FieldProps,
        UrlFieldComponent: UrlFieldComponent,
        UsernameFieldComponent: UsernameFieldComponent,
        PasswordFieldComponent: PasswordFieldComponent,
        RememberMeFieldComponent: RememberMeFieldComponent // eslint-disable-next-line react/jsx-props-no-spreading

      }, FormFieldsProps)), /*#__PURE__*/React__default.createElement(FormTextComponent, _extends({
        helperText: helperText,
        submitError: submitError // eslint-disable-next-line react/jsx-props-no-spreading

      }, FormTextProps)), /*#__PURE__*/React__default.createElement(FormButtonsComponent, _extends({
        submitting: submitting,
        handleSubmit: handleSubmit,
        SubmitButtonProps: SubmitButtonProps // eslint-disable-next-line react/jsx-props-no-spreading

      }, FormButtonsProps)));
    }
  }));
}

var styles$f = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -11,
      marginRight: 11,
      '&$disabled': {
        cursor: 'default'
      },
      width: '100%'
    },
    disabled: {},
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },
    labelText: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    labelCount: {
      marginLeft: 'auto',
      marginRight: -11
    }
  };
};
var ExpandedFormControlLabel = /*#__PURE__*/forwardRef(function (props, ref) {
  var checked = props.checked,
      classes = props.classes,
      className = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = _objectWithoutProperties(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "name", "onChange", "value"]);

  var muiFormControl = useFormControl();
  var labels = label ? label.split(' ') : [];
  var labelText = labels.slice(0, labels.length - 1).join(' ');
  var labelCount = labels.slice(-1);
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    createElement("label", _extends({
      className: clsx(classes.root, _defineProperty({}, classes.disabled, disabled), className),
      ref: ref // eslint-disable-next-line react/jsx-props-no-spreading

    }, other), /*#__PURE__*/cloneElement(control, controlProps), /*#__PURE__*/createElement(Typography$1, {
      component: "span",
      className: clsx(classes.label, classes.labelText, _defineProperty({}, classes.disabled, disabled))
    }, labelText), /*#__PURE__*/createElement(Typography$1, {
      component: "span",
      className: clsx(classes.label, classes.labelCount, _defineProperty({}, classes.disabled, disabled))
    }, labelCount))
  );
});
var ExpandedFormControlLabel$1 = withStyles$1(styles$f, {
  name: 'VdtExpandedFormControlLabel'
})(ExpandedFormControlLabel);

var onGetToken = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var userName, password, serverUrl, queryParams, headers, _yield$UserApi$getTok, token, _error$response, response, _error$message, message, submissionError;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            userName = _ref.userName, password = _ref.password, serverUrl = _ref.serverUrl;
            queryParams = {
              seconds: 2592000,
              autoRefresh: 'true'
            };
            headers = {
              password: password,
              username: userName
            };

            if (serverUrl) {
              utils.defaultClient.defaults.baseURL = serverUrl;
            }

            _context.prev = 4;
            _context.next = 7;
            return user.getToken({
              userName: userName,
              queryParams: queryParams,
              headers: headers
            });

          case 7:
            _yield$UserApi$getTok = _context.sent;
            token = _yield$UserApi$getTok.data;
            return _context.abrupt("return", token);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](4);
            _error$response = _context.t0.response, response = _error$response === void 0 ? {} : _error$response, _error$message = _context.t0.message, message = _error$message === void 0 ? 'Unknown error.' : _error$message;
            submissionError = _defineProperty({}, FORM_ERROR, message);

            if (response.status === 401) {
              submissionError = _defineProperty({}, FORM_ERROR, 'Incorrect Username/Password');
            }

            throw submissionError;

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 12]]);
  }));

  return function onGetToken(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var styles$g = function styles(theme) {
  return {
    root: {
      height: 20,
      lineHeight: 'inherit'
    },
    icon: {
      padding: 0,
      marginLeft: theme.spacing(2)
    }
  };
};

function FilterFormLabel(_ref) {
  var classes = _ref.classes,
      label = _ref.label,
      hidden = _ref.hidden,
      onClick = _ref.onClick,
      _ref$IconComponent = _ref.IconComponent,
      IconComponent = _ref$IconComponent === void 0 ? CancelIcon : _ref$IconComponent;
  return /*#__PURE__*/React__default.createElement(Box, {
    className: classes.root
  }, label, /*#__PURE__*/React__default.createElement(IconButton, {
    className: classes.icon,
    onClick: onClick,
    style: {
      visibility: hidden ? 'hidden' : 'inherit'
    }
  }, /*#__PURE__*/React__default.createElement(IconComponent, null)));
}

var FilterFormLabel$1 = withStyles(styles$g, {
  name: 'VdtFilterFormLabel'
})(FilterFormLabel);

var defaultParseOptions = function defaultParseOptions() {
  var facet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var hideEmptyOptions = arguments.length > 1 ? arguments[1] : undefined;
  return Object.entries(facet).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        count = _ref2[1];

    return hideEmptyOptions === false || count !== 0;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        value = _ref4[0],
        count = _ref4[1];

    return {
      value: value,
      label: "".concat(value.toUpperCase()).concat(count !== undefined ? " (".concat(count, ")") : '')
    };
  });
};

function FilterForm(_ref5) {
  var className = _ref5.className,
      fields = _ref5.fields,
      _ref5$defaultValues = _ref5.defaultValues,
      defaultValues = _ref5$defaultValues === void 0 ? {} : _ref5$defaultValues,
      parsedFacet = _ref5.parsedFacet,
      form = _ref5.form,
      _ref5$dirtyFields = _ref5.dirtyFields,
      dirtyFields = _ref5$dirtyFields === void 0 ? {} : _ref5$dirtyFields,
      handleSubmit = _ref5.handleSubmit,
      hideEmptyFilters = _ref5.hideEmptyFilters;
  var hasChangedValues = React__default.useCallback(function (name) {
    var _form$getState = form.getState(),
        _form$getState$values = _form$getState.values,
        values = _form$getState$values === void 0 ? {} : _form$getState$values;

    if (values[name] && Array.isArray(values[name])) {
      return values[name].length > 0;
    }

    return dirtyFields[name];
  }, [dirtyFields, form]);
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit,
    className: className
  }, fields.map(function (_ref6) {
    var name = _ref6.value,
        _ref6$parseOptions = _ref6.parseOptions,
        parseOptions = _ref6$parseOptions === void 0 ? defaultParseOptions : _ref6$parseOptions,
        label = _ref6.label,
        _ref6$FacetProps = _ref6.FacetProps,
        FacetProps = _ref6$FacetProps === void 0 ? {} : _ref6$FacetProps,
        _ref6$FilterFormLabel = _ref6.FilterFormLabelProps,
        FilterFormLabelProps = _ref6$FilterFormLabel === void 0 ? {} : _ref6$FilterFormLabel,
        props = _objectWithoutProperties(_ref6, ["value", "parseOptions", "label", "FacetProps", "FilterFormLabelProps"]);

    var facets = parsedFacet[name];
    var count = FacetProps.count;
    var options = parseOptions(facets, hideEmptyFilters);
    var display = hideEmptyFilters === true && count === true && options.length === 0 ? 'none' : 'inherit';
    return /*#__PURE__*/React__default.createElement("div", {
      key: name,
      style: {
        display: display
      }
    }, /*#__PURE__*/React__default.createElement(Field, _extends({
      name: name,
      FormHelperTextProps: {
        style: {
          display: 'none'
        }
      },
      defaultValue: defaultValues[name],
      label: /*#__PURE__*/React__default.createElement(FilterFormLabel$1, _extends({
        hidden: !hasChangedValues(name),
        label: label,
        onClick: function onClick() {
          return form.change(name);
        } // eslint-disable-next-line react/jsx-props-no-spreading

      }, FilterFormLabelProps)),
      options: options // eslint-disable-next-line react/jsx-props-no-spreading

    }, props)));
  }));
}

var styles$h = function styles(theme) {
  return {
    header: {
      padding: theme.spacing(2),
      paddingBottom: '0'
    },
    form: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    }
  };
};

var isDate = function isDate(value) {
  var dateValue = new Date(value);
  return dateValue instanceof Date && !Number.isNaN(dateValue.getTime());
};

var isString = function isString(value) {
  return typeof value === 'string' || value instanceof String;
};

var isNumber = function isNumber(value) {
  return typeof value === 'number';
};

var isNow = function isNow(value) {
  return isString(value) && value.startsWith('NOW');
};

var hasDates = function hasDates(values) {
  return values.every(isDate);
};

var hasNumbers = function hasNumbers(values) {
  return values.every(isNumber);
};

var hasNowRange = function hasNowRange(values) {
  return values.every(isNow) || values.some(isNow) && values.some(isDate);
};

var getRangeValues = function getRangeValues(value) {
  var values;

  if (hasDates(value)) {
    values = value.sort(function (a, b) {
      return new Date(a).getTime() - new Date(b).getTime();
    });
  } else if (hasNumbers(value)) {
    values = value.sort(function (a, b) {
      return Number(a) - Number(b);
    });
  } else if (hasNowRange(value)) {
    values = value.sort(function (a, b) {
      return parseNowDate(a).getTime() - parseNowDate(b).getTime();
    });
  } else {
    return undefined;
  }

  return [values[0], values[values.length - 1]];
};

var getRangeFilter = function getRangeFilter(name, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  return {
    name: name,
    field: [{
      name: name,
      range: [{
        value: [{
          value: min
        }, {
          value: max
        }]
      }]
    }]
  };
};

var getFieldFilter = function getFieldFilter(name, value, operation) {
  return {
    name: name,
    field: Array.isArray(value) ? value.map(function (v) {
      return {
        name: name,
        value: [{
          value: v
        }]
      };
    }) : [{
      name: name,
      value: [{
        value: value
      }]
    }],
    operation: operation
  };
};

function parseFilterValues(filter) {
  return (filter || []).reduce(function (acc, curr) {
    return _objectSpread2(_defineProperty({}, curr.name, (curr.field || []).flatMap(function (_ref3) {
      var value = _ref3.value,
          range = _ref3.range;

      if (value) {
        return value[0].value;
      }

      if (range) {
        return range[0].value.map(function (v) {
          return v.value;
        });
      }

      return undefined;
    })), acc);
  }, {});
}

function FilterCard(_ref4) {
  var className = _ref4.className,
      classes = _ref4.classes,
      _ref4$itemListType = _ref4.itemListType,
      itemListType = _ref4$itemListType === void 0 ? {} : _ref4$itemListType,
      _ref4$fields = _ref4.fields,
      fields = _ref4$fields === void 0 ? [] : _ref4$fields,
      initialSearchFilter = _ref4.initialSearchFilter,
      isLoading = _ref4.isLoading,
      onChange = _ref4.onChange,
      _ref4$headerText = _ref4.headerText,
      headerText = _ref4$headerText === void 0 ? 'Filter' : _ref4$headerText,
      _ref4$component = _ref4.component,
      RootComponent = _ref4$component === void 0 ? Paper : _ref4$component,
      _ref4$FormComponent = _ref4.FormComponent,
      FormComponent = _ref4$FormComponent === void 0 ? FilterForm : _ref4$FormComponent,
      _ref4$FormProps = _ref4.FormProps,
      FormProps = _ref4$FormProps === void 0 ? {} : _ref4$FormProps,
      _ref4$HeaderProps = _ref4.HeaderProps,
      HeaderProps = _ref4$HeaderProps === void 0 ? {} : _ref4$HeaderProps,
      _ref4$CardProps = _ref4.CardProps,
      CardProps = _ref4$CardProps === void 0 ? {} : _ref4$CardProps,
      _ref4$operation = _ref4.operation,
      operation = _ref4$operation === void 0 ? 'OR' : _ref4$operation,
      hideEmptyFilters = _ref4.hideEmptyFilters;

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      dirty = _React$useState2[0],
      setDirty = _React$useState2[1];

  var facet = itemListType.facet;
  var initialValues = React__default.useMemo(function () {
    return parseFilterValues(initialSearchFilter);
  }, [initialSearchFilter]);
  var parsedFacet = React__default.useMemo(function () {
    return parseFacetType(facet);
  }, [facet]);
  var onSubmit = React__default.useCallback(function (values) {
    var valueEntries = Object.entries(values);
    if (valueEntries.length === 0 && !dirty) return;
    if (!dirty) setDirty(true);
    var filters = valueEntries.filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          value = _ref6[1];

      return value !== null;
    }).map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          name = _ref8[0],
          value = _ref8[1];

      var field = fields.find(function (f) {
        return f.value === name;
      });

      if (field.isRange && Array.isArray(value) && value.length >= 2) {
        return getRangeFilter(name, getRangeValues(value));
      }

      return getFieldFilter(name, value, operation);
    });
    onChange(filters);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [onChange, dirty]);
  return !isLoading ? /*#__PURE__*/React__default.createElement(RootComponent, _extends({
    className: className // eslint-disable-next-line react/jsx-props-no-spreading

  }, CardProps), headerText && /*#__PURE__*/React__default.createElement(Box$1, {
    className: classes.header
  }, /*#__PURE__*/React__default.createElement(Typography$1, _extends({
    variant: "button",
    color: "textSecondary" // eslint-disable-next-line react/jsx-props-no-spreading

  }, HeaderProps), headerText)), /*#__PURE__*/React__default.createElement(Form, _extends({
    className: classes.form,
    onSubmit: onSubmit,
    render: FormComponent,
    parsedFacet: parsedFacet,
    validate: onSubmit,
    fields: fields,
    defaultValues: initialValues,
    hideEmptyFilters: hideEmptyFilters // eslint-disable-next-line react/jsx-props-no-spreading

  }, FormProps))) : null;
}

var FilterCard$1 = withStyles(styles$h, {
  name: 'VdtFilterCard'
})(FilterCard);

var ALL = 'all';
var READY = 'READY';
var STARTED = 'STARTED';
var VIDINET_JOB = 'VIDINET_JOB';
var FINISHED = 'FINISHED';
var FINISHED_WARNING = 'FINISHED_WARNING';
var WAITING = 'WAITING';
var ABORT_PENDING = 'ABORT_PENDING';
var ABORTED = 'ABORTED';
var FAILED_TOTAL = 'FAILED_TOTAL';
var LOWEST = 'LOWEST';
var LOW = 'LOW';
var MEDIUM = 'MEDIUM';
var HIGH = 'HIGH';
var HIGHEST = 'HIGHEST';
var IMMEDIATE = 'IMMEDIATE';
var JOB_PRIORITIES = [LOWEST, LOW, MEDIUM, HIGH, HIGHEST, IMMEDIATE];
var JOB_STATES = [READY, STARTED, VIDINET_JOB, FINISHED, FINISHED_WARNING, WAITING, ABORT_PENDING, ABORTED, FAILED_TOTAL];
var ALL_STATES = [ALL];
var ERROR_STATES = [FAILED_TOTAL, ABORTED];
var SUCCESSFUL_STATES = [FINISHED];
var RUNNING_STATES = [READY, STARTED, VIDINET_JOB, WAITING, ABORT_PENDING];
var INACTIVE_STATES = [FINISHED, FINISHED_WARNING, FAILED_TOTAL, ABORTED];

function JobRowButton(_ref) {
  var job = _ref.job,
      icon = _ref.icon,
      tooltip = _ref.tooltip,
      _onClick = _ref.onClick,
      disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement(Tooltip$1, {
    placement: "top",
    title: tooltip
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    disabled: disabled,
    onClick: function onClick() {
      return _onClick(job);
    },
    size: "small"
  }, icon));
}

function JobRow(_ref) {
  var _ref$job = _ref.job,
      job = _ref$job === void 0 ? {} : _ref$job,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      onClick = _ref.onClick,
      restartJob = _ref.restartJob,
      deleteJob = _ref.deleteJob,
      abortJob = _ref.abortJob,
      _ref$retryText = _ref.retryText,
      retryText = _ref$retryText === void 0 ? 'Retry' : _ref$retryText,
      _ref$deleteText = _ref.deleteText,
      deleteText = _ref$deleteText === void 0 ? 'Delete' : _ref$deleteText,
      _ref$startedText = _ref.startedText,
      startedText = _ref$startedText === void 0 ? 'Started' : _ref$startedText,
      _ref$finishedText = _ref.finishedText,
      finishedText = _ref$finishedText === void 0 ? 'Finished' : _ref$finishedText;
  var _job$status = job.status,
      status = _job$status === void 0 ? '' : _job$status;
  return /*#__PURE__*/React__default.createElement(TableRow$3, {
    onClick: onClick !== undefined ? function () {
      return onClick(job);
    } : undefined,
    style: {
      cursor: onClick !== undefined ? 'pointer' : 'initial'
    }
  }, /*#__PURE__*/React__default.createElement(TableCell, null, RUNNING_STATES.includes(status) && /*#__PURE__*/React__default.createElement(CircularProgress$1, {
    size: 20
  }), ERROR_STATES.includes(status) && /*#__PURE__*/React__default.createElement(Cancel, {
    style: {
      color: red[500]
    },
    size: 20
  }), SUCCESSFUL_STATES.includes(status) && /*#__PURE__*/React__default.createElement(CheckCircle, {
    style: {
      color: green[500]
    },
    size: 20
  })), columns.map(function (_ref2) {
    var value = _ref2.value,
        valueComponent = _ref2.valueComponent;
    return /*#__PURE__*/React__default.createElement(TableCell, {
      key: value
    }, valueComponent ? valueComponent({
      job: job,
      value: job[value],
      startedText: startedText,
      finishedText: finishedText
    }) : job[value]);
  }), abortJob && RUNNING_STATES.indexOf(status) > -1 && /*#__PURE__*/React__default.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React__default.createElement(JobRowButton, {
    job: job,
    icon: /*#__PURE__*/React__default.createElement(Cancel, {
      size: 20
    }),
    tooltip: "Abort",
    onClick: abortJob,
    disabled: status === 'ABORTED_PENDING'
  })), restartJob && ERROR_STATES.indexOf(status) > -1 && /*#__PURE__*/React__default.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React__default.createElement(JobRowButton, {
    job: job,
    icon: /*#__PURE__*/React__default.createElement(Replay, {
      size: 20
    }),
    tooltip: retryText,
    onClick: restartJob
  })), deleteJob && SUCCESSFUL_STATES.indexOf(status) > -1 && /*#__PURE__*/React__default.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React__default.createElement(JobRowButton, {
    job: job,
    icon: /*#__PURE__*/React__default.createElement(Cancel, {
      size: 20
    }),
    tooltip: deleteText,
    onClick: deleteJob
  })));
}

var JobRow$1 = withStyles({}, {
  name: 'VdtJobRow'
})(JobRow);

var StartedComponent = function StartedComponent(_ref) {
  var _ref$job = _ref.job,
      status = _ref$job.status,
      started = _ref$job.started,
      finished = _ref$job.finished,
      _ref$startedText = _ref.startedText,
      startedText = _ref$startedText === void 0 ? 'Started' : _ref$startedText,
      _ref$finishedText = _ref.finishedText,
      finishedText = _ref$finishedText === void 0 ? 'Finished' : _ref$finishedText;
  return RUNNING_STATES.includes(status) ? "".concat(startedText, " ").concat(started ? moment(started).fromNow() : '') : "".concat(finishedText, " ").concat(finished ? moment(finished).fromNow() : '');
};
var DEFAULT_COLUMNS = [{
  value: 'type'
}, {
  value: 'started',
  valueComponent: StartedComponent
}];
var DEFAULT_COLUMN_LABELS = {
  type: 'Type',
  started: 'Started'
};

function JobTable(_ref2) {
  var _ref2$jobs = _ref2.jobs,
      jobs = _ref2$jobs === void 0 ? [] : _ref2$jobs,
      _ref2$columns = _ref2.columns,
      columns = _ref2$columns === void 0 ? DEFAULT_COLUMNS : _ref2$columns,
      abortJob = _ref2.abortJob,
      deleteJob = _ref2.deleteJob,
      restartJob = _ref2.restartJob,
      _ref2$hideHeader = _ref2.hideHeader,
      hideHeader = _ref2$hideHeader === void 0 ? false : _ref2$hideHeader,
      _ref2$JobRowComponent = _ref2.JobRowComponent,
      JobRowComponent = _ref2$JobRowComponent === void 0 ? JobRow$1 : _ref2$JobRowComponent,
      _ref2$JobRowProps = _ref2.JobRowProps,
      JobRowProps = _ref2$JobRowProps === void 0 ? {} : _ref2$JobRowProps,
      _ref2$jobColumnLabels = _ref2.jobColumnLabels,
      jobColumnLabels = _ref2$jobColumnLabels === void 0 ? DEFAULT_COLUMN_LABELS : _ref2$jobColumnLabels;
  return /*#__PURE__*/React__default.createElement(TableContainer, null, /*#__PURE__*/React__default.createElement(Table, {
    size: "small"
  }, !hideHeader && /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$3, null, /*#__PURE__*/React__default.createElement(TableCell, null), columns.map(function (_ref3) {
    var value = _ref3.value;
    return /*#__PURE__*/React__default.createElement(TableCell, {
      key: jobColumnLabels[value]
    }, jobColumnLabels[value]);
  }), /*#__PURE__*/React__default.createElement(TableCell, null))), /*#__PURE__*/React__default.createElement(TableBody, null, jobs.map(function (job) {
    return /*#__PURE__*/React__default.createElement(JobRowComponent, _extends({
      key: job.jobId,
      job: job,
      columns: columns,
      abortJob: abortJob,
      deleteJob: deleteJob,
      restartJob: restartJob // eslint-disable-next-line react/jsx-props-no-spreading

    }, JobRowProps));
  }))));
}

var JobTable$1 = withStyles({}, {
  name: 'VdtJobTable'
})(JobTable);

var useExpand = (function () {
  var initialExpanded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _React$useState = React__default.useState(initialExpanded),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  var onExpand = function onExpand() {
    return setExpanded(true);
  };

  var onClose = function onClose() {
    return setExpanded(false);
  };

  var onToggle = function onToggle() {
    return setExpanded(!expanded);
  };

  return {
    expanded: expanded,
    onExpand: onExpand,
    onClose: onClose,
    onToggle: onToggle
  };
});

var options = [{
  label: 'All',
  value: ALL_STATES
}, {
  label: 'Running',
  value: RUNNING_STATES
}, {
  label: 'Inactive',
  value: INACTIVE_STATES
}];
function JobFooter(_ref) {
  var _ref$defaultExpanded = _ref.defaultExpanded,
      defaultExpanded = _ref$defaultExpanded === void 0 ? false : _ref$defaultExpanded,
      jobs = _ref.jobs,
      isLoading = _ref.isLoading,
      hasLoaded = _ref.hasLoaded,
      onListJob = _ref.onListJob,
      _ref$refreshInterval = _ref.refreshInterval,
      refreshInterval = _ref$refreshInterval === void 0 ? 15000 : _ref$refreshInterval,
      _ref$startTimeFromMin = _ref.startTimeFromMinutes,
      startTimeFromMinutes = _ref$startTimeFromMin === void 0 ? 10 : _ref$startTimeFromMin,
      _ref$JobTableComponen = _ref.JobTableComponent,
      JobTableComponent = _ref$JobTableComponen === void 0 ? JobTable$1 : _ref$JobTableComponen;

  var _useExpand = useExpand(defaultExpanded),
      expanded = _useExpand.expanded,
      onToggle = _useExpand.onToggle;

  var _React$useState = React__default.useState({
    first: 1,
    number: 5,
    sort: 'startTime desc',
    state: ALL_STATES
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      matrixParams = _React$useState2[0],
      setMatrixParams = _React$useState2[1];

  var onChange = function onChange(_ref2) {
    var state = _ref2.target.value;
    setMatrixParams(_objectSpread2(_objectSpread2({}, matrixParams), {}, {
      state: state
    }));
  };

  var onRefresh = React__default.useCallback(function () {
    var currentTime = new Date();
    currentTime.setMinutes(currentTime.getMinutes() - startTimeFromMinutes);
    var queryParams = {
      'starttime-from': currentTime.toISOString()
    };
    onListJob({
      matrixParams: matrixParams,
      queryParams: queryParams
    });
  }, [matrixParams, onListJob, startTimeFromMinutes]);
  React__default.useEffect(function () {
    onRefresh();
    var interval = setInterval(onRefresh, refreshInterval);
    return function () {
      return clearInterval(interval);
    };
  }, [onRefresh, refreshInterval]); // eslint-disable-next-line max-len

  if (!hasLoaded || matrixParams.state === ALL_STATES && jobs.length === 0) return null;
  return /*#__PURE__*/React__default.createElement(AppBar, {
    color: "inherit",
    position: "fixed",
    style: {
      bottom: 8,
      left: 8,
      top: 'auto',
      width: '32em'
    }
  }, /*#__PURE__*/React__default.createElement(Accordion$1, {
    TransitionProps: {
      unmountOnExit: true
    },
    expanded: expanded
  }, /*#__PURE__*/React__default.createElement(AccordionSummary$1, {
    expandIcon: isLoading ? /*#__PURE__*/React__default.createElement(CircularProgress$1, {
      size: 20
    }) : /*#__PURE__*/React__default.createElement(ExpandLess, null),
    onClick: onToggle
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "button",
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, "Jobs"), expanded && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Divider, {
    orientation: "vertical",
    style: {
      margin: '0 25px',
      height: 30
    }
  }), /*#__PURE__*/React__default.createElement(Select$1, {
    value: matrixParams.state,
    onChange: onChange,
    fullWidth: true
  }, options.map(function (_ref3) {
    var label = _ref3.label,
        value = _ref3.value;
    return /*#__PURE__*/React__default.createElement(MenuItem$1, {
      key: value,
      value: value
    }, label);
  })))), /*#__PURE__*/React__default.createElement(AccordionDetails$1, {
    style: {
      flexDirection: 'column'
    }
  }, jobs.length > 0 ? /*#__PURE__*/React__default.createElement(JobTableComponent, {
    jobs: jobs,
    hideHeader: true
  }) : /*#__PURE__*/React__default.createElement("span", null, "No jobs found"))));
}

function SearchPaginationActions(_ref) {
  var count = _ref.count,
      page = _ref.page,
      rowsPerPage = _ref.rowsPerPage,
      onChangePage = _ref.onChangePage;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick() {
      return onChangePage({
        page: 0
      });
    },
    disabled: page === 0
  }, /*#__PURE__*/React__default.createElement(FirstPageIcon, null)), /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick() {
      return onChangePage({
        page: page - 1
      });
    },
    disabled: page === 0
  }, /*#__PURE__*/React__default.createElement(KeyboardArrowLeft, null)), /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick() {
      return onChangePage({
        page: page + 1
      });
    },
    disabled: page >= Math.ceil(count / rowsPerPage) - 1
  }, /*#__PURE__*/React__default.createElement(KeyboardArrowRight, null)), /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick() {
      return onChangePage({
        page: Math.max(0, Math.ceil(count / rowsPerPage) - 1)
      });
    },
    disabled: page >= Math.ceil(count / rowsPerPage) - 1
  }, /*#__PURE__*/React__default.createElement(LastPageIcon, null)));
}

function SearchPagination(_ref) {
  var _ref$count = _ref.count,
      count = _ref$count === void 0 ? 0 : _ref$count,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? 0 : _ref$page,
      _ref$rowsPerPage = _ref.rowsPerPage,
      rowsPerPage = _ref$rowsPerPage === void 0 ? 10 : _ref$rowsPerPage,
      _ref$rowsPerPageOptio = _ref.rowsPerPageOptions,
      initialRowsPerPageOptions = _ref$rowsPerPageOptio === void 0 ? [10, 25, 50, 100] : _ref$rowsPerPageOptio,
      onChangePage = _ref.onChangePage,
      onChangeRowsPerPage = _ref.onChangeRowsPerPage,
      _ref$ActionsComponent = _ref.ActionsComponent,
      ActionsComponent = _ref$ActionsComponent === void 0 ? SearchPaginationActions : _ref$ActionsComponent,
      _ref$TablePaginationP = _ref.TablePaginationProps,
      TablePaginationProps = _ref$TablePaginationP === void 0 ? {} : _ref$TablePaginationP;
  var rowsPerPageOptions = !initialRowsPerPageOptions.includes(rowsPerPage) ? [].concat(_toConsumableArray(initialRowsPerPageOptions), [rowsPerPage]).sort(function (a, b) {
    return a - b;
  }) : initialRowsPerPageOptions;
  return /*#__PURE__*/React__default.createElement(TablePagination, _extends({
    component: "div",
    count: count,
    page: page,
    rowsPerPage: rowsPerPage,
    onChangePage: onChangePage,
    onChangeRowsPerPage: onChangeRowsPerPage,
    ActionsComponent: ActionsComponent,
    rowsPerPageOptions: rowsPerPageOptions // eslint-disable-next-line react/jsx-props-no-spreading

  }, TablePaginationProps));
}

var useStyles = function useStyles(secondaryColor) {
  return makeStyles({
    selected: {
      '&$selected': {
        backgroundColor: fade(secondaryColor, 0.16),
        color: secondaryColor
      }
    }
  });
};

var SortMenuItem = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var primary = _ref.primary,
      onClick = _ref.onClick,
      selected = _ref.selected,
      secondaryColor = _ref.secondaryColor,
      MenuItemProps = _ref.MenuItemProps,
      ListItemTextProps = _ref.ListItemTextProps;
  var classes = useStyles(secondaryColor)();
  return /*#__PURE__*/React__default.createElement(MenuItem, _extends({
    selected: selected,
    onClick: onClick,
    dense: true,
    classes: {
      selected: classes.selected
    },
    ref: ref // eslint-disable-next-line react/jsx-props-no-spreading

  }, MenuItemProps), /*#__PURE__*/React__default.createElement(ListItemText, _extends({
    primary: primary,
    primaryTypographyProps: {
      variant: 'caption'
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemTextProps)));
});
SortMenuItem.propTypes = {
  primary: propTypes.string,
  secondaryColor: propTypes.string,
  onClick: propTypes.func,
  selected: propTypes.bool,
  MenuItemProps: propTypes.objectOf(propTypes.any),
  ListItemTextProps: propTypes.objectOf(propTypes.any)
};
SortMenuItem.defaultProps = {
  primary: '',
  secondaryColor: red.A200,
  onClick: undefined,
  selected: false,
  MenuItemProps: {},
  ListItemTextProps: {}
};

var styles$i = function styles(theme) {
  return {
    root: {
      color: theme.palette.secondary.main,
      paddingLeft: 9,
      paddingRight: 9,
      borderRadius: 4
    },
    indicator: {
      marginRight: -2,
      marginLeft: 4,
      color: theme.palette.secondary.main,
      transition: 'transform .2s ease-out'
    },
    indicatorAsc: {
      transform: 'rotate(180deg)'
    },
    menuPaper: {
      minWidth: 150,
      marginTop: 4
    }
  };
};

function Sort(_ref) {
  var classes = _ref.classes,
      caption = _ref.caption,
      options = _ref.options,
      sortAsc = _ref.sortAsc,
      sortDesc = _ref.sortDesc,
      IconComponent = _ref.IconComponent,
      MenuItemComponent = _ref.MenuItemComponent,
      onChange = _ref.onChange,
      initialSort = _ref.initialSort,
      innerProps = _objectWithoutProperties(_ref, ["classes", "caption", "options", "sortAsc", "sortDesc", "IconComponent", "MenuItemComponent", "onChange", "initialSort"]);

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleOpen = function handleOpen(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var _React$useState3 = React__default.useState(initialSort || {
    option: {},
    direction: sortDesc
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      sortBy = _React$useState4[0],
      setSortBy = _React$useState4[1];

  var handleSortBy = function handleSortBy(newOption) {
    return function (event) {
      var option = sortBy.option,
          direction = sortBy.direction;

      if (newOption.value !== option.value) {
        option = newOption;
      } else {
        direction = direction === sortDesc ? sortAsc : sortDesc;
      }

      setSortBy({
        option: option,
        direction: direction
      });
      if (onChange) onChange(event, option.value, direction);
      handleClose();
    };
  };

  var isDisabled = options === undefined || options.length === 0;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ButtonBase, {
    onClick: handleOpen,
    className: classes.root,
    disabled: isDisabled
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: isDisabled ? 'textSecondary' : 'textPrimary',
    className: classes.label
  }, "".concat(caption, ": ").concat(sortBy.option.label || '')), IconComponent && /*#__PURE__*/React__default.createElement("span", {
    className: clsx(classes.indicator, _defineProperty({}, classes.indicatorAsc, sortBy.direction === sortAsc))
  }, /*#__PURE__*/React__default.createElement(IconComponent, null))), /*#__PURE__*/React__default.createElement(Menu, {
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose,
    elevation: 1,
    getContentAnchorEl: null,
    marginThreshold: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    PaperProps: {
      className: classes.menuPaper
    }
  }, options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(MenuItemComponent, _extends({
      key: option.value,
      primary: option.label,
      onClick: handleSortBy(option),
      selected: option.value === sortBy.option.value // eslint-disable-next-line react/jsx-props-no-spreading

    }, innerProps));
  })));
}

Sort.propTypes = {
  classes: propTypes.objectOf(propTypes.any).isRequired,
  caption: propTypes.string,
  sortAsc: propTypes.string,
  sortDesc: propTypes.string,
  IconComponent: propTypes.elementType,
  MenuItemComponent: propTypes.elementType,
  onChange: propTypes.func,
  options: propTypes.arrayOf(propTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    value: propTypes.any,
    label: propTypes.string
  })),
  initialSort: propTypes.shape({
    option: propTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      value: propTypes.any,
      label: propTypes.string
    }),
    direction: propTypes.string
  })
};
Sort.defaultProps = {
  caption: 'Sort by',
  sortAsc: 'ascending',
  sortDesc: 'descending',
  IconComponent: ArrowDropDownIcon,
  MenuItemComponent: SortMenuItem,
  onChange: undefined,
  initialSort: undefined,
  options: []
};
var Sort$1 = withStyles(styles$i, {
  name: 'VdtSort'
})(Sort);

var getLabel = function getLabel(label, count) {
  return "".concat(label).concat(count !== undefined ? " (".concat(count, ")") : '');
};

function FilterSelectForm(_ref) {
  var _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {
    return null;
  } : _ref$onSubmit,
      _ref$onChange = _ref.onChange,
      handleChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      name = _ref.name,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, ["onSubmit", "onChange", "options", "name", "label"]);

  var hasLoaded = React__default.useRef();

  var onChange = function onChange(_ref2) {
    var values = _ref2.values;

    if (!hasLoaded.current) {
      hasLoaded.current = true;
      return;
    }

    var field = {
      name: name,
      value: []
    };
    Object.values(values).forEach(function (value) {
      field.value.push({
        value: value
      });
    });
    var filter = {
      field: [field],
      operation: 'OR',
      name: name
    };
    handleChange(filter);
  };

  return /*#__PURE__*/React__default.createElement(Form, {
    onSubmit: onSubmit,
    render: function render(_ref3) {
      var handleSubmit = _ref3.handleSubmit,
          form = _ref3.form,
          dirty = _ref3.dirty;
      return /*#__PURE__*/React__default.createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/React__default.createElement(Field, _extends({
        name: name,
        label: /*#__PURE__*/React__default.createElement(Box, {
          height: 20,
          style: {
            lineHeight: 'inherit'
          }
        }, label, /*#__PURE__*/React__default.createElement(IconButton, {
          onClick: form.reset,
          style: {
            padding: 0,
            marginLeft: 16,
            visibility: dirty ? 'inherit' : 'hidden'
          }
        }, /*#__PURE__*/React__default.createElement(CancelIcon, null))),
        component: SelectField$1,
        FormHelperTextProps: {
          style: {
            display: 'none'
          }
        },
        options: options.map(function (_ref4) {
          var value = _ref4.value,
              fieldLabel = _ref4.label,
              count = _ref4.count;
          return {
            value: value,
            label: getLabel(fieldLabel, count)
          };
        }),
        type: "text",
        FormControlProps: {
          fullWidth: true
        } // eslint-disable-next-line react/jsx-props-no-spreading

      }, props)), /*#__PURE__*/React__default.createElement(FormSpy, {
        subscription: {
          values: true
        },
        onChange: onChange
      }));
    }
  });
}

var styles$j = function styles(theme) {
  return {
    root: {
      backgroundColor: theme.palette.background.paper
    }
  };
};

function SearchInputFieldSelect(_ref) {
  var classes = _ref.classes,
      onSubmit = _ref.onSubmit,
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [{
    label: 'Item ID',
    value: 'itemId'
  }, {
    label: 'Shape ID',
    value: 'shapeId'
  }, {
    label: 'Tag',
    value: 'tag'
  }] : _ref$fields,
      _ref$value = _ref.value,
      defaultValue = _ref$value === void 0 ? '' : _ref$value,
      _ref$query = _ref.query,
      defaultQuery = _ref$query === void 0 ? '' : _ref$query,
      _ref$fieldPlaceHolder = _ref.fieldPlaceHolder,
      fieldPlaceHolder = _ref$fieldPlaceHolder === void 0 ? 'Field' : _ref$fieldPlaceHolder,
      _ref$queryPlaceHolder = _ref.queryPlaceHolder,
      queryPlaceHolder = _ref$queryPlaceHolder === void 0 ? 'Query' : _ref$queryPlaceHolder,
      _ref$disableReset = _ref.disableReset,
      disableReset = _ref$disableReset === void 0 ? false : _ref$disableReset,
      _ref$disableRequired = _ref.disableRequired,
      disableRequired = _ref$disableRequired === void 0 ? false : _ref$disableRequired,
      fieldInputRef = _ref.fieldInputRef,
      queryInputRef = _ref.queryInputRef,
      props = _objectWithoutProperties(_ref, ["classes", "onSubmit", "fields", "value", "query", "fieldPlaceHolder", "queryPlaceHolder", "disableReset", "disableRequired", "fieldInputRef", "queryInputRef"]);

  var _React$useState = React__default.useState(defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      field = _React$useState2[0],
      setField = _React$useState2[1];

  var _React$useState3 = React__default.useState(defaultQuery),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      query = _React$useState4[0],
      setQuery = _React$useState4[1];

  var _React$useState5 = React__default.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      menu = _React$useState6[0],
      setMenu = _React$useState6[1];

  var fieldElInputRef = React__default.useRef();
  if (fieldInputRef) fieldElInputRef = fieldInputRef;
  var queryElInputRef = React__default.useRef();
  if (queryInputRef) queryElInputRef = queryInputRef;

  var onReset = function onReset() {
    setQuery('');
    setField('');
  };

  var onEnter = function onEnter(e) {
    e.preventDefault();

    if (!disableRequired && !field) {
      return fieldElInputRef.current.focus();
    }

    if (!disableRequired && !query) {
      return queryElInputRef.current.focus();
    }

    onSubmit({
      field: field,
      query: query
    });
    return !disableReset ? onReset() : null;
  };

  return /*#__PURE__*/React__default.createElement(Box$1, _extends({
    className: classes.root,
    component: "form",
    display: "flex",
    onSubmit: onEnter // eslint-disable-next-line react/jsx-props-no-spreading

  }, props), /*#__PURE__*/React__default.createElement(InputBase, {
    className: classes.inputBaseField,
    inputRef: fieldElInputRef,
    placeholder: fieldPlaceHolder,
    value: field,
    required: !disableRequired,
    onChange: function onChange(_ref2) {
      var target = _ref2.target;
      return setField(target.value);
    },
    startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
      position: "start"
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      onClick: function onClick(_ref3) {
        var c = _ref3.currentTarget;
        return setMenu(c);
      }
    }, /*#__PURE__*/React__default.createElement(Label, null)))
  }), /*#__PURE__*/React__default.createElement(Box$1, {
    mx: 2
  }, /*#__PURE__*/React__default.createElement(Divider, {
    orientation: "vertical"
  })), /*#__PURE__*/React__default.createElement(InputBase, {
    className: classes.inputBaseQuery,
    fullWidth: true,
    inputRef: queryElInputRef,
    placeholder: queryPlaceHolder,
    value: query,
    required: !disableRequired,
    onChange: function onChange(_ref4) {
      var target = _ref4.target;
      return setQuery(target.value);
    },
    endAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      type: "submit",
      size: "small"
    }, /*#__PURE__*/React__default.createElement(Search, null)))
  }), /*#__PURE__*/React__default.createElement(Menu$1, {
    className: classes.menu,
    anchorEl: menu,
    keepMounted: true,
    open: Boolean(menu),
    onClose: function onClose() {
      return setMenu(null);
    }
  }, fields.map(function (_ref5) {
    var label = _ref5.label,
        value = _ref5.value;
    return /*#__PURE__*/React__default.createElement(MenuItem$1, {
      key: value,
      onClick: function onClick() {
        setField(value);
        setMenu(null);
      }
    }, label);
  })));
}

var SearchInputFieldSelect$1 = withStyles(styles$j, {
  name: 'VdtSearchInputFieldSelect'
})(SearchInputFieldSelect);

var YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
var THIS_WEEK = moment().subtract(7, 'days').format('YYYY-MM-DD');
var JOB_TABLE_COLUMNS = [{
  value: 'jobId'
}, {
  value: 'status'
}].concat(_toConsumableArray(DEFAULT_COLUMNS));
var SORT_OPTIONS = ['jobId', 'type', 'state', 'user', 'startTime', 'priority'];
var DEFAULT_COLUMN_LABELS$1 = {
  jobId: 'Job ID',
  type: 'Type',
  state: 'State',
  user: 'Created By',
  startTime: 'Started',
  priority: 'Priority',
  status: 'Status',
  started: 'Started',
  finished: 'Finished',
  yesterday: 'Yesterday',
  thisWeek: 'This Week',
  allTime: 'All Time'
};

function JobList(_ref) {
  var page = _ref.page,
      _ref$jobs = _ref.jobs;
  _ref$jobs = _ref$jobs === void 0 ? {} : _ref$jobs;
  var _ref$jobs$job = _ref$jobs.job,
      job$1 = _ref$jobs$job === void 0 ? [] : _ref$jobs$job,
      _ref$jobs$hits = _ref$jobs.hits,
      hits = _ref$jobs$hits === void 0 ? 0 : _ref$jobs$hits,
      _ref$jobMetadata = _ref.jobMetadata,
      jobMetadata = _ref$jobMetadata === void 0 ? [] : _ref$jobMetadata,
      rowsPerPage = _ref.rowsPerPage,
      onChangeSort = _ref.onChangeSort,
      onChangePage = _ref.onChangePage,
      onChangeType = _ref.onChangeType,
      onChangeState = _ref.onChangeState,
      onChangePriority = _ref.onChangePriority,
      onChangeStarttime = _ref.onChangeStarttime,
      onChangeFinishtime = _ref.onChangeFinishtime,
      onChangeRowsPerPage = _ref.onChangeRowsPerPage,
      onChangeJobmetadata = _ref.onChangeJobmetadata,
      onRefresh = _ref.onRefresh,
      matrixParams = _ref.matrixParams,
      _ref$jobColumnLabels = _ref.jobColumnLabels,
      jobColumnLabels = _ref$jobColumnLabels === void 0 ? DEFAULT_COLUMN_LABELS$1 : _ref$jobColumnLabels,
      _ref$JobTableProps = _ref.JobTableProps,
      JobTableProps = _ref$JobTableProps === void 0 ? {} : _ref$JobTableProps;
  var Abort = useApi(job.abortJob);
  var Restart = useApi(job.duplicateJob);
  var Delete = useApi(job.deleteJob);

  var _useApi = useApi(taskdefinition.listJobType),
      getJobTypes = _useApi.request,
      _useApi$data = _useApi.data,
      jobTypes = _useApi$data === void 0 ? {} : _useApi$data;

  var abortJob = function abortJob(_ref2) {
    var jobId = _ref2.jobId;
    Abort.request({
      jobId: jobId
    });
  };

  var restartJob = function restartJob(_ref3) {
    var jobId = _ref3.jobId;
    Restart.request({
      jobId: jobId
    });
  };

  var deleteJob = function deleteJob(_ref4) {
    var jobId = _ref4.jobId;
    Delete.request({
      queryParams: {
        id: jobId
      }
    });
  };

  var _jobTypes$uri = jobTypes.uri,
      uri = _jobTypes$uri === void 0 ? [] : _jobTypes$uri;
  React__default.useEffect(function () {
    getJobTypes();
  }, [getJobTypes]);
  React__default.useEffect(function () {
    onRefresh(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Abort.isLoading, Restart.isLoading, Delete.isLoading]);

  var asd = function asd(_ref5) {
    var value = _ref5.query,
        key = _ref5.field;
    onChangeJobmetadata([].concat(_toConsumableArray(jobMetadata), [{
      key: key,
      value: value
    }]));
  };

  var handleDelete = function handleDelete(index) {
    var newMetadata = _toConsumableArray(jobMetadata);

    newMetadata.splice(index, 1);
    onChangeJobmetadata(newMetadata);
  };

  var initialSort;
  var sortOptions = SORT_OPTIONS.map(function (value) {
    return {
      value: value,
      label: jobColumnLabels[value]
    };
  });

  if (matrixParams && matrixParams.sort) {
    var _matrixParams$sort$sp = matrixParams.sort.split(' '),
        _matrixParams$sort$sp2 = _slicedToArray(_matrixParams$sort$sp, 2),
        sortValue = _matrixParams$sort$sp2[0],
        _matrixParams$sort$sp3 = _matrixParams$sort$sp2[1],
        direction = _matrixParams$sort$sp3 === void 0 ? 'asc' : _matrixParams$sort$sp3;

    var option = sortOptions.find(function (_ref6) {
      var thisValue = _ref6.value;
      return thisValue === sortValue;
    });
    if (option) initialSort = {
      option: option,
      direction: direction
    };
  }

  return /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%"
  }, /*#__PURE__*/React__default.createElement(Box, {
    height: 40,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(SearchInputFieldSelect$1, {
    onSubmit: asd,
    flexGrow: 1,
    py: 0.5,
    px: 1
  }), /*#__PURE__*/React__default.createElement(Box, null, jobMetadata.map(function (_ref7, index) {
    var key = _ref7.key,
        value = _ref7.value;
    return /*#__PURE__*/React__default.createElement(Chip$1, {
      size: "small",
      clickable: true,
      key: key + value,
      label: "".concat(key, ": ").concat(value),
      onDelete: function onDelete() {
        return handleDelete(index);
      }
    });
  })), /*#__PURE__*/React__default.createElement(Sort$1, {
    options: sortOptions,
    initialSort: initialSort,
    onChange: onChangeSort,
    sortAsc: "asc",
    sortDesc: "desc"
  }), /*#__PURE__*/React__default.createElement(SearchPagination, {
    page: page,
    count: hits,
    rowsPerPage: rowsPerPage,
    onChangePage: onChangePage,
    onChangeRowsPerPage: onChangeRowsPerPage
  })), /*#__PURE__*/React__default.createElement(Box, {
    width: "100%",
    py: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    alignItems: "flex-start"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    lg: 2,
    md: 3,
    sm: 4,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Box, {
    mr: 4
  }, /*#__PURE__*/React__default.createElement(FilterSelectForm, {
    options: uri.map(function (val) {
      return {
        value: val,
        label: val
      };
    }),
    label: jobColumnLabels.type,
    name: "type",
    multiple: true,
    onChange: onChangeType
  }), /*#__PURE__*/React__default.createElement(FilterSelectForm, {
    options: JOB_STATES.map(function (val) {
      return {
        value: val,
        label: val
      };
    }),
    label: jobColumnLabels.state,
    name: "state",
    multiple: true,
    onChange: onChangeState
  }), /*#__PURE__*/React__default.createElement(FilterSelectForm, {
    options: JOB_PRIORITIES.map(function (val) {
      return {
        value: val,
        label: val
      };
    }),
    label: jobColumnLabels.priority,
    name: "priority",
    multiple: true,
    onChange: onChangePriority
  }), /*#__PURE__*/React__default.createElement(FilterSelectForm, {
    options: [{
      value: YESTERDAY,
      label: jobColumnLabels.yesterday
    }, {
      value: THIS_WEEK,
      label: jobColumnLabels.thisWeek
    }, {
      value: 0,
      label: jobColumnLabels.allTime
    }],
    label: jobColumnLabels.started,
    name: "starttime-from",
    onChange: onChangeStarttime
  }), /*#__PURE__*/React__default.createElement(FilterSelectForm, {
    options: [{
      value: YESTERDAY,
      label: jobColumnLabels.yesterday
    }, {
      value: THIS_WEEK,
      label: jobColumnLabels.thisWeek
    }, {
      value: 0,
      label: jobColumnLabels.allTime
    }],
    label: jobColumnLabels.finished,
    name: "finishtime-from",
    onChange: onChangeFinishtime
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    lg: 10,
    md: 9,
    sm: 8,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(JobTable$1, _extends({
    jobs: job$1,
    columns: JOB_TABLE_COLUMNS,
    abortJob: abortJob,
    deleteJob: deleteJob,
    restartJob: restartJob,
    jobColumnLabels: jobColumnLabels // eslint-disable-next-line react/jsx-props-no-spreading

  }, JobTableProps))))));
}

var JobList$1 = withStyles({}, {
  name: 'VdtJobList'
})(JobList);

var TableCellLabel = withStyles(function (theme) {
  return {
    root: _objectSpread2({
      borderStyle: 'none',
      verticalAlign: 'top',
      paddingRight: '1em'
    }, theme.typography.body2)
  };
})(TableCell$1);
var TableCellValue = withStyles(function (theme) {
  return {
    root: _objectSpread2({
      borderStyle: 'none',
      wordBreak: 'break-word',
      verticalAlign: 'top'
    }, theme.typography.subtitle2)
  };
})(TableCell$1);

var TableRow = function TableRow(_ref) {
  var label = _ref.label,
      value = _ref.value,
      _ref$formatValue = _ref.formatValue,
      formatValue = _ref$formatValue === void 0 ? function (thisValue) {
    return thisValue;
  } : _ref$formatValue,
      _ref$TableRowProps = _ref.TableRowProps,
      TableRowProps = _ref$TableRowProps === void 0 ? {} : _ref$TableRowProps,
      _ref$TableCellLabelPr = _ref.TableCellLabelProps,
      TableCellLabelProps = _ref$TableCellLabelPr === void 0 ? {} : _ref$TableCellLabelPr,
      _ref$TableCellValuePr = _ref.TableCellValueProps,
      TableCellValueProps = _ref$TableCellValuePr === void 0 ? {} : _ref$TableCellValuePr;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React__default.createElement(TableRow$3$1, _extends({
      component: "div"
    }, TableRowProps), /*#__PURE__*/React__default.createElement(TableCellLabel, _extends({
      component: "div" // eslint-disable-next-line react/jsx-props-no-spreading

    }, TableCellLabelProps), label), /*#__PURE__*/React__default.createElement(TableCellValue, _extends({
      component: "div" // eslint-disable-next-line react/jsx-props-no-spreading

    }, TableCellValueProps), value !== undefined ? formatValue(value) : ''))
  );
};

function ItemMetadataTable(_ref2) {
  var _ref2$fields = _ref2.fields,
      fields = _ref2$fields === void 0 ? [] : _ref2$fields,
      _ref2$TableRowCompone = _ref2.TableRowComponent,
      TableRowComponent = _ref2$TableRowCompone === void 0 ? TableRow : _ref2$TableRowCompone,
      _ref2$TableRowProps = _ref2.TableRowProps,
      TableRowProps = _ref2$TableRowProps === void 0 ? {} : _ref2$TableRowProps,
      values = _objectWithoutProperties(_ref2, ["fields", "TableRowComponent", "TableRowProps"]);

  return /*#__PURE__*/React__default.createElement(Table$1, {
    size: "small",
    padding: "none",
    style: {
      width: '100%'
    },
    component: "div"
  }, /*#__PURE__*/React__default.createElement(TableBody$1, {
    component: "div"
  }, fields.map(function (_ref3) {
    var label = _ref3.label,
        fieldName = _ref3.value,
        fieldProps = _objectWithoutProperties(_ref3, ["label", "value"]);

    return /*#__PURE__*/React__default.createElement(TableRowComponent, _extends({
      key: fieldName,
      label: label,
      value: values[fieldName],
      TableRowProps: TableRowProps // eslint-disable-next-line react/jsx-props-no-spreading

    }, TableRowProps, fieldProps));
  })));
}

var parseKeyValuePairType = function parseKeyValuePairType() {
  var keyValuePairType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var keyValuePairTypeReducer = function keyValuePairTypeReducer(a, _ref) {
    var key = _ref.key,
        value = _ref.value;
    return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, key, value));
  };

  return keyValuePairType.reduce(keyValuePairTypeReducer, {});
};

var useJob = function useJob(jobId, fieldList) {
  var _useApi = useApi(job.getJob),
      getJob = _useApi.request,
      _useApi$data = _useApi.data,
      jobType = _useApi$data === void 0 ? {} : _useApi$data,
      reset = _useApi.reset;

  var fields = fieldList.map(function (f) {
    return typeof f === 'string' ? {
      label: f,
      value: f
    } : f;
  });
  React__default.useEffect(function () {
    var queryParams = {
      metadata: true,
      field: fieldList.map(function (field) {
        return field.value ? field.value : field;
      })
    };
    getJob({
      jobId: jobId,
      queryParams: queryParams
    });
    return reset;
  }, [jobId, getJob, reset, fieldList]);
  var _jobType$data = jobType.data,
      dataType = _jobType$data === void 0 ? [] : _jobType$data,
      user = jobType.user,
      type = jobType.type,
      status = jobType.status,
      started = jobType.started,
      finished = jobType.finished,
      priority = jobType.priority;
  var data = parseKeyValuePairType(dataType);

  var values = _objectSpread2(_objectSpread2({}, data), {}, {
    user: user,
    type: type,
    status: status,
    started: started,
    finished: finished,
    priority: priority,
    jobId: jobId
  });

  return {
    fields: fields,
    values: values
  };
};

function JobDataTable(_ref2) {
  var jobId = _ref2.jobId,
      initialFields = _ref2.fields,
      TableComponent = _ref2.TableComponent,
      TableProps = _ref2.TableProps;

  var _useJob = useJob(jobId, initialFields),
      fields = _useJob.fields,
      values = _useJob.values; // eslint-disable-next-line react/jsx-props-no-spreading


  return /*#__PURE__*/React__default.createElement(TableComponent, _extends({
    fields: fields
  }, TableProps, values));
}

JobDataTable.propTypes = {
  jobId: propTypes.string.isRequired,
  fields: propTypes.arrayOf(propTypes.oneOfType([propTypes.string, propTypes.shape({
    label: propTypes.string,
    value: propTypes.string,
    formatValue: propTypes.func
  })])),
  TableComponent: propTypes.elementType,
  TableProps: propTypes.objectOf(propTypes.any)
};
JobDataTable.defaultProps = {
  fields: [{
    label: 'Job ID',
    value: 'jobId'
  }, {
    label: 'Resource ID',
    value: 'vidinetResourceId'
  }, {
    label: 'User',
    value: 'user'
  }, {
    label: 'Type',
    value: 'type'
  }, {
    label: 'Priority',
    value: 'priority'
  }, {
    label: 'Started',
    value: 'started',
    formatValue: function formatValue(val) {
      return new Date(val).toLocaleString();
    }
  }, {
    label: 'Finished',
    value: 'finished',
    formatValue: function formatValue(val) {
      return new Date(val).toLocaleString();
    }
  }, {
    label: 'Vidinet ID',
    value: 'vidinetJobId'
  }],
  TableComponent: ItemMetadataTable,
  TableProps: {}
};
var JobDataTable$1 = withStyles({}, {
  name: 'VdtJobDataTable'
})(JobDataTable);

var humanizeDuration = function humanizeDuration() {
  var samples = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _formatSeconds$toTime = formatSeconds(samples).toTime(),
      hours = _formatSeconds$toTime.hours,
      minutes = _formatSeconds$toTime.minutes,
      seconds = _formatSeconds$toTime.seconds;

  var duration = ["".concat(seconds !== undefined ? seconds : 1, "s")];
  if (minutes > 0) duration.unshift("".concat(minutes, "m"));
  if (hours > 0) duration.unshift("".concat(hours, "h"));
  return duration.join(' ');
};

var useJobTasks = function useJobTasks(jobId, autoRefresh) {
  var _useApi = useApi(job.getJob),
      getJob = _useApi.request,
      _useApi$data = _useApi.data,
      jobStep = _useApi$data === void 0 ? {} : _useApi$data;

  var onGetJobStep = function onGetJobStep() {
    if (!jobId) return;
    getJob({
      jobId: jobId
    });
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  React__default.useEffect(onGetJobStep, [jobId]);
  var taskDefinitionType = React__default.useMemo(function () {
    return jobStep.type;
  }, [jobStep]);

  var _useApi2 = useApi(taskdefinition.getTaskDefinitionType),
      getJobType = _useApi2.request,
      _useApi2$data = _useApi2.data,
      jobType = _useApi2$data === void 0 ? {} : _useApi2$data;

  var getJobTasks = function getJobTasks() {
    if (!taskDefinitionType) return;
    getJobType({
      taskDefinitionType: taskDefinitionType
    });
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  React__default.useEffect(getJobTasks, [taskDefinitionType]);
  var jobStatus = jobStep.status,
      _jobStep$log = jobStep.log;
  _jobStep$log = _jobStep$log === void 0 ? {} : _jobStep$log;
  var _jobStep$log$task = _jobStep$log.task,
      stepList = _jobStep$log$task === void 0 ? [] : _jobStep$log$task;
  var steps = React__default.useMemo(function () {
    return stepList.map(function (step, index) {
      if (!stepList.length) return [];
      var timestamp = step.timestamp,
          subStep = step.subStep,
          status = step.status;
      var refTimestamp;

      if (RUNNING_STATES.includes(status)) {
        refTimestamp = moment().add(5, 'm');
      } else if (subStep && subStep.length) {
        var ref = subStep.slice(-1)[0].timestamp;
        refTimestamp = moment(ref).add(5, 'm');
      } else if (stepList[index + 1] !== undefined) {
        var _ref = stepList[index + 1].timestamp;
        refTimestamp = moment(_ref);
      } else {
        return _objectSpread2(_objectSpread2({}, step), {}, {
          duration: 0
        });
      }

      var duration = moment(refTimestamp).diff(timestamp, 's');
      return _objectSpread2(_objectSpread2({}, step), {}, {
        duration: duration
      });
    });
  }, [stepList]);
  React__default.useEffect(function () {
    if (!jobStatus || !autoRefresh) return function () {
      return null;
    };
    var interval = null; // set reasonable interval

    if (RUNNING_STATES.includes(jobStatus)) interval = setInterval(onGetJobStep, 1000);
    return function () {
      return clearInterval(interval);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onGetJobStep, jobStatus]);
  var tasks = React__default.useMemo(function () {
    var _jobType$task = jobType.task,
        task = _jobType$task === void 0 ? [] : _jobType$task;
    if (!task.length) return steps.reverse();
    var inactiveSteps = task.filter(function (_ref2) {
      var step = _ref2.step;
      return !steps.some(function (_ref3) {
        var s = _ref3.step;
        return s === step;
      });
    });
    return steps.concat(inactiveSteps).reverse();
  }, [jobType, steps]);
  return {
    tasks: tasks
  };
};

var JobTaskTableRow = function JobTaskTableRow(_ref4) {
  var task = _ref4.task;
  var status = task.status,
      duration = task.duration,
      description = task.description,
      _task$errorMessage = task.errorMessage,
      errorMessage = _task$errorMessage === void 0 ? '' : _task$errorMessage;
  var isRunning = RUNNING_STATES.includes(status);
  var isFinished = SUCCESSFUL_STATES.includes(status);
  var isFailed = ERROR_STATES.includes(status);
  return /*#__PURE__*/React__default.createElement(Tooltip$1, {
    title: errorMessage
  }, /*#__PURE__*/React__default.createElement(TableRow$3, {
    component: "div"
  }, /*#__PURE__*/React__default.createElement(TableCell, {
    padding: "checkbox",
    component: "div"
  }, isRunning && /*#__PURE__*/React__default.createElement(CircularProgress$1, {
    size: 20
  }), isFinished && /*#__PURE__*/React__default.createElement(CheckCircle, {
    style: {
      color: green[500]
    }
  }), isFailed && /*#__PURE__*/React__default.createElement(Cancel, {
    style: {
      color: red[500]
    }
  }), !isRunning && !isFinished && !isFailed && '-'), /*#__PURE__*/React__default.createElement(TableCell, {
    component: "div"
  }, description), /*#__PURE__*/React__default.createElement(TableCell, {
    align: "right",
    component: "div",
    style: {
      fontVariantNumeric: 'tabular-nums'
    }
  }, duration !== undefined ? humanizeDuration(duration) : '-')));
};

var styles$k = {
  root: {},
  TableHead: {},
  TableBody: {}
};

function JobTaskTable(_ref5) {
  var className = _ref5.className,
      classes = _ref5.classes,
      jobId = _ref5.jobId,
      autoRefresh = _ref5.autoRefresh,
      TableProps = _ref5.TableProps,
      statusText = _ref5.statusText,
      stepText = _ref5.stepText,
      durationText = _ref5.durationText,
      JobTaskTableRowComponent = _ref5.JobTaskTableRowComponent,
      JobTaskTableRowProps = _ref5.JobTaskTableRowProps;

  var _useJobTasks = useJobTasks(jobId, autoRefresh),
      _useJobTasks$tasks = _useJobTasks.tasks,
      tasks = _useJobTasks$tasks === void 0 ? [] : _useJobTasks$tasks;

  return /*#__PURE__*/React__default.createElement(Table, _extends({
    className: clsx(className, classes.root, 'VdtJobTaskTable-root'),
    component: "div" // eslint-disable-next-line react/jsx-props-no-spreading

  }, TableProps), /*#__PURE__*/React__default.createElement(TableHead$1, {
    component: "div",
    className: classes.TableHead
  }, /*#__PURE__*/React__default.createElement(TableRow$3, {
    component: "div"
  }, /*#__PURE__*/React__default.createElement(TableCell, {
    padding: "checkbox",
    component: "div"
  }, statusText), /*#__PURE__*/React__default.createElement(TableCell, {
    component: "div"
  }, stepText), /*#__PURE__*/React__default.createElement(TableCell, {
    align: "right",
    component: "div"
  }, durationText))), /*#__PURE__*/React__default.createElement(TableBody, {
    component: "div",
    className: classes.TableHead
  }, tasks.map(function (task) {
    return /*#__PURE__*/React__default.createElement(JobTaskTableRowComponent, _extends({
      key: task.step,
      task: task // eslint-disable-next-line react/jsx-props-no-spreading

    }, JobTaskTableRowProps));
  })));
}

JobTaskTable.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.string),
  jobId: propTypes.string.isRequired,
  autoRefresh: propTypes.bool,
  TableProps: propTypes.objectOf(propTypes.any),
  statusText: propTypes.string,
  stepText: propTypes.string,
  durationText: propTypes.string,
  JobTaskTableRowComponent: propTypes.elementType,
  JobTaskTableRowProps: propTypes.objectOf(propTypes.any)
};
JobTaskTable.defaultProps = {
  className: undefined,
  classes: {},
  autoRefresh: false,
  TableProps: {},
  statusText: 'Status',
  stepText: 'Step',
  durationText: 'Duration',
  JobTaskTableRowComponent: JobTaskTableRow,
  JobTaskTableRowProps: {}
};
var JobTaskTable$1 = withStyles(styles$k, {
  name: 'VdtJobTaskTable'
})(JobTaskTable);

function JobMenu(_ref) {
  var jobType = _ref.jobType,
      onAbort = _ref.onAbort,
      onDelete = _ref.onDelete,
      onDuplicate = _ref.onDuplicate,
      _ref$IconComponent = _ref.IconComponent,
      IconComponent = _ref$IconComponent === void 0 ? MoreVertIcon : _ref$IconComponent;
  var status = jobType.status;

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleMenuClick = function handleMenuClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleMenuClose = function handleMenuClose() {
    setAnchorEl(null);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(IconButton$1, {
    component: ButtonBase$1,
    onClick: handleMenuClick,
    disableRipple: true
  }, /*#__PURE__*/React__default.createElement(IconComponent, null)), /*#__PURE__*/React__default.createElement(Menu$1, {
    onClick: handleMenuClose,
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleMenuClose,
    elevation: 1,
    PaperProps: {
      square: true
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$1, {
    disabled: !INACTIVE_STATES.includes(status),
    onClick: onDelete
  }, /*#__PURE__*/React__default.createElement(ListItemIcon, null, /*#__PURE__*/React__default.createElement(Delete, null)), /*#__PURE__*/React__default.createElement(ListItemText$1, {
    primary: "Delete job"
  })), /*#__PURE__*/React__default.createElement(MenuItem$1, {
    disabled: !RUNNING_STATES.includes(status),
    onClick: onAbort
  }, /*#__PURE__*/React__default.createElement(ListItemIcon, null, /*#__PURE__*/React__default.createElement(Block, null)), /*#__PURE__*/React__default.createElement(ListItemText$1, {
    primary: "Abort job"
  })), /*#__PURE__*/React__default.createElement(MenuItem$1, {
    onClick: onDuplicate
  }, /*#__PURE__*/React__default.createElement(ListItemIcon, null, /*#__PURE__*/React__default.createElement(Replay, null)), /*#__PURE__*/React__default.createElement(ListItemText$1, {
    primary: "Duplicate job"
  }))));
}

var styles$l = {
  root: {},
  CardContent: {
    height: 'calc(100% - 70px)',
    overflow: 'auto'
  },
  Alert: {},
  CardHeader: {},
  Collapse: {}
};

function JobCard(_ref2) {
  var className = _ref2.className,
      classes = _ref2.classes,
      jobType = _ref2.jobType,
      onSuccess = _ref2.onSuccess,
      onError = _ref2.onError,
      JobMenuComponent = _ref2.JobMenuComponent,
      JobMenuProps = _ref2.JobMenuProps;

  var _React$useState3 = React__default.useState({}),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      alert = _React$useState4[0],
      setAlert = _React$useState4[1];

  var _React$useState5 = React__default.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      showAlert = _React$useState6[0],
      setShowAlert = _React$useState6[1];

  var openAlert = function openAlert(alertProps) {
    setShowAlert(true);
    setAlert(alertProps);
  };

  var closeAlert = function closeAlert() {
    return setShowAlert(false);
  };

  if (!jobType) return null;
  var jobId = jobType.jobId;

  var onAbort = function onAbort() {
    return job.abortJob({
      jobId: jobId
    }).then(function (response) {
      openAlert({
        severity: 'success',
        children: 'Successfully aborted job'
      });
      if (onSuccess) onSuccess(response);
    })["catch"](function (error) {
      openAlert({
        severity: 'error',
        children: 'Failed to abort job'
      });
      if (onError) onError(error);
    });
  };

  var onDelete = function onDelete() {
    return job.deleteJob({
      queryParams: {
        id: jobId
      }
    }).then(function (response) {
      openAlert({
        severity: 'success',
        children: 'Successfully deleted job'
      });
      if (onSuccess) onSuccess(response);
    })["catch"](function (error) {
      openAlert({
        severity: 'error',
        children: 'Failed to deleted job'
      });
      if (onError) onError(error);
    });
  };

  var onDuplicate = function onDuplicate() {
    return job.duplicateJob({
      jobId: jobId
    }).then(function (response) {
      openAlert({
        severity: 'success',
        children: 'Successfully duplicated job'
      });
      if (onSuccess) onSuccess(response);
    })["catch"](function (error) {
      openAlert({
        severity: 'error',
        children: 'Failed to duplicate job'
      });
      if (onError) onError(error);
    });
  };

  return /*#__PURE__*/React__default.createElement(Card, {
    elevation: 0,
    className: clsx(className, classes.root, 'VdtJobCard-root')
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    className: classes.CardHeader,
    title: jobId,
    action: /*#__PURE__*/React__default.createElement(HasRole, {
      roleName: [roles.ITEM_WRITE],
      allow: /*#__PURE__*/React__default.createElement(JobMenuComponent, _extends({
        jobType: jobType,
        onAbort: onAbort,
        onDelete: onDelete,
        onDuplicate: onDuplicate // eslint-disable-next-line react/jsx-props-no-spreading

      }, JobMenuProps))
    })
  }), /*#__PURE__*/React__default.createElement(Collapse$1, {
    className: classes.Collapse,
    "in": showAlert
  }, /*#__PURE__*/React__default.createElement(Alert, _extends({
    className: classes.Alert,
    onClose: closeAlert // eslint-disable-next-line react/jsx-props-no-spreading

  }, alert))), /*#__PURE__*/React__default.createElement(CardContent, {
    className: classes.CardContent
  }, /*#__PURE__*/React__default.createElement(JobDataTable$1, {
    jobId: jobId
  }), /*#__PURE__*/React__default.createElement(JobTaskTable$1, {
    jobId: jobId,
    autoRefresh: true
  })));
}

JobCard.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.string),
  jobType: propTypes.objectOf(propTypes.any),
  onSuccess: propTypes.func,
  onError: propTypes.func,
  JobMenuComponent: propTypes.elementType,
  JobMenuProps: propTypes.objectOf(propTypes.any)
};
JobCard.defaultProps = {
  className: undefined,
  classes: {},
  jobType: undefined,
  onSuccess: undefined,
  onError: undefined,
  JobMenuComponent: JobMenu,
  JobMenuProps: {}
};
var JobCard$1 = withStyles(styles$l, {
  name: 'VdtJobCard'
})(JobCard);

var JobFooterContext = /*#__PURE__*/React__default.createContext({
  jobs: [],
  hits: 0,
  abortJob: null,
  transcode: null,
  isLoading: false,
  hasLoaded: false,
  onRefresh: null,
  deleteJob: null,
  shapeTags: null,
  restartJob: null,
  queryParams: null,
  matrixParams: null,
  setQueryParams: null,
  setMatrixParams: null
});
var defaultQueryParams = {};
var defaultMatrixParams = {
  first: 1,
  number: 5,
  sort: 'startTime desc'
};

var JobFooterContextProvider = function JobFooterContextProvider(_ref) {
  var _ref$queryParams = _ref.queryParams,
      initialQueryParams = _ref$queryParams === void 0 ? {} : _ref$queryParams,
      _ref$matrixParams = _ref.matrixParams,
      initialMatrixParams = _ref$matrixParams === void 0 ? {} : _ref$matrixParams,
      _ref$JobFooterProps = _ref.JobFooterProps,
      JobFooterProps = _ref$JobFooterProps === void 0 ? {} : _ref$JobFooterProps,
      _ref$JobFooterCompone = _ref.JobFooterComponent,
      JobFooterComponent = _ref$JobFooterCompone === void 0 ? JobFooter : _ref$JobFooterCompone,
      children = _ref.children;

  var _React$useState = React__default.useState(_objectSpread2(_objectSpread2({}, defaultQueryParams), initialQueryParams)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      queryParams = _React$useState2[0],
      setQueryParams = _React$useState2[1];

  var _React$useState3 = React__default.useState(_objectSpread2(_objectSpread2({}, defaultMatrixParams), initialMatrixParams)),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      matrixParams = _React$useState4[0],
      setMatrixParams = _React$useState4[1];

  var _useApi = useApi(job.listJob),
      onListJob = _useApi.request,
      _useApi$data = _useApi.data;

  _useApi$data = _useApi$data === void 0 ? {} : _useApi$data;
  var _useApi$data$hits = _useApi$data.hits,
      hits = _useApi$data$hits === void 0 ? 0 : _useApi$data$hits,
      _useApi$data$job = _useApi$data.job,
      jobs = _useApi$data$job === void 0 ? [] : _useApi$data$job,
      isLoading = _useApi.isLoading,
      hasLoaded = _useApi.hasLoaded;
  var Abort = useApi(job.abortJob);
  var Restart = useApi(job.duplicateJob);
  var Delete = useApi(job.deleteJob);

  var onRefresh = function onRefresh() {
    return onListJob({
      queryParams: queryParams,
      matrixParams: matrixParams
    });
  };

  var abortJob = function abortJob(_ref2) {
    var jobId = _ref2.jobId;
    Abort.request({
      jobId: jobId
    });
  };

  var restartJob = function restartJob(_ref3) {
    var jobId = _ref3.jobId;
    Restart.request({
      jobId: jobId
    });
  };

  var deleteJob = function deleteJob(_ref4) {
    var jobId = _ref4.jobId;
    Delete.request({
      queryParams: {
        id: jobId
      }
    });
  };

  return /*#__PURE__*/React__default.createElement(JobFooterContext.Provider, {
    value: {
      jobs: jobs,
      hits: hits,
      abortJob: abortJob,
      onRefresh: onRefresh,
      onListJob: onListJob,
      isLoading: isLoading,
      hasLoaded: hasLoaded,
      deleteJob: deleteJob,
      restartJob: restartJob,
      queryParams: queryParams,
      matrixParams: matrixParams,
      setQueryParams: setQueryParams,
      setMatrixParams: setMatrixParams
    }
  }, children, /*#__PURE__*/React__default.createElement(JobFooterComponent, _extends({
    jobs: jobs,
    isLoading: isLoading,
    hasLoaded: hasLoaded,
    onListJob: onListJob // eslint-disable-next-line react/jsx-props-no-spreading

  }, JobFooterProps)));
};

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("style", null, ".vidispine_24_svg__cls-1{fill:#0068a9}.vidispine_24_svg__cls-2{fill:#fff}.vidispine_24_svg__cls-5{fill:#44a8aa}"));

var _ref2 = /*#__PURE__*/createElement("path", {
  fill: "none",
  id: "vidispine_24_svg__canvas_background",
  d: "M-1-1h26v26H-1z"
});

var _ref3 = /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_2",
  d: "M83.35 251.09l-1.91-4.88h-7.25l-1.76 4.88h-2.55l7.18-18.79h1.63L86 251.09h-2.65zm-4.72-12.74c-.17-.47-.32-.89-.43-1.27s-.22-.73-.29-1.05c-.08.35-.18.7-.3 1.07s-.26.77-.43 1.22l-2.1 5.68h5.51l-1.96-5.65z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_3",
  d: "M97.16 251.09v-8.16a9.18 9.18 0 00-.07-1.17 3.33 3.33 0 00-.31-1.07 2 2 0 00-.67-.78 2 2 0 00-1.17-.29 3.69 3.69 0 00-1.09.16 6.22 6.22 0 00-1 .43 7.76 7.76 0 00-1 .6c-.3.22-.59.45-.85.68v9.6h-2.48v-13.45h2.1l.31 1.55q.58-.44 1.14-.78a8 8 0 011.12-.59 6.88 6.88 0 011.19-.38 6.16 6.16 0 011.32-.13 4.27 4.27 0 011.45.26 3.56 3.56 0 011.28.84 4.28 4.28 0 01.91 1.47 6.24 6.24 0 01.34 2.2v9l-2.52.01z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_4",
  d: "M121.66 251.09l-1.91-4.88h-7.25l-1.76 4.88h-2.55l7.19-18.79H117l7.3 18.79h-2.64zm-4.72-12.74a21.359 21.359 0 01-.72-2.32c-.08.35-.18.7-.29 1.07s-.27.77-.44 1.22l-2.1 5.68h5.51l-1.96-5.65z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_5",
  d: "M133.56 240.09a2.9 2.9 0 00-1.34-.31 3 3 0 00-1.37.36 7.81 7.81 0 00-1.53 1.11v9.84h-2.49v-13.45h2.06l.35 1.52a10.39 10.39 0 011.15-.95 6.21 6.21 0 011-.56 4 4 0 01.83-.27 3.81 3.81 0 01.75-.07 3 3 0 01.94.14 3.23 3.23 0 01.69.3l-1.04 2.34z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_6",
  d: "M142.2 251.17h-1.91L135 237.64h2.56l3.67 10.24 4-10.24h2.47l-5.5 13.53z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_7",
  d: "M157.58 251.09l-.54-1.28a6.42 6.42 0 01-.73.58 5.63 5.63 0 01-.91.5 6.46 6.46 0 01-1.1.35 6.74 6.74 0 01-1.33.13 4.61 4.61 0 01-1.62-.29 3.86 3.86 0 01-1.33-.82 4 4 0 01-.91-1.32 4.27 4.27 0 01-.34-1.75 3.85 3.85 0 011.41-3.17 6.7 6.7 0 014.07-1.23l2.62-.08v-.51a3.56 3.56 0 00-.21-1.31 2.08 2.08 0 00-.58-.87 2.13 2.13 0 00-.89-.48 3.92 3.92 0 00-1.11-.15 5.8 5.8 0 00-1.14.11 5.64 5.64 0 00-.95.27 5.25 5.25 0 00-.79.37c-.23.14-.45.28-.64.42l-.94-1.71a8.56 8.56 0 011.22-.75 7 7 0 011.21-.47 7.34 7.34 0 011.22-.25 10.58 10.58 0 011.27-.07 7.42 7.42 0 011.94.24 4.09 4.09 0 011.54.79 3.82 3.82 0 011 1.44 5.82 5.82 0 01.37 2.19v6.51c0 .54 0 1 .05 1.33a6.17 6.17 0 00.09.81 4.48 4.48 0 00.12.47h-2.07zm-.71-6.37l-2.45.08a4.37 4.37 0 00-2.39.63 1.85 1.85 0 00-.74 1.57 2.57 2.57 0 00.16.9 1.89 1.89 0 00.46.72 2.21 2.21 0 00.78.49 3 3 0 001.07.18 4.27 4.27 0 001.06-.13 4.92 4.92 0 00.87-.31 3.44 3.44 0 00.68-.43 4.59 4.59 0 00.5-.44v-3.26z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_8",
  d: "M169.27 251a5.94 5.94 0 01-2 .37 3.82 3.82 0 01-1.37-.22 2.45 2.45 0 01-.94-.6 2.55 2.55 0 01-.55-.93 3.8 3.8 0 01-.18-1.21v-8.74H162v-2h2.24v-3l2.53-.79v3.8h4.15l-.82 2h-3.33v7.89a1.89 1.89 0 00.32 1.23 1.17 1.17 0 001 .4 3.08 3.08 0 00.68-.08l.63-.21a4.21 4.21 0 00.56-.29c.17-.1.32-.21.46-.31l.74 1.71a7.72 7.72 0 01-1.89.98z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_9",
  d: "M179.4 237.31a6.59 6.59 0 012.53.47 5.82 5.82 0 012 1.35 6.35 6.35 0 011.38 2.27 8.88 8.88 0 01.47 3 8.71 8.71 0 01-.49 3 6.63 6.63 0 01-1.41 2.3 5.79 5.79 0 01-2 1.3 6.72 6.72 0 01-2.51.45 6 6 0 01-4.34-1.64 6.13 6.13 0 01-1.44-2.33 8.84 8.84 0 01-.49-3 8.56 8.56 0 01.49-3 6.63 6.63 0 011.41-2.3 5.86 5.86 0 011.94-1.32 6.31 6.31 0 012.46-.55zm0 2.08a3.39 3.39 0 00-1.59.36 3.25 3.25 0 00-1.17 1 5.1 5.1 0 00-.72 1.56 7.8 7.8 0 00-.24 2 7.59 7.59 0 00.26 2 4.62 4.62 0 00.75 1.56 3.36 3.36 0 001.19 1 3.45 3.45 0 001.59.36 3.31 3.31 0 001.57-.36 3.43 3.43 0 001.17-1 4.84 4.84 0 00.73-1.57 8.29 8.29 0 000-4 4.52 4.52 0 00-.74-1.56 3.23 3.23 0 00-1.18-1 3.51 3.51 0 00-1.65-.35h.03z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_10",
  d: "M207.33 246.35a4.43 4.43 0 01-.47 2.06 4.7 4.7 0 01-1.29 1.58 6.13 6.13 0 01-1.95 1 7.82 7.82 0 01-2.42.36 10.4 10.4 0 01-1.74-.14 10.75 10.75 0 01-1.46-.36 9.47 9.47 0 01-1.19-.5 10 10 0 01-.95-.56l1.14-1.95a5.33 5.33 0 00.72.46 7.12 7.12 0 001 .44 7.27 7.27 0 001.14.32 6 6 0 001.3.14 5.17 5.17 0 001.23-.15 3.84 3.84 0 001.14-.46 2.71 2.71 0 00.83-.82 2.13 2.13 0 00.32-1.2 2.59 2.59 0 00-.34-1.34 4.54 4.54 0 00-.91-1.06 9.17 9.17 0 00-1.29-.9l-1.49-.85c-.5-.29-1-.6-1.48-.92a7.31 7.31 0 01-1.29-1.12 5.18 5.18 0 01-1-1.46 5 5 0 01-.35-1.92 4.84 4.84 0 01.37-1.87 4.28 4.28 0 011.1-1.53 5.29 5.29 0 011.77-1 7.31 7.31 0 012.39-.37 9.47 9.47 0 012.56.3 10.55 10.55 0 011.76.64v2.5a9.36 9.36 0 00-1.94-.89 7.05 7.05 0 00-2.24-.36 5.3 5.3 0 00-1.22.14 3.13 3.13 0 00-1 .42 2.19 2.19 0 00-.69.73 2.12 2.12 0 00-.26 1.07 2.35 2.35 0 00.36 1.3 4.14 4.14 0 00.93 1.05 9.53 9.53 0 001.32.9l1.51.87c.52.3 1 .61 1.51 1A7.32 7.32 0 01206 243a5.35 5.35 0 01.94 1.47 4.62 4.62 0 01.39 1.88z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_11",
  d: "M216.74 252.12a15 15 0 01-1.37 2.95 7.06 7.06 0 01-1.48 1.73 4.32 4.32 0 01-1.59.82 7.2 7.2 0 01-1.67.2 6.55 6.55 0 01-1.5-.15 10.54 10.54 0 01-1.2-.39l.62-1.93a4 4 0 00.92.34 4.6 4.6 0 001.11.12 2.85 2.85 0 001.14-.24 3.29 3.29 0 001.08-.8 6.28 6.28 0 001-1.45 12.85 12.85 0 00.83-2.17l-6.09-13.51h2.67l4.61 10.52h.08l3.53-10.52h2.5l-5.19 14.48z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_12",
  d: "M232.77 247.34a3.78 3.78 0 01-.41 1.85 3.51 3.51 0 01-1.11 1.25 5 5 0 01-1.67.71 9.52 9.52 0 01-2 .22 9.79 9.79 0 01-1.38-.09 9.11 9.11 0 01-1.2-.28 8.8 8.8 0 01-1-.36 8.27 8.27 0 01-.79-.41l.88-1.91a6.54 6.54 0 00.66.36 5.34 5.34 0 00.8.34 5.06 5.06 0 00.91.25 4.77 4.77 0 001 .1 4.55 4.55 0 001.07-.12 3.15 3.15 0 00.85-.36 1.86 1.86 0 00.55-.57 1.43 1.43 0 00.2-.77 1.67 1.67 0 00-.26-.94 2.83 2.83 0 00-.69-.69 5.15 5.15 0 00-1-.53c-.37-.16-.75-.32-1.13-.5a12 12 0 01-1.13-.57 4.39 4.39 0 01-1-.77 3.7 3.7 0 01-.69-1.08 3.82 3.82 0 01-.26-1.51 3.45 3.45 0 01.29-1.43 3.21 3.21 0 01.87-1.18 4.51 4.51 0 011.46-.79 6.56 6.56 0 012-.29 9.07 9.07 0 012 .2 10.11 10.11 0 011.58.51v2.16l-.78-.31c-.26-.1-.53-.18-.81-.26a7.76 7.76 0 00-.89-.19 6.24 6.24 0 00-1-.07 4.39 4.39 0 00-.91.09 2.18 2.18 0 00-.73.28 1.28 1.28 0 00-.66 1.17 1.4 1.4 0 00.27.86 2.75 2.75 0 00.7.65 7.19 7.19 0 001 .52l1.16.52c.39.18.77.38 1.15.6a4.42 4.42 0 011 .78 3.61 3.61 0 01.7 1.07 3.54 3.54 0 01.4 1.49z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_13",
  d: "M241.94 251a5.94 5.94 0 01-2 .37 3.79 3.79 0 01-1.37-.22 2.38 2.38 0 01-.94-.6 2.42 2.42 0 01-.55-.93 3.8 3.8 0 01-.18-1.21v-8.74h-2.25v-2h2.25v-3l2.53-.79v3.8h4.15l-.82 2h-3.33v7.89a1.89 1.89 0 00.32 1.23 1.17 1.17 0 001 .4 2.93 2.93 0 00.67-.08c.22-.06.43-.13.64-.21a4.21 4.21 0 00.56-.29c.17-.1.32-.21.46-.31l.74 1.71a7.91 7.91 0 01-1.88.98z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_14",
  d: "M248.4 244.9a5 5 0 00.29 1.7 4.13 4.13 0 00.82 1.39 3.89 3.89 0 001.33.95 4.41 4.41 0 001.8.35 5.15 5.15 0 001.72-.3 8.85 8.85 0 001.55-.7l.71 1.73a6.8 6.8 0 01-2.1 1 8.49 8.49 0 01-2.36.35 6.31 6.31 0 01-2.85-.6 5.89 5.89 0 01-2-1.59 6.45 6.45 0 01-1.17-2.29 9.34 9.34 0 01-.38-2.71 8.77 8.77 0 01.4-2.7 6.84 6.84 0 011.14-2.18 5.62 5.62 0 011.79-1.46 5.16 5.16 0 012.34-.53 5.56 5.56 0 012.36.49 4.91 4.91 0 011.76 1.41 6.45 6.45 0 011.08 2.18 9.73 9.73 0 01.38 2.85v.66h-8.61zm5.76-3.26a3.5 3.5 0 00-.55-1.15 2.89 2.89 0 00-.91-.83 2.67 2.67 0 00-1.29-.31 2.72 2.72 0 00-1.26.29 3.05 3.05 0 00-1 .78 3.28 3.28 0 00-.61 1.14 4.73 4.73 0 00-.2 1.37h6a4.78 4.78 0 00-.18-1.29z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_15",
  d: "M277.32 251.09v-8.65a6.88 6.88 0 00-.09-1.15 2.55 2.55 0 00-.31-.93 1.57 1.57 0 00-.63-.62 2.2 2.2 0 00-1.06-.22 4 4 0 00-1.16.16 5.41 5.41 0 00-1.05.44 7.16 7.16 0 00-.91.6c-.28.23-.55.44-.8.66a1.72 1.72 0 010 .33v9.38h-2.52v-8.58a8.72 8.72 0 00-.08-1.17 3.09 3.09 0 00-.31-1 1.68 1.68 0 00-.64-.63 2.12 2.12 0 00-1.07-.23 3.68 3.68 0 00-1.15.17 5.81 5.81 0 00-1 .44 7.34 7.34 0 00-.92.61c-.29.22-.55.44-.8.67v9.68h-2.53v-13.41h2.11l.3 1.57a9.94 9.94 0 012.45-1.44 6.27 6.27 0 012.29-.46 3.63 3.63 0 012.12.6 3.32 3.32 0 011.26 1.58 10.15 10.15 0 011.18-.92 10.87 10.87 0 011.24-.68 8.81 8.81 0 011.25-.43 5.06 5.06 0 011.2-.15 5.38 5.38 0 011.55.22 3.32 3.32 0 011.33.72 3.51 3.51 0 01.92 1.34 5.39 5.39 0 01.35 2.07v9.43h-2.52z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_16",
  d: "M292.12 247.34a3.89 3.89 0 01-.41 1.85 3.64 3.64 0 01-1.12 1.25 5 5 0 01-1.67.71 9.38 9.38 0 01-2 .22 10 10 0 01-1.38-.09 8.6 8.6 0 01-1.15-.24 8.27 8.27 0 01-1-.36 7 7 0 01-.78-.41l.87-1.91q.3.18.66.36a5.83 5.83 0 00.8.34 5.17 5.17 0 00.92.25 4.74 4.74 0 001 .1 4.49 4.49 0 001.07-.12 3.15 3.15 0 00.85-.36 1.86 1.86 0 00.55-.57 1.43 1.43 0 00.2-.77 1.6 1.6 0 00-.26-.94 2.66 2.66 0 00-.69-.69 5.15 5.15 0 00-1-.53l-1.13-.5c-.38-.17-.76-.36-1.13-.57a4.12 4.12 0 01-1-.77 3.53 3.53 0 01-.7-1.08 4 4 0 01-.26-1.51 3.62 3.62 0 01.29-1.43 3.32 3.32 0 01.87-1.18 4.51 4.51 0 011.46-.79 6.56 6.56 0 012-.29 9.23 9.23 0 012 .2 10.33 10.33 0 011.57.51v2.16l-.78-.31c-.26-.1-.53-.18-.81-.26a7.76 7.76 0 00-.89-.19 6.24 6.24 0 00-1-.07 4.39 4.39 0 00-.91.09 2.18 2.18 0 00-.73.28 1.33 1.33 0 00-.49.48 1.36 1.36 0 00-.17.69 1.4 1.4 0 00.27.86 2.64 2.64 0 00.71.65 6.22 6.22 0 001 .52l1.15.52c.39.18.77.38 1.15.6a4.21 4.21 0 011 .78 3.61 3.61 0 01.7 1.07 3.38 3.38 0 01.37 1.45z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_17",
  d: "M314.84 245.46a6.41 6.41 0 01-.34 2 4.63 4.63 0 01-1.11 1.81 5.57 5.57 0 01-2 1.31 8.35 8.35 0 01-3.12.51h-5.08v-18.73h5.46a5.81 5.81 0 012.26.41 4.68 4.68 0 011.58 1.09 4.37 4.37 0 01.92 1.49 4.79 4.79 0 01.3 1.64 4.64 4.64 0 01-.62 2.48 4.35 4.35 0 01-1.77 1.62 4.15 4.15 0 011.38.45 4.2 4.2 0 011.14.92 4.33 4.33 0 01.76 1.31 4.82 4.82 0 01.24 1.69zm-9.16-10.85v5.79H308a3.32 3.32 0 001.11-.19 3 3 0 001-.57 3 3 0 00.7-.94 2.9 2.9 0 00.27-1.28 2.74 2.74 0 00-.78-2.06 3.42 3.42 0 00-2.43-.75h-2.19zm6.45 11a3 3 0 00-.23-1.17 2.54 2.54 0 00-.7-.93 3.13 3.13 0 00-1.14-.63 5 5 0 00-1.57-.23h-2.81v6.19h2.58a5.32 5.32 0 001.68-.24 3.62 3.62 0 001.21-.67 2.82 2.82 0 00.73-1 3.27 3.27 0 00.25-1.32z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_18",
  d: "M324.85 240.09a2.86 2.86 0 00-1.33-.31 3 3 0 00-1.37.36 7.26 7.26 0 00-1.53 1.11v9.84h-2.5v-13.45h2.07l.34 1.52a10.39 10.39 0 011.15-.95 7.31 7.31 0 011-.56 4 4 0 01.83-.27 3.91 3.91 0 01.76-.07 3 3 0 01.94.14 3.13 3.13 0 01.68.3l-1.04 2.34z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_19",
  d: "M335.49 251.09l-.54-1.28a6.42 6.42 0 01-.73.58 5.63 5.63 0 01-.91.5 6.46 6.46 0 01-1.1.35 6.9 6.9 0 01-1.33.13 4.61 4.61 0 01-1.62-.29 3.77 3.77 0 01-1.33-.82 3.89 3.89 0 01-.91-1.32 4.27 4.27 0 01-.34-1.75 3.85 3.85 0 011.41-3.17 6.68 6.68 0 014.07-1.23l2.62-.08v-.51a3.56 3.56 0 00-.21-1.31 2.13 2.13 0 00-1.47-1.35 3.92 3.92 0 00-1.11-.15 5.91 5.91 0 00-2.09.38 5.25 5.25 0 00-.79.37c-.23.14-.45.28-.64.42l-1-1.71a9.23 9.23 0 011.23-.75 6.71 6.71 0 011.21-.47 7.34 7.34 0 011.22-.25 10.46 10.46 0 011.27-.07 7.42 7.42 0 011.94.24 4 4 0 011.53.79 3.84 3.84 0 011 1.44 5.82 5.82 0 01.37 2.19v6.51c0 .54 0 1 .05 1.33a6.17 6.17 0 00.09.81 4.48 4.48 0 00.12.47h-2.01zm-.71-6.37l-2.46.08a4.33 4.33 0 00-2.38.63 1.85 1.85 0 00-.74 1.57 2.57 2.57 0 00.15.9 2 2 0 00.47.72 2.21 2.21 0 00.78.49 2.93 2.93 0 001.07.18 4.33 4.33 0 001.06-.13 4.92 4.92 0 00.87-.31 3.44 3.44 0 00.68-.43 5.78 5.78 0 00.5-.44v-3.26z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_20",
  d: "M349.79 251.09v-8.16a9.18 9.18 0 00-.07-1.17 3.33 3.33 0 00-.31-1.07 2 2 0 00-.67-.78 2 2 0 00-1.17-.29 3.69 3.69 0 00-1.09.16 6.22 6.22 0 00-1 .43 7.76 7.76 0 00-1 .6 10.12 10.12 0 00-.85.68v9.6h-2.49v-13.45h2.1l.31 1.55q.58-.44 1.14-.78a8 8 0 011.12-.59 6.88 6.88 0 011.19-.38 6.16 6.16 0 011.32-.13 4.27 4.27 0 011.45.26 3.56 3.56 0 011.28.84 4.28 4.28 0 01.91 1.47 6.24 6.24 0 01.34 2.2v9l-2.51.01z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("path", {
  id: "vidispine_24_svg__svg_21",
  d: "M365.31 251.08a11.43 11.43 0 01-2.69.29 8.42 8.42 0 01-2.72-.43 6.28 6.28 0 01-2.24-1.27 6 6 0 01-1.51-2.13 7.35 7.35 0 01-.57-3 7.64 7.64 0 01.55-2.9 7 7 0 011.51-2.28 6.93 6.93 0 012.25-1.5 7.24 7.24 0 012.8-.54 9.23 9.23 0 011.14.06 6.6 6.6 0 01.87.14V231h2.53v19.41a8.22 8.22 0 01-1.92.67zm-.61-11.35l-.38-.11-.41-.1a3.46 3.46 0 00-.49-.06 5.92 5.92 0 00-.62 0 4.78 4.78 0 00-1.81.34 4.21 4.21 0 00-1.49 1 4.67 4.67 0 00-1 1.56 5.35 5.35 0 00-.38 2 5.9 5.9 0 00.31 2 4 4 0 00.91 1.54 4.33 4.33 0 001.52 1 5.73 5.73 0 002.12.37 5.17 5.17 0 00.95-.09 3.71 3.71 0 00.78-.23l-.01-9.22z",
  className: "vidispine_24_svg__cls-2"
}), /*#__PURE__*/createElement("g", {
  stroke: "null",
  id: "vidispine_24_svg__svg_37"
}, /*#__PURE__*/createElement("path", {
  stroke: "null",
  id: "vidispine_24_svg__svg_31",
  fill: "#7c74bd",
  d: "M.167.277h6.524v6.524H.167z"
}), /*#__PURE__*/createElement("path", {
  stroke: "null",
  id: "vidispine_24_svg__svg_32",
  fill: "#6dc3c5",
  d: "M17.183.277h6.524v6.524h-6.524z"
}), /*#__PURE__*/createElement("path", {
  stroke: "null",
  id: "vidispine_24_svg__svg_33",
  className: "vidispine_24_svg__cls-1",
  d: "M.167 8.785h6.524v6.524H.167z"
}), /*#__PURE__*/createElement("path", {
  stroke: "null",
  id: "vidispine_24_svg__svg_34",
  d: "M17.183 15.309a6.52 6.52 0 006.52-6.524h-6.52v6.524",
  className: "vidispine_24_svg__cls-5"
}), /*#__PURE__*/createElement("path", {
  stroke: "null",
  id: "vidispine_24_svg__svg_35",
  className: "vidispine_24_svg__cls-1",
  d: "M.167 17.293h6.524v6.524H.167z"
}), /*#__PURE__*/createElement("path", {
  stroke: "null",
  id: "vidispine_24_svg__svg_36",
  d: "M8.685 23.817a6.52 6.52 0 006.52-6.524h-6.52v6.524",
  className: "vidispine_24_svg__cls-5"
})));

function SvgVidispine24(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

function VidispineIcon(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React__default.createElement(SvgIcon, _extends({
    component: SvgVidispine24
  }, props));
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$1 = /*#__PURE__*/createElement("style", null, ".bitmovin_24_svg__st0{fill:#2fabe1}");

var _ref2$1 = /*#__PURE__*/createElement("path", {
  id: "bitmovin_24_svg__canvas_background",
  fill: "none",
  d: "M-1-1h26v26H-1z"
});

var _ref3$1 = /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", {
  stroke: "null",
  id: "bitmovin_24_svg__svg_10"
}, /*#__PURE__*/createElement("path", {
  stroke: "null",
  className: "bitmovin_24_svg__st0",
  d: "M8.643 1.667V6.35l7.223 5.041a.52.52 0 010 .834l-7.223 5.04v4.684l13.773-9.645c.357-.238.357-.754 0-1.032L8.643 1.667z",
  id: "bitmovin_24_svg__svg_14"
}), /*#__PURE__*/createElement("path", {
  stroke: "null",
  className: "bitmovin_24_svg__st0",
  d: "M4.594 5.08v3.572l3.93 2.74a.52.52 0 010 .833l-3.93 2.738v3.573l8.93-6.232c.358-.238.358-.754 0-1.032L4.595 5.08z",
  id: "bitmovin_24_svg__svg_15"
}), /*#__PURE__*/createElement("path", {
  stroke: "null",
  className: "bitmovin_24_svg__st0",
  d: "M1.458 8.017v2.263l1.588 1.111a.52.52 0 010 .834l-1.588 1.111v2.262l4.684-3.294a.593.593 0 000-.992L1.458 8.017z",
  id: "bitmovin_24_svg__svg_16"
})));

function SvgBitmovin24(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1, _ref2$1, _ref3$1);
}

function BitmovinIcon(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React__default.createElement(SvgIcon, _extends({
    component: SvgBitmovin24
  }, props));
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$2 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("linearGradient", {
  id: "mediaconvert_24_svg__a",
  y2: "0%",
  x2: "100%",
  y1: "100%",
  x1: "0%"
}, /*#__PURE__*/createElement("stop", {
  offset: "0%",
  stopColor: "#C8511B"
}), /*#__PURE__*/createElement("stop", {
  offset: "100%",
  stopColor: "#F90"
})));

var _ref2$2 = /*#__PURE__*/createElement("path", {
  fill: "none",
  d: "M-1-1h26v26H-1z"
});

var _ref3$2 = /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", {
  fillRule: "evenodd",
  fill: "none",
  stroke: "null"
}, /*#__PURE__*/createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "url(#mediaconvert_24_svg__a)"
}), /*#__PURE__*/createElement("path", {
  fill: "#FFF",
  d: "M12 10.545l-1.125.563v1.786l1.125.563 1.125-.563v-1.786L12 10.544zm.168-.755l1.305.653.944-.63.416.625-.958.638v2.05c0 .142-.08.272-.207.335l-1.293.647v1.224h-.75v-1.224l-1.293-.647a.374.374 0 01-.207-.335v-2.05l-.958-.638.416-.624.944.629 1.305-.653a.376.376 0 01.336 0h0zm3.582-.192L12 7.552 8.25 9.598v4.805L12 16.45l3.75-2.046V9.598zm3.75-1.723v2.25h-.75V8.483L16.5 9.607v5.02a.376.376 0 01-.195.328l-3.93 2.144v2.138l1.563-.87.365.656-2.12 1.18a.375.375 0 01-.365 0l-2.121-1.18.365-.655 1.563.87v-2.139l-3.93-2.144a.376.376 0 01-.195-.329V9.607L5.25 8.482v1.644H4.5v-2.25c0-.143.08-.272.207-.336l2.25-1.125.336.67-1.58.79 2.154 1.078 3.953-2.157a.375.375 0 01.36 0l3.953 2.157 2.153-1.078-1.579-.79.336-.67 2.25 1.125a.375.375 0 01.207.335h0zm-.75 8.02l-2.043 1.02.335.672 2.25-1.125a.374.374 0 00.208-.336v-2.25h-.75v2.018zM12 4.545l2.082 1.04.336-.67-2.25-1.126a.376.376 0 00-.336 0l-2.25 1.125.336.671L12 4.545zm-6.75 11.35l2.043 1.02-.336.672-2.25-1.125a.374.374 0 01-.207-.336v-2.25h.75v2.018z"
})));

function SvgMediaconvert24(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2, _ref2$2, _ref3$2);
}

function MediaConvertIcon(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React__default.createElement(SvgIcon, _extends({
    component: SvgMediaconvert24
  }, props));
}

var styles$m = function styles(theme) {
  var isLight = theme.palette.type === 'light';
  return {
    badge: {
      height: '1rem',
      marginRight: 6,
      borderColor: isLight ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.8)',
      color: isLight ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.8)',
      borderWidth: 1.45,
      borderStyle: 'solid',
      backgroundColor: isLight ? 'unset' : 'rgba(0, 0, 0, .15)',
      padding: '0 4px',
      borderRadius: 2.5,
      whiteSpace: 'nowrap',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 900,
      fontSize: '0.7rem',
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      minWidth: 32,
      textAlign: 'center'
    }
  };
};

function MediaBadge(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement("span", {
    className: clsx(classes.badge, 'VdtMediaBadge-badge', className)
  }, children);
}

var MediaBadge$1 = withStyles(styles$m, {
  name: 'VdtMediaBadge'
})(MediaBadge);

var generateBadges = function generateBadges(_ref) {
  var shapeType = _ref.shapeType,
      transcodePresetType = _ref.transcodePresetType;
  var shape = transcodePresetType || parseShapeType(shapeType);
  var badges = [];
  if (shape.containerFormat) badges.push(shape.containerFormat);
  if (shape.videoFormat) badges.push(shape.videoFormat);
  if (shape.audioFormat) badges.push(shape.audioFormat);

  if (shape.height) {
    var fieldOrder = shape.fieldOrder,
        height = shape.height;
    var heightFieldOrder = "".concat(height).concat(fieldOrder ? fieldOrder[0] : 'px');

    switch (height) {
      case 720:
        badges.push('HD Ready');
        break;

      case 1080:
        badges.push('Full HD');
        break;

      case 1440:
        badges.push('Quad HD');
        break;

      case 2160:
        badges.push('4K UHD');
        break;

      case 4320:
        badges.push('8K UHD');
        break;
    }

    if (height > 0 && height < 720) {
      badges.push('SD');
    }

    badges.push(heightFieldOrder);
  }

  if (shape.audioChannels) {
    var audioChannels = shape.audioChannels;

    switch (audioChannels) {
      case 1:
        badges.push('Mono');
        break;

      case 2:
        badges.push('Stereo');
        break;

      case 3:
        badges.push('2.1');
        break;

      case 6:
        badges.push('5.1');
        break;

      case 8:
        badges.push('7.1');
        break;
    }
  }

  if (shape.colorPrimaries) {
    var colorPrimaries = shape.colorPrimaries;

    switch (colorPrimaries) {
      case 'BT.2020':
      case 'REC.2020':
        badges.push('HDR');
        break;

      case 'BT.709':
      case 'REC.709':
        badges.push('SDR');
        break;
    }
  }

  if (shape.textFormat) {
    badges.push('CC');
  }

  if (shape.frameRate) {
    try {
      if (shape.frameRate.match(/\d/)) {
        badges.push("".concat(shape.frameRate, "fps"));
      } else {
        badges.push(shape.frameRate);
      }
    } catch (e) {// Figure out which to really throw on
    }
  }

  if (shape.aspectRatio) badges.push(shape.aspectRatio);
  return _toConsumableArray(new Set(badges)); // remove duplicates
};

var styles$n = function styles() {
  return {
    root: {}
  };
};

function MediaBadges(_ref2) {
  var classes = _ref2.classes,
      className = _ref2.className,
      _ref2$generateBadges = _ref2.generateBadges,
      handleGenerateBadges = _ref2$generateBadges === void 0 ? generateBadges : _ref2$generateBadges,
      shapeType = _ref2.shapeType,
      transcodePresetType = _ref2.transcodePresetType,
      _ref2$MediaBadgeCompo = _ref2.MediaBadgeComponent,
      MediaBadgeComponent = _ref2$MediaBadgeCompo === void 0 ? MediaBadge$1 : _ref2$MediaBadgeCompo,
      _ref2$MediaBadgeProps = _ref2.MediaBadgeProps,
      MediaBadgeProps = _ref2$MediaBadgeProps === void 0 ? {} : _ref2$MediaBadgeProps;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var badges = React__default.useMemo(function () {
    return handleGenerateBadges({
      shapeType: shapeType,
      transcodePresetType: transcodePresetType
    });
  }, [shapeType]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtMediaBadges-root', className)
  }, badges.map(function (badge) {
    return /*#__PURE__*/React__default.createElement(MediaBadgeComponent, _extends({
      key: badge // eslint-disable-next-line react/jsx-props-no-spreading

    }, MediaBadgeProps), badge);
  }));
}

var MediaBadges$1 = withStyles(styles$n, {
  name: 'VdtMediaBadges'
})(MediaBadges);

var styles$o = function styles(theme) {
  return {
    root: {
      display: 'flex'
    },
    thumbnail: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      width: 80,
      height: 40,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      textTransform: 'uppercase',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      color: theme.palette.background["default"],
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },
    detailContainer: {},
    thumbnailContainer: {},
    description: {
      fontStyle: 'italic'
    }
  };
};

function ShapeTagCard(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      transcodePresetType = _ref.transcodePresetType,
      containerFormatText = _ref.containerFormatText,
      MediaBadgesComponent = _ref.MediaBadgesComponent,
      MediaBadgesProps = _ref.MediaBadgesProps;
  var shapeTag = parseTranscodePreset(transcodePresetType);
  var thumbnailLabel = shapeTag.containerFormat ? shapeTag.containerFormat.split('_')[0].split('-')[0] : containerFormatText;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtShapeTagCard-root', className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.thumbnailContainer
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.thumbnail
  }, thumbnailLabel)), /*#__PURE__*/React__default.createElement("div", {
    className: classes.detailContainer
  }, /*#__PURE__*/React__default.createElement(MediaBadgesComponent, _extends({
    transcodePresetType: shapeTag,
    parseShape: false // eslint-disable-next-line react/jsx-props-no-spreading

  }, MediaBadgesProps)), shapeTag.description && /*#__PURE__*/React__default.createElement("div", {
    className: classes.description
  }, shapeTag.description)));
}
var ShapeTagCard$1 = withStyles(styles$o, {
  name: 'VdtShapeTagCard'
})(ShapeTagCard);
ShapeTagCard.propTypes = {
  classes: propTypes.objectOf(propTypes.string),
  className: propTypes.string,
  transcodePresetType: propTypes.objectOf(propTypes.any).isRequired,
  containerFormatText: propTypes.string,
  MediaBadgesComponent: propTypes.elementType,
  MediaBadgesProps: propTypes.objectOf(propTypes.any)
};
ShapeTagCard.defaultProps = {
  classes: {},
  className: undefined,
  containerFormatText: 'Source',
  MediaBadgesComponent: MediaBadges$1,
  MediaBadgesProps: {}
};

var useShapeTagDetail = function useShapeTagDetail(_ref) {
  var onEstimate = _ref.onEstimate;

  var _React$useState = React__default.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      shapeTagDetail = _React$useState2[0],
      setShapeTagDetail = _React$useState2[1];

  var onGetShapeTag = function onGetShapeTag(tagName) {
    return shapetag.getShapeTag({
      tagName: tagName
    }).then(function (_ref2) {
      var data = _ref2.data;
      setShapeTagDetail(function (currentState) {
        return _objectSpread2(_objectSpread2({}, currentState), {}, _defineProperty({}, tagName, data));
      });
      if (onEstimate) return onEstimate(tagName);
      return Promise.resolve();
    }).then(function (costEstimate) {
      if (costEstimate) {
        var _costEstimate$data$se = _slicedToArray(costEstimate.data.service, 1),
            _costEstimate$data$se2 = _costEstimate$data$se[0],
            cost = _costEstimate$data$se2.cost,
            state = _costEstimate$data$se2.state,
            message = _costEstimate$data$se2.message;

        setShapeTagDetail(function (currentState) {
          var newState = _objectSpread2({}, currentState);

          newState[tagName].cost = cost;
          newState[tagName].estimateError = state !== 'FINISHED' ? message : false;
          return newState;
        });
      }
    })["catch"](function (error) {
      if (error.config && error.config.url && error.config.url.includes('/cost/')) {
        setShapeTagDetail(function (currentState) {
          var newState = _objectSpread2({}, currentState);

          newState[tagName].estimateError = 'unspecified reason.';
          return newState;
        });
      } else {
        throw new Error(error);
      }
    });
  };

  return {
    shapeTagDetail: shapeTagDetail,
    onGetShapeTag: onGetShapeTag
  };
};

var useExpand$1 = function useExpand(initialState) {
  var _React$useState3 = React__default.useState(initialState),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      expanded = _React$useState4[0],
      setExpanded = _React$useState4[1];

  var onChangeExpand = function onChangeExpand(panel) {
    return function (_, newExpanded) {
      return setExpanded(newExpanded ? panel : false);
    };
  };

  return {
    expanded: expanded,
    onChangeExpand: onChangeExpand
  };
};

var Accordion = withStyles(function (theme) {
  return {
    root: {
      border: theme.palette.type === 'light' ? '1px solid rgba(0, 0, 0, .125)' : '1px solid rgba(0, 0, 0, .3)',
      boxShadow: 'none',
      '&:not(:last-child)': {
        borderBottom: 0
      },
      '&:before': {
        display: 'none'
      },
      '&$expanded': {
        margin: 'auto'
      }
    },
    expanded: {}
  };
})(MuiAccordion);
var AccordionSummary = withStyles(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, .03)' : 'rgba(0, 0, 0, .1)',
      borderBottom: theme.palette.type === 'light' ? '1px solid rgba(0, 0, 0, .125)' : '1px solid rgba(0, 0, 0, .3)',
      marginBottom: -1,
      minHeight: 56,
      '&$expanded': {
        minHeight: 56
      }
    },
    content: {
      '&$expanded': {
        margin: '12px 0'
      }
    },
    expanded: {}
  };
})(MuiAccordionSummary);
var AccordionDetails = withStyles(function (theme) {
  return {
    root: {
      padding: theme.spacing(2)
    }
  };
})(MuiAccordionDetails);

var styles$p = function styles(theme) {
  return {
    root: {},
    Accordion: {},
    AccordionDetails: {},
    AccordionSummary: {},
    Button: {},
    shapeTagList: {
      height: 200,
      overflowY: 'scroll',
      '&::-webkit-scrollbar': {
        WebkitAppearance: 'none'
      },
      '&::-webkit-scrollbar:vertical': {
        width: 11
      },
      '&::-webkit-scrollbar-thumb': {
        borderStyle: 'solid',
        borderWidth: 2,
        borderColor: theme.palette.divider,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
      }
    },
    LinearProgress: {
      width: '100%'
    },
    shapeTagDetail: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'
    },
    Typography: {},
    costEstimateText: {
      fontStyle: 'italic',
      color: theme.palette.primary.main,
      marginTop: theme.spacing(2)
    },
    action: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end'
    }
  };
};

function ShapeTagListAccordion(_ref3) {
  var className = _ref3.className,
      classes = _ref3.classes,
      shapeTagNames = _ref3.shapeTagNames,
      onTranscode = _ref3.onTranscode,
      onEstimate = _ref3.onEstimate,
      transcodeText = _ref3.transcodeText,
      ShapeTagCardComponent = _ref3.ShapeTagCardComponent,
      ShapeTagCardProps = _ref3.ShapeTagCardProps,
      loadingCostEstimateText = _ref3.loadingCostEstimateText,
      costEstimateText = _ref3.costEstimateText,
      failedCostEstimateText = _ref3.failedCostEstimateText;

  var _useShapeTagDetail = useShapeTagDetail({
    onEstimate: onEstimate
  }),
      shapeTagDetail = _useShapeTagDetail.shapeTagDetail,
      onGetShapeTag = _useShapeTagDetail.onGetShapeTag;

  var _useExpand = useExpand$1(),
      expanded = _useExpand.expanded,
      onChangeExpand = _useExpand.onChangeExpand;

  React__default.useEffect(function () {
    if (!expanded || shapeTagDetail[expanded]) return;
    onGetShapeTag(expanded); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtShapeTagListAccordion-root', className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.shapeTagList
  }, shapeTagNames.map(function (shapeTagName) {
    return /*#__PURE__*/React__default.createElement(Accordion, {
      className: classes.Accordion,
      key: shapeTagName,
      square: true,
      expanded: expanded === shapeTagName,
      onChange: onChangeExpand(shapeTagName)
    }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
      className: classes.AccordionSummary
    }, /*#__PURE__*/React__default.createElement(Typography, {
      noWrap: true,
      className: classes.Typography
    }, shapeTagName.replace('__', ''))), expanded === shapeTagName && /*#__PURE__*/React__default.createElement(AccordionDetails, {
      className: classes.AccordionDetails
    }, shapeTagDetail[expanded] ? /*#__PURE__*/React__default.createElement("div", {
      className: classes.shapeTagDetail
    }, /*#__PURE__*/React__default.createElement(ShapeTagCardComponent, _extends({
      transcodePresetType: shapeTagDetail[expanded] // eslint-disable-next-line react/jsx-props-no-spreading

    }, ShapeTagCardProps)), /*#__PURE__*/React__default.createElement("div", {
      className: classes.action
    }, onTranscode && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button$1, {
      color: "primary",
      variant: "contained",
      onClick: function onClick() {
        return onTranscode(shapeTagName);
      },
      disabled: onEstimate && shapeTagDetail[expanded].estimateError,
      className: classes.Button
    }, transcodeText)), onEstimate && /*#__PURE__*/React__default.createElement("div", {
      className: classes.costEstimateText
    }, shapeTagDetail[expanded].estimateError ? "".concat(failedCostEstimateText, " ").concat(shapeTagDetail[expanded].estimateError) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, shapeTagDetail[expanded].cost ? "".concat(costEstimateText, " $").concat(shapeTagDetail[expanded].cost.value) : loadingCostEstimateText)))) : /*#__PURE__*/React__default.createElement(LinearProgress$1, {
      className: classes.LinearProgress
    })));
  })));
}
var ShapeTagListAccordion$1 = withStyles(styles$p, {
  name: 'VdtShapeTagListAccordion'
})(ShapeTagListAccordion);
ShapeTagListAccordion.propTypes = {
  classes: propTypes.objectOf(propTypes.string),
  className: propTypes.string,
  shapeTagNames: propTypes.arrayOf(propTypes.string),
  onTranscode: propTypes.func,
  onEstimate: propTypes.func,
  transcodeText: propTypes.string,
  ShapeTagCardComponent: propTypes.elementType,
  ShapeTagCardProps: propTypes.objectOf(propTypes.any),
  loadingCostEstimateText: propTypes.string,
  costEstimateText: propTypes.string,
  failedCostEstimateText: propTypes.string
};
ShapeTagListAccordion.defaultProps = {
  classes: {},
  className: undefined,
  shapeTagNames: [],
  onTranscode: undefined,
  onEstimate: undefined,
  transcodeText: 'Transcode',
  ShapeTagCardComponent: ShapeTagCard$1,
  ShapeTagCardProps: {},
  loadingCostEstimateText: 'Requesting cost estimate',
  costEstimateText: 'Estimated cost:',
  failedCostEstimateText: 'Failed:'
};

var TRANSCODER = 'TRANSCODER'; // Vidispine transcoder

var BITMOVIN = 'BITMOVIN';
var ELEMENTAL_MEDIACONVERT = 'ELEMENTAL_MEDIACONVERT';

var useTabs = function useTabs(_ref) {
  var _ref$tabs = _ref.tabs,
      tabs = _ref$tabs === void 0 ? [] : _ref$tabs;
  var initialTab = tabs.length > 0 ? tabs[0].value : undefined;

  var _React$useState = React__default.useState(initialTab),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentTab = _React$useState2[0],
      setCurrentTab = _React$useState2[1];

  var onChangeTab = function onChangeTab(_, newValue) {
    return newValue && setCurrentTab(newValue);
  };

  return {
    currentTab: currentTab,
    onChangeTab: onChangeTab
  };
};

var useShapeTagNames = function useShapeTagNames(_ref2) {
  var listShapeTagRef = _ref2.listShapeTagRef,
      initialHideDefault = _ref2.initialHideDefault,
      _ref2$initialSearchVa = _ref2.initialSearchValue,
      initialSearchValue = _ref2$initialSearchVa === void 0 ? '' : _ref2$initialSearchVa,
      _ref2$tabs = _ref2.tabs,
      tabs = _ref2$tabs === void 0 ? [] : _ref2$tabs;

  var _React$useState3 = React__default.useState(initialHideDefault),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      hideDefault = _React$useState4[0],
      setHideDefault = _React$useState4[1];

  var onChangeShowDefault = function onChangeShowDefault(event) {
    return setHideDefault(event.target.checked);
  };

  var _React$useState5 = React__default.useState(initialSearchValue),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      searchValue = _React$useState6[0],
      setSearchValue = _React$useState6[1];

  var onChangeSearch = function onChangeSearch(event) {
    return setSearchValue(event.target.value);
  };

  var onClearSearch = function onClearSearch() {
    return setSearchValue('');
  };

  var _useApi = useApi(shapetag.listShapeTag, undefined, listShapeTagRef),
      listShapeTag = _useApi.request,
      _useApi$data = _useApi.data,
      uriList = _useApi$data === void 0 ? {} : _useApi$data;

  React__default.useEffect(function () {
    listShapeTag(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var shapeTagNames = React__default.useMemo(function () {
    var _uriList$uri = uriList.uri,
        allNames = _uriList$uri === void 0 ? [] : _uriList$uri;
    var filteredNames = allNames.filter(function (tagName) {
      return !(hideDefault && tagName.startsWith('__')) && !(searchValue && !tagName.toLowerCase().includes(searchValue.toLowerCase()));
    });
    return tabs.reduce(function (a, _ref3) {
      var value = _ref3.value,
          tagNameFilter = _ref3.tagNameFilter;
      return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, value, tagNameFilter ? tagNameFilter(filteredNames) : filteredNames));
    }, {}); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uriList, hideDefault, searchValue]);
  return {
    shapeTagNames: shapeTagNames,
    onChangeShowDefault: onChangeShowDefault,
    hideDefault: hideDefault,
    onChangeSearch: onChangeSearch,
    onClearSearch: onClearSearch,
    searchValue: searchValue
  };
};

var useTranscodeResources = function useTranscodeResources(_ref4) {
  var listResourceTypeRef = _ref4.listResourceTypeRef,
      tabs = _ref4.tabs;

  var _useApi2 = useApi(resource.listResourceType, undefined, listResourceTypeRef),
      listResourceType = _useApi2.request,
      _useApi2$data = _useApi2.data,
      resourceListDocument = _useApi2$data === void 0 ? {} : _useApi2$data;

  React__default.useEffect(function () {
    listResourceType({
      resourceType: 'vidinet'
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var resources = React__default.useMemo(function () {
    var _resourceListDocument = resourceListDocument.resource,
        resourceList = _resourceListDocument === void 0 ? [] : _resourceListDocument;
    return tabs.reduce(function (a, _ref5) {
      var value = _ref5.value,
          resourceFilter = _ref5.resourceFilter;
      return _objectSpread2(_objectSpread2({}, a), {}, _defineProperty({}, value, resourceFilter ? resourceFilter(resourceList) : []));
    }, {}); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resourceListDocument]);
  return {
    resources: resources
  };
};

var styles$q = function styles(theme) {
  return {
    root: {},
    noResourceText: _objectSpread2(_objectSpread2({}, theme.typography.body1), {}, {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      width: '100%',
      textAlign: 'center',
      fontWeight: 'bold',
      color: theme.palette.error.main
    }),
    shapeTagFilter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2)
    },
    TextField: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },
    Tabs: {
      marginBottom: '10px'
    },
    Tab: {},
    Switch: {}
  };
};

function TranscodeDialog(_ref6) {
  var className = _ref6.className,
      classes = _ref6.classes,
      itemId = _ref6.itemId,
      onSuccess = _ref6.onSuccess,
      onError = _ref6.onError,
      onClose = _ref6.onClose,
      tabs = _ref6.tabs,
      listShapeTagRef = _ref6.listShapeTagRef,
      listResourceTypeRef = _ref6.listResourceTypeRef,
      noResourceText = _ref6.noResourceText,
      initialHideDefault = _ref6.hideDefault,
      hideDefaultText = _ref6.hideDefaultText,
      initialSearchValue = _ref6.searchValue,
      searchText = _ref6.searchText,
      ShapeTagListComponent = _ref6.ShapeTagListComponent,
      ShapeTagListProps = _ref6.ShapeTagListProps;

  var _useTabs = useTabs({
    tabs: tabs
  }),
      onChangeTab = _useTabs.onChangeTab,
      currentTab = _useTabs.currentTab;

  var _useTranscodeResource = useTranscodeResources({
    listResourceTypeRef: listResourceTypeRef,
    tabs: tabs
  }),
      resources = _useTranscodeResource.resources;

  var _useShapeTagNames = useShapeTagNames({
    listShapeTagRef: listShapeTagRef,
    initialHideDefault: initialHideDefault,
    initialSearchValue: initialSearchValue,
    tabs: tabs
  }),
      shapeTagNames = _useShapeTagNames.shapeTagNames,
      onChangeShowDefault = _useShapeTagNames.onChangeShowDefault,
      hideDefault = _useShapeTagNames.hideDefault,
      onChangeSearch = _useShapeTagNames.onChangeSearch,
      onClearSearch = _useShapeTagNames.onClearSearch,
      searchValue = _useShapeTagNames.searchValue;

  var onTranscode = function onTranscode(tag) {
    var queryParams = {
      tag: tag
    };

    if (currentTab === ELEMENTAL_MEDIACONVERT || currentTab === BITMOVIN) {
      var resourceList = resources[currentTab];

      if (resourceList.length === 0) {
        var error = new Error("No ".concat(currentTab, " Resources Available"));
        if (onError) onError(error);else throw error;
      }

      queryParams.resourceId = resourceList[0].id;
    }

    return new Promise(function (resolve, reject) {
      return item.createTranscode({
        itemId: itemId,
        queryParams: queryParams
      }).then(function (resp) {
        if (onSuccess) onSuccess(resp);
        if (onClose) onClose();
        resolve(resp);
      })["catch"](function (error) {
        if (onError) onError(error);
        reject(error);
      });
    });
  };

  var estimateRef = React__default.useRef({});

  var onEstimate = function onEstimate(tag) {
    var queryParams = {
      tag: tag
    };
    var resourceList = resources[currentTab];

    if (resourceList.length === 0) {
      throw new Error("No ".concat(currentTab, " Resources Available"));
    }

    queryParams.resourceId = resourceList[0].id;
    return new Promise(function (resolve, reject) {
      return item.createTranscode({
        itemId: itemId,
        queryParams: queryParams,
        costEstimate: true
      }).then(function (_ref7) {
        var _ref7$data = _ref7.data;
        _ref7$data = _ref7$data === void 0 ? {} : _ref7$data;
        var costEstimateId = _ref7$data.id;

        var newPoll = function newPoll() {
          vidinet.getCostEstimate({
            costEstimateId: costEstimateId
          }).then(function (response) {
            if (estimateRef.current[costEstimateId] !== null) {
              clearTimeout(estimateRef.current[costEstimateId]);
              delete estimateRef.current[costEstimateId];
            }

            var _response$data = response.data;
            _response$data = _response$data === void 0 ? {} : _response$data;
            var state = _response$data.state;
            if (state === 'FINISHED') resolve(response);else {
              estimateRef.current[costEstimateId] = setTimeout(function () {
                return newPoll();
              }, 1000);
            }
          })["catch"](function (error) {
            return reject(error);
          });
        };

        newPoll();
      })["catch"](reject);
    });
  };

  React__default.useEffect(function () {
    return function () {
      if (estimateRef.current !== null) {
        Object.values(estimateRef.current).forEach(function (timerId) {
          return clearTimeout(timerId);
        });
      }
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtTranscodeDialog-root', className)
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, null, "Transcode"), /*#__PURE__*/React__default.createElement(DialogContent$1, null, tabs.length > 1 ? /*#__PURE__*/React__default.createElement(Tabs$1, {
    className: classes.Tabs,
    value: currentTab,
    onChange: onChangeTab,
    variant: "fullWidth",
    textColor: "primary",
    indicatorColor: "primary"
  }, tabs.map(function (_ref8) {
    var value = _ref8.value,
        IconComponent = _ref8.icon,
        label = _ref8.label;
    return /*#__PURE__*/React__default.createElement(Tab$1, {
      className: classes.Tab,
      key: value,
      value: value,
      label: label || value,
      icon: IconComponent ? /*#__PURE__*/React__default.createElement(IconComponent, null) : undefined
    });
  })) : null), /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement("div", {
    className: classes.shapeTagFilter
  }, /*#__PURE__*/React__default.createElement(TextField$2, {
    className: classes.TextField,
    label: searchText,
    onChange: onChangeSearch,
    value: searchValue,
    fullWidth: true,
    InputProps: {
      endAdornment: searchValue ? /*#__PURE__*/React__default.createElement(InputAdornment$1, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(ButtonBase, {
        onClick: onClearSearch
      }, /*#__PURE__*/React__default.createElement(ClearIcon, null))) : undefined
    }
  }), /*#__PURE__*/React__default.createElement(FormControlLabel, {
    control: /*#__PURE__*/React__default.createElement(Switch, {
      checked: hideDefault,
      onChange: onChangeShowDefault,
      color: "primary",
      className: classes.Switch
    }),
    label: hideDefaultText
  })), tabs.map(function (_ref9) {
    var value = _ref9.value;
    return /*#__PURE__*/React__default.createElement("div", {
      key: value,
      style: {
        display: value === currentTab ? 'initial' : 'none'
      }
    }, value !== TRANSCODER && ( // always show vs transcodes
    !resources[value] || resources[value].length === 0) ? /*#__PURE__*/React__default.createElement("div", {
      className: classes.noResourceText
    }, noResourceText) : /*#__PURE__*/React__default.createElement(ShapeTagListComponent, _extends({
      onTranscode: onTranscode,
      onEstimate: resources[value] && resources[value].length > 0 ? onEstimate : undefined,
      shapeTagNames: shapeTagNames[value] // eslint-disable-next-line react/jsx-props-no-spreading

    }, ShapeTagListProps)));
  })));
}
var TranscodeDialog$1 = withStyles(styles$q, {
  name: 'VdtTranscodeDialog'
})(TranscodeDialog);
TranscodeDialog.propTypes = {
  classes: propTypes.objectOf(propTypes.string),
  className: propTypes.string,
  itemId: propTypes.string.isRequired,
  onSuccess: propTypes.func,
  onError: propTypes.func,
  onClose: propTypes.func,
  tabs: propTypes.arrayOf(propTypes.shape({
    value: propTypes.string.isRequired,
    icon: propTypes.elementType,
    label: propTypes.string,
    tagNameFilter: propTypes.func,
    resourceFilter: propTypes.func
  })),
  noResourceText: propTypes.string,
  listShapeTagRef: propTypes.shape({
    current: propTypes.objectOf(propTypes.any)
  }),
  listResourceTypeRef: propTypes.shape({
    current: propTypes.objectOf(propTypes.any)
  }),
  hideDefault: propTypes.bool,
  hideDefaultText: propTypes.string,
  searchText: propTypes.string,
  searchValue: propTypes.string,
  ShapeTagListComponent: propTypes.elementType,
  ShapeTagListProps: propTypes.objectOf(propTypes.any)
};
TranscodeDialog.defaultProps = {
  classes: {},
  className: undefined,
  onSuccess: undefined,
  onError: undefined,
  onClose: undefined,
  tabs: [{
    value: TRANSCODER,
    icon: VidispineIcon,
    label: 'Vidispine',
    tagNameFilter: function tagNameFilter(tagNames) {
      return tagNames.filter(function (tagName) {
        return !tagName.toLowerCase().includes('mediaconvert');
      });
    },
    resourceFilter: function resourceFilter(resources) {
      return resources.filter(function (_ref10) {
        var _ref10$vidinet = _ref10.vidinet;
        _ref10$vidinet = _ref10$vidinet === void 0 ? {} : _ref10$vidinet;
        var resourceType = _ref10$vidinet.type;
        return resourceType === TRANSCODER;
      });
    }
  }, {
    value: BITMOVIN,
    icon: BitmovinIcon,
    label: 'Bitmovin',
    tagNameFilter: function tagNameFilter(tagNames) {
      return tagNames.filter(function (tagName) {
        return !tagName.toLowerCase().includes('mediaconvert');
      });
    },
    resourceFilter: function resourceFilter(resources) {
      return resources.filter(function (_ref11) {
        var _ref11$vidinet = _ref11.vidinet;
        _ref11$vidinet = _ref11$vidinet === void 0 ? {} : _ref11$vidinet;
        var resourceType = _ref11$vidinet.type;
        return resourceType === BITMOVIN;
      });
    }
  }, {
    value: ELEMENTAL_MEDIACONVERT,
    icon: MediaConvertIcon,
    label: 'AWS MediaConvert',
    tagNameFilter: function tagNameFilter(tagNames) {
      return tagNames.filter(function (tagName) {
        return tagName.toLowerCase().includes('mediaconvert');
      });
    },
    resourceFilter: function resourceFilter(resources) {
      return resources.filter(function (_ref12) {
        var _ref12$vidinet = _ref12.vidinet;
        _ref12$vidinet = _ref12$vidinet === void 0 ? {} : _ref12$vidinet;
        var resourceType = _ref12$vidinet.type;
        return resourceType === ELEMENTAL_MEDIACONVERT;
      });
    }
  }],
  listShapeTagRef: undefined,
  listResourceTypeRef: undefined,
  noResourceText: 'No transcode services configured in Vidinet.',
  hideDefault: true,
  hideDefaultText: 'Hide Default',
  searchText: 'Search',
  searchValue: undefined,
  ShapeTagListComponent: ShapeTagListAccordion$1,
  ShapeTagListProps: {}
};

function ItemTimespanFilter(_ref) {
  var filterText = _ref.filterText,
      setFilterText = _ref.setFilterText,
      _ref$searchText = _ref.searchText,
      searchText = _ref$searchText === void 0 ? 'Search' : _ref$searchText;

  var handleChange = function handleChange(event) {
    setFilterText(event.target.value);
  };

  var handleClear = function handleClear() {
    return setFilterText('');
  };

  return /*#__PURE__*/React__default.createElement(TextField$2, {
    label: searchText,
    variant: "outlined",
    value: filterText,
    onChange: handleChange,
    fullWidth: true,
    margin: "dense",
    color: "primary",
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment$1, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, null)),
      endAdornment: filterText ? /*#__PURE__*/React__default.createElement(InputAdornment$1, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(Button$1, {
        onClick: handleClear,
        size: "small",
        style: {
          minWidth: 0
        }
      }, /*#__PURE__*/React__default.createElement(CloseIcon, null))) : undefined
    }
  });
}

var ItemTimespanFilter$1 = withStyles({}, {
  name: 'VdtItemTimespanFilter'
})(ItemTimespanFilter);

var isSmpte = function isSmpte() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var expression = /(^(?:(?:[0-1][0-9]|[0-2][0-3]):)(?:[0-5][0-9]:){2}(?:[0-2][0-9])$)/gi;
  var regex = new RegExp(expression);
  var matches = value.match(regex);
  return matches ? undefined : 'Invalid Timecode';
};

var parseSmpte = function parseSmpte(value) {
  if (!value) return value;
  if (value.length >= 11) return value.slice(0, 11);
  if (value.endsWith(':')) return value;
  if (value.split(':').length === 4) return value;
  var onlyNums = value.replace(/[^\d|]/g, '');
  if (!onlyNums) return '';
  if (onlyNums.length <= 8) return onlyNums.match(/.{1,2}/g).join(':');
  return value.slice(0, 11);
};

function ItemTimespanForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      valid = _ref.valid,
      onClose = _ref.onClose,
      onDelete = _ref.onDelete,
      metadataUuid = _ref.metadataUuid,
      _ref$subtitleGroup = _ref.subtitleGroup,
      subtitleGroup = _ref$subtitleGroup === void 0 ? 'stl_subtitle' : _ref$subtitleGroup,
      _ref$subtitleField = _ref.subtitleField,
      subtitleField = _ref$subtitleField === void 0 ? 'stl_text' : _ref$subtitleField,
      _ref$startText = _ref.startText,
      startText = _ref$startText === void 0 ? 'Start' : _ref$startText,
      _ref$endText = _ref.endText,
      endText = _ref$endText === void 0 ? 'End' : _ref$endText,
      _ref$textText = _ref.textText,
      textText = _ref$textText === void 0 ? 'Text' : _ref$textText,
      _ref$requiredText = _ref.requiredText,
      requiredText = _ref$requiredText === void 0 ? 'Required' : _ref$requiredText,
      _ref$saveText = _ref.saveText,
      saveText = _ref$saveText === void 0 ? 'Save' : _ref$saveText,
      _ref$deleteText = _ref.deleteText,
      deleteText = _ref$deleteText === void 0 ? 'Delete' : _ref$deleteText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText;
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    justify: "space-between"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React__default.createElement(Field, {
    name: "startSmpte",
    component: TextField$1,
    type: "text",
    label: startText,
    variant: "outlined",
    fullWidth: true,
    margin: "dense",
    validate: isSmpte,
    parse: parseSmpte
  }), /*#__PURE__*/React__default.createElement(Field, {
    component: TextField$1,
    name: "endSmpte",
    label: endText,
    variant: "outlined",
    fullWidth: true,
    margin: "dense",
    validate: isSmpte,
    parse: parseSmpte
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React__default.createElement(Field, {
    component: TextField$1,
    name: "".concat(subtitleGroup, ".").concat(subtitleField),
    label: textText,
    variant: "outlined",
    fullWidth: true,
    margin: "dense",
    multiline: true,
    rows: 6,
    validate: function validate(value) {
      return value ? undefined : requiredText;
    }
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "column",
    justify: "space-around",
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "outlined",
    color: "primary",
    type: "submit",
    disabled: !valid
  }, saveText), metadataUuid && /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "outlined",
    color: "secondary",
    onClick: onDelete
  }, deleteText), /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "outlined",
    onClick: onClose
  }, cancelText)))));
}

var ItemTimespanForm$1 = withStyles({}, {
  name: 'VdtItemTimespanForm'
})(ItemTimespanForm);

function ItemTimespanEdit(_ref) {
  var itemId = _ref.itemId,
      _ref$sampleRate = _ref.sampleRate,
      sampleRate = _ref$sampleRate === void 0 ? 'PAL' : _ref$sampleRate,
      onSuccess = _ref.onSuccess,
      onClose = _ref.onClose,
      video = _ref.video,
      _ref$initialValues = _ref.initialValues,
      props = _ref$initialValues === void 0 ? {} : _ref$initialValues,
      _ref$subtitleGroup = _ref.subtitleGroup,
      subtitleGroup = _ref$subtitleGroup === void 0 ? 'stl_subtitle' : _ref$subtitleGroup,
      _ref$subtitleField = _ref.subtitleField,
      subtitleField = _ref$subtitleField === void 0 ? 'stl_text' : _ref$subtitleField,
      _ref$sameAsStartText = _ref.sameAsStartText,
      sameAsStartText = _ref$sameAsStartText === void 0 ? 'Same as start' : _ref$sameAsStartText,
      _ref$laterThanEndText = _ref.laterThanEndText,
      laterThanEndText = _ref$laterThanEndText === void 0 ? 'Later than end' : _ref$laterThanEndText;

  var initialStart = props.startText,
      initialEnd = props.endText,
      metadataUuid = props.uuid,
      initialValues = _objectWithoutProperties(props, ["startText", "endText", "uuid"]);

  if (video && !initialValues.startSmpte && !initialValues.endSmpte) {
    var _video$currentTime = video.currentTime,
        currentTime = _video$currentTime === void 0 ? 0 : _video$currentTime;
    var timeBase = formatTimeBase(sampleRate);
    var currentSmpte = formatSeconds(currentTime, timeBase).toSmpte();
    initialValues.startSmpte = currentSmpte;
    initialValues.endSmpte = currentSmpte;
  }

  var onSubmit = function onSubmit(values, form) {
    var _form$getState = form.getState(),
        _form$getState$dirtyF = _form$getState.dirtyFields,
        dirtyFields = _form$getState$dirtyF === void 0 ? {} : _form$getState$dirtyF;

    var hasChangedStart = dirtyFields.startSmpte,
        hasChangedEnd = dirtyFields.endSmpte;

    var startSmpte = values.startSmpte,
        endSmpte = values.endSmpte,
        fieldsGroups = _objectWithoutProperties(values, ["startSmpte", "endSmpte"]);

    var startNum = parseInt(startSmpte.replace(/[^\d|]/g, ''), 10);
    var endNum = parseInt(endSmpte.replace(/[^\d|]/g, ''), 10);

    if (startNum > endNum) {
      return {
        startSmpte: laterThanEndText
      };
    }

    if (startNum === endNum) {
      return {
        endSmpte: sameAsStartText
      };
    }

    var start = hasChangedStart || !initialStart ? formatSmpte(startSmpte, sampleRate).toText() : initialStart;
    var end = hasChangedEnd || !initialEnd ? formatSmpte(endSmpte, sampleRate).toText() : initialEnd;
    var metadataDocument = createMetadataType(_objectSpread2({
      start: start,
      end: end
    }, fieldsGroups));

    if (metadataUuid && (hasChangedStart || hasChangedEnd)) {
      return item.updateItemMetadata({
        itemId: itemId,
        metadataDocument: metadataDocument
      }).then(function () {
        return metadata.removeMetadata({
          metadataUuid: metadataUuid
        });
      }).then(function () {
        return onSuccess();
      });
    }

    return item.updateItemMetadata({
      itemId: itemId,
      metadataDocument: metadataDocument
    }).then(function () {
      return onSuccess();
    });
  };

  var onDelete = function onDelete() {
    metadata.removeMetadata({
      metadataUuid: metadataUuid
    }).then(function () {
      return onSuccess();
    });
  };

  return /*#__PURE__*/React__default.createElement(Form, {
    onSubmit: onSubmit,
    initialValues: initialValues,
    component: ItemTimespanForm$1,
    onClose: onClose,
    onDelete: onDelete,
    metadataUuid: metadataUuid,
    subtitleGroup: subtitleGroup,
    subtitleField: subtitleField
  });
}

var ItemTimespanEdit$1 = withStyles({}, {
  name: 'VdtItemTimespanEdit'
})(ItemTimespanEdit);

var styles$r = function styles(theme) {
  return {
    root: {
      transition: 'background-color 0.3s ease-out',
      '&:hover': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.2)'
      },
      '&:hover $actions': {
        visibility: 'visible'
      }
    },
    seek: {
      cursor: 'pointer'
    },
    actions: {
      visibility: 'hidden'
    },
    active: {
      backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.3)',
      '&:hover': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.3)' : 'rgba(0, 0, 0, 0.4)'
      }
    },
    chip: {
      margin: theme.spacing(0.5)
    },
    actionButton: {
      minWidth: 0
    }
  };
};

var ItemTimespanIntervalBox = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _clsx;

  var start = props.start,
      end = props.end,
      duration = props.duration,
      text = props.text,
      aduList = props.aduList,
      onSeek = props.onSeek,
      onEdit = props.onEdit,
      isActive = props.isActive,
      classes = props.classes,
      className = props.className,
      filterConfidence = props.filterConfidence,
      _props$canEdit = props.canEdit,
      canEdit = _props$canEdit === void 0 ? true : _props$canEdit;
  var textList = aduList;

  if (aduList && filterConfidence !== undefined) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    textList = React__default.useMemo(function () {
      return aduList.filter(function (_ref) {
        var confidence = _ref.confidence;
        return confidence >= filterConfidence;
      });
    }, [filterConfidence, aduList]);
  }

  if (aduList && aduList.length > 0 && textList.length === 0) return null;
  return /*#__PURE__*/React__default.createElement(Box, {
    className: clsx(classes.root, (_clsx = {}, _defineProperty(_clsx, classes.active, isActive), _defineProperty(_clsx, classes.seek, onSeek !== undefined), _clsx), className),
    minHeight: 50,
    py: 1,
    pl: 1,
    pr: 2,
    onClick: onSeek,
    ref: ref
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    alignItems: "flex-start",
    wrap: "nowrap"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption"
  }, start), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption"
  }, end))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    px: 2
  }, aduList && aduList.length > 0 ? textList.map(function (_ref2) {
    var value = _ref2.value,
        confidence = _ref2.confidence;
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      key: value,
      title: confidence,
      placement: "top",
      arrow: true
    }, /*#__PURE__*/React__default.createElement(Chip$1, {
      label: value,
      variant: "outlined",
      size: "small",
      className: classes.chip
    }));
  }) : /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2"
  }, text))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption"
  }, duration), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "row",
    wrap: "nowrap",
    className: classes.actions
  }, canEdit && onEdit && /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: onEdit,
    size: "small",
    className: classes.actionButton
  }, /*#__PURE__*/React__default.createElement(EditIcon, null)))))));
});
var ItemTimespanIntervalBox$1 = withStyles(styles$r, {
  name: 'VdtItemTimespanIntervalBox'
})(ItemTimespanIntervalBox);

var timespanToProps = function timespanToProps(_ref) {
  var _ref$timespan = _ref.timespan,
      timespan = _ref$timespan === void 0 ? {} : _ref$timespan,
      subtitleGroup = _ref.subtitleGroup,
      subtitleField = _ref.subtitleField,
      aduGroup = _ref.aduGroup,
      aduValue = _ref.aduValue,
      aduConfidence = _ref.aduConfidence,
      handleOnSeek = _ref.handleOnSeek,
      handleOnEdit = _ref.handleOnEdit;
  var startText = timespan.start,
      endText = timespan.end;
  var start = formatTimeCodeText(startText);
  var end = formatTimeCodeText(endText);
  var durationSamples = end.samples - start.samples;
  var timeCodeType = {
    samples: durationSamples,
    timeBase: end.timeBase
  };
  var duration = formatTimeCodeType(timeCodeType);
  var _timespan$group = timespan.group,
      subtitleGroupList = _timespan$group === void 0 ? [] : _timespan$group;
  var metadataFieldGroup = subtitleGroupList.find(function (_ref2) {
    var name = _ref2.name;
    return name === subtitleGroup;
  }) || {};
  var metadataFieldValue = metadataFieldGroup[subtitleField],
      _metadataFieldGroup$g = metadataFieldGroup.group,
      aduGroupList = _metadataFieldGroup$g === void 0 ? [] : _metadataFieldGroup$g,
      uuid = metadataFieldGroup.uuid;
  var aduList = aduGroupList.filter(function (_ref3) {
    var name = _ref3.name;
    return name === aduGroup;
  }).map(function (_ref4) {
    var value = _ref4[aduValue],
        c = _ref4[aduConfidence];
    return {
      confidence: Number(c),
      value: value
    };
  });
  var onSeek = handleOnSeek ? handleOnSeek(start.toSeconds()) : undefined;
  var onEdit = handleOnEdit ? handleOnEdit(_defineProperty({
    startText: start.toText(),
    endText: end.toText(),
    startSmpte: start.toSmpte(),
    endSmpte: end.toSmpte(),
    uuid: uuid
  }, subtitleGroup, _defineProperty({}, subtitleField, metadataFieldValue))) : undefined;
  return {
    start: start,
    end: end,
    duration: duration,
    metadataFieldValue: metadataFieldValue,
    aduList: aduList,
    onSeek: onSeek,
    onEdit: onEdit
  };
};

function ItemTimespanInterval(_ref5) {
  var _ref5$canEdit = _ref5.canEdit,
      canEdit = _ref5$canEdit === void 0 ? true : _ref5$canEdit,
      timespan = _ref5.timespan,
      handleOnSeek = _ref5.onSeek,
      handleOnEdit = _ref5.onEdit,
      playbackTime = _ref5.playbackTime,
      _ref5$subtitleGroup = _ref5.subtitleGroup,
      subtitleGroup = _ref5$subtitleGroup === void 0 ? 'stl_subtitle' : _ref5$subtitleGroup,
      _ref5$subtitleField = _ref5.subtitleField,
      subtitleField = _ref5$subtitleField === void 0 ? 'stl_text' : _ref5$subtitleField,
      _ref5$sampleRate = _ref5.sampleRate,
      sampleRate = _ref5$sampleRate === void 0 ? 'PAL' : _ref5$sampleRate,
      _ref5$isActive = _ref5.isActive,
      isActive = _ref5$isActive === void 0 ? false : _ref5$isActive,
      aduGroup = _ref5.aduGroup,
      aduValue = _ref5.aduValue,
      aduConfidence = _ref5.aduConfidence,
      filterConfidence = _ref5.filterConfidence,
      props = _objectWithoutProperties(_ref5, ["canEdit", "timespan", "onSeek", "onEdit", "playbackTime", "subtitleGroup", "subtitleField", "sampleRate", "isActive", "aduGroup", "aduValue", "aduConfidence", "filterConfidence"]);

  var ref = /*#__PURE__*/React__default.createRef();

  var _React$useMemo = React__default.useMemo(function () {
    return timespanToProps({
      timespan: timespan,
      subtitleGroup: subtitleGroup,
      subtitleField: subtitleField,
      handleOnSeek: handleOnSeek,
      handleOnEdit: handleOnEdit,
      aduGroup: aduGroup,
      aduValue: aduValue,
      aduConfidence: aduConfidence
    });
  }, [timespan, subtitleGroup, subtitleField, handleOnSeek, handleOnEdit, aduGroup, aduValue, aduConfidence]),
      start = _React$useMemo.start,
      end = _React$useMemo.end,
      duration = _React$useMemo.duration,
      metadataFieldValue = _React$useMemo.metadataFieldValue,
      aduList = _React$useMemo.aduList,
      onSeek = _React$useMemo.onSeek,
      onEdit = _React$useMemo.onEdit;

  React__default.useEffect(function () {
    if (isActive) {
      if (ref && ref.current) {
        ref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }
  }, [ref, isActive]);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React__default.createElement(ItemTimespanIntervalBox$1, _extends({
    start: start.toSmpte(),
    end: end.toSmpte(),
    duration: duration.toDuration(),
    text: metadataFieldValue,
    aduList: aduList,
    onSeek: onSeek,
    onEdit: onEdit,
    canEdit: canEdit,
    isActive: isActive,
    sampleRate: sampleRate,
    filterConfidence: filterConfidence
  }, props)));
}

var findActiveTimespanIndex = function findActiveTimespanIndex(_ref) {
  var timespanList = _ref.timespanList,
      _ref$video = _ref.video,
      video = _ref$video === void 0 ? {} : _ref$video,
      setActiveTimespanIndex = _ref.setActiveTimespanIndex,
      currentTimespanIndex = _ref.activeTimespanIndex;
  var _video$currentTime = video.currentTime,
      currentTime = _video$currentTime === void 0 ? 0 : _video$currentTime;
  var currentSeconds = Number(currentTime.toFixed(3));
  var activeTimespanIndex = timespanList.findIndex(function (_ref2) {
    var startText = _ref2.start,
        endText = _ref2.end;
    var start = formatTimeCodeText(startText);
    var end = formatTimeCodeText(endText);
    var startSeconds = Number(start.toSeconds().toFixed(3));
    var endSeconds = Number(end.toSeconds().toFixed(3));

    if (currentSeconds >= startSeconds && currentSeconds < endSeconds) {
      return true;
    }

    return false;
  });

  if (activeTimespanIndex > -1 && currentTimespanIndex !== activeTimespanIndex) {
    setActiveTimespanIndex(activeTimespanIndex);
  }
};

function ItemTimespanList(_ref3) {
  var _ref3$canEdit = _ref3.canEdit,
      canEdit = _ref3$canEdit === void 0 ? true : _ref3$canEdit,
      timespanList = _ref3.timespanList,
      onEdit = _ref3.onEdit,
      video = _ref3.video,
      _ref3$subtitleGroup = _ref3.subtitleGroup,
      subtitleGroup = _ref3$subtitleGroup === void 0 ? 'stl_subtitle' : _ref3$subtitleGroup,
      _ref3$subtitleField = _ref3.subtitleField,
      subtitleField = _ref3$subtitleField === void 0 ? 'stl_text' : _ref3$subtitleField,
      _ref3$sampleRate = _ref3.sampleRate,
      sampleRate = _ref3$sampleRate === void 0 ? 'PAL' : _ref3$sampleRate,
      aduGroup = _ref3.aduGroup,
      aduValue = _ref3.aduValue,
      aduConfidence = _ref3.aduConfidence,
      filterConfidence = _ref3.filterConfidence;

  var _React$useState = React__default.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeTimespanIndex = _React$useState2[0],
      setActiveTimespanIndex = _React$useState2[1];

  var onSeek = React__default.useCallback(function (seconds) {
    return function () {
      if (video) {
        // eslint-disable-next-line no-param-reassign
        video.currentTime = seconds;
        if (video.played.length === 0) video.play();
      }
    };
  }, [video]);
  React__default.useEffect(function () {
    if (video && timespanList.length > 0) {
      var onTimeUpdate = function onTimeUpdate() {
        return findActiveTimespanIndex({
          timespanList: timespanList,
          video: video,
          activeTimespanIndex: activeTimespanIndex,
          setActiveTimespanIndex: setActiveTimespanIndex
        });
      };

      video.addEventListener('timeupdate', onTimeUpdate);
      return function () {
        video.removeEventListener('timeupdate', onTimeUpdate);
      };
    }

    return undefined; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [video, timespanList]);
  return timespanList.map(function (timespan, index) {
    return /*#__PURE__*/React__default.createElement(Box, {
      key: [timespan.start, timespan.end].join()
    }, /*#__PURE__*/React__default.createElement(ItemTimespanInterval, {
      timespan: timespan,
      onSeek: video ? onSeek : undefined,
      canEdit: canEdit,
      onEdit: onEdit,
      isActive: activeTimespanIndex === index,
      subtitleGroup: subtitleGroup,
      subtitleField: subtitleField,
      sampleRate: sampleRate,
      aduGroup: aduGroup,
      aduValue: aduValue,
      aduConfidence: aduConfidence,
      filterConfidence: filterConfidence
    }), /*#__PURE__*/React__default.createElement(Divider$1, null));
  });
}

var parseTimespans = function parseTimespans(_ref) {
  var itemType = _ref.itemType;
  var metadataType = itemType.metadata;
  var parseOptions = {
    includeTimespanAttributes: true,
    includeGroupAttributes: true,
    flatTimespan: true,
    flatGroup: true,
    groupAsList: true,
    joinValue: ','
  };

  var _ref2 = metadataType || {},
      _ref2$timespan = _ref2.timespan,
      timespan = _ref2$timespan === void 0 ? [] : _ref2$timespan;

  var sortedTimespans = timespan.sort(sortTimespanList);
  return sortedTimespans.map(function (timespanType) {
    return parseTimespan(timespanType, parseOptions);
  });
};

var filterTimespanList = function filterTimespanList(_ref3) {
  var parsedTimespans = _ref3.parsedTimespans,
      filterText = _ref3.filterText,
      subtitleGroup = _ref3.subtitleGroup,
      subtitleField = _ref3.subtitleField;
  if (filterText === undefined || filterText === '') return parsedTimespans;
  return parsedTimespans.filter(function (timespanType) {
    var _timespanType$group = timespanType.group,
        groupList = _timespanType$group === void 0 ? [] : _timespanType$group;

    var _ref4 = groupList.find(function (_ref5) {
      var name = _ref5.name;
      return name === subtitleGroup;
    }) || {},
        _ref4$subtitleField = _ref4[subtitleField],
        timespanText = _ref4$subtitleField === void 0 ? '' : _ref4$subtitleField;

    if (timespanText === '') return false;

    if (filterText) {
      return timespanText.toString().toLowerCase().includes(filterText.toLowerCase());
    }

    return true;
  });
};

var ConfidenceSlider = withStyles({}, {
  name: 'VdtConfidenceSlider'
})(function (_ref6) {
  var onChange = _ref6.onChange,
      _ref6$confidenceText = _ref6.confidenceText,
      confidenceText = _ref6$confidenceText === void 0 ? 'Confidence' : _ref6$confidenceText;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var debouncedOnChange = React__default.useCallback(debounce(onChange, 500));

  var _React$useState = React__default.useState(0.5),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      filterConfidence = _React$useState2[0],
      setFilterConfidence = _React$useState2[1];

  var handleChange = function handleChange(event, newValue) {
    setFilterConfidence(newValue);
    debouncedOnChange(newValue);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    gutterBottom: true
  }, confidenceText), /*#__PURE__*/React__default.createElement(MUISlider, {
    defaultValue: 0.5,
    valueLabelDisplay: "auto",
    step: 0.05,
    marks: true,
    min: 0,
    max: 1,
    value: filterConfidence,
    onChange: handleChange
  }));
});

var styles$s = function styles(theme) {
  return {
    itemTimespanList: {
      overflowY: 'scroll',
      height: '100%',
      maxHeight: 1080 / 2,
      '&::-webkit-scrollbar': {
        WebkitAppearance: 'none'
      },
      '&::-webkit-scrollbar:vertical': {
        width: 11
      },
      '&::-webkit-scrollbar-thumb': {
        borderStyle: 'solid',
        borderWidth: 2,
        borderColor: theme.palette.common.white,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
      }
    },
    itemTimespanFilter: {
      flexGrow: 1,
      paddingLeft: theme.spacing(1)
    }
  };
};

function ItemTimespanBox(_ref7) {
  var classes = _ref7.classes,
      itemType = _ref7.itemType,
      _ref7$videoEl = _ref7.videoEl,
      videoEl = _ref7$videoEl === void 0 ? {} : _ref7$videoEl,
      _ref7$subtitleGroup = _ref7.subtitleGroup,
      subtitleGroup = _ref7$subtitleGroup === void 0 ? 'stl_subtitle' : _ref7$subtitleGroup,
      _ref7$subtitleField = _ref7.subtitleField,
      subtitleField = _ref7$subtitleField === void 0 ? 'stl_text' : _ref7$subtitleField,
      aduGroup = _ref7.aduGroup,
      aduValue = _ref7.aduValue,
      aduConfidence = _ref7.aduConfidence,
      _ref7$sampleRate = _ref7.sampleRate,
      sampleRate = _ref7$sampleRate === void 0 ? 'PAL' : _ref7$sampleRate,
      onRefresh = _ref7.onRefresh,
      itemId = _ref7.itemId,
      _ref7$canEdit = _ref7.canEdit,
      canEdit = _ref7$canEdit === void 0 ? true : _ref7$canEdit;
  var video;
  if (videoEl.current) video = videoEl.current.player.videoEl;

  var _React$useState3 = React__default.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      filterText = _React$useState4[0],
      setFilterText = _React$useState4[1];

  var _React$useState5 = React__default.useState(0.5),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      filterConfidence = _React$useState6[0],
      setFilterConfidence = _React$useState6[1];

  var _React$useState7 = React__default.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      isEditing = _React$useState8[0],
      setIsEditing = _React$useState8[1];

  var _React$useState9 = React__default.useState(),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      initialValues = _React$useState10[0],
      setinitialValues = _React$useState10[1];

  var parsedTimespans = React__default.useMemo(function () {
    return parseTimespans({
      itemType: itemType
    });
  }, [itemType]);
  var timespanList = React__default.useMemo(function () {
    return filterTimespanList({
      filterText: filterText,
      parsedTimespans: parsedTimespans,
      subtitleGroup: subtitleGroup,
      subtitleField: subtitleField
    });
  }, [filterText, parsedTimespans, subtitleGroup, subtitleField]);
  var onEdit = React__default.useCallback(function (props) {
    return function () {
      setinitialValues(props);
      setIsEditing(true);
    };
  }, []);

  var onSuccess = function onSuccess() {
    setIsEditing(false);
    setinitialValues();
    onRefresh();
  };

  var onOpenEdit = function onOpenEdit() {
    return setIsEditing(!isEditing);
  };

  var onCloseEdit = function onCloseEdit() {
    setIsEditing(!isEditing);
    setinitialValues();
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: classes.itemTimespanFilter
  }, /*#__PURE__*/React__default.createElement(ItemTimespanFilter$1, {
    setFilterText: setFilterText,
    filterText: filterText
  })), aduGroup && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    style: {
      flexGrow: 0.5,
      marginLeft: 5,
      marginRight: 5
    }
  }, /*#__PURE__*/React__default.createElement(ConfidenceSlider, {
    onChange: setFilterConfidence
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, isEditing ? /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: onOpenEdit,
    size: "small",
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React__default.createElement(NotInterestedIcon, null)) : /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: onCloseEdit,
    size: "small",
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React__default.createElement(AddCircleOutlineIcon, null)))), /*#__PURE__*/React__default.createElement(Collapse, {
    "in": isEditing
  }, /*#__PURE__*/React__default.createElement(Divider$1, null), canEdit && isEditing && /*#__PURE__*/React__default.createElement(ItemTimespanEdit$1, {
    video: video,
    onSuccess: onSuccess,
    onClose: onCloseEdit,
    initialValues: initialValues,
    itemId: itemId,
    sampleRate: sampleRate,
    subtitleGroup: subtitleGroup,
    subtitleField: subtitleField
  }), /*#__PURE__*/React__default.createElement(Divider$1, null)), /*#__PURE__*/React__default.createElement("div", {
    className: classes.itemTimespanList
  }, /*#__PURE__*/React__default.createElement(ItemTimespanList, {
    timespanList: timespanList,
    video: video,
    onEdit: onEdit,
    canEdit: canEdit,
    subtitleGroup: subtitleGroup,
    subtitleField: subtitleField,
    sampleRate: sampleRate,
    aduGroup: aduGroup,
    aduValue: aduValue,
    aduConfidence: aduConfidence,
    filterConfidence: filterConfidence
  })));
}

var ItemTimespanBox$1 = withStyles(styles$s)(ItemTimespanBox);

var ItemTimespanSelection = withStyles({}, {
  name: 'VdtItemTimespanSelection'
})(function (_ref) {
  var currentValue = _ref.value,
      handleChange = _ref.handleChange,
      options = _ref.options,
      _ref$eventTypeText = _ref.eventTypeText,
      eventTypeText = _ref$eventTypeText === void 0 ? 'Event Type' : _ref$eventTypeText;
  return /*#__PURE__*/React__default.createElement(FormControl, {
    variant: "standard",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(InputLabel, null, eventTypeText), /*#__PURE__*/React__default.createElement(Select, {
    value: currentValue,
    onChange: handleChange
  }, options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      value: option,
      key: option.label
    }, option.label);
  })));
});
function ItemTimespanTab(_ref2) {
  var itemId = _ref2.itemId,
      videoEl = _ref2.videoEl,
      _ref2$sampleRate = _ref2.sampleRate,
      sampleRate = _ref2$sampleRate === void 0 ? 'PAL' : _ref2$sampleRate,
      _ref2$timespanOptions = _ref2.timespanOptions,
      timespanOptions = _ref2$timespanOptions === void 0 ? [{}] : _ref2$timespanOptions;

  var _React$useState = React__default.useState(timespanOptions[0]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      timespanValue = _React$useState2[0],
      setTimespanValue = _React$useState2[1];

  var _timespanValue$value = timespanValue.value;
  _timespanValue$value = _timespanValue$value === void 0 ? {} : _timespanValue$value;
  var _timespanValue$value$ = _timespanValue$value.subtitleGroup,
      subtitleGroup = _timespanValue$value$ === void 0 ? 'stl_subtitle' : _timespanValue$value$,
      _timespanValue$value$2 = _timespanValue$value.subtitleField,
      subtitleField = _timespanValue$value$2 === void 0 ? 'stl_text' : _timespanValue$value$2,
      aduGroup = _timespanValue$value.aduGroup,
      aduValue = _timespanValue$value.aduValue,
      aduConfidence = _timespanValue$value.aduConfidence;

  var onChangeTimespanValue = function onChangeTimespanValue(event) {
    return setTimespanValue(event.target.value);
  };

  var queryParams = {
    content: 'metadata',
    group: [subtitleGroup, aduGroup],
    field: [subtitleField, aduValue, aduConfidence],
    sampleRate: sampleRate
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, timespanOptions && timespanOptions.length > 1 && /*#__PURE__*/React__default.createElement(Box, {
    mb: 1
  }, /*#__PURE__*/React__default.createElement(ItemTimespanSelection, {
    options: timespanOptions,
    value: timespanValue,
    handleChange: onChangeTimespanValue
  })), /*#__PURE__*/React__default.createElement(GetItem, {
    itemId: itemId,
    queryParams: queryParams
  }, /*#__PURE__*/React__default.createElement(ItemTimespanBox$1, {
    videoEl: videoEl,
    subtitleGroup: subtitleGroup,
    subtitleField: subtitleField,
    aduGroup: aduGroup,
    aduValue: aduValue,
    aduConfidence: aduConfidence,
    sampleRate: sampleRate
  })));
}

var ALLOWED_MIME_TYPES = ['video/mp4'];

var styles$t = function styles(theme) {
  return {
    root: {
      '& .video-js.controls-below-player:not(.vjs-fullscreen) .vjs-control-bar .vdt-timecode:not(.vjs-menu-item-text)': {
        color: theme.palette.text.primary
      },
      '& .video-js.controls-below-player:not(.vjs-fullscreen) .vjs-control-bar .vjs-button:not(.vjs-menu-item-text)': {
        color: theme.palette.text.primary
      },
      '& .video-js.controls-below-player:not(.vjs-fullscreen) .vjs-control-bar .vjs-volume-level': {
        backgroundColor: theme.palette.text.primary,
        color: theme.palette.text.primary
      },
      '& .video-js .vjs-play-progress.vjs-slider-bar': {
        backgroundColor: theme.palette.secondary.main
      }
    }
  };
};

function ItemVideoPlayer(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      itemType = _ref.itemType,
      videoEl = _ref.videoEl,
      _ref$subtitleGroup = _ref.subtitleGroup,
      subtitleGroup = _ref$subtitleGroup === void 0 ? 'stl_subtitle' : _ref$subtitleGroup,
      _ref$subtitleField = _ref.subtitleField,
      subtitleField = _ref$subtitleField === void 0 ? 'stl_text' : _ref$subtitleField,
      _ref$subtitleLanguage = _ref.subtitleLanguage,
      subtitleLanguage = _ref$subtitleLanguage === void 0 ? 'en' : _ref$subtitleLanguage,
      _ref$subtitleLanguage2 = _ref.subtitleLanguageLabel,
      subtitleLanguageLabel = _ref$subtitleLanguage2 === void 0 ? 'English' : _ref$subtitleLanguage2,
      _ref$sampleRate = _ref.sampleRate,
      sampleRate = _ref$sampleRate === void 0 ? 'PAL' : _ref$sampleRate,
      onReady = _ref.onReady,
      onCinema = _ref.onCinema,
      onScreenshot = _ref.onScreenshot,
      onScreenshotSuccess = _ref.onScreenshotSuccess,
      onScreenshotError = _ref.onScreenshotError,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$sourceTag = _ref.sourceTag,
      sourceTag = _ref$sourceTag === void 0 ? 'original' : _ref$sourceTag,
      _ref$videoPlayerProps = _ref.videoPlayerProps,
      videoPlayerProps = _ref$videoPlayerProps === void 0 ? {} : _ref$videoPlayerProps,
      _ref$previewSources = _ref.previewSources,
      previewSources = _ref$previewSources === void 0 ? [] : _ref$previewSources;
  var ref = React__default.useRef();

  if (videoEl) {
    ref = videoEl;
  }

  var _itemType$thumbnails = itemType.thumbnails;
  _itemType$thumbnails = _itemType$thumbnails === void 0 ? {} : _itemType$thumbnails;
  var _itemType$thumbnails$ = _itemType$thumbnails.uri,
      thumbnailList = _itemType$thumbnails$ === void 0 ? [] : _itemType$thumbnails$,
      metadataType = itemType.metadata,
      itemId = itemType.id;
  var webVtt = React__default.useMemo(function () {
    return metadataTypeToWebVtt({
      metadataType: metadataType,
      subtitleGroup: subtitleGroup,
      subtitleField: subtitleField,
      sampleRate: sampleRate
    });
  }, [metadataType, subtitleGroup, subtitleField, sampleRate]);
  var subtitles = React__default.useMemo(function () {
    if (webVtt) {
      return [{
        src: new Blob([webVtt], {
          type: 'text/plain'
        }),
        lang: subtitleLanguage,
        label: subtitleLanguageLabel
      }];
    }

    return undefined;
  }, [webVtt, subtitleLanguage, subtitleLanguageLabel]);

  var _thumbnailList = _slicedToArray(thumbnailList, 1),
      poster = _thumbnailList[0];

  var timeBase = formatTimeBase(sampleRate);

  var defaultOnScreenshot = function defaultOnScreenshot(seconds) {
    var timeText = formatSeconds(seconds, timeBase).toText();
    var priority = 'HIGHEST';
    var createThumbnails = timeText;
    var createPosters = timeText;
    Promise.all([item.createThumbnail({
      itemId: itemId,
      queryParams: {
        createThumbnails: createThumbnails,
        priority: priority,
        sourceTag: sourceTag
      }
    }), item.createThumbnail({
      itemId: itemId,
      queryParams: {
        createPosters: createPosters,
        priority: priority,
        sourceTag: sourceTag
      }
    })]).then(function (resp) {
      if (onScreenshotSuccess) onScreenshotSuccess(resp);
    })["catch"](function (e) {
      if (onScreenshotError) onScreenshotError(e);
    });
  };

  return /*#__PURE__*/React__default.createElement(Box, {
    className: clsx(classes.root, 'VdtItemVideoPlayer-root', className)
  }, /*#__PURE__*/React__default.createElement(Box, {
    width: "100%",
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React__default.createElement(VideoPlayer, _extends({
    controls: true,
    sources: previewSources,
    subtitles: subtitles,
    posterUrl: poster,
    ref: ref,
    frameRate: timeBase.denominator / timeBase.numerator,
    timecode: true,
    width: width,
    onScreenshot: onScreenshot || defaultOnScreenshot,
    onReady: onReady,
    onCinema: onCinema // eslint-disable-next-line react/jsx-props-no-spreading

  }, videoPlayerProps)))));
}

var ItemVideoPlayer$1 = withStyles(styles$t, {
  name: 'VdtItemVideoPlayer'
})(ItemVideoPlayer);

/* eslint-disable no-nested-ternary */
var ALLOWED_MIME_TYPES$1 = ['audio/mp4', 'audio/mpeg', 'audio/x-aac', 'audio/aac', 'audio/x-wav', 'audio/wav', 'audio/accp', 'audio/ogg', 'audio/webm', 'audio/x-flac'];

var styles$u = function styles(theme) {
  return {
    root: {
      '& .video-js': {
        backgroundColor: 'rgba(0, 0, 0, 0.2)'
      },
      '& .video-js.vjs-has-started.vjs-user-inactive.vjs-playing:not(.controls-below-player) .vjs-control-bar': {
        transform: 'none'
      },
      '& .video-js .vjs-play-progress.vjs-slider-bar': {
        backgroundColor: theme.palette.secondary.main
      },
      '& .video-js .vjs-fullscreen-control': {
        display: 'none'
      }
    }
  };
};

function ItemAudioPlayer(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      videoEl = _ref.videoEl,
      onReady = _ref.onReady,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$previewSources = _ref.previewSources,
      previewSources = _ref$previewSources === void 0 ? [] : _ref$previewSources;
  return /*#__PURE__*/React__default.createElement(Box, {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React__default.createElement(VideoPlayer, {
    controls: true,
    sources: previewSources.slice(0, 1),
    ref: videoEl,
    width: width,
    onReady: onReady
  })));
}

var ItemAudioPlayer$1 = withStyles(styles$u, {
  name: 'VdtItemAudioPlayer'
})(ItemAudioPlayer);

var ALLOWED_MIME_TYPES$2 = ['image/apng', 'image/bmp', 'image/gif', 'image/jpeg', 'image/x-icon', 'image/png', 'image/svg+xml'];

var styles$v = function styles() {
  return {
    root: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    },
    img: {
      display: 'block',
      margin: 'auto',
      maxWidth: '100%',
      maxHeight: '70vh'
    }
  };
};

function ItemImagePlayer(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      _ref$previewSource = _ref.previewSource,
      previewSource = _ref$previewSource === void 0 ? {} : _ref$previewSource;
  var src = previewSource.src;
  return /*#__PURE__*/React__default.createElement(Box, {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement("img", {
    className: classes.img,
    src: src,
    alt: ""
  }));
}

var ItemImagePlayer$1 = withStyles(styles$v, {
  name: 'VdtItemImagePlayer'
})(ItemImagePlayer);

var ALLOWED_MIME_TYPES$3 = [].concat(_toConsumableArray(ALLOWED_MIME_TYPES), _toConsumableArray(ALLOWED_MIME_TYPES$2), _toConsumableArray(ALLOWED_MIME_TYPES$1));
var IMAGE = 'IMAGE';
var AUDIO = 'AUDIO';
var VIDEO = 'VIDEO';

var defaultShapeToLabel = function defaultShapeToLabel(shape) {
  if (shape.height) {
    if (shape.fieldOrder) {
      return "".concat(shape.tag, " (").concat(shape.height).concat(shape.fieldOrder[0], ")");
    }

    return "".concat(shape.tag, " (").concat(shape.height, "x").concat(shape.width, ")");
  }

  if (shape.audioFormat) {
    if (shape.containerFormat !== shape.audioFormat) {
      return "".concat(shape.tag, " (").concat(shape.audioFormat, " - ").concat(shape.containerFormat, ")");
    }

    return "".concat(shape.tag, " (").concat(shape.audioFormat, ")");
  }

  return shape.tag;
};

var SourceSelection = withStyles({}, {
  name: 'VdtSourceSelection'
})(function (_ref) {
  var currentValue = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      _ref$previewSourceTex = _ref.previewSourceText,
      previewSourceText = _ref$previewSourceTex === void 0 ? 'Preview Source' : _ref$previewSourceTex;
  return /*#__PURE__*/React__default.createElement(FormControl, {
    variant: "standard",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(InputLabel, null, previewSourceText), /*#__PURE__*/React__default.createElement(Select, {
    value: currentValue,
    onChange: onChange
  }, options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      value: option,
      key: option.src
    }, option.label);
  })));
}); // extract to vdt-js?

var getShapeDuration = function getShapeDuration(shape) {
  var hmsToSeconds = function hmsToSeconds(hms) {
    return hms.split(':').reduce(function (acc, seconds) {
      return 60 * acc + Number(seconds);
    });
  };

  if (shape.timeCode) return Math.floor(shape.timeCode.toSeconds());
  if (shape.duration) return hmsToSeconds(shape.duration);
  return undefined;
};

function ItemPlayer(_ref2) {
  var className = _ref2.className,
      itemId = _ref2.itemId,
      videoEl = _ref2.videoEl,
      itemType = _ref2.itemType,
      isLoading = _ref2.isLoading,
      _ref2$subtitleGroup = _ref2.subtitleGroup,
      subtitleGroup = _ref2$subtitleGroup === void 0 ? 'stl_subtitle' : _ref2$subtitleGroup,
      _ref2$subtitleField = _ref2.subtitleField,
      subtitleField = _ref2$subtitleField === void 0 ? 'stl_text' : _ref2$subtitleField,
      _ref2$sampleRate = _ref2.sampleRate,
      sampleRate = _ref2$sampleRate === void 0 ? 'PAL' : _ref2$sampleRate,
      _ref2$allowedMimeType = _ref2.allowedMimeTypes,
      allowedMimeTypes = _ref2$allowedMimeType === void 0 ? ALLOWED_MIME_TYPES$3 : _ref2$allowedMimeType,
      _ref2$ItemImagePlayer = _ref2.ItemImagePlayerComponent,
      ItemImagePlayerComponent = _ref2$ItemImagePlayer === void 0 ? ItemImagePlayer$1 : _ref2$ItemImagePlayer,
      _ref2$ItemAudioPlayer = _ref2.ItemAudioPlayerComponent,
      ItemAudioPlayerComponent = _ref2$ItemAudioPlayer === void 0 ? ItemAudioPlayer$1 : _ref2$ItemAudioPlayer,
      _ref2$ItemVideoPlayer = _ref2.ItemVideoPlayerComponent,
      ItemVideoPlayerComponent = _ref2$ItemVideoPlayer === void 0 ? ItemVideoPlayer$1 : _ref2$ItemVideoPlayer,
      onReady = _ref2.onReady,
      onCinema = _ref2.onCinema,
      onScreenshot = _ref2.onScreenshot,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '100%' : _ref2$width,
      _ref2$sourceTag = _ref2.sourceTag,
      sourceTag = _ref2$sourceTag === void 0 ? 'original' : _ref2$sourceTag,
      _ref2$SourceSelection = _ref2.SourceSelectionComponent,
      SourceSelectionComponent = _ref2$SourceSelection === void 0 ? SourceSelection : _ref2$SourceSelection,
      _ref2$videoPlayerProp = _ref2.videoPlayerProps,
      videoPlayerProps = _ref2$videoPlayerProp === void 0 ? {} : _ref2$videoPlayerProp,
      _ref2$shapeToLabel = _ref2.shapeToLabel,
      shapeToLabel = _ref2$shapeToLabel === void 0 ? defaultShapeToLabel : _ref2$shapeToLabel,
      _ref2$ItemVideoPlayer2 = _ref2.ItemVideoPlayerProps,
      ItemVideoPlayerProps = _ref2$ItemVideoPlayer2 === void 0 ? {} : _ref2$ItemVideoPlayer2,
      props = _objectWithoutProperties(_ref2, ["className", "itemId", "videoEl", "itemType", "isLoading", "subtitleGroup", "subtitleField", "sampleRate", "allowedMimeTypes", "ItemImagePlayerComponent", "ItemAudioPlayerComponent", "ItemVideoPlayerComponent", "onReady", "onCinema", "onScreenshot", "width", "sourceTag", "SourceSelectionComponent", "videoPlayerProps", "shapeToLabel", "ItemVideoPlayerProps"]);

  var _React$useState = React__default.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      source = _React$useState2[0],
      setSource = _React$useState2[1];

  var previewSources = React__default.useMemo(function () {
    return filterShapeSource(itemType, {
      allowedMimeTypes: allowedMimeTypes
    }).map(function (previewProps) {
      return _objectSpread2(_objectSpread2({}, previewProps), {}, {
        label: shapeToLabel(previewProps.shape)
      });
    });
  }, [itemType, allowedMimeTypes, shapeToLabel]);
  var mediaType = React__default.useMemo(function () {
    if (source) {
      return getShapeMediaType(source.shape);
    }

    if (previewSources && previewSources.length > 0) {
      return getShapeMediaType(previewSources[0].shape);
    }

    return undefined;
  }, [source, previewSources]);

  var onChangeSource = function onChangeSource(_ref3) {
    var newSource = _ref3.target.value;
    var newSrc = newSource.src,
        newShape = newSource.shape,
        newType = newSource.type;

    if (mediaType === VIDEO || mediaType === AUDIO) {
      var player = videoEl && videoEl.current && videoEl.current.player && videoEl.current.player.videojs;
      if (!player || player.currentSrc() === newSrc) return;
      var isPaused = player.paused();
      var currentTime = player.currentTime();
      var currentDuration = Math.floor(player.duration());
      var newDuration = getShapeDuration(newShape);
      if (player.preload === 'none') player.preload = 'metadata';

      if (currentDuration <= newDuration + 2 && currentDuration >= newDuration - 2) {
        player.addClass('vjs-has-started');
        player.bigPlayButton.hide();
        player.poster(''); // TODO: Show poster image if existing

        player.one('loadedmetadata', function () {
          player.currentTime(currentTime);
          if (!isPaused) player.play();
        });
      } else {
        player.one('loadeddata', function () {
          player.bigPlayButton.show();
        });
      }

      player.pause();
      player.src({
        src: newSrc,
        type: newType.replace('x-', '')
      });
    }

    setSource(newSource);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, isLoading || mediaType === undefined || previewSources.length === 0 ?
  /*#__PURE__*/
  // Show loading or no previews...
  React__default.createElement(Skeleton, {
    variant: "rect",
    width: "100%",
    height: 520
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (mediaType === IMAGE || mediaType === AUDIO) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, mediaType === IMAGE && /*#__PURE__*/React__default.createElement(ItemImagePlayerComponent, _extends({
    previewSource: source || previewSources[0],
    videoEl: videoEl // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)), mediaType === AUDIO && /*#__PURE__*/React__default.createElement(ItemAudioPlayerComponent, {
    videoEl: videoEl,
    onReady: onReady,
    width: width,
    sourceTag: sourceTag,
    previewSources: previewSources
  }), SourceSelectionComponent && previewSources.length > 1 && /*#__PURE__*/React__default.createElement(SourceSelectionComponent, {
    options: previewSources,
    value: source || previewSources[0],
    onChange: onChangeSource
  })), mediaType === VIDEO && /*#__PURE__*/React__default.createElement(ItemVideoPlayerComponent, _extends({
    videoEl: videoEl,
    itemType: itemType,
    subtitleGroup: subtitleGroup,
    subtitleField: subtitleField,
    sampleRate: sampleRate,
    onReady: onReady,
    onCinema: onCinema,
    onScreenshot: onScreenshot,
    width: width,
    sourceTag: sourceTag,
    previewSources: previewSources,
    videoPlayerProps: videoPlayerProps
  }, ItemVideoPlayerProps))));
}

var TableCellLabel$1 = withStyles(function (theme) {
  return {
    root: _objectSpread2({
      display: 'flex',
      alignItems: 'center',
      borderStyle: 'none'
    }, theme.typography.body2)
  };
})(TableCell$1);
var TableCellValue$1 = withStyles(function (theme) {
  return {
    root: _objectSpread2({
      borderStyle: 'none'
    }, theme.typography.subtitle2)
  };
})(TableCell$1);
var Chip = withStyles(function () {
  return {
    root: {
      borderStyle: 'none'
    }
  };
})(Chip$1);

var toCapsCase = function toCapsCase(string) {
  return "".concat(string[0].toUpperCase()).concat(string.slice(1).toLowerCase());
};

function EntityAccessMenu(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'VdtEntityAccessMenu-root' : _ref$className,
      onRemove = _ref.onRemove,
      accessType = _ref.accessType,
      entityType = _ref.entityType,
      entityId = _ref.entityId;

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var onOpen = function onOpen(event) {
    setAnchorEl(event.currentTarget);
  };

  var onClose = function onClose() {
    setAnchorEl(null);
  };

  var accessId = accessType.id;

  var handleRemove = function handleRemove() {
    onRemove({
      accessId: accessId,
      entityType: entityType,
      entityId: entityId
    });
    onClose();
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: onOpen
  }, /*#__PURE__*/React__default.createElement(MoreVertIcon, null)), /*#__PURE__*/React__default.createElement(Menu, {
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: handleRemove
  }, /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(DeleteIcon, null)), /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: "Delete",
    primaryTypographyProps: {
      color: 'secondary'
    }
  }))));
}

function EntityAccessRow(_ref2) {
  var _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? 'VdtEntityAccessRow-root' : _ref2$className,
      accessType = _ref2.accessType,
      entityType = _ref2.entityType,
      entityId = _ref2.entityId,
      onRemove = _ref2.onRemove,
      _ref2$EntityAccessMen = _ref2.EntityAccessMenuComponent,
      EntityAccessMenuComponent = _ref2$EntityAccessMen === void 0 ? EntityAccessMenu : _ref2$EntityAccessMen,
      _ref2$EntityAccessMen2 = _ref2.EntityAccessMenuProps,
      EntityAccessMenuProps = _ref2$EntityAccessMen2 === void 0 ? {} : _ref2$EntityAccessMen2;
  var user = accessType.user,
      group = accessType.group,
      permission = accessType.permission;
  var label = user || group;
  var value = toCapsCase(permission);
  var IconComponent = null;
  if (user) IconComponent = UserIcon;else if (group) IconComponent = GroupIcon;
  return /*#__PURE__*/React__default.createElement(TableRow$3$1, {
    component: "div",
    className: className
  }, /*#__PURE__*/React__default.createElement(TableCellLabel$1, {
    component: "div"
  }, onRemove ? /*#__PURE__*/React__default.createElement(EntityAccessMenuComponent, _extends({
    onRemove: onRemove,
    entityType: entityType,
    entityId: entityId,
    accessType: accessType // eslint-disable-next-line react/jsx-props-no-spreading

  }, EntityAccessMenuProps)) : null, /*#__PURE__*/React__default.createElement(Chip, {
    label: label,
    icon: /*#__PURE__*/React__default.createElement(IconComponent, null),
    variant: "outlined"
  })), /*#__PURE__*/React__default.createElement(TableCellValue$1, {
    component: "div"
  }, value));
}

function EntityAccessTable(_ref3) {
  var _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? 'VdtEntityAccessTable-root' : _ref3$className,
      accessControlList = _ref3.accessControlList,
      entityType = _ref3.entityType,
      entityId = _ref3.entityId,
      onRemove = _ref3.onRemove,
      _ref3$EntityAccessRow = _ref3.EntityAccessRowComponent,
      EntityAccessRowComponent = _ref3$EntityAccessRow === void 0 ? EntityAccessRow : _ref3$EntityAccessRow,
      _ref3$EntityAccessRow2 = _ref3.EntityAccessRowProps,
      EntityAccessRowProps = _ref3$EntityAccessRow2 === void 0 ? {} : _ref3$EntityAccessRow2;
  var _accessControlList$ac = accessControlList.access,
      access = _accessControlList$ac === void 0 ? [] : _accessControlList$ac;
  return /*#__PURE__*/React__default.createElement(Table$1, {
    size: "small",
    component: "div",
    className: className
  }, /*#__PURE__*/React__default.createElement(TableBody$1, {
    component: "div"
  }, access.map(function (accessType) {
    return /*#__PURE__*/React__default.createElement(EntityAccessRowComponent, _extends({
      key: accessType.id,
      accessType: accessType,
      entityType: entityType,
      entityId: entityId,
      onRemove: onRemove // eslint-disable-next-line react/jsx-props-no-spreading

    }, EntityAccessRowProps));
  })));
}

var EntityAccessTable$1 = withStyles({}, {
  name: 'VdtEntityAccessTable'
})(EntityAccessTable);

var RECIPIENT_TYPES = {
  GROUP: 'group',
  USER: 'user'
};
var PERMISSIONS = {
  ALL: 'ALL',
  WRITE: 'WRITE',
  READ: 'READ',
  NONE: 'NONE'
};

var styles$w = function styles(theme) {
  return {
    root: {},
    recipientRoot: {
      display: 'flex',
      width: '100%'
    },
    recipientType: {
      flexGrow: 1
    },
    actions: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(2),
      justifyContent: 'flex-end',
      flex: '0 0 auto',
      '& > :not(:first-child)': {
        marginLeft: theme.spacing(2)
      }
    },
    actionsSubmit: {}
  };
};

var accessControlDocumentReducer = function accessControlDocumentReducer(state, action) {
  switch (action.type) {
    case 'CHANGE_PERMISSION':
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          permission: action.value
        });
      }

    case 'CHANGE_RECIPIENT':
      {
        if (state[RECIPIENT_TYPES.USER] !== undefined) {
          return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, RECIPIENT_TYPES.USER, action.value));
        }

        if (state[RECIPIENT_TYPES.GROUP] !== undefined) {
          return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, RECIPIENT_TYPES.GROUP, action.value));
        }

        return state;
      }

    case 'CHANGE_RECIPIENTTYPE':
      {
        var _RECIPIENT_TYPES$USER = RECIPIENT_TYPES.USER,
            _RECIPIENT_TYPES$GROU = RECIPIENT_TYPES.GROUP,
            user = state[_RECIPIENT_TYPES$USER],
            group = state[_RECIPIENT_TYPES$GROU],
            otherState = _objectWithoutProperties(state, [_RECIPIENT_TYPES$USER, _RECIPIENT_TYPES$GROU].map(_toPropertyKey));

        return _objectSpread2(_objectSpread2({}, otherState), {}, _defineProperty({}, action.value, null));
      }

    default:
      {
        throw new Error("Unhandled action type: ".concat(action.type));
      }
  }
};

var useAccessControlDocument = function useAccessControlDocument(initialState) {
  var _React$useReducer = React__default.useReducer(accessControlDocumentReducer, initialState),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      accessControlDocument = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var onChangePermission = React__default.useCallback(function (value) {
    return dispatch({
      value: value,
      type: 'CHANGE_PERMISSION'
    });
  }, []);
  var onChangeRecipient = React__default.useCallback(function (value) {
    return dispatch({
      value: value,
      type: 'CHANGE_RECIPIENT'
    });
  }, []);
  var onChangeRecipientType = React__default.useCallback(function (value) {
    return dispatch({
      value: value,
      type: 'CHANGE_RECIPIENTTYPE'
    });
  }, []);
  return {
    accessControlDocument: accessControlDocument,
    onChangePermission: onChangePermission,
    onChangeRecipient: onChangeRecipient,
    onChangeRecipientType: onChangeRecipientType
  };
};

function onSearchGroups(_x, _x2) {
  return _onSearchGroups.apply(this, arguments);
}

function _onSearchGroups() {
  _onSearchGroups = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(searchText, hideDefaultGroups) {
    var _yield$GroupApi$searc, _yield$GroupApi$searc2, group$1;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return group.searchGroup({
              groupSearchDocument: {
                field: [{
                  name: 'groupname',
                  value: searchText
                }]
              }
            });

          case 2:
            _yield$GroupApi$searc = _context.sent;
            _yield$GroupApi$searc2 = _yield$GroupApi$searc.data.group;
            group$1 = _yield$GroupApi$searc2 === void 0 ? [] : _yield$GroupApi$searc2;

            if (!hideDefaultGroups) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", group$1.map(function (g) {
              return g.groupName;
            }).filter(function (g) {
              return !g.startsWith('_');
            }));

          case 7:
            return _context.abrupt("return", group$1.map(function (g) {
              return g.groupName;
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _onSearchGroups.apply(this, arguments);
}

function onSearchUsers(_x3) {
  return _onSearchUsers.apply(this, arguments);
}

function _onSearchUsers() {
  _onSearchUsers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(searchText) {
    var _yield$UserApi$search, _yield$UserApi$search2, user$1;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return user.searchUser({
              userSearchDocument: {
                field: [{
                  name: 'username',
                  value: searchText
                }]
              }
            });

          case 2:
            _yield$UserApi$search = _context2.sent;
            _yield$UserApi$search2 = _yield$UserApi$search.data.user;
            user$1 = _yield$UserApi$search2 === void 0 ? [] : _yield$UserApi$search2;
            return _context2.abrupt("return", user$1.map(function (u) {
              return u.userName;
            }));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _onSearchUsers.apply(this, arguments);
}

function RecipientSearchPicker(_ref) {
  var onSearch = _ref.onSearch,
      onChange = _ref.onChange,
      label = _ref.label,
      hideDefaultGroups = _ref.hideDefaultGroups;

  var _React$useState = React__default.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      options = _React$useState2[0],
      setOptions = _React$useState2[1];

  var _React$useState3 = React__default.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      inputValue = _React$useState4[0],
      setInputValue = _React$useState4[1];

  var _React$useState5 = React__default.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      value = _React$useState6[0],
      setValue = _React$useState6[1];

  var search = function search(searchText) {
    onSearch(searchText, hideDefaultGroups).then(setOptions);
  };

  var handleInputChange = function handleInputChange(_, val, reason) {
    setInputValue(val);
    if (reason === 'input') search(val);
  };

  var handleChange = function handleChange(_, val) {
    setValue(val);
    onChange(val);
  };

  return /*#__PURE__*/React__default.createElement(Autocomplete, {
    value: value,
    inputValue: inputValue,
    options: options,
    onChange: handleChange,
    onInputChange: handleInputChange,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$2 // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, params, {
        label: label,
        variant: "outlined"
      }));
    }
  });
}

function PermissionPicker(_ref2) {
  var value = _ref2.value,
      label = _ref2.label,
      _onChange = _ref2.onChange,
      _ref2$choices = _ref2.choices,
      choices = _ref2$choices === void 0 ? PERMISSIONS : _ref2$choices,
      selected = _ref2.selected;
  return /*#__PURE__*/React__default.createElement(FormControl, {
    margin: "normal",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(FormLabel, null, label), /*#__PURE__*/React__default.createElement(RadioGroup, {
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }, Object.entries(choices).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        radioValue = _ref4[0],
        radioLabel = _ref4[1];

    return /*#__PURE__*/React__default.createElement(FormControlLabel, {
      key: radioValue,
      value: radioValue,
      control: /*#__PURE__*/React__default.createElement(Radio, null),
      label: radioLabel,
      disabled: !selected
    });
  })));
}

function RecipientTypePicker(_ref5) {
  var _onChange2 = _ref5.onChange,
      value = _ref5.value,
      userText = _ref5.userText,
      groupText = _ref5.groupText;
  return /*#__PURE__*/React__default.createElement(ToggleButtonGroup, {
    value: value,
    exclusive: true,
    onChange: function onChange(e, newValue) {
      return _onChange2(newValue);
    }
  }, /*#__PURE__*/React__default.createElement(ToggleButton, {
    value: RECIPIENT_TYPES.USER
  }, userText), /*#__PURE__*/React__default.createElement(ToggleButton, {
    value: RECIPIENT_TYPES.GROUP
  }, groupText));
}

function EntityAccessEdit(_ref6) {
  var classes = _ref6.classes,
      entityType = _ref6.entityType,
      entityId = _ref6.entityId,
      _ref6$onSuccess = _ref6.onSuccess,
      onSuccess = _ref6$onSuccess === void 0 ? function () {} : _ref6$onSuccess,
      _ref6$onError = _ref6.onError,
      onError = _ref6$onError === void 0 ? function () {} : _ref6$onError,
      _ref6$onSubmit = _ref6.onSubmit,
      onSubmit = _ref6$onSubmit === void 0 ? access.createEntityAccess : _ref6$onSubmit,
      onCancel = _ref6.onCancel,
      _ref6$initialAccessCo = _ref6.initialAccessControlDocument,
      initialAccessControlDocument = _ref6$initialAccessCo === void 0 ? {
    user: null
  } : _ref6$initialAccessCo,
      _ref6$UserPickerCompo = _ref6.UserPickerComponent,
      UserPickerComponent = _ref6$UserPickerCompo === void 0 ? RecipientSearchPicker : _ref6$UserPickerCompo,
      _ref6$UserPickerProps = _ref6.UserPickerProps,
      UserPickerProps = _ref6$UserPickerProps === void 0 ? {} : _ref6$UserPickerProps,
      _ref6$GroupPickerComp = _ref6.GroupPickerComponent,
      GroupPickerComponent = _ref6$GroupPickerComp === void 0 ? RecipientSearchPicker : _ref6$GroupPickerComp,
      _ref6$GroupPickerProp = _ref6.GroupPickerProps,
      GroupPickerProps = _ref6$GroupPickerProp === void 0 ? {} : _ref6$GroupPickerProp,
      _ref6$PermissionPicke = _ref6.PermissionPickerComponent,
      PermissionPickerComponent = _ref6$PermissionPicke === void 0 ? PermissionPicker : _ref6$PermissionPicke,
      PermissionPickerProps = _ref6.PermissionPickerProps,
      _ref6$RecipientTypePi = _ref6.RecipientTypePickerComponent,
      RecipientTypePickerComponent = _ref6$RecipientTypePi === void 0 ? RecipientTypePicker : _ref6$RecipientTypePi,
      RecipientTypePickerProps = _ref6.RecipientTypePickerProps,
      _ref6$permissionText = _ref6.permissionText,
      permissionText = _ref6$permissionText === void 0 ? 'Permission' : _ref6$permissionText,
      _ref6$grantAccessText = _ref6.grantAccessText,
      grantAccessText = _ref6$grantAccessText === void 0 ? 'Grant Access' : _ref6$grantAccessText,
      _ref6$userText = _ref6.userText,
      userText = _ref6$userText === void 0 ? 'User' : _ref6$userText,
      _ref6$groupText = _ref6.groupText,
      groupText = _ref6$groupText === void 0 ? 'Group' : _ref6$groupText,
      _ref6$searchText = _ref6.searchText,
      searchText = _ref6$searchText === void 0 ? 'Search' : _ref6$searchText,
      _ref6$cancelText = _ref6.cancelText,
      cancelText = _ref6$cancelText === void 0 ? 'Cancel' : _ref6$cancelText,
      _ref6$hideDefaultGrou = _ref6.hideDefaultGroups,
      hideDefaultGroups = _ref6$hideDefaultGrou === void 0 ? true : _ref6$hideDefaultGrou;

  var _useAccessControlDocu = useAccessControlDocument(initialAccessControlDocument),
      accessControlDocument = _useAccessControlDocu.accessControlDocument,
      onChangePermission = _useAccessControlDocu.onChangePermission,
      onChangeRecipient = _useAccessControlDocu.onChangeRecipient,
      onChangeRecipientType = _useAccessControlDocu.onChangeRecipientType;

  var handleSubmit = function handleSubmit() {
    return Promise.resolve(onSubmit({
      entityType: entityType,
      entityId: entityId,
      accessControlDocument: accessControlDocument
    })).then(onSuccess)["catch"](onError);
  };

  var _accessControlDocumen = accessControlDocument.permission,
      permission = _accessControlDocumen === void 0 ? '' : _accessControlDocumen;
  var recipientType = React__default.useMemo(function () {
    if (accessControlDocument[RECIPIENT_TYPES.USER] !== undefined) return RECIPIENT_TYPES.USER;
    if (accessControlDocument[RECIPIENT_TYPES.GROUP] !== undefined) return RECIPIENT_TYPES.GROUP;
    return undefined;
  }, [accessControlDocument]);

  var _Object$values = Object.values(accessControlDocument),
      _Object$values2 = _slicedToArray(_Object$values, 1),
      selected = _Object$values2[0];

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.recipientRoot
  }, RecipientTypePickerComponent ? /*#__PURE__*/React__default.createElement(RecipientTypePickerComponent, _extends({
    value: recipientType,
    onChange: onChangeRecipientType,
    userText: userText,
    groupText: groupText // eslint-disable-next-line react/jsx-props-no-spreading

  }, RecipientTypePickerProps)) : null, /*#__PURE__*/React__default.createElement("div", {
    className: classes.recipientType
  }, UserPickerComponent && recipientType === RECIPIENT_TYPES.USER ? /*#__PURE__*/React__default.createElement(UserPickerComponent, _extends({
    onSearch: onSearchUsers,
    onChange: onChangeRecipient,
    label: searchText // eslint-disable-next-line react/jsx-props-no-spreading

  }, UserPickerProps)) : null, GroupPickerComponent && recipientType === RECIPIENT_TYPES.GROUP ? /*#__PURE__*/React__default.createElement(GroupPickerComponent, _extends({
    onSearch: onSearchGroups,
    onChange: onChangeRecipient,
    label: searchText // eslint-disable-next-line react/jsx-props-no-spreading

  }, GroupPickerProps, {
    hideDefaultGroups: hideDefaultGroups
  })) : null)), PermissionPickerComponent ? /*#__PURE__*/React__default.createElement(PermissionPickerComponent, _extends({
    value: permission,
    onChange: onChangePermission,
    selected: selected,
    label: permissionText // eslint-disable-next-line react/jsx-props-no-spreading

  }, PermissionPickerProps)) : null, /*#__PURE__*/React__default.createElement("div", {
    className: classes.actions
  }, onCancel ? /*#__PURE__*/React__default.createElement(Button$1, {
    className: classes.actionsCancel,
    onClick: onCancel
  }, cancelText) : null, /*#__PURE__*/React__default.createElement(Button$1, {
    className: classes.actionsSubmit,
    onClick: handleSubmit,
    disabled: !accessControlDocument[recipientType] || !permission,
    variant: "outlined",
    color: "primary"
  }, grantAccessText)));
}

var EntityAccessEdit$1 = withStyles(styles$w, {
  name: 'VdtEntityAccessEdit'
})(EntityAccessEdit);

function ItemAccessTab(_ref) {
  var itemId = _ref.itemId,
      _ref$toggleAddLabelTe = _ref.toggleAddLabelText,
      toggleAddLabelText = _ref$toggleAddLabelTe === void 0 ? function (isAdding) {
    return isAdding ? 'Cancel' : 'Add permission';
  } : _ref$toggleAddLabelTe,
      _ref$showAddAccess = _ref.showAddAccess,
      showAddAccess = _ref$showAddAccess === void 0 ? true : _ref$showAddAccess,
      _ref$EntityAccessTabl = _ref.EntityAccessTableProps,
      EntityAccessTableProps = _ref$EntityAccessTabl === void 0 ? {} : _ref$EntityAccessTabl;

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isAdding = _React$useState2[0],
      setIsAdding = _React$useState2[1];

  var toggleAdd = function toggleAdd() {
    return setIsAdding(!isAdding);
  };

  var _useEntityAccess = useEntityAccess({
    entityId: itemId,
    entityType: 'item'
  }),
      accessControlList = _useEntityAccess.accessControlList,
      onList = _useEntityAccess.onList,
      onRemove = _useEntityAccess.onRemove,
      onAdd = _useEntityAccess.onAdd;

  React__default.useEffect(function () {
    onList(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId]);

  var handleRemove = function handleRemove(props) {
    return onRemove(props).then(onList);
  };

  var onAddSuccess = function onAddSuccess() {
    onList();
    setIsAdding(false);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showAddAccess && /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel, {
    control: /*#__PURE__*/React__default.createElement(Switch, {
      checked: isAdding,
      onChange: toggleAdd
    }),
    label: toggleAddLabelText(isAdding),
    labelPlacement: "start"
  })), showAddAccess && isAdding ? /*#__PURE__*/React__default.createElement(EntityAccessEdit$1, {
    entityType: "item",
    entityId: itemId,
    onSuccess: onAddSuccess,
    onCancel: function onCancel() {
      return setIsAdding(false);
    },
    onSubmit: onAdd
  }) : /*#__PURE__*/React__default.createElement(EntityAccessTable$1, _extends({
    entityType: "item",
    entityId: itemId,
    accessControlList: accessControlList,
    onRemove: handleRemove // eslint-disable-next-line react/jsx-props-no-spreading

  }, EntityAccessTableProps)));
}

var ItemAccessTab$1 = withStyles({}, {
  name: 'VdtItemAccessTab'
})(ItemAccessTab);

var styles$x = function styles(theme) {
  return {
    root: {
      height: '42px',
      paddingTop: '8px !important'
    },
    cell: {
      borderBottom: 'none',
      fontSize: '14px'
    },
    labelCell: {
      lineHeight: '20px',
      padding: '10px 0'
    },
    fieldCell: {
      '& .MuiInput-root': _objectSpread2(_objectSpread2({}, theme.typography.body1), {}, {
        '& .MuiInput-input': {
          lineHeight: '20px',
          height: '20px',
          padding: '7px 0'
        }
      }),
      '& .MuiInputBase-multiline': {
        padding: 0
      }
    },
    field: {
      marginTop: 0,
      '& .MuiFormHelperText-root': {
        display: 'none'
      },
      '& .VdtSelectField-select': {
        marginTop: 0
      },
      '&.VdtSelectField-root': {
        height: '34px'
      }
    }
  };
};

function ItemMetadataFieldRow(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      name = _ref.name,
      label = _ref.label,
      _ref$labelText = _ref.labelText,
      labelText = _ref$labelText === void 0 ? function () {
    return label || name;
  } : _ref$labelText,
      props = _objectWithoutProperties(_ref, ["classes", "className", "name", "label", "labelText"]);

  return /*#__PURE__*/React__default.createElement(TableRow$3$1, {
    className: clsx(classes.root, 'VdtItemMetadataFieldRow-root', className)
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    className: clsx(classes.cell, classes.labelCell, 'VdtItemMetadataFieldRow-labelCell'),
    colSpan: 2
  }, labelText(name, label)), /*#__PURE__*/React__default.createElement(TableCell$1, {
    className: clsx(classes.cell, classes.fieldCell, 'VdtItemMetadataFieldRow-fieldCell'),
    colSpan: 3
  }, /*#__PURE__*/React__default.createElement(Field, _extends({
    name: name,
    className: clsx(classes.field, 'VdtItemMetadataFieldRow-field') // eslint-disable-next-line react/jsx-props-no-spreading

  }, props))));
}

var ItemMetadataFieldRow$1 = withStyles(styles$x, {
  name: 'VdtItemMetadataFieldRow'
})(ItemMetadataFieldRow);

var DISPLAY_TYPES = {
  AUTOCOMPLETE: 'autocomplete',
  SELECT: 'select',
  SWITCH: 'switch',
  CHECKBOX: 'checkbox',
  CHECKBOXGROUP: 'checkboxGroup',
  RADIO: 'radio',
  INTEGER: 'integer',
  FLOAT: 'float',
  LONG: 'long',
  TEXTAREA: 'textArea',
  TEXT: 'text'
};
var DEFAULT_TYPE = DISPLAY_TYPES.TEXT;

var componentSelector = function componentSelector(displayType) {
  switch (displayType) {
    case DISPLAY_TYPES.AUTOCOMPLETE:
      return AutocompleteField$1;

    case DISPLAY_TYPES.SELECT:
      return SelectField$1;

    case DISPLAY_TYPES.SWITCH:
      return SwitchField$1;

    case DISPLAY_TYPES.CHECKBOX:
      return CheckboxField$1;

    case DISPLAY_TYPES.CHECKBOXGROUP:
      return CheckboxGroupField$1;

    case DISPLAY_TYPES.RADIO:
      return RadioField$1;

    case DISPLAY_TYPES.DATE:
    case DISPLAY_TYPES.INTEGER:
    case DISPLAY_TYPES.LONG:
    case DISPLAY_TYPES.FLOAT:
    case DISPLAY_TYPES.TEXTAREA:
    case DISPLAY_TYPES.TEXT:
    default:
      return TextField$1;
  }
};

var typeSelector = function typeSelector(type, displayType) {
  // react-final-form needs type checkbox to manage values correctly
  if (type === 'boolean' && displayType === 'checkbox') {
    return 'checkbox';
  }

  if (['integer', 'long'].includes(type)) {
    return 'number';
  }

  return type || DEFAULT_TYPE;
};

var defaultGetFieldProps = function defaultGetFieldProps(_ref) {
  var displayType = _ref.displayType,
      fieldType = _ref.type;
  var component = componentSelector(displayType);
  var type = typeSelector(fieldType, displayType);
  var multiline = displayType === DISPLAY_TYPES.TEXTAREA || undefined;
  return {
    component: component,
    type: type,
    multiline: multiline
  };
};

var styles$y = {
  root: {
    tableLayout: 'fixed'
  },
  dividerCell: {
    height: '20px'
  }
};

var PureItemMetadataFormTable = function PureItemMetadataFormTable(_ref2) {
  var classes = _ref2.classes,
      className = _ref2.className,
      groupName = _ref2.groupName,
      _ref2$fields = _ref2.fields,
      fields = _ref2$fields === void 0 ? [] : _ref2$fields,
      _ref2$groups = _ref2.groups,
      groups = _ref2$groups === void 0 ? [] : _ref2$groups,
      _ref2$getFieldProps = _ref2.getFieldProps,
      getFieldProps = _ref2$getFieldProps === void 0 ? defaultGetFieldProps : _ref2$getFieldProps;
  var GroupFieldTableRows = React__default.useMemo(function () {
    return groups.map(function (_ref3) {
      var name = _ref3.name,
          groupFields = _ref3.fields,
          childGroups = _ref3.groups,
          props = _objectWithoutProperties(_ref3, ["name", "fields", "groups"]);

      return /*#__PURE__*/React__default.createElement(ItemMetadataFieldGroupRow, _extends({
        key: name,
        name: groupName ? "".concat(groupName, ".").concat(name) : name,
        fields: groupFields,
        groups: childGroups,
        getFieldProps: getFieldProps
      }, props));
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [groups]);
  var FieldTableRows = React__default.useMemo(function () {
    return fields.map(function (field) {
      var name = field.name,
          displayType = field.displayType,
          props = _objectWithoutProperties(field, ["name", "displayType"]);

      return /*#__PURE__*/React__default.createElement(ItemMetadataFieldRow$1, _extends({
        key: name,
        name: groupName ? "".concat(groupName, ".").concat(name) : name
      }, getFieldProps(field), props));
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [fields]);
  return /*#__PURE__*/React__default.createElement(Table, {
    size: "small",
    padding: "none",
    className: clsx(classes.root, 'VdtItemMetadataFormTable-root', className)
  }, /*#__PURE__*/React__default.createElement(TableBody, null, FieldTableRows, /*#__PURE__*/React__default.createElement(TableRow$3, null, /*#__PURE__*/React__default.createElement(TableCell, {
    className: clsx(classes.dividerCell, 'VdtItemMetadataFormTable-dividerCell'),
    colSpan: 5
  })), GroupFieldTableRows));
};

var FieldGroupRowStyles = {
  accordion: {
    backgroundColor: 'unset',
    boxShadow: 'unset'
  },
  summary: {
    padding: 0,
    '&.MuiAccordionSummary-root.Mui-expanded': {
      minHeight: '56px'
    },
    '& .MuiAccordionSummary-content': {
      marginTop: '5px',
      marginBottom: '5px'
    }
  },
  details: {
    paddingTop: 0
  }
};

var PureItemMetadataFieldGroupRow = function PureItemMetadataFieldGroupRow(_ref4) {
  var classes = _ref4.classes,
      className = _ref4.className,
      name = _ref4.name,
      label = _ref4.label,
      _ref4$labelText = _ref4.labelText,
      labelText = _ref4$labelText === void 0 ? function () {
    return label || name;
  } : _ref4$labelText,
      fields = _ref4.fields,
      groups = _ref4.groups,
      getFieldProps = _ref4.getFieldProps;
  return /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: clsx(classes.root, 'VdtItemMetadataFieldGroupRow-root', className)
  }, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 5
  }, /*#__PURE__*/React__default.createElement(Accordion$1, {
    className: clsx(classes.accordion, 'VdtItemMetadataFieldGroupRow-accordion')
  }, /*#__PURE__*/React__default.createElement(AccordionSummary$1, {
    className: clsx(classes.summary, 'VdtItemMetadataFieldGroupRow-summary'),
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMore, null),
    "aria-controls": "panel1a-content",
    id: "panel1a-header"
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    className: clsx(classes.label, 'VdtItemMetadataFieldGroupRow-label')
  }, labelText(name, label))), /*#__PURE__*/React__default.createElement(AccordionDetails$1, {
    className: clsx(classes.details, 'VdtItemMetadataFieldGroupRow-details')
  }, /*#__PURE__*/React__default.createElement(ItemMetadataFormTable, {
    groupName: name,
    fields: fields,
    groups: groups,
    getFieldProps: getFieldProps
  })))));
};

var ItemMetadataFieldGroupRow = withStyles(FieldGroupRowStyles, {
  name: 'VdtItemMetadataFieldGroupRow'
})(PureItemMetadataFieldGroupRow);
var ItemMetadataFormTable = withStyles(styles$y, {
  name: 'VdtItemMetadataFormTable'
})(PureItemMetadataFormTable);

function ItemMetadataForm(_ref) {
  var _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields,
      _ref$groups = _ref.groups,
      groups = _ref$groups === void 0 ? [] : _ref$groups,
      handleSubmit = _ref.handleSubmit,
      handleFormSpy = _ref.handleFormSpy,
      _ref$saveText = _ref.saveText,
      saveText = _ref$saveText === void 0 ? 'Save' : _ref$saveText,
      _ref$ItemMetadataForm = _ref.ItemMetadataFormComponent,
      ItemMetadataFormComponent = _ref$ItemMetadataForm === void 0 ? ItemMetadataFormTable : _ref$ItemMetadataForm,
      _ref$ItemMetadataForm2 = _ref.ItemMetadataFormProps,
      ItemMetadataFormProps = _ref$ItemMetadataForm2 === void 0 ? {} : _ref$ItemMetadataForm2;
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React__default.createElement(ItemMetadataFormComponent, _extends({
    fields: fields,
    groups: groups
  }, ItemMetadataFormProps)), handleFormSpy && /*#__PURE__*/React__default.createElement(FormSpy, {
    subscription: {
      values: true,
      invalid: true,
      active: true
    },
    onChange: handleFormSpy
  }), /*#__PURE__*/React__default.createElement(Box$1, {
    m: 2
  }, /*#__PURE__*/React__default.createElement(Button, {
    fullWidth: true,
    variant: "outlined",
    type: "submit",
    color: "primary"
  }, saveText)));
}

var ItemMetadataForm$1 = withStyles({}, {
  name: 'VdtItemMetadataForm'
})(ItemMetadataForm);

function stringsToBooleans(acc, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  if (value === 'true') {
    acc[key] = true;
  } else if (value === 'false') {
    acc[key] = false;
  } else if (Array.isArray(value)) {
    acc[key] = value.map(function (thisValue) {
      if (thisValue === 'true') return true;
      if (thisValue === 'false') return false;
      return thisValue;
    });
  } else if (_typeof(value) === 'object') {
    acc[key] = Object.entries(value).reduce(stringsToBooleans, {});
  } else {
    acc[key] = value;
  }

  return acc;
}

function booleansToStrings(acc, _ref3, joinValue) {
  var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];

  if (value === true) {
    acc[key] = 'true';
  } else if (value === false) {
    acc[key] = 'false';
  } else if (Array.isArray(value)) {
    acc[key] = value.map(function (thisValue) {
      if (thisValue === true) return 'true';
      if (thisValue === false) return 'false';
      return thisValue;
    });
  } else if (_typeof(value) === 'object') {
    acc[key] = Object.entries(value).reduce(booleansToStrings, {});
  } else {
    var valueArray = value.split(joinValue);
    acc[key] = valueArray.length > 1 ? valueArray : value;
  }

  return acc;
}

function ItemMetadataEdit(_ref5) {
  var itemId = _ref5.itemId,
      onSuccess = _ref5.onSuccess,
      fields = _ref5.fields,
      groups = _ref5.groups,
      itemType = _ref5.itemType,
      onRefresh = _ref5.onRefresh,
      isLoading = _ref5.isLoading,
      joinValue = _ref5.joinValue,
      _ref5$onError = _ref5.onError,
      onError = _ref5$onError === void 0 ? function (error) {
    return console.error(error.message);
  } : _ref5$onError;
  var metadataType = itemType.metadata;
  var initialValues = React__default.useMemo(function () {
    var values = parseMetadataType(metadataType, {
      flat: true,
      arrayOnSingle: false
    });
    var valuesWithBooleans = Object.entries(values).reduce(stringsToBooleans, {});
    return valuesWithBooleans;
  }, [metadataType]);

  var onSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
      var valuesAsStrings, metadataDocument;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              valuesAsStrings = Object.entries(values).reduce(function (a, c) {
                return booleansToStrings(a, c, joinValue);
              }, {});
              metadataDocument = createMetadataType(valuesAsStrings);
              _context.prev = 2;
              _context.next = 5;
              return item.updateItemMetadata({
                itemId: itemId,
                metadataDocument: metadataDocument
              });

            case 5:
              _context.next = 7;
              return onRefresh();

            case 7:
              onSuccess();
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              onError(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10]]);
    }));

    return function onSubmit(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && /*#__PURE__*/React__default.createElement(Form, {
    onSubmit: onSubmit,
    component: ItemMetadataForm$1,
    fields: fields,
    groups: groups,
    initialValues: initialValues
  }));
}

var styles$z = function styles(theme) {
  return {
    root: {
      padding: 0,
      margin: '2px 0'
    },
    text: {
      margin: 0,
      '& > .MuiListItemText-primary': _objectSpread2({}, theme.typography.body2)
    },
    label: {
      flexBasis: '30%',
      marginBottom: 'auto',
      '& > .MuiListItemText-primary': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    },
    value: {
      flexBasis: '70%',
      display: 'flex',
      alignItems: 'flex-end',
      '& > .MuiListItemText-primary': {
        wordBreak: 'break-all',
        fontWeight: 600
      },
      '& > .MuiListItemText-secondary': {
        marginLeft: '6px'
      }
    }
  };
};

var ItemMetadataListFieldItem = function ItemMetadataListFieldItem(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      _ref$formatValue = _ref.formatValue,
      formatValue = _ref$formatValue === void 0 ? function (thisValue) {
    return thisValue;
  } : _ref$formatValue,
      options = _ref.options,
      showFieldName = _ref.showFieldName,
      _ref$showOptionLabel = _ref.showOptionLabel,
      showOptionLabel = _ref$showOptionLabel === void 0 ? true : _ref$showOptionLabel;
  var optionLabel = options && options.some(function (o) {
    return o.value === value;
  }) ? options.find(function (o) {
    return o.value === value;
  }).label : undefined;
  return /*#__PURE__*/React__default.createElement(ListItem, {
    className: clsx(classes.root, 'VdtItemMetadataListFieldItem-root', className)
  }, /*#__PURE__*/React__default.createElement(ListItemText$1, {
    className: clsx(classes.text, classes.label, 'VdtItemMetadataListFieldItem-label'),
    primary: label || name,
    secondary: showFieldName && name
  }), /*#__PURE__*/React__default.createElement(ListItemText$1, {
    className: clsx(classes.text, classes.value, 'VdtItemMetadataListFieldItem-value'),
    primary: value !== undefined ? formatValue(value) : '',
    secondary: showOptionLabel && optionLabel && "(".concat(optionLabel, ")")
  }));
};

var ItemMetadataListFieldItem$1 = withStyles(styles$z, {
  name: 'VdtItemMetadataListFieldItem'
})(ItemMetadataListFieldItem);

var styles$A = function styles(theme) {
  return {
    root: {
      padding: 0
    },
    label: {
      flexBasis: 1,
      margin: '2px',
      '& > .MuiListItemText-primary': _objectSpread2({}, theme.typography.body2)
    },
    list: {
      padding: 0,
      paddingLeft: '1em'
    }
  };
};

var ItemMetadataListFieldGroupItem = function ItemMetadataListFieldGroupItem(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      name = _ref.name,
      label = _ref.label,
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields,
      _ref$groups = _ref.groups,
      groups = _ref$groups === void 0 ? [] : _ref$groups,
      values = _ref.values,
      showFieldName = _ref.showFieldName,
      showOptionLabel = _ref.showOptionLabel,
      props = _objectWithoutProperties(_ref, ["classes", "className", "name", "label", "fields", "groups", "values", "showFieldName", "showOptionLabel"]);

  var _React$useState = React__default.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var handleClick = function handleClick() {
    setOpen(!open);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ListItem, _extends({
    className: clsx(classes.root, 'VdtItemMetadataListFieldGroupItem-root', className),
    button: true,
    onClick: handleClick
  }, props), /*#__PURE__*/React__default.createElement(ListItemText$1, {
    className: clsx(classes.label, 'VdtItemMetadataListFieldGroupItem-label'),
    primary: label || name,
    secondary: showFieldName && name
  }), open ? /*#__PURE__*/React__default.createElement(ExpandLess, null) : /*#__PURE__*/React__default.createElement(ExpandMore, null)), /*#__PURE__*/React__default.createElement(Collapse$1, {
    "in": open,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/React__default.createElement(List, {
    component: "div",
    className: clsx(classes.list, 'VdtItemMetadataListFieldGroupItem-list')
  }, fields.map(function (_ref2) {
    var fieldName = _ref2.name,
        fieldProps = _objectWithoutProperties(_ref2, ["name"]);

    return /*#__PURE__*/React__default.createElement(ItemMetadataListFieldItem$1, _extends({
      key: "".concat(name, "-").concat(fieldName),
      name: fieldName,
      value: values[fieldName],
      showFieldName: showFieldName,
      showOptionLabel: showOptionLabel
    }, fieldProps));
  }), groups.map(function (_ref3) {
    var groupName = _ref3.name,
        groupFields = _ref3.fields,
        childGroups = _ref3.groups,
        groupProps = _objectWithoutProperties(_ref3, ["name", "fields", "groups"]);

    return /*#__PURE__*/React__default.createElement(ItemMetadataListFieldGroupItem, _extends({
      key: "".concat(name, "-").concat(groupName),
      classes: classes,
      className: className,
      name: groupName,
      fields: groupFields,
      groups: childGroups,
      values: values[groupName] ? values[groupName] : {},
      showFieldName: showFieldName,
      showOptionLabel: showOptionLabel
    }, groupProps));
  }))));
};

var ItemMetadataListFieldGroupItem$1 = withStyles(styles$A, {
  name: 'VdtItemMetadataListFieldGroupItem'
})(ItemMetadataListFieldGroupItem);

var styles$B = function styles() {
  return {
    root: {
      width: '100%',
      '& .MuiDivider-root': {
        marginTop: '10px',
        marginBottom: '10px'
      }
    }
  };
};

var ItemMetadataList = function ItemMetadataList(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields,
      _ref$groups = _ref.groups,
      groups = _ref$groups === void 0 ? [] : _ref$groups,
      _ref$showFieldName = _ref.showFieldName,
      showFieldName = _ref$showFieldName === void 0 ? false : _ref$showFieldName,
      _ref$showOptionLabel = _ref.showOptionLabel,
      showOptionLabel = _ref$showOptionLabel === void 0 ? true : _ref$showOptionLabel,
      values = _objectWithoutProperties(_ref, ["classes", "className", "fields", "groups", "showFieldName", "showOptionLabel"]);

  return /*#__PURE__*/React__default.createElement(List, {
    className: clsx(classes.root, 'VdtItemMetadataList-root', className),
    size: "small",
    padding: "none",
    component: "div"
  }, fields.map(function (_ref2) {
    var fieldName = _ref2.name,
        fieldProps = _objectWithoutProperties(_ref2, ["name"]);

    return /*#__PURE__*/React__default.createElement(ItemMetadataListFieldItem$1, _extends({
      key: fieldName,
      name: fieldName,
      value: values[fieldName],
      showFieldName: showFieldName
    }, fieldProps));
  }), /*#__PURE__*/React__default.createElement(Divider, null), groups.map(function (_ref3) {
    var groupName = _ref3.name,
        groupProps = _objectWithoutProperties(_ref3, ["name"]);

    return /*#__PURE__*/React__default.createElement(ItemMetadataListFieldGroupItem$1, _extends({
      key: groupName,
      name: groupName,
      values: values[groupName] ? values[groupName] : {},
      showFieldName: showFieldName,
      showOptionLabel: showOptionLabel
    }, groupProps));
  }));
};

var ItemMetadataList$1 = withStyles(styles$B, {
  name: 'VdtItemMetadataList'
})(ItemMetadataList);

function ItemMetadataTab(_ref) {
  var itemId = _ref.itemId,
      fields = _ref.fields,
      groups = _ref.groups,
      _ref$editingLabel = _ref.editingLabel,
      editingLabel = _ref$editingLabel === void 0 ? function (isEditing) {
    return isEditing ? 'Cancel' : 'Edit';
  } : _ref$editingLabel,
      _ref$showEditMetadata = _ref.showEditMetadata,
      showEditMetadata = _ref$showEditMetadata === void 0 ? true : _ref$showEditMetadata,
      onError = _ref.onError,
      _ref$editJoinValue = _ref.editJoinValue,
      editJoinValue = _ref$editJoinValue === void 0 ? ';' : _ref$editJoinValue,
      _ref$useContentPaths = _ref.useContentPaths,
      useContentPaths = _ref$useContentPaths === void 0 ? false : _ref$useContentPaths;
  var queryParams = React__default.useMemo(function () {
    if (useContentPaths) {
      var groupPathParams = groups ? groups.map(function (g) {
        return g.name;
      }).map(function (name) {
        return "metadata.timespan.group[name=".concat(name, "]");
      }).join(',') : undefined;
      var fieldPathParams = fields ? fields.map(function (f) {
        return f.name;
      }).map(function (name) {
        return "v(".concat(name, ")");
      }).join(',') : 'metadata.timespan.field';
      return {
        p: [fieldPathParams, groupPathParams].join(',')
      };
    }

    return {
      field: fields ? fields.map(function (_ref2) {
        var name = _ref2.name;
        return name;
      }) : [],
      group: groups ? groups.map(function (_ref3) {
        var name = _ref3.name;
        return name;
      }) : [],
      content: 'metadata'
    };
  }, [fields, groups, useContentPaths]);

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isEditing = _React$useState2[0],
      setIsEditing = _React$useState2[1];

  var toggleEdit = function toggleEdit() {
    return setIsEditing(!isEditing);
  };

  var _useAddMetadataFieldA = useAddMetadataFieldAttributes({
    fields: fields,
    groups: groups
  }),
      fieldsWithAttributes = _useAddMetadataFieldA.fieldsWithAttributes,
      groupsWithAttributes = _useAddMetadataFieldA.groupsWithAttributes;

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showEditMetadata && /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel, {
    control: /*#__PURE__*/React__default.createElement(Switch, {
      checked: isEditing,
      onChange: toggleEdit
    }),
    label: editingLabel(isEditing),
    labelPlacement: "start"
  })), (fieldsWithAttributes.length > 0 || groupsWithAttributes.length > 0) && /*#__PURE__*/React__default.createElement(GetItem, {
    itemId: itemId,
    queryParams: queryParams
  }, showEditMetadata && isEditing ? /*#__PURE__*/React__default.createElement(ItemMetadataEdit, {
    fields: fieldsWithAttributes,
    groups: groupsWithAttributes,
    onSuccess: toggleEdit,
    onError: onError,
    joinValue: editJoinValue
  }) : /*#__PURE__*/React__default.createElement(MetadataType$1, {
    joinValue: ", "
  }, /*#__PURE__*/React__default.createElement(ItemMetadataList$1, {
    fields: fieldsWithAttributes,
    groups: groupsWithAttributes
  }))));
}

var ItemMetadataTab$1 = withStyles({}, {
  name: 'VdtItemMetadataTab'
})(ItemMetadataTab);

function ItemFieldGroupTab(_ref) {
  var itemId = _ref.itemId,
      _ref$metadataGroupTex = _ref.metadataGroupText,
      metadataGroupText = _ref$metadataGroupTex === void 0 ? 'Metadata Group' : _ref$metadataGroupTex,
      _ref$editingLabel = _ref.editingLabel,
      editingLabel = _ref$editingLabel === void 0 ? function (isEditing) {
    return isEditing ? 'Cancel' : 'Edit';
  } : _ref$editingLabel;

  var _React$useState = React__default.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      fields = _React$useState2[0],
      setFields = _React$useState2[1];

  var _React$useState3 = React__default.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      groups = _React$useState4[0],
      setGroups = _React$useState4[1];

  var _React$useState5 = React__default.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      selectedGroup = _React$useState6[0],
      setSelectedGroup = _React$useState6[1];

  var _React$useState7 = React__default.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      isEditing = _React$useState8[0],
      setIsEditing = _React$useState8[1];

  var _useApi = useApi(fieldgroup.getFieldGroup),
      getFieldGroupRequest = _useApi.request,
      _useApi$data = _useApi.data;

  _useApi$data = _useApi$data === void 0 ? {} : _useApi$data;
  var _useApi$data$field = _useApi$data.field,
      fieldGroupFields = _useApi$data$field === void 0 ? [] : _useApi$data$field;

  var _useApi2 = useApi(fieldgroup.listFieldGroup),
      listFieldGroupRequest = _useApi2.request,
      _useApi2$data = _useApi2.data;

  _useApi2$data = _useApi2$data === void 0 ? {} : _useApi2$data;
  var _useApi2$data$group = _useApi2$data.group,
      fieldGroups = _useApi2$data$group === void 0 ? [] : _useApi2$data$group;
  React__default.useEffect(function () {
    listFieldGroupRequest(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var getMetadataFieldGroup = function getMetadataFieldGroup() {
    return getFieldGroupRequest({
      groupName: selectedGroup
    });
  };

  React__default.useEffect(function () {
    var groupArr = fieldGroups.map(function (group) {
      return group.name;
    });
    setGroups(groupArr);
  }, [fieldGroups]);
  React__default.useEffect(function () {
    if (selectedGroup) {
      getMetadataFieldGroup();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [selectedGroup]);
  React__default.useEffect(function () {
    if (fieldGroupFields && fieldGroupFields.length) {
      var fieldArr = fieldGroupFields.map(function (field) {
        return {
          value: field.name,
          label: field.name
        };
      });
      setFields(fieldArr);
    }
  }, [fieldGroupFields]);
  var queryParams = {
    content: 'metadata',
    interval: 'generic',
    includeTransientMetadata: false,
    field: fields ? fields.map(function (_ref2) {
      var value = _ref2.value;
      return value;
    }) : []
  };

  var toggleEdit = function toggleEdit() {
    return setIsEditing(!isEditing);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default.createElement(Autocomplete, {
    options: groups,
    id: "field-group-select",
    disabled: isEditing,
    disableClearable: true,
    style: {
      width: '100%',
      paddingBottom: '1rem'
    },
    onChange: function onChange(event, value) {
      if (value) {
        setSelectedGroup(value);
      }
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$2, _extends({
        label: metadataGroupText // eslint-disable-next-line react/jsx-props-no-spreading

      }, params));
    }
  }), /*#__PURE__*/React__default.createElement(FormControlLabel, {
    control: /*#__PURE__*/React__default.createElement(Switch, {
      checked: isEditing,
      onChange: toggleEdit
    }),
    label: editingLabel(isEditing),
    labelPlacement: "start"
  })), /*#__PURE__*/React__default.createElement(GetItem, {
    itemId: itemId,
    queryParams: queryParams
  }, isEditing ? /*#__PURE__*/React__default.createElement(ItemMetadataEdit, {
    fields: fields,
    groups: groups,
    onSuccess: toggleEdit
  }) : /*#__PURE__*/React__default.createElement(MetadataType$1, null, /*#__PURE__*/React__default.createElement(ItemMetadataTable, {
    fields: fields,
    groups: groups
  }))));
}

var ItemFieldGroupTab$1 = withStyles({}, {
  name: 'VdtItemFieldGroupTab'
})(ItemFieldGroupTab);

function createCommonjsModule$1(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b$1 = "function" === typeof Symbol && Symbol["for"],
    c$1 = b$1 ? Symbol["for"]("react.element") : 60103,
    d$1 = b$1 ? Symbol["for"]("react.portal") : 60106,
    e$1 = b$1 ? Symbol["for"]("react.fragment") : 60107,
    f$6 = b$1 ? Symbol["for"]("react.strict_mode") : 60108,
    g$1 = b$1 ? Symbol["for"]("react.profiler") : 60114,
    h$1 = b$1 ? Symbol["for"]("react.provider") : 60109,
    k$1 = b$1 ? Symbol["for"]("react.context") : 60110,
    l$1 = b$1 ? Symbol["for"]("react.async_mode") : 60111,
    m$1 = b$1 ? Symbol["for"]("react.concurrent_mode") : 60111,
    n$1 = b$1 ? Symbol["for"]("react.forward_ref") : 60112,
    p$1 = b$1 ? Symbol["for"]("react.suspense") : 60113,
    q$1 = b$1 ? Symbol["for"]("react.suspense_list") : 60120,
    r$1 = b$1 ? Symbol["for"]("react.memo") : 60115,
    t$1 = b$1 ? Symbol["for"]("react.lazy") : 60116,
    v$1 = b$1 ? Symbol["for"]("react.block") : 60121,
    w$1 = b$1 ? Symbol["for"]("react.fundamental") : 60117,
    x$1 = b$1 ? Symbol["for"]("react.responder") : 60118,
    y$1 = b$1 ? Symbol["for"]("react.scope") : 60119;

function z$1(a) {
  if ("object" === _typeof$1(a) && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c$1:
        switch (a = a.type, a) {
          case l$1:
          case m$1:
          case e$1:
          case g$1:
          case f$6:
          case p$1:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k$1:
              case n$1:
              case t$1:
              case r$1:
              case h$1:
                return a;

              default:
                return u;
            }

        }

      case d$1:
        return u;
    }
  }
}

function A$1(a) {
  return z$1(a) === m$1;
}

var AsyncMode$1 = l$1;
var ConcurrentMode$1 = m$1;
var ContextConsumer$1 = k$1;
var ContextProvider$1 = h$1;
var Element$2 = c$1;
var ForwardRef$1 = n$1;
var Fragment$1 = e$1;
var Lazy$1 = t$1;
var Memo$1 = r$1;
var Portal$1 = d$1;
var Profiler$1 = g$1;
var StrictMode$1 = f$6;
var Suspense$1 = p$1;

var isAsyncMode$1 = function isAsyncMode(a) {
  return A$1(a) || z$1(a) === l$1;
};

var isConcurrentMode$1 = A$1;

var isContextConsumer$1 = function isContextConsumer(a) {
  return z$1(a) === k$1;
};

var isContextProvider$1 = function isContextProvider(a) {
  return z$1(a) === h$1;
};

var isElement$1 = function isElement(a) {
  return "object" === _typeof$1(a) && null !== a && a.$$typeof === c$1;
};

var isForwardRef$1 = function isForwardRef(a) {
  return z$1(a) === n$1;
};

var isFragment$1 = function isFragment(a) {
  return z$1(a) === e$1;
};

var isLazy$1 = function isLazy(a) {
  return z$1(a) === t$1;
};

var isMemo$1 = function isMemo(a) {
  return z$1(a) === r$1;
};

var isPortal$1 = function isPortal(a) {
  return z$1(a) === d$1;
};

var isProfiler$1 = function isProfiler(a) {
  return z$1(a) === g$1;
};

var isStrictMode$1 = function isStrictMode(a) {
  return z$1(a) === f$6;
};

var isSuspense$1 = function isSuspense(a) {
  return z$1(a) === p$1;
};

var isValidElementType$1 = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m$1 || a === g$1 || a === f$6 || a === p$1 || a === q$1 || "object" === _typeof$1(a) && null !== a && (a.$$typeof === t$1 || a.$$typeof === r$1 || a.$$typeof === h$1 || a.$$typeof === k$1 || a.$$typeof === n$1 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v$1);
};

var typeOf$1 = z$1;
var reactIs_production_min$1 = {
  AsyncMode: AsyncMode$1,
  ConcurrentMode: ConcurrentMode$1,
  ContextConsumer: ContextConsumer$1,
  ContextProvider: ContextProvider$1,
  Element: Element$2,
  ForwardRef: ForwardRef$1,
  Fragment: Fragment$1,
  Lazy: Lazy$1,
  Memo: Memo$1,
  Portal: Portal$1,
  Profiler: Profiler$1,
  StrictMode: StrictMode$1,
  Suspense: Suspense$1,
  isAsyncMode: isAsyncMode$1,
  isConcurrentMode: isConcurrentMode$1,
  isContextConsumer: isContextConsumer$1,
  isContextProvider: isContextProvider$1,
  isElement: isElement$1,
  isForwardRef: isForwardRef$1,
  isFragment: isFragment$1,
  isLazy: isLazy$1,
  isMemo: isMemo$1,
  isPortal: isPortal$1,
  isProfiler: isProfiler$1,
  isStrictMode: isStrictMode$1,
  isSuspense: isSuspense$1,
  isValidElementType: isValidElementType$1,
  typeOf: typeOf$1
};
var reactIs_development$1 = createCommonjsModule$1(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof$1(type) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (_typeof$1(object) === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return _typeof$1(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs_development_1$1 = reactIs_development$1.AsyncMode;
var reactIs_development_2$1 = reactIs_development$1.ConcurrentMode;
var reactIs_development_3$1 = reactIs_development$1.ContextConsumer;
var reactIs_development_4$1 = reactIs_development$1.ContextProvider;
var reactIs_development_5$1 = reactIs_development$1.Element;
var reactIs_development_6$1 = reactIs_development$1.ForwardRef;
var reactIs_development_7$1 = reactIs_development$1.Fragment;
var reactIs_development_8$1 = reactIs_development$1.Lazy;
var reactIs_development_9$1 = reactIs_development$1.Memo;
var reactIs_development_10$1 = reactIs_development$1.Portal;
var reactIs_development_11$1 = reactIs_development$1.Profiler;
var reactIs_development_12$1 = reactIs_development$1.StrictMode;
var reactIs_development_13$1 = reactIs_development$1.Suspense;
var reactIs_development_14$1 = reactIs_development$1.isAsyncMode;
var reactIs_development_15$1 = reactIs_development$1.isConcurrentMode;
var reactIs_development_16$1 = reactIs_development$1.isContextConsumer;
var reactIs_development_17$1 = reactIs_development$1.isContextProvider;
var reactIs_development_18$1 = reactIs_development$1.isElement;
var reactIs_development_19$1 = reactIs_development$1.isForwardRef;
var reactIs_development_20$1 = reactIs_development$1.isFragment;
var reactIs_development_21$1 = reactIs_development$1.isLazy;
var reactIs_development_22$1 = reactIs_development$1.isMemo;
var reactIs_development_23$1 = reactIs_development$1.isPortal;
var reactIs_development_24$1 = reactIs_development$1.isProfiler;
var reactIs_development_25$1 = reactIs_development$1.isStrictMode;
var reactIs_development_26$1 = reactIs_development$1.isSuspense;
var reactIs_development_27$1 = reactIs_development$1.isValidElementType;
var reactIs_development_28$1 = reactIs_development$1.typeOf;
var reactIs$1 = createCommonjsModule$1(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$1;
  } else {
    module.exports = reactIs_development$1;
  }
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
var propIsEnumerable$1 = Object.prototype.propertyIsEnumerable;

function toObject$2(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative$1() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign$1 = shouldUseNative$1() ? Object.assign : function (target, source) {
  var from;
  var to = toObject$2(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty$2.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols$1) {
      symbols = getOwnPropertySymbols$1(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable$1.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$2;

var printWarning$2 = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1$1 = ReactPropTypesSecret_1$1;
  var loggedTypeFailures$1 = {};
  var has$4 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$2 = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$4(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof$1(typeSpecs[typeSpecName]) + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$2((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + _typeof$1(error) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures$1)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures$1[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$2('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures$1 = {};
  }
};

var checkPropTypes_1$1 = checkPropTypes$1;
var has$1$1 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1$1 = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1$1 = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull$1() {
  return null;
}

var factoryWithTypeCheckers$1 = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$1);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull$1;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull$1;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning$1$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull$1;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign$1({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (_typeof$1(propValue)) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = _typeof$1(propValue);

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1$1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1$1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction$1() {}

function emptyFunctionWithReset$1() {}

emptyFunctionWithReset$1.resetWarningCache = emptyFunction$1;

var factoryWithThrowingShims$1 = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1$1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset$1,
    resetWarningCache: emptyFunction$1
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes$1 = createCommonjsModule$1(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs$1; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers$1(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims$1();
  }
});
/* eslint no-use-before-define: 0 */

function lazyFunction(fn) {
  // eslint-disable-next-line func-names
  return function () {
    // eslint-disable-next-line prefer-rest-params
    return fn.apply(this, arguments);
  };
}

var SearchResultEntryTimespanType = lazyFunction(function () {
  return {
    field: propTypes$1.arrayOf(propTypes$1.shape({
      name: propTypes$1.string.isRequired,
      value: propTypes$1.arrayOf(propTypes$1.string)
    })),
    end: propTypes$1.string.isRequired,
    start: propTypes$1.string.isRequired
  };
});
var EssenceMappingsType = lazyFunction(function () {
  return {
    storage: propTypes$1.arrayOf(propTypes$1.shape(StorageMappingType)),
    asset: propTypes$1.arrayOf(propTypes$1.shape(AssetMappingType)),
    file: propTypes$1.arrayOf(propTypes$1.shape(FileMappingType))
  };
});
var MaterialPackageType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(PackageType), propTypes$1.shape({
    track: propTypes$1.arrayOf(propTypes$1.shape(MaterialPackageTrackType))
  }));
});
var AudioComponentType = lazyFunction(function () {
  return propTypes$1.arrayOf(MediaComponentType, propTypes$1.shape({
    channelCount: propTypes$1.number.isRequired,
    frameSize: propTypes$1.number,
    channelLayout: propTypes$1.number,
    sampleFormat: propTypes$1.string,
    mediaInfo: AudioMediaInfoType,
    blockAlign: propTypes$1.number
  }));
});
var MetadataSchemaGroupType = lazyFunction(function () {
  return {
    field: propTypes$1.arrayOf(propTypes$1.shape(MetadataSchemaElementType)),
    group: propTypes$1.arrayOf(propTypes$1.shape(MetadataSchemaElementType))
  };
});
var StorageGroupType = lazyFunction(function () {
  return {
    storage: propTypes$1.arrayOf(propTypes$1.shape(StorageType)),
    data: propTypes$1.arrayOf(propTypes$1.shape({
      value: propTypes$1.string.isRequired,
      key: propTypes$1.string.isRequired
    })),
    name: propTypes$1.string
  };
});
var ClipType = lazyFunction(function () {
  return {
    track: propTypes$1.number,
    subClip: propTypes$1.arrayOf(propTypes$1.shape(SubClipType)),
    uri: propTypes$1.string,
    stream: propTypes$1.number,
    id: propTypes$1.string
  };
});
var NotificationItemTriggerType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationTriggerType));
});
var MetadataFieldStringType = lazyFunction(function () {
  return {
    minLength: propTypes$1.number,
    pattern: propTypes$1.string,
    maxLength: propTypes$1.number
  };
});
var ComplexJobOTIFType = lazyFunction(function () {
  return {
    resource: propTypes$1.arrayOf(propTypes$1.shape(NameURIPairType)),
    bulkyMetadataURI: propTypes$1.string,
    versionMajor: propTypes$1.number.isRequired,
    versionPatch: propTypes$1.number.isRequired,
    versionMinor: propTypes$1.number.isRequired,
    trackerPlugin: propTypes$1.string.isRequired,
    configuration: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType))
  };
});
var NotFoundExceptionType = lazyFunction(function () {
  return {
    type: propTypes$1.string,
    id: propTypes$1.string,
    context: propTypes$1.string
  };
});
var CollectionReorderType = lazyFunction(function () {
  return {
    item: propTypes$1.arrayOf(propTypes$1.shape(CollectionReorderEntryType)),
    library: propTypes$1.arrayOf(propTypes$1.shape(CollectionReorderEntryType)),
    collection: propTypes$1.arrayOf(propTypes$1.shape(CollectionReorderEntryType))
  };
});
var LDAPResourceType = lazyFunction(function () {
  return {
    useStartTLS: propTypes$1.bool.isRequired,
    groupSearchFilter: propTypes$1.string,
    bindPassword: propTypes$1.string,
    bindDN: propTypes$1.string,
    url: propTypes$1.arrayOf(propTypes$1.string),
    "import": propTypes$1.shape(LDAPImportType),
    groupnameAttribute: propTypes$1.string,
    usernameFormat: propTypes$1.string,
    userDN: propTypes$1.string.isRequired,
    sync: LDAPSyncType,
    realNameAttribute: propTypes$1.string,
    userSearchFilter: propTypes$1.string,
    usernameAttribute: propTypes$1.string.isRequired,
    groupDN: propTypes$1.string,
    cacheLifetime: propTypes$1.number
  };
});
var TimelineJobRequestType = lazyFunction(function () {
  return {
    stream: propTypes$1.arrayOf(propTypes$1.shape({
      input: propTypes$1.arrayOf(propTypes$1.shape({
        interval: propTypes$1.shape(TimeIntervalType).isRequired,
        uri: propTypes$1.string.isRequired,
        stream: propTypes$1.number.isRequired
      }))
    })),
    outputUri: propTypes$1.string.isRequired,
    containerFormat: propTypes$1.string.isRequired
  };
});
var MetadataLockType = lazyFunction(function () {
  return {
    field: propTypes$1.arrayOf(propTypes$1.string),
    expires: propTypes$1.string.isRequired,
    id: propTypes$1.string.isRequired,
    user: propTypes$1.string.isRequired
  };
});
var BulkyMetadataPairType = lazyFunction(function () {
  return {
    itemTrack: propTypes$1.string,
    end: propTypes$1.string,
    stream: propTypes$1.number,
    start: propTypes$1.string,
    value: propTypes$1.string,
    maps: propTypes$1.shape(BulkyMapListType),
    key: propTypes$1.string.isRequired,
    channel: propTypes$1.number
  };
});
var ComplexJobSubtitleOutputType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(ComplexJobOutputType));
});
var MOVIndexJobType = lazyFunction(function () {
  return {
    source: propTypes$1.arrayOf(propTypes$1.shape({
      absoluteAlias: propTypes$1.string,
      alias: propTypes$1.string,
      setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
      uri: propTypes$1.string.isRequired
    })),
    targetUri: propTypes$1.string.isRequired
  };
});
var PartialFileDVDescriptorType = lazyFunction(function () {
  return {
    frameSize: propTypes$1.number.isRequired,
    frameCount: propTypes$1.number.isRequired
  };
});
var NotificationJavaScriptActionType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationActionType), propTypes$1.shape({
    script: propTypes$1.string.isRequired
  }));
});
var MetadataType = lazyFunction(function () {
  return {
    timespan: propTypes$1.arrayOf(propTypes$1.shape({
      field: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldValueType)),
      end: propTypes$1.string,
      group: propTypes$1.arrayOf(propTypes$1.shape(MetadataGroupValueType)),
      base: propTypes$1.string,
      start: propTypes$1.string
    })),
    group: propTypes$1.arrayOf(propTypes$1.string),
    template: propTypes$1.string,
    revision: propTypes$1.string
  };
});
var VXAStorageType = lazyFunction(function () {
  return {
    path: propTypes$1.string.isRequired,
    createProxiesStorage: propTypes$1.string,
    isCollectionStorage: propTypes$1.string,
    name: propTypes$1.string.isRequired,
    id: propTypes$1.string.isRequired
  };
});
var AnalyzeJobType = lazyFunction(function () {
  return {
    bars: propTypes$1.shape({
      threshold: propTypes$1.number.isRequired,
      percentage: propTypes$1.number.isRequired
    }),
    freeze: propTypes$1.shape({
      threshold: propTypes$1.number.isRequired,
      time: propTypes$1.number.isRequired
    }),
    video: propTypes$1.shape(AnalyzeVideoJobType),
    black: propTypes$1.shape({
      threshold: propTypes$1.number.isRequired,
      percentage: propTypes$1.number.isRequired
    }),
    audio: propTypes$1.shape(AnalyzeAudioJobType),
    channel: propTypes$1.arrayOf(propTypes$1.shape(AnalyzeAudioChannelType))
  };
});
var MXFServerResourceType = lazyFunction(function () {
  return {
    importShapes: propTypes$1.string,
    databaseName: propTypes$1.string.isRequired,
    url: propTypes$1.string.isRequired,
    description: propTypes$1.string,
    mxfServerUserId: propTypes$1.number.isRequired,
    enforceQuota: propTypes$1.bool,
    fileImportPattern: propTypes$1.string,
    mxfServerPathToStorage: propTypes$1.string.isRequired,
    atomShapes: propTypes$1.string,
    userWorkspaceUrl: propTypes$1.string.isRequired,
    storageId: propTypes$1.string.isRequired,
    mxfServerWorkspacePath: propTypes$1.string.isRequired,
    detectAtom: propTypes$1.bool,
    workspaceUrl: propTypes$1.string.isRequired,
    metadata: propTypes$1.shape(SimpleMetadataType)
  };
});
var JobRequestChoiceType = lazyFunction(function () {
  return {
    hashRequest: propTypes$1.shape(HashJobType),
    shapeDeductionRequest: propTypes$1.shape(ShapeDeductionJobType),
    transferRequest: propTypes$1.shape(TransferJobType),
    xmpRequest: propTypes$1.shape(XMPJobType),
    queueRequest: propTypes$1.shape(QueueJobType),
    timelineRequest: propTypes$1.shape(TimelineJobRequestType),
    aafGeneratorRequest: propTypes$1.shape(AAFGeneratorJobType),
    movIndexRequest: propTypes$1.shape(MOVIndexJobType),
    mxfTimecodeExtractionRequest: propTypes$1.shape(MXFTimecodeExtractionJobType),
    mxfOp1bRequest: propTypes$1.shape(MXFOp1bJobType),
    durationRequest: propTypes$1.shape(DurationJobType),
    complexRequest: propTypes$1.shape(ComplexJobType),
    nleRequest: propTypes$1.shape(NLEJobType),
    segmentationRequest: propTypes$1.shape(SegmentationJobType)
  };
});
var AAFGeneratorJobType = lazyFunction(function () {
  return {
    xml: propTypes$1.string,
    aaf: propTypes$1.string
  };
});
var NLEJob2AudioOutputType = lazyFunction(function () {
  return propTypes$1.arrayOf(ComplexJobAudioOutputType, propTypes$1.shape({
    mix: propTypes$1.arrayOf(propTypes$1.shape(NLEJob2MixType)),
    uri: propTypes$1.string,
    sequence: propTypes$1.arrayOf(propTypes$1.number)
  }));
});
var XMPJobType = lazyFunction(function () {
  return {
    read: propTypes$1.arrayOf(propTypes$1.shape(XMPReadOperation)),
    write: propTypes$1.arrayOf(propTypes$1.shape(XMPWriteOperation))
  };
});
var MetadataValueType = lazyFunction(function () {
  return {
    lang: propTypes$1.string,
    id: propTypes$1.string,
    value: propTypes$1.string
  };
});
var FacetCountType = lazyFunction(function () {
  return {
    fieldValue: propTypes$1.string.isRequired,
    value: propTypes$1.number
  };
});
var AnalyzeAudioJobType = lazyFunction(function () {
  return {
    otif: propTypes$1.arrayOf(propTypes$1.shape(OtifPresetType))
  };
});
var CarbonPreset = lazyFunction(function () {
  return {
    videoCodec: propTypes$1.string.isRequired,
    name: propTypes$1.string.isRequired,
    description: propTypes$1.string.isRequired,
    GUID: propTypes$1.string.isRequired,
    displayAspectRatio: propTypes$1.shape(AspectRatioType).isRequired,
    audioCodec: propTypes$1.string.isRequired,
    containerFormat: propTypes$1.string.isRequired
  };
});
var SigniantType = lazyFunction(function () {
  return {
    url: propTypes$1.string.isRequired,
    username: propTypes$1.string.isRequired,
    password: propTypes$1.string.isRequired,
    tag: propTypes$1.string.isRequired,
    description: propTypes$1.string
  };
});
var TrackSegmentType = lazyFunction(function () {
  return {
    transition: propTypes$1.shape(NLEJobTransitionType),
    subClip: propTypes$1.number,
    effect: propTypes$1.arrayOf(propTypes$1.shape(EffectType)),
    fillerLength: propTypes$1.number
  };
});
var AuditLogType = lazyFunction(function () {
  return {
    count: propTypes$1.number,
    entry: propTypes$1.arrayOf(propTypes$1.shape(AuditLogEntryType))
  };
});
var StatsDRecieverType = lazyFunction(function () {
  return {
    prefix: propTypes$1.string,
    destination: propTypes$1.shape(AddressPortType).isRequired
  };
});
var TransitionType = lazyFunction(function () {
  return {
    reverse: propTypes$1.bool,
    transition: propTypes$1.string,
    horizRepeat: propTypes$1.number,
    vertRepeat: propTypes$1.number,
    duration: propTypes$1.shape(TimeCodeType).isRequired,
    endPercentage: propTypes$1.number,
    startPercentage: propTypes$1.number,
    border: propTypes$1.shape(BorderType),
    wipe: propTypes$1.number
  };
});
var CodecType = lazyFunction(function () {
  return {
    encode: propTypes$1.bool,
    decode: propTypes$1.bool,
    name: propTypes$1.string
  };
});
var MetadataFieldFloatType = lazyFunction(function () {
  return {
    maxInclusive: propTypes$1.number,
    minInclusive: propTypes$1.number
  };
});
var VidinetServiceType = lazyFunction(function () {
  return {
    endpoint: propTypes$1.string,
    name: propTypes$1.string,
    url: propTypes$1.string.isRequired,
    state: propTypes$1.string,
    scheme: propTypes$1.arrayOf(propTypes$1.string),
    type: propTypes$1.string.isRequired
  };
});
var EssenceVersionListType = lazyFunction(function () {
  return {
    version: propTypes$1.arrayOf(propTypes$1.shape({
      created: propTypes$1.string,
      id: propTypes$1.number.isRequired,
      uri: propTypes$1.string.isRequired
    }))
  };
});
var TransferType = lazyFunction(function () {
  return {
    priority: propTypes$1.string,
    state: propTypes$1.string,
    fileId: propTypes$1.string,
    name: propTypes$1.string,
    transferred: propTypes$1.number
  };
});
var JobLogEntryType = lazyFunction(function () {
  return {
    timestamp: propTypes$1.string,
    value: propTypes$1.string,
    level: propTypes$1.string
  };
});
var ExportLocationListType = lazyFunction(function () {
  return {
    exportLocation: propTypes$1.arrayOf(propTypes$1.shape(ExportLocationType))
  };
});
var ConfigurationPropertyListType = lazyFunction(function () {
  return {
    property: propTypes$1.arrayOf(propTypes$1.shape(ConfigurationPropertyType))
  };
});
var NLEJobAudioOutputType = lazyFunction(function () {
  return {
    codec: propTypes$1.string.isRequired,
    bitrate: propTypes$1.number,
    uri: propTypes$1.string,
    sequence: propTypes$1.arrayOf(propTypes$1.number)
  };
});
var StreamIntervalType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(TimeIntervalType));
});
var LockType = lazyFunction(function () {
  return {
    expires: propTypes$1.string.isRequired,
    id: propTypes$1.string.isRequired,
    user: propTypes$1.string.isRequired
  };
});
var MetadataFieldGroupListType = lazyFunction(function () {
  return {
    group: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldGroupType))
  };
});
var FileReferenceType = lazyFunction(function () {
  return {
    status: propTypes$1.string,
    path: propTypes$1.string,
    hash: propTypes$1.string,
    id: propTypes$1.string,
    file: propTypes$1.arrayOf(propTypes$1.shape(FileType))
  };
});
var AutoProjectionRuleType = lazyFunction(function () {
  return {
    inputFilters: propTypes$1.shape({
      inputFilter: propTypes$1.arrayOf(propTypes$1.oneOf(['oldMetadata', 'shapeDocument'])),
      bulkyMetadataKeysRegex: propTypes$1.string
    }),
    step: propTypes$1.arrayOf(propTypes$1.shape(AutoProjectionStepType)),
    triggers: propTypes$1.shape({
      trigger: propTypes$1.arrayOf(propTypes$1.oneOf(['shapeMetadata', 'itemMetadata', 'bulkyMetadata']))
    }),
    name: propTypes$1.string,
    description: propTypes$1.string
  };
});
var NLEJobOutputType = lazyFunction(function () {
  return {
    uri: propTypes$1.string,
    video: propTypes$1.arrayOf(propTypes$1.shape(NLEJobVideoOutputType)),
    containerFormat: propTypes$1.string.isRequired,
    audio: propTypes$1.arrayOf(propTypes$1.shape(NLEJobAudioOutputType)),
    umid: propTypes$1.string,
    clipName: propTypes$1.string
  };
});
var TransferLogListType = lazyFunction(function () {
  return {
    count: propTypes$1.number,
    transferLogEntry: propTypes$1.arrayOf(propTypes$1.shape(TransferLogEntryType))
  };
});
var ConformDestinationType = lazyFunction(function () {
  return {
    interval: propTypes$1.shape(ConformIntervalType).isRequired
  };
});
var MetadataFieldType = lazyFunction(function () {
  return {
    origin: propTypes$1.string,
    index: propTypes$1.oneOf(['noindex', 'index', 'extend']),
    fullText: propTypes$1.bool,
    floatRestriction: propTypes$1.shape(MetadataFieldFloatType),
    name: propTypes$1.string,
    constraint: propTypes$1.shape({
      parent: propTypes$1.string,
      levelProperty: propTypes$1.string.isRequired,
      value: propTypes$1.string.isRequired,
      dataset: propTypes$1.string.isRequired,
      validationGroup: propTypes$1.string,
      levelValue: propTypes$1.string.isRequired
    }),
    data: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    defaultValue: propTypes$1.string,
    inheritance: propTypes$1.string,
    caseSensitiveSorting: propTypes$1.bool,
    system: propTypes$1.string,
    longRestriction: propTypes$1.shape(MetadataFieldLongType),
    boost: propTypes$1.number,
    values: propTypes$1.shape(SimpleMetadataType),
    sortable: propTypes$1.bool,
    integerRestriction: propTypes$1.shape(MetadataFieldIntegerType),
    externalId: propTypes$1.arrayOf(propTypes$1.string),
    type: propTypes$1.oneOf(['date', 'date-noindex', 'date-sortable', 'float', 'float-noindex', 'float-sortable', 'integer', 'integer-noindex', 'integer-sortable', 'long', 'long-noindex', 'string', 'string-sortable', 'string-exact', 'string-exact-sortable', 'string-noindex', 'boolean', 'boolean-noindex', 'timeCode', 'timeCode-noindex']),
    stringRestriction: propTypes$1.shape(MetadataFieldStringType),
    schema: propTypes$1.shape(MetadataSchemaElementType)
  };
});
var NotificationGroupTriggerType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationTriggerType));
});
var FtpPoolConfigurationType = lazyFunction(function () {
  return {
    pool: propTypes$1.shape(ConnectionPoolType)
  };
});
var SlaveLicenseListType = lazyFunction(function () {
  return {
    slaveLicense: propTypes$1.arrayOf(propTypes$1.shape(SlaveLicenseType))
  };
});
var SearchResultType = lazyFunction(function () {
  return {
    facet: propTypes$1.arrayOf(propTypes$1.shape(FacetType)),
    hits: propTypes$1.number,
    autocomplete: propTypes$1.arrayOf(propTypes$1.shape(AutocompleteResponseType)),
    nextCursor: propTypes$1.string,
    suggestion: propTypes$1.arrayOf(propTypes$1.shape(SuggestionResultType)),
    entry: propTypes$1.arrayOf(propTypes$1.shape(SearchResultEntryType))
  };
});
var HashJobType = lazyFunction(function () {
  return {
    compute: propTypes$1.arrayOf(propTypes$1.shape(HashComputeOperation))
  };
});
var PackageType = lazyFunction(function () {
  return {
    timestamp: propTypes$1.shape(MXFTimestampType).isRequired,
    umid: propTypes$1.string.isRequired
  };
});
var ComponentListType = lazyFunction(function () {
  return {
    component: propTypes$1.arrayOf(propTypes$1.shape(ComponentType))
  };
});
var AccessControlMergedGroupType = lazyFunction(function () {
  return {
    access: propTypes$1.arrayOf(propTypes$1.shape({
      rank: propTypes$1.number,
      group: propTypes$1.string.isRequired,
      permission: propTypes$1.string.isRequired,
      extradata: propTypes$1.string,
      effectivePermission: propTypes$1.string,
      collection: propTypes$1.string,
      id: propTypes$1.string,
      grantor: propTypes$1.string,
      type: propTypes$1.string.isRequired,
      originalDisabledGrantor: propTypes$1.arrayOf(propTypes$1.string),
      library: propTypes$1.string
    }))
  };
});
var IndexingConfigurationType = lazyFunction(function () {
  return {
    fieldDefault: propTypes$1.arrayOf(propTypes$1.shape({
      fullText: propTypes$1.bool.isRequired,
      name: propTypes$1.string.isRequired
    })),
    autoSoftCommit: propTypes$1.bool,
    queryTimeout: propTypes$1.number,
    softCommitInterval: propTypes$1.number,
    pingTimeout: propTypes$1.number,
    commitInterval: propTypes$1.number,
    pingAttempts: propTypes$1.number
  };
});
var VideoMediaInfoType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(BaseMediaInfoType), propTypes$1.shape({
    Format_Settings_GOP: propTypes$1.string,
    intra_dc_precision: propTypes$1.number
  }));
});
var FileMappingType = lazyFunction(function () {
  return {
    path: propTypes$1.string,
    hash: propTypes$1.string,
    id: propTypes$1.string,
    timestamp: propTypes$1.string,
    size: propTypes$1.number
  };
});
var EidrType = lazyFunction(function () {
  return {
    url: propTypes$1.string.isRequired,
    userId: propTypes$1.string,
    password: propTypes$1.string,
    include: propTypes$1.arrayOf(propTypes$1.string),
    partyId: propTypes$1.string
  };
});
var FrameRateType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(RationalType));
});
var CollectionType = lazyFunction(function () {
  return {
    absoluteTime: propTypes$1.bool,
    loc: propTypes$1.string,
    'merged-access': propTypes$1.shape(AccessControlMergedType),
    name: propTypes$1.string,
    project: propTypes$1.shape(ProjectType),
    sequence: propTypes$1.arrayOf(propTypes$1.shape(SequenceType)),
    terse: propTypes$1.shape({
      undefined: undefined
    }),
    content: propTypes$1.arrayOf(propTypes$1.shape(CollectionContentType)),
    externalId: propTypes$1.arrayOf(propTypes$1.shape(ExternalIdentifierType)),
    id: propTypes$1.string,
    metadata: propTypes$1.shape(MetadataType)
  };
});
var CerifyType = lazyFunction(function () {
  return {
    cleanup: propTypes$1.bool,
    mediaLocation: propTypes$1.arrayOf(propTypes$1.shape({
      storageMethod: propTypes$1.arrayOf(propTypes$1.string),
      name: propTypes$1.string.isRequired
    })),
    address: propTypes$1.string.isRequired
  };
});
var SlaveLicenseType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(LicenseType), propTypes$1.shape({
    slaveIdentifier: propTypes$1.string,
    masterIdentifier: propTypes$1.string,
    slaveInstances: propTypes$1.number,
    validityTime: propTypes$1.string,
    id: propTypes$1.string,
    validityPeriod: propTypes$1.number
  }));
});
var FinalCutServerType = lazyFunction(function () {
  return {
    url: propTypes$1.string.isRequired,
    state: propTypes$1.string,
    tag: propTypes$1.string.isRequired,
    description: propTypes$1.string,
    metadata: propTypes$1.shape(SimpleMetadataType)
  };
});
var ExternalIdentifierNamespaceType = lazyFunction(function () {
  return {
    priority: propTypes$1.number,
    pattern: propTypes$1.string.isRequired,
    name: propTypes$1.string
  };
});
var WaveformDataType = lazyFunction(function () {
  return {
    value: propTypes$1.arrayOf(propTypes$1.shape({
      itemTrack: propTypes$1.string,
      stream: propTypes$1.number,
      filePath: propTypes$1.arrayOf(propTypes$1.string),
      data: propTypes$1.arrayOf(propTypes$1.number),
      channel: propTypes$1.number,
      fileId: propTypes$1.arrayOf(propTypes$1.string)
    }))
  };
});
var ReindexRequestType = lazyFunction(function () {
  return {
    status: propTypes$1.string.isRequired,
    index: propTypes$1.string.isRequired,
    finish: propTypes$1.string,
    priority: propTypes$1.number.isRequired,
    start: propTypes$1.string,
    indexesDone: propTypes$1.number,
    indexesTotal: propTypes$1.number
  };
});
var SearchOperatorType = lazyFunction(function () {
  return {
    group: propTypes$1.arrayOf(propTypes$1.shape(SearchGroupType)),
    reference: propTypes$1.arrayOf(propTypes$1.string),
    field: propTypes$1.arrayOf(propTypes$1.shape(SearchFieldType)),
    text: propTypes$1.arrayOf(propTypes$1.shape(ItemSearchTextValueType)),
    item: ItemCriterionType,
    shape: ShapeCriterionType,
    file: propTypes$1.shape(CriterionType),
    operator: propTypes$1.arrayOf(propTypes$1.shape(SearchOperatorType)),
    operation: propTypes$1.oneOf(['AND', 'OR', 'NOT']).isRequired
  };
});
var ComponentType = lazyFunction(function () {
  return {
    id: propTypes$1.string,
    file: propTypes$1.arrayOf(propTypes$1.shape(FileType)),
    metadata: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType))
  };
});
var ExternalIdentifierNamespaceListType = lazyFunction(function () {
  return {
    namespace: propTypes$1.arrayOf(propTypes$1.shape(ExternalIdentifierNamespaceType))
  };
});
var AudioMediaInfoType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(BaseMediaInfoType));
});
var HashResponse = lazyFunction(function () {
  return {
    "function": propTypes$1.string.isRequired,
    error: propTypes$1.string,
    hash: propTypes$1.string,
    id: propTypes$1.string.isRequired,
    uri: propTypes$1.string.isRequired
  };
});
var ComplexJobMixType = lazyFunction(function () {
  return {
    gain: propTypes$1.number.isRequired,
    id: propTypes$1.number.isRequired,
    stream: propTypes$1.number.isRequired,
    channel: propTypes$1.number.isRequired
  };
});
var ComplexJobMixInputType = lazyFunction(function () {
  return {
    mix: propTypes$1.arrayOf(propTypes$1.shape(ComplexJobMixType))
  };
});
var PluginType = lazyFunction(function () {
  return {
    alias: propTypes$1.string.isRequired,
    fileName: propTypes$1.string.isRequired
  };
});
var ProjectType = lazyFunction(function () {
  return {
    name: propTypes$1.string,
    metadata: propTypes$1.shape(MetadataType)
  };
});
var MetadataFieldGroupPermissionType = lazyFunction(function () {
  return {
    username: propTypes$1.string.isRequired,
    field: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldPermissionType)),
    fieldGroup: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldGroupPermissionType)),
    name: propTypes$1.string.isRequired,
    permission: propTypes$1.string.isRequired
  };
});
var NotificationTriggerType = lazyFunction(function () {
  return {
    type: propTypes$1.string
  };
});
var ExportProblemType = lazyFunction(function () {
  return {
    parameter: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    message: propTypes$1.string.isRequired,
    type: propTypes$1.string.isRequired,
    asset: propTypes$1.string
  };
});
var AudioTranscodePresetType = lazyFunction(function () {
  return {
    otif: propTypes$1.shape(OtifPresetType),
    stream: propTypes$1.arrayOf(propTypes$1.number),
    framerate: TimeBaseType,
    noAudio: propTypes$1.bool,
    preset: propTypes$1.arrayOf(propTypes$1.string),
    mix: propTypes$1.arrayOf(propTypes$1.shape(AudioTranscodePresetMixType)),
    codec: propTypes$1.string,
    allChannel: propTypes$1.bool,
    output: propTypes$1.arrayOf(propTypes$1.shape(AudioOutputType)),
    monoFile: propTypes$1.bool,
    bitrate: propTypes$1.number,
    setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    channel: propTypes$1.arrayOf(propTypes$1.number)
  };
});
var LibrarySettingsType = lazyFunction(function () {
  return {
    username: propTypes$1.string,
    updateMode: propTypes$1.string,
    updateFrequency: propTypes$1.number,
    lastUpdate: propTypes$1.string,
    query: propTypes$1.shape(ItemSearchType),
    id: propTypes$1.string,
    autoRefresh: propTypes$1.bool
  };
});
var StorageRuleType = lazyFunction(function () {
  return {
    group: propTypes$1.arrayOf(propTypes$1.string),
    precedence: propTypes$1.string,
    appliesTo: propTypes$1.shape({
      type: propTypes$1.string,
      id: propTypes$1.string
    }),
    storage: propTypes$1.arrayOf(propTypes$1.string),
    priority: propTypes$1.arrayOf(propTypes$1.shape({
      storagecriteriatype: propTypes$1.oneOf(['bandwidth', 'capacity']),
      level: propTypes$1.number.isRequired
    })),
    storageCount: propTypes$1.number,
    inherited: propTypes$1.bool,
    not: propTypes$1.shape({
      group: propTypes$1.arrayOf(propTypes$1.string),
      storage: propTypes$1.arrayOf(propTypes$1.string),
      any: propTypes$1.string
    }),
    id: propTypes$1.string,
    pool: propTypes$1.shape({
      group: propTypes$1.arrayOf(propTypes$1.string),
      storage: propTypes$1.arrayOf(propTypes$1.string)
    })
  };
});
var ConformSegmentType = lazyFunction(function () {
  return {
    source: propTypes$1.shape(ConformSourceType).isRequired,
    destination: propTypes$1.shape(ConformDestinationType)
  };
});
var AAFGeneratorResponse = lazyFunction(function () {
  return {
    xml: propTypes$1.string,
    aaf: propTypes$1.string
  };
});
var SiteRuleListType = lazyFunction(function () {
  return {
    siteRule: propTypes$1.arrayOf(propTypes$1.shape(SiteRuleType))
  };
});
var JobPriorityConfigurationType = lazyFunction(function () {
  return {
    job: propTypes$1.shape({
      type: propTypes$1.string,
      value: propTypes$1.string
    }).isRequired
  };
});
var ComplexJobAudioChannelSequenceInputType = lazyFunction(function () {
  return {
    input: propTypes$1.arrayOf(propTypes$1.shape(ComplexJobAudioChannelMapInputType))
  };
});
var StorageMappingType = lazyFunction(function () {
  return {
    path: propTypes$1.string.isRequired,
    id: propTypes$1.string.isRequired
  };
});
var ImportAccessControlListType = lazyFunction(function () {
  return {
    group: propTypes$1.arrayOf(propTypes$1.shape({
      name: propTypes$1.string.isRequired,
      permission: propTypes$1.string.isRequired
    }))
  };
});
var ThumbnailInfoType = lazyFunction(function () {
  return {
    timeCode: propTypes$1.shape(TimeCodeType).isRequired,
    uri: propTypes$1.string.isRequired
  };
});
var CORSConfigurationType = lazyFunction(function () {
  return {
    entry: propTypes$1.arrayOf(propTypes$1.shape(CORSConfigurationEntry))
  };
});
var EDLEntryType = lazyFunction(function () {
  return {
    start: propTypes$1.number.isRequired,
    length: propTypes$1.number.isRequired,
    mediaRate: propTypes$1.number.isRequired
  };
});
var SegmentationJobType = lazyFunction(function () {
  return {
    segmentUriPostfix: propTypes$1.string.isRequired,
    segmentLength: propTypes$1.shape(TimeCodeType).isRequired,
    playlistOutput: propTypes$1.string.isRequired,
    input: propTypes$1.string.isRequired,
    segmentUriPrefix: propTypes$1.string.isRequired,
    containerFormat: propTypes$1.string.isRequired
  };
});
var NLEJobType = lazyFunction(function () {
  return {
    sequence: propTypes$1.arrayOf(propTypes$1.shape(NLEJobSequenceType)),
    output2: propTypes$1.arrayOf(propTypes$1.shape(NLEJob2OutputType)),
    pauseFrame: propTypes$1.number,
    frameRate: FrameRateType.isRequired,
    audioClip: propTypes$1.arrayOf(propTypes$1.shape(AudioClipType)),
    videoClip: propTypes$1.arrayOf(propTypes$1.shape(VideoClipType)),
    height: propTypes$1.number.isRequired,
    width: propTypes$1.number.isRequired,
    dar: propTypes$1.shape(AspectRatioType).isRequired,
    output: propTypes$1.arrayOf(propTypes$1.shape(NLEJobOutputType)),
    sampleRate: propTypes$1.number.isRequired,
    subtitleClip: propTypes$1.arrayOf(propTypes$1.shape(SubtitleClipType))
  };
});
var MetadataEntryListType2 = lazyFunction(function () {
  return {
    entry: propTypes$1.arrayOf(propTypes$1.arrayOf(propTypes$1.shape(MetadataEntryType)))
  };
});
var EffectPointType = lazyFunction(function () {
  return {
    position: propTypes$1.number.isRequired,
    value: propTypes$1.number.isRequired
  };
});
var BulkyMapType = lazyFunction(function () {
  return {
    entry: propTypes$1.arrayOf(propTypes$1.shape(BulkyMapEntryType))
  };
});
var EssenceVersionType = lazyFunction(function () {
  return {
    shape: propTypes$1.arrayOf(propTypes$1.shape(ShapeType)),
    created: propTypes$1.string
  };
});
var MDObjectStrongReference = lazyFunction(function () {
  return propTypes$1.arrayOf(MDObjectNode);
});
var NotificationDeletionLockTriggerType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationTriggerType));
});
var PlaceholderImportRequestType = lazyFunction(function () {
  return {
    video: propTypes$1.arrayOf(propTypes$1.string),
    audio: propTypes$1.arrayOf(propTypes$1.string),
    container: propTypes$1.string,
    binary: propTypes$1.arrayOf(propTypes$1.string)
  };
});
var NotificationStorageTriggerType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationTriggerType));
});
var VideoComponentType = lazyFunction(function () {
  return propTypes$1.arrayOf(MediaComponentType, propTypes$1.shape({
    dropFrame: propTypes$1.bool,
    bitDepth: propTypes$1.number,
    colr_primaries: propTypes$1.number,
    displayYOffset: propTypes$1.shape(RationalType),
    displayWidth: propTypes$1.shape(RationalType),
    colorPrimaries: propTypes$1.string,
    averageFrameRate: TimeBaseType,
    bitsPerPixel: propTypes$1.number,
    pixelAspectRatio: propTypes$1.shape(AspectRatioType),
    startTimecode: propTypes$1.number,
    realBaseFrameRate: TimeBaseType,
    fieldOrder: propTypes$1.string,
    displayXOffset: propTypes$1.shape(RationalType),
    colr_matrix: propTypes$1.number,
    mediaInfo: VideoMediaInfoType,
    pixelFormat: propTypes$1.string,
    codecTimeBase: TimeBaseType,
    max_packet_size: propTypes$1.number,
    ticks_per_frame: propTypes$1.number,
    maxBFrames: propTypes$1.number,
    containerSAR: propTypes$1.shape(AspectRatioType),
    videoStandard: propTypes$1.shape({
      type: propTypes$1.string.isRequired,
      value: propTypes$1.string
    }),
    colr_transfer_function: propTypes$1.number,
    displayHeight: propTypes$1.shape(RationalType),
    resolution: propTypes$1.shape(ResolutionType)
  }));
});
var ComplexJobInputType = lazyFunction(function () {
  return {
    transition: propTypes$1.shape(TransitionType),
    setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    id: propTypes$1.number.isRequired,
    stream: propTypes$1.number.isRequired
  };
});
var SearchFilterType = lazyFunction(function () {
  return {
    group: propTypes$1.arrayOf(propTypes$1.shape(SearchGroupType)),
    name: propTypes$1.string,
    reference: propTypes$1.arrayOf(propTypes$1.string),
    item: ItemCriterionType,
    field: propTypes$1.arrayOf(propTypes$1.shape(SearchFieldType)),
    shape: ShapeCriterionType,
    file: propTypes$1.shape(CriterionType),
    operator: propTypes$1.arrayOf(propTypes$1.shape(SearchOperatorType)),
    operation: propTypes$1.oneOf(['AND', 'OR', 'NOT'])
  };
});
var MetadataFieldIntegerType = lazyFunction(function () {
  return {
    maxInclusive: propTypes$1.number,
    minInclusive: propTypes$1.number
  };
});
var FilePrefixType = lazyFunction(function () {
  return {
    prefix: propTypes$1.arrayOf(propTypes$1.string)
  };
});
var MetadataSchemaMoveOperationType = lazyFunction(function () {
  return {
    to: propTypes$1.shape(MetadataSchemaHierarchyType).isRequired,
    from: propTypes$1.shape(MetadataSchemaHierarchyType).isRequired,
    type: propTypes$1.string
  };
});
var NotificationEjbActionType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationActionType), propTypes$1.shape({
    bean: propTypes$1.string.isRequired,
    data: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    method: propTypes$1.string.isRequired
  }));
});
var AuditLogEntryType = lazyFunction(function () {
  return {
    username: propTypes$1.string.isRequired,
    body: propTypes$1.string,
    contentType: propTypes$1.string,
    timestamp: propTypes$1.string.isRequired,
    runAs: propTypes$1.string,
    matrixParameters: propTypes$1.string.isRequired,
    contentLength: propTypes$1.string,
    responseCode: propTypes$1.number,
    queryParameters: propTypes$1.string.isRequired,
    path: propTypes$1.string.isRequired,
    method: propTypes$1.string.isRequired
  };
});
var FilenameFilterType = lazyFunction(function () {
  return {
    pattern: propTypes$1.string.isRequired,
    tag: propTypes$1.arrayOf(propTypes$1.string)
  };
});
var TapePackageTrackType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(PackageTrackType), propTypes$1.shape({
    trackID: propTypes$1.number.isRequired
  }));
});
var MetadataSchemaElementType = lazyFunction(function () {
  return {
    reference: propTypes$1.bool
  };
});
var CostEstimateType = lazyFunction(function () {
  return {
    url: propTypes$1.string,
    state: propTypes$1.string,
    id: propTypes$1.string,
    service: propTypes$1.arrayOf(propTypes$1.shape({
      status: propTypes$1.string,
      resource: propTypes$1.string.isRequired,
      name: propTypes$1.string,
      state: propTypes$1.string,
      cost: propTypes$1.shape(AmountType),
      message: propTypes$1.string,
      type: propTypes$1.string
    }))
  };
});
var AspectRatioType = lazyFunction(function () {
  return {
    horizontal: propTypes$1.number.isRequired,
    vertical: propTypes$1.number.isRequired
  };
});
var HashComputeOperation = lazyFunction(function () {
  return {
    "function": propTypes$1.string,
    setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    id: propTypes$1.string,
    uri: propTypes$1.string.isRequired
  };
});
var FileSearchType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(ItemSearchType));
});
var ExternalTranscoderType = lazyFunction(function () {
  return {
    regex: propTypes$1.string.isRequired,
    interval: propTypes$1.number,
    destination: propTypes$1.string.isRequired,
    source: propTypes$1.string.isRequired,
    timeout: propTypes$1.number,
    shapeTag: propTypes$1.string.isRequired,
    checks: propTypes$1.number
  };
});
var TaskGroupType = lazyFunction(function () {
  return {
    loc: propTypes$1.string,
    name: propTypes$1.string.isRequired,
    transcoder: propTypes$1.arrayOf(propTypes$1.shape({
      id: propTypes$1.string.isRequired
    })),
    priority: propTypes$1.string,
    job: propTypes$1.arrayOf(propTypes$1.shape({
      priority: propTypes$1.arrayOf(propTypes$1.string),
      group: propTypes$1.arrayOf(propTypes$1.string),
      type: propTypes$1.arrayOf(propTypes$1.string),
      user: propTypes$1.arrayOf(propTypes$1.string),
      data: propTypes$1.arrayOf(propTypes$1.shape({
        value: propTypes$1.string,
        key: propTypes$1.string.isRequired
      }))
    })),
    maxConcurrency: propTypes$1.number,
    metadata: propTypes$1.shape(SimpleMetadataType)
  };
});
var DurationType = lazyFunction(function () {
  return {
    duration: propTypes$1.shape(TimeCodeType).isRequired,
    stream: propTypes$1.arrayOf(propTypes$1.shape(StreamIntervalType))
  };
});
var SequenceTrackType = lazyFunction(function () {
  return {
    audio: propTypes$1.bool,
    segment: propTypes$1.arrayOf(propTypes$1.shape(SequenceMediaType)),
    transition: propTypes$1.arrayOf(propTypes$1.shape(SequenceTransitionType))
  };
});
var MetadataFieldListType = lazyFunction(function () {
  return {
    access: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldAccessControlType)),
    field: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldType))
  };
});
var LicenseErrorType = lazyFunction(function () {
  return {
    licenseError: propTypes$1.string
  };
});
var NotificationQuotaTriggerType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationTriggerType));
});
var TapePackageType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(PackageType), propTypes$1.shape({
    track: propTypes$1.arrayOf(propTypes$1.shape(TapePackageTrackType))
  }));
});
var CriterionType = lazyFunction(function () {
  return {
    operator: propTypes$1.shape(SearchOperatorType),
    field: propTypes$1.arrayOf(propTypes$1.shape(SearchFieldType)),
    group: propTypes$1.arrayOf(propTypes$1.shape(SearchGroupType))
  };
});
var StorageGroupListType = lazyFunction(function () {
  return {
    group: propTypes$1.arrayOf(propTypes$1.shape(StorageGroupType))
  };
});
var TransferJobType = lazyFunction(function () {
  return {
    transfer: propTypes$1.arrayOf(propTypes$1.shape(TransferOperation))
  };
});
var NLEJob2MixTypeInput = lazyFunction(function () {
  return {
    gain: propTypes$1.number.isRequired,
    sequence: propTypes$1.number.isRequired
  };
});
var JobListType = lazyFunction(function () {
  return {
    facet: propTypes$1.arrayOf(propTypes$1.shape(FacetType)),
    notFound: propTypes$1.arrayOf(propTypes$1.shape(NotFoundExceptionType)),
    hits: propTypes$1.number,
    job: propTypes$1.arrayOf(propTypes$1.shape(JobType))
  };
});
var ComplexJobVideoOutputType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(ComplexJobOutputType), propTypes$1.shape({
    gopSize: propTypes$1.number,
    forceCFR: propTypes$1.bool,
    disableFrameDupDrop: propTypes$1.bool,
    displayYOffset: propTypes$1.shape(RationalType),
    displayWidth: propTypes$1.shape(RationalType),
    rcInitialBufferOccupancy: propTypes$1.number,
    detectFaces: propTypes$1.shape({
      faceDetectorPlugin: propTypes$1.string.isRequired,
      metadataUri: propTypes$1.string.isRequired
    }),
    maxBitrate: propTypes$1.number,
    generateThumbnails: propTypes$1.shape({
      minDelay: propTypes$1.shape(TimeCodeType),
      maxDelay: propTypes$1.shape(TimeCodeType),
      detectorPlugin: propTypes$1.string,
      bulkyMetadataURI: propTypes$1.string,
      uri: propTypes$1.arrayOf(propTypes$1.string),
      period: propTypes$1.shape(TimeCodeType),
      background: propTypes$1.string,
      resolution: propTypes$1.shape(ResolutionType)
    }),
    imageQuality: propTypes$1.number,
    stripParameterSets: propTypes$1.bool,
    overlay: propTypes$1.arrayOf(propTypes$1.shape(OverlayType)),
    addParameterSets: propTypes$1.bool,
    generatePosters: propTypes$1.shape({
      format: propTypes$1.string,
      uri: propTypes$1.arrayOf(propTypes$1.string),
      setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
      background: propTypes$1.string,
      timeCode: propTypes$1.arrayOf(propTypes$1.shape(TimeCodeType)),
      resolution: propTypes$1.shape(ResolutionType),
      smallPosters: propTypes$1.bool
    }),
    displayXOffset: propTypes$1.shape(RationalType),
    burnTimecode: propTypes$1.bool,
    scaling: propTypes$1.shape(ScalingType),
    pixelFormat: propTypes$1.string,
    parameterSets: propTypes$1.string,
    textOverlay: propTypes$1.arrayOf(propTypes$1.shape(TextOverlayType)),
    level: propTypes$1.number,
    maxBFrames: propTypes$1.number,
    containerSAR: propTypes$1.shape(AspectRatioType),
    colorSiting: propTypes$1.number,
    minBitrate: propTypes$1.number,
    rcBufferSize: propTypes$1.number,
    displayHeight: propTypes$1.shape(RationalType),
    resolution: propTypes$1.shape(ResolutionType)
  }));
});
var ItemSearchType = lazyFunction(function () {
  return {
    sort: propTypes$1.arrayOf(propTypes$1.shape({
      field: propTypes$1.string.isRequired,
      order: propTypes$1.oneOf(['ascending', 'descending']).isRequired
    })),
    facet: propTypes$1.arrayOf(propTypes$1.shape({
      count: propTypes$1.bool,
      name: propTypes$1.string,
      maxResults: propTypes$1.number,
      field: propTypes$1.string.isRequired,
      range: propTypes$1.arrayOf(propTypes$1.shape(FacetRangeType)),
      exclude: propTypes$1.arrayOf(propTypes$1.string),
      minCount: propTypes$1.number
    })),
    group: propTypes$1.arrayOf(propTypes$1.shape(SearchGroupType)),
    suggestion: propTypes$1.shape(SuggestionSearchType),
    reference: propTypes$1.arrayOf(propTypes$1.string),
    item: propTypes$1.shape(ItemCriterionType),
    facetFilter: propTypes$1.arrayOf(propTypes$1.shape({
      field: propTypes$1.string.isRequired,
      range: propTypes$1.shape(FacetRangeType),
      value: propTypes$1.string
    })),
    text: propTypes$1.arrayOf(propTypes$1.shape(ItemSearchTextValueType)),
    version: propTypes$1.number,
    filter: propTypes$1.arrayOf(propTypes$1.shape(SearchFilterType)),
    field: propTypes$1.arrayOf(propTypes$1.shape(SearchFieldType)),
    shape: propTypes$1.shape(ShapeCriterionType),
    intervals: propTypes$1.oneOf(['all', 'generic', 'timed']),
    cursor: propTypes$1.string,
    file: propTypes$1.shape(CriterionType),
    operator: propTypes$1.shape(SearchOperatorType),
    highlight: propTypes$1.shape({
      field: propTypes$1.arrayOf(propTypes$1.string),
      prefix: propTypes$1.string,
      suffix: propTypes$1.string,
      matchingOnly: propTypes$1.bool
    }),
    autocomplete: propTypes$1.arrayOf(propTypes$1.shape(AutocompleteRequestType))
  };
});
var ItemType = lazyFunction(function () {
  return {
    files: propTypes$1.shape(URIListType),
    'merged-access': propTypes$1.shape(AccessControlMergedType),
    end: propTypes$1.string,
    thumbnails: propTypes$1.shape(URIListType),
    timespan: propTypes$1.arrayOf(propTypes$1.shape({
      field: propTypes$1.arrayOf(propTypes$1.shape({
        name: propTypes$1.string.isRequired,
        value: propTypes$1.arrayOf(propTypes$1.string)
      })),
      end: propTypes$1.string.isRequired,
      start: propTypes$1.string.isRequired
    })),
    terse: propTypes$1.shape({
      undefined: undefined
    }),
    access: propTypes$1.arrayOf(propTypes$1.shape({
      type: propTypes$1.string.isRequired,
      permission: propTypes$1.string.isRequired
    })),
    start: propTypes$1.string,
    shape: propTypes$1.arrayOf(propTypes$1.shape(ShapeType)),
    base: propTypes$1.string,
    externalId: propTypes$1.arrayOf(propTypes$1.shape(ExternalIdentifierType)),
    posters: propTypes$1.shape(URIListType),
    id: propTypes$1.string,
    metadata: propTypes$1.shape(MetadataType)
  };
});
var MetadataSchemaDeleteOperationType = lazyFunction(function () {
  return {
    type: propTypes$1.string,
    target: propTypes$1.shape(MetadataSchemaHierarchyType).isRequired
  };
});
var MDObjectLeaf = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(MDObjectBase), propTypes$1.shape({
    stringValue: propTypes$1.string,
    hexValue: propTypes$1.string
  }));
});
var ConfigurationPropertyType = lazyFunction(function () {
  return {
    lastChange: propTypes$1.string,
    value: propTypes$1.string,
    key: propTypes$1.string.isRequired
  };
});
var ExternalIdentifierListType = lazyFunction(function () {
  return {
    id: propTypes$1.arrayOf(propTypes$1.shape(ExternalIdentifierType))
  };
});
var SiteDefinitionType = lazyFunction(function () {
  return {
    url: propTypes$1.string.isRequired,
    username: propTypes$1.string.isRequired,
    password: propTypes$1.string.isRequired,
    syncPolicy: propTypes$1.oneOf(['ONDEMAND', 'ALWAYS']).isRequired
  };
});
var UserType = lazyFunction(function () {
  return {
    userName: propTypes$1.string.isRequired,
    loc: propTypes$1.string,
    realName: propTypes$1.string,
    accessPreserved: propTypes$1.bool,
    remove: propTypes$1.bool,
    groupList: propTypes$1.shape(GroupListType),
    disabled: propTypes$1.bool,
    alias: propTypes$1.arrayOf(propTypes$1.string),
    password: propTypes$1.string,
    salt: propTypes$1.string,
    id: propTypes$1.string,
    origin: propTypes$1.string,
    metadata: propTypes$1.shape(SimpleMetadataType)
  };
});
var CodecStatusType = lazyFunction(function () {
  return {
    codec: propTypes$1.arrayOf(propTypes$1.shape(CodecType)),
    codecExtraTags: propTypes$1.string
  };
});
var MetadataFieldLongType = lazyFunction(function () {
  return {
    maxInclusive: propTypes$1.number,
    minInclusive: propTypes$1.number
  };
});
var FileSequestionDefinitionType = lazyFunction(function () {
  return {
    regex: propTypes$1.string.isRequired,
    numGroup: propTypes$1.number.isRequired,
    idGroup: propTypes$1.number.isRequired,
    timeout: propTypes$1.number.isRequired,
    numFormat: propTypes$1.string
  };
});
var NLEJob2MixType = lazyFunction(function () {
  return {
    input: propTypes$1.arrayOf(propTypes$1.shape(NLEJob2MixTypeInput))
  };
});
var SearchHistoryType = lazyFunction(function () {
  return {
    timestamp: propTypes$1.string.isRequired,
    user: propTypes$1.string.isRequired,
    query: propTypes$1.shape(ItemSearchType).isRequired
  };
});
var VideoTranscodePresetType = lazyFunction(function () {
  return {
    gopSize: propTypes$1.number,
    forceCFR: propTypes$1.bool,
    displayYOffset: propTypes$1.shape(RationalType),
    displayWidth: propTypes$1.shape(RationalType),
    noVideo: propTypes$1.bool,
    otif: propTypes$1.shape(OtifPresetType),
    imageQuality: propTypes$1.number,
    stripParameterSets: propTypes$1.bool,
    addParameterSets: propTypes$1.bool,
    codec: propTypes$1.string,
    setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    burnSubtitles: propTypes$1.bool,
    profile: propTypes$1.arrayOf(propTypes$1.string),
    displayXOffset: propTypes$1.shape(RationalType),
    burnTimecode: propTypes$1.bool,
    scaling: propTypes$1.shape(ScalingType),
    pixelFormat: propTypes$1.string,
    preset: propTypes$1.arrayOf(propTypes$1.string),
    parameterSets: propTypes$1.string,
    bitrate: propTypes$1.number,
    maxBFrames: propTypes$1.number,
    containerSAR: propTypes$1.shape(AspectRatioType),
    framerate: TimeBaseType,
    displayHeight: propTypes$1.shape(RationalType),
    resolution: propTypes$1.shape(ResolutionType)
  };
});
var ScheduledRequestType = lazyFunction(function () {
  return {
    executed: propTypes$1.string,
    created: propTypes$1.string.isRequired,
    request: propTypes$1.shape({
      body: propTypes$1.string,
      uri: propTypes$1.string,
      method: propTypes$1.string
    }).isRequired,
    response: propTypes$1.shape({
      hasBody: propTypes$1.bool.isRequired,
      contentType: propTypes$1.string,
      statusCode: propTypes$1.number.isRequired
    }).isRequired,
    state: propTypes$1.string.isRequired,
    user: propTypes$1.string.isRequired,
    date: propTypes$1.string.isRequired,
    id: propTypes$1.number.isRequired
  };
});
var NotificationShapeTriggerType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationTriggerType));
});
var ExportResponseType = lazyFunction(function () {
  return {
    problem: propTypes$1.arrayOf(propTypes$1.shape(ExportProblemType)),
    mappings: propTypes$1.shape(EssenceMappingsType).isRequired
  };
});
var NotificationSQSActionType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationActionType), propTypes$1.shape({
    endpoint: propTypes$1.string.isRequired,
    contentType: propTypes$1.string,
    accessKey: propTypes$1.string,
    queue: propTypes$1.string.isRequired,
    secret: propTypes$1.string,
    messageGroupId: propTypes$1.string
  }));
});
var MetadataFieldAccessControlListType = lazyFunction(function () {
  return {
    access: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldAccessControlType))
  };
});
var ConformType = lazyFunction(function () {
  return {
    textOverlay: propTypes$1.arrayOf(propTypes$1.shape(TextOverlayType)),
    timeline: propTypes$1.shape(ConformTimelineType).isRequired,
    timeBase: TimeBaseType,
    overlay: propTypes$1.arrayOf(propTypes$1.shape(ConformOverlayType))
  };
});
var MetadataSchemaType = lazyFunction(function () {
  return {
    group: propTypes$1.arrayOf(propTypes$1.shape(MetadataSchemaGroupType))
  };
});
var StorageType = lazyFunction(function () {
  return {
    lowWatermark: propTypes$1.number,
    projection: propTypes$1.string,
    sequence: propTypes$1.arrayOf(propTypes$1.shape(StorageFileSequenceType)),
    sequenceTimeout: propTypes$1.number,
    bandwidth: propTypes$1.number,
    freeCapacity: propTypes$1.number,
    id: propTypes$1.string,
    capacity: propTypes$1.number,
    highWatermark: propTypes$1.number,
    autoDetect: propTypes$1.bool,
    highWatermarkPercentage: propTypes$1.number,
    priority: propTypes$1.string,
    state: propTypes$1.string,
    showImportables: propTypes$1.bool,
    type: propTypes$1.string,
    method: propTypes$1.arrayOf(propTypes$1.shape(StorageMethodType)),
    lowWatermarkPercentage: propTypes$1.number,
    metadata: propTypes$1.shape(SimpleMetadataType),
    timestamp: propTypes$1.string,
    scanInterval: propTypes$1.number,
    bean: propTypes$1.string,
    archiveScript: propTypes$1.string
  };
});
var DeletionLockType = lazyFunction(function () {
  return {
    isExpired: propTypes$1.bool,
    entityType: propTypes$1.string.isRequired,
    expiryTime: propTypes$1.string.isRequired,
    modified: propTypes$1.string.isRequired,
    isInherited: propTypes$1.bool,
    user: propTypes$1.string.isRequired,
    entityId: propTypes$1.string.isRequired,
    isEffective: propTypes$1.bool,
    id: propTypes$1.string.isRequired,
    metadata: propTypes$1.shape(SimpleMetadataType)
  };
});
var TaskDefinitionDependency = lazyFunction(function () {
  return {
    allPrevious: propTypes$1.bool,
    step: propTypes$1.number,
    previous: propTypes$1.bool
  };
});
var ConformTimePointType = lazyFunction(function () {
  return {
    timeBase: TimeBaseType,
    samples: propTypes$1.number.isRequired
  };
});
var EffectParameterType = lazyFunction(function () {
  return {
    name: propTypes$1.string.isRequired,
    value: propTypes$1.number,
    point: propTypes$1.arrayOf(propTypes$1.shape(EffectPointType))
  };
});
var SuggestionResultType = lazyFunction(function () {
  return {
    term: propTypes$1.string.isRequired,
    suggestion: propTypes$1.arrayOf(propTypes$1.string)
  };
});
var MDSegment = lazyFunction(function () {
  return {
    dms1Framework: MDObjectNode.isRequired,
    interval: propTypes$1.shape(TimeIntervalType).isRequired
  };
});
var LoudnessType = lazyFunction(function () {
  return {
    loudnessLU: propTypes$1.number,
    end: propTypes$1.string,
    mix: propTypes$1.arrayOf(propTypes$1.shape(LoudnessMixType)),
    startLoudness: propTypes$1.string,
    endLoudness: propTypes$1.string,
    start: propTypes$1.string,
    shape: propTypes$1.string,
    loudnessRangeLU: propTypes$1.number,
    startRange: propTypes$1.string,
    shapeTag: propTypes$1.string,
    id: propTypes$1.string,
    endRange: propTypes$1.string
  };
});
var QuotaRuleListType = lazyFunction(function () {
  return {
    rule: propTypes$1.arrayOf(propTypes$1.shape(QuotaRuleType))
  };
});
var ShapeCriterionType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(CriterionType), propTypes$1.shape({
    file: propTypes$1.shape(CriterionType)
  }));
});
var LicenseType = lazyFunction(function () {
  return {
    endCustomerCompanyContactEmail: propTypes$1.string,
    databaseSizeLimit: propTypes$1.shape(LicenseNumberType),
    resellerCompanyContactEmail: propTypes$1.string,
    licenseType: propTypes$1.string,
    licenseErrorStatus: propTypes$1.shape(LicenseErrorType),
    expiryDate: propTypes$1.string,
    itemNumber: propTypes$1.shape(LicenseNumberType),
    fileStatus: propTypes$1.string,
    macaddresses: propTypes$1.shape(SystemInfoType),
    licenseStatus: propTypes$1.string,
    endCustomerCompanyname: propTypes$1.string,
    storageNumber: propTypes$1.shape(LicenseNumberType),
    transcoderNumber: propTypes$1.shape(LicenseNumberType),
    userNumber: propTypes$1.shape(LicenseNumberType),
    resellerCompanyName: propTypes$1.string,
    codecStatus: propTypes$1.shape(CodecStatusType)
  };
});
var TranscoderConfigurationType = lazyFunction(function () {
  return {
    decoderOfferThreads: propTypes$1.number,
    logLevel: propTypes$1.string,
    dataPath: propTypes$1.string.isRequired,
    vp6EncoderPoolSize: propTypes$1.number,
    carbonServer: propTypes$1.arrayOf(propTypes$1.shape(AddressPortType)),
    apiUsername: propTypes$1.string.isRequired,
    dataBufferFlushTime: propTypes$1.number,
    redDecoderType: propTypes$1.oneOf(['CPU', 'CUDA', 'OPENCL']),
    tempPath: propTypes$1.string,
    logo: propTypes$1.string,
    port: propTypes$1.number.isRequired,
    vp6Encoder: propTypes$1.shape(AddressPortType),
    bilinearEffects: propTypes$1.bool.isRequired,
    thumbnailResolution: propTypes$1.shape(ResolutionType).isRequired,
    proresDecoder: propTypes$1.shape(AddressPortType),
    faceDetectorPlugin: propTypes$1.arrayOf(propTypes$1.shape(PluginType)),
    encoderThreads: propTypes$1.number,
    apiURL: propTypes$1.shape(AddressPortType),
    readBufferLength: propTypes$1.number,
    dataBufferWriteSize: propTypes$1.number,
    statsd: propTypes$1.arrayOf(propTypes$1.shape(StatsDRecieverType)),
    imagemagick: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    dataBufferSize: propTypes$1.number,
    carbonPreset: propTypes$1.arrayOf(propTypes$1.shape(CarbonPreset)),
    address: propTypes$1.string.isRequired,
    colorProfilePath: propTypes$1.arrayOf(propTypes$1.string),
    proresEncoder: propTypes$1.shape(AddressPortType),
    thumbnailPeriod: propTypes$1.shape(TimeCodeType),
    apiPassword: propTypes$1.string.isRequired,
    presetPath: propTypes$1.string.isRequired
  };
});
var NLEJobVideoOutputType = lazyFunction(function () {
  return {
    gopSize: propTypes$1.number,
    sequence: propTypes$1.number.isRequired,
    maxBFrames: propTypes$1.number,
    uri: propTypes$1.string,
    pixelFormat: propTypes$1.string,
    preset: propTypes$1.arrayOf(propTypes$1.string),
    bitrate: propTypes$1.number.isRequired,
    codec: propTypes$1.string.isRequired
  };
});
var JobStatusType = lazyFunction(function () {
  return {
    transferResponse: propTypes$1.arrayOf(propTypes$1.shape(TransferResponse)),
    estimatedTimeLeft: propTypes$1.number,
    isRunning: propTypes$1.bool.isRequired,
    log: propTypes$1.arrayOf(propTypes$1.shape(JobLogEntryType)),
    shapeDeductionResponse: propTypes$1.arrayOf(propTypes$1.shape(ShapeDeductionResponse)),
    inputProgress: propTypes$1.arrayOf(propTypes$1.shape(JobInputProgressType)),
    hashResponse: propTypes$1.arrayOf(propTypes$1.shape(HashResponse)),
    request: propTypes$1.shape(JobRequestChoiceType),
    aafGeneratorResponse: propTypes$1.arrayOf(propTypes$1.shape(AAFGeneratorResponse)),
    thumbnail: propTypes$1.arrayOf(propTypes$1.shape(ThumbnailInfoType)),
    statusUri: propTypes$1.string.isRequired,
    isPaused: propTypes$1.bool.isRequired,
    xmpResponse: propTypes$1.arrayOf(propTypes$1.shape(XMPResponse)),
    durationResponse: propTypes$1.arrayOf(propTypes$1.shape(DurationResponse)),
    progress: propTypes$1.number,
    message: propTypes$1.string,
    walltime: propTypes$1.number.isRequired,
    id: propTypes$1.string.isRequired,
    exitcode: propTypes$1.number
  };
});
var TransferOperation = lazyFunction(function () {
  return {
    destinationUri: propTypes$1.arrayOf(propTypes$1.string),
    setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    id: propTypes$1.string,
    sourceUri: propTypes$1.arrayOf(propTypes$1.string)
  };
});
var OtifPresetType = lazyFunction(function () {
  return {
    resource: propTypes$1.arrayOf(propTypes$1.shape(NameURIPairType)),
    uuid: propTypes$1.string.isRequired,
    versionMajor: propTypes$1.number.isRequired,
    versionPatch: propTypes$1.number.isRequired,
    versionMinor: propTypes$1.number.isRequired,
    configuration: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType))
  };
});
var EffectType = lazyFunction(function () {
  return {
    parameter: propTypes$1.arrayOf(propTypes$1.shape(EffectParameterType)),
    name: propTypes$1.string.isRequired
  };
});
var AssetMappingType = lazyFunction(function () {
  return {
    item: propTypes$1.string.isRequired,
    shape: propTypes$1.string,
    id: propTypes$1.string.isRequired
  };
});
var MetadataFieldPermissionType = lazyFunction(function () {
  return {
    username: propTypes$1.string.isRequired,
    name: propTypes$1.string.isRequired,
    permission: propTypes$1.string.isRequired
  };
});
var MetadataFieldValueConstraintType = lazyFunction(function () {
  return {
    field: propTypes$1.string,
    id: propTypes$1.string,
    value: propTypes$1.string
  };
});
var TranscoderType = lazyFunction(function () {
  return {
    reverseAddress: propTypes$1.string,
    weight: propTypes$1.number,
    reverseAddressDetected: propTypes$1.string,
    url: propTypes$1.string.isRequired,
    job: propTypes$1.arrayOf(propTypes$1.shape(JobStatusType)),
    transcoder: propTypes$1.arrayOf(propTypes$1.shape(TranscoderType)),
    state: propTypes$1.string,
    version: propTypes$1.string,
    directAccess: propTypes$1.arrayOf(propTypes$1.shape(TranscoderDirectAccess)),
    configuration: propTypes$1.shape(TranscoderConfigurationType),
    type: propTypes$1.oneOf(['TRANSCODER', 'DIRECTORY']),
    maxJob: propTypes$1.number
  };
});
var SequenceType = lazyFunction(function () {
  return {
    track: propTypes$1.arrayOf(propTypes$1.shape(SequenceTrackType)),
    id: propTypes$1.string
  };
});
var ShapeDeductionResponse = lazyFunction(function () {
  return {
    shape: propTypes$1.shape(ShapeType).isRequired,
    range: propTypes$1.arrayOf(propTypes$1.shape(SequenceRangeType)),
    id: propTypes$1.string.isRequired,
    uri: propTypes$1.string
  };
});
var LoudnessMixType = lazyFunction(function () {
  return {
    sourceItemTrack: propTypes$1.string,
    sourceChannel: propTypes$1.number,
    sourceStream: propTypes$1.number,
    name: propTypes$1.string,
    weightdB: propTypes$1.number
  };
});
var ConformSourceType = lazyFunction(function () {
  return {
    interval: propTypes$1.shape(ConformIntervalType),
    id: propTypes$1.string.isRequired
  };
});
var AutoProjectionStepType = lazyFunction(function () {
  return {
    script: propTypes$1.string,
    order: propTypes$1.number,
    xslt: propTypes$1.string,
    description: propTypes$1.string
  };
});
var NetworkType = lazyFunction(function () {
  return {
    netmask: propTypes$1.string.isRequired,
    bandwidth: propTypes$1.number
  };
});
var ConnectionPoolType = lazyFunction(function () {
  return {
    minSize: propTypes$1.number.isRequired,
    maxSize: propTypes$1.number,
    evictionInterval: propTypes$1.number,
    minIdleTime: propTypes$1.number
  };
});
var LogReportConfigurationType = lazyFunction(function () {
  return {
    certificate: propTypes$1.string,
    uploadUri: propTypes$1.string,
    clientCertificate: propTypes$1.arrayOf(propTypes$1.string),
    expiryTime: propTypes$1.number,
    path: propTypes$1.string,
    clientKey: propTypes$1.string
  };
});
var ShapeType = lazyFunction(function () {
  return {
    mimeType: propTypes$1.arrayOf(propTypes$1.string),
    videoComponent: propTypes$1.arrayOf(propTypes$1.shape(VideoComponentType)),
    uuid: propTypes$1.string,
    created: propTypes$1.string,
    audioComponent: propTypes$1.arrayOf(propTypes$1.shape(AudioComponentType)),
    descriptorComponent: propTypes$1.arrayOf(propTypes$1.shape(DescriptorComponentType)),
    essenceVersion: propTypes$1.number,
    binaryComponent: propTypes$1.arrayOf(propTypes$1.shape(BinaryComponentType)),
    subtitleComponent: propTypes$1.arrayOf(propTypes$1.shape(SubtitleComponentType)),
    item: propTypes$1.arrayOf(propTypes$1.shape({
      id: propTypes$1.string
    })),
    tag: propTypes$1.arrayOf(propTypes$1.string),
    containerComponent: ContainerComponentType,
    id: propTypes$1.string,
    metadata: propTypes$1.shape(SimpleMetadataType)
  };
});
var SlaveListType = lazyFunction(function () {
  return {
    slave: propTypes$1.arrayOf(propTypes$1.shape(SlaveType))
  };
});
var AddressPortType = lazyFunction(function () {
  return {
    host: propTypes$1.string,
    port: propTypes$1.number.isRequired,
    address: propTypes$1.string
  };
});
var KeyValueType = lazyFunction(function () {
  return {
    value: propTypes$1.string.isRequired,
    key: propTypes$1.string.isRequired
  };
});
var NameURIPairType = lazyFunction(function () {
  return {
    name: propTypes$1.string.isRequired,
    uri: propTypes$1.string.isRequired
  };
});
var TranscoderDirectAccess = lazyFunction(function () {
  return {
    filter: propTypes$1.string.isRequired,
    rewrite: propTypes$1.arrayOf(propTypes$1.shape({
      pattern: propTypes$1.string.isRequired,
      replacement: propTypes$1.string.isRequired
    }))
  };
});
var AutoImportRuleType = lazyFunction(function () {
  return {
    excludeFilter: propTypes$1.arrayOf(propTypes$1.shape(FilenameFilterType)),
    settingsId: propTypes$1.string,
    fileNameAsTitle: propTypes$1.bool,
    projection: propTypes$1.string,
    shapeTagFilter: propTypes$1.arrayOf(propTypes$1.shape(FilenameFilterType)),
    enabled: propTypes$1.bool,
    sequenceDefinition: propTypes$1.shape(SequenceDefinitionType),
    storage: propTypes$1.string,
    disabledSidecarExtensions: propTypes$1.arrayOf(propTypes$1.string),
    ignoreSidecarImport: propTypes$1.bool,
    priority: propTypes$1.string,
    jobmetadata: propTypes$1.shape(SimpleMetadataType),
    tag: propTypes$1.arrayOf(propTypes$1.string),
    user: propTypes$1.string,
    resourceId: propTypes$1.string,
    metadata: propTypes$1.shape(MetadataType)
  };
});
var LDAPImportType = lazyFunction(function () {
  return {
    interval: propTypes$1.number,
    importOrganizationalUnits: propTypes$1.bool
  };
});
var BaseMediaInfoType = lazyFunction(function () {
  return {
    Bit_rate_mode: propTypes$1.string,
    property: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    Source: propTypes$1.string
  };
});
var AccessControlMergedType = lazyFunction(function () {
  return {
    access: propTypes$1.arrayOf(propTypes$1.shape({
      username: propTypes$1.string,
      superUser: propTypes$1.bool,
      rank: propTypes$1.number.isRequired,
      group: propTypes$1.string,
      permission: propTypes$1.string.isRequired,
      matches: propTypes$1.bool,
      extradata: propTypes$1.string,
      effectivePermission: propTypes$1.string,
      collection: propTypes$1.string,
      id: propTypes$1.string,
      grantor: propTypes$1.string,
      type: propTypes$1.string.isRequired,
      originalDisabledGrantor: propTypes$1.arrayOf(propTypes$1.string),
      library: propTypes$1.string
    })),
    query: propTypes$1.shape({
      username: propTypes$1.string.isRequired,
      item: propTypes$1.string.isRequired,
      extradata: propTypes$1.string,
      type: propTypes$1.string.isRequired,
      permission: propTypes$1.string.isRequired
    }),
    field: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldPermissionType)),
    fieldGroup: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldGroupPermissionType))
  };
});
var SubtitleComponentType = lazyFunction(function () {
  return propTypes$1.arrayOf(MediaComponentType);
});
var StorageFileSequenceType = lazyFunction(function () {
  return {
    regex: propTypes$1.string.isRequired,
    numGroup: propTypes$1.number
  };
});
var ComplexJobAtomType = lazyFunction(function () {
  return {
    uri: propTypes$1.string.isRequired,
    sourcePackageID: propTypes$1.string
  };
});
var SelfTestType = lazyFunction(function () {
  return {
    status: propTypes$1.string.isRequired,
    name: propTypes$1.string,
    took: propTypes$1.string,
    test: propTypes$1.arrayOf(propTypes$1.shape(SelfTestType)),
    message: propTypes$1.arrayOf(propTypes$1.string),
    description: propTypes$1.string
  };
});
var NotificationHttpActionType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationActionType), propTypes$1.shape({
    url: propTypes$1.string.isRequired,
    contentType: propTypes$1.string,
    method: propTypes$1.string,
    timeout: propTypes$1.string.isRequired
  }));
});
var ItemCriterionType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(CriterionType), propTypes$1.shape({
    shape: ShapeCriterionType,
    file: propTypes$1.shape(CriterionType)
  }));
});
var BulkyMapEntryType = lazyFunction(function () {
  return {
    key: propTypes$1.string.isRequired,
    value: propTypes$1.string
  };
});
var ComplexJobOutputType = lazyFunction(function () {
  return {
    objectTracking: propTypes$1.shape(ComplexJobOTIFType),
    timeBase: TimeBaseType,
    codecTag: propTypes$1.number,
    codecName: propTypes$1.string,
    setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    edl: propTypes$1.shape(EDLType),
    codecTagString: propTypes$1.string,
    start: propTypes$1.shape(TimeCodeType),
    codec: propTypes$1.string,
    bitrate: propTypes$1.number,
    id: propTypes$1.arrayOf(propTypes$1.number),
    preset: propTypes$1.arrayOf(propTypes$1.string),
    metadata: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType))
  };
});
var ConstraintValueType = lazyFunction(function () {
  return {
    id: propTypes$1.string.isRequired,
    value: propTypes$1.string
  };
});
var StorageRulesType = lazyFunction(function () {
  return {
    "default": propTypes$1.shape(StorageRuleType),
    tag: propTypes$1.arrayOf(propTypes$1.shape(StorageRuleType))
  };
});
var SequenceMediaType = lazyFunction(function () {
  return {
    sourceIn: propTypes$1.shape(TimeCodeType),
    effect: propTypes$1.arrayOf(propTypes$1.shape(EffectType)),
    sourceTrack: propTypes$1.number.isRequired,
    item: propTypes$1.string.isRequired,
    "in": propTypes$1.shape(TimeCodeType),
    sourceOut: propTypes$1.shape(TimeCodeType),
    out: propTypes$1.shape(TimeCodeType)
  };
});
var ResourceType = lazyFunction(function () {
  return {
    vidinet: propTypes$1.shape(VidinetServiceType),
    externalTranscoder: propTypes$1.shape(ExternalTranscoderType),
    network: propTypes$1.shape(NetworkType),
    unknown: propTypes$1.string,
    cerify: propTypes$1.shape(CerifyType),
    mxfserver: propTypes$1.shape(MXFServerResourceType),
    transcoder: propTypes$1.shape(TranscoderType),
    cloudconvert: propTypes$1.shape(CloudConvertType),
    thumbnail: propTypes$1.shape(ThumbnailServiceType),
    state: propTypes$1.string,
    signiant: propTypes$1.shape(SigniantType),
    eidr: propTypes$1.shape(EidrType),
    ldap: propTypes$1.shape(LDAPResourceType),
    id: propTypes$1.string,
    finalcutserver: propTypes$1.shape(FinalCutServerType)
  };
});
var MetadataLockListType = lazyFunction(function () {
  return {
    lock: propTypes$1.arrayOf(propTypes$1.shape(MetadataLockType))
  };
});
var NotificationType = lazyFunction(function () {
  return {
    action: propTypes$1.shape({
      http: NotificationHttpActionType,
      sqs: NotificationSQSActionType,
      jms: NotificationJmsActionType,
      javascript: NotificationJavaScriptActionType,
      ejb: NotificationEjbActionType,
      sns: NotificationSNSActionType
    }).isRequired,
    trigger: propTypes$1.shape({
      group: NotificationGroupTriggerType,
      deletionLock: NotificationDeletionLockTriggerType,
      storage: NotificationStorageTriggerType,
      shape: NotificationShapeTriggerType,
      collection: NotificationCollectionTriggerType,
      quota: NotificationQuotaTriggerType,
      access: NotificationAccessTriggerType,
      item: NotificationItemTriggerType,
      job: NotificationJobTriggerType,
      file: NotificationFileTriggerType,
      document: NotificationDocumentTriggerType,
      metadata: NotificationMetadataTriggerType
    }).isRequired
  };
});
var KeyValuePairType = lazyFunction(function () {
  return {
    value: propTypes$1.string.isRequired,
    key: propTypes$1.string.isRequired
  };
});
var OverlayType = lazyFunction(function () {
  return {
    opacity: propTypes$1.number,
    interval: propTypes$1.shape(TimeIntervalType),
    uri: propTypes$1.arrayOf(propTypes$1.string),
    range: propTypes$1.arrayOf(propTypes$1.shape(SequenceRangeType)),
    y: propTypes$1.number.isRequired,
    x: propTypes$1.number.isRequired,
    id: propTypes$1.string
  };
});
var MetadataChangeSetType = lazyFunction(function () {
  return {
    changeSet: propTypes$1.arrayOf(propTypes$1.shape({
      id: propTypes$1.string.isRequired,
      metadata: propTypes$1.shape(MetadataType).isRequired
    }))
  };
});
var ProjectVersionType = lazyFunction(function () {
  return {
    item: propTypes$1.arrayOf(propTypes$1.shape({
      externalId: propTypes$1.string,
      id: propTypes$1.string,
      uri: propTypes$1.string
    })),
    metadata: propTypes$1.shape(MetadataType),
    id: propTypes$1.string,
    sequence: propTypes$1.arrayOf(propTypes$1.shape(SequenceType))
  };
});
var MetadataEntryType = lazyFunction(function () {
  return {
    field: propTypes$1.shape(MetadataFieldValueType),
    group: propTypes$1.shape(MetadataGroupValueType),
    value: propTypes$1.shape(MetadataValueType),
    source: propTypes$1.shape({
      loc: propTypes$1.string.isRequired,
      type: propTypes$1.string.isRequired,
      id: propTypes$1.string.isRequired
    })
  };
});
var FileListType = lazyFunction(function () {
  return {
    prefixes: propTypes$1.shape(FilePrefixType),
    hits: propTypes$1.number,
    nextCursor: propTypes$1.string,
    file: propTypes$1.arrayOf(propTypes$1.shape(FileType))
  };
});
var MetadataFieldResultType = lazyFunction(function () {
  return {
    hits: propTypes$1.number.isRequired,
    group: propTypes$1.arrayOf(propTypes$1.shape({
      definition: propTypes$1.shape(MetadataFieldGroupType),
      end: propTypes$1.string.isRequired,
      uuid: propTypes$1.string.isRequired,
      source: propTypes$1.shape({
        loc: propTypes$1.string.isRequired,
        type: propTypes$1.string.isRequired,
        id: propTypes$1.string.isRequired
      }).isRequired,
      value: propTypes$1.shape(MetadataGroupValueType),
      start: propTypes$1.string.isRequired,
      name: propTypes$1.string.isRequired
    }))
  };
});
var AccessControlShapeType = lazyFunction(function () {
  return {
    tag: propTypes$1.string
  };
});
var NotificationJobTriggerType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationTriggerType), propTypes$1.shape({
    create: propTypes$1.string,
    stop: propTypes$1.string,
    update: propTypes$1.string,
    filter: propTypes$1.shape({
      step: propTypes$1.number,
      type: propTypes$1.string,
      jobdata: propTypes$1.shape({
        'value-regex': propTypes$1.string,
        'key-regex': propTypes$1.string,
        value: propTypes$1.string,
        key: propTypes$1.string
      })
    }),
    finished: propTypes$1.string,
    fail: propTypes$1.string,
    contentFilters: propTypes$1.shape({
      contentFilter: propTypes$1.arrayOf(propTypes$1.oneOf(['jobId', 'jobState', 'user', 'startTime', 'jobType', 'jobData', 'errorMessage', 'itemId', 'totalSteps', 'currentStep']))
    }),
    placeholder: propTypes$1.bool
  }));
});
var AudioTranscodePresetChannelMixType = lazyFunction(function () {
  return {
    gain: propTypes$1.number,
    id: propTypes$1.number,
    stream: propTypes$1.number,
    channel: propTypes$1.number.isRequired
  };
});
var ConstraintValueListType = lazyFunction(function () {
  return {
    value: propTypes$1.arrayOf(propTypes$1.shape(ConstraintValueType))
  };
});
var NotificationMetadataTriggerType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationTriggerType));
});
var SearchResultEntryType = lazyFunction(function () {
  return {
    end: propTypes$1.string,
    start: propTypes$1.string,
    timespan: propTypes$1.arrayOf(propTypes$1.shape(SearchResultEntryTimespanType)),
    parent_type: propTypes$1.string,
    collection: propTypes$1.shape(CollectionType),
    item: propTypes$1.shape(ItemType),
    shape: propTypes$1.shape(ShapeType),
    base: propTypes$1.string,
    parent_id: propTypes$1.string,
    file: propTypes$1.shape(FileType),
    type: propTypes$1.string,
    id: propTypes$1.string
  };
});
var ComplexJobAnalyzeType = lazyFunction(function () {
  return {
    barsThresh: propTypes$1.number,
    metadataUri: propTypes$1.string.isRequired,
    blackPercentage: propTypes$1.number,
    freezeThresh: propTypes$1.number,
    freezeTime: propTypes$1.number,
    video: propTypes$1.shape(AnalyzeVideoType),
    barsPercentage: propTypes$1.number,
    blackThresh: propTypes$1.number,
    audio: propTypes$1.shape(AnalyzeAudioType),
    channel: propTypes$1.arrayOf(propTypes$1.shape(AnalyzeAudioChannelType))
  };
});
var NLEJobSequenceType = lazyFunction(function () {
  return {
    track: propTypes$1.arrayOf(propTypes$1.shape(TrackType)),
    length: propTypes$1.number.isRequired,
    id: propTypes$1.number.isRequired
  };
});
var ContainerComponentType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(ComponentType), propTypes$1.shape({
    roundedTimeBase: propTypes$1.number,
    mediaInfo: propTypes$1.shape(BaseMediaInfoType),
    dropFrame: propTypes$1.bool,
    format: propTypes$1.string,
    startTimestamp: propTypes$1.shape(TimeCodeType),
    timeCodeTimeBase: TimeBaseType,
    firstSMPTETimecode: propTypes$1.string,
    subFormat: propTypes$1.string,
    duration: propTypes$1.shape(TimeCodeType),
    startTimecode: propTypes$1.number
  }));
});
var CloudConvertType = lazyFunction(function () {
  return {
    publicAddress: propTypes$1.string.isRequired,
    apiHost: propTypes$1.string.isRequired,
    apiKey: propTypes$1.string.isRequired,
    inputMethod: propTypes$1.string.isRequired,
    script: propTypes$1.string.isRequired
  };
});
var ExternalIdentifierType = lazyFunction(function () {
  return {
    externalId: propTypes$1.string.isRequired,
    entityId: propTypes$1.string.isRequired,
    entityType: propTypes$1.string.isRequired,
    namespace: propTypes$1.string.isRequired
  };
});
var ForwardServiceType = lazyFunction(function () {
  return {
    id: propTypes$1.number.isRequired,
    uri: propTypes$1.string.isRequired
  };
});
var TransferListType = lazyFunction(function () {
  return {
    transfer: propTypes$1.arrayOf(propTypes$1.shape(TransferType))
  };
});
var PartialFileRandomIndexType = lazyFunction(function () {
  return {
    packet: propTypes$1.arrayOf(propTypes$1.shape({
      stream: propTypes$1.number,
      duration: propTypes$1.number,
      length: propTypes$1.number,
      offset: propTypes$1.number,
      dts: propTypes$1.number,
      pts: propTypes$1.number,
      isKeyFrame: propTypes$1.bool
    }))
  };
});
var AccessControlListType = lazyFunction(function () {
  return {
    access: propTypes$1.arrayOf(propTypes$1.shape(AccessControlType))
  };
});
var GroupType = lazyFunction(function () {
  return {
    origin: propTypes$1.string,
    loc: propTypes$1.string,
    description: propTypes$1.string,
    parentGroupList: propTypes$1.shape(GroupListType),
    userList: propTypes$1.shape(UserListType),
    remove: propTypes$1.bool,
    groupName: propTypes$1.string,
    role: propTypes$1.bool,
    childGroupList: propTypes$1.shape(GroupListType),
    id: propTypes$1.string,
    metadata: propTypes$1.shape(SimpleMetadataType)
  };
});
var MetricsConfigurationType = lazyFunction(function () {
  return {
    statsd: StatsdReporterType
  };
});
var AccessControlType = lazyFunction(function () {
  return {
    loc: propTypes$1.string,
    group: propTypes$1.string,
    recursive: propTypes$1.bool,
    permission: propTypes$1.string.isRequired,
    appliesTo: propTypes$1.arrayOf(propTypes$1.shape({
      undefined: undefined
    })),
    grantor: propTypes$1.string,
    priority: propTypes$1.number,
    user: propTypes$1.string,
    operation: propTypes$1.shape({
      shape: propTypes$1.shape(AccessControlShapeType),
      uri: propTypes$1.shape(AccessControlUriType),
      metadata: propTypes$1.shape(AccessControlMetadataType)
    }),
    id: propTypes$1.string
  };
});
var StorageMethodType = lazyFunction(function () {
  return {
    loc: propTypes$1.string,
    read: propTypes$1.bool.isRequired,
    lastSuccess: propTypes$1.string,
    uri: propTypes$1.string.isRequired,
    lastFailure: propTypes$1.string,
    write: propTypes$1.bool.isRequired,
    browse: propTypes$1.bool.isRequired,
    bandwidth: propTypes$1.number,
    failureMessage: propTypes$1.string,
    type: propTypes$1.string,
    id: propTypes$1.string,
    metadata: propTypes$1.shape(SimpleMetadataType)
  };
});
var NLEJob2VideoOutputType = lazyFunction(function () {
  return propTypes$1.arrayOf(ComplexJobVideoOutputType, propTypes$1.shape({
    uri: propTypes$1.string,
    sequence: propTypes$1.number.isRequired
  }));
});
var URIListType = lazyFunction(function () {
  return {
    hits: propTypes$1.number,
    uri: propTypes$1.arrayOf(propTypes$1.string)
  };
});
var ItemSearchTextValueType = lazyFunction(function () {
  return {
    noescape: propTypes$1.bool,
    boost: propTypes$1.number,
    value: propTypes$1.string
  };
});
var SubClipType = lazyFunction(function () {
  return {
    start: propTypes$1.number.isRequired,
    length: propTypes$1.number.isRequired,
    id: propTypes$1.number.isRequired
  };
});
var ExportRequestType = lazyFunction(function () {
  return {
    sequence: propTypes$1.shape(SequenceType),
    format: propTypes$1.string,
    storage: propTypes$1.arrayOf(propTypes$1.shape({
      path: propTypes$1.string,
      id: propTypes$1.string.isRequired
    })),
    content: propTypes$1.arrayOf(propTypes$1.string),
    item: propTypes$1.arrayOf(propTypes$1.shape({
      path: propTypes$1.string.isRequired,
      id: propTypes$1.string.isRequired
    })),
    tag: propTypes$1.string
  };
});
var ComplexJobAudioOutputType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(ComplexJobOutputType), propTypes$1.shape({
    thumbnailUri: propTypes$1.arrayOf(propTypes$1.string)
  }));
});
var SearchHistoryListType = lazyFunction(function () {
  return {
    search: propTypes$1.arrayOf(propTypes$1.shape(SearchHistoryType))
  };
});
var TimeIntervalType = lazyFunction(function () {
  return {
    start: propTypes$1.shape(TimeCodeType),
    end: propTypes$1.shape(TimeCodeType)
  };
});
var LicenseNumberType = lazyFunction(function () {
  return {
    current: propTypes$1.string,
    allowed: propTypes$1.string
  };
});
var VidispineServiceType = lazyFunction(function () {
  return {
    threadStatus: propTypes$1.string,
    exception: propTypes$1.string,
    isRunning: propTypes$1.bool,
    name: propTypes$1.string,
    thread: propTypes$1.string,
    exceptionTimestamp: propTypes$1.string,
    isEnabled: propTypes$1.bool,
    id: propTypes$1.string,
    arguments: propTypes$1.string,
    load60: propTypes$1.number,
    load5: propTypes$1.number,
    "class": propTypes$1.string
  };
});
var MetadataFieldValueConstraintListType = lazyFunction(function () {
  return {
    constraint: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldValueConstraintType))
  };
});
var ScalingType = lazyFunction(function () {
  return {
    padColor: propTypes$1.string,
    right: propTypes$1.number,
    bottom: propTypes$1.number,
    pixelAspectRatio: propTypes$1.shape(AspectRatioType),
    top: propTypes$1.number,
    height: propTypes$1.number,
    width: propTypes$1.number,
    rotate: propTypes$1.string,
    targetDAR: propTypes$1.shape(AspectRatioType),
    left: propTypes$1.number
  };
});
var AccessControlMetadataType = lazyFunction(function () {
  return {
    field: propTypes$1.string
  };
});
var ImportSettingsType = lazyFunction(function () {
  return {
    access: propTypes$1.arrayOf(propTypes$1.shape(AccessControlType)),
    id: propTypes$1.string
  };
});
var DMS1Type = lazyFunction(function () {
  return {
    partition: propTypes$1.arrayOf(propTypes$1.shape({
      materialPackage: propTypes$1.arrayOf(propTypes$1.shape({
        staticTrack: propTypes$1.arrayOf(propTypes$1.shape({
          dms1Framework: MDObjectNode.isRequired
        })),
        eventTrack: propTypes$1.arrayOf(propTypes$1.shape({
          segment: propTypes$1.arrayOf(propTypes$1.shape(MDSegment))
        }))
      })),
      offset: propTypes$1.number
    }))
  };
});
var AnalyzeAudioChannelType = lazyFunction(function () {
  return {
    thresh: propTypes$1.number,
    tone: propTypes$1.arrayOf(propTypes$1.number),
    channel: propTypes$1.number.isRequired,
    stream: propTypes$1.number.isRequired
  };
});
var VideoClipType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(ClipType));
});
var MetricsReporterType = lazyFunction(function () {
  return {
    exclude: propTypes$1.arrayOf(propTypes$1.string),
    include: propTypes$1.arrayOf(propTypes$1.string)
  };
});
var NotificationSNSActionType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationActionType), propTypes$1.shape({
    topic: propTypes$1.string.isRequired,
    secret: propTypes$1.string,
    endpoint: propTypes$1.string.isRequired,
    contentType: propTypes$1.string,
    accessKey: propTypes$1.string
  }));
});
var MDObjectBase = lazyFunction(function () {
  return {
    ul: propTypes$1.string.isRequired,
    name: propTypes$1.string
  };
});
var DurationJobType = lazyFunction(function () {
  return {
    input: propTypes$1.arrayOf(propTypes$1.shape({
      setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
      id: propTypes$1.string,
      uri: propTypes$1.string.isRequired
    }))
  };
});
var BulkyMetadataType = lazyFunction(function () {
  return {
    field: propTypes$1.arrayOf(propTypes$1.shape(BulkyMetadataPairType)),
    id: propTypes$1.string
  };
});
var MaterialPackageTrackType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(PackageTrackType), propTypes$1.shape({
    sourcePackageID: propTypes$1.string.isRequired
  }));
});
var NotificationFileTriggerType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationTriggerType), propTypes$1.shape({
    hash: propTypes$1.string,
    storage: propTypes$1.string,
    "new": propTypes$1.string,
    close: propTypes$1.string,
    change: propTypes$1.string,
    "delete": propTypes$1.string
  }));
});
var AutocompleteResponseType = lazyFunction(function () {
  return {
    field: propTypes$1.string,
    suggestion: propTypes$1.arrayOf(propTypes$1.string)
  };
});
var StatsdReporterType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(MetricsReporterType), propTypes$1.shape({
    host: propTypes$1.string,
    prefix: propTypes$1.string,
    port: propTypes$1.number,
    tags: propTypes$1.bool
  }));
});
var SystemInfoType = lazyFunction(function () {
  return {
    databaseSize: propTypes$1.number,
    macaddress: propTypes$1.arrayOf(propTypes$1.string)
  };
});
var ShapeDeductionJobType = lazyFunction(function () {
  return {
    input: propTypes$1.arrayOf(propTypes$1.shape({
      verbose: propTypes$1.bool,
      pageno: propTypes$1.number,
      image: propTypes$1.bool,
      useMediaInfo: propTypes$1.bool,
      uri: propTypes$1.string,
      range: propTypes$1.arrayOf(propTypes$1.shape(SequenceRangeType)),
      setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
      id: propTypes$1.string
    }))
  };
});
var FastStartSettingType = lazyFunction(function () {
  return {
    requireFastStart: propTypes$1.bool,
    analyzeDuration: propTypes$1.bool,
    fastStartDuration: propTypes$1.arrayOf(propTypes$1.shape(TimeCodeType))
  };
});
var VidispineServiceListType = lazyFunction(function () {
  return {
    service: propTypes$1.arrayOf(propTypes$1.shape(VidispineServiceType))
  };
});
var NLEJob2OutputType = lazyFunction(function () {
  return {
    audio: propTypes$1.arrayOf(propTypes$1.shape(NLEJob2AudioOutputType)),
    video: propTypes$1.arrayOf(propTypes$1.shape(NLEJob2VideoOutputType)),
    format: propTypes$1.shape(ComplexJobOutputFormatType).isRequired
  };
});
var CORSConfigurationEntryResponse = lazyFunction(function () {
  return {
    allowHeaders: propTypes$1.arrayOf(propTypes$1.string),
    allowOrigin: propTypes$1.string.isRequired,
    allowMethods: propTypes$1.arrayOf(propTypes$1.string),
    allowOtherHeader: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    allowMaxAge: propTypes$1.number
  };
});
var CollectionListType = lazyFunction(function () {
  return {
    autocomplete: propTypes$1.arrayOf(propTypes$1.shape(AutocompleteResponseType)),
    hits: propTypes$1.number,
    collection: propTypes$1.arrayOf(propTypes$1.shape(CollectionType)),
    facet: propTypes$1.arrayOf(propTypes$1.shape(FacetType)),
    nextCursor: propTypes$1.string,
    suggestion: propTypes$1.arrayOf(propTypes$1.shape(SuggestionResultType))
  };
});
var TextRenditionType = lazyFunction(function () {
  return {
    verticalBase: propTypes$1.string,
    yRel: propTypes$1.number,
    font: propTypes$1.string,
    size: propTypes$1.number,
    outlineSize: propTypes$1.number,
    sizeRel: propTypes$1.number,
    xRel: propTypes$1.number,
    language: propTypes$1.string,
    line: propTypes$1.arrayOf(propTypes$1.string),
    a: propTypes$1.number,
    b: propTypes$1.number,
    outline: propTypes$1.string,
    g: propTypes$1.number,
    outlineG: propTypes$1.number,
    align: propTypes$1.string,
    outlineB: propTypes$1.number,
    outlineA: propTypes$1.number,
    r: propTypes$1.number,
    horizontalBase: propTypes$1.string,
    y: propTypes$1.number,
    x: propTypes$1.number,
    outlineR: propTypes$1.number
  };
});
var PackageTrackType = lazyFunction(function () {
  return {
    name: propTypes$1.string.isRequired,
    isPicture: propTypes$1.bool.isRequired,
    frameRate: FrameRateType,
    number: propTypes$1.number.isRequired,
    length: propTypes$1.number.isRequired,
    is50FPS: propTypes$1.bool
  };
});
var SequenceListType = lazyFunction(function () {
  return {
    sequence: propTypes$1.arrayOf(propTypes$1.shape({
      type: propTypes$1.string.isRequired,
      id: propTypes$1.string.isRequired
    }))
  };
});
var CollectionContentType = lazyFunction(function () {
  return {
    addItems: propTypes$1.bool,
    after: propTypes$1.string,
    uri: propTypes$1.string,
    mode: propTypes$1.oneOf(['add', 'remove', 'move']),
    metadata: propTypes$1.shape(SimpleMetadataType),
    type: propTypes$1.oneOf(['item', 'library', 'collection']),
    id: propTypes$1.string,
    before: propTypes$1.string
  };
});
var NotificationAccessTriggerType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationTriggerType));
});
var FileImportDefType = lazyFunction(function () {
  return {
    path: propTypes$1.string.isRequired,
    size: propTypes$1.number.isRequired,
    component: propTypes$1.arrayOf(propTypes$1.string),
    fileId: propTypes$1.string.isRequired
  };
});
var ItemRelationListType = lazyFunction(function () {
  return {
    relation: propTypes$1.arrayOf(propTypes$1.shape(ItemRelationType))
  };
});
var SiteRuleType = lazyFunction(function () {
  return {
    files: propTypes$1.bool,
    localTargetStorage: propTypes$1.string,
    deleted: propTypes$1.bool,
    site: propTypes$1.string,
    access: propTypes$1.bool,
    shape: propTypes$1.arrayOf(propTypes$1.string),
    groups: propTypes$1.bool,
    targetStorage: propTypes$1.string,
    id: propTypes$1.string,
    metadata: propTypes$1.bool
  };
});
var MetadataFieldValueType = lazyFunction(function () {
  return {
    referenced: propTypes$1.shape(MetadataReferencedType),
    name: propTypes$1.string,
    reference: propTypes$1.string,
    inheritance: propTypes$1.string,
    track: propTypes$1.string,
    data: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    value: propTypes$1.arrayOf(propTypes$1.shape(MetadataValueType)),
    type: propTypes$1.shape(MetadataFieldType),
    id: propTypes$1.arrayOf(propTypes$1.string)
  };
});
var AnalyzeVideoJobType = lazyFunction(function () {
  return {
    otif: propTypes$1.arrayOf(propTypes$1.shape(OtifPresetType))
  };
});
var MXFTimecodeExtractionJobType = lazyFunction(function () {
  return {
    targetUri: propTypes$1.string.isRequired,
    sourceUri: propTypes$1.string.isRequired
  };
});
var XMPResponse = lazyFunction(function () {
  return {
    xmp: propTypes$1.string.isRequired,
    id: propTypes$1.string.isRequired,
    uri: propTypes$1.string.isRequired
  };
});
var ComplexJobAudioChannelMapInputType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(ComplexJobInputType), propTypes$1.shape({
    channel: propTypes$1.number.isRequired
  }));
});
var AccessKeyListType = lazyFunction(function () {
  return {
    hits: propTypes$1.number,
    key: propTypes$1.arrayOf(propTypes$1.shape(AccessKeyType))
  };
});
var FacetType = lazyFunction(function () {
  return {
    count: propTypes$1.arrayOf(propTypes$1.shape(FacetCountType)),
    field: propTypes$1.string.isRequired,
    range: propTypes$1.arrayOf(propTypes$1.shape(FacetRangeType)),
    name: propTypes$1.string
  };
});
var SimpleSearchFieldType = lazyFunction(function () {
  return {
    name: propTypes$1.string.isRequired,
    value: propTypes$1.string.isRequired
  };
});
var TimeBaseType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(RationalType));
});
var DatabasePurgingConfigurationType = lazyFunction(function () {
  return {
    job: propTypes$1.shape({
      age: propTypes$1.number,
      compress: propTypes$1.bool,
      uri: propTypes$1.string
    }),
    transferLog: propTypes$1.shape({
      age: propTypes$1.number,
      compress: propTypes$1.bool,
      uri: propTypes$1.string,
      forceAge: propTypes$1.number,
      batch: propTypes$1.number
    }),
    auditTrail: propTypes$1.shape({
      body: propTypes$1.bool,
      age: propTypes$1.number,
      compress: propTypes$1.bool,
      uri: propTypes$1.string,
      batch: propTypes$1.number
    }),
    changeLog: propTypes$1.shape({
      age: propTypes$1.number,
      forceAge: propTypes$1.number
    })
  };
});
var NLEJobTransitionType = lazyFunction(function () {
  return {
    reverse: propTypes$1.bool,
    transition: propTypes$1.string,
    horizRepeat: propTypes$1.number,
    length: propTypes$1.number.isRequired,
    vertRepeat: propTypes$1.number,
    delta: propTypes$1.number,
    endPercentage: propTypes$1.number,
    startPercentage: propTypes$1.number,
    border: propTypes$1.shape(BorderType),
    wipe: propTypes$1.number
  };
});
var NotificationCollectionTriggerType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationTriggerType));
});
var ConformOverlayType = lazyFunction(function () {
  return {
    y: propTypes$1.number.isRequired,
    x: propTypes$1.number.isRequired,
    interval: propTypes$1.shape(TimeIntervalType),
    id: propTypes$1.string.isRequired
  };
});
var NotificationJmsActionType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(NotificationActionType), propTypes$1.shape({
    queue: propTypes$1.string.isRequired,
    username: propTypes$1.string,
    password: propTypes$1.string,
    contentType: propTypes$1.string,
    queueFactory: propTypes$1.string.isRequired
  }));
});
var DeletionLockListType = lazyFunction(function () {
  return {
    lock: propTypes$1.arrayOf(propTypes$1.shape(DeletionLockType))
  };
});
var JobInputProgressType = lazyFunction(function () {
  return {
    duration: propTypes$1.shape(TimeCodeType),
    mediaTime: propTypes$1.shape(TimeCodeType).isRequired
  };
});
var MetadataFieldGroupType = lazyFunction(function () {
  return {
    origin: propTypes$1.string,
    group: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldGroupType)),
    name: propTypes$1.string,
    inheritance: propTypes$1.string,
    access: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldAccessControlType)),
    field: propTypes$1.arrayOf(propTypes$1.shape(MetadataFieldType)),
    externalId: propTypes$1.arrayOf(propTypes$1.string),
    data: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    schema: propTypes$1.shape(MetadataSchemaElementType)
  };
});
var ConformIntervalType = lazyFunction(function () {
  return {
    start: propTypes$1.shape(ConformTimePointType).isRequired,
    end: propTypes$1.shape(ConformTimePointType)
  };
});
var AccessControlUriType = lazyFunction(function () {
  return {
    type: propTypes$1.string
  };
});
var FileType = lazyFunction(function () {
  return {
    range: propTypes$1.arrayOf(propTypes$1.shape({
      count: propTypes$1.number.isRequired,
      start: propTypes$1.string.isRequired
    })),
    hash: propTypes$1.string,
    sequence: propTypes$1.bool,
    timestamp: propTypes$1.string,
    storage: propTypes$1.string,
    uri: propTypes$1.arrayOf(propTypes$1.string),
    storageDefinition: propTypes$1.shape(StorageType),
    item: propTypes$1.arrayOf(propTypes$1.shape({
      shape: propTypes$1.arrayOf(propTypes$1.shape({
        component: propTypes$1.arrayOf(propTypes$1.shape({
          id: propTypes$1.string
        })),
        id: propTypes$1.string
      })),
      id: propTypes$1.string
    })),
    state: propTypes$1.string.isRequired,
    type: propTypes$1.string,
    path: propTypes$1.string,
    metadata: propTypes$1.shape(SimpleMetadataType),
    refreshFlag: propTypes$1.number,
    id: propTypes$1.string,
    size: propTypes$1.number
  };
});
var MetadataSchemaMigrationListType = lazyFunction(function () {
  return {
    migration: propTypes$1.arrayOf(propTypes$1.shape(MetadataSchemaMigrationType))
  };
});
var MediaComponentType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(ComponentType), propTypes$1.shape({
    numberOfPackets: propTypes$1.number,
    profile: propTypes$1.number,
    itemTrack: propTypes$1.string,
    timeBase: TimeBaseType,
    level: propTypes$1.number,
    repeatCount: propTypes$1.number,
    startTimestamp: propTypes$1.shape(TimeCodeType),
    interval: propTypes$1.shape(TimeIntervalType),
    pid: propTypes$1.number,
    edl: propTypes$1.shape(EDLType),
    codec: propTypes$1.string,
    extradata: propTypes$1.string,
    segment: propTypes$1.number,
    duration: propTypes$1.shape(TimeCodeType),
    trackOrder: propTypes$1.number,
    essenceStreamId: propTypes$1.number,
    bitrate: propTypes$1.number
  }));
});
var AutoImportRuleListType = lazyFunction(function () {
  return {
    rule: propTypes$1.arrayOf(propTypes$1.shape(AutoImportRuleType))
  };
});
var SequenceRangeType = lazyFunction(function () {
  return {
    count: propTypes$1.number,
    start: propTypes$1.number.isRequired,
    wildcard: propTypes$1.string.isRequired,
    value: propTypes$1.string,
    width: propTypes$1.number
  };
});
var VXAType = lazyFunction(function () {
  return {
    vsInstance: propTypes$1.arrayOf(propTypes$1.shape(VXAVSInstanceType)),
    transcoder: propTypes$1.arrayOf(propTypes$1.shape(TranscoderType)),
    agentGroup: propTypes$1.string,
    lastSeen: propTypes$1.string,
    file: propTypes$1.arrayOf(propTypes$1.string),
    forwardService: propTypes$1.arrayOf(propTypes$1.shape(ForwardServiceType)),
    port: propTypes$1.number,
    s3CredentialType: propTypes$1.oneOf(['none', 'temporary', 'secretkey']),
    uuid: propTypes$1.string.isRequired,
    storage: propTypes$1.arrayOf(propTypes$1.shape(VXAStorageType)),
    instance: propTypes$1.string,
    allStorages: propTypes$1.bool,
    externalUri: propTypes$1.string,
    status: propTypes$1.oneOf(['OFFLINE', 'ONLINE']),
    vsClusterAddress: propTypes$1.string,
    publicKey: propTypes$1.string,
    user: propTypes$1.string,
    vxaVersion: propTypes$1.string.isRequired,
    name: propTypes$1.string,
    transcoderVersion: propTypes$1.string.isRequired,
    uri: propTypes$1.string,
    mode: propTypes$1.string
  };
});
var RationalType = lazyFunction(function () {
  return {
    denominator: propTypes$1.number.isRequired,
    numerator: propTypes$1.number.isRequired
  };
});
var ScheduledRequestListType = lazyFunction(function () {
  return {
    scheduledRequest: propTypes$1.arrayOf(propTypes$1.shape(ScheduledRequestType))
  };
});
var MetadataDatasetListType = lazyFunction(function () {
  return {
    hits: propTypes$1.number,
    dataset: propTypes$1.arrayOf(propTypes$1.shape({
      name: propTypes$1.string.isRequired,
      uri: propTypes$1.string.isRequired
    }))
  };
});
var CORSConfigurationEntry = lazyFunction(function () {
  return {
    request: propTypes$1.arrayOf(propTypes$1.shape(CORSConfigurationEntryRequest)),
    response: propTypes$1.shape(CORSConfigurationEntryResponse).isRequired
  };
});
var CORSConfigurationEntryRequest = lazyFunction(function () {
  return {
    origin: propTypes$1.arrayOf(propTypes$1.string),
    pathRegex: propTypes$1.arrayOf(propTypes$1.string),
    originRegex: propTypes$1.arrayOf(propTypes$1.string),
    method: propTypes$1.arrayOf(propTypes$1.string),
    headerRegex: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType))
  };
});
var OAuth2ConfigurationType = lazyFunction(function () {
  return {
    federationMetadataInterval: propTypes$1.number,
    federationMetadataURI: propTypes$1.string,
    validationEndpoint: propTypes$1.string,
    publicKey: propTypes$1.string,
    x509Certificate: propTypes$1.string,
    expectedAudience: propTypes$1.string,
    tokenUser: propTypes$1.string
  };
});
var VXAVSInstanceType = lazyFunction(function () {
  return {
    status: propTypes$1.oneOf(['OFFLINE', 'ONLINE']),
    vsClusterAddress: propTypes$1.string,
    uri: propTypes$1.string,
    lastSeen: propTypes$1.string
  };
});
var PartialFileDescriptorType = lazyFunction(function () {
  return {
    index: propTypes$1.shape(PartialFileRandomIndexType),
    videoStream: propTypes$1.arrayOf(propTypes$1.shape(VideoComponentType)),
    dropFrame: propTypes$1.bool,
    transcoderVersion: propTypes$1.string,
    dvDescriptor: propTypes$1.shape(PartialFileDVDescriptorType),
    label: propTypes$1.string,
    containerComponent: ContainerComponentType,
    roundedTimeBase: propTypes$1.number,
    startTimecode: propTypes$1.number,
    audioStream: propTypes$1.arrayOf(propTypes$1.shape(AudioComponentType))
  };
});
var TimeCodeType = lazyFunction(function () {
  return {
    timeBase: TimeBaseType.isRequired,
    samples: propTypes$1.number.isRequired
  };
});
var SubtitleClipType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(TextRenditionType));
});
var AudioTranscodePresetMixType = lazyFunction(function () {
  return {
    input: propTypes$1.arrayOf(propTypes$1.shape(AudioTranscodePresetChannelMixType)),
    silence: propTypes$1.bool
  };
});
var NotificationActionType = lazyFunction(function () {
  return {
    group: propTypes$1.string,
    extradata: propTypes$1.string,
    synchronous: propTypes$1.bool.isRequired,
    retry: propTypes$1.number
  };
});
var SimpleSearchOperatorType = lazyFunction(function () {
  return {
    field: propTypes$1.arrayOf(propTypes$1.shape(SimpleSearchFieldType)),
    operation: propTypes$1.oneOf(['AND', 'OR', 'NOT']).isRequired
  };
});
var JobSearchType = lazyFunction(function () {
  return {
    facetFilter: propTypes$1.arrayOf(propTypes$1.shape({
      field: propTypes$1.string.isRequired,
      range: propTypes$1.shape(FacetRangeType),
      value: propTypes$1.string
    })),
    facet: propTypes$1.arrayOf(propTypes$1.shape({
      count: propTypes$1.bool,
      name: propTypes$1.string,
      exclude: propTypes$1.arrayOf(propTypes$1.string),
      maxResults: propTypes$1.number,
      field: propTypes$1.string.isRequired,
      maxCount: propTypes$1.number,
      minCount: propTypes$1.number
    }))
  };
});
var SimpleMetadataType = lazyFunction(function () {
  return {
    field: propTypes$1.arrayOf(propTypes$1.shape({
      value: propTypes$1.string.isRequired,
      key: propTypes$1.string.isRequired
    }))
  };
});
var SearchFieldType = lazyFunction(function () {
  return {
    range: propTypes$1.arrayOf(propTypes$1.shape({
      exclusiveMaximum: propTypes$1.bool,
      exclusiveMinimum: propTypes$1.bool,
      value: propTypes$1.arrayOf(propTypes$1.shape(ItemSearchValueType))
    })),
    name: propTypes$1.string.isRequired,
    value: propTypes$1.arrayOf(propTypes$1.shape(ItemSearchValueType)),
    target: propTypes$1.oneOf(['item', 'shape', 'file'])
  };
});
var JobPoolListType = lazyFunction(function () {
  return {
    concurrentJobs: propTypes$1.number,
    pool: propTypes$1.arrayOf(propTypes$1.shape(JobPoolType))
  };
});
var JobType = lazyFunction(function () {
  return {
    status: propTypes$1.string.isRequired,
    totalSteps: propTypes$1.number,
    log: propTypes$1.shape({
      task: propTypes$1.arrayOf(propTypes$1.shape(JobTaskType))
    }),
    started: propTypes$1.string,
    data: propTypes$1.arrayOf(propTypes$1.shape({
      value: propTypes$1.string.isRequired,
      key: propTypes$1.string.isRequired
    })),
    waiting: propTypes$1.shape({
      resourceType: propTypes$1.string,
      resourceId: propTypes$1.string,
      requirement: propTypes$1.string
    }),
    currentStep: propTypes$1.shape({
      status: propTypes$1.string.isRequired,
      description: propTypes$1.string.isRequired,
      number: propTypes$1.number.isRequired
    }).isRequired,
    jobId: propTypes$1.string.isRequired,
    priority: propTypes$1.string.isRequired,
    subJob: propTypes$1.arrayOf(propTypes$1.shape(JobType)),
    finished: propTypes$1.string,
    user: propTypes$1.string,
    type: propTypes$1.string.isRequired
  };
});
var AuthenticationTokenType = lazyFunction(function () {
  return {
    token: propTypes$1.string.isRequired,
    user: propTypes$1.string.isRequired
  };
});
var TaskGroupListType = lazyFunction(function () {
  return {
    group: propTypes$1.arrayOf(propTypes$1.shape(TaskGroupType))
  };
});
var TaskDefinitionListType = lazyFunction(function () {
  return {
    task: propTypes$1.arrayOf(propTypes$1.shape(TaskDefinitionType)),
    metadata: propTypes$1.shape(SimpleMetadataType)
  };
});
var StorageMethodListType = lazyFunction(function () {
  return {
    method: propTypes$1.arrayOf(propTypes$1.shape(StorageMethodType))
  };
});
var MetadataReferencedType = lazyFunction(function () {
  return {
    type: propTypes$1.string.isRequired,
    id: propTypes$1.string.isRequired,
    uuid: propTypes$1.string.isRequired
  };
});
var MXFTimestampType = lazyFunction(function () {
  return {
    hour: propTypes$1.number.isRequired,
    min: propTypes$1.number.isRequired,
    month: propTypes$1.number.isRequired,
    sec: propTypes$1.number.isRequired,
    year: propTypes$1.number.isRequired,
    qmsec: propTypes$1.number.isRequired,
    day: propTypes$1.number.isRequired
  };
});
var ResolutionType = lazyFunction(function () {
  return {
    width: propTypes$1.number.isRequired,
    height: propTypes$1.number.isRequired
  };
});
var EDLType = lazyFunction(function () {
  return {
    entry: propTypes$1.arrayOf(propTypes$1.shape(EDLEntryType)),
    timeBase: TimeBaseType,
    timeScale: TimeBaseType.isRequired
  };
});
var MDObjectNode = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(MDObjectBase), propTypes$1.shape({
    weakReference: propTypes$1.arrayOf(propTypes$1.shape(MDObjectWeakReference)),
    strongReference: propTypes$1.arrayOf(propTypes$1.shape(MDObjectStrongReference)),
    leaf: propTypes$1.arrayOf(propTypes$1.shape(MDObjectLeaf)),
    child: propTypes$1.arrayOf(propTypes$1.shape(MDObjectNode))
  }));
});
var AutocompleteRequestType = lazyFunction(function () {
  return {
    text: propTypes$1.string.isRequired,
    maximumSuggestions: propTypes$1.number,
    field: propTypes$1.string
  };
});
var SequenceMetaDataType = lazyFunction(function () {
  return {
    regex: propTypes$1.string.isRequired,
    idGroup: propTypes$1.number.isRequired
  };
});
var SequenceDefinitionType = lazyFunction(function () {
  return {
    sequenceMetadata: propTypes$1.shape(SequenceMetaDataType),
    fileSequence: propTypes$1.shape(FileSequestionDefinitionType).isRequired
  };
});
var MetadataGroupValueType = lazyFunction(function () {
  return {
    referenced: propTypes$1.shape(MetadataReferencedType),
    name: propTypes$1.string,
    inheritance: propTypes$1.string,
    data: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    id: propTypes$1.arrayOf(propTypes$1.string),
    cycle: propTypes$1.bool
  };
});
var ConformRequestType = lazyFunction(function () {
  return {
    conform: propTypes$1.shape(ConformType).isRequired,
    metadata: propTypes$1.shape(MetadataType)
  };
});
var ProjectFileType = lazyFunction(function () {
  return {
    type: propTypes$1.string,
    location: propTypes$1.string.isRequired,
    asset: propTypes$1.arrayOf(propTypes$1.shape({
      status: propTypes$1.string,
      name: propTypes$1.string.isRequired,
      item: propTypes$1.arrayOf(propTypes$1.shape({
        shape: propTypes$1.string,
        id: propTypes$1.string,
        match: propTypes$1.string,
        permission: propTypes$1.string
      })),
      file: propTypes$1.arrayOf(propTypes$1.shape(FileReferenceType)),
      type: propTypes$1.string.isRequired,
      id: propTypes$1.string.isRequired
    }))
  };
});
var ComplexJobOutputFormatType = lazyFunction(function () {
  return {
    dropFrame: propTypes$1.bool,
    textOverlay: propTypes$1.arrayOf(propTypes$1.shape(TextOverlayType)),
    requireFaststart: propTypes$1.bool,
    overlay: propTypes$1.arrayOf(propTypes$1.shape(OverlayType)),
    initialSMPTETimecode: propTypes$1.string,
    atom: propTypes$1.arrayOf(propTypes$1.shape(ComplexJobAtomType)),
    uri: propTypes$1.string,
    muxrate: propTypes$1.number,
    clipName: propTypes$1.string,
    roundedTimeBase: propTypes$1.number,
    range: propTypes$1.shape(SequenceRangeType),
    setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    maxChunkDuration: propTypes$1.shape(TimeCodeType),
    mxfPackages: propTypes$1.shape(MXFPackagesType),
    dms1Source: propTypes$1.shape({
      demuxerId: propTypes$1.number,
      metadata: propTypes$1.shape(DMS1Type)
    }),
    startTimecode: propTypes$1.number,
    pfdTargetUri: propTypes$1.string,
    metadata: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    id: propTypes$1.number.isRequired,
    containerFormat: propTypes$1.string.isRequired
  };
});
var DocumentListType = lazyFunction(function () {
  return {
    hits: propTypes$1.number,
    document: propTypes$1.arrayOf(propTypes$1.shape({
      name: propTypes$1.string.isRequired,
      uri: propTypes$1.string.isRequired
    }))
  };
});
var ComplexJobType = lazyFunction(function () {
  return {
    input: propTypes$1.arrayOf(propTypes$1.shape({
      scanForStartPTS: propTypes$1.number,
      bulkyMetadataRequest: propTypes$1.shape(ComplexJobBulkyMetadataRequestType),
      dms1TargetUri: propTypes$1.string,
      pageno: propTypes$1.number,
      interval: propTypes$1.shape(TimeIntervalType),
      uri: propTypes$1.arrayOf(propTypes$1.string),
      partialFile: propTypes$1.shape(PartialFileDemuxerInfoType),
      faststartDuration: propTypes$1.arrayOf(propTypes$1.shape(TimeCodeType)),
      range: propTypes$1.arrayOf(propTypes$1.shape(SequenceRangeType)),
      demuxerSetting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
      intervalIsDts: propTypes$1.bool,
      doubleDurationHack: propTypes$1.number,
      analyze: propTypes$1.shape(ComplexJobAnalyzeType),
      id: propTypes$1.number.isRequired
    })),
    connection: propTypes$1.arrayOf(propTypes$1.shape({
      audioChannelMapInput: propTypes$1.arrayOf(propTypes$1.shape(ComplexJobAudioChannelMapInputType)),
      audioOutput: ComplexJobAudioOutputType,
      videoOutput: ComplexJobVideoOutputType,
      pid: propTypes$1.number,
      audioMixInput: propTypes$1.arrayOf(propTypes$1.shape(ComplexJobMixInputType)),
      input: propTypes$1.arrayOf(propTypes$1.shape(ComplexJobInputType)),
      subtitleOutput: ComplexJobSubtitleOutputType,
      audioChannelSequenceInput: propTypes$1.arrayOf(propTypes$1.shape(ComplexJobAudioChannelSequenceInputType))
    })),
    output: propTypes$1.arrayOf(propTypes$1.arrayOf(propTypes$1.shape(ComplexJobOutputFormatType)))
  };
});
var JobTaskProgressType = lazyFunction(function () {
  return {
    total: propTypes$1.number,
    unit: propTypes$1.oneOf(['bytes', 'percent']),
    value: propTypes$1.number
  };
});
var ThumbnailServiceType = lazyFunction(function () {
  return {
    lastSuccess: propTypes$1.string,
    failureMessage: propTypes$1.string,
    state: propTypes$1.string.isRequired,
    mode: propTypes$1.string,
    path: propTypes$1.string.isRequired,
    lastFailure: propTypes$1.string
  };
});
var ImportableFileListType = lazyFunction(function () {
  return {
    prefixes: propTypes$1.shape(FilePrefixType),
    hits: propTypes$1.number,
    element: propTypes$1.arrayOf(propTypes$1.shape(ImportableFileType))
  };
});
var ImportableFileType = lazyFunction(function () {
  return {
    file: propTypes$1.shape(FileType).isRequired,
    metadata: propTypes$1.shape(MetadataType)
  };
});
var AudioTrackTranscodePresetType = lazyFunction(function () {
  return {
    framerate: TimeBaseType,
    preset: propTypes$1.arrayOf(propTypes$1.string),
    mix: propTypes$1.arrayOf(propTypes$1.shape(AudioTranscodePresetMixType)),
    codec: propTypes$1.string,
    bitrate: propTypes$1.number,
    setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    channel: propTypes$1.arrayOf(propTypes$1.number)
  };
});
var ExportLocationType = lazyFunction(function () {
  return {
    projection: propTypes$1.string,
    script: propTypes$1.string,
    uri: propTypes$1.string,
    tag: propTypes$1.arrayOf(propTypes$1.string),
    uriList: propTypes$1.arrayOf(propTypes$1.string),
    name: propTypes$1.string
  };
});
var ItemListType = lazyFunction(function () {
  return {
    autocomplete: propTypes$1.arrayOf(propTypes$1.shape(AutocompleteResponseType)),
    hits: propTypes$1.number,
    library: propTypes$1.string,
    facet: propTypes$1.arrayOf(propTypes$1.shape(FacetType)),
    item: propTypes$1.arrayOf(propTypes$1.shape(ItemType)),
    nextCursor: propTypes$1.string,
    suggestion: propTypes$1.arrayOf(propTypes$1.shape(SuggestionResultType))
  };
});
var JobPoolType = lazyFunction(function () {
  return {
    priorityThreshold: propTypes$1.string.isRequired,
    size: propTypes$1.number.isRequired
  };
});
var TaskDefinitionType = lazyFunction(function () {
  return {
    description: propTypes$1.string,
    script: propTypes$1.string,
    extradata: propTypes$1.string,
    dependency: propTypes$1.shape(TaskDefinitionDependency),
    step: propTypes$1.number,
    cleanup: propTypes$1.bool,
    flags: propTypes$1.number,
    critical: propTypes$1.bool,
    parallelDependency: propTypes$1.shape(TaskDefinitionDependency),
    id: propTypes$1.number,
    jobType: propTypes$1.string,
    metadata: propTypes$1.shape(SimpleMetadataType)
  };
});
var JobTaskType = lazyFunction(function () {
  return {
    status: propTypes$1.string.isRequired,
    totalSubTasks: propTypes$1.number,
    description: propTypes$1.string,
    timestamp: propTypes$1.string.isRequired,
    errorMessage: propTypes$1.string,
    attempts: propTypes$1.number.isRequired,
    id: propTypes$1.number,
    step: propTypes$1.number.isRequired,
    subStep: propTypes$1.arrayOf(propTypes$1.shape({
      timestamp: propTypes$1.string.isRequired,
      description: propTypes$1.string.isRequired
    })),
    progress: propTypes$1.shape(JobTaskProgressType),
    subTask: propTypes$1.arrayOf(propTypes$1.shape(JobTaskType))
  };
});
var TransferResponse = lazyFunction(function () {
  return {
    destinationUri: propTypes$1.arrayOf(propTypes$1.string),
    id: propTypes$1.string.isRequired,
    sourceUri: propTypes$1.arrayOf(propTypes$1.string),
    error: propTypes$1.string
  };
});
var VXAListType = lazyFunction(function () {
  return {
    hits: propTypes$1.number,
    vxa: propTypes$1.arrayOf(propTypes$1.shape(VXAType))
  };
});
var SuggestionSearchType = lazyFunction(function () {
  return {
    maximumSuggestions: propTypes$1.number,
    accuracy: propTypes$1.number
  };
});
var ItemSearchValueType = lazyFunction(function () {
  return {
    noescape: propTypes$1.bool,
    minimum: propTypes$1.bool,
    boost: propTypes$1.number,
    maximum: propTypes$1.bool,
    value: propTypes$1.string
  };
});
var MetadataSchemaHierarchyType = lazyFunction(function () {
  return {
    field: propTypes$1.shape(MetadataFieldType),
    group: propTypes$1.shape(MetadataFieldGroupType)
  };
});
var ComplexJobBulkyMetadataRequestType = lazyFunction(function () {
  return {
    failIfTimecodeNotPresent: propTypes$1.bool,
    targetUri: propTypes$1.string.isRequired
  };
});
var PathAliasConfigurationType = lazyFunction(function () {
  return {
    alias: propTypes$1.arrayOf(propTypes$1.string)
  };
});
var XMPWriteOperation = lazyFunction(function () {
  return {
    setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    xmp: propTypes$1.string.isRequired,
    id: propTypes$1.string,
    uri: propTypes$1.string.isRequired
  };
});
var QueueJobType = lazyFunction(function () {
  return {
    job: propTypes$1.arrayOf(propTypes$1.shape(JobRequestChoiceType))
  };
});
var UserListType = lazyFunction(function () {
  return {
    hits: propTypes$1.number,
    user: propTypes$1.arrayOf(propTypes$1.shape(UserType))
  };
});
var MetadataSchemaMigrationType = lazyFunction(function () {
  return {
    rename: propTypes$1.arrayOf(propTypes$1.shape(MetadataSchemaRenameOperationType)),
    move: propTypes$1.arrayOf(propTypes$1.shape(MetadataSchemaMoveOperationType)),
    done: propTypes$1.bool,
    id: propTypes$1.number,
    migrationsLeft: propTypes$1.number,
    "delete": propTypes$1.arrayOf(propTypes$1.shape(MetadataSchemaDeleteOperationType))
  };
});
var BorderType = lazyFunction(function () {
  return {
    a: propTypes$1.number.isRequired,
    width: propTypes$1.number.isRequired,
    r: propTypes$1.number.isRequired,
    b: propTypes$1.number.isRequired,
    g: propTypes$1.number.isRequired
  };
});
var TranscodePresetType = lazyFunction(function () {
  return {
    video: propTypes$1.shape(VideoTranscodePresetType),
    maxChunkDuration: propTypes$1.shape(TimeCodeType),
    sequenceOutput: propTypes$1.shape({
      start: propTypes$1.number,
      width: propTypes$1.number
    }),
    script: propTypes$1.string,
    preferredSourceTag: propTypes$1.string,
    posterBackground: propTypes$1.string,
    shapeMetadata: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    startTimecode: propTypes$1.string,
    posterResolution: propTypes$1.shape(ResolutionType),
    metadata: propTypes$1.shape(SimpleMetadataType),
    description: propTypes$1.string,
    format: propTypes$1.string,
    faceDetect: propTypes$1.bool,
    audioTrack: propTypes$1.arrayOf(propTypes$1.shape(AudioTrackTranscodePresetType)),
    fastStartSetting: propTypes$1.shape(FastStartSettingType),
    addClipName: propTypes$1.bool,
    thumbnailBackground: propTypes$1.string,
    textOverlay: propTypes$1.arrayOf(propTypes$1.shape(TextOverlayType)),
    name: propTypes$1.string,
    thumbnailPeriod: propTypes$1.shape(TimeCodeType),
    overlay: propTypes$1.arrayOf(propTypes$1.shape(OverlayType)),
    mediaconvert: propTypes$1.shape({
      outputSetting: propTypes$1.arrayOf(propTypes$1.string),
      other: propTypes$1.arrayOf(propTypes$1.string),
      inputSetting: propTypes$1.string
    }),
    thumbnailResolution: propTypes$1.shape(ResolutionType),
    demuxerSetting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    thumbnailPlugin: propTypes$1.string,
    audio: propTypes$1.shape(AudioTranscodePresetType),
    muxerSetting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    preserveEDL: propTypes$1.bool
  };
});
var CompType = lazyFunction(function () {
  return {
    version: propTypes$1.string.isRequired,
    siteId: propTypes$1.string,
    name: propTypes$1.string.isRequired
  };
});
var SlaveType = lazyFunction(function () {
  return {
    requestSourceIp: propTypes$1.string,
    slaveInstanceName: propTypes$1.string,
    slaveIp: propTypes$1.string.isRequired,
    slaveMac: propTypes$1.string.isRequired,
    hostname: propTypes$1.string,
    lastUpdated: propTypes$1.string.isRequired,
    slaveId: propTypes$1.string.isRequired,
    Id: propTypes$1.string.isRequired
  };
});
var SequenceTransitionType = lazyFunction(function () {
  return {
    borderColor: propTypes$1.string,
    reverse: propTypes$1.bool,
    transition: propTypes$1.string.isRequired,
    horizRepeat: propTypes$1.number,
    borderWidth: propTypes$1.number,
    vertRepeat: propTypes$1.number,
    "in": propTypes$1.shape(TimeCodeType).isRequired,
    endPercentage: propTypes$1.number,
    startPercentage: propTypes$1.number,
    wipe: propTypes$1.number,
    out: propTypes$1.shape(TimeCodeType).isRequired
  };
});
var MXFPackagesType = lazyFunction(function () {
  return {
    materialTrackName: propTypes$1.string.isRequired,
    tapeTrackName: propTypes$1.string,
    materialPackage: MaterialPackageType.isRequired,
    tapePackage: TapePackageType,
    projectEditRate: FrameRateType
  };
});
var FacetRangeType = lazyFunction(function () {
  return {
    start: propTypes$1.string.isRequired,
    integerorempty: propTypes$1.string,
    end: propTypes$1.string.isRequired
  };
});
var TransferLogEntryType = lazyFunction(function () {
  return {
    destinationUri: propTypes$1.string,
    status: propTypes$1.string,
    sourceUri: propTypes$1.string,
    destinationShape: propTypes$1.string,
    timestamp: propTypes$1.string,
    referredId: propTypes$1.number,
    sourceFile: propTypes$1.string,
    destinationFile: propTypes$1.string,
    method: propTypes$1.string,
    job: propTypes$1.string,
    sourceShape: propTypes$1.string,
    sourceItem: propTypes$1.string,
    destinationStorage: propTypes$1.string,
    destinationItem: propTypes$1.string,
    id: propTypes$1.number,
    sourceStorage: propTypes$1.string
  };
});
var BulkyMapListType = lazyFunction(function () {
  return {
    map: propTypes$1.arrayOf(propTypes$1.shape(BulkyMapType))
  };
});
var DescriptorComponentType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(ComponentType), propTypes$1.shape({
    description: propTypes$1.arrayOf(propTypes$1.shape({
      type: propTypes$1.string.isRequired,
      value: propTypes$1.string
    }))
  }));
});
var SequenceRenderRequestType = lazyFunction(function () {
  return {
    metadata: propTypes$1.shape(MetadataType),
    sequence: propTypes$1.shape(SequenceType).isRequired
  };
});
var NotificationDocumentTriggerType = lazyFunction(function () {
  return propTypes$1.arrayOf(NotificationMetadataTriggerType);
});
var ShapeSearchType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(ItemSearchType));
});
var XMPReadOperation = lazyFunction(function () {
  return {
    setting: propTypes$1.arrayOf(propTypes$1.shape(KeyValuePairType)),
    id: propTypes$1.string,
    uri: propTypes$1.string.isRequired
  };
});
var QuotaRuleType = lazyFunction(function () {
  return {
    updateFrequency: propTypes$1.number,
    lastUpdate: propTypes$1.string,
    resource: propTypes$1.arrayOf(propTypes$1.shape({
      usage: propTypes$1.number,
      limit: propTypes$1.number.isRequired,
      name: propTypes$1.oneOf(['item', 'storage']).isRequired
    })),
    description: propTypes$1.string,
    storageGroup: propTypes$1.string,
    storage: propTypes$1.string,
    collection: propTypes$1.string,
    tag: propTypes$1.string,
    externalId: propTypes$1.arrayOf(propTypes$1.shape(ExternalIdentifierType)),
    user: propTypes$1.string,
    group: propTypes$1.string,
    id: propTypes$1.string,
    library: propTypes$1.string
  };
});
var MetadataListType = lazyFunction(function () {
  return {
    item: propTypes$1.arrayOf(propTypes$1.shape({
      id: propTypes$1.string,
      metadata: propTypes$1.shape(MetadataType)
    }))
  };
});
var MDObjectWeakReference = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(MDObjectBase), propTypes$1.shape({
    target: propTypes$1.string.isRequired
  }));
});
var AccessKeyType = lazyFunction(function () {
  return {
    status: propTypes$1.oneOf(['ACTIVE', 'INACTIVE']).isRequired,
    secret: propTypes$1.string,
    created: propTypes$1.string.isRequired,
    id: propTypes$1.string,
    name: propTypes$1.string
  };
});
var ConformTimelineType = lazyFunction(function () {
  return {
    segment: propTypes$1.arrayOf(propTypes$1.shape(ConformSegmentType))
  };
});
var PartialFileDemuxerInfoType = lazyFunction(function () {
  return {
    descriptor: propTypes$1.shape(PartialFileDescriptorType),
    descriptorLocation: propTypes$1.string,
    byteOffset: propTypes$1.number,
    adjustForPTSPredecessors: propTypes$1.bool
  };
});
var MXFOp1bJobType = lazyFunction(function () {
  return {
    output: propTypes$1.string.isRequired,
    reference: propTypes$1.arrayOf(propTypes$1.shape({
      source: propTypes$1.string.isRequired,
      stream: propTypes$1.arrayOf(propTypes$1.number),
      locator: propTypes$1.arrayOf(propTypes$1.string)
    }))
  };
});
var BinaryComponentType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(ComponentType), propTypes$1.shape({
    mediaInfo: propTypes$1.shape(BaseMediaInfoType),
    length: propTypes$1.number,
    encoding: propTypes$1.string,
    offset: propTypes$1.number,
    format: propTypes$1.string
  }));
});
var ResourceListType = lazyFunction(function () {
  return {
    resource: propTypes$1.arrayOf(propTypes$1.shape(ResourceType))
  };
});
var LDAPSyncType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(LDAPImportType), propTypes$1.shape({
    createGroups: propTypes$1.bool,
    createUsers: propTypes$1.bool
  }));
});
var AudioClipType = lazyFunction(function () {
  return propTypes$1.arrayOf(propTypes$1.shape(ClipType));
});
var BulkyMetadataConfigurationType = lazyFunction(function () {
  return {
    status: propTypes$1.shape({
      metadataOnStorage: propTypes$1.number.isRequired,
      metadataInDatabase: propTypes$1.number.isRequired,
      storageStatus: propTypes$1.string.isRequired
    }),
    storageDisabled: propTypes$1.bool,
    uri: propTypes$1.string
  };
});
var StorageListType = lazyFunction(function () {
  return {
    hits: propTypes$1.number,
    storage: propTypes$1.arrayOf(propTypes$1.shape(StorageType))
  };
});
var ResourceTypeListType = lazyFunction(function () {
  return {
    resourcetype: propTypes$1.arrayOf(propTypes$1.shape({
      url: propTypes$1.string,
      type: propTypes$1.string.isRequired
    }))
  };
});
var CollectionReorderEntryType = lazyFunction(function () {
  return {
    after: propTypes$1.string,
    id: propTypes$1.string.isRequired,
    before: propTypes$1.string
  };
});
var DurationResponse = lazyFunction(function () {
  return {
    duration: propTypes$1.shape(DurationType).isRequired,
    id: propTypes$1.string.isRequired,
    uri: propTypes$1.string.isRequired
  };
});
var AmountType = lazyFunction(function () {
  return {
    unit: propTypes$1.string,
    value: propTypes$1.number
  };
});
var TextOverlayType = lazyFunction(function () {
  return {
    opacity: propTypes$1.number,
    text: propTypes$1.shape(TextRenditionType).isRequired,
    interval: propTypes$1.shape(TimeIntervalType)
  };
});
var TrackType = lazyFunction(function () {
  return {
    segment: propTypes$1.arrayOf(propTypes$1.shape(TrackSegmentType))
  };
});
var MetadataSchemaRenameOperationType = lazyFunction(function () {
  return {
    to: propTypes$1.string.isRequired,
    from: propTypes$1.shape(MetadataSchemaHierarchyType).isRequired
  };
});
var JobProblemListType = lazyFunction(function () {
  return {
    problem: propTypes$1.arrayOf(propTypes$1.shape(JobProblemType))
  };
});
var GroupListType = lazyFunction(function () {
  return {
    hits: propTypes$1.number,
    group: propTypes$1.arrayOf(propTypes$1.shape(GroupType))
  };
});
var MetadataFieldAccessControlType = lazyFunction(function () {
  return {
    group: propTypes$1.string,
    permission: propTypes$1.string.isRequired,
    fieldGroup: propTypes$1.string,
    field: propTypes$1.string,
    user: propTypes$1.string,
    id: propTypes$1.string
  };
});
var AnalyzeVideoType = lazyFunction(function () {
  return {
    otif: propTypes$1.arrayOf(propTypes$1.shape(ComplexJobOTIFType))
  };
});
var StorageImportType = lazyFunction(function () {
  return {
    file: propTypes$1.arrayOf(propTypes$1.shape(FileImportDefType))
  };
});
var SearchGroupType = lazyFunction(function () {
  return {
    operator: propTypes$1.shape(SearchOperatorType),
    name: propTypes$1.string
  };
});
var SimpleSearchType = lazyFunction(function () {
  return {
    sort: propTypes$1.arrayOf(propTypes$1.shape({
      field: propTypes$1.string.isRequired,
      order: propTypes$1.oneOf(['ascending', 'descending']).isRequired
    })),
    field: propTypes$1.arrayOf(propTypes$1.shape(SimpleSearchFieldType)),
    operator: propTypes$1.shape(SimpleSearchOperatorType)
  };
});
var JobProblemType = lazyFunction(function () {
  return {
    data: propTypes$1.arrayOf(propTypes$1.shape(KeyValueType)),
    job: propTypes$1.arrayOf(propTypes$1.string),
    type: propTypes$1.string.isRequired,
    id: propTypes$1.number.isRequired
  };
});
var AnalyzeAudioType = lazyFunction(function () {
  return {
    otif: propTypes$1.arrayOf(propTypes$1.shape(ComplexJobOTIFType))
  };
});
var ItemRelationType = lazyFunction(function () {
  return {
    direction: propTypes$1.shape({
      source: propTypes$1.string,
      type: propTypes$1.string,
      target: propTypes$1.string
    }).isRequired,
    id: propTypes$1.string.isRequired,
    value: propTypes$1.arrayOf(propTypes$1.shape({
      key: propTypes$1.string.isRequired,
      value: propTypes$1.string
    }))
  };
});
var AudioOutputType = lazyFunction(function () {
  return {
    stream: propTypes$1.arrayOf(propTypes$1.number),
    format: propTypes$1.string,
    framerate: TimeBaseType,
    codec: propTypes$1.string,
    bitrate: propTypes$1.number,
    channel: propTypes$1.arrayOf(propTypes$1.number)
  };
});
var VersionType = lazyFunction(function () {
  return {
    systemInfo: propTypes$1.shape(SystemInfoType),
    component: propTypes$1.arrayOf(propTypes$1.shape(CompType)),
    licenseInfo: propTypes$1.shape(LicenseType)
  };
});
var ShapeListType = lazyFunction(function () {
  return {
    facet: propTypes$1.arrayOf(propTypes$1.shape(FacetType)),
    hits: propTypes$1.number,
    shape: propTypes$1.arrayOf(propTypes$1.shape(ShapeType)),
    suggestion: propTypes$1.arrayOf(propTypes$1.shape(SuggestionResultType))
  };
});
var index = {
  SearchResultEntryTimespanType: propTypes$1.exact(SearchResultEntryTimespanType()),
  EssenceMappingsType: propTypes$1.exact(EssenceMappingsType()),
  MaterialPackageType: propTypes$1.exact(MaterialPackageType()),
  AudioComponentType: propTypes$1.exact(AudioComponentType()),
  MetadataSchemaGroupType: propTypes$1.exact(MetadataSchemaGroupType()),
  StorageGroupType: propTypes$1.exact(StorageGroupType()),
  ClipType: propTypes$1.exact(ClipType()),
  NotificationItemTriggerType: propTypes$1.exact(NotificationItemTriggerType()),
  MetadataFieldStringType: propTypes$1.exact(MetadataFieldStringType()),
  ComplexJobOTIFType: propTypes$1.exact(ComplexJobOTIFType()),
  NotFoundExceptionType: propTypes$1.exact(NotFoundExceptionType()),
  CollectionReorderType: propTypes$1.exact(CollectionReorderType()),
  LDAPResourceType: propTypes$1.exact(LDAPResourceType()),
  TimelineJobRequestType: propTypes$1.exact(TimelineJobRequestType()),
  MetadataLockType: propTypes$1.exact(MetadataLockType()),
  BulkyMetadataPairType: propTypes$1.exact(BulkyMetadataPairType()),
  ComplexJobSubtitleOutputType: propTypes$1.exact(ComplexJobSubtitleOutputType()),
  MOVIndexJobType: propTypes$1.exact(MOVIndexJobType()),
  PartialFileDVDescriptorType: propTypes$1.exact(PartialFileDVDescriptorType()),
  NotificationJavaScriptActionType: propTypes$1.exact(NotificationJavaScriptActionType()),
  MetadataType: propTypes$1.exact(MetadataType()),
  VXAStorageType: propTypes$1.exact(VXAStorageType()),
  AnalyzeJobType: propTypes$1.exact(AnalyzeJobType()),
  MXFServerResourceType: propTypes$1.exact(MXFServerResourceType()),
  JobRequestChoiceType: propTypes$1.exact(JobRequestChoiceType()),
  AAFGeneratorJobType: propTypes$1.exact(AAFGeneratorJobType()),
  NLEJob2AudioOutputType: propTypes$1.exact(NLEJob2AudioOutputType()),
  XMPJobType: propTypes$1.exact(XMPJobType()),
  MetadataValueType: propTypes$1.exact(MetadataValueType()),
  FacetCountType: propTypes$1.exact(FacetCountType()),
  AnalyzeAudioJobType: propTypes$1.exact(AnalyzeAudioJobType()),
  CarbonPreset: propTypes$1.exact(CarbonPreset()),
  SigniantType: propTypes$1.exact(SigniantType()),
  TrackSegmentType: propTypes$1.exact(TrackSegmentType()),
  AuditLogType: propTypes$1.exact(AuditLogType()),
  StatsDRecieverType: propTypes$1.exact(StatsDRecieverType()),
  TransitionType: propTypes$1.exact(TransitionType()),
  CodecType: propTypes$1.exact(CodecType()),
  MetadataFieldFloatType: propTypes$1.exact(MetadataFieldFloatType()),
  VidinetServiceType: propTypes$1.exact(VidinetServiceType()),
  EssenceVersionListType: propTypes$1.exact(EssenceVersionListType()),
  TransferType: propTypes$1.exact(TransferType()),
  JobLogEntryType: propTypes$1.exact(JobLogEntryType()),
  ExportLocationListType: propTypes$1.exact(ExportLocationListType()),
  ConfigurationPropertyListType: propTypes$1.exact(ConfigurationPropertyListType()),
  NLEJobAudioOutputType: propTypes$1.exact(NLEJobAudioOutputType()),
  StreamIntervalType: propTypes$1.exact(StreamIntervalType()),
  LockType: propTypes$1.exact(LockType()),
  MetadataFieldGroupListType: propTypes$1.exact(MetadataFieldGroupListType()),
  FileReferenceType: propTypes$1.exact(FileReferenceType()),
  AutoProjectionRuleType: propTypes$1.exact(AutoProjectionRuleType()),
  NLEJobOutputType: propTypes$1.exact(NLEJobOutputType()),
  TransferLogListType: propTypes$1.exact(TransferLogListType()),
  ConformDestinationType: propTypes$1.exact(ConformDestinationType()),
  MetadataFieldType: propTypes$1.exact(MetadataFieldType()),
  NotificationGroupTriggerType: propTypes$1.exact(NotificationGroupTriggerType()),
  FtpPoolConfigurationType: propTypes$1.exact(FtpPoolConfigurationType()),
  SlaveLicenseListType: propTypes$1.exact(SlaveLicenseListType()),
  SearchResultType: propTypes$1.exact(SearchResultType()),
  HashJobType: propTypes$1.exact(HashJobType()),
  PackageType: propTypes$1.exact(PackageType()),
  ComponentListType: propTypes$1.exact(ComponentListType()),
  AccessControlMergedGroupType: propTypes$1.exact(AccessControlMergedGroupType()),
  IndexingConfigurationType: propTypes$1.exact(IndexingConfigurationType()),
  VideoMediaInfoType: propTypes$1.exact(VideoMediaInfoType()),
  FileMappingType: propTypes$1.exact(FileMappingType()),
  EidrType: propTypes$1.exact(EidrType()),
  FrameRateType: propTypes$1.exact(FrameRateType()),
  CollectionType: propTypes$1.exact(CollectionType()),
  CerifyType: propTypes$1.exact(CerifyType()),
  SlaveLicenseType: propTypes$1.exact(SlaveLicenseType()),
  FinalCutServerType: propTypes$1.exact(FinalCutServerType()),
  ExternalIdentifierNamespaceType: propTypes$1.exact(ExternalIdentifierNamespaceType()),
  WaveformDataType: propTypes$1.exact(WaveformDataType()),
  ReindexRequestType: propTypes$1.exact(ReindexRequestType()),
  SearchOperatorType: propTypes$1.exact(SearchOperatorType()),
  ComponentType: propTypes$1.exact(ComponentType()),
  ExternalIdentifierNamespaceListType: propTypes$1.exact(ExternalIdentifierNamespaceListType()),
  AudioMediaInfoType: propTypes$1.exact(AudioMediaInfoType()),
  HashResponse: propTypes$1.exact(HashResponse()),
  ComplexJobMixType: propTypes$1.exact(ComplexJobMixType()),
  ComplexJobMixInputType: propTypes$1.exact(ComplexJobMixInputType()),
  PluginType: propTypes$1.exact(PluginType()),
  ProjectType: propTypes$1.exact(ProjectType()),
  MetadataFieldGroupPermissionType: propTypes$1.exact(MetadataFieldGroupPermissionType()),
  NotificationTriggerType: propTypes$1.exact(NotificationTriggerType()),
  ExportProblemType: propTypes$1.exact(ExportProblemType()),
  AudioTranscodePresetType: propTypes$1.exact(AudioTranscodePresetType()),
  LibrarySettingsType: propTypes$1.exact(LibrarySettingsType()),
  StorageRuleType: propTypes$1.exact(StorageRuleType()),
  ConformSegmentType: propTypes$1.exact(ConformSegmentType()),
  AAFGeneratorResponse: propTypes$1.exact(AAFGeneratorResponse()),
  SiteRuleListType: propTypes$1.exact(SiteRuleListType()),
  JobPriorityConfigurationType: propTypes$1.exact(JobPriorityConfigurationType()),
  ComplexJobAudioChannelSequenceInputType: propTypes$1.exact(ComplexJobAudioChannelSequenceInputType()),
  StorageMappingType: propTypes$1.exact(StorageMappingType()),
  ImportAccessControlListType: propTypes$1.exact(ImportAccessControlListType()),
  ThumbnailInfoType: propTypes$1.exact(ThumbnailInfoType()),
  CORSConfigurationType: propTypes$1.exact(CORSConfigurationType()),
  EDLEntryType: propTypes$1.exact(EDLEntryType()),
  SegmentationJobType: propTypes$1.exact(SegmentationJobType()),
  NLEJobType: propTypes$1.exact(NLEJobType()),
  MetadataEntryListType2: propTypes$1.exact(MetadataEntryListType2()),
  EffectPointType: propTypes$1.exact(EffectPointType()),
  BulkyMapType: propTypes$1.exact(BulkyMapType()),
  EssenceVersionType: propTypes$1.exact(EssenceVersionType()),
  MDObjectStrongReference: propTypes$1.exact(MDObjectStrongReference()),
  NotificationDeletionLockTriggerType: propTypes$1.exact(NotificationDeletionLockTriggerType()),
  PlaceholderImportRequestType: propTypes$1.exact(PlaceholderImportRequestType()),
  NotificationStorageTriggerType: propTypes$1.exact(NotificationStorageTriggerType()),
  VideoComponentType: propTypes$1.exact(VideoComponentType()),
  ComplexJobInputType: propTypes$1.exact(ComplexJobInputType()),
  SearchFilterType: propTypes$1.exact(SearchFilterType()),
  MetadataFieldIntegerType: propTypes$1.exact(MetadataFieldIntegerType()),
  FilePrefixType: propTypes$1.exact(FilePrefixType()),
  MetadataSchemaMoveOperationType: propTypes$1.exact(MetadataSchemaMoveOperationType()),
  NotificationEjbActionType: propTypes$1.exact(NotificationEjbActionType()),
  AuditLogEntryType: propTypes$1.exact(AuditLogEntryType()),
  FilenameFilterType: propTypes$1.exact(FilenameFilterType()),
  TapePackageTrackType: propTypes$1.exact(TapePackageTrackType()),
  MetadataSchemaElementType: propTypes$1.exact(MetadataSchemaElementType()),
  CostEstimateType: propTypes$1.exact(CostEstimateType()),
  AspectRatioType: propTypes$1.exact(AspectRatioType()),
  HashComputeOperation: propTypes$1.exact(HashComputeOperation()),
  FileSearchType: propTypes$1.exact(FileSearchType()),
  ExternalTranscoderType: propTypes$1.exact(ExternalTranscoderType()),
  TaskGroupType: propTypes$1.exact(TaskGroupType()),
  DurationType: propTypes$1.exact(DurationType()),
  SequenceTrackType: propTypes$1.exact(SequenceTrackType()),
  MetadataFieldListType: propTypes$1.exact(MetadataFieldListType()),
  LicenseErrorType: propTypes$1.exact(LicenseErrorType()),
  NotificationQuotaTriggerType: propTypes$1.exact(NotificationQuotaTriggerType()),
  TapePackageType: propTypes$1.exact(TapePackageType()),
  CriterionType: propTypes$1.exact(CriterionType()),
  StorageGroupListType: propTypes$1.exact(StorageGroupListType()),
  TransferJobType: propTypes$1.exact(TransferJobType()),
  NLEJob2MixTypeInput: propTypes$1.exact(NLEJob2MixTypeInput()),
  JobListType: propTypes$1.exact(JobListType()),
  ComplexJobVideoOutputType: propTypes$1.exact(ComplexJobVideoOutputType()),
  ItemSearchType: propTypes$1.exact(ItemSearchType()),
  ItemType: propTypes$1.exact(ItemType()),
  MetadataSchemaDeleteOperationType: propTypes$1.exact(MetadataSchemaDeleteOperationType()),
  MDObjectLeaf: propTypes$1.exact(MDObjectLeaf()),
  ConfigurationPropertyType: propTypes$1.exact(ConfigurationPropertyType()),
  ExternalIdentifierListType: propTypes$1.exact(ExternalIdentifierListType()),
  SiteDefinitionType: propTypes$1.exact(SiteDefinitionType()),
  UserType: propTypes$1.exact(UserType()),
  CodecStatusType: propTypes$1.exact(CodecStatusType()),
  MetadataFieldLongType: propTypes$1.exact(MetadataFieldLongType()),
  FileSequestionDefinitionType: propTypes$1.exact(FileSequestionDefinitionType()),
  NLEJob2MixType: propTypes$1.exact(NLEJob2MixType()),
  SearchHistoryType: propTypes$1.exact(SearchHistoryType()),
  VideoTranscodePresetType: propTypes$1.exact(VideoTranscodePresetType()),
  ScheduledRequestType: propTypes$1.exact(ScheduledRequestType()),
  NotificationShapeTriggerType: propTypes$1.exact(NotificationShapeTriggerType()),
  ExportResponseType: propTypes$1.exact(ExportResponseType()),
  NotificationSQSActionType: propTypes$1.exact(NotificationSQSActionType()),
  MetadataFieldAccessControlListType: propTypes$1.exact(MetadataFieldAccessControlListType()),
  ConformType: propTypes$1.exact(ConformType()),
  MetadataSchemaType: propTypes$1.exact(MetadataSchemaType()),
  StorageType: propTypes$1.exact(StorageType()),
  DeletionLockType: propTypes$1.exact(DeletionLockType()),
  TaskDefinitionDependency: propTypes$1.exact(TaskDefinitionDependency()),
  ConformTimePointType: propTypes$1.exact(ConformTimePointType()),
  EffectParameterType: propTypes$1.exact(EffectParameterType()),
  SuggestionResultType: propTypes$1.exact(SuggestionResultType()),
  MDSegment: propTypes$1.exact(MDSegment()),
  LoudnessType: propTypes$1.exact(LoudnessType()),
  QuotaRuleListType: propTypes$1.exact(QuotaRuleListType()),
  ShapeCriterionType: propTypes$1.exact(ShapeCriterionType()),
  LicenseType: propTypes$1.exact(LicenseType()),
  TranscoderConfigurationType: propTypes$1.exact(TranscoderConfigurationType()),
  NLEJobVideoOutputType: propTypes$1.exact(NLEJobVideoOutputType()),
  JobStatusType: propTypes$1.exact(JobStatusType()),
  TransferOperation: propTypes$1.exact(TransferOperation()),
  OtifPresetType: propTypes$1.exact(OtifPresetType()),
  EffectType: propTypes$1.exact(EffectType()),
  AssetMappingType: propTypes$1.exact(AssetMappingType()),
  MetadataFieldPermissionType: propTypes$1.exact(MetadataFieldPermissionType()),
  MetadataFieldValueConstraintType: propTypes$1.exact(MetadataFieldValueConstraintType()),
  TranscoderType: propTypes$1.exact(TranscoderType()),
  SequenceType: propTypes$1.exact(SequenceType()),
  ShapeDeductionResponse: propTypes$1.exact(ShapeDeductionResponse()),
  LoudnessMixType: propTypes$1.exact(LoudnessMixType()),
  ConformSourceType: propTypes$1.exact(ConformSourceType()),
  AutoProjectionStepType: propTypes$1.exact(AutoProjectionStepType()),
  NetworkType: propTypes$1.exact(NetworkType()),
  ConnectionPoolType: propTypes$1.exact(ConnectionPoolType()),
  LogReportConfigurationType: propTypes$1.exact(LogReportConfigurationType()),
  ShapeType: propTypes$1.exact(ShapeType()),
  SlaveListType: propTypes$1.exact(SlaveListType()),
  AddressPortType: propTypes$1.exact(AddressPortType()),
  KeyValueType: propTypes$1.exact(KeyValueType()),
  NameURIPairType: propTypes$1.exact(NameURIPairType()),
  TranscoderDirectAccess: propTypes$1.exact(TranscoderDirectAccess()),
  AutoImportRuleType: propTypes$1.exact(AutoImportRuleType()),
  LDAPImportType: propTypes$1.exact(LDAPImportType()),
  BaseMediaInfoType: propTypes$1.exact(BaseMediaInfoType()),
  AccessControlMergedType: propTypes$1.exact(AccessControlMergedType()),
  SubtitleComponentType: propTypes$1.exact(SubtitleComponentType()),
  StorageFileSequenceType: propTypes$1.exact(StorageFileSequenceType()),
  ComplexJobAtomType: propTypes$1.exact(ComplexJobAtomType()),
  SelfTestType: propTypes$1.exact(SelfTestType()),
  NotificationHttpActionType: propTypes$1.exact(NotificationHttpActionType()),
  ItemCriterionType: propTypes$1.exact(ItemCriterionType()),
  BulkyMapEntryType: propTypes$1.exact(BulkyMapEntryType()),
  ComplexJobOutputType: propTypes$1.exact(ComplexJobOutputType()),
  ConstraintValueType: propTypes$1.exact(ConstraintValueType()),
  StorageRulesType: propTypes$1.exact(StorageRulesType()),
  SequenceMediaType: propTypes$1.exact(SequenceMediaType()),
  ResourceType: propTypes$1.exact(ResourceType()),
  MetadataLockListType: propTypes$1.exact(MetadataLockListType()),
  NotificationType: propTypes$1.exact(NotificationType()),
  KeyValuePairType: propTypes$1.exact(KeyValuePairType()),
  OverlayType: propTypes$1.exact(OverlayType()),
  MetadataChangeSetType: propTypes$1.exact(MetadataChangeSetType()),
  ProjectVersionType: propTypes$1.exact(ProjectVersionType()),
  MetadataEntryType: propTypes$1.exact(MetadataEntryType()),
  FileListType: propTypes$1.exact(FileListType()),
  MetadataFieldResultType: propTypes$1.exact(MetadataFieldResultType()),
  AccessControlShapeType: propTypes$1.exact(AccessControlShapeType()),
  NotificationJobTriggerType: propTypes$1.exact(NotificationJobTriggerType()),
  AudioTranscodePresetChannelMixType: propTypes$1.exact(AudioTranscodePresetChannelMixType()),
  ConstraintValueListType: propTypes$1.exact(ConstraintValueListType()),
  NotificationMetadataTriggerType: propTypes$1.exact(NotificationMetadataTriggerType()),
  SearchResultEntryType: propTypes$1.exact(SearchResultEntryType()),
  ComplexJobAnalyzeType: propTypes$1.exact(ComplexJobAnalyzeType()),
  NLEJobSequenceType: propTypes$1.exact(NLEJobSequenceType()),
  ContainerComponentType: propTypes$1.exact(ContainerComponentType()),
  CloudConvertType: propTypes$1.exact(CloudConvertType()),
  ExternalIdentifierType: propTypes$1.exact(ExternalIdentifierType()),
  ForwardServiceType: propTypes$1.exact(ForwardServiceType()),
  TransferListType: propTypes$1.exact(TransferListType()),
  PartialFileRandomIndexType: propTypes$1.exact(PartialFileRandomIndexType()),
  AccessControlListType: propTypes$1.exact(AccessControlListType()),
  GroupType: propTypes$1.exact(GroupType()),
  MetricsConfigurationType: propTypes$1.exact(MetricsConfigurationType()),
  AccessControlType: propTypes$1.exact(AccessControlType()),
  StorageMethodType: propTypes$1.exact(StorageMethodType()),
  NLEJob2VideoOutputType: propTypes$1.exact(NLEJob2VideoOutputType()),
  URIListType: propTypes$1.exact(URIListType()),
  ItemSearchTextValueType: propTypes$1.exact(ItemSearchTextValueType()),
  SubClipType: propTypes$1.exact(SubClipType()),
  ExportRequestType: propTypes$1.exact(ExportRequestType()),
  ComplexJobAudioOutputType: propTypes$1.exact(ComplexJobAudioOutputType()),
  SearchHistoryListType: propTypes$1.exact(SearchHistoryListType()),
  TimeIntervalType: propTypes$1.exact(TimeIntervalType()),
  LicenseNumberType: propTypes$1.exact(LicenseNumberType()),
  VidispineServiceType: propTypes$1.exact(VidispineServiceType()),
  MetadataFieldValueConstraintListType: propTypes$1.exact(MetadataFieldValueConstraintListType()),
  ScalingType: propTypes$1.exact(ScalingType()),
  AccessControlMetadataType: propTypes$1.exact(AccessControlMetadataType()),
  ImportSettingsType: propTypes$1.exact(ImportSettingsType()),
  DMS1Type: propTypes$1.exact(DMS1Type()),
  AnalyzeAudioChannelType: propTypes$1.exact(AnalyzeAudioChannelType()),
  VideoClipType: propTypes$1.exact(VideoClipType()),
  MetricsReporterType: propTypes$1.exact(MetricsReporterType()),
  NotificationSNSActionType: propTypes$1.exact(NotificationSNSActionType()),
  MDObjectBase: propTypes$1.exact(MDObjectBase()),
  DurationJobType: propTypes$1.exact(DurationJobType()),
  BulkyMetadataType: propTypes$1.exact(BulkyMetadataType()),
  MaterialPackageTrackType: propTypes$1.exact(MaterialPackageTrackType()),
  NotificationFileTriggerType: propTypes$1.exact(NotificationFileTriggerType()),
  AutocompleteResponseType: propTypes$1.exact(AutocompleteResponseType()),
  StatsdReporterType: propTypes$1.exact(StatsdReporterType()),
  SystemInfoType: propTypes$1.exact(SystemInfoType()),
  ShapeDeductionJobType: propTypes$1.exact(ShapeDeductionJobType()),
  FastStartSettingType: propTypes$1.exact(FastStartSettingType()),
  VidispineServiceListType: propTypes$1.exact(VidispineServiceListType()),
  NLEJob2OutputType: propTypes$1.exact(NLEJob2OutputType()),
  CORSConfigurationEntryResponse: propTypes$1.exact(CORSConfigurationEntryResponse()),
  CollectionListType: propTypes$1.exact(CollectionListType()),
  TextRenditionType: propTypes$1.exact(TextRenditionType()),
  PackageTrackType: propTypes$1.exact(PackageTrackType()),
  SequenceListType: propTypes$1.exact(SequenceListType()),
  CollectionContentType: propTypes$1.exact(CollectionContentType()),
  NotificationAccessTriggerType: propTypes$1.exact(NotificationAccessTriggerType()),
  FileImportDefType: propTypes$1.exact(FileImportDefType()),
  ItemRelationListType: propTypes$1.exact(ItemRelationListType()),
  SiteRuleType: propTypes$1.exact(SiteRuleType()),
  MetadataFieldValueType: propTypes$1.exact(MetadataFieldValueType()),
  AnalyzeVideoJobType: propTypes$1.exact(AnalyzeVideoJobType()),
  MXFTimecodeExtractionJobType: propTypes$1.exact(MXFTimecodeExtractionJobType()),
  XMPResponse: propTypes$1.exact(XMPResponse()),
  ComplexJobAudioChannelMapInputType: propTypes$1.exact(ComplexJobAudioChannelMapInputType()),
  AccessKeyListType: propTypes$1.exact(AccessKeyListType()),
  FacetType: propTypes$1.exact(FacetType()),
  SimpleSearchFieldType: propTypes$1.exact(SimpleSearchFieldType()),
  TimeBaseType: propTypes$1.exact(TimeBaseType()),
  DatabasePurgingConfigurationType: propTypes$1.exact(DatabasePurgingConfigurationType()),
  NLEJobTransitionType: propTypes$1.exact(NLEJobTransitionType()),
  NotificationCollectionTriggerType: propTypes$1.exact(NotificationCollectionTriggerType()),
  ConformOverlayType: propTypes$1.exact(ConformOverlayType()),
  NotificationJmsActionType: propTypes$1.exact(NotificationJmsActionType()),
  DeletionLockListType: propTypes$1.exact(DeletionLockListType()),
  JobInputProgressType: propTypes$1.exact(JobInputProgressType()),
  MetadataFieldGroupType: propTypes$1.exact(MetadataFieldGroupType()),
  ConformIntervalType: propTypes$1.exact(ConformIntervalType()),
  AccessControlUriType: propTypes$1.exact(AccessControlUriType()),
  FileType: propTypes$1.exact(FileType()),
  MetadataSchemaMigrationListType: propTypes$1.exact(MetadataSchemaMigrationListType()),
  MediaComponentType: propTypes$1.exact(MediaComponentType()),
  AutoImportRuleListType: propTypes$1.exact(AutoImportRuleListType()),
  SequenceRangeType: propTypes$1.exact(SequenceRangeType()),
  VXAType: propTypes$1.exact(VXAType()),
  RationalType: propTypes$1.exact(RationalType()),
  ScheduledRequestListType: propTypes$1.exact(ScheduledRequestListType()),
  MetadataDatasetListType: propTypes$1.exact(MetadataDatasetListType()),
  CORSConfigurationEntry: propTypes$1.exact(CORSConfigurationEntry()),
  CORSConfigurationEntryRequest: propTypes$1.exact(CORSConfigurationEntryRequest()),
  OAuth2ConfigurationType: propTypes$1.exact(OAuth2ConfigurationType()),
  VXAVSInstanceType: propTypes$1.exact(VXAVSInstanceType()),
  PartialFileDescriptorType: propTypes$1.exact(PartialFileDescriptorType()),
  TimeCodeType: propTypes$1.exact(TimeCodeType()),
  SubtitleClipType: propTypes$1.exact(SubtitleClipType()),
  AudioTranscodePresetMixType: propTypes$1.exact(AudioTranscodePresetMixType()),
  NotificationActionType: propTypes$1.exact(NotificationActionType()),
  SimpleSearchOperatorType: propTypes$1.exact(SimpleSearchOperatorType()),
  JobSearchType: propTypes$1.exact(JobSearchType()),
  SimpleMetadataType: propTypes$1.exact(SimpleMetadataType()),
  SearchFieldType: propTypes$1.exact(SearchFieldType()),
  JobPoolListType: propTypes$1.exact(JobPoolListType()),
  JobType: propTypes$1.exact(JobType()),
  AuthenticationTokenType: propTypes$1.exact(AuthenticationTokenType()),
  TaskGroupListType: propTypes$1.exact(TaskGroupListType()),
  TaskDefinitionListType: propTypes$1.exact(TaskDefinitionListType()),
  StorageMethodListType: propTypes$1.exact(StorageMethodListType()),
  MetadataReferencedType: propTypes$1.exact(MetadataReferencedType()),
  MXFTimestampType: propTypes$1.exact(MXFTimestampType()),
  ResolutionType: propTypes$1.exact(ResolutionType()),
  EDLType: propTypes$1.exact(EDLType()),
  MDObjectNode: propTypes$1.exact(MDObjectNode()),
  AutocompleteRequestType: propTypes$1.exact(AutocompleteRequestType()),
  SequenceMetaDataType: propTypes$1.exact(SequenceMetaDataType()),
  SequenceDefinitionType: propTypes$1.exact(SequenceDefinitionType()),
  MetadataGroupValueType: propTypes$1.exact(MetadataGroupValueType()),
  ConformRequestType: propTypes$1.exact(ConformRequestType()),
  ProjectFileType: propTypes$1.exact(ProjectFileType()),
  ComplexJobOutputFormatType: propTypes$1.exact(ComplexJobOutputFormatType()),
  DocumentListType: propTypes$1.exact(DocumentListType()),
  ComplexJobType: propTypes$1.exact(ComplexJobType()),
  JobTaskProgressType: propTypes$1.exact(JobTaskProgressType()),
  ThumbnailServiceType: propTypes$1.exact(ThumbnailServiceType()),
  ImportableFileListType: propTypes$1.exact(ImportableFileListType()),
  ImportableFileType: propTypes$1.exact(ImportableFileType()),
  AudioTrackTranscodePresetType: propTypes$1.exact(AudioTrackTranscodePresetType()),
  ExportLocationType: propTypes$1.exact(ExportLocationType()),
  ItemListType: propTypes$1.exact(ItemListType()),
  JobPoolType: propTypes$1.exact(JobPoolType()),
  TaskDefinitionType: propTypes$1.exact(TaskDefinitionType()),
  JobTaskType: propTypes$1.exact(JobTaskType()),
  TransferResponse: propTypes$1.exact(TransferResponse()),
  VXAListType: propTypes$1.exact(VXAListType()),
  SuggestionSearchType: propTypes$1.exact(SuggestionSearchType()),
  ItemSearchValueType: propTypes$1.exact(ItemSearchValueType()),
  MetadataSchemaHierarchyType: propTypes$1.exact(MetadataSchemaHierarchyType()),
  ComplexJobBulkyMetadataRequestType: propTypes$1.exact(ComplexJobBulkyMetadataRequestType()),
  PathAliasConfigurationType: propTypes$1.exact(PathAliasConfigurationType()),
  XMPWriteOperation: propTypes$1.exact(XMPWriteOperation()),
  QueueJobType: propTypes$1.exact(QueueJobType()),
  UserListType: propTypes$1.exact(UserListType()),
  MetadataSchemaMigrationType: propTypes$1.exact(MetadataSchemaMigrationType()),
  BorderType: propTypes$1.exact(BorderType()),
  TranscodePresetType: propTypes$1.exact(TranscodePresetType()),
  CompType: propTypes$1.exact(CompType()),
  SlaveType: propTypes$1.exact(SlaveType()),
  SequenceTransitionType: propTypes$1.exact(SequenceTransitionType()),
  MXFPackagesType: propTypes$1.exact(MXFPackagesType()),
  FacetRangeType: propTypes$1.exact(FacetRangeType()),
  TransferLogEntryType: propTypes$1.exact(TransferLogEntryType()),
  BulkyMapListType: propTypes$1.exact(BulkyMapListType()),
  DescriptorComponentType: propTypes$1.exact(DescriptorComponentType()),
  SequenceRenderRequestType: propTypes$1.exact(SequenceRenderRequestType()),
  NotificationDocumentTriggerType: propTypes$1.exact(NotificationDocumentTriggerType()),
  ShapeSearchType: propTypes$1.exact(ShapeSearchType()),
  XMPReadOperation: propTypes$1.exact(XMPReadOperation()),
  QuotaRuleType: propTypes$1.exact(QuotaRuleType()),
  MetadataListType: propTypes$1.exact(MetadataListType()),
  MDObjectWeakReference: propTypes$1.exact(MDObjectWeakReference()),
  AccessKeyType: propTypes$1.exact(AccessKeyType()),
  ConformTimelineType: propTypes$1.exact(ConformTimelineType()),
  PartialFileDemuxerInfoType: propTypes$1.exact(PartialFileDemuxerInfoType()),
  MXFOp1bJobType: propTypes$1.exact(MXFOp1bJobType()),
  BinaryComponentType: propTypes$1.exact(BinaryComponentType()),
  ResourceListType: propTypes$1.exact(ResourceListType()),
  LDAPSyncType: propTypes$1.exact(LDAPSyncType()),
  AudioClipType: propTypes$1.exact(AudioClipType()),
  BulkyMetadataConfigurationType: propTypes$1.exact(BulkyMetadataConfigurationType()),
  StorageListType: propTypes$1.exact(StorageListType()),
  ResourceTypeListType: propTypes$1.exact(ResourceTypeListType()),
  CollectionReorderEntryType: propTypes$1.exact(CollectionReorderEntryType()),
  DurationResponse: propTypes$1.exact(DurationResponse()),
  AmountType: propTypes$1.exact(AmountType()),
  TextOverlayType: propTypes$1.exact(TextOverlayType()),
  TrackType: propTypes$1.exact(TrackType()),
  MetadataSchemaRenameOperationType: propTypes$1.exact(MetadataSchemaRenameOperationType()),
  JobProblemListType: propTypes$1.exact(JobProblemListType()),
  GroupListType: propTypes$1.exact(GroupListType()),
  MetadataFieldAccessControlType: propTypes$1.exact(MetadataFieldAccessControlType()),
  AnalyzeVideoType: propTypes$1.exact(AnalyzeVideoType()),
  StorageImportType: propTypes$1.exact(StorageImportType()),
  SearchGroupType: propTypes$1.exact(SearchGroupType()),
  SimpleSearchType: propTypes$1.exact(SimpleSearchType()),
  JobProblemType: propTypes$1.exact(JobProblemType()),
  AnalyzeAudioType: propTypes$1.exact(AnalyzeAudioType()),
  ItemRelationType: propTypes$1.exact(ItemRelationType()),
  AudioOutputType: propTypes$1.exact(AudioOutputType()),
  VersionType: propTypes$1.exact(VersionType()),
  ShapeListType: propTypes$1.exact(ShapeListType())
};

var styles$C = function styles(theme) {
  return {
    TableCellLabel: _objectSpread2({
      borderStyle: 'none'
    }, theme.typography.body2),
    TableCellValue: _objectSpread2({
      borderStyle: 'none',
      wordBreak: 'break-all'
    }, theme.typography.subtitle2)
  };
};

var TableRow$1 = function TableRow(_ref) {
  var classes = _ref.classes,
      label = _ref.label,
      value = _ref.value,
      _ref$formatValue = _ref.formatValue,
      formatValue = _ref$formatValue === void 0 ? function (thisValue) {
    return thisValue;
  } : _ref$formatValue,
      props = _objectWithoutProperties(_ref, ["classes", "label", "value", "formatValue"]);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React__default.createElement(TableRow$3$1, props, /*#__PURE__*/React__default.createElement(TableCell$1, {
      classes: {
        root: classes.TableCellLabel
      }
    }, label), /*#__PURE__*/React__default.createElement(TableCell$1, {
      classes: {
        root: classes.TableCellValue
      }
    }, value !== undefined ? formatValue(value) : ''))
  );
};

var TableRow$2 = withStyles(styles$C)(TableRow$1);

var TableHead = function TableHead(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(TableHead$1$1, null, /*#__PURE__*/React__default.createElement(TableRow$3$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    colSpan: 2
  }, children)));
};

function ContainerComponentTypeTableBody(_ref) {
  var className = _ref.className,
      containerComponentType = _ref.containerComponentType;
  var container = React__default.useMemo(function () {
    return parseContainerComponent(containerComponentType);
  }, [containerComponentType]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableHead, null, "Media Container"), /*#__PURE__*/React__default.createElement(TableBody$1, {
    className: className
  }, /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Media Container",
    value: container.containerFormat
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Duration",
    value: container.duration
  })));
}

function AudioComponentTypeTableBody(_ref) {
  var className = _ref.className,
      audioComponentType = _ref.audioComponentType;
  var audio = React__default.useMemo(function () {
    return parseAudioComponent(audioComponentType);
  }, [audioComponentType]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableHead, null, "Audio Track"), /*#__PURE__*/React__default.createElement(TableBody$1, {
    className: className
  }, /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Audio Codec",
    value: audio.audioFormat || audio.audioCodec
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Audio Channels",
    value: audio.audioChannels
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Audio Sample Rate",
    value: audio.audioSamplerate
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Audio Bit Rate",
    value: audio.audioBitrate
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Audio Bit Depth",
    value: audio.audioBitDepth
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Audio Bit Rate Mode",
    value: audio.audioBitRateMode
  })));
}

var useToggleOnClick = function useToggleOnClick(defaultState, callback, externalState) {
  var _React$useState = React__default.useState(defaultState),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      internalState = _React$useState2[0],
      setInternalState = _React$useState2[1];

  var state = externalState === undefined ? internalState : externalState;
  var setState = React__default.useCallback(function (event, updateState) {
    return setInternalState(function (prevState) {
      var newState = updateState !== undefined ? updateState : !prevState;
      if (callback) callback(newState);
      return newState;
    });
  }, [callback]);
  return [state, setState];
};
var toCapsCase$1 = function toCapsCase(string) {
  return "".concat(string[0].toUpperCase()).concat(string.slice(1).toLowerCase());
};

function VideoComponentTypeTableBody(_ref) {
  var className = _ref.className,
      videoComponentType = _ref.videoComponentType;
  var video = React__default.useMemo(function () {
    return parseVideoComponent(videoComponentType);
  }, [videoComponentType]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableHead, null, "Video Track"), /*#__PURE__*/React__default.createElement(TableBody$1, {
    className: className
  }, /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Video Codec",
    value: video.videoFormat || video.videoCodec
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "SMPTE",
    value: video.smpte
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Frame Rate",
    value: video.frameRate
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Width",
    value: video.width
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Height",
    value: video.height
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Aspect Ratio",
    value: video.aspectRatio
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Video Bitrate",
    value: video.videoBitrate
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Color Space",
    value: video.colorSpace
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Chroma Subsampling",
    value: video.chromaSubsampling
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Field Order",
    value: video.fieldOrder,
    formatValue: toCapsCase$1
  })));
}

var EXIF = 'EXIF';
var IPTC = 'IPTC';
var XMP = 'XMP';
var EMBEDDED_KEYS = [{
  prefix: 'image_exif_',
  label: EXIF
}, {
  prefix: 'image_iptc_',
  label: IPTC
}, {
  prefix: 'image_xmp',
  label: XMP
}];

var getEmbeddedMetadata = function getEmbeddedMetadata() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$videoMetadata = _ref.videoMetadata,
      videoMetadata = _ref$videoMetadata === void 0 ? {} : _ref$videoMetadata;

  return Object.entries(videoMetadata).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    var embeddedKey = EMBEDDED_KEYS.find(function (_ref4) {
      var prefix = _ref4.prefix;
      return key.startsWith(prefix);
    });

    if (embeddedKey) {
      var newAcc = _objectSpread2({}, acc);

      if (newAcc[embeddedKey.label] === undefined) newAcc[embeddedKey.label] = {};
      newAcc[embeddedKey.label][key.replace(embeddedKey.prefix, '')] = value;
      return newAcc;
    }

    return acc;
  }, {});
};

function ImageTypeTableBody(_ref5) {
  var className = _ref5.className,
      videoComponentType = _ref5.videoComponentType;
  var image = React__default.useMemo(function () {
    return parseVideoComponent(videoComponentType);
  }, [videoComponentType]);
  var embeddedMetadata = getEmbeddedMetadata(image);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableHead, null, "Image"), /*#__PURE__*/React__default.createElement(TableBody$1, {
    className: className
  }, /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Format",
    value: image.videoFormat || image.videoCodec
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Width",
    value: image.width
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Height",
    value: image.height
  })), Object.entries(embeddedMetadata).map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        label = _ref7[0],
        values = _ref7[1];

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: label
    }, /*#__PURE__*/React__default.createElement(TableHead, null, label), /*#__PURE__*/React__default.createElement(TableBody$1, null, Object.entries(values).map(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
          key = _ref9[0],
          value = _ref9[1];

      return /*#__PURE__*/React__default.createElement(TableRow$2, {
        key: key,
        label: key.replace('_', ' '),
        value: value
      });
    })));
  }));
}

function PdfTypeTableBody(_ref) {
  var className = _ref.className,
      videoComponentType = _ref.videoComponentType;
  var pdf = React__default.useMemo(function () {
    return parseVideoComponent(videoComponentType);
  }, [videoComponentType]);
  return /*#__PURE__*/React__default.createElement(TableBody$1, {
    className: className
  }, /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Pages",
    value: pdf.videoMetadata.image_pages
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Width",
    value: pdf.width
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Height",
    value: pdf.height
  }));
}

var VIDEO_MEDIATYPE = 'VIDEO_MEDIATYPE';
var AUDIO_MEDIATYPE = 'AUDIO_MEDIATYPE';
var IMAGE_MEDIATYPE = 'IMAGE_MEDIATYPE';
var PDF_MEDIATYPE = 'PDF_MEDIATYPE';
var BINARY_MEDIATYPE = 'BINARY_MEDIATYPE';

var getMediaType = function getMediaType() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$mimeType = _ref.mimeType,
      mimeTypeList = _ref$mimeType === void 0 ? [] : _ref$mimeType,
      containerComponent = _ref.containerComponent,
      audioComponentList = _ref.audioComponent,
      videoComponentList = _ref.videoComponent,
      binaryComponentList = _ref.binaryComponent;

  var _mimeTypeList = _slicedToArray(mimeTypeList, 1),
      mimeType = _mimeTypeList[0];

  if (mimeType) {
    if (mimeType.startsWith('video')) return VIDEO_MEDIATYPE;
    if (mimeType.startsWith('audio')) return AUDIO_MEDIATYPE;
    if (mimeType.startsWith('image')) return IMAGE_MEDIATYPE;
  }

  if (containerComponent) {
    if (containerComponent.format === 'PDF') return PDF_MEDIATYPE;
  }

  if (audioComponentList && videoComponentList) return VIDEO_MEDIATYPE;
  if (audioComponentList) return AUDIO_MEDIATYPE;

  if (videoComponentList && videoComponentList.length) {
    var _videoComponentList = _slicedToArray(videoComponentList, 1),
        videoComponent = _videoComponentList[0];

    if (videoComponent.duration) return VIDEO_MEDIATYPE;
    return IMAGE_MEDIATYPE;
  }

  if (binaryComponentList) return BINARY_MEDIATYPE;
  return undefined;
};

function ShapeTypeTableBody(_ref2) {
  var className = _ref2.className,
      shapeType = _ref2.shapeType;
  var shape = React__default.useMemo(function () {
    return parseShapeType(shapeType);
  }, [shapeType]);
  var containerComponentType = shapeType.containerComponent,
      _shapeType$videoCompo = shapeType.videoComponent,
      videoComponentList = _shapeType$videoCompo === void 0 ? [] : _shapeType$videoCompo,
      _shapeType$audioCompo = shapeType.audioComponent,
      audioComponentList = _shapeType$audioCompo === void 0 ? [] : _shapeType$audioCompo;
  var mediaType = getMediaType(shapeType);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableBody$1, {
    className: className
  }, /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Mime-Type",
    value: shape.mimeType
  }), shape.fileSize && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "File Size",
    value: shape.fileSize
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Checksum",
    value: shape.hash
  }))), (mediaType === VIDEO_MEDIATYPE || mediaType === AUDIO_MEDIATYPE) && /*#__PURE__*/React__default.createElement(ContainerComponentTypeTableBody, {
    containerComponentType: containerComponentType
  }), mediaType === VIDEO_MEDIATYPE && videoComponentList.map(function (videoComponentType) {
    return /*#__PURE__*/React__default.createElement(VideoComponentTypeTableBody, {
      key: videoComponentType.id,
      videoComponentType: videoComponentType
    });
  }), (mediaType === VIDEO_MEDIATYPE || mediaType === AUDIO_MEDIATYPE) && audioComponentList.map(function (audioComponentType) {
    return /*#__PURE__*/React__default.createElement(AudioComponentTypeTableBody, {
      key: audioComponentType.id,
      audioComponentType: audioComponentType
    });
  }), mediaType === IMAGE_MEDIATYPE && videoComponentList.map(function (videoComponentType) {
    return /*#__PURE__*/React__default.createElement(ImageTypeTableBody, {
      key: videoComponentType.id,
      videoComponentType: videoComponentType
    });
  }), mediaType === PDF_MEDIATYPE && videoComponentList.map(function (videoComponentType) {
    return /*#__PURE__*/React__default.createElement(PdfTypeTableBody, {
      key: videoComponentType.id,
      videoComponentType: videoComponentType
    });
  }));
}

function ItemShapeRow(_ref) {
  var shapeType = _ref.shapeType,
      TableRowProps = _ref.TableRowProps,
      _ref$canExpand = _ref.canExpand,
      canExpand = _ref$canExpand === void 0 ? true : _ref$canExpand;
  var shape = React__default.useMemo(function () {
    return parseShapeType(shapeType);
  }, [shapeType]);

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var toggleOpen = function toggleOpen() {
    return setOpen(function (prevOpen) {
      return !prevOpen;
    });
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableRow$3$1 // eslint-disable-next-line react/jsx-props-no-spreading
  , TableRowProps, /*#__PURE__*/React__default.createElement(TableCell$1, null, canExpand && /*#__PURE__*/React__default.createElement(IconButton, {
    size: "small",
    onClick: toggleOpen
  }, open ? /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null) : /*#__PURE__*/React__default.createElement(ChevronRightIcon, null))), /*#__PURE__*/React__default.createElement(TableCell$1, null, shape.tag), /*#__PURE__*/React__default.createElement(Hidden, {
    smDown: true
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, shape.containerFormat), /*#__PURE__*/React__default.createElement(TableCell$1, null, shape.videoCodec), /*#__PURE__*/React__default.createElement(TableCell$1, null, shape.audioCodec), /*#__PURE__*/React__default.createElement(TableCell$1, null, shape.frameRate)), /*#__PURE__*/React__default.createElement(TableCell$1, null, shape.dimension), /*#__PURE__*/React__default.createElement(TableCell$1, null, shape.fileSize), /*#__PURE__*/React__default.createElement(TableCell$1, null, shape.fileSizeBytes && /*#__PURE__*/React__default.createElement(IconButton, {
    href: shape.uri
  }, /*#__PURE__*/React__default.createElement(CloudDownload, null)))), canExpand && /*#__PURE__*/React__default.createElement(TableRow$3$1, null, /*#__PURE__*/React__default.createElement(TableCell$1 // hardcoded to the number of cells in the row above
  , {
    colSpan: 9
  }, /*#__PURE__*/React__default.createElement(Collapse, {
    "in": open,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/React__default.createElement(Box, {
    margin: 1
  }, /*#__PURE__*/React__default.createElement(Table$1, {
    size: "small",
    padding: "none"
  }, /*#__PURE__*/React__default.createElement(ShapeTypeTableBody, {
    shapeType: shapeType
  })))))));
}

var styles$D = function styles() {
  return {
    root: {
      width: '100%'
    },
    ItemShapeRow: {}
  };
};
function ItemShapeTable(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      itemType = _ref.itemType,
      canExpand = _ref.canExpand;
  var _itemType$shape = itemType.shape,
      shape = _itemType$shape === void 0 ? [] : _itemType$shape;
  return /*#__PURE__*/React__default.createElement(Table$1, {
    className: clsx(classes.root, className),
    size: "small",
    padding: "none"
  }, /*#__PURE__*/React__default.createElement(TableHead$1$1, null, /*#__PURE__*/React__default.createElement(TableRow$3$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Tag"), /*#__PURE__*/React__default.createElement(Hidden, {
    smDown: true
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, "Container"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Video"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Audio"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Frame Rate")), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Picture Size"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "File Size"), /*#__PURE__*/React__default.createElement(TableCell$1, null))), /*#__PURE__*/React__default.createElement(TableBody$1, null, shape.map(function (shapeType) {
    return /*#__PURE__*/React__default.createElement(ItemShapeRow, {
      key: shapeType.id,
      className: classes.ItemShapeRow,
      shapeType: shapeType,
      TableRowProps: {
        hover: true
      },
      canExpand: canExpand
    });
  })));
}
ItemShapeTable.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  itemType: index.ItemType,

  /**
   * Show the shape expansion information.
   */
  canExpand: propTypes.bool
};
ItemShapeTable.defaultProps = {
  className: undefined,
  classes: {},
  itemType: {},
  canExpand: true
};

var ItemShapeTable$1 = withStyles(styles$D, {
  name: 'VdtItemShapeTable'
})(ItemShapeTable);

var queryParams = {
  content: 'shape',
  methodMetadata: [{
    key: 'format',
    value: 'SIGNED-AUTO'
  }, {
    key: 'contentDisposition',
    value: 'attachment'
  }]
};
function ItemShapeTab(_ref) {
  var itemId = _ref.itemId;
  return /*#__PURE__*/React__default.createElement(GetItem, {
    itemId: itemId,
    queryParams: queryParams
  }, /*#__PURE__*/React__default.createElement(ItemShapeTable$1, null));
}

function MetadataTypeTableBody(_ref) {
  var className = _ref.className,
      metadataType = _ref.metadataType;

  var _React$useMemo = React__default.useMemo(function () {
    return parseMetadataType(metadataType, {
      joinValue: ',',
      flat: true
    });
  }, [metadataType]),
      originalFilename = _React$useMemo.originalFilename,
      mediaType = _React$useMemo.mediaType;

  return /*#__PURE__*/React__default.createElement(TableBody$1, {
    className: className
  }, /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Original Filename",
    value: originalFilename
  }), /*#__PURE__*/React__default.createElement(TableRow$2, {
    label: "Media Type",
    value: mediaType,
    formatValue: toCapsCase$1
  }));
}

var styles$E = function styles() {
  return {
    root: {
      width: '100%'
    }
  };
};
function ItemSourceTable(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      itemType = _ref.itemType;
  var _itemType$shape = itemType.shape,
      shapeTypeList = _itemType$shape === void 0 ? [] : _itemType$shape,
      metadataType = itemType.metadata;

  var _shapeTypeList = _slicedToArray(shapeTypeList, 1),
      shapeType = _shapeTypeList[0];

  return /*#__PURE__*/React__default.createElement(Table$1, {
    className: clsx(classes.root, className),
    size: "small",
    padding: "none"
  }, metadataType && /*#__PURE__*/React__default.createElement(MetadataTypeTableBody, {
    metadataType: metadataType
  }), shapeType && /*#__PURE__*/React__default.createElement(ShapeTypeTableBody, {
    shapeType: shapeType
  }));
}
ItemSourceTable.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  itemType: index.ItemType.isRequired
};
ItemSourceTable.defaultProps = {
  className: undefined,
  classes: {}
};

var ItemSourceTable$1 = withStyles(styles$E, {
  name: 'VdtItemSourceTable'
})(ItemSourceTable);

var queryParams$1 = {
  content: ['shape', 'metadata'],
  tag: 'original',
  interval: 'generic',
  field: ['mediaType', 'originalFilename'],
  group: ''
};
function ItemSourceTab(_ref) {
  var itemId = _ref.itemId;
  return /*#__PURE__*/React__default.createElement(GetItem, {
    itemId: itemId,
    queryParams: queryParams$1
  }, /*#__PURE__*/React__default.createElement(ItemSourceTable$1, null));
}

var styles$F = function styles(theme) {
  return {
    root: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.common.black,
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5)
    },
    label: _objectSpread2(_objectSpread2({}, theme.typography.caption), {}, {
      color: 'inherit'
    })
  };
};
function MediaCardThumbnailLabel(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      label = _ref.label;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement("span", {
    className: classes.label
  }, label));
}
MediaCardThumbnailLabel.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  label: propTypes.string
};
MediaCardThumbnailLabel.defaultProps = {
  className: undefined,
  classes: {},
  label: undefined
};

var MediaCardThumbnailLabel$1 = withStyles(styles$F, {
  name: 'VdtMediaCardThumbnailLabel'
})(MediaCardThumbnailLabel);

var styles$G = function styles(theme) {
  return {
    root: {},
    container: {
      position: 'relative',
      overflow: 'hidden'
    },
    onClick: {
      cursor: 'pointer'
    },
    scrubProgress: {
      height: 4,
      transition: 'width 0.5s linear',
      position: 'absolute',
      bottom: 0,
      left: 0,
      zIndex: 4,
      backgroundColor: theme.palette.error.main
    },
    background: {
      transform: 'scale(1.1)',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      zIndex: 1,
      height: '100%',
      width: '100%',
      position: 'absolute'
    },
    backgroundHasImage: {
      filter: 'blur(20px) grayscale(60%)'
    },
    img: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 'auto',
      height: 'auto',
      maxWidth: '100%',
      maxHeight: '100%',
      zIndex: 2
    },
    labelContainer: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      zIndex: 3,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    },
    labelTop: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    labelBottom: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    labelLeftTop: {},
    labelRightTop: {},
    labelLeftBottom: {},
    labelRightBottom: {}
  };
};
function MediaCardThumbnail(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      Component = _ref.component,
      image = _ref.image,
      height = _ref.height,
      width = _ref.width,
      primaryColor = _ref.primaryColor,
      onClick = _ref.onClick,
      labelLeftTop = _ref.labelLeftTop,
      LabelComponentLeftTop = _ref.LabelComponentLeftTop,
      LabelPropsLeftTop = _ref.LabelPropsLeftTop,
      labelLeftBottom = _ref.labelLeftBottom,
      LabelComponentLeftBottom = _ref.LabelComponentLeftBottom,
      LabelPropsLeftBottom = _ref.LabelPropsLeftBottom,
      labelRightTop = _ref.labelRightTop,
      LabelComponentRightTop = _ref.LabelComponentRightTop,
      LabelPropsRightTop = _ref.LabelPropsRightTop,
      labelRightBottom = _ref.labelRightBottom,
      LabelComponentRightBottom = _ref.LabelComponentRightBottom,
      LabelPropsRightBottom = _ref.LabelPropsRightBottom,
      innerProps = _ref.innerProps,
      scrubOnHover = _ref.scrubOnHover,
      props = _objectWithoutProperties(_ref, ["classes", "className", "component", "image", "height", "width", "primaryColor", "onClick", "labelLeftTop", "LabelComponentLeftTop", "LabelPropsLeftTop", "labelLeftBottom", "LabelComponentLeftBottom", "LabelPropsLeftBottom", "labelRightTop", "LabelComponentRightTop", "LabelPropsRightTop", "labelRightBottom", "LabelComponentRightBottom", "LabelPropsRightBottom", "innerProps", "scrubOnHover"]);

  var _innerProps$itemType = innerProps.itemType,
      itemType = _innerProps$itemType === void 0 ? {} : _innerProps$itemType;
  var _itemType$thumbnails = itemType.thumbnails,
      thumbnails = _itemType$thumbnails === void 0 ? {} : _itemType$thumbnails;
  var _thumbnails$uri = thumbnails.uri,
      srcList = _thumbnails$uri === void 0 ? [] : _thumbnails$uri;
  if (image && srcList.length === 0) srcList = [image];

  var _useThumbnailScrub = useThumbnailScrub(srcList),
      onMouseEnter = _useThumbnailScrub.onMouseEnter,
      onMouseLeave = _useThumbnailScrub.onMouseLeave,
      imageSrc = _useThumbnailScrub.imageSrc,
      scrubWidth = _useThumbnailScrub.width;

  return /*#__PURE__*/React__default.createElement(Component, _extends({
    className: clsx(classes.root, className, _defineProperty({}, classes.onClick, onClick)),
    onMouseEnter: scrubOnHover === true ? onMouseEnter : undefined,
    onMouseLeave: scrubOnHover === true ? onMouseLeave : undefined,
    onClick: onClick // eslint-disable-next-line react/jsx-props-no-spreading

  }, props), /*#__PURE__*/React__default.createElement("div", {
    className: classes.container,
    style: {
      height: height,
      width: width
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.background, _defineProperty({}, classes.backgroundHasImage, image)),
    style: {
      backgroundColor: image ? undefined : primaryColor,
      backgroundImage: image ? "url(".concat(image, ")") : undefined
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    className: classes.img,
    src: imageSrc || image,
    alt: ""
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classes.labelContainer
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.labelTop
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.labelLeftTop
  }, /*#__PURE__*/React__default.createElement(LabelComponentLeftTop, _extends({
    label: labelLeftTop,
    innerProps: innerProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, LabelPropsLeftTop))), /*#__PURE__*/React__default.createElement("div", {
    className: classes.labelRightTop
  }, /*#__PURE__*/React__default.createElement(LabelComponentRightTop, _extends({
    label: labelRightTop,
    innerProps: innerProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, LabelPropsRightTop)))), /*#__PURE__*/React__default.createElement("div", {
    className: classes.labelBottom
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.labelLeftBottom
  }, /*#__PURE__*/React__default.createElement(LabelComponentLeftBottom, _extends({
    label: labelLeftBottom,
    innerProps: innerProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, LabelPropsLeftBottom))), /*#__PURE__*/React__default.createElement("div", {
    className: classes.labelRightBottom
  }, /*#__PURE__*/React__default.createElement(LabelComponentRightBottom, _extends({
    label: labelRightBottom,
    innerProps: innerProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, LabelPropsRightBottom))))), scrubOnHover && /*#__PURE__*/React__default.createElement("div", {
    className: classes.scrubProgress,
    style: {
      width: scrubWidth
    }
  })));
}
MediaCardThumbnail.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes.oneOfType([propTypes.string, propTypes.elementType]),
  image: propTypes.string,
  height: propTypes.oneOfType([propTypes.string, propTypes.number]),
  width: propTypes.oneOfType([propTypes.string, propTypes.number]),
  primaryColor: propTypes.string,
  onClick: propTypes.func,
  labelLeftTop: propTypes.string,
  LabelComponentLeftTop: propTypes.elementType,
  LabelPropsLeftTop: propTypes.objectOf(propTypes.any),
  labelLeftBottom: propTypes.string,
  LabelComponentLeftBottom: propTypes.elementType,
  LabelPropsLeftBottom: propTypes.objectOf(propTypes.any),
  labelRightTop: propTypes.string,
  LabelComponentRightTop: propTypes.elementType,
  LabelPropsRightTop: propTypes.objectOf(propTypes.any),
  labelRightBottom: propTypes.string,
  LabelComponentRightBottom: propTypes.elementType,
  LabelPropsRightBottom: propTypes.objectOf(propTypes.any),
  innerProps: propTypes.objectOf(propTypes.any),
  scrubOnHover: propTypes.bool
};
MediaCardThumbnail.defaultProps = {
  className: undefined,
  classes: {},
  component: 'div',
  image: undefined,
  height: 180,
  width: '100%',
  primaryColor: undefined,
  onClick: undefined,
  labelLeftTop: undefined,
  LabelComponentLeftTop: MediaCardThumbnailLabel$1,
  LabelPropsLeftTop: {},
  labelLeftBottom: undefined,
  LabelComponentLeftBottom: MediaCardThumbnailLabel$1,
  LabelPropsLeftBottom: {},
  labelRightTop: undefined,
  LabelComponentRightTop: MediaCardThumbnailLabel$1,
  LabelPropsRightTop: {},
  labelRightBottom: undefined,
  LabelComponentRightBottom: MediaCardThumbnailLabel$1,
  LabelPropsRightBottom: {},
  innerProps: {},
  scrubOnHover: true
};

var MediaCardThumbnail$1 = withStyles(styles$G, {
  name: 'VdtMediaCardThumbnail'
})(MediaCardThumbnail);

var styles$H = function styles(theme) {
  return {
    root: {},
    posterRoot: {
      width: 320,
      margin: theme.spacing(2),
      cursor: 'pointer'
    }
  };
};

function ItemPosterList(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      _ref$imgList = _ref.imgList,
      imgList = _ref$imgList === void 0 ? [] : _ref$imgList,
      handleOpen = _ref.handleOpen,
      _ref$MediaCardThumbna = _ref.MediaCardThumbnailComponent,
      MediaCardThumbnailComponent = _ref$MediaCardThumbna === void 0 ? MediaCardThumbnail$1 : _ref$MediaCardThumbna,
      _ref$MediaCardThumbna2 = _ref.MediaCardThumbnailProps,
      MediaCardThumbnailProps = _ref$MediaCardThumbna2 === void 0 ? {} : _ref$MediaCardThumbna2;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className, 'VdtItemPosterList-root')
  }, imgList.map(function (_ref2, posterIdx) {
    var thumbnailUri = _ref2.thumbnailUri,
        time = _ref2.time;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line max-len
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      React__default.createElement("div", {
        key: thumbnailUri,
        className: clsx(classes.posterRoot, 'VdtItemPosterList-posterRoot'),
        onClick: handleOpen ? function () {
          return handleOpen(posterIdx);
        } : undefined
      }, /*#__PURE__*/React__default.createElement(MediaCardThumbnailComponent, _extends({
        image: thumbnailUri,
        labelRightBottom: time.toDuration({
          format: 'hhmmss'
        }) // eslint-disable-next-line react/jsx-props-no-spreading

      }, MediaCardThumbnailProps)))
    );
  }));
}

var ItemPosterList$1 = withStyles(styles$H, {
  name: 'VdtItemPosterList'
})(ItemPosterList);

function ItemPosterDialog(_ref) {
  var open = _ref.open,
      posterUri = _ref.posterUri,
      handleClose = _ref.handleClose,
      handleBefore = _ref.handleBefore,
      handleNext = _ref.handleNext,
      handleDownload = _ref.handleDownload;
  return /*#__PURE__*/React__default.createElement(Dialog$1, {
    fullScreen: true,
    open: open,
    onClose: handleClose
  }, /*#__PURE__*/React__default.createElement(Toolbar, null, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    width: "100%"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    onClick: handleClose
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    disabled: !handleBefore,
    onClick: handleBefore
  }, /*#__PURE__*/React__default.createElement(NavigateBeforeIcon, null)), /*#__PURE__*/React__default.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    disabled: !handleNext,
    onClick: handleNext
  }, /*#__PURE__*/React__default.createElement(NavigateNextIcon, null))), /*#__PURE__*/React__default.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    onClick: handleDownload
  }, /*#__PURE__*/React__default.createElement(SaveAltIcon, null)))), open && /*#__PURE__*/React__default.createElement(Box, {
    width: "100vw",
    height: "80vh",
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: posterUri,
    alt: "",
    style: {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  })));
}

var ApiClient = utils.defaultClient;

var findThumbnailUri = function findThumbnailUri(posterUri, thumbnailList) {
  var thisPoster = posterUri.split('poster')[1].split('?hash')[0];
  var time = formatTimeCodeText(thisPoster.split('/').pop());
  var thumbnailUri = thumbnailList.find(function (thisThumbnail) {
    return thisPoster === thisThumbnail.split('thumbnail')[1].split('?hash')[0];
  });
  return {
    posterUri: posterUri,
    thumbnailUri: thumbnailUri,
    time: time
  };
};

var downloadFile = function downloadFile(url, fileName) {
  ApiClient({
    url: url,
    method: 'GET',
    responseType: 'blob'
  }).then(function (_ref) {
    var data = _ref.data;
    var objectUrl = window.URL.createObjectURL(new Blob([data]));
    var link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', fileName);
    link.click();
    window.URL.revokeObjectURL(objectUrl);
  });
};

function ItemPoster(_ref2) {
  var _ref2$itemType = _ref2.itemType,
      itemType = _ref2$itemType === void 0 ? {} : _ref2$itemType;
  var _itemType$posters = itemType.posters;
  _itemType$posters = _itemType$posters === void 0 ? {} : _itemType$posters;
  var _itemType$posters$uri = _itemType$posters.uri,
      posterList = _itemType$posters$uri === void 0 ? [] : _itemType$posters$uri,
      _itemType$thumbnails = itemType.thumbnails;
  _itemType$thumbnails = _itemType$thumbnails === void 0 ? {} : _itemType$thumbnails;
  var _itemType$thumbnails$ = _itemType$thumbnails.uri,
      thumbnailList = _itemType$thumbnails$ === void 0 ? [] : _itemType$thumbnails$;
  var imgList = React__default.useMemo(function () {
    return posterList.map(function (posterUri) {
      return findThumbnailUri(posterUri, thumbnailList);
    });
  }, [posterList, thumbnailList]);

  var _React$useState = React__default.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      posterIdx = _React$useState2[0],
      setPosterIdx = _React$useState2[1];

  var open = posterIdx !== undefined;

  var _ref3 = imgList[posterIdx] || {},
      posterUri = _ref3.posterUri;

  var handleOpen = function handleOpen(newPosterIdx) {
    return setPosterIdx(newPosterIdx);
  };

  var handleClose = function handleClose() {
    return setPosterIdx();
  };

  var handleDownload = function handleDownload() {
    return downloadFile(posterUri.replace('APInoauth', 'API'), 'poster.jpeg');
  };

  var handleBefore = posterIdx !== 0 ? function () {
    return setPosterIdx(posterIdx - 1);
  } : undefined;
  var handleNext = posterIdx + 1 !== imgList.length ? function () {
    return setPosterIdx(posterIdx + 1);
  } : undefined;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ItemPosterList$1, {
    imgList: imgList,
    handleOpen: handleOpen
  }), /*#__PURE__*/React__default.createElement(ItemPosterDialog, {
    open: open,
    posterUri: posterUri,
    handleClose: handleClose,
    handleBefore: handleBefore,
    handleNext: handleNext,
    handleDownload: handleDownload
  }));
}

function ItemPosterTab(_ref) {
  var itemId = _ref.itemId,
      _ref$sampleRate = _ref.sampleRate,
      sampleRate = _ref$sampleRate === void 0 ? 'PAL' : _ref$sampleRate;
  var queryParams = {
    content: 'poster,thumbnail',
    'noauth-url': true,
    url: 'false',
    sampleRate: sampleRate
  };
  return /*#__PURE__*/React__default.createElement(GetItem, {
    itemId: itemId,
    queryParams: queryParams
  }, /*#__PURE__*/React__default.createElement(ItemPoster, null));
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */

var FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */

var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';
/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Detect free variable `global` from Node.js. */

var freeGlobal = _typeof(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue(object, key) {
  return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */


function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;

  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }

  return result;
}
/** Used for built-in method references. */


var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */

var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */


var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$3).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */

var _Symbol$1 = root.Symbol,
    splice = arrayProto.splice;
/* Built-in method references that are verified to be native. */

var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol$1 ? _Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */


function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */


function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */


function listCacheClear() {
  this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */


function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */


function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */


function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$3.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    object[key] = value;
  }
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */


function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */


function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }

  return index && index == length ? object : undefined;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */


function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */


function baseSet(object, path, value, customizer) {
  if (!isObject$1(object)) {
    return object;
  }

  path = isKey(path, object) ? [path] : castPath(path);
  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;

      if (newValue === undefined) {
        newValue = isObject$1(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }

    assignValue(nested, key, newValue);
    nested = nested[key];
  }

  return object;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */


function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * The base implementation of `_.update`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to update.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */


function baseUpdate(object, path, updater, customizer) {
  return baseSet(object, path, updater(baseGet(object, path)), customizer);
}
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */


function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */


function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */


function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */


function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */


function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }

  var type = _typeof(value);

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */


function isKeyable(value) {
  var type = _typeof(value);

  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */


var stringToPath = memoize(function (string) {
  string = toString$1(string);
  var result = [];

  if (reLeadingDot.test(string)) {
    result.push('');
  }

  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */


function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */


function memoize(func, resolver) {
  if (typeof func != 'function' || resolver && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };

  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
} // Assign cache to `_.memoize`.


memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq(value, other) {
  return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */


var isArray = Array.isArray;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject$1(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject$1(value) {
  var type = _typeof(value);

  return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString$1(value) {
  return value == null ? '' : baseToString(value);
}
/**
 * This method is like `_.set` except that accepts `updater` to produce the
 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
 * is invoked with one argument: (value).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
 * console.log(object.a[0].b.c);
 * // => 9
 *
 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
 * console.log(object.x[0].y.z);
 * // => 0
 */


function update(object, path, updater) {
  return object == null ? object : baseUpdate(object, path, castFunction(updater));
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */


function identity(value) {
  return value;
}

var lodash_update = update;

var styles$I = function styles(theme) {
  return {
    root: {
      width: 'inherit',
      maxWidth: 320,
      height: 'inherit',
      borderColor: 'transparent',
      borderWidth: 0.7,
      borderStyle: 'solid',
      transition: 'border-color .2s ease-out',
      '&:hover': {
        '& .MuiIconButton-root': {
          color: theme.palette.primary.main
        },
        '& .MuiAvatar-square': {
          color: theme.palette.type === 'dark' ? theme.palette.grey[500] : theme.palette.grey[100],
          backgroundColor: theme.palette.primary.main
        }
      },
      '& .MuiCardHeader-root': {
        backgroundColor: theme.palette.type === 'dark' ? emphasize(theme.palette.background.paper, 0.1) : undefined,
        color: theme.palette.type === 'dark' ? theme.palette.common.white : undefined
      }
    },
    checked: {
      borderColor: theme.palette.secondary.main
    }
  };
};

function MediaCardCard(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      checked = _ref.checked,
      handleHover = _ref.handleHover,
      children = _ref.children,
      innerProps = _ref.innerProps,
      CardProps = _objectWithoutProperties(_ref, ["className", "classes", "checked", "handleHover", "children", "innerProps"]);

  return /*#__PURE__*/React__default.createElement(Card$1, _extends({
    className: clsx(classes.root, _defineProperty({}, classes.checked, checked), 'VdtMediaCardCard-root', className),
    onMouseEnter: handleHover,
    onMouseLeave: handleHover,
    raised: false,
    elevation: 0 // eslint-disable-next-line react/jsx-props-no-spreading

  }, CardProps), children);
}

var MediaCardCard$1 = withStyles(styles$I, {
  name: 'VdtMediaCardCard'
})(MediaCardCard);

var styles$J = {
  root: {
    transition: 'background-color .2s ease-out'
  },
  colorDefaultSkeleton: {
    backgroundColor: 'unset'
  }
};
function MediaCardAvatar(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      avatar = _ref.avatar,
      _ref$skeleton = _ref.skeleton,
      skeleton = _ref$skeleton === void 0 ? false : _ref$skeleton,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'square' : _ref$variant,
      _ref$MimeTypeComponen = _ref.MimeTypeComponent,
      MimeTypeComponent = _ref$MimeTypeComponen === void 0 ? MimeTypeIcon$1 : _ref$MimeTypeComponen,
      _ref$MimeTypeProps = _ref.MimeTypeProps,
      MimeTypeProps = _ref$MimeTypeProps === void 0 ? {} : _ref$MimeTypeProps,
      _ref$SkeletonProps = _ref.SkeletonProps,
      SkeletonProps = _ref$SkeletonProps === void 0 ? {} : _ref$SkeletonProps,
      _ref$AvatarProps = _ref.AvatarProps,
      AvatarProps = _ref$AvatarProps === void 0 ? {} : _ref$AvatarProps;
  return /*#__PURE__*/React__default.createElement(Avatar, _extends({
    className: clsx(className, 'VdtMediaCardAvatar-root'),
    style: {
      transition: 'background-color .2s ease-out'
    },
    variant: variant,
    classes: {
      colorDefault: skeleton ? classes.colorDefaultSkeleton : undefined
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, AvatarProps), skeleton ? /*#__PURE__*/React__default.createElement(Skeleton, _extends({
    variant: variant === 'square' ? 'rect' : variant,
    height: "100%",
    width: "100%" // eslint-disable-next-line react/jsx-props-no-spreading

  }, SkeletonProps)) : /*#__PURE__*/React__default.createElement(MimeTypeComponent, _extends({
    mimeType: avatar // eslint-disable-next-line react/jsx-props-no-spreading

  }, MimeTypeProps)));
}
MediaCardAvatar.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.string),
  avatar: propTypes.string,
  skeleton: propTypes.bool,
  variant: propTypes.oneOf(['circle', 'circular', 'rounded', 'square']),
  MimeTypeComponent: propTypes.elementType,
  MimeTypeProps: propTypes.objectOf(propTypes.any),
  SkeletonProps: propTypes.objectOf(propTypes.any),
  AvatarProps: propTypes.objectOf(propTypes.any)
};
MediaCardAvatar.defaultProps = {
  className: undefined,
  classes: {},
  avatar: undefined,
  skeleton: false,
  variant: 'square',
  MimeTypeComponent: MimeTypeIcon$1,
  MimeTypeProps: {},
  SkeletonProps: {},
  AvatarProps: {}
};
var MediaCardAvatar$1 = withStyles(styles$J, {
  name: 'VdtMediaCardAvatar'
})(MediaCardAvatar);

var useStyles$1 = makeStyles({
  colorDefault: {
    color: function color(props) {
      return props.primaryColor;
    },
    backgroundColor: 'transparent'
  }
});
function MediaCardMenu(_ref) {
  var hover = _ref.hover,
      primaryColor = _ref.primaryColor;
  var classes = useStyles$1({
    primaryColor: primaryColor
  });

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleMenuClick = function handleMenuClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleMenuClose = function handleMenuClose() {
    setAnchorEl(null);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      visibility: hover ? 'visible' : 'hidden',
      transition: 'visibility .2s ease-out'
    }
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    onClick: handleMenuClick,
    component: ButtonBase,
    disableRipple: true,
    classes: {
      colorDefault: classes.colorDefault
    }
  }, /*#__PURE__*/React__default.createElement(MoreVertIcon, null)), /*#__PURE__*/React__default.createElement(Menu, {
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleMenuClose,
    elevation: 0,
    PaperProps: {
      square: true
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem, null, "First"), /*#__PURE__*/React__default.createElement(MenuItem, null, "Second"), /*#__PURE__*/React__default.createElement(MenuItem, null, "Third")));
}

var useStyles$2 = makeStyles({
  root: {
    paddingLeft: 8,
    paddingRight: 0,
    paddingTop: 8,
    paddingBottom: 8
  },
  action: {
    margin: 0
  }
});
function MediaCardHeader(_ref) {
  var className = _ref.className,
      primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor,
      title = _ref.title,
      _ref$titleTypographyP = _ref.titleTypographyProps,
      titleTypographyProps = _ref$titleTypographyP === void 0 ? {
    noWrap: true,
    style: {
      width: 220
    }
  } : _ref$titleTypographyP,
      subheader = _ref.subheader,
      _ref$subheaderTypogra = _ref.subheaderTypographyProps,
      subheaderTypographyProps = _ref$subheaderTypogra === void 0 ? {
    noWrap: true,
    style: {
      width: 220
    }
  } : _ref$subheaderTypogra,
      hover = _ref.hover,
      checked = _ref.checked,
      handleChecked = _ref.handleChecked,
      avatar = _ref.avatar,
      _ref$AvatarComponent = _ref.AvatarComponent,
      AvatarComponent = _ref$AvatarComponent === void 0 ? MediaCardAvatar$1 : _ref$AvatarComponent,
      _ref$AvatarProps = _ref.AvatarProps,
      AvatarProps = _ref$AvatarProps === void 0 ? {} : _ref$AvatarProps,
      _ref$MenuComponent = _ref.MenuComponent,
      MenuComponent = _ref$MenuComponent === void 0 ? MediaCardMenu : _ref$MenuComponent,
      _ref$MenuProps = _ref.MenuProps,
      MenuProps = _ref$MenuProps === void 0 ? {} : _ref$MenuProps,
      _ref$innerProps = _ref.innerProps,
      innerProps = _ref$innerProps === void 0 ? {} : _ref$innerProps;
  var classes = useStyles$2();
  return /*#__PURE__*/React__default.createElement(CardHeader$1, {
    className: className,
    avatar: AvatarComponent && /*#__PURE__*/React__default.createElement(AvatarComponent, _extends({
      primaryColor: primaryColor,
      secondaryColor: secondaryColor,
      hover: hover,
      avatar: avatar,
      handleChecked: handleChecked,
      checked: checked,
      innerProps: innerProps // eslint-disable-next-line react/jsx-props-no-spreading

    }, AvatarProps)),
    action: MenuComponent && /*#__PURE__*/React__default.createElement(MenuComponent, _extends({
      hover: hover,
      innerProps: innerProps,
      primaryColor: primaryColor,
      secondaryColor: secondaryColor,
      handleChecked: handleChecked,
      checked: checked // eslint-disable-next-line react/jsx-props-no-spreading

    }, MenuProps)),
    title: title,
    titleTypographyProps: titleTypographyProps,
    subheader: subheader,
    subheaderTypographyProps: subheaderTypographyProps,
    classes: {
      root: classes.root,
      action: classes.action
    }
  });
}

function MediaCardContent(_ref) {
  var content = _ref.content,
      _ref$truncateContentL = _ref.truncateContentLength,
      truncateContentLength = _ref$truncateContentL === void 0 ? 120 : _ref$truncateContentL;
  return /*#__PURE__*/React__default.createElement(CardContent$1, {
    style: {
      paddingBottom: 0
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    height: 60
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    title: content,
    enterDelay: 500,
    open: content.length > truncateContentLength ? undefined : false
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    component: "p"
  }, truncate(content, {
    length: truncateContentLength
  })))));
}

function MediaCardCheckbox(_ref) {
  var checked = _ref.checked,
      handleChecked = _ref.handleChecked;
  return /*#__PURE__*/React__default.createElement(Checkbox, {
    checked: checked,
    onChange: handleChecked,
    style: {
      marginLeft: 'auto',
      transition: 'color .2s ease-out'
    }
  });
}

function MediaCardActions(_ref) {
  var hover = _ref.hover,
      checked = _ref.checked,
      handleChecked = _ref.handleChecked,
      _ref$primaryColor = _ref.primaryColor,
      primaryColor = _ref$primaryColor === void 0 ? grey$1[500] : _ref$primaryColor,
      _ref$secondaryColor = _ref.secondaryColor,
      secondaryColor = _ref$secondaryColor === void 0 ? red.A200 : _ref$secondaryColor,
      _ref$ChecboxComponent = _ref.ChecboxComponent,
      ChecboxComponent = _ref$ChecboxComponent === void 0 ? MediaCardCheckbox : _ref$ChecboxComponent;
  return /*#__PURE__*/React__default.createElement(CardActions, {
    disableSpacing: true
  }, /*#__PURE__*/React__default.createElement(IconButton, null, /*#__PURE__*/React__default.createElement(Visibility, {
    style: {
      color: hover ? secondaryColor : primaryColor,
      transition: 'color .2s ease-out'
    }
  })), /*#__PURE__*/React__default.createElement(IconButton, null, /*#__PURE__*/React__default.createElement(ShareIcon, {
    style: {
      color: hover ? secondaryColor : primaryColor,
      transition: 'color .2s ease-out'
    }
  })), /*#__PURE__*/React__default.createElement(ChecboxComponent, {
    checked: checked,
    handleChecked: handleChecked,
    hover: hover,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  }));
}

/**
 * MediaCard displays information, thumbnail and action buttons
 */

var styles$K = function styles() {
  return {
    root: {}
  };
};

var MediaCard = function MediaCard(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      onHover = _ref.onHover,
      onCheck = _ref.onCheck,
      onClick = _ref.onClick,
      controlledCheck = _ref.checked,
      title = _ref.title,
      subheader = _ref.subheader,
      image = _ref.image,
      content = _ref.content,
      avatar = _ref.avatar,
      CardComponent = _ref.CardComponent,
      CardProps = _ref.CardProps,
      HeaderComponent = _ref.HeaderComponent,
      HeaderProps = _ref.HeaderProps,
      ThumbnailComponent = _ref.ThumbnailComponent,
      ThumbnailProps = _ref.ThumbnailProps,
      ContentComponent = _ref.ContentComponent,
      ContentProps = _ref.ContentProps,
      ActionsComponent = _ref.ActionsComponent,
      ActionsProps = _ref.ActionsProps,
      AvatarComponent = _ref.AvatarComponent,
      AvatarProps = _ref.AvatarProps,
      MenuComponent = _ref.MenuComponent,
      MenuProps = _ref.MenuProps,
      innerProps = _objectWithoutProperties(_ref, ["className", "classes", "onHover", "onCheck", "onClick", "checked", "title", "subheader", "image", "content", "avatar", "CardComponent", "CardProps", "HeaderComponent", "HeaderProps", "ThumbnailComponent", "ThumbnailProps", "ContentComponent", "ContentProps", "ActionsComponent", "ActionsProps", "AvatarComponent", "AvatarProps", "MenuComponent", "MenuProps"]);

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      uncontrolledChecked = _React$useState2[0],
      setChecked = _React$useState2[1];

  var checked = controlledCheck === undefined ? uncontrolledChecked : controlledCheck;

  var handleChecked = function handleChecked(event) {
    if (controlledCheck === undefined) setChecked(!checked);
    if (onCheck) onCheck(event, !checked, innerProps);
  };

  var handleOnClick = onClick ? function (event) {
    return onClick(event, innerProps);
  } : undefined;
  return /*#__PURE__*/React__default.createElement(CardComponent, _extends({
    className: clsx(className, classes.root),
    checked: checked,
    innerProps: innerProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, CardProps), HeaderComponent && /*#__PURE__*/React__default.createElement(HeaderComponent, _extends({
    title: title,
    subheader: subheader,
    avatar: avatar,
    handleChecked: handleChecked,
    checked: checked,
    innerProps: innerProps,
    AvatarComponent: AvatarComponent,
    AvatarProps: AvatarProps,
    MenuComponent: MenuComponent,
    MenuProps: MenuProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, HeaderProps, innerProps)), ThumbnailComponent && /*#__PURE__*/React__default.createElement(ThumbnailComponent, _extends({
    image: image,
    innerProps: innerProps,
    onClick: handleOnClick // eslint-disable-next-line react/jsx-props-no-spreading

  }, ThumbnailProps)), ContentComponent && /*#__PURE__*/React__default.createElement(ContentComponent, _extends({
    content: content,
    innerProps: innerProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, ContentProps)), ActionsComponent && /*#__PURE__*/React__default.createElement(ActionsComponent, _extends({
    handleChecked: handleChecked,
    checked: checked,
    innerProps: innerProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, ActionsProps)));
};

var MediaCard$1 = withStyles$1(styles$K, {
  name: 'VdtMediaCard'
})(MediaCard);
MediaCard.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.any),
  onClick: propTypes.func,
  onHover: propTypes.func,
  onCheck: propTypes.func,
  checked: propTypes.bool,
  hover: propTypes.bool,
  title: propTypes.node,
  subheader: propTypes.node,
  image: propTypes.string,
  content: propTypes.string,
  avatar: propTypes.string,
  CardComponent: propTypes.elementType,
  HeaderComponent: propTypes.elementType,
  ThumbnailComponent: propTypes.elementType,
  ContentComponent: propTypes.elementType,
  ActionsComponent: propTypes.elementType,
  AvatarComponent: propTypes.elementType,
  MenuComponent: propTypes.elementType,
  CardProps: propTypes.objectOf(propTypes.any),
  HeaderProps: propTypes.objectOf(propTypes.any),
  ThumbnailProps: propTypes.objectOf(propTypes.any),
  ContentProps: propTypes.objectOf(propTypes.any),
  ActionsProps: propTypes.objectOf(propTypes.any),
  AvatarProps: propTypes.objectOf(propTypes.any),
  MenuProps: propTypes.objectOf(propTypes.any)
};
MediaCard.defaultProps = {
  className: 'VdtMediaCard',
  classes: {},
  onClick: undefined,
  onHover: undefined,
  onCheck: undefined,
  checked: undefined,
  hover: undefined,
  title: undefined,
  subheader: undefined,
  image: undefined,
  content: undefined,
  avatar: undefined,
  CardComponent: MediaCardCard$1,
  HeaderComponent: MediaCardHeader,
  ThumbnailComponent: MediaCardThumbnail$1,
  ContentComponent: MediaCardContent,
  ActionsComponent: MediaCardActions,
  AvatarComponent: MediaCardAvatar$1,
  MenuComponent: MediaCardMenu,
  CardProps: {},
  HeaderProps: {},
  ThumbnailProps: {},
  ContentProps: {},
  ActionsProps: {},
  AvatarProps: {},
  MenuProps: {}
};

var CollectionAvatar = function CollectionAvatar() {
  return /*#__PURE__*/React__default.createElement(Avatar, {
    variant: "square"
  }, /*#__PURE__*/React__default.createElement(FolderIcon, null));
};

var metadataToProps = function metadataToProps(_ref) {
  var collectionType = _ref.collectionType,
      titleSelector = _ref.titleSelector,
      subheaderSelector = _ref.subheaderSelector,
      parseMetadataOpts = _ref.parseMetadataOpts;
  var _collectionType$metad = collectionType.metadata,
      metadata = _collectionType$metad === void 0 ? {} : _collectionType$metad;
  var parsedMetadata = parseMetadataType(metadata, parseMetadataOpts);
  return {
    title: titleSelector(parsedMetadata),
    subheader: subheaderSelector(parsedMetadata)
  };
};

function CollectionCard(_ref2) {
  var collectionType = _ref2.collectionType,
      MediaCardComponent = _ref2.MediaCardComponent,
      AvatarComponent = _ref2.AvatarComponent,
      ThumbnailComponent = _ref2.ThumbnailComponent,
      MenuComponent = _ref2.MenuComponent,
      ContentComponent = _ref2.ContentComponent,
      ActionsComponent = _ref2.ActionsComponent,
      handleMetadataToProps = _ref2.metadataToProps,
      parseMetadataOpts = _ref2.parseMetadataOpts,
      titleSelector = _ref2.titleSelector,
      subheaderSelector = _ref2.subheaderSelector,
      innerProps = _objectWithoutProperties(_ref2, ["collectionType", "MediaCardComponent", "AvatarComponent", "ThumbnailComponent", "MenuComponent", "ContentComponent", "ActionsComponent", "metadataToProps", "parseMetadataOpts", "titleSelector", "subheaderSelector"]);

  var mediaCardProps = React__default.useMemo(function () {
    return handleMetadataToProps({
      collectionType: collectionType,
      parseMetadataOpts: parseMetadataOpts,
      titleSelector: titleSelector,
      subheaderSelector: subheaderSelector
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [handleMetadataToProps]);
  return /*#__PURE__*/React__default.createElement(MediaCardComponent, _extends({
    title: mediaCardProps.title,
    subheader: mediaCardProps.subheader,
    collectionType: collectionType,
    AvatarComponent: AvatarComponent,
    ThumbnailComponent: ThumbnailComponent,
    MenuComponent: MenuComponent,
    ContentComponent: ContentComponent,
    ActionsComponent: ActionsComponent // eslint-disable-next-line react/jsx-props-no-spreading

  }, innerProps));
}
CollectionCard.propTypes = {
  collectionType: propTypes.objectOf(propTypes.any),
  parseMetadataOpts: propTypes.objectOf(propTypes.any),
  metadataToProps: propTypes.func,
  MediaCardComponent: propTypes.elementType,
  AvatarComponent: propTypes.elementType,
  ThumbnailComponent: propTypes.elementType,
  MenuComponent: propTypes.elementType,
  ContentComponent: propTypes.elementType,
  ActionsComponent: propTypes.elementType,
  titleSelector: propTypes.func,
  subheaderSelector: propTypes.func
};
CollectionCard.defaultProps = {
  collectionType: undefined,
  metadataToProps: metadataToProps,
  parseMetadataOpts: {
    joinValue: ', ',
    flat: true
  },
  MediaCardComponent: MediaCard$1,
  AvatarComponent: CollectionAvatar,
  ThumbnailComponent: null,
  MenuComponent: null,
  ContentComponent: null,
  ActionsComponent: null,
  titleSelector: function titleSelector(parsedMetadata) {
    return parsedMetadata.title;
  },
  subheaderSelector: function subheaderSelector(parsedMetadata) {
    return parsedMetadata.created;
  }
};

function CollectionGrid(_ref) {
  var collectionListType = _ref.collectionListType,
      CollectionCardComponent = _ref.CollectionCardComponent,
      CollectionCardProps = _ref.CollectionCardProps,
      GridContainerProps = _ref.GridContainerProps,
      GridItemProps = _ref.GridItemProps,
      onItemClick = _ref.onItemClick;
  var _collectionListType$c = collectionListType.collection,
      collection = _collectionListType$c === void 0 ? [] : _collectionListType$c;
  var _GridItemProps$style = GridItemProps.style,
      gridItemPropsStyle = _GridItemProps$style === void 0 ? {} : _GridItemProps$style;
  return /*#__PURE__*/React__default.createElement(Grid, _extends({
    container: true // eslint-disable-next-line react/jsx-props-no-spreading

  }, GridContainerProps), collection && collection.map(function (collectionType, index) {
    return /*#__PURE__*/React__default.createElement(Grid, _extends({
      item: true,
      xs: "auto",
      key: collectionType.id,
      onClick: function onClick() {
        return onItemClick && onItemClick(collectionType);
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, GridItemProps, {
      style: _objectSpread2({
        cursor: onItemClick ? 'pointer' : 'initial'
      }, gridItemPropsStyle)
    }), /*#__PURE__*/React__default.createElement(CollectionCardComponent, _extends({
      index: index,
      collectionId: collectionType.id,
      collectionType: collectionType // eslint-disable-next-line react/jsx-props-no-spreading

    }, CollectionCardProps)));
  }));
}
CollectionGrid.propTypes = {
  collectionListType: propTypes.objectOf(propTypes.any),
  CollectionCardComponent: propTypes.elementType,
  CollectionCardProps: propTypes.objectOf(propTypes.any),
  GridContainerProps: propTypes.objectOf(propTypes.any),
  GridItemProps: propTypes.objectOf(propTypes.any),
  onItemClick: propTypes.func
};
CollectionGrid.defaultProps = {
  collectionListType: {},
  CollectionCardComponent: CollectionCard,
  CollectionCardProps: {},
  GridContainerProps: {},
  GridItemProps: {},
  onItemClick: null
};

var metadataToProps$1 = function metadataToProps(_ref) {
  var collectionType = _ref.collectionType,
      parseMetadataOpts = _ref.parseMetadataOpts,
      options = _ref.options;
  var _collectionType$metad = collectionType.metadata,
      metadata = _collectionType$metad === void 0 ? {} : _collectionType$metad;
  var parsedMetadata = parseMetadataType(metadata, parseMetadataOpts);
  return options.map(function (_ref2) {
    var value = _ref2.value;
    var parsedValue = parsedMetadata[value];
    return parsedValue;
  });
};

function CollectionRow(_ref3) {
  var _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? [] : _ref3$options,
      _ref3$metadataToProps = _ref3.metadataToProps,
      handleMetadataToProps = _ref3$metadataToProps === void 0 ? metadataToProps$1 : _ref3$metadataToProps,
      _ref3$parseMetadataOp = _ref3.parseMetadataOpts,
      parseMetadataOpts = _ref3$parseMetadataOp === void 0 ? {
    joinValue: ', ',
    flat: true
  } : _ref3$parseMetadataOp,
      selected = _ref3.selected,
      onCheck = _ref3.onCheck,
      onClick = _ref3.onClick,
      _ref3$TableRowProps = _ref3.TableRowProps,
      TableRowProps = _ref3$TableRowProps === void 0 ? {} : _ref3$TableRowProps,
      innerProps = _objectWithoutProperties(_ref3, ["options", "metadataToProps", "parseMetadataOpts", "selected", "onCheck", "onClick", "TableRowProps"]);

  var collectionType = innerProps.collectionType;
  var rowValues = React__default.useMemo(function () {
    return handleMetadataToProps({
      collectionType: collectionType,
      parseMetadataOpts: parseMetadataOpts,
      options: options
    });
  }, [collectionType, options, parseMetadataOpts, handleMetadataToProps]);

  var handleChecked = function handleChecked(event) {
    if (onCheck) onCheck(event, !selected, innerProps);
  };

  return /*#__PURE__*/React__default.createElement(TableRow$3$1, _extends({
    hover: true,
    selected: selected,
    onClick: onClick,
    style: {
      cursor: 'pointer'
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, TableRowProps), onCheck && /*#__PURE__*/React__default.createElement(TableCell$1, {
    padding: "checkbox"
  }, /*#__PURE__*/React__default.createElement(MediaCardCheckbox, {
    checked: selected,
    handleChecked: handleChecked
  })), rowValues.map(function (cellValue, index) {
    return /*#__PURE__*/React__default.createElement(Hidden, {
      key: options[index].key || options[index].value || options[index].label,
      only: options[index].hide
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, options[index].valueComponent ? /*#__PURE__*/React__default.createElement(Box, {
      component: options[index].valueComponent,
      value: cellValue,
      innerProps: innerProps
    }) : cellValue));
  }));
}

function CollectionTable(_ref) {
  var _ref$collectionListTy = _ref.collectionListType,
      collectionListType = _ref$collectionListTy === void 0 ? {} : _ref$collectionListTy,
      _ref$RowComponent = _ref.RowComponent,
      RowComponent = _ref$RowComponent === void 0 ? CollectionRow : _ref$RowComponent,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      onCheck = _ref.onCheck,
      selected = _ref.selected,
      onRowClick = _ref.onRowClick,
      innerProps = _objectWithoutProperties(_ref, ["collectionListType", "RowComponent", "options", "onCheck", "selected", "onRowClick"]);

  var _collectionListType$c = collectionListType.collection,
      collection = _collectionListType$c === void 0 ? [] : _collectionListType$c;
  return /*#__PURE__*/React__default.createElement(Table$1, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead$1$1, null, /*#__PURE__*/React__default.createElement(TableRow$3$1, null, onCheck && /*#__PURE__*/React__default.createElement(TableCell$1, {
    padding: "checkbox"
  }), options.map(function (_ref2, idx) {
    var label = _ref2.label,
        value = _ref2.value,
        hide = _ref2.hide;
    return /*#__PURE__*/React__default.createElement(Hidden, {
      key: label || value || idx,
      only: hide
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, label));
  }))), /*#__PURE__*/React__default.createElement(TableBody$1, null, collection && collection.map(function (collectionType) {
    return /*#__PURE__*/React__default.createElement(RowComponent, _extends({
      key: collectionType.id,
      collectionType: collectionType,
      collectionId: collectionType.id,
      options: options,
      onCheck: onCheck,
      selected: selected && selected.includes(collectionType.id),
      onClick: function onClick() {
        return onRowClick(collectionType);
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, innerProps));
  })));
}

var LOAD_MORE = 'LOAD_MORE';
var ITEM = 'ITEM';
var COLLECTION$1 = 'COLLECTION';
var JOIN_CHARACTER = '_';
var ROOT = 'ROOT';
var DROP_ZONE_ROOT = 'DROP_ZONE_ROOT';

var getEntityId = function getEntityId(_ref) {
  var entityId = _ref.entityId,
      itemId = _ref.itemId,
      collectionId = _ref.collectionId,
      _ref$entity = _ref.entity,
      entity = _ref$entity === void 0 ? {} : _ref$entity,
      _ref$item = _ref.item,
      item = _ref$item === void 0 ? {} : _ref$item,
      _ref$collection = _ref.collection,
      collection = _ref$collection === void 0 ? {} : _ref$collection,
      _ref$entityType = _ref.entityType,
      entityType = _ref$entityType === void 0 ? {} : _ref$entityType,
      _ref$itemType = _ref.itemType,
      itemType = _ref$itemType === void 0 ? {} : _ref$itemType,
      _ref$collectionType = _ref.collectionType,
      collectionType = _ref$collectionType === void 0 ? {} : _ref$collectionType;
  if (entityId) return entityId;
  if (itemId) return itemId;
  if (collectionId) return collectionId;
  if (entity && entity.id) return entity.id;
  if (item && item.id) return item.id;
  if (collection && collection.id) return collection.id;
  if (itemType && itemType.id) return itemType.id;
  if (entityType && entityType.id) return entityType.id;
  if (collectionType && collectionType.id) return collectionType.id;
  return undefined;
};

var getEntityType = function getEntityType(_ref2) {
  var itemId = _ref2.itemId,
      collectionId = _ref2.collectionId,
      _ref2$entity = _ref2.entity,
      entity = _ref2$entity === void 0 ? {} : _ref2$entity,
      item = _ref2.item,
      collection = _ref2.collection,
      entityType = _ref2.entityType,
      itemType = _ref2.itemType,
      collectionType = _ref2.collectionType;
  if (entity && entity.type) return entity.type.toUpperCase();
  if (entityType && typeof entityType === 'string') return entityType.toUpperCase();
  if (itemId || item || itemType) return 'ITEM';
  if (collectionId || collection || collectionType) return 'COLLECTION';
  return undefined;
};

var getEntity = function getEntity(_ref3) {
  var entity = _ref3.entity,
      entityType = _ref3.entityType,
      item = _ref3.item,
      itemType = _ref3.itemType,
      collection = _ref3.collection,
      collectionType = _ref3.collectionType;
  if (entity) return entity;
  if (entityType && typeof entityType !== 'string') return entityType;
  if (item) return item;
  if (itemType) return itemType;
  if (collection) return collection;
  if (collectionType) return collectionType;
  return undefined;
};

var getEntityParentId = function getEntityParentId(_ref4) {
  var parentCollectionId = _ref4.parentCollectionId,
      entityParentId = _ref4.entityParentId,
      parentId = _ref4.parentId;
  if (parentCollectionId) return parentCollectionId;
  if (entityParentId) return entityParentId;
  if (parentId) return parentId;
  return undefined;
}; // Only support for COLLECTION (i.e. not LIBRARY/PROJECT or custom types like BIN)


var getEntityParentType = function getEntityParentType(props) {
  return getEntityParentId(props) ? 'COLLECTION' : undefined;
};

var getEntityTimespan = function getEntityTimespan(_ref5) {
  var timespan = _ref5.timespan,
      entityTimespan = _ref5.entityTimespan;
  return timespan || entityTimespan;
};
var extractEntityInfo = (function (props) {
  return {
    entityId: getEntityId(props),
    entityType: getEntityType(props),
    entity: getEntity(props),
    entityParentId: getEntityParentId(props),
    entityParentType: getEntityParentType(props),
    entityTimespan: getEntityTimespan(props)
  };
});

var ACCEPTED_ENTITY_TYPES = ['COLLECTION', 'ITEM']; // Adds what to include when dropped on native droppable interfaces (e.g. WordPad)

var defaultHandleDragStart = function defaultHandleDragStart(event, dragInfo) {
  event.dataTransfer.setData('text/plain', JSON.stringify(dragInfo));
};

var withDrag = function withDrag(Component) {
  return function (_ref) {
    var className = _ref.className,
        _ref$classes = _ref.classes,
        classes = _ref$classes === void 0 ? {} : _ref$classes,
        onSort = _ref.onSort,
        _ref$onDragStart = _ref.onDragStart,
        onDragStart = _ref$onDragStart === void 0 ? defaultHandleDragStart : _ref$onDragStart,
        hardcodedDragInfo = _ref.dragInfo,
        _ref$wrapDragInDiv = _ref.wrapDragInDiv,
        wrapDragInDiv = _ref$wrapDragInDiv === void 0 ? true : _ref$wrapDragInDiv,
        _ref$hideDefaultDragg = _ref.hideDefaultDraggedComponent,
        hideDefaultDraggedComponent = _ref$hideDefaultDragg === void 0 ? false : _ref$hideDefaultDragg,
        _ref$acceptedEntityTy = _ref.acceptedEntityTypes,
        acceptedEntityTypes = _ref$acceptedEntityTy === void 0 ? ACCEPTED_ENTITY_TYPES : _ref$acceptedEntityTy,
        props = _objectWithoutProperties(_ref, ["className", "classes", "onSort", "onDragStart", "dragInfo", "wrapDragInDiv", "hideDefaultDraggedComponent", "acceptedEntityTypes"]);

    try {
      // Only extract info once for performance reason
      // eslint-disable-next-line react-hooks/exhaustive-deps
      var extractedInitialDragInfo = React__default.useMemo(function () {
        return extractEntityInfo(props);
      }, []);
      var dragInfo = hardcodedDragInfo || extractedInitialDragInfo;
      var entityType = dragInfo.entityType;
      var ref = React__default.useRef(null);
      var id = props.id,
          index = props.index;

      var _useDrag = useDrag({
        item: {
          type: "".concat(entityType),
          dragInfo: dragInfo,
          id: id,
          index: index
        },
        collect: function collect(monitor) {
          return {
            isDragging: !!monitor.isDragging()
          };
        },
        end: function end(_, monitor) {
          if (!onSort) return;

          var _monitor$getItem = monitor.getItem(),
              dragId = _monitor$getItem.id,
              originalDragIndex = _monitor$getItem.index;

          var didDrop = monitor.didDrop();

          if (!didDrop) {
            onSort({
              dragId: dragId,
              originalDragIndex: originalDragIndex
            });
          }
        }
      }),
          _useDrag2 = _slicedToArray(_useDrag, 3),
          isDragging = _useDrag2[0].isDragging,
          connectDrag = _useDrag2[1],
          preview = _useDrag2[2];

      var _useDrop = useDrop({
        accept: acceptedEntityTypes,
        canDrop: false,
        hover: function hover(_ref2) {
          var dragId = _ref2.id;
          if (!onSort) return;
          var hoverId = id;
          if (dragId === undefined || dragId === hoverId) return;
          onSort({
            dragId: dragId,
            hoverId: hoverId
          });
        },
        collect: function collect(monitor) {
          return {
            isOver: !!monitor.isOver()
          };
        }
      }),
          _useDrop2 = _slicedToArray(_useDrop, 2),
          isOver = _useDrop2[0].isOver,
          connectDrop = _useDrop2[1];

      connectDrag(ref);
      connectDrop(ref);
      React__default.useEffect(function () {
        if (hideDefaultDraggedComponent) {
          preview(getEmptyImage());
        }
      }, [hideDefaultDraggedComponent, preview]);
      var DragComponent = /*#__PURE__*/React__default.createElement(Component, _extends({
        className: clsx(className, isDragging && classes.isDragging, isDragging && 'VdtDraggable-isDragging', isOver && classes.isOver, isOver && 'VdtDraggable-isOver'),
        classes: _objectSpread2(_objectSpread2({}, classes), {}, {
          isDragging: undefined,
          'VdtDraggable-isDragging': undefined,
          isOver: undefined,
          'VdtDraggable-isOver': undefined
        })
      }, props));
      var handleDragStart = React__default.useCallback(function (event) {
        if (onDragStart) {
          onDragStart(event, dragInfo);
        }
      }, // eslint-disable-next-line react-hooks/exhaustive-deps
      [dragInfo]);
      return wrapDragInDiv ? /*#__PURE__*/React__default.createElement("div", {
        ref: ref,
        onDragStart: handleDragStart
      }, DragComponent) : /*#__PURE__*/React__default.createElement(RootRef, {
        rootRef: ref
      }, DragComponent);
    } catch (_) {
      return /*#__PURE__*/React__default.createElement(Component, props);
    }
  };
};

var ACCEPTED_ENTITY_TYPES$1 = ['COLLECTION', 'ITEM'];

var withDrop = function withDrop(Component) {
  return function (_ref) {
    var className = _ref.className,
        _ref$classes = _ref.classes,
        classes = _ref$classes === void 0 ? {} : _ref$classes,
        onDrop = _ref.onDrop,
        hardcodedDropInfo = _ref.dropInfo,
        _ref$ignoreDropOnExit = _ref.ignoreDropOnExitingIds,
        ignoreDropOnExitingIds = _ref$ignoreDropOnExit === void 0 ? false : _ref$ignoreDropOnExit,
        _ref$ignoreDropOnSame = _ref.ignoreDropOnSameEntity,
        ignoreDropOnSameEntity = _ref$ignoreDropOnSame === void 0 ? true : _ref$ignoreDropOnSame,
        _ref$acceptedEntityTy = _ref.acceptedEntityTypes,
        acceptedEntityTypes = _ref$acceptedEntityTy === void 0 ? ACCEPTED_ENTITY_TYPES$1 : _ref$acceptedEntityTy,
        props = _objectWithoutProperties(_ref, ["className", "classes", "onDrop", "dropInfo", "ignoreDropOnExitingIds", "ignoreDropOnSameEntity", "acceptedEntityTypes"]);

    try {
      // Only extract info once for performance reason
      // eslint-disable-next-line react-hooks/exhaustive-deps
      var extractedInitialDropInfo = React__default.useMemo(function () {
        return extractEntityInfo(props);
      }, []);
      var dropInfo = hardcodedDropInfo || extractedInitialDropInfo;

      if (!dropInfo) {
        throw new Error('Did not retrieve any dropInfo to withDrop');
      }

      var checkIfValidDrop = React__default.useCallback(function (_ref2) {
        var id = _ref2.id,
            dragInfo = _ref2.dragInfo;
        var entityId = dragInfo.entityId,
            entityType = dragInfo.entityType;

        if (ignoreDropOnExitingIds && id !== undefined) {
          return false;
        }

        if (ignoreDropOnSameEntity && entityId === dropInfo.entityId && entityType === dropInfo.entityType) {
          return false;
        }

        return true;
      }, [dropInfo.entityId, dropInfo.entityType, ignoreDropOnExitingIds, ignoreDropOnSameEntity]);

      var _useDrop = useDrop({
        accept: acceptedEntityTypes,
        canDrop: checkIfValidDrop,
        drop: function drop(_ref3) {
          var dragInfo = _ref3.dragInfo;

          if (!onDrop) {
            throw Error('onDrop inside withDrop cannot be undefined');
          }

          return onDrop({
            dragInfo: dragInfo,
            dropInfo: dropInfo
          });
        },
        collect: function collect(monitor) {
          return {
            isOver: !!monitor.isOver(),
            canDrop: !!monitor.canDrop()
          };
        }
      }),
          _useDrop2 = _slicedToArray(_useDrop, 2),
          _useDrop2$ = _useDrop2[0],
          isOver = _useDrop2$.isOver,
          canDrop = _useDrop2$.canDrop,
          drop = _useDrop2[1];

      var classesWithoutDropStyles = React__default.useMemo(function () {
        return _objectSpread2(_objectSpread2({}, classes), {}, {
          isOver: undefined,
          canDrop: undefined,
          'VdtDroppable-isOver': undefined,
          'VdtDroppable-canDrop': undefined
        });
      }, [classes]);
      var DropComponent = React__default.useMemo(function () {
        return /*#__PURE__*/React__default.createElement(Component, _extends({
          className: clsx(className, isOver && classes.isOver, canDrop && classes.canDrop, isOver && 'VdtDroppable-isOver', canDrop && 'VdtDroppable-canDrop'),
          classes: classesWithoutDropStyles
        }, props));
      }, [canDrop, className, classes.canDrop, classes.isOver, classesWithoutDropStyles, isOver, props]);
      return /*#__PURE__*/React__default.createElement("div", {
        ref: drop
      }, DropComponent);
    } catch (_) {
      return /*#__PURE__*/React__default.createElement(Component, props);
    }
  };
};

/* Using this hook as is has better performance than using clientOffset from regular monitor
 * https://github.com/react-dnd/react-dnd/issues/2414
 */

var useDragOffsetDiff = function useDragOffsetDiff(enabled) {
  var fps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;

  var _React$useContext = React__default.useContext(DndContext),
      dragDropManager = _React$useContext.dragDropManager;

  var monitor = dragDropManager.getMonitor();

  var _React$useState = React__default.useState(monitor.getDifferenceFromInitialOffset()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      dragOffsetDiff = _React$useState2[0],
      setDragOffsetDiff = _React$useState2[1];

  var offsetChangeListener = function offsetChangeListener() {
    return setDragOffsetDiff(monitor.getDifferenceFromInitialOffset());
  };

  var _React$useState3 = React__default.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      intervalId = _React$useState4[0],
      setIntervalId = _React$useState4[1];

  var cleanup = function cleanup() {
    if (intervalId) {
      clearInterval(intervalId);
      setDragOffsetDiff({
        x: 0,
        y: 0
      });
    }
  };

  React__default.useEffect(function () {
    if (enabled) {
      setIntervalId(setInterval(function () {
        offsetChangeListener();
      }, 1000 / fps));
    } else {
      cleanup();
    }

    return cleanup; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
  return dragOffsetDiff;
};

/* eslint-disable react/jsx-props-no-spreading */
var layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
}; // Align dragged item vertically at mouse position

var getMouseOffset = function getMouseOffset(initialOffset) {
  var mousePosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    x: 0,
    y: 0
  };

  var _ref = initialOffset || {},
      _ref$y = _ref.y,
      iy = _ref$y === void 0 ? 0 : _ref$y;

  var my = mousePosition.y;
  var y = my - iy + (iy - my) / 3; // Skipping x

  return {
    x: 0,
    y: y
  };
};

var getItemStyles = function getItemStyles(diffOffset, initialOffset, mouseOffset) {
  var _ref2 = initialOffset || {},
      ix = _ref2.x,
      iy = _ref2.y;

  var _ref3 = diffOffset || {},
      dx = _ref3.x,
      dy = _ref3.y;

  var _ref4 = mouseOffset || {},
      mx = _ref4.x,
      my = _ref4.y;

  var transform = "translate(".concat(ix + dx + mx, "px, ").concat(iy + dy + my, "px)");
  return {
    transform: transform
  };
};

var DragLayer = function DragLayer(_ref5) {
  var _ref5$allowedTypes = _ref5.allowedTypes,
      allowedTypes = _ref5$allowedTypes === void 0 ? ['ITEM', 'COLLECTION'] : _ref5$allowedTypes,
      Component = _ref5.Component;

  var _useDragLayer = useDragLayer(function (monitor) {
    return {
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      isDragging: monitor.isDragging()
    };
  }),
      item = _useDragLayer.item,
      isDragging = _useDragLayer.isDragging,
      itemType = _useDragLayer.itemType,
      initialOffset = _useDragLayer.initialOffset;

  var _ref6 = item || {},
      dragInfo = _ref6.dragInfo;

  var mousePosition = useMouseDownPosition();
  var diffOffset = useDragOffsetDiff(isDragging);
  return isDragging && allowedTypes.includes(itemType) ? /*#__PURE__*/React__default.createElement("div", {
    style: layerStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    style: getItemStyles(diffOffset, initialOffset, getMouseOffset(initialOffset, mousePosition, Component))
  }, Component && dragInfo ? /*#__PURE__*/React__default.createElement(Component, dragInfo) : null)) : null;
};

var styles$L = {
  isDragging: {
    opacity: 0.5,
    cursor: 'move'
  }
};
var TreeItemDraggable = compose(withStyles$1(styles$L, {
  name: 'VdtTreeItemDraggable'
}), withDrag)(TreeItem);

var styles$M = function styles() {
  return {
    root: {}
  };
};

var ItemLabel = function ItemLabel(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      item = _ref.item,
      labelField = _ref.labelField;

  var _React$useMemo = React__default.useMemo(function () {
    var metadata = parseMetadataType(item.metadata, {
      joinValue: ',',
      flat: true
    });
    return [metadata.mimeType, metadata[labelField] || item.id]; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      mimeType = _React$useMemo2[0],
      label = _React$useMemo2[1];

  return /*#__PURE__*/React__default.createElement(Box$1, {
    className: clsx(className, classes.root, 'VdtItemLabel-root'),
    display: "flex",
    alignItems: "flex-end"
  }, /*#__PURE__*/React__default.createElement(MimeTypeIcon$1, {
    mimeType: mimeType
  }), /*#__PURE__*/React__default.createElement(Typography$1, {
    style: {
      fontWeight: 'inherit'
    }
  }, label));
};

var ItemLabel$1 = withStyles$1(styles$M, {
  name: 'VdtItemLabel'
})(ItemLabel);

var styles$N = function styles(theme) {
  return {
    isOver: {
      backgroundColor: theme.palette.primary.main
    }
  };
};

var ItemLabelDroppable = compose(withStyles$1(styles$N, {
  name: 'VdtItemLabelDroppable'
}), withDrop)(ItemLabel$1);

var styles$O = {
  root: {}
};

var ItemTreeItem = function ItemTreeItem(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      item = _ref.item,
      parentCollectionId = _ref.parentCollectionId,
      _ref$nodeId = _ref.nodeId,
      nodeId = _ref$nodeId === void 0 ? [ITEM, item.id, COLLECTION$1, parentCollectionId].join(JOIN_CHARACTER) : _ref$nodeId,
      onDrop = _ref.onDrop,
      _ref$ItemLabelCompone = _ref.ItemLabelComponent,
      ItemLabelComponent = _ref$ItemLabelCompone === void 0 ? ItemLabelDroppable : _ref$ItemLabelCompone,
      _ref$TreeItemComponen = _ref.TreeItemComponent,
      TreeItemComponent = _ref$TreeItemComponen === void 0 ? TreeItemDraggable : _ref$TreeItemComponen,
      _ref$TreeItemProps = _ref.TreeItemProps,
      TreeItemProps = _ref$TreeItemProps === void 0 ? {} : _ref$TreeItemProps,
      _ref$ItemLabelProps = _ref.ItemLabelProps,
      ItemLabelProps = _ref$ItemLabelProps === void 0 ? {} : _ref$ItemLabelProps;
  var label = /*#__PURE__*/React__default.createElement(ItemLabelComponent, _extends({
    item: item,
    parentCollectionId: parentCollectionId,
    nodeId: nodeId,
    onDrop: onDrop // eslint-disable-next-line react/jsx-props-no-spreading

  }, ItemLabelProps));
  return /*#__PURE__*/React__default.createElement(TreeItemComponent, _extends({
    className: clsx(classes.root, 'VdtItemTreeItem-root', className),
    label: label,
    nodeId: nodeId,
    dragInfo: {
      entityType: ITEM,
      entityId: item.id,
      entityParentId: parentCollectionId
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, TreeItemProps));
};

var ItemTreeItem$1 = withStyles$1(styles$O, {
  name: 'VdtItemTreeItem'
})(ItemTreeItem);

var EntityTreeContext = /*#__PURE__*/React__default.createContext({
  childIds: {},
  addAsChildrenToCollection: function addAsChildrenToCollection() {
    return null;
  },
  removeAsChildrenToCollection: function removeAsChildrenToCollection() {
    return null;
  },
  addOrUpdateCollections: function addOrUpdateCollections() {
    return null;
  },
  addOrUpdateItems: function addOrUpdateItems() {
    return null;
  },
  getChildCollections: function getChildCollections() {
    return [];
  },
  getChildItems: function getChildItems() {
    return [];
  }
});
var EntityTreeProvider = function EntityTreeProvider(_ref) {
  var _ref$initialChildIds = _ref.initialChildIds,
      initialChildIds = _ref$initialChildIds === void 0 ? {} : _ref$initialChildIds,
      _ref$initialCollectio = _ref.initialCollections,
      initialCollections = _ref$initialCollectio === void 0 ? [] : _ref$initialCollectio,
      _ref$initialItems = _ref.initialItems,
      initialItems = _ref$initialItems === void 0 ? [] : _ref$initialItems,
      children = _ref.children;

  var _React$useState = React__default.useState(initialChildIds),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      childIds = _React$useState2[0],
      setChildIds = _React$useState2[1];

  var _React$useState3 = React__default.useState(initialCollections),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      collections = _React$useState4[0],
      setCollections = _React$useState4[1];

  var _React$useState5 = React__default.useState(initialItems),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      items = _React$useState6[0],
      setItems = _React$useState6[1];

  var addAsChildrenToCollection = function addAsChildrenToCollection(entityId, entityType, collectionId) {
    if (entityType === COLLECTION$1) {
      var collectionIds = Array.isArray(entityId) ? entityId : [entityId];
      setChildIds(function (old) {
        var _old$collectionId = old[collectionId],
            existingChildIds = _old$collectionId === void 0 ? {} : _old$collectionId;
        var _existingChildIds$col = existingChildIds.collectionIds,
            existingCollectionsIds = _existingChildIds$col === void 0 ? [] : _existingChildIds$col;
        return _objectSpread2(_objectSpread2({}, old), {}, _defineProperty({}, collectionId, _objectSpread2(_objectSpread2({}, existingChildIds), {}, {
          collectionIds: _toConsumableArray(Array.from(new Set([].concat(_toConsumableArray(existingCollectionsIds), _toConsumableArray(collectionIds)))))
        })));
      });
    } else if (entityType === ITEM) {
      var itemIds = Array.isArray(entityId) ? entityId : [entityId];
      setChildIds(function (old) {
        var _old$collectionId2 = old[collectionId],
            existingChildIds = _old$collectionId2 === void 0 ? {} : _old$collectionId2;
        var _existingChildIds$ite = existingChildIds.itemIds,
            existingItemIds = _existingChildIds$ite === void 0 ? [] : _existingChildIds$ite;
        return _objectSpread2(_objectSpread2({}, old), {}, _defineProperty({}, collectionId, _objectSpread2(_objectSpread2({}, existingChildIds || {}), {}, {
          itemIds: _toConsumableArray(Array.from(new Set([].concat(_toConsumableArray(existingItemIds), _toConsumableArray(itemIds)))))
        })));
      });
    }
  };

  var removeAsChildrenToCollection = function removeAsChildrenToCollection(entityId, entityType, collectionId) {
    if (entityType === COLLECTION$1) {
      var collectionIds = Array.isArray(entityId) ? entityId : [entityId];
      setChildIds(function (old) {
        var _old$collectionId3 = old[collectionId],
            existingChildIds = _old$collectionId3 === void 0 ? {} : _old$collectionId3;
        var _existingChildIds$col2 = existingChildIds.collectionIds,
            existingCollectionsIds = _existingChildIds$col2 === void 0 ? [] : _existingChildIds$col2;
        return _objectSpread2(_objectSpread2({}, old), {}, _defineProperty({}, collectionId, _objectSpread2(_objectSpread2({}, existingChildIds), {}, {
          collectionIds: _toConsumableArray(existingCollectionsIds.filter(function (id) {
            return !collectionIds.includes(id);
          }))
        })));
      });
    } else if (entityType === ITEM) {
      var itemIds = Array.isArray(entityId) ? entityId : [entityId];
      setChildIds(function (old) {
        var _old$collectionId4 = old[collectionId],
            existingChildIds = _old$collectionId4 === void 0 ? {} : _old$collectionId4;
        var _existingChildIds$ite2 = existingChildIds.itemIds,
            existingItemIds = _existingChildIds$ite2 === void 0 ? [] : _existingChildIds$ite2;
        return _objectSpread2(_objectSpread2({}, old), {}, _defineProperty({}, collectionId, _objectSpread2(_objectSpread2({}, existingChildIds), {}, {
          itemIds: _toConsumableArray(existingItemIds.filter(function (id) {
            return !itemIds.includes(id);
          }))
        })));
      });
    }
  };

  var splitEntitesToStates = function splitEntitesToStates(existingEntities, entities) {
    var existingEntityIds = existingEntities.map(function (c) {
      return c.id;
    });
    var newEntities = entities.filter(function (nc) {
      return !existingEntityIds.includes(nc.id);
    });
    var updatedEntities = entities.filter(function (nc) {
      return existingEntityIds.includes(nc.id);
    });
    var newOrUpdatedEntityIds = [].concat(_toConsumableArray(updatedEntities), _toConsumableArray(newEntities)).map(function (c) {
      return c.id;
    });
    var unchangedEntites = existingEntities.filter(function (c) {
      return !newOrUpdatedEntityIds.includes(c.id);
    });
    return {
      unchangedEntites: unchangedEntites,
      updatedEntities: updatedEntities,
      newEntities: newEntities
    };
  };

  var addOrUpdateCollections = function addOrUpdateCollections(collectionId, collection) {
    if (!collection) return;
    var newCollections = Array.isArray(collection) ? collection : [collection];
    setCollections(function (existingCollections) {
      var _splitEntitesToStates = splitEntitesToStates(existingCollections, newCollections),
          unchangedEntites = _splitEntitesToStates.unchangedEntites,
          updatedEntities = _splitEntitesToStates.updatedEntities,
          newEntities = _splitEntitesToStates.newEntities;

      return [].concat(_toConsumableArray(unchangedEntites), _toConsumableArray(updatedEntities), _toConsumableArray(newEntities));
    });
  };

  var addOrUpdateItems = function addOrUpdateItems(collectionId, item) {
    if (!item) return;
    var newItems = Array.isArray(item) ? item : [item];
    setItems(function (existingItems) {
      var _splitEntitesToStates2 = splitEntitesToStates(existingItems, newItems),
          unchangedEntites = _splitEntitesToStates2.unchangedEntites,
          updatedEntities = _splitEntitesToStates2.updatedEntities,
          newEntities = _splitEntitesToStates2.newEntities;

      return [].concat(_toConsumableArray(unchangedEntites), _toConsumableArray(updatedEntities), _toConsumableArray(newEntities));
    });
  };

  var getChildCollections = function getChildCollections(id) {
    var _ref2 = childIds[id] || {},
        _ref2$collectionIds = _ref2.collectionIds,
        collectionIds = _ref2$collectionIds === void 0 ? [] : _ref2$collectionIds; // Keeps order as it is in collectionIds


    return collectionIds.map(function (collectionId) {
      return collections.find(function (c) {
        return c.id === collectionId;
      });
    }).filter(function (c) {
      return c;
    });
  };

  var getChildItems = function getChildItems(id) {
    var _ref3 = childIds[id] || {},
        _ref3$itemIds = _ref3.itemIds,
        itemIds = _ref3$itemIds === void 0 ? [] : _ref3$itemIds; // Keeps order as it is in itemIds


    return itemIds.map(function (itemId) {
      return items.find(function (c) {
        return c.id === itemId;
      });
    }).filter(function (i) {
      return i;
    });
  };

  return /*#__PURE__*/React__default.createElement(EntityTreeContext.Provider, {
    value: {
      childIds: childIds,
      addAsChildrenToCollection: addAsChildrenToCollection,
      removeAsChildrenToCollection: removeAsChildrenToCollection,
      addOrUpdateCollections: addOrUpdateCollections,
      addOrUpdateItems: addOrUpdateItems,
      getChildCollections: getChildCollections,
      getChildItems: getChildItems
    }
  }, children);
};

var styles$P = {
  root: {}
};

var CollectionLabel = function CollectionLabel(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      collection = _ref.collection,
      labelField = _ref.labelField;
  var collectionLabel = React__default.useMemo(function () {
    if (!labelField) return collection.id;
    if (labelField === 'name') return collection.name || collection.id;
    var metadata = parseMetadataType(collection.metadata, {
      joinValue: ',',
      flat: true
    });
    return metadata[labelField] || collection.id;
  }, [labelField, collection]);
  return /*#__PURE__*/React__default.createElement(Box$1, {
    className: clsx(className, classes.root, 'VdtCollectionLabel-root'),
    display: "flex",
    alignItems: "flex-end"
  }, /*#__PURE__*/React__default.createElement(Folder, {
    color: "inherit"
  }), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      fontWeight: 'inherit'
    }
  }, collectionLabel));
};

var CollectionLabel$1 = withStyles$1(styles$P, {
  name: 'CollectionLabel'
})(CollectionLabel);

var styles$Q = function styles(theme) {
  return {
    isOver: {
      backgroundColor: theme.palette.primary.main
    }
  };
};

var CollectionLabelDroppable = compose(withStyles$1(styles$Q, {
  name: 'VdtCollectionLabelDroppable'
}), withDrop)(CollectionLabel$1);

var defaultCollectionState = {
  queryParams: {
    field: ['content'],
    content: ['metadata']
  }
};
var defaultItemState = {
  queryParams: {
    field: ['mimeType'],
    content: ['metadata']
  }
};

var getStateWithParentCollection = function getStateWithParentCollection(state, collectionId) {
  var _state$itemSearchDocu = state.itemSearchDocument,
      itemSearchDocument = _state$itemSearchDocu === void 0 ? {} : _state$itemSearchDocu;
  var _itemSearchDocument$f = itemSearchDocument.field,
      field = _itemSearchDocument$f === void 0 ? [] : _itemSearchDocument$f;
  return _objectSpread2(_objectSpread2({}, state), {}, {
    itemSearchDocument: _objectSpread2(_objectSpread2({}, itemSearchDocument), {}, {
      field: [].concat(_toConsumableArray(field), [{
        name: '__parent_collection',
        value: [{
          value: collectionId
        }]
      }])
    })
  });
};

var styles$R = {
  root: {}
};

var CollectionTreeList = function CollectionTreeList(_ref) {
  var parentCollectionId = _ref.parentCollectionId,
      _ref$collection = _ref.collection,
      collection$1 = _ref$collection === void 0 ? {} : _ref$collection,
      _ref$nodeId = _ref.nodeId,
      nodeId = _ref$nodeId === void 0 ? [COLLECTION$1, collection$1.id, COLLECTION$1, parentCollectionId].join(JOIN_CHARACTER) : _ref$nodeId,
      props = _objectWithoutProperties(_ref, ["parentCollectionId", "collection", "nodeId"]);

  var collectionId = collection$1.id;
  var className = props.className,
      classes = props.classes,
      _props$collectionStat = props.collectionState,
      collectionState = _props$collectionStat === void 0 ? defaultCollectionState : _props$collectionStat,
      _props$itemState = props.itemState,
      itemState = _props$itemState === void 0 ? defaultItemState : _props$itemState,
      _props$includeItems = props.includeItems,
      includeItems = _props$includeItems === void 0 ? true : _props$includeItems,
      _props$onDrop = props.onDrop,
      onDrop = _props$onDrop === void 0 ? function () {} : _props$onDrop,
      _props$onError = props.onError,
      onError = _props$onError === void 0 ? function () {
    return null;
  } : _props$onError,
      _props$CollectionComp = props.CollectionComponent,
      CollectionComponent = _props$CollectionComp === void 0 ? CollectionTreeList : _props$CollectionComp,
      _props$CollectionLabe = props.CollectionLabelComponent,
      CollectionLabelComponent = _props$CollectionLabe === void 0 ? CollectionLabelDroppable : _props$CollectionLabe,
      _props$ItemComponent = props.ItemComponent,
      ItemComponent = _props$ItemComponent === void 0 ? ItemTreeItem$1 : _props$ItemComponent,
      _props$TreeItemCompon = props.TreeItemComponent,
      TreeItemComponent = _props$TreeItemCompon === void 0 ? TreeItemDraggable : _props$TreeItemCompon,
      _props$CollectionLabe2 = props.CollectionLabelProps,
      CollectionLabelProps = _props$CollectionLabe2 === void 0 ? {} : _props$CollectionLabe2,
      _props$TreeItemProps = props.TreeItemProps,
      TreeItemProps = _props$TreeItemProps === void 0 ? {} : _props$TreeItemProps,
      _props$ItemProps = props.ItemProps,
      ItemProps = _props$ItemProps === void 0 ? {} : _props$ItemProps;

  var _useContext = useContext(EntityTreeContext),
      addOrUpdateCollections = _useContext.addOrUpdateCollections,
      addOrUpdateItems = _useContext.addOrUpdateItems,
      addAsChildrenToCollection = _useContext.addAsChildrenToCollection,
      getChildCollections = _useContext.getChildCollections,
      getChildItems = _useContext.getChildItems;

  var childCollections = getChildCollections(collectionId);
  var childItems = getChildItems(collectionId);

  var getItemsWithMetadata = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$CollectionApi$, _yield$CollectionApi$2, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return collection.getCollectionItem(_objectSpread2(_objectSpread2({}, itemState), {}, {
                collectionId: collectionId
              }));

            case 3:
              _yield$CollectionApi$ = _context.sent;
              _yield$CollectionApi$2 = _yield$CollectionApi$.data;
              data = _yield$CollectionApi$2 === void 0 ? {} : _yield$CollectionApi$2;
              return _context.abrupt("return", data.item || []);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              onError({
                message: 'Could not get items',
                error: _context.t0
              });
              return _context.abrupt("return", []);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function getItemsWithMetadata() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getCollectionsWithMetadata = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var stateWithParentCollection, _yield$CollectionApi$3, _yield$CollectionApi$4, data;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              stateWithParentCollection = getStateWithParentCollection(collectionState, collectionId);
              _context2.next = 4;
              return collection.searchCollection(stateWithParentCollection);

            case 4:
              _yield$CollectionApi$3 = _context2.sent;
              _yield$CollectionApi$4 = _yield$CollectionApi$3.data;
              data = _yield$CollectionApi$4 === void 0 ? {} : _yield$CollectionApi$4;
              return _context2.abrupt("return", data.collection || []);

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              onError({
                message: "Could not list collections for ".concat(collectionId),
                error: _context2.t0
              });
              return _context2.abrupt("return", []);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));

    return function getCollectionsWithMetadata() {
      return _ref3.apply(this, arguments);
    };
  }();

  var getCollection = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _yield$CollectionApi$5, data, _data$content, content, contentCollections, contentItems, newCollections, newCollectionIds, existingChildIds, newChildIds, newItems, newItemIds, _existingChildIds, _newChildIds;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return collection.getCollection(_objectSpread2(_objectSpread2({}, collectionState), {}, {
                collectionId: collectionId
              }));

            case 3:
              _yield$CollectionApi$5 = _context3.sent;
              data = _yield$CollectionApi$5.data;
              _data$content = data.content, content = _data$content === void 0 ? [] : _data$content;
              contentCollections = content.filter(function (e) {
                return e.type === 'collection';
              });
              contentItems = content.filter(function (e) {
                return e.type === 'item';
              });

              if (!contentCollections.length) {
                _context3.next = 17;
                break;
              }

              _context3.next = 11;
              return getCollectionsWithMetadata();

            case 11:
              newCollections = _context3.sent;
              addOrUpdateCollections(collectionId, newCollections);
              newCollectionIds = newCollections.map(function (i) {
                return i.id;
              });
              existingChildIds = childCollections.map(function (i) {
                return i.id;
              });
              newChildIds = newCollectionIds.filter(function (id) {
                return !existingChildIds.includes(id);
              });

              if (newChildIds.length) {
                addAsChildrenToCollection(newChildIds, COLLECTION$1, collectionId);
              }

            case 17:
              if (!(includeItems && contentItems.length)) {
                _context3.next = 26;
                break;
              }

              _context3.next = 20;
              return getItemsWithMetadata();

            case 20:
              newItems = _context3.sent;
              addOrUpdateItems(collectionId, newItems);
              newItemIds = newItems.map(function (i) {
                return i.id;
              });
              _existingChildIds = childItems.map(function (i) {
                return i.id;
              });
              _newChildIds = newItemIds.filter(function (id) {
                return !_existingChildIds.includes(id);
              });

              if (_newChildIds.length) {
                addAsChildrenToCollection(_newChildIds, ITEM, collectionId);
              }

            case 26:
              _context3.next = 31;
              break;

            case 28:
              _context3.prev = 28;
              _context3.t0 = _context3["catch"](0);
              onError({
                message: "Could not get collection ".concat(collectionId),
                error: _context3.t0
              });

            case 31:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 28]]);
    }));

    return function getCollection() {
      return _ref4.apply(this, arguments);
    };
  }();

  React__default.useEffect(function () {
    getCollection(collectionId); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collectionId]);
  var label = /*#__PURE__*/React__default.createElement(CollectionLabelComponent, _extends({
    collection: collection$1,
    parentCollectionId: parentCollectionId,
    nodeId: nodeId,
    onDrop: onDrop
  }, CollectionLabelProps));

  var getKey = function getKey(entityType, entityId, parentId, grandParentId) {
    return [entityType, entityId, COLLECTION$1, parentId, COLLECTION$1, grandParentId].join(JOIN_CHARACTER);
  };

  return /*#__PURE__*/React__default.createElement(TreeItemComponent, _extends({
    className: clsx(className, classes.root, 'VdtCollectionTreeList-root'),
    nodeId: nodeId,
    dragInfo: {
      entityType: COLLECTION$1,
      entityId: collectionId,
      entityParentId: parentCollectionId
    },
    label: label // eslint-disable-next-line react/jsx-props-no-spreading

  }, TreeItemProps), childCollections.length ? childCollections.map(function (c) {
    return /*#__PURE__*/React__default.createElement(CollectionComponent, _extends({
      key: getKey(COLLECTION$1, c.id, collectionId, parentCollectionId),
      parentCollectionId: collectionId,
      collection: c
    }, props));
  }) : undefined, childItems.length ? childItems.map(function (i) {
    return /*#__PURE__*/React__default.createElement(ItemComponent, _extends({
      key: getKey(ITEM, i.id, collectionId, parentCollectionId),
      item: i,
      parentCollectionId: collectionId,
      onDrop: onDrop
    }, ItemProps));
  }) : undefined);
};

var CollectionTreeList$1 = withStyles$1(styles$R, {
  name: 'VdtCollectionTreeList'
})(CollectionTreeList);

var styles$S = function styles() {
  return {
    ListItemSecondaryAction: {
      visibility: 'hidden'
    },
    ListItemContainer: {
      '&:hover $ListItemSecondaryAction': {
        visibility: 'visible'
      }
    }
  };
};

function CollectionListItem(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      collectionType = _ref.collectionType,
      onClick = _ref.onClick,
      parseMetadataOptions = _ref.parseMetadataOptions,
      primary = _ref.primary,
      secondary = _ref.secondary,
      AvatarComponent = _ref.AvatarComponent,
      AvatarProps = _ref.AvatarProps,
      ActionComponent = _ref.ActionComponent,
      ActionProps = _ref.ActionProps,
      ListItemProps = _ref.ListItemProps,
      skeleton = _ref.skeleton;
  var collectionId = collectionType.id,
      metadataType = collectionType.metadata;
  var parsedMetadata = parseMetadataType(metadataType, parseMetadataOptions);
  var primaryText;
  var secondaryText;

  if (typeof primary === 'string') {
    primaryText = parsedMetadata[primary];
  } else if (typeof primary === 'function') {
    primaryText = primary(_objectSpread2(_objectSpread2({}, parsedMetadata), {}, {
      collectionType: collectionType,
      collectionId: collectionId
    }));
  }

  if (typeof secondary === 'string') {
    secondaryText = parsedMetadata[secondary];
  } else if (typeof secondary === 'function') {
    secondaryText = secondary(_objectSpread2(_objectSpread2({}, parsedMetadata), {}, {
      collectionType: collectionType,
      collectionId: collectionId
    }));
  }

  return /*#__PURE__*/React__default.createElement(ListItem, _extends({
    className: clsx(className, classes.root, 'VdtCollectionListItem-root'),
    onClick: onClick ? function (event) {
      return onClick(event, {
        collectionId: collectionId,
        collectionType: collectionType
      });
    } : undefined,
    button: onClick ? true : undefined,
    classes: {
      container: classes.ListItemContainer
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemProps), /*#__PURE__*/React__default.createElement(ListItemAvatar, {
    className: clsx(classes.ListItemAvatar, 'VdtCollectionListItem-ListItemAvatar')
  }, /*#__PURE__*/React__default.createElement(AvatarComponent, _extends({
    avatar: "collection",
    collectionId: collectionId,
    collectionType: collectionType,
    skeleton: skeleton // eslint-disable-next-line react/jsx-props-no-spreading

  }, AvatarProps))), /*#__PURE__*/React__default.createElement(ListItemText$1, {
    primary: skeleton ? /*#__PURE__*/React__default.createElement(Skeleton, {
      width: 120
    }) : primaryText,
    secondary: skeleton ? /*#__PURE__*/React__default.createElement(Skeleton, {
      width: 60
    }) : secondaryText
  }), ActionComponent && /*#__PURE__*/React__default.createElement(ListItemSecondaryAction, {
    className: clsx(classes.ListItemSecondaryAction, 'VdtCollectionListItem-ListItemSecondaryAction')
  }, /*#__PURE__*/React__default.createElement(ActionComponent, _extends({
    skeleton: skeleton,
    collectionId: collectionId,
    collectionType: collectionType // eslint-disable-next-line react/jsx-props-no-spreading

  }, ActionProps))));
}
CollectionListItem.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.string),
  collectionType: propTypes.objectOf(propTypes.any).isRequired,
  primary: propTypes.oneOfType([propTypes.string, propTypes.func]),
  secondary: propTypes.oneOfType([propTypes.string, propTypes.func]),
  onClick: propTypes.func,
  ActionComponent: propTypes.elementType,
  ActionProps: propTypes.objectOf(propTypes.any),
  AvatarComponent: propTypes.elementType,
  AvatarProps: propTypes.objectOf(propTypes.any),
  ListItemProps: propTypes.objectOf(propTypes.any),
  parseMetadataOptions: propTypes.objectOf(propTypes.any),
  skeleton: propTypes.bool
};
CollectionListItem.defaultProps = {
  className: undefined,
  classes: {},
  primary: function primary(_ref2) {
    var collectionId = _ref2.collectionId;
    return collectionId;
  },
  secondary: undefined,
  onClick: undefined,
  ActionComponent: undefined,
  ActionProps: {},
  AvatarComponent: MediaCardAvatar$1,
  AvatarProps: {},
  ListItemProps: {},
  parseMetadataOptions: {
    flat: true,
    arrayOnSingle: false
  },
  skeleton: false
};
var CollectionListItem$1 = withStyles(styles$S, {
  name: 'VdtCollectionListItem'
})(CollectionListItem);

var styles$T = function styles() {
  return {
    root: {
      width: '100%'
    },
    listItem: {},
    addButton: {}
  };
};

var CollectionList = function CollectionList(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      _ref$collectionListTy = _ref.collectionListType,
      collectionListType = _ref$collectionListTy === void 0 ? {} : _ref$collectionListTy,
      CollectionListItemComponent = _ref.CollectionListItemComponent,
      CollectionListItemProps = _ref.CollectionListItemProps;
  var _collectionListType$c = collectionListType.collection,
      collectionList = _collectionListType$c === void 0 ? [] : _collectionListType$c;
  return /*#__PURE__*/React__default.createElement(List, {
    className: clsx(classes.root, 'VdtCollectionList-root', className)
  }, collectionList.map(function (collectionType) {
    return /*#__PURE__*/React__default.createElement(CollectionListItemComponent, _extends({
      key: collectionType.id,
      collectionType: collectionType // eslint-disable-next-line react/jsx-props-no-spreading

    }, CollectionListItemProps));
  }));
};
CollectionList.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.any),
  collectionListType: propTypes.objectOf(propTypes.any),
  CollectionListItemComponent: propTypes.elementType,
  CollectionListItemProps: propTypes.objectOf(propTypes.any)
};
CollectionList.defaultProps = {
  className: undefined,
  classes: {},
  collectionListType: {},
  CollectionListItemComponent: CollectionListItem$1,
  CollectionListItemProps: {}
};
var CollectionList$1 = withStyles(styles$T, {
  name: 'VdtCollectionList'
})(CollectionList);

function stringsToBooleans$1(acc, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  if (value === 'true') {
    acc[key] = true;
  } else if (value === 'false') {
    acc[key] = false;
  } else if (_typeof(value) === 'object') {
    acc[key] = Object.entries(value).reduce(stringsToBooleans$1, {});
  } else {
    acc[key] = value;
  }

  return acc;
}

function booleansToStrings$1(acc, _ref3, joinValue) {
  var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];

  if (value === true) {
    acc[key] = 'true';
  } else if (value === false) {
    acc[key] = 'false';
  } else if (_typeof(value) === 'object') {
    acc[key] = Object.entries(value).reduce(booleansToStrings$1, {});
  } else {
    var valueArray = value.split(joinValue);
    acc[key] = valueArray.length > 1 ? valueArray : value;
  }

  return acc;
}

function CollectionMetadataEdit(_ref5) {
  var collectionId = _ref5.collectionId,
      onSuccess = _ref5.onSuccess,
      fields = _ref5.fields,
      groups = _ref5.groups,
      collectionType = _ref5.collectionType,
      onRefresh = _ref5.onRefresh,
      isLoading = _ref5.isLoading,
      joinValue = _ref5.joinValue,
      _ref5$onError = _ref5.onError,
      onError = _ref5$onError === void 0 ? function (error) {
    return console.error(error.message);
  } : _ref5$onError;
  var metadataType = collectionType.metadata;
  var initialValues = React__default.useMemo(function () {
    var values = parseMetadataType(metadataType, {
      flat: true,
      joinValue: joinValue
    });
    var valuesWithBooleans = Object.entries(values).reduce(stringsToBooleans$1, {});
    return valuesWithBooleans;
  }, [metadataType, joinValue]);

  var onSubmit = function onSubmit(values) {
    var valuesAsStrings = Object.entries(values).reduce(function (a, c) {
      return booleansToStrings$1(a, c, joinValue);
    }, {});
    var metadataDocument = createMetadataType(valuesAsStrings);

    try {
      collection.updateCollectionMetadata({
        collectionId: collectionId,
        metadataDocument: metadataDocument
      }).then(function () {
        onRefresh();
        onSuccess();
      })["catch"](onError);
    } catch (error) {
      onError(error);
    }
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && /*#__PURE__*/React__default.createElement(Form, {
    onSubmit: onSubmit,
    component: ItemMetadataForm$1,
    fields: fields,
    groups: groups,
    initialValues: initialValues
  }));
}

function CollectionMetadataTab(_ref) {
  var collectionId = _ref.collectionId,
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields,
      _ref$groups = _ref.groups,
      groups = _ref$groups === void 0 ? [] : _ref$groups,
      _ref$editingLabel = _ref.editingLabel,
      editingLabel = _ref$editingLabel === void 0 ? function (isEditing) {
    return isEditing ? 'Cancel' : 'Edit';
  } : _ref$editingLabel,
      _ref$showEditMetadata = _ref.showEditMetadata,
      showEditMetadata = _ref$showEditMetadata === void 0 ? true : _ref$showEditMetadata,
      onError = _ref.onError,
      onSuccess = _ref.onSuccess,
      _ref$editJoinValue = _ref.editJoinValue,
      editJoinValue = _ref$editJoinValue === void 0 ? ';' : _ref$editJoinValue;
  var queryParams = React__default.useMemo(function () {
    return {
      content: 'metadata',
      field: fields.map(function (_ref2) {
        var name = _ref2.name;
        return name;
      }),
      group: groups.map(function (_ref3) {
        var name = _ref3.name;
        return name;
      })
    };
  }, [fields, groups]);

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isEditing = _React$useState2[0],
      setIsEditing = _React$useState2[1];

  var toggleEdit = function toggleEdit() {
    return setIsEditing(!isEditing);
  };

  var handleSuccess = function handleSuccess(args) {
    toggleEdit();
    if (onSuccess) onSuccess(args);
  };

  var _useAddMetadataFieldA = useAddMetadataFieldAttributes({
    fields: fields,
    groups: groups
  }),
      fieldsWithAttributes = _useAddMetadataFieldA.fieldsWithAttributes,
      groupsWithAttributes = _useAddMetadataFieldA.groupsWithAttributes;

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showEditMetadata && /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel, {
    control: /*#__PURE__*/React__default.createElement(Switch, {
      checked: isEditing,
      onChange: toggleEdit
    }),
    label: editingLabel(isEditing),
    labelPlacement: "start"
  })), (fieldsWithAttributes.length > 0 || groupsWithAttributes.length > 0) && /*#__PURE__*/React__default.createElement(GetCollection, {
    collectionId: collectionId,
    queryParams: queryParams
  }, showEditMetadata && isEditing ? /*#__PURE__*/React__default.createElement(CollectionMetadataEdit, {
    fields: fieldsWithAttributes,
    groups: groupsWithAttributes,
    onSuccess: handleSuccess,
    onError: onError,
    joinValue: editJoinValue
  }) : /*#__PURE__*/React__default.createElement(MetadataType$1, null, /*#__PURE__*/React__default.createElement(ItemMetadataList$1, {
    fields: fieldsWithAttributes,
    groups: groupsWithAttributes
  }))));
}

var CollectionMetadataTab$1 = withStyles({}, {
  name: 'VdtCollectionMetadataTab'
})(CollectionMetadataTab);

function CollectionAccessTab(_ref) {
  var collectionId = _ref.collectionId,
      _ref$toggleAddLabelTe = _ref.toggleAddLabelText,
      toggleAddLabelText = _ref$toggleAddLabelTe === void 0 ? function (isAdding) {
    return isAdding ? 'Cancel' : 'Add permission';
  } : _ref$toggleAddLabelTe,
      _ref$showAddAccess = _ref.showAddAccess,
      showAddAccess = _ref$showAddAccess === void 0 ? true : _ref$showAddAccess,
      _ref$EntityAccessTabl = _ref.EntityAccessTableProps,
      EntityAccessTableProps = _ref$EntityAccessTabl === void 0 ? {} : _ref$EntityAccessTabl;

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isAdding = _React$useState2[0],
      setIsAdding = _React$useState2[1];

  var toggleAdd = function toggleAdd() {
    return setIsAdding(!isAdding);
  };

  var _useEntityAccess = useEntityAccess({
    entityId: collectionId,
    entityType: 'collection'
  }),
      accessControlList = _useEntityAccess.accessControlList,
      onList = _useEntityAccess.onList,
      onRemove = _useEntityAccess.onRemove,
      onAdd = _useEntityAccess.onAdd;

  React__default.useEffect(function () {
    onList();
  }, [onList]);

  var handleRemove = function handleRemove(props) {
    return onRemove(props).then(onList);
  };

  var onAddSuccess = function onAddSuccess() {
    onList();
    setIsAdding(false);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showAddAccess && /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel, {
    control: /*#__PURE__*/React__default.createElement(Switch, {
      checked: isAdding,
      onChange: toggleAdd
    }),
    label: toggleAddLabelText(isAdding),
    labelPlacement: "start"
  })), showAddAccess && isAdding ? /*#__PURE__*/React__default.createElement(EntityAccessEdit$1, {
    entityType: "collection",
    entityId: collectionId,
    onSuccess: onAddSuccess,
    onCancel: function onCancel() {
      return setIsAdding(false);
    },
    onSubmit: onAdd
  }) : /*#__PURE__*/React__default.createElement(EntityAccessTable$1, _extends({
    entityType: "collection",
    entityId: collectionId,
    accessControlList: accessControlList,
    onRemove: handleRemove // eslint-disable-next-line react/jsx-props-no-spreading

  }, EntityAccessTableProps)));
}

var CollectionAccessTab$1 = withStyles({}, {
  name: 'VdtCollectionAccessTab'
})(CollectionAccessTab);

function CollectionCreateDialog(_ref) {
  var _ref$collectionDocume = _ref.collectionDocument,
      collectionDocument = _ref$collectionDocume === void 0 ? {} : _ref$collectionDocume,
      _ref$createText = _ref.createText,
      createText = _ref$createText === void 0 ? 'Create' : _ref$createText,
      _ref$closeText = _ref.closeText,
      closeText = _ref$closeText === void 0 ? 'Cancel' : _ref$closeText,
      _ref$collectionNameTe = _ref.collectionNameText,
      collectionNameText = _ref$collectionNameTe === void 0 ? 'Collection Name' : _ref$collectionNameTe,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'New Collection' : _ref$title,
      open = _ref.open,
      onClose = _ref.onClose,
      onSuccess = _ref.onSuccess;

  var _React$useState = React__default.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      collectionName = _React$useState2[0],
      setCollectionName = _React$useState2[1];

  var onCreateCollection = function onCreateCollection() {
    var queryParams = {
      name: collectionName
    };
    collection.createCollection({
      collectionDocument: collectionDocument,
      queryParams: queryParams
    }).then(function (_ref2) {
      var newCollectionDocument = _ref2.data;
      if (onSuccess) onSuccess(newCollectionDocument);
    });
  };

  return /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, null, title), /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement(TextField$2, {
    autoFocus: true,
    margin: "dense",
    label: collectionNameText,
    type: "text",
    fullWidth: true,
    onChange: function onChange(event) {
      return setCollectionName(event.target.value);
    }
  })), /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: onClose
  }, closeText), /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: onCreateCollection,
    color: "primary",
    variant: "contained",
    disabled: !collectionName
  }, createText)));
}

var CollectionCreateDialog$1 = withStyles({}, {
  name: 'VdtCollectionCreateDialog'
})(CollectionCreateDialog);

var styles$U = function styles(theme) {
  return {
    root: {
      alignItems: 'center',
      width: '100%',
      display: 'flex'
    },
    input: {
      paddingLeft: theme.spacing(1),
      borderWidth: 1,
      flex: 1,
      borderStyle: 'solid',
      borderColor: theme.palette.grey[400],
      borderRadius: 2,
      transition: 'border-color .3s ease-in',
      height: 32
    },
    button: {
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[800],
      color: theme.palette.text.primary,
      borderBottomLeftRadius: 0,
      borderTopLeftRadius: 0,
      borderLeftWidth: 1,
      borderLeftStyle: 'solid',
      borderRadius: 2,
      borderLeftColor: theme.palette.grey[400],
      padding: 0,
      height: '100%'
    },
    closeButton: {
      visibility: 'visible',
      cursor: 'pointer',
      transition: 'visibility .5s ease-in'
    },
    closeButtonHidden: {
      visibility: 'hidden'
    },
    focused: {
      borderColor: theme.palette.primary.main
    },
    touched: {}
  };
};

function useSuggestionsNavigation(_ref) {
  var suggestions = _ref.suggestions,
      inputRef = _ref.inputRef;
  var suggestionsWithCurrent = React__default.useMemo(function () {
    return [].concat(_toConsumableArray(inputRef.current ? [inputRef.current.value] : []), _toConsumableArray(suggestions || []));
  }, [inputRef, suggestions]); // focused includes the current input value, not just the suggestion list

  var _React$useState = React__default.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  React__default.useEffect(function () {
    setFocused(0);
  }, [suggestionsWithCurrent]);

  var mod = function mod(n, m) {
    return (n % m + m) % m;
  };

  var newFocused = function newFocused(prev, e) {
    return mod(prev + (e.key === 'ArrowDown' ? 1 : -1), suggestionsWithCurrent.length);
  };

  var onKeyDown = function onKeyDown(e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (inputRef.current) {
        // eslint-disable-next-line no-param-reassign
        inputRef.current.value = suggestionsWithCurrent[newFocused(focused, e)];
        setFocused(function (prev) {
          return newFocused(prev, e);
        });
      }

      e.preventDefault();
    }
  };

  var onHoverSuggestion = function onHoverSuggestion(i) {
    return setFocused(i + 1);
  };

  var focusedSuggestion = focused - 1;
  return {
    onKeyDown: onKeyDown,
    onHoverSuggestion: onHoverSuggestion,
    focusedSuggestion: focusedSuggestion
  };
}

function SearchInput(_ref2) {
  var _clsx;

  var className = _ref2.className,
      classes = _ref2.classes,
      value = _ref2.value,
      onSubmit = _ref2.onSubmit,
      defaultValue = _ref2.defaultValue,
      submitting = _ref2.submitting,
      suggestions = _ref2.suggestions,
      searchPlaceholder = _ref2.searchPlaceholder,
      onChange = _ref2.onChange,
      SuggestionsComponent = _ref2.SuggestionsComponent,
      SuggestionsProps = _ref2.SuggestionsProps,
      ButtonProps = _ref2.ButtonProps,
      InputBaseProps = _ref2.InputBaseProps,
      SearchIconComponent = _ref2.SearchIconComponent,
      ProgressComponent = _ref2.ProgressComponent,
      ProgressProps = _ref2.ProgressProps,
      CloseIconComponent = _ref2.CloseIconComponent,
      defaultInputRef = _ref2.inputRef;
  var inputRef = React__default.useRef(null);
  if (defaultInputRef) inputRef = defaultInputRef;

  var _React$useState3 = React__default.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isFocused = _React$useState4[0],
      setIsFocused = _React$useState4[1];

  var _React$useState5 = React__default.useState(Boolean(defaultValue)),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      canClear = _React$useState6[0],
      setCanClear = _React$useState6[1];

  var handleOnChange = function handleOnChange(val) {
    onChange(val);
    setCanClear(inputRef.current.value.length > 0);
  };

  var setInput = function setInput(val) {
    if (value === undefined) inputRef.current.value = val;
    handleOnChange(val);
  };

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    if (inputRef && inputRef.current) inputRef.current.blur();

    var _ref3 = inputRef.current || '',
        currValue = _ref3.value;

    onSubmit(currValue);
    if (currValue) setCanClear(true);
  };

  var onClear = function onClear() {
    setCanClear(false);
    onSubmit('');
    setInput('');
  };

  var onSelectedSuggestion = function onSelectedSuggestion(event, suggestion) {
    setInput(suggestion);
    handleSubmit(event);
  };

  var _React$useState7 = React__default.useState(null),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      anchorEl = _React$useState8[0],
      setAnchorEl = _React$useState8[1];

  var suggestionsVisible = Boolean(anchorEl) && isFocused && canClear;

  var _useSuggestionsNaviga = useSuggestionsNavigation({
    suggestions: suggestions,
    inputRef: inputRef
  }),
      onKeyDown = _useSuggestionsNaviga.onKeyDown,
      onHoverSuggestion = _useSuggestionsNaviga.onHoverSuggestion,
      focusedSuggestion = _useSuggestionsNaviga.focusedSuggestion;

  return /*#__PURE__*/React__default.createElement("form", {
    className: clsx(className, classes.root, 'VdtSearchInput-root'),
    onSubmit: handleSubmit
  }, /*#__PURE__*/React__default.createElement(InputBase$1, _extends({
    value: value,
    classes: {
      root: classes.input,
      focused: classes.focused
    },
    defaultValue: defaultValue,
    ref: function ref(r) {
      return setAnchorEl(r);
    },
    inputProps: {
      onFocus: function onFocus() {
        return setIsFocused(true);
      },
      onBlur: function onBlur() {
        return setIsFocused(false);
      }
    },
    placeholder: searchPlaceholder,
    inputRef: inputRef,
    endAdornment: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CloseIconComponent, {
      className: canClear ? classes.closeButton : classes.closeButtonHidden,
      onClick: onClear
    }), /*#__PURE__*/React__default.createElement(Button$1, _extends({
      size: "small",
      type: "submit",
      disableRipple: true,
      className: clsx(classes.button, (_clsx = {}, _defineProperty(_clsx, classes.focused, isFocused), _defineProperty(_clsx, classes.touched, canClear), _clsx)) // eslint-disable-next-line react/jsx-props-no-spreading

    }, ButtonProps), submitting ? /*#__PURE__*/React__default.createElement(ProgressComponent, _extends({
      size: 20,
      color: "inherit" // eslint-disable-next-line react/jsx-props-no-spreading

    }, ProgressProps)) : /*#__PURE__*/React__default.createElement(SearchIconComponent, null))),
    onChange: function onChange(e) {
      return handleOnChange(e.target.value);
    },
    onKeyDown: suggestions && onKeyDown // eslint-disable-next-line react/jsx-props-no-spreading

  }, InputBaseProps)), suggestionsVisible && SuggestionsComponent && /*#__PURE__*/React__default.createElement(SuggestionsComponent, _extends({
    suggestions: suggestions,
    onSelected: onSelectedSuggestion,
    onHover: onHoverSuggestion,
    focused: focusedSuggestion,
    anchorEl: anchorEl // eslint-disable-next-line react/jsx-props-no-spreading

  }, SuggestionsProps)));
}
SearchInput.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.string).isRequired,
  value: propTypes.string,
  onSubmit: propTypes.func,
  defaultValue: propTypes.string,
  submitting: propTypes.bool,
  suggestions: propTypes.arrayOf(propTypes.string),
  searchPlaceholder: propTypes.string,
  onChange: propTypes.func,
  SuggestionsComponent: propTypes.elementType,
  SuggestionsProps: propTypes.objectOf(propTypes.any),
  ButtonProps: propTypes.objectOf(propTypes.any),
  InputBaseProps: propTypes.objectOf(propTypes.any),
  SearchIconComponent: propTypes.elementType,
  ProgressComponent: propTypes.elementType,
  ProgressProps: propTypes.objectOf(propTypes.any),
  CloseIconComponent: propTypes.elementType,
  inputRef: propTypes.shape({
    current: propTypes.instanceOf(Element)
  })
};
SearchInput.defaultProps = {
  className: undefined,
  value: undefined,
  defaultValue: undefined,
  submitting: false,
  suggestions: undefined,
  searchPlaceholder: 'Search',
  onSubmit: function onSubmit() {},
  onChange: function onChange() {},
  SuggestionsComponent: null,
  SuggestionsProps: {},
  ButtonProps: {},
  InputBaseProps: {},
  SearchIconComponent: SearchIcon,
  ProgressComponent: CircularProgress,
  ProgressProps: {},
  CloseIconComponent: CloseIcon,
  inputRef: undefined
};
var SearchInput$1 = withStyles(styles$U, {
  name: 'VdtSearchInput'
})(SearchInput);

function PaginationWrapper(_ref) {
  var _ref$PaginationCompon = _ref.PaginationComponent,
      PaginationComponent = _ref$PaginationCompon === void 0 ? SearchPagination : _ref$PaginationCompon,
      props = _objectWithoutProperties(_ref, ["PaginationComponent"]);

  var _props$collectionList = props.collectionListType.hits,
      count = _props$collectionList === void 0 ? 0 : _props$collectionList;
  return /*#__PURE__*/React__default.createElement(PaginationComponent, _extends({
    count: count // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

function SearchInputWrapper(props) {
  var isLoading = props.isLoading;
  return /*#__PURE__*/React__default.createElement(SearchInput$1, _extends({
    submitting: isLoading // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

function CollectionSearchPicker(_ref2) {
  var onChange = _ref2.onChange,
      _ref2$onCheck = _ref2.onCheck,
      onCheck = _ref2$onCheck === void 0 ? function () {} : _ref2$onCheck,
      _ref2$CollectionTable = _ref2.CollectionTableComponent,
      CollectionTableComponent = _ref2$CollectionTable === void 0 ? CollectionTable : _ref2$CollectionTable,
      _ref2$CollectionTable2 = _ref2.CollectionTableProps,
      CollectionTableProps = _ref2$CollectionTable2 === void 0 ? {} : _ref2$CollectionTable2,
      searchProps = _ref2.searchProps,
      _ref2$idLabelText = _ref2.idLabelText,
      idLabelText = _ref2$idLabelText === void 0 ? 'Id' : _ref2$idLabelText,
      _ref2$titleLabelText = _ref2.titleLabelText,
      titleLabelText = _ref2$titleLabelText === void 0 ? 'Title' : _ref2$titleLabelText,
      _ref2$ownerLabelText = _ref2.ownerLabelText,
      ownerLabelText = _ref2$ownerLabelText === void 0 ? 'Owner' : _ref2$ownerLabelText,
      _ref2$searchPlacehold = _ref2.searchPlaceholder,
      searchPlaceholder = _ref2$searchPlacehold === void 0 ? 'Search collections' : _ref2$searchPlacehold,
      _ref2$SearchInputProp = _ref2.SearchInputProps,
      SearchInputProps = _ref2$SearchInputProp === void 0 ? {} : _ref2$SearchInputProp,
      _ref2$PaginationProps = _ref2.PaginationProps,
      PaginationProps = _ref2$PaginationProps === void 0 ? {} : _ref2$PaginationProps,
      _ref2$SearchCollectio = _ref2.SearchCollectionProps,
      SearchCollectionProps = _ref2$SearchCollectio === void 0 ? {} : _ref2$SearchCollectio;
  var defaultSearchProps = useSearch({
    queryParams: {
      field: ['collectionId', 'title', '__user'],
      content: 'metadata'
    }
  });

  var _ref3 = searchProps || defaultSearchProps,
      state = _ref3.state,
      setSearchText = _ref3.setSearchText,
      onChangeRowsPerPage = _ref3.onChangeRowsPerPage,
      onChangePage = _ref3.onChangePage;

  var matrixParams = state.matrixParams,
      queryParams = state.queryParams,
      itemSearchDocument = state.itemSearchDocument,
      page = state.page,
      rowsPerPage = state.rowsPerPage;

  var _React$useState = React__default.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      checked = _React$useState2[0],
      setChecked = _React$useState2[1];

  var check = function check(collectionId) {
    if (checked.includes(collectionId)) {
      setChecked(function (curr) {
        return curr.filter(function (c) {
          return c !== collectionId;
        });
      });
    } else {
      setChecked(function (curr) {
        return [].concat(_toConsumableArray(curr), [collectionId]);
      });
    }
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  React__default.useEffect(function () {
    return onChange && onChange(checked);
  }, [checked]);

  var handleRowClick = function handleRowClick(_ref4) {
    var id = _ref4.id;
    return check(id);
  };

  return /*#__PURE__*/React__default.createElement(SearchCollection, _extends({
    itemSearchDocument: itemSearchDocument,
    matrixParams: matrixParams,
    queryParams: queryParams // eslint-disable-next-line react/jsx-props-no-spreading

  }, SearchCollectionProps), /*#__PURE__*/React__default.createElement(SearchInputWrapper, _extends({
    onSubmit: function onSubmit(text) {
      return setSearchText("*".concat(text, "*"));
    },
    searchPlaceholder: searchPlaceholder // eslint-disable-next-line react/jsx-props-no-spreading

  }, SearchInputProps)), /*#__PURE__*/React__default.createElement(CollectionTableComponent, _extends({
    onRowClick: handleRowClick,
    onCheck: onCheck,
    selected: checked,
    options: [{
      label: titleLabelText,
      value: 'title'
    }, {
      label: idLabelText,
      value: 'collectionId'
    }, {
      label: ownerLabelText,
      value: '__user'
    }] // eslint-disable-next-line react/jsx-props-no-spreading

  }, CollectionTableProps)), /*#__PURE__*/React__default.createElement(PaginationWrapper, _extends({
    onChangePage: onChangePage,
    onChangeRowsPerPage: onChangeRowsPerPage,
    page: page,
    rowsPerPage: rowsPerPage // eslint-disable-next-line react/jsx-props-no-spreading

  }, PaginationProps)));
}

var CollectionSearchPicker$1 = withStyles({}, {
  name: 'VdtCollectionSearchPicker'
})(CollectionSearchPicker);

function defaultOnSubmit(entities, collectionIds) {
  return Promise.all(collectionIds.map(function (collectionId) {
    return collection.updateCollection({
      collectionId: collectionId,
      collectionDocument: {
        content: entities.map(function (_ref) {
          var id = _ref.id,
              type = _ref.type,
              metadata = _ref.metadata;
          return {
            id: id,
            mode: 'add',
            type: type.toLowerCase(),
            metadata: metadata
          };
        })
      },
      queryParams: {
        clear: false
      }
    });
  }));
}

function defaultOnCreate(entities, collectionDocument) {
  return collection.createCollection({
    collectionDocument: _objectSpread2(_objectSpread2({}, collectionDocument), {}, {
      content: [].concat(_toConsumableArray(collectionDocument.content || []), _toConsumableArray(entities.map(function (_ref2) {
        var id = _ref2.id,
            type = _ref2.type,
            metadata = _ref2.metadata;
        return {
          id: id,
          mode: 'add',
          type: type.toLowerCase(),
          metadata: metadata
        };
      })))
    })
  });
}

var CreateCollection = withStyles({}, {
  name: 'VdtCreateCollection'
})(function (_ref3) {
  var collectionDocument = _ref3.collectionDocument,
      onChange = _ref3.onChange,
      _ref3$collectionNameT = _ref3.collectionNameText,
      collectionNameText = _ref3$collectionNameT === void 0 ? 'New Collection' : _ref3$collectionNameT;

  var _ref4 = collectionDocument.metadata ? parseMetadataType(collectionDocument.metadata, {
    flat: true,
    joinValue: ','
  }) : {},
      _ref4$title = _ref4.title,
      title = _ref4$title === void 0 ? '' : _ref4$title;

  var createCollectionDocument = function createCollectionDocument(newTitle) {
    return {
      metadata: createMetadataType({
        title: newTitle
      })
    };
  };

  var handleChange = function handleChange() {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _event$target = event.target;
    _event$target = _event$target === void 0 ? {} : _event$target;
    var value = _event$target.value;

    if (value) {
      return onChange(createCollectionDocument(value));
    }

    return onChange({});
  };

  return /*#__PURE__*/React__default.createElement(TextField$2, {
    value: title,
    required: true,
    autoFocus: true,
    margin: "dense",
    label: collectionNameText,
    type: "text",
    fullWidth: true,
    onChange: handleChange
  });
});

function AddToCollectionDialog(_ref5) {
  var classes = _ref5.classes,
      className = _ref5.className,
      entities = _ref5.entities,
      onClose = _ref5.onClose,
      onSubmit = _ref5.onSubmit,
      onCreate = _ref5.onCreate,
      onSuccess = _ref5.onSuccess,
      onError = _ref5.onError,
      CollectionPickerComponent = _ref5.CollectionPickerComponent,
      CollectionPickerProps = _ref5.CollectionPickerProps,
      CreateCollectionComponent = _ref5.CreateCollectionComponent,
      CreateCollectionProps = _ref5.CreateCollectionProps,
      defaultView = _ref5.defaultView,
      titleText = _ref5.titleText,
      submitText = _ref5.submitText,
      searchText = _ref5.searchText,
      createdText = _ref5.createdText,
      CreateCollectionIcon = _ref5.CreateCollectionIcon,
      SearchCollectionIcon = _ref5.SearchCollectionIcon;

  var _React$useState = React__default.useState(defaultView),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      view = _React$useState2[0],
      setView = _React$useState2[1];

  var _React$useState3 = React__default.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      collectionIds = _React$useState4[0],
      setCollectionIds = _React$useState4[1];

  var _React$useState5 = React__default.useState({}),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      createCollectionDocument = _React$useState6[0],
      setCreateCollectionDocument = _React$useState6[1];

  var handleSubmit = function handleSubmit() {
    Promise.resolve(view === 'create' ? onCreate(entities, createCollectionDocument) : onSubmit(entities, collectionIds)).then(function () {
      for (var _len = arguments.length, response = new Array(_len), _key = 0; _key < _len; _key++) {
        response[_key] = arguments[_key];
      }

      return onSuccess.apply(void 0, [collectionIds].concat(response));
    })["catch"](function (e) {
      return onError(collectionIds, e);
    })["finally"](function () {
      return onClose();
    });
  };

  var isDisabled = view === 'search' ? collectionIds.length === 0 : Object.keys(createCollectionDocument).length === 0;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtAddToCollectionDialog-root', className)
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, null, titleText), /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement(Tabs$1, {
    value: view,
    onChange: function onChange(e, newValue) {
      return newValue && setView(newValue);
    },
    variant: "fullWidth",
    textColor: "primary",
    indicatorColor: "primary",
    style: {
      marginBottom: '10px'
    }
  }, /*#__PURE__*/React__default.createElement(Tab$1, {
    value: "search",
    label: searchText,
    icon: /*#__PURE__*/React__default.createElement(SearchCollectionIcon, null)
  }), /*#__PURE__*/React__default.createElement(Tab$1, {
    value: "create",
    label: createdText,
    icon: /*#__PURE__*/React__default.createElement(CreateCollectionIcon, null)
  })), {
    search: /*#__PURE__*/React__default.createElement(CollectionPickerComponent, _extends({
      onChange: setCollectionIds // eslint-disable-next-line react/jsx-props-no-spreading

    }, CollectionPickerProps)),
    create: /*#__PURE__*/React__default.createElement(CreateCollectionComponent, _extends({
      collectionDocument: createCollectionDocument,
      onChange: setCreateCollectionDocument // eslint-disable-next-line react/jsx-props-no-spreading

    }, CreateCollectionProps))
  }[view]), /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: handleSubmit,
    color: "primary",
    variant: "contained",
    disabled: isDisabled
  }, submitText)));
}

AddToCollectionDialog.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: propTypes.object,
  className: propTypes.string,
  entities: propTypes.arrayOf(propTypes.shape({
    id: propTypes.string.isRequired,
    type: propTypes.string.isRequired
  })).isRequired,
  onClose: propTypes.func,
  onSubmit: propTypes.func,
  onCreate: propTypes.func,
  onSuccess: propTypes.func,
  onError: propTypes.func,
  CollectionPickerComponent: propTypes.elementType,
  // eslint-disable-next-line react/forbid-prop-types
  CollectionPickerProps: propTypes.object,
  CreateCollectionComponent: propTypes.elementType,
  // eslint-disable-next-line react/forbid-prop-types
  CreateCollectionProps: propTypes.object,
  defaultView: propTypes.string,
  titleText: propTypes.string,
  submitText: propTypes.string,
  searchText: propTypes.string,
  createdText: propTypes.string,
  CreateCollectionIcon: propTypes.elementType,
  SearchCollectionIcon: propTypes.elementType
};
AddToCollectionDialog.defaultProps = {
  classes: {},
  className: undefined,
  CollectionPickerComponent: CollectionSearchPicker$1,
  CreateCollectionComponent: CreateCollection,
  onClose: function onClose() {},
  onSubmit: defaultOnSubmit,
  onCreate: defaultOnCreate,
  onSuccess: function onSuccess() {},
  // eslint-disable-next-line no-console
  onError: function onError(e) {
    return console.error(e);
  },
  CollectionPickerProps: {},
  CreateCollectionProps: {},
  defaultView: 'search',
  titleText: 'Add to Collection',
  submitText: 'Add',
  searchText: 'Search',
  createdText: 'Create',
  CreateCollectionIcon: CreateNewFolderIcon,
  SearchCollectionIcon: SearchIcon
};
var AddToCollectionDialog$1 = withStyles({}, {
  name: 'VdtAddToCollectionDialog'
})(AddToCollectionDialog);

var defaultOnConfirm = function defaultOnConfirm(_ref) {
  var collectionId = _ref.collectionId,
      entityId = _ref.entityId,
      entityType = _ref.entityType;
  return collection.removeCollectionEntity({
    collectionId: collectionId,
    entityId: entityId,
    queryParams: {
      type: entityType
    }
  });
};

function RemoveFromCollectionDialog(_ref2) {
  var className = _ref2.className,
      classes = _ref2.classes,
      entityId = _ref2.entityId,
      entityType = _ref2.entityType,
      collectionId = _ref2.collectionId,
      onSuccess = _ref2.onSuccess,
      onError = _ref2.onError,
      onClose = _ref2.onClose,
      onConfirm = _ref2.onConfirm,
      descriptionText = _ref2.descriptionText,
      titleText = _ref2.titleText,
      cancelText = _ref2.cancelText,
      confirmText = _ref2.confirmText;

  var handleConfirm = function handleConfirm() {
    return onConfirm({
      collectionId: collectionId,
      entityType: entityType,
      entityId: entityId
    }).then(onSuccess)["catch"](onError);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtRemoveFromCollectionDialog-root', className)
  }, /*#__PURE__*/React__default.createElement(DialogTitle, null, titleText), /*#__PURE__*/React__default.createElement(DialogContent, null, descriptionText({
    collectionId: collectionId,
    entityType: entityType,
    entityId: entityId
  })), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button, {
    onClick: onClose,
    color: "primary"
  }, cancelText), /*#__PURE__*/React__default.createElement(Button, {
    variant: "contained",
    onClick: handleConfirm,
    color: "secondary"
  }, confirmText)));
}
RemoveFromCollectionDialog.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.string),
  entityId: propTypes.string.isRequired,
  entityType: propTypes.string.isRequired,
  collectionId: propTypes.string.isRequired,
  onSuccess: propTypes.func,
  onError: propTypes.func,
  onClose: propTypes.func,
  onConfirm: propTypes.func,
  descriptionText: propTypes.func,
  titleText: propTypes.string,
  cancelText: propTypes.string,
  confirmText: propTypes.string
};
RemoveFromCollectionDialog.defaultProps = {
  className: undefined,
  classes: {},
  onSuccess: function onSuccess() {},
  // eslint-disable-next-line no-console
  onError: function onError(e) {
    return console.error(e);
  },
  onClose: function onClose() {},
  onConfirm: defaultOnConfirm,
  descriptionText: function descriptionText(_ref3) {
    var collectionId = _ref3.collectionId,
        entityType = _ref3.entityType;
    return "Do you want to remove this ".concat(entityType, " from ").concat(collectionId, "?");
  },
  titleText: 'Remove From Collection?',
  cancelText: 'Cancel',
  confirmText: 'Remove'
};

window.lodashGet = get$1;

var styles$V = function styles() {
  return {
    root: {},
    ListItemAvatar: {
      paddingRight: 6,
      marginTop: 0,
      marginBottom: 0
    },
    Thumbnail: {},
    Paper: {
      height: 94,
      width: 168,
      position: 'relative'
    },
    Icon: {
      fontSize: 40,
      position: 'absolute',
      left: '50%',
      marginLeft: -20,
      top: '50%',
      marginTop: -20
    },
    ThumbnailLabel: {
      position: 'absolute',
      bottom: 0,
      right: 4
    },
    ListItemTextComponent: {},
    primary: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    secondary: {
      fontStyle: 'italic'
    }
  };
};

var defaultListItemTextComponent = function defaultListItemTextComponent(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      _ref$ListItemTextComp = _ref.ListItemTextComponent,
      ListItemTextComponent = _ref$ListItemTextComp === void 0 ? ListItemText$1 : _ref$ListItemTextComp,
      itemId = _ref.itemId,
      itemType = _ref.itemType,
      simpleMetadataType = _ref.simpleMetadataType,
      _ref$primaryTextKeys = _ref.primaryTextKeys,
      primaryTextKeys = _ref$primaryTextKeys === void 0 ? ['adu_label_AWSVideoRekognitionAnalyzer.adu_value', 'adu_transcript_AWSTranscribeAnalyzer.adu_value', 'adu_celebrity_AWSVideoRekognitionAnalyzer.adu_value', 'stl_subtitle.stl_text', 'co'] : _ref$primaryTextKeys,
      props = _objectWithoutProperties(_ref, ["className", "classes", "ListItemTextComponent", "itemId", "itemType", "simpleMetadataType", "primaryTextKeys"]);

  var _parseSimpleMetadataT = parseSimpleMetadataType(simpleMetadataType),
      startTimecodeText = _parseSimpleMetadataT.start,
      endTimecodeText = _parseSimpleMetadataT.end;

  var isEvent = startTimecodeText !== undefined;
  var _itemType$metadata = itemType.metadata,
      metadataType = _itemType$metadata === void 0 ? {} : _itemType$metadata;
  var timedMetadataTimespan = findTimespan(metadataType, startTimecodeText, endTimecodeText);
  var genericMetadataTimespan = findTimespan(metadataType, '-INF', '+INF');

  var _parseTimespan = parseTimespan(genericMetadataTimespan, {
    flat: true,
    arrayOnSingle: false
  }),
      title = _parseTimespan.title,
      originalFilename = _parseTimespan.originalFilename,
      durationSeconds = _parseTimespan.durationSeconds,
      user = _parseTimespan.user,
      created = _parseTimespan.created;

  var timedMetadata = parseTimespan(timedMetadataTimespan, {
    flat: true,
    arrayOnSingle: false
  });
  var start = formatTimeCodeText(startTimecodeText);
  var end = formatTimeCodeText(endTimecodeText);
  var primary;
  var secondary;

  if (isEvent) {
    primary = /*#__PURE__*/React__default.createElement("div", null, primaryTextKeys.map(function (textKey) {
      return get$1(timedMetadata, textKey) !== undefined ? /*#__PURE__*/React__default.createElement("div", {
        key: textKey,
        className: classes.primary
      }, get$1(timedMetadata, textKey)) : null;
    }));
    secondary = /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      className: classes.secondary
    }, "".concat(start.toSmpte(), " - ").concat(end.toSmpte())), /*#__PURE__*/React__default.createElement("div", {
      className: classes.primary
    }, title || originalFilename), /*#__PURE__*/React__default.createElement("div", null, "".concat(user, " \u2022 ").concat(moment(created).fromNow())));
  } else if (durationSeconds) {
    primary = /*#__PURE__*/React__default.createElement("div", {
      className: classes.primary
    }, title || originalFilename);
    secondary = "".concat(user, " \u2022 ").concat(moment(created).fromNow());
  }

  return /*#__PURE__*/React__default.createElement(ListItemTextComponent, _extends({
    className: className,
    primary: primary,
    secondary: secondary,
    secondaryTypographyProps: {
      component: 'div'
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
};

var defaultListItemAvatarComponent = function defaultListItemAvatarComponent(_ref2) {
  var className = _ref2.className,
      classes = _ref2.classes,
      itemId = _ref2.itemId,
      itemType = _ref2.itemType,
      simpleMetadataType = _ref2.simpleMetadataType,
      _ref2$PaperProps = _ref2.PaperProps,
      PaperProps = _ref2$PaperProps === void 0 ? {} : _ref2$PaperProps,
      _ref2$ThumbnailCompon = _ref2.ThumbnailComponent,
      ThumbnailComponent = _ref2$ThumbnailCompon === void 0 ? MediaCardThumbnail$1 : _ref2$ThumbnailCompon,
      _ref2$ThumbnailProps = _ref2.ThumbnailProps,
      ThumbnailProps = _ref2$ThumbnailProps === void 0 ? {} : _ref2$ThumbnailProps,
      _ref2$ThumbnailLabelC = _ref2.ThumbnailLabelComponent,
      ThumbnailLabelComponent = _ref2$ThumbnailLabelC === void 0 ? MediaCardThumbnailLabel$1 : _ref2$ThumbnailLabelC,
      _ref2$IconComponent = _ref2.IconComponent,
      IconComponent = _ref2$IconComponent === void 0 ? MimeTypeIcon$1 : _ref2$IconComponent,
      _ref2$ListItemAvatarC = _ref2.ListItemAvatarComponent,
      ListItemAvatarComponent = _ref2$ListItemAvatarC === void 0 ? ListItemAvatar : _ref2$ListItemAvatarC,
      props = _objectWithoutProperties(_ref2, ["className", "classes", "itemId", "itemType", "simpleMetadataType", "PaperProps", "ThumbnailComponent", "ThumbnailProps", "ThumbnailLabelComponent", "IconComponent", "ListItemAvatarComponent"]);

  var _parseSimpleMetadataT2 = parseSimpleMetadataType(simpleMetadataType),
      startTimecodeText = _parseSimpleMetadataT2.start,
      endTimecodeText = _parseSimpleMetadataT2.end;

  var isEvent = startTimecodeText !== undefined;
  var _itemType$metadata2 = itemType.metadata,
      metadataType = _itemType$metadata2 === void 0 ? {} : _itemType$metadata2;
  var genericMetadataTimespan = findTimespan(metadataType, '-INF', '+INF');

  var _parseTimespan2 = parseTimespan(genericMetadataTimespan, {
    flat: true,
    arrayOnSingle: false
  }),
      durationSeconds = _parseTimespan2.durationSeconds,
      mimeType = _parseTimespan2.mimeType;

  var start = formatTimeCodeText(startTimecodeText);
  var end = formatTimeCodeText(endTimecodeText);
  var labelRightBottom;

  if (isEvent) {
    labelRightBottom = end.subtract(start).toSmpte();
  } else if (durationSeconds) {
    labelRightBottom = formatSeconds(durationSeconds).toDuration();
  }

  var thumbnail = findNearestThumbnail(itemType, startTimecodeText);
  return /*#__PURE__*/React__default.createElement(ListItemAvatarComponent, _extends({
    className: className // eslint-disable-next-line react/jsx-props-no-spreading

  }, props), thumbnail ? /*#__PURE__*/React__default.createElement(ThumbnailComponent, _extends({
    className: classes.Thumbnail,
    innerProps: {
      itemType: {
        thumbnails: {
          uri: [thumbnail]
        }
      }
    },
    height: 94,
    width: 168,
    labelRightBottom: labelRightBottom // eslint-disable-next-line react/jsx-props-no-spreading

  }, ThumbnailProps)) : /*#__PURE__*/React__default.createElement(Paper$1, _extends({
    className: classes.Paper,
    elevation: 0,
    square: true // eslint-disable-next-line react/jsx-props-no-spreading

  }, PaperProps), /*#__PURE__*/React__default.createElement(IconComponent, {
    mimeType: mimeType,
    className: classes.Icon
  }), labelRightBottom && /*#__PURE__*/React__default.createElement(ThumbnailLabelComponent, {
    className: classes.ThumbnailLabel,
    label: labelRightBottom
  })));
};

function CollectionContentItem(_ref3) {
  var className = _ref3.className,
      classes = _ref3.classes,
      selected = _ref3.selected,
      simpleMetadataType = _ref3.simpleMetadataType,
      itemType = _ref3.itemType,
      itemId = _ref3.itemId,
      entityType = _ref3.entityType,
      onClick = _ref3.onClick,
      _ref3$ListItemCompone = _ref3.ListItemComponent,
      ListItemComponent = _ref3$ListItemCompone === void 0 ? ListItem : _ref3$ListItemCompone,
      _ref3$ListItemProps = _ref3.ListItemProps,
      ListItemProps = _ref3$ListItemProps === void 0 ? {} : _ref3$ListItemProps,
      _ref3$ListItemTextCom = _ref3.ListItemTextComponent,
      ListItemTextComponent = _ref3$ListItemTextCom === void 0 ? defaultListItemTextComponent : _ref3$ListItemTextCom,
      _ref3$ListItemTextPro = _ref3.ListItemTextProps,
      ListItemTextProps = _ref3$ListItemTextPro === void 0 ? {} : _ref3$ListItemTextPro,
      _ref3$ListItemAvatarC = _ref3.ListItemAvatarComponent,
      ListItemAvatarComponent = _ref3$ListItemAvatarC === void 0 ? defaultListItemAvatarComponent : _ref3$ListItemAvatarC,
      _ref3$ListItemAvatarP = _ref3.ListItemAvatarProps,
      ListItemAvatarProps = _ref3$ListItemAvatarP === void 0 ? {} : _ref3$ListItemAvatarP;

  var _parseSimpleMetadataT3 = parseSimpleMetadataType(simpleMetadataType),
      startTimecodeText = _parseSimpleMetadataT3.start;

  var startSeconds = startTimecodeText ? formatTimeCodeText(startTimecodeText).toSeconds() : undefined;
  var isSelected = selected && selected.entityType === 'item' && selected.entityId === itemId && selected.startSeconds === startSeconds;

  var onClickListItem = function onClickListItem() {
    return onClick({
      entityType: entityType,
      entityId: itemId,
      startSeconds: startSeconds
    });
  };

  return /*#__PURE__*/React__default.createElement(ListItemComponent, _extends({
    className: clsx(classes.root, className),
    selected: isSelected,
    alignItems: "flex-start",
    button: true,
    onClick: onClickListItem // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemProps), /*#__PURE__*/React__default.createElement(ListItemAvatarComponent, _extends({
    className: classes.ListItemAvatar,
    classes: classes,
    itemId: itemId,
    itemType: itemType,
    simpleMetadataType: simpleMetadataType // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemAvatarProps)), /*#__PURE__*/React__default.createElement(ListItemTextComponent, _extends({
    className: classes.ListItemTextComponent,
    classes: classes,
    itemId: itemId,
    itemType: itemType,
    simpleMetadataType: simpleMetadataType // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemTextProps)));
}

var CollectionContentItem$1 = withStyles(styles$V, {
  name: 'VdtCollectionContentItem'
})(CollectionContentItem);

var styles$W = function styles() {
  return {
    root: {},
    ListItemAvatar: {
      paddingRight: 6,
      marginTop: 0,
      marginBottom: 0
    },
    Paper: {
      height: 94,
      width: 168,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    Icon: {
      fontSize: 40
    },
    primary: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    secondary: {},
    ListItemText: {}
  };
};

var defaultListItemTextComponent$1 = function defaultListItemTextComponent(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      _ref$ListItemTextComp = _ref.ListItemTextComponent,
      ListItemTextComponent = _ref$ListItemTextComp === void 0 ? ListItemText$1 : _ref$ListItemTextComp,
      collectionId = _ref.collectionId,
      collectionType = _ref.collectionType,
      props = _objectWithoutProperties(_ref, ["className", "classes", "ListItemTextComponent", "collectionId", "collectionType"]);

  var _collectionType$metad = collectionType.metadata,
      metadataType = _collectionType$metad === void 0 ? {} : _collectionType$metad;
  var genericMetadataTimespan = findTimespan(metadataType, '-INF', '+INF');

  var _parseTimespan = parseTimespan(genericMetadataTimespan, {
    flat: true,
    arrayOnSingle: false
  }),
      title = _parseTimespan.title,
      user = _parseTimespan.user,
      created = _parseTimespan.created;

  return /*#__PURE__*/React__default.createElement(ListItemTextComponent, _extends({
    className: className,
    primary: /*#__PURE__*/React__default.createElement("div", {
      className: classes.primary
    }, title),
    secondary: /*#__PURE__*/React__default.createElement("div", {
      className: classes.secondary
    }, "".concat(user, " \u2022 ").concat(moment(created).fromNow())),
    secondaryTypographyProps: {
      component: 'div'
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
};

function CollectionContentCollection(_ref2) {
  var className = _ref2.className,
      classes = _ref2.classes,
      selected = _ref2.selected,
      collectionType = _ref2.collectionType,
      collectionId = _ref2.collectionId,
      entityType = _ref2.entityType,
      onClick = _ref2.onClick,
      _ref2$ListItemCompone = _ref2.ListItemComponent,
      ListItemComponent = _ref2$ListItemCompone === void 0 ? ListItem : _ref2$ListItemCompone,
      _ref2$ListItemProps = _ref2.ListItemProps,
      ListItemProps = _ref2$ListItemProps === void 0 ? {} : _ref2$ListItemProps,
      _ref2$ListItemTextCom = _ref2.ListItemTextComponent,
      ListItemTextComponent = _ref2$ListItemTextCom === void 0 ? defaultListItemTextComponent$1 : _ref2$ListItemTextCom,
      _ref2$ListItemTextPro = _ref2.ListItemTextProps,
      ListItemTextProps = _ref2$ListItemTextPro === void 0 ? {} : _ref2$ListItemTextPro,
      _ref2$ListItemAvatarC = _ref2.ListItemAvatarComponent,
      ListItemAvatarComponent = _ref2$ListItemAvatarC === void 0 ? ListItemAvatar : _ref2$ListItemAvatarC,
      _ref2$ListItemAvatarP = _ref2.ListItemAvatarProps,
      ListItemAvatarProps = _ref2$ListItemAvatarP === void 0 ? {} : _ref2$ListItemAvatarP,
      _ref2$PaperProps = _ref2.PaperProps,
      PaperProps = _ref2$PaperProps === void 0 ? {} : _ref2$PaperProps,
      _ref2$IconComponent = _ref2.IconComponent,
      IconComponent = _ref2$IconComponent === void 0 ? MimeTypeIcon$1 : _ref2$IconComponent;
  var isSelected = selected && selected.entityType === 'collection' && selected.entityId === collectionId;

  var onClickListItem = function onClickListItem() {
    return onClick({
      entityType: entityType,
      entityId: collectionId
    });
  };

  return /*#__PURE__*/React__default.createElement(ListItemComponent, _extends({
    className: clsx(classes.root, className),
    selected: isSelected,
    alignItems: "flex-start",
    button: true,
    onClick: onClickListItem // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemProps), /*#__PURE__*/React__default.createElement(ListItemAvatarComponent, _extends({
    className: classes.ListItemAvatar // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemAvatarProps), /*#__PURE__*/React__default.createElement(Paper$1, _extends({
    className: classes.Paper,
    elevation: 0,
    square: true // eslint-disable-next-line react/jsx-props-no-spreading

  }, PaperProps), /*#__PURE__*/React__default.createElement(IconComponent, {
    mimeType: entityType,
    className: classes.Icon
  }))), /*#__PURE__*/React__default.createElement(ListItemTextComponent, _extends({
    className: classes.ListItemText,
    classes: classes,
    collectionType: collectionType,
    collectionId: collectionId // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemTextProps)));
}

var CollectionContentCollection$1 = withStyles(styles$W, {
  name: 'VdtCollectionContentCollection'
})(CollectionContentCollection);

var styles$X = function styles() {
  return {
    root: {},
    ListItemAvatar: {},
    Avatar: {},
    ListItemText: {},
    Action: {},
    ListItemSecondaryAction: {
      visibility: 'hidden'
    },
    ListItemContainer: {
      '&:hover $ListItemSecondaryAction': {
        visibility: 'visible'
      }
    }
  };
};

function CollectionContentSkeleton(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      AvatarComponent = _ref.AvatarComponent,
      AvatarProps = _ref.AvatarProps,
      ActionComponent = _ref.ActionComponent,
      ActionProps = _ref.ActionProps,
      ListItemProps = _ref.ListItemProps,
      ListItemAvatarProps = _ref.ListItemAvatarProps,
      ListItemTextProps = _ref.ListItemTextProps;
  return /*#__PURE__*/React__default.createElement(ListItem, _extends({
    className: clsx(className, classes.root, 'VdtCollectionContentSkeleton-root'),
    classes: {
      container: classes.ListItemContainer
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemProps), /*#__PURE__*/React__default.createElement(ListItemAvatar, _extends({
    className: clsx(classes.ListItemAvatar, 'VdtCollectionContentSkeleton-ListItemAvatar') // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemAvatarProps), /*#__PURE__*/React__default.createElement(AvatarComponent, _extends({
    variant: "rect",
    height: "100%",
    width: "100%" // eslint-disable-next-line react/jsx-props-no-spreading

  }, AvatarProps))), /*#__PURE__*/React__default.createElement(ListItemText$1, _extends({
    primary: /*#__PURE__*/React__default.createElement(Skeleton, {
      width: 120
    }),
    secondary: /*#__PURE__*/React__default.createElement(Skeleton, {
      width: 60
    }),
    className: clsx(classes.ListItemText, 'VdtCollectionContentSkeleton-ListItemText') // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemTextProps)), ActionComponent && /*#__PURE__*/React__default.createElement(ListItemSecondaryAction, {
    className: clsx(classes.ListItemSecondaryAction, 'VdtCollectionContentSkeleton-ListItemSecondaryAction')
  }, /*#__PURE__*/React__default.createElement(ActionComponent, _extends({
    skeleton: true,
    className: clsx(classes.Action, 'VdtCollectionContentSkeleton-Action') // eslint-disable-next-line react/jsx-props-no-spreading

  }, ActionProps))));
}

CollectionContentSkeleton.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.string),
  ActionComponent: propTypes.elementType,
  ActionProps: propTypes.objectOf(propTypes.any),
  AvatarComponent: propTypes.elementType,
  AvatarProps: propTypes.objectOf(propTypes.any),
  ListItemProps: propTypes.objectOf(propTypes.any),
  ListItemAvatarProps: propTypes.objectOf(propTypes.any),
  ListItemTextProps: propTypes.objectOf(propTypes.any)
};
CollectionContentSkeleton.defaultProps = {
  className: undefined,
  classes: {},
  ActionComponent: undefined,
  ActionProps: {},
  AvatarComponent: Skeleton,
  AvatarProps: {},
  ListItemProps: {},
  ListItemAvatarProps: {},
  ListItemTextProps: {}
};
var CollectionContentSkeleton$1 = withStyles(styles$X, {
  name: 'VdtCollectionContentSkeleton'
})(CollectionContentSkeleton);

function CollectionContentEntity(_ref) {
  var collectionContentType = _ref.collectionContentType,
      onClick = _ref.onClick,
      selected = _ref.selected,
      _ref$ItemEntityCompon = _ref.ItemEntityComponent,
      ItemEntityComponent = _ref$ItemEntityCompon === void 0 ? CollectionContentItem$1 : _ref$ItemEntityCompon,
      _ref$ItemContentProps = _ref.ItemContentProps,
      ItemContentProps = _ref$ItemContentProps === void 0 ? {} : _ref$ItemContentProps,
      _ref$CollectionEntity = _ref.CollectionEntityComponent,
      CollectionEntityComponent = _ref$CollectionEntity === void 0 ? CollectionContentCollection$1 : _ref$CollectionEntity,
      _ref$CollectionEntity2 = _ref.CollectionEntityProps,
      CollectionEntityProps = _ref$CollectionEntity2 === void 0 ? {} : _ref$CollectionEntity2,
      _ref$LoadingEntityCom = _ref.LoadingEntityComponent,
      LoadingEntityComponent = _ref$LoadingEntityCom === void 0 ? CollectionContentSkeleton$1 : _ref$LoadingEntityCom,
      _ref$LoadingEntityPro = _ref.LoadingEntityProps,
      LoadingEntityProps = _ref$LoadingEntityPro === void 0 ? {} : _ref$LoadingEntityPro;
  var entityId = collectionContentType.id,
      entityType = collectionContentType.type,
      simpleMetadataType = collectionContentType.metadata;

  var _useGetEntity = useGetEntity({
    entityId: entityId,
    entityType: entityType
  }),
      itemType = _useGetEntity.itemType,
      itemId = _useGetEntity.itemId,
      collectionType = _useGetEntity.collectionType,
      collectionId = _useGetEntity.collectionId,
      onGetEntity = _useGetEntity.onGetEntity,
      isLoading = _useGetEntity.isLoading;

  React__default.useEffect(function () {
    onGetEntity({
      queryParams: {
        content: ['metadata', 'thumbnail'],
        'noauth-url': true
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return isLoading ? /*#__PURE__*/React__default.createElement(LoadingEntityComponent, _extends({
    AvatarProps: {
      height: 94,
      width: 168
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, LoadingEntityProps)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, {
    item: /*#__PURE__*/React__default.createElement(ItemEntityComponent, _extends({
      itemId: itemId,
      itemType: itemType,
      entityType: entityType,
      simpleMetadataType: simpleMetadataType,
      onClick: onClick,
      selected: selected // eslint-disable-next-line react/jsx-props-no-spreading

    }, ItemContentProps)),
    collection: /*#__PURE__*/React__default.createElement(CollectionEntityComponent, _extends({
      collectionId: collectionId,
      collectionType: collectionType,
      entityType: entityType,
      simpleMetadataType: simpleMetadataType,
      onClick: onClick,
      selected: selected // eslint-disable-next-line react/jsx-props-no-spreading

    }, CollectionEntityProps))
  }[entityType]);
}

var CollectionContentEntity$1 = withStyles({}, {
  name: 'VdtCollectionContentEntity'
})(CollectionContentEntity);

var styles$Y = function styles() {
  return {
    root: {}
  };
};

function CollectionContent(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      collectionId = _ref.collectionId,
      _ref$ListProps = _ref.ListProps,
      ListProps = _ref$ListProps === void 0 ? {} : _ref$ListProps,
      _ref$ListComponent = _ref.ListComponent,
      ListComponent = _ref$ListComponent === void 0 ? List$1 : _ref$ListComponent,
      _ref$ListItemComponen = _ref.ListItemComponent,
      ListItemComponent = _ref$ListItemComponen === void 0 ? CollectionContentEntity$1 : _ref$ListItemComponen,
      _ref$ListItemProps = _ref.ListItemProps,
      ListItemProps = _ref$ListItemProps === void 0 ? {} : _ref$ListItemProps,
      onClick = _ref.onClick,
      selected = _ref.selected;

  var _useGetCollection = useGetCollection({
    collectionId: collectionId
  }),
      collectionType = _useGetCollection.collectionType;

  var _collectionType$conte = collectionType.content,
      content = _collectionType$conte === void 0 ? [] : _collectionType$conte;
  return /*#__PURE__*/React__default.createElement(ListComponent, _extends({
    component: "div",
    className: clsx(classes.root, className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListProps), content.map(function (collectionContentType) {
    return /*#__PURE__*/React__default.createElement(ListItemComponent, _extends({
      key: collectionContentType.reference || collectionContentType.id,
      collectionContentType: collectionContentType,
      onClick: onClick,
      selected: selected // eslint-disable-next-line react/jsx-props-no-spreading

    }, ListItemProps));
  }));
}

var CollectionContent$1 = withStyles(styles$Y, {
  name: 'VdtCollectionContent'
})(CollectionContent);

var styles$Z = {};

var ActionComponent = function ActionComponent(_ref) {
  var collectionId = _ref.collectionId,
      itemId = _ref.itemId,
      _ref$removeText = _ref.removeText,
      removeText = _ref$removeText === void 0 ? 'Remove Item From Collection' : _ref$removeText,
      onClickCollection = _ref.onClick,
      _ref$goToText = _ref.goToText,
      goToText = _ref$goToText === void 0 ? 'Go To Collection' : _ref$goToText,
      onRefresh = _ref.onRefresh;

  var _useMenu = useMenu(),
      anchorEl = _useMenu.anchorEl,
      onOpen = _useMenu.onOpen,
      onClose = _useMenu.onClose,
      isOpen = _useMenu.isOpen,
      onClickMenu = _useMenu.onClick;

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openDialog = _React$useState2[0],
      setOpenDialog = _React$useState2[1];

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ButtonBase, {
    size: "small",
    onClick: onOpen
  }, /*#__PURE__*/React__default.createElement(MoreVertIcon, null)), /*#__PURE__*/React__default.createElement(Menu, {
    anchorEl: anchorEl,
    open: isOpen,
    keepMounted: true,
    onClose: onClose,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: onClickMenu(function (e) {
      return onClickCollection(e, {
        collectionId: collectionId
      });
    })
  }, /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(ForwardIcon, {
    fontSize: "small"
  })), /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: goToText
  })), /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: onClickMenu(function () {
      return setOpenDialog(true);
    })
  }, /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(RemoveCircleOutlineIcon, {
    fontSize: "small"
  })), /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: removeText
  }))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: openDialog
  }, /*#__PURE__*/React__default.createElement(RemoveFromCollectionDialog, {
    collectionId: collectionId,
    entityId: itemId,
    entityType: "item",
    onClose: function onClose() {
      return setOpenDialog(false);
    },
    onSuccess: function onSuccess() {
      onRefresh();
      setOpenDialog(false);
    }
  })));
};

function ItemParentsTab(_ref2) {
  var className = _ref2.className,
      classes = _ref2.classes,
      itemId = _ref2.itemId,
      initialItemSearchDocument = _ref2.itemSearchDocument,
      initialCollectionListType = _ref2.collectionListType,
      queryParams = _ref2.queryParams,
      onError = _ref2.onError,
      CollectionListComponent = _ref2.CollectionListComponent,
      CollectionListProps = _ref2.CollectionListProps;

  var _React$useState3 = React__default.useState(initialCollectionListType),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      collectionListType = _React$useState4[0],
      setCollectionListType = _React$useState4[1];

  var _React$useState5 = React__default.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      skeleton = _React$useState6[0],
      setSkeleton = _React$useState6[1];

  var onRefresh = function onRefresh() {
    item.getItem({
      itemId: itemId,
      queryParams: {
        content: 'metadata',
        field: '__collection'
      }
    }).then(function (_ref3) {
      var itemType = _ref3.data;

      var _parseMetadataType = parseMetadataType(itemType.metadata, {
        flat: true
      }),
          _parseMetadataType$__ = _parseMetadataType.__collection,
          parentCollectionIds = _parseMetadataType$__ === void 0 ? [] : _parseMetadataType$__;

      if (parentCollectionIds.length === 0) {
        return {
          data: {}
        };
      }

      var parentCollectionsField = {
        name: 'collectionId',
        value: parentCollectionIds.map(function (id) {
          return {
            value: id
          };
        })
      };

      var itemSearchDocument = lodash_update(initialItemSearchDocument, 'field', function () {
        var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return [].concat(_toConsumableArray(field.filter(function (f) {
          return f.name !== 'collectionId';
        })), [parentCollectionsField]);
      });

      return collection.searchCollection({
        itemSearchDocument: itemSearchDocument,
        queryParams: queryParams
      });
    }).then(function (_ref4) {
      var newCollectionListType = _ref4.data;
      setCollectionListType(newCollectionListType);
      setSkeleton(false);
    })["catch"](function (error) {
      return onError(error);
    });
  };

  React__default.useEffect(function () {
    onRefresh(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var _CollectionListProps$ = CollectionListProps.CollectionListItemProps,
      CollectionListItemProps = _CollectionListProps$ === void 0 ? {} : _CollectionListProps$;
  var onClick = CollectionListItemProps.onClick,
      _CollectionListItemPr = CollectionListItemProps.ActionProps,
      ActionProps = _CollectionListItemPr === void 0 ? {} : _CollectionListItemPr;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtItemParentsTab-root', className)
  }, /*#__PURE__*/React__default.createElement(CollectionListComponent, _extends({
    collectionListType: collectionListType
  }, CollectionListProps, {
    CollectionListItemProps: _objectSpread2({
      skeleton: skeleton,
      ActionProps: _objectSpread2({
        itemId: itemId,
        onClick: onClick,
        onRefresh: onRefresh
      }, ActionProps),
      ActionComponent: ActionComponent
    }, CollectionListItemProps)
  })));
}
ItemParentsTab.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.any).isRequired,
  itemId: propTypes.string.isRequired,
  itemSearchDocument: propTypes.objectOf(propTypes.any),
  queryParams: propTypes.objectOf(propTypes.any),
  onError: propTypes.func,
  CollectionListComponent: propTypes.elementType,
  CollectionListProps: propTypes.objectOf(propTypes.any),
  collectionListType: propTypes.objectOf(propTypes.any)
};
ItemParentsTab.defaultProps = {
  className: undefined,
  itemSearchDocument: {},
  queryParams: {
    content: 'metadata',
    field: 'title'
  },
  // eslint-disable-next-line no-console
  onError: function onError(_ref5) {
    var message = _ref5.message;
    return console.error(message);
  },
  CollectionListComponent: CollectionList$1,
  CollectionListProps: {},
  collectionListType: {
    collection: _toConsumableArray(Array(3).keys()).map(function (id) {
      return {
        id: String(id)
      };
    })
  }
};
var ItemParentsTab$1 = withStyles(styles$Z, {
  name: 'VdtItemParentsTab'
})(ItemParentsTab);

var styles$_ = function styles() {
  return {
    root: {},
    ListItemAvatar: {},
    Avatar: {},
    ListItemText: {},
    Action: {},
    ListItemSecondaryAction: {
      visibility: 'hidden'
    },
    ListItemContainer: {
      '&:hover $ListItemSecondaryAction': {
        visibility: 'visible'
      }
    }
  };
};

function ItemListItem(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      itemType = _ref.itemType,
      onClick = _ref.onClick,
      parseMetadataOptions = _ref.parseMetadataOptions,
      primary = _ref.primary,
      secondary = _ref.secondary,
      AvatarComponent = _ref.AvatarComponent,
      AvatarProps = _ref.AvatarProps,
      ActionComponent = _ref.ActionComponent,
      ActionProps = _ref.ActionProps,
      ListItemProps = _ref.ListItemProps,
      skeleton = _ref.skeleton,
      ListItemAvatarProps = _ref.ListItemAvatarProps,
      ListItemTextProps = _ref.ListItemTextProps;
  var itemId = itemType.id,
      metadataType = itemType.metadata;
  var primaryText;
  var secondaryText;

  if (skeleton === false) {
    var parsedMetadata = parseMetadataType(metadataType, parseMetadataOptions);

    if (typeof primary === 'string') {
      primaryText = parsedMetadata[primary];
    } else if (typeof primary === 'function') {
      primaryText = primary(_objectSpread2(_objectSpread2({}, parsedMetadata), {}, {
        itemType: itemType,
        itemId: itemId
      }));
    }

    if (typeof secondary === 'string') {
      secondaryText = parsedMetadata[secondary];
    } else if (typeof secondary === 'function') {
      secondaryText = secondary(_objectSpread2(_objectSpread2({}, parsedMetadata), {}, {
        itemType: itemType,
        itemId: itemId
      }));
    }
  }

  return /*#__PURE__*/React__default.createElement(ListItem, _extends({
    className: clsx(className, classes.root, 'VdtItemListItem-root'),
    onClick: onClick ? function (event) {
      return onClick(event, {
        id: itemId
      });
    } : undefined,
    button: onClick ? true : undefined,
    classes: {
      container: classes.ListItemContainer
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemProps), /*#__PURE__*/React__default.createElement(ListItemAvatar, _extends({
    className: clsx(classes.ListItemAvatar, 'VdtItemListItem-ListItemAvatar') // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListItemAvatarProps), /*#__PURE__*/React__default.createElement(AvatarComponent, _extends({
    avatar: "item",
    itemId: itemId,
    itemType: itemType,
    skeleton: skeleton,
    className: clsx(classes.Avatar, 'VdtItemListItem-Avatar') // eslint-disable-next-line react/jsx-props-no-spreading

  }, AvatarProps))), /*#__PURE__*/React__default.createElement(ListItemText$1, _extends({
    primary: skeleton ? /*#__PURE__*/React__default.createElement(Skeleton, {
      width: 120
    }) : primaryText,
    secondary: skeleton ? /*#__PURE__*/React__default.createElement(Skeleton, {
      width: 60
    }) : secondaryText,
    className: clsx(classes.ListItemText, 'VdtItemListItem-ListItemText')
  }, ListItemTextProps)), ActionComponent && /*#__PURE__*/React__default.createElement(ListItemSecondaryAction, {
    className: clsx(classes.ListItemSecondaryAction, 'VdtItemListItem-ListItemSecondaryAction')
  }, /*#__PURE__*/React__default.createElement(ActionComponent, _extends({
    skeleton: skeleton,
    itemType: itemType,
    className: clsx(classes.Action, 'VdtItemListItem-Action') // eslint-disable-next-line react/jsx-props-no-spreading

  }, ActionProps))));
}
ItemListItem.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.string),
  itemType: propTypes.objectOf(propTypes.any),
  primary: propTypes.oneOfType([propTypes.string, propTypes.func]),
  secondary: propTypes.oneOfType([propTypes.string, propTypes.func]),
  onClick: propTypes.func,
  ActionComponent: propTypes.elementType,
  ActionProps: propTypes.objectOf(propTypes.any),
  AvatarComponent: propTypes.elementType,
  AvatarProps: propTypes.objectOf(propTypes.any),
  ListItemProps: propTypes.objectOf(propTypes.any),
  ListItemAvatarProps: propTypes.objectOf(propTypes.any),
  ListItemTextProps: propTypes.objectOf(propTypes.any),
  parseMetadataOptions: propTypes.objectOf(propTypes.any),
  skeleton: propTypes.bool
};
ItemListItem.defaultProps = {
  className: undefined,
  classes: {},
  itemType: {},
  primary: function primary(_ref2) {
    var itemId = _ref2.itemId;
    return itemId;
  },
  secondary: undefined,
  onClick: undefined,
  ActionComponent: undefined,
  ActionProps: {},
  AvatarComponent: MediaCardAvatar$1,
  AvatarProps: {},
  ListItemProps: {},
  ListItemAvatarProps: {},
  ListItemTextProps: {},
  parseMetadataOptions: {
    flat: true,
    arrayOnSingle: false
  },
  skeleton: false
};
var ItemListItem$1 = withStyles(styles$_, {
  name: 'VdtItemListItem'
})(ItemListItem);

var styles$$ = function styles() {
  return {
    root: {
      width: '100%'
    }
  };
};

var ItemList = function ItemList(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      itemListType = _ref.itemListType,
      ItemListItemComponent = _ref.ItemListItemComponent,
      ItemListItemProps = _ref.ItemListItemProps;
  var _itemListType$item = itemListType.item,
      itemList = _itemListType$item === void 0 ? [] : _itemListType$item;
  return /*#__PURE__*/React__default.createElement(List, {
    className: clsx(classes.root, 'VdtItemList-root', className)
  }, itemList.map(function (itemType) {
    return /*#__PURE__*/React__default.createElement(ItemListItemComponent, _extends({
      key: itemType.id,
      itemType: itemType,
      primary: "title" // eslint-disable-next-line react/jsx-props-no-spreading

    }, ItemListItemProps));
  }));
};
ItemList.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.any),
  itemListType: propTypes.objectOf(propTypes.any),
  ItemListItemComponent: propTypes.elementType,
  ItemListItemProps: propTypes.objectOf(propTypes.any)
};
ItemList.defaultProps = {
  className: undefined,
  classes: {},
  itemListType: {},
  ItemListItemComponent: ItemListItem$1,
  ItemListItemProps: {}
};
var ItemList$1 = withStyles(styles$$, {
  name: 'VdtItemList'
})(ItemList);

function ItemRelationRemoveDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      onSuccess = _ref.onSuccess,
      relationId = _ref.relationId,
      onError = _ref.onError,
      onConfirm = _ref.onConfirm,
      ConfirmationDialogProps = _ref.ConfirmationDialogProps,
      titleText = _ref.titleText,
      confirmText = _ref.confirmText,
      rejectText = _ref.rejectText;

  var handleConfirm = function handleConfirm() {
    return onConfirm({
      relationId: relationId
    }).then(onSuccess)["catch"](onError);
  };

  return /*#__PURE__*/React__default.createElement(ConfirmationDialog, _extends({
    open: open,
    onReject: onClose,
    titleText: titleText,
    confirmText: confirmText,
    rejectText: rejectText,
    onConfirm: handleConfirm // eslint-disable-next-line react/jsx-props-no-spreading

  }, ConfirmationDialogProps));
}

ItemRelationRemoveDialog.propTypes = {
  relationId: propTypes.string.isRequired,
  open: propTypes.bool,
  onClose: propTypes.func,
  onSuccess: propTypes.func,
  onError: propTypes.func,
  onConfirm: propTypes.func,
  ConfirmationDialogProps: propTypes.objectOf(propTypes.any),
  titleText: propTypes.string,
  confirmText: propTypes.string,
  rejectText: propTypes.string
};
ItemRelationRemoveDialog.defaultProps = {
  open: false,
  onClose: undefined,
  onSuccess: undefined,
  // eslint-disable-next-line no-console
  onError: function onError(_ref2) {
    var message = _ref2.message,
        error = _ref2.error;
    return console.error("".concat(message, "\n").concat(error));
  },
  onConfirm: function onConfirm(_ref3) {
    var relationId = _ref3.relationId;
    return item.removeRelation({
      relationId: relationId
    });
  },
  ConfirmationDialogProps: {},
  titleText: 'Remove relation?',
  confirmText: 'Remove',
  rejectText: 'Cancel'
};
var ItemRelationRemoveDialog$1 = withStyles({}, {
  name: 'VdtItemRelationRemoveDialog'
})(ItemRelationRemoveDialog);

var metadataToProps$2 = function metadataToProps(_ref) {
  var itemType = _ref.itemType,
      parseMetadataOpts = _ref.parseMetadataOpts,
      options = _ref.options;
  var _itemType$metadata = itemType.metadata,
      metadata = _itemType$metadata === void 0 ? {} : _itemType$metadata;
  var parsedMetadata = parseMetadataType(metadata, parseMetadataOpts);
  return options.map(function (_ref2) {
    var value = _ref2.value;
    var parsedValue = parsedMetadata[value];
    return parsedValue;
  });
};

function ItemRow(_ref3) {
  var _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? [] : _ref3$options,
      _ref3$metadataToProps = _ref3.metadataToProps,
      handleMetadataToProps = _ref3$metadataToProps === void 0 ? metadataToProps$2 : _ref3$metadataToProps,
      _ref3$parseMetadataOp = _ref3.parseMetadataOpts,
      parseMetadataOpts = _ref3$parseMetadataOp === void 0 ? {
    joinValue: ', ',
    flat: true
  } : _ref3$parseMetadataOp,
      selected = _ref3.selected,
      onCheck = _ref3.onCheck,
      onClick = _ref3.onClick,
      _ref3$TableRowProps = _ref3.TableRowProps,
      TableRowProps = _ref3$TableRowProps === void 0 ? {} : _ref3$TableRowProps,
      innerProps = _objectWithoutProperties(_ref3, ["options", "metadataToProps", "parseMetadataOpts", "selected", "onCheck", "onClick", "TableRowProps"]);

  var itemType = innerProps.itemType;
  var rowValues = React__default.useMemo(function () {
    return handleMetadataToProps({
      itemType: itemType,
      parseMetadataOpts: parseMetadataOpts,
      options: options
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [itemType, options, metadataToProps$2]);

  var handleChecked = function handleChecked(event) {
    if (onCheck) onCheck(event, !selected, innerProps);
  };

  return /*#__PURE__*/React__default.createElement(TableRow$3$1, _extends({
    hover: true,
    selected: selected,
    onClick: onClick,
    style: {
      cursor: 'pointer'
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, TableRowProps), onCheck && /*#__PURE__*/React__default.createElement(TableCell$1, {
    padding: "checkbox"
  }, /*#__PURE__*/React__default.createElement(MediaCardCheckbox, {
    checked: selected,
    handleChecked: handleChecked
  })), rowValues.map(function (cellValue, index) {
    return /*#__PURE__*/React__default.createElement(Hidden, {
      key: options[index].key || options[index].value || options[index].label,
      only: options[index].hide
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, options[index].valueComponent ? /*#__PURE__*/React__default.createElement(Box, {
      component: options[index].valueComponent,
      value: cellValue,
      innerProps: innerProps
    }) : cellValue));
  }));
}

function ItemTable(_ref) {
  var _ref$itemListType = _ref.itemListType,
      itemListType = _ref$itemListType === void 0 ? {} : _ref$itemListType,
      _ref$RowComponent = _ref.RowComponent,
      RowComponent = _ref$RowComponent === void 0 ? ItemRow : _ref$RowComponent,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      onCheck = _ref.onCheck,
      selected = _ref.selected,
      onRowClick = _ref.onRowClick,
      innerProps = _objectWithoutProperties(_ref, ["itemListType", "RowComponent", "options", "onCheck", "selected", "onRowClick"]);

  var _itemListType$item = itemListType.item,
      item = _itemListType$item === void 0 ? [] : _itemListType$item;
  return /*#__PURE__*/React__default.createElement(Table$1, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead$1$1, null, /*#__PURE__*/React__default.createElement(TableRow$3$1, null, onCheck && /*#__PURE__*/React__default.createElement(TableCell$1, {
    padding: "checkbox"
  }), options.map(function (_ref2, idx) {
    var label = _ref2.label,
        value = _ref2.value,
        hide = _ref2.hide;
    return /*#__PURE__*/React__default.createElement(Hidden, {
      key: label || value || idx,
      only: hide
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, label));
  }))), /*#__PURE__*/React__default.createElement(TableBody$1, null, item && item.map(function (itemType) {
    return /*#__PURE__*/React__default.createElement(RowComponent, _extends({
      key: itemType.id,
      itemType: itemType,
      itemId: itemType.id,
      options: options,
      onCheck: onCheck,
      selected: selected && selected.includes(itemType.id),
      onClick: function onClick() {
        return onRowClick(itemType);
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, innerProps));
  })));
}

function PaginationWrapper$1(props) {
  var _props$itemListType$h = props.itemListType.hits,
      count = _props$itemListType$h === void 0 ? 0 : _props$itemListType$h;
  return /*#__PURE__*/React__default.createElement(SearchPagination, _extends({
    count: count // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

function SearchInputWrapper$1(props) {
  var isLoading = props.isLoading;
  return /*#__PURE__*/React__default.createElement(SearchInput$1, _extends({
    submitting: isLoading // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

var initialSearchState = {
  queryParams: {
    field: ['itemId', 'title', '__user'],
    content: 'metadata'
  }
};

function ItemSearchPicker(_ref) {
  var onChange = _ref.onChange,
      _ref$onCheck = _ref.onCheck,
      onCheck = _ref$onCheck === void 0 ? function () {} : _ref$onCheck,
      _ref$ItemTableCompone = _ref.ItemTableComponent,
      ItemTableComponent = _ref$ItemTableCompone === void 0 ? ItemTable : _ref$ItemTableCompone,
      _ref$ItemTableProps = _ref.ItemTableProps,
      ItemTableProps = _ref$ItemTableProps === void 0 ? {} : _ref$ItemTableProps,
      _ref$searchProps = _ref.searchProps,
      searchProps = _ref$searchProps === void 0 ? useSearch(initialSearchState) : _ref$searchProps,
      _ref$idLabelText = _ref.idLabelText,
      idLabelText = _ref$idLabelText === void 0 ? 'Id' : _ref$idLabelText,
      _ref$titleLabelText = _ref.titleLabelText,
      titleLabelText = _ref$titleLabelText === void 0 ? 'Title' : _ref$titleLabelText,
      _ref$ownerLabelText = _ref.ownerLabelText,
      ownerLabelText = _ref$ownerLabelText === void 0 ? 'Owner' : _ref$ownerLabelText,
      _ref$searchPlaceholde = _ref.searchPlaceholder,
      searchPlaceholder = _ref$searchPlaceholde === void 0 ? 'Search item' : _ref$searchPlaceholde,
      _ref$SearchInputProps = _ref.SearchInputProps,
      SearchInputProps = _ref$SearchInputProps === void 0 ? {} : _ref$SearchInputProps,
      _ref$PaginationProps = _ref.PaginationProps,
      PaginationProps = _ref$PaginationProps === void 0 ? {} : _ref$PaginationProps,
      _ref$SearchItemProps = _ref.SearchItemProps,
      SearchItemProps = _ref$SearchItemProps === void 0 ? {} : _ref$SearchItemProps;
  var state = searchProps.state,
      setSearchText = searchProps.setSearchText,
      onChangeRowsPerPage = searchProps.onChangeRowsPerPage,
      onChangePage = searchProps.onChangePage;
  var matrixParams = state.matrixParams,
      queryParams = state.queryParams,
      itemSearchDocument = state.itemSearchDocument,
      page = state.page,
      rowsPerPage = state.rowsPerPage;

  var _React$useState = React__default.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      checked = _React$useState2[0],
      setChecked = _React$useState2[1];

  var check = function check(collectionId) {
    if (checked.includes(collectionId)) {
      setChecked(function (curr) {
        return curr.filter(function (c) {
          return c !== collectionId;
        });
      });
    } else {
      setChecked(function (curr) {
        return [].concat(_toConsumableArray(curr), [collectionId]);
      });
    }
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  React__default.useEffect(function () {
    return onChange && onChange(checked);
  }, [checked]);

  var handleRowClick = function handleRowClick(_ref2) {
    var id = _ref2.id;
    return check(id);
  };

  return /*#__PURE__*/React__default.createElement(SearchItem, _extends({
    itemSearchDocument: itemSearchDocument,
    matrixParams: matrixParams,
    queryParams: queryParams // eslint-disable-next-line react/jsx-props-no-spreading

  }, SearchItemProps), /*#__PURE__*/React__default.createElement(SearchInputWrapper$1, _extends({
    onSubmit: function onSubmit(text) {
      return setSearchText("*".concat(text, "*"));
    },
    searchPlaceholder: searchPlaceholder // eslint-disable-next-line react/jsx-props-no-spreading

  }, SearchInputProps)), /*#__PURE__*/React__default.createElement(ItemTableComponent, _extends({
    onRowClick: handleRowClick,
    onCheck: onCheck,
    selected: checked,
    options: [{
      label: titleLabelText,
      value: 'title'
    }, {
      label: idLabelText,
      value: 'itemId'
    }, {
      label: ownerLabelText,
      value: '__user'
    }] // eslint-disable-next-line react/jsx-props-no-spreading

  }, ItemTableProps)), /*#__PURE__*/React__default.createElement(PaginationWrapper$1, _extends({
    onChangePage: onChangePage,
    onChangeRowsPerPage: onChangeRowsPerPage,
    page: page,
    rowsPerPage: rowsPerPage // eslint-disable-next-line react/jsx-props-no-spreading

  }, PaginationProps)));
}

var ItemSearchPicker$1 = withStyles({}, {
  name: 'VdtItemSearchPicker'
})(ItemSearchPicker);

function defaultOnSubmit$1(itemId, itemIds) {
  return Promise.resolve(item.createItemRelationList({
    itemRelationListDocument: {
      relation: itemIds.map(function (item) {
        return {
          direction: {
            source: itemId,
            target: item
          }
        };
      })
    }
  }));
}

function AddRelationDialog(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      itemId = _ref.itemId,
      onSubmit = _ref.onSubmit,
      onSuccess = _ref.onSuccess,
      onError = _ref.onError,
      ItemPickerComponent = _ref.ItemPickerComponent,
      ItemPickerProps = _ref.ItemPickerProps,
      view = _ref.defaultView,
      titleText = _ref.titleText,
      submitText = _ref.submitText,
      onRefresh = _ref.onRefresh,
      open = _ref.open,
      setOpenDialog = _ref.setOpenDialog;

  var _React$useState = React__default.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      itemIds = _React$useState2[0],
      setItemIds = _React$useState2[1];

  var handleSubmit = function handleSubmit() {
    Promise.resolve(onSubmit(itemId, itemIds)).then(function () {
      for (var _len = arguments.length, response = new Array(_len), _key = 0; _key < _len; _key++) {
        response[_key] = arguments[_key];
      }

      onSuccess.apply(void 0, [itemIds].concat(response));
      setOpenDialog(false);
      onRefresh();
    })["catch"](function (e) {
      return onError(itemIds, e);
    })["finally"](function () {
      return setOpenDialog(false);
    });
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtAddRelationDialog-root', className)
  }, /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: open,
    onClose: function onClose() {
      setOpenDialog(false);
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, null, titleText), /*#__PURE__*/React__default.createElement(DialogContent$1, null, {
    search: /*#__PURE__*/React__default.createElement(ItemPickerComponent, _extends({
      onChange: setItemIds // eslint-disable-next-line react/jsx-props-no-spreading

    }, ItemPickerProps))
  }[view]), /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: function onClick() {
      setOpenDialog(false);
    },
    color: "secondary"
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: handleSubmit,
    color: "primary",
    variant: "contained",
    disabled: view === 'search' && itemIds.length === 0
  }, submitText))));
}

AddRelationDialog.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: propTypes.object,
  className: propTypes.string,
  itemId: propTypes.string.isRequired,
  onClose: propTypes.func,
  onSubmit: propTypes.func,
  onSuccess: propTypes.func,
  onError: propTypes.func,
  ItemPickerComponent: propTypes.elementType,
  // eslint-disable-next-line react/forbid-prop-types
  ItemPickerProps: propTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  CreateCollectionProps: propTypes.object,
  defaultView: propTypes.string,
  titleText: propTypes.string,
  submitText: propTypes.string,
  searchText: propTypes.string,
  SearchCollectionIcon: propTypes.elementType,
  onRefresh: propTypes.func,
  open: propTypes.bool,
  setOpenDialog: propTypes.func
};
AddRelationDialog.defaultProps = {
  classes: {},
  className: undefined,
  ItemPickerComponent: ItemSearchPicker$1,
  onClose: function onClose() {},
  onSubmit: defaultOnSubmit$1,
  onSuccess: function onSuccess() {},
  // eslint-disable-next-line no-console
  onError: function onError(e) {
    return console.error(e);
  },
  ItemPickerProps: {},
  CreateCollectionProps: {},
  defaultView: 'search',
  titleText: 'Add Relation',
  submitText: 'Add',
  searchText: 'Search',
  SearchCollectionIcon: SearchIcon,
  onRefresh: function onRefresh() {},
  open: false,
  setOpenDialog: function setOpenDialog() {}
};
var AddRelationDialog$1 = withStyles({}, {
  name: 'VdtAddRelationDialog'
})(AddRelationDialog);

var styles$10 = {
  root: {},
  actions: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {}
};

var ActionComponent$1 = function ActionComponent(_ref) {
  var itemId = _ref.itemId,
      itemType = _ref.itemType,
      _ref$itemRelationList = _ref.itemRelationListType,
      itemRelationListType = _ref$itemRelationList === void 0 ? {} : _ref$itemRelationList,
      _ref$removeText = _ref.removeText,
      removeText = _ref$removeText === void 0 ? 'Remove Relation' : _ref$removeText,
      onItemClick = _ref.onClick,
      _ref$goToText = _ref.goToText,
      goToText = _ref$goToText === void 0 ? 'Go To Item' : _ref$goToText,
      onRefresh = _ref.onRefresh,
      onRemove = _ref.onRemove,
      _ref$MenuIcon = _ref.MenuIcon,
      MenuIcon = _ref$MenuIcon === void 0 ? MoreVertIcon : _ref$MenuIcon;

  var _useMenu = useMenu(),
      anchorEl = _useMenu.anchorEl,
      onOpen = _useMenu.onOpen,
      onClose = _useMenu.onClose,
      isOpen = _useMenu.isOpen,
      onClickMenu = _useMenu.onClick;

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openDialog = _React$useState2[0],
      setOpenDialog = _React$useState2[1];

  var onCloseDialog = function onCloseDialog() {
    return setOpenDialog(false);
  };

  var _itemRelationListType = itemRelationListType.relation,
      relationList = _itemRelationListType === void 0 ? [] : _itemRelationListType;

  var _ref2 = relationList.find(function (_ref3) {
    var _ref3$direction = _ref3.direction;
    _ref3$direction = _ref3$direction === void 0 ? {} : _ref3$direction;
    var source = _ref3$direction.source,
        target = _ref3$direction.target;
    return (source === itemType.id || target === itemType.id) && (source === itemId || target === itemId);
  }) || {},
      relationId = _ref2.id;

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ButtonBase, {
    size: "small",
    onClick: onOpen
  }, /*#__PURE__*/React__default.createElement(MenuIcon, null)), /*#__PURE__*/React__default.createElement(Menu, {
    anchorEl: anchorEl,
    open: isOpen,
    keepMounted: true,
    onClose: onClose,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: onClickMenu(function (e) {
      return onItemClick(e, {
        id: itemType.id
      });
    })
  }, /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(ForwardIcon, {
    fontSize: "small"
  })), /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: goToText
  })), /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: onClickMenu(function () {
      return setOpenDialog(true);
    })
  }, /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(RemoveCircleOutlineIcon, {
    fontSize: "small"
  })), /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: removeText
  }))), /*#__PURE__*/React__default.createElement(ItemRelationRemoveDialog$1, {
    itemId: itemType.id,
    relationId: relationId,
    open: openDialog,
    onClose: onCloseDialog,
    onSuccess: function onSuccess() {
      onCloseDialog();
      if (onRemove) onRemove();
      onRefresh();
    }
  }));
};

function ItemRelationsTab(_ref4) {
  var className = _ref4.className,
      classes = _ref4.classes,
      itemId = _ref4.itemId,
      initialItemSearchDocument = _ref4.itemSearchDocument,
      queryParams = _ref4.queryParams,
      onError = _ref4.onError,
      ItemListComponent = _ref4.ItemListComponent,
      ItemListProps = _ref4.ItemListProps,
      onAdd = _ref4.onAdd,
      onRemove = _ref4.onRemove,
      addText = _ref4.addText,
      direction = _ref4.direction;

  var _React$useState3 = React__default.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      openDialog = _React$useState4[0],
      setOpenDialog = _React$useState4[1];

  var _useApi = useApi(item.listItemRelation),
      _useApi$data = _useApi.data,
      itemRelationListType = _useApi$data === void 0 ? {} : _useApi$data,
      listItemRelation = _useApi.request;

  var _useApi2 = useApi(item.searchItem),
      itemListType = _useApi2.data,
      searchItem = _useApi2.request,
      reset = _useApi2.reset;

  var onRefresh = function onRefresh() {
    return listItemRelation({
      itemId: itemId,
      queryParams: {
        direction: direction
      }
    })["catch"](function (e) {
      return onError(e.message);
    });
  };

  React__default.useEffect(function () {
    onRefresh(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId, direction]);
  React__default.useEffect(function () {
    var _itemRelationListType2 = itemRelationListType.relation,
        relationList = _itemRelationListType2 === void 0 ? [] : _itemRelationListType2;

    if (relationList.length === 0) {
      if (itemListType && itemListType.hits > 0) reset();
      return;
    }

    var relationsField = {
      name: 'itemId',
      value: relationList.map(function (_ref5) {
        var _ref5$direction = _ref5.direction,
            source = _ref5$direction.source,
            target = _ref5$direction.target;
        return {
          value: source === itemId ? target : source
        };
      })
    };

    var itemSearchDocument = lodash_update(initialItemSearchDocument, 'field', function () {
      var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return [].concat(_toConsumableArray(field.filter(function (f) {
        return f.name !== 'itemId';
      })), [relationsField]);
    });

    searchItem({
      itemSearchDocument: itemSearchDocument,
      queryParams: queryParams
    })["catch"](function (e) {
      return onError(e.message);
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemRelationListType]);
  var _ItemListProps$ItemLi = ItemListProps.ItemListItemProps,
      ItemListItemProps = _ItemListProps$ItemLi === void 0 ? {} : _ItemListProps$ItemLi;
  var onClick = ItemListItemProps.onClick,
      _ItemListItemProps$Ac = ItemListItemProps.ActionProps,
      ActionProps = _ItemListItemProps$Ac === void 0 ? {} : _ItemListItemProps$Ac;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtItemRelationsTab-root', className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "contained",
    color: "primary",
    className: classes.button,
    startIcon: /*#__PURE__*/React__default.createElement(AddIcon, null),
    onClick: function onClick() {
      setOpenDialog(true);
    }
  }, addText)), /*#__PURE__*/React__default.createElement(ItemListComponent, _extends({
    itemListType: itemListType // eslint-disable-next-line react/jsx-props-no-spreading

  }, ItemListProps, {
    ItemListItemProps: _objectSpread2({
      ActionProps: _objectSpread2({
        itemId: itemId,
        onClick: onClick,
        onRefresh: onRefresh,
        itemRelationListType: itemRelationListType,
        onRemove: onRemove
      }, ActionProps),
      ActionComponent: ActionComponent$1
    }, ItemListItemProps)
  })), /*#__PURE__*/React__default.createElement(AddRelationDialog$1, {
    itemId: itemId,
    open: openDialog,
    setOpenDialog: setOpenDialog,
    onSuccess: onAdd,
    onRefresh: onRefresh
  }));
}
ItemRelationsTab.propTypes = {
  className: propTypes.string,
  classes: propTypes.objectOf(propTypes.any).isRequired,
  itemId: propTypes.string.isRequired,
  itemSearchDocument: propTypes.objectOf(propTypes.any),
  queryParams: propTypes.objectOf(propTypes.any),
  onError: propTypes.func,
  ItemListComponent: propTypes.elementType,
  ItemListProps: propTypes.objectOf(propTypes.any),
  onRemove: propTypes.func,
  onAdd: propTypes.func,
  addText: propTypes.string,
  direction: propTypes.oneOf(['U', 'S', 'T', 'D', 'A'])
};
ItemRelationsTab.defaultProps = {
  className: undefined,
  itemSearchDocument: {},
  queryParams: {
    content: 'metadata',
    field: 'title'
  },
  // eslint-disable-next-line no-console
  onError: function onError(_ref6) {
    var message = _ref6.message;
    return console.error(message);
  },
  ItemListComponent: ItemList$1,
  ItemListProps: {},
  onRemove: function onRemove() {},
  onAdd: function onAdd() {},
  addText: 'Add new relation',
  direction: 'A'
};
var ItemRelationsTab$1 = withStyles(styles$10, {
  name: 'VdtItemRelationsTab'
})(ItemRelationsTab);

var itemTabStyles = function itemTabStyles(theme) {
  var _root;

  return {
    root: (_root = {
      paddingLeft: 0,
      minHeight: 20
    }, _defineProperty(_root, theme.breakpoints.up('sm'), {
      minWidth: 0
    }), _defineProperty(_root, "borderWidth", 1), _defineProperty(_root, '&:not(:first-of-type)', {
      marginLeft: -1
    }), _defineProperty(_root, "backgroundColor", 'unset'), _defineProperty(_root, '&::after', {
      color: theme.palette.primary.main,
      transition: 'width 0.25s ease-in-out 0.05s',
      borderBottom: '0.25em solid',
      width: 0,
      position: 'absolute',
      bottom: 0,
      left: 0,
      content: '""'
    }), _defineProperty(_root, '&:hover', {
      opacity: 1,
      backgroundColor: 'unset',
      '&::after': {
        width: 'calc(100% - 12px)'
      }
    }), _root),
    selected: {
      backgroundColor: 'unset',
      '&::after': {
        width: 'calc(100% - 12px)'
      }
    }
  };
};

var Tab = withStyles(itemTabStyles, {
  name: 'VdtItemTab'
})(Tab$1);
var itemTabsStyles = {
  root: {
    backgroundColor: 'unset',
    minHeight: 20
  },
  indicator: {
    display: 'none'
  },
  scrollButtons: {
    backgroundColor: 'unset'
  }
};
var Tabs = withStyles(itemTabsStyles, {
  name: 'VdtItemTabs'
})(Tabs$1);

var TabPanel = function TabPanel(_ref) {
  var _ref$hideOnMount = _ref.hideOnMount,
      hideOnMount = _ref$hideOnMount === void 0 ? true : _ref$hideOnMount,
      currentTab = _ref.currentTab,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["hideOnMount", "currentTab", "value"]);

  return !hideOnMount && value !== currentTab ? null : /*#__PURE__*/React__default.createElement(Box, _extends({
    p: 3,
    hidden: value !== currentTab // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
};

function ItemTabs(_ref2) {
  var _ref2$tabs = _ref2.tabs,
      tabs = _ref2$tabs === void 0 ? [] : _ref2$tabs,
      props = _objectWithoutProperties(_ref2, ["tabs"]);

  var _React$useState = React__default.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentTab = _React$useState2[0],
      setCurrentTab = _React$useState2[1];

  var onChangeTab = function onChangeTab(event, newValue) {
    setCurrentTab(newValue);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: onChangeTab,
    variant: "scrollable",
    scrollButtons: "auto"
  }, tabs.map(function (_ref3, idx) {
    var label = _ref3.label;
    return /*#__PURE__*/React__default.createElement(Tab, {
      label: label,
      value: idx,
      key: label
    });
  })), /*#__PURE__*/React__default.createElement(Divider$1, null), tabs.map(function (_ref4, idx) {
    var TabComponent = _ref4.component,
        label = _ref4.label,
        _ref4$hideOnMount = _ref4.hideOnMount,
        hideOnMount = _ref4$hideOnMount === void 0 ? true : _ref4$hideOnMount,
        tabProps = _objectWithoutProperties(_ref4, ["component", "label", "hideOnMount"]);

    return /*#__PURE__*/React__default.createElement(TabPanel, {
      currentTab: currentTab,
      hideOnMount: hideOnMount,
      value: idx,
      key: label
    }, /*#__PURE__*/React__default.createElement(TabComponent, _extends({}, props, tabProps)));
  }));
}

var formatDurationSeconds = function formatDurationSeconds(durationSeconds) {
  var hours = Math.floor(durationSeconds / 3600);
  var minutes = Math.floor(durationSeconds % 3600 / 60);
  var seconds = Math.floor(durationSeconds % 60);
  var timeArray = [hours.toString().padStart(2, '0'), minutes.toString().padStart(2, '0'), seconds.toString().padStart(2, '0')];
  return timeArray.join(':');
};

function MediaCardDurationLabel(_ref) {
  var label = _ref.label;
  if (!label) return null;
  var seconds = Number(label);
  if (seconds === 0) return null;
  var formattedDuration = formatDurationSeconds(seconds);
  return /*#__PURE__*/React__default.createElement(MediaCardThumbnailLabel$1, {
    label: formattedDuration
  });
}

var metadataToProps$3 = function metadataToProps(_ref) {
  var itemType = _ref.itemType,
      titleSelector = _ref.titleSelector,
      subheaderSelector = _ref.subheaderSelector,
      imageSelector = _ref.imageSelector,
      contentSelector = _ref.contentSelector,
      avatarSelector = _ref.avatarSelector,
      labelRightBottomSelector = _ref.labelRightBottomSelector,
      parseMetadataOpts = _ref.parseMetadataOpts,
      parseHighlightOpts = _ref.parseHighlightOpts;
  var _itemType$metadata = itemType.metadata,
      metadata = _itemType$metadata === void 0 ? {} : _itemType$metadata,
      _itemType$timespan = itemType.timespan,
      timespan = _itemType$timespan === void 0 ? [] : _itemType$timespan;
  var parsedMetadata = parseMetadataType(metadata, parseMetadataOpts);
  var parsedHighlight = parseHighlightTimespanList(timespan, parseHighlightOpts);
  return {
    title: titleSelector(parsedMetadata, parsedHighlight),
    subheader: subheaderSelector(parsedMetadata, parsedHighlight),
    image: imageSelector(parsedMetadata),
    content: contentSelector(parsedMetadata),
    avatar: avatarSelector(parsedMetadata),
    labelRightBottom: labelRightBottomSelector(parsedMetadata)
  };
};

function ItemCard(_ref2) {
  var itemType = _ref2.itemType,
      MediaCardComponent = _ref2.MediaCardComponent,
      handleMetadataToProps = _ref2.metadataToProps,
      parseMetadataOpts = _ref2.parseMetadataOpts,
      parseHighlightOpts = _ref2.parseHighlightOpts,
      titleSelector = _ref2.titleSelector,
      subheaderSelector = _ref2.subheaderSelector,
      imageSelector = _ref2.imageSelector,
      contentSelector = _ref2.contentSelector,
      avatarSelector = _ref2.avatarSelector,
      labelRightBottomSelector = _ref2.labelRightBottomSelector,
      innerProps = _objectWithoutProperties(_ref2, ["itemType", "MediaCardComponent", "metadataToProps", "parseMetadataOpts", "parseHighlightOpts", "titleSelector", "subheaderSelector", "imageSelector", "contentSelector", "avatarSelector", "labelRightBottomSelector"]);

  var mediaCardProps = React__default.useMemo(function () {
    return handleMetadataToProps({
      itemType: itemType,
      titleSelector: titleSelector,
      subheaderSelector: subheaderSelector,
      imageSelector: imageSelector,
      contentSelector: contentSelector,
      avatarSelector: avatarSelector,
      labelRightBottomSelector: labelRightBottomSelector,
      parseMetadataOpts: parseMetadataOpts,
      parseHighlightOpts: parseHighlightOpts
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [itemType]);
  return /*#__PURE__*/React__default.createElement(MediaCardComponent, _extends({
    title: mediaCardProps.title,
    subheader: mediaCardProps.subheader,
    content: mediaCardProps.content,
    avatar: mediaCardProps.avatar,
    image: mediaCardProps.image,
    ThumbnailProps: {
      labelRightBottom: mediaCardProps.labelRightBottom,
      LabelComponentRightBottom: MediaCardDurationLabel
    },
    itemType: itemType // eslint-disable-next-line react/jsx-props-no-spreading

  }, innerProps));
}
ItemCard.propTypes = {
  itemType: propTypes.objectOf(propTypes.any),
  parseMetadataOpts: propTypes.objectOf(propTypes.any),
  parseHighlightOpts: propTypes.objectOf(propTypes.any),
  metadataToProps: propTypes.func,
  MediaCardComponent: propTypes.elementType,
  titleSelector: propTypes.func,
  subheaderSelector: propTypes.func,
  imageSelector: propTypes.func,
  contentSelector: propTypes.func,
  avatarSelector: propTypes.func,
  labelRightBottomSelector: propTypes.func
};
ItemCard.defaultProps = {
  itemType: undefined,
  metadataToProps: metadataToProps$3,
  parseMetadataOpts: {
    joinValue: ', ',
    flat: true
  },
  parseHighlightOpts: {
    arrayOnSingle: false,
    flat: true
  },
  MediaCardComponent: MediaCard$1,
  titleSelector: function titleSelector() {
    var parsedMetadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return parsedMetadata.title;
  },
  subheaderSelector: function subheaderSelector() {
    var parsedMetadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return parsedMetadata.created;
  },
  imageSelector: function imageSelector() {
    var parsedMetadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return parsedMetadata.representativeThumbnailNoAuth;
  },
  contentSelector: function contentSelector() {
    var parsedMetadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return parsedMetadata.user;
  },
  avatarSelector: function avatarSelector() {
    var parsedMetadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return parsedMetadata.mimeType;
  },
  labelRightBottomSelector: function labelRightBottomSelector() {
    var parsedMetadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return parsedMetadata.durationSeconds;
  }
};

function ItemGrid(_ref) {
  var itemListType = _ref.itemListType,
      ItemCardComponent = _ref.ItemCardComponent,
      ItemCardProps = _ref.ItemCardProps,
      GridContainerProps = _ref.GridContainerProps,
      GridItemProps = _ref.GridItemProps;
  var _itemListType$item = itemListType.item,
      item = _itemListType$item === void 0 ? [] : _itemListType$item;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React__default.createElement(Grid, _extends({
      container: true
    }, GridContainerProps), item && item.map(function (itemType, index) {
      return /*#__PURE__*/React__default.createElement(Grid, _extends({
        key: itemType.id,
        item: true,
        xs: "auto" // eslint-disable-next-line react/jsx-props-no-spreading

      }, GridItemProps), /*#__PURE__*/React__default.createElement(ItemCardComponent, _extends({
        itemId: itemType.id,
        itemType: itemType,
        index: index // eslint-disable-next-line react/jsx-props-no-spreading

      }, ItemCardProps)));
    }))
  );
}
ItemGrid.propTypes = {
  itemListType: propTypes.objectOf(propTypes.any),
  ItemCardComponent: propTypes.elementType,
  ItemCardProps: propTypes.objectOf(propTypes.any),
  GridContainerProps: propTypes.objectOf(propTypes.any),
  GridItemProps: propTypes.objectOf(propTypes.any)
};
ItemGrid.defaultProps = {
  itemListType: {},
  ItemCardComponent: ItemCard,
  ItemCardProps: {},
  GridContainerProps: {},
  GridItemProps: {}
};

var ItemCardClone = function ItemCardClone(_ref) {
  var ItemCardComponent = _ref.ItemCardComponent,
      itemType = _ref.itemType,
      provided = _ref.provided,
      snapshot = _ref.snapshot,
      rubric = _ref.rubric,
      props = _objectWithoutProperties(_ref, ["ItemCardComponent", "itemType", "provided", "snapshot", "rubric"]);

  var draggableProps = provided.draggableProps,
      dragHandleProps = provided.dragHandleProps;
  var style = draggableProps.style;
  return /*#__PURE__*/React__default.createElement("div", _extends({
    ref: provided.innerRef // eslint-disable-next-line react/jsx-props-no-spreading

  }, draggableProps, dragHandleProps, {
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      height: 'inherit'
    })
  }), /*#__PURE__*/React__default.createElement(ItemCardComponent // eslint-disable-next-line react/jsx-props-no-spreading
  , _extends({}, props, {
    itemId: itemType.id,
    itemType: itemType,
    MediaCardComponent: MediaCard$1,
    ThumbnailComponent: null
  })));
};

function ItemGridDroppable(_ref2) {
  var _ref2$ItemCardCloneCo = _ref2.ItemCardCloneComponent,
      ItemCardCloneComponent = _ref2$ItemCardCloneCo === void 0 ? ItemCardClone : _ref2$ItemCardCloneCo,
      _ref2$ItemCardCompone = _ref2.ItemCardComponent,
      ItemCardComponent = _ref2$ItemCardCompone === void 0 ? ItemCard : _ref2$ItemCardCompone,
      _ref2$ItemCardProps = _ref2.ItemCardProps,
      ItemCardProps = _ref2$ItemCardProps === void 0 ? {} : _ref2$ItemCardProps,
      _ref2$GridContainerPr = _ref2.GridContainerProps,
      GridContainerProps = _ref2$GridContainerPr === void 0 ? {} : _ref2$GridContainerPr,
      _ref2$GridItemProps = _ref2.GridItemProps,
      GridItemProps = _ref2$GridItemProps === void 0 ? {} : _ref2$GridItemProps,
      _ref2$item = _ref2.item,
      itemList = _ref2$item === void 0 ? [] : _ref2$item,
      _ref2$DroppableProps = _ref2.DroppableProps,
      DroppableProps = _ref2$DroppableProps === void 0 ? {} : _ref2$DroppableProps;
  return /*#__PURE__*/React__default.createElement(Grid, _extends({
    container: true // eslint-disable-next-line react/jsx-props-no-spreading

  }, GridContainerProps), itemList && itemList.map(function (itemType, index) {
    return /*#__PURE__*/React__default.createElement(Grid, _extends({
      item: true,
      xs: "auto",
      key: itemType.id // eslint-disable-next-line react/jsx-props-no-spreading

    }, GridItemProps), /*#__PURE__*/React__default.createElement(Droppable, _extends({
      droppableId: itemType.id,
      isDropDisabled: true,
      renderClone: function renderClone(provided, snapshot, rubric) {
        return /*#__PURE__*/React__default.createElement(ItemCardCloneComponent, _extends({
          ItemCardComponent: ItemCardComponent,
          provided: provided,
          snapshot: snapshot,
          rubric: rubric,
          itemType: itemType // eslint-disable-next-line react/jsx-props-no-spreading

        }, ItemCardProps));
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, DroppableProps), function (provided) {
      return /*#__PURE__*/React__default.createElement("div", _extends({}, provided.droppableProps, {
        style: {
          minWidth: 320
        },
        ref: provided.innerRef
      }), /*#__PURE__*/React__default.createElement(ItemCardComponent, _extends({
        draggableId: itemType.id,
        index: index,
        itemId: itemType.id,
        itemType: itemType // eslint-disable-next-line react/jsx-props-no-spreading

      }, ItemCardProps)), /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: 'none',
          visibility: 'hidden'
        }
      }, provided.placeholder));
    }));
  }));
}

var onDownloadWebVTT = function onDownloadWebVTT(_ref) {
  var itemId = _ref.itemId,
      _ref$subtitleGroup = _ref.subtitleGroup,
      subtitleGroup = _ref$subtitleGroup === void 0 ? 'stl_subtitle' : _ref$subtitleGroup,
      _ref$subtitleField = _ref.subtitleField,
      subtitleField = _ref$subtitleField === void 0 ? 'stl_text' : _ref$subtitleField;
  return new Promise(function (resolve) {
    var queryParams = {
      content: 'metadata',
      group: subtitleGroup,
      field: subtitleField
    };
    item.getItem({
      itemId: itemId,
      queryParams: queryParams
    }).then(function (_ref2) {
      var data = _ref2.data;
      var metadataType = data.metadata;
      var webVtt = metadataTypeToWebVtt({
        metadataType: metadataType,
        subtitleGroup: subtitleGroup,
        subtitleField: subtitleField
      });
      resolve({
        data: webVtt
      });
    });
  });
};

var SUBTITLE_OPTIONS = [{
  name: 'scc',
  avatar: 'SCC',
  primary: 'Scenarist Closed Captions',
  onDownload: function onDownload(_ref3) {
    var itemId = _ref3.itemId;
    return subtitle.getSubtitleSCC({
      itemId: itemId
    });
  }
}, {
  name: 'ttml',
  avatar: 'TTML',
  primary: 'Timed Text Markup Language',
  onDownload: function onDownload(_ref4) {
    var itemId = _ref4.itemId;
    return subtitle.getSubtitleTTML({
      itemId: itemId
    });
  }
}, {
  name: 'webvtt',
  avatar: 'VTT',
  primary: 'Web Video Text Tracks ',
  onDownload: onDownloadWebVTT
}, {
  name: 'xml',
  avatar: 'XML',
  primary: 'Vidispine XML',
  onDownload: function onDownload(_ref5) {
    var itemId = _ref5.itemId;
    return item.getItemMetadata({
      itemId: itemId,
      headers: {
        accept: 'application/xml'
      }
    });
  }
}];

var ItemSidecarDownloadListItem = function ItemSidecarDownloadListItem(_ref6) {
  var className = _ref6.className,
      classes = _ref6.classes,
      itemId = _ref6.itemId,
      subtitle = _ref6.subtitle,
      onSuccess = _ref6.onSuccess,
      onFailure = _ref6.onFailure,
      subtitleGroup = _ref6.subtitleGroup,
      subtitleField = _ref6.subtitleField,
      _ref6$DownloadIcon = _ref6.DownloadIcon,
      DownloadIcon = _ref6$DownloadIcon === void 0 ? GetAppIcon : _ref6$DownloadIcon,
      _ref6$ProgressCompone = _ref6.ProgressComponent,
      ProgressComponent = _ref6$ProgressCompone === void 0 ? CircularProgress : _ref6$ProgressCompone;

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isDownloading = _React$useState2[0],
      setIsDownloading = _React$useState2[1];

  var onDownload = subtitle.onDownload,
      name = subtitle.name,
      avatar = subtitle.avatar,
      primary = subtitle.primary,
      secondary = subtitle.secondary,
      subtitleProps = _objectWithoutProperties(subtitle, ["onDownload", "name", "avatar", "primary", "secondary"]);

  var onClick = function onClick() {
    setIsDownloading(true);
    onDownload(_objectSpread2({
      itemId: itemId,
      subtitleGroup: subtitleGroup,
      subtitleField: subtitleField
    }, subtitleProps)).then(function (resp) {
      var fileName = "".concat(itemId, ".").concat(name);
      var objectUrl = window.URL.createObjectURL(new Blob([resp.data]));
      var link = document.createElement('a');
      link.href = objectUrl;
      link.setAttribute('download', fileName);
      link.click();
      window.URL.revokeObjectURL(objectUrl);
    }).then(function () {
      setIsDownloading(false);
      if (onSuccess) onSuccess({
        name: name,
        itemId: itemId
      });
    })["catch"](function (error) {
      setIsDownloading(false);
      if (onFailure) onFailure({
        name: name,
        itemId: itemId,
        error: error
      });else throw new Error(error);
    });
  };

  return /*#__PURE__*/React__default.createElement(ListItem$1, {
    button: true,
    disabled: isDownloading === true,
    onClick: onClick,
    className: className
  }, avatar && /*#__PURE__*/React__default.createElement(ListItemAvatar$1, {
    className: classes.ListItemAvatar
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    className: classes.Avatar,
    variant: "square"
  }, avatar)), /*#__PURE__*/React__default.createElement(ListItemText, {
    className: classes.ListItemText,
    primary: primary,
    secondary: secondary
  }), /*#__PURE__*/React__default.createElement(ListItemSecondaryAction$1, {
    className: classes.ListItemSecondaryAction
  }, isDownloading === true ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, ProgressComponent ? /*#__PURE__*/React__default.createElement(ProgressComponent, {
    size: 20,
    className: classes.Progress
  }) : null) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, DownloadIcon ? /*#__PURE__*/React__default.createElement(ButtonBase, {
    onClick: onClick,
    className: classes.DownloadButton
  }, /*#__PURE__*/React__default.createElement(DownloadIcon, {
    className: classes.DownloadIcon
  })) : null)));
};

var ItemSidecarDownloadList = function ItemSidecarDownloadList(_ref7) {
  var classes = _ref7.classes,
      className = _ref7.className,
      options = _ref7.options,
      itemId = _ref7.itemId,
      onSuccess = _ref7.onSuccess,
      onFailure = _ref7.onFailure,
      subtitleGroup = _ref7.subtitleGroup,
      subtitleField = _ref7.subtitleField,
      _ref7$ItemSidecarDown = _ref7.ItemSidecarDownloadListItemComponent,
      ItemSidecarDownloadListItemComponent = _ref7$ItemSidecarDown === void 0 ? ItemSidecarDownloadListItem : _ref7$ItemSidecarDown,
      _ref7$ItemSidecarDown2 = _ref7.ItemSidecarDownloadListItemProps,
      ItemSidecarDownloadListItemProps = _ref7$ItemSidecarDown2 === void 0 ? {} : _ref7$ItemSidecarDown2;
  return /*#__PURE__*/React__default.createElement(List$1, {
    dense: true,
    className: className
  }, options.map(function (subtitle) {
    return /*#__PURE__*/React__default.createElement(ItemSidecarDownloadListItemComponent, _extends({
      key: subtitle.name,
      subtitle: subtitle,
      className: classes.ListItem,
      classes: classes,
      itemId: itemId,
      onSuccess: onSuccess,
      onFailure: onFailure,
      subtitleGroup: subtitleGroup,
      subtitleField: subtitleField // eslint-disable-next-line react/jsx-props-no-spreading

    }, ItemSidecarDownloadListItemProps));
  }));
};

var styles$11 = function styles() {
  return {
    List: {},
    ListItem: {},
    ListItemAvatar: {},
    Avatar: {},
    ListItemText: {},
    ListItemSecondaryAction: {},
    Progress: {},
    DownloadButton: {},
    DownloadIcon: {}
  };
};
function ItemSidecarDownload(_ref8) {
  var className = _ref8.className,
      classes = _ref8.classes,
      itemId = _ref8.itemId,
      subtitleOptions = _ref8.subtitleOptions,
      onSuccess = _ref8.onSuccess,
      onFailure = _ref8.onFailure,
      subtitleGroup = _ref8.subtitleGroup,
      subtitleField = _ref8.subtitleField,
      ItemSidecarDownloadListComponent = _ref8.ItemSidecarDownloadListComponent,
      ItemSidecarDownloadListProps = _ref8.ItemSidecarDownloadListProps,
      ItemSidecarDownloadListItemComponent = _ref8.ItemSidecarDownloadListItemComponent,
      ItemSidecarDownloadListItemProps = _ref8.ItemSidecarDownloadListItemProps;
  return /*#__PURE__*/React__default.createElement(ItemSidecarDownloadListComponent, _extends({
    classes: classes,
    className: clsx(classes.List, className),
    options: subtitleOptions,
    itemId: itemId,
    onSuccess: onSuccess,
    onFailure: onFailure,
    subtitleGroup: subtitleGroup,
    subtitleField: subtitleField,
    ItemSidecarDownloadListItemComponent: ItemSidecarDownloadListItemComponent,
    ItemSidecarDownloadListItemProps: ItemSidecarDownloadListItemProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, ItemSidecarDownloadListProps));
}
ItemSidecarDownload.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  itemId: propTypes.string.isRequired,
  subtitleOptions: propTypes.arrayOf(propTypes.shape({
    name: propTypes.string,
    avatar: propTypes.string,
    primary: propTypes.string,
    onDownload: propTypes.func
  })),
  onSuccess: propTypes.func,
  onFailure: propTypes.func,
  subtitleGroup: propTypes.string,
  subtitleField: propTypes.string,
  ItemSidecarDownloadListComponent: propTypes.elementType,
  ItemSidecarDownloadListProps: propTypes.objectOf(propTypes.any),
  ItemSidecarDownloadListItemComponent: propTypes.elementType,
  ItemSidecarDownloadListItemProps: propTypes.objectOf(propTypes.any)
};
ItemSidecarDownload.defaultProps = {
  className: undefined,
  classes: {},
  subtitleOptions: SUBTITLE_OPTIONS,
  onSuccess: undefined,
  onFailure: undefined,
  subtitleGroup: undefined,
  subtitleField: undefined,
  ItemSidecarDownloadListComponent: ItemSidecarDownloadList,
  ItemSidecarDownloadListProps: {},
  ItemSidecarDownloadListItemComponent: ItemSidecarDownloadListItem,
  ItemSidecarDownloadListItemProps: {}
};

var ItemSidecarDownload$1 = withStyles(styles$11, {
  name: 'VdtItemSidecarDownload'
})(ItemSidecarDownload);

var SUBTITLE_OPTIONS$1 = [{
  name: 'srt',
  avatar: 'SRT',
  primary: 'SubRip Subtitle',
  onUpload: function onUpload(_ref) {
    var itemId = _ref.itemId,
        file = _ref.file;
    return vsimport.createImportItemSidecarRaw({
      itemId: itemId,
      file: file,
      queryParams: {
        fileExtension: 'srt'
      }
    });
  }
}, {
  name: 'stl',
  avatar: 'STL',
  primary: 'EBU STL',
  onUpload: function onUpload(_ref2) {
    var itemId = _ref2.itemId,
        file = _ref2.file;
    return vsimport.createImportItemSidecarRaw({
      itemId: itemId,
      file: file,
      queryParams: {
        fileExtension: 'stl'
      }
    });
  }
}, {
  name: 'scc',
  avatar: 'SCC',
  primary: 'Scenarist Closed Captions',
  onUpload: function onUpload(_ref3) {
    var itemId = _ref3.itemId,
        file = _ref3.file;
    return vsimport.createImportItemSidecarRaw({
      itemId: itemId,
      file: file,
      queryParams: {
        fileExtension: 'scc'
      }
    });
  }
}, {
  name: 'evs',
  avatar: 'EVS',
  primary: 'EVS Metadata',
  onUpload: function onUpload(_ref4) {
    var itemId = _ref4.itemId,
        file = _ref4.file;
    return vsimport.createImportItemSidecarRaw({
      itemId: itemId,
      file: file,
      queryParams: {
        fileExtension: 'evs'
      }
    });
  }
}, {
  name: 'xml',
  avatar: 'XML',
  primary: 'Vidispine XML Metadata',
  onUpload: function onUpload(_ref5) {
    var itemId = _ref5.itemId,
        file = _ref5.file;
    return vsimport.createImportItemSidecarRaw({
      itemId: itemId,
      file: file,
      queryParams: {
        fileExtension: 'xml'
      }
    });
  }
}, {
  name: 'xmp',
  avatar: 'XMP',
  primary: 'eXtensible Metadata Platform',
  onUpload: function onUpload(_ref6) {
    var itemId = _ref6.itemId,
        file = _ref6.file;
    return vsimport.createImportItemSidecarRaw({
      itemId: itemId,
      file: file,
      queryParams: {
        fileExtension: 'xmp'
      }
    });
  }
}];

var ItemSidecarUploadActions = function ItemSidecarUploadActions(_ref7) {
  var className = _ref7.className,
      classes = _ref7.classes,
      uploadText = _ref7.uploadText,
      onClickUpload = _ref7.onClickUpload,
      uploadDisabled = _ref7.uploadDisabled;
  return /*#__PURE__*/React__default.createElement(DialogActions$1, {
    className: className
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    className: classes.Button,
    onClick: onClickUpload,
    color: "primary",
    variant: "contained",
    disabled: uploadDisabled
  }, uploadText));
};

var ItemSidecarUploadListItem = function ItemSidecarUploadListItem(_ref8) {
  var className = _ref8.className,
      _ref8$classes = _ref8.classes,
      classes = _ref8$classes === void 0 ? {} : _ref8$classes,
      option = _ref8.option,
      onChange = _ref8.onChange,
      selected = _ref8.selected;
  var primary = option.primary,
      avatar = option.avatar;
  return /*#__PURE__*/React__default.createElement(ListItem$1, {
    button: true,
    onClick: onChange,
    className: className,
    selected: selected
  }, avatar && /*#__PURE__*/React__default.createElement(ListItemAvatar$1, {
    className: classes.ListItemAvatar
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    className: classes.Avatar,
    variant: "square"
  }, avatar)), /*#__PURE__*/React__default.createElement(ListItemText, {
    className: classes.ListItemText,
    primary: primary
  }), /*#__PURE__*/React__default.createElement(ListItemSecondaryAction$1, {
    className: classes.ListItemSecondaryAction
  }, /*#__PURE__*/React__default.createElement(Radio, {
    className: classes.Radio,
    checked: selected,
    onChange: onChange
  })));
};

var ItemSidecarUploadList = function ItemSidecarUploadList(_ref9) {
  var className = _ref9.className,
      classes = _ref9.classes,
      chooseText = _ref9.chooseText,
      options = _ref9.options,
      _onChange = _ref9.onChange,
      selected = _ref9.selected,
      _ref9$ItemSidecarUplo = _ref9.ItemSidecarUploadListItemComponent,
      ItemSidecarUploadListItemComponent = _ref9$ItemSidecarUplo === void 0 ? ItemSidecarUploadListItem : _ref9$ItemSidecarUplo,
      _ref9$ItemSidecarUplo2 = _ref9.ItemSidecarUploadListItemProps,
      ItemSidecarUploadListItemProps = _ref9$ItemSidecarUplo2 === void 0 ? {} : _ref9$ItemSidecarUplo2;
  return /*#__PURE__*/React__default.createElement(List$1, {
    dense: true,
    className: className,
    subheader: /*#__PURE__*/React__default.createElement(ListSubheader, {
      className: classes.ListSubheader
    }, chooseText)
  }, options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(ItemSidecarUploadListItemComponent, _extends({
      key: option.name,
      onChange: function onChange() {
        return _onChange(option);
      },
      className: classes.ListItem,
      classes: classes,
      selected: selected === option,
      option: option // eslint-disable-next-line react/jsx-props-no-spreading

    }, ItemSidecarUploadListItemProps));
  }));
};

var ItemSidecarUploadDropzone = function ItemSidecarUploadDropzone(_ref10) {
  var className = _ref10.className,
      classes = _ref10.classes,
      onDrop = _ref10.onDrop,
      onReset = _ref10.onReset,
      acceptedFile = _ref10.acceptedFile,
      rejectedFile = _ref10.rejectedFile,
      accept = _ref10.accept,
      dropText = _ref10.dropText,
      _ref10$ResetIconCompo = _ref10.ResetIconComponent,
      ResetIconComponent = _ref10$ResetIconCompo === void 0 ? CancelIcon : _ref10$ResetIconCompo;

  var _useDropzone = useDropzone({
    onDrop: onDrop,
    maxFiles: 1,
    multiple: false,
    accept: accept
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps;

  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, /*#__PURE__*/React__default.createElement("div", _extends({}, getRootProps(), {
    className: clsx(classes.dropzoneInput, rejectedFile ? classes.dropzoneInputError : classes.dropzoneInputDefault)
  }), /*#__PURE__*/React__default.createElement("input", getInputProps()), !acceptedFile && !rejectedFile && /*#__PURE__*/React__default.createElement("p", null, dropText), acceptedFile && /*#__PURE__*/React__default.createElement("span", {
    className: classes.acceptedFile
  }, acceptedFile.name, /*#__PURE__*/React__default.createElement(ResetIconComponent, {
    onClick: onReset,
    className: classes.ResetIcon
  })), rejectedFile && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: classes.rejectedFile
  }, rejectedFile.file.name, /*#__PURE__*/React__default.createElement(ResetIconComponent, {
    onClick: onReset,
    className: classes.ResetIcon
  })), rejectedFile.errors.length && /*#__PURE__*/React__default.createElement("span", {
    className: classes.errorMessage
  }, rejectedFile.errors[0].message))));
};

var styles$12 = function styles(theme) {
  return {
    dropzoneRoot: {
      cursor: 'pointer',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5)
    },
    dropzoneInput: {
      marginTop: theme.spacing(0.5),
      minHeight: '10vh',
      minWidth: theme.spacing(4),
      borderWidth: 2,
      borderRadius: 3,
      borderStyle: 'dotted',
      backgroundColor: 'rgba(0,0,0,0.05)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'min-height 0.3s'
    },
    dropzoneInputDefault: {
      borderColor: theme.palette.grey.A200
    },
    dropzoneInputError: {
      borderColor: theme.palette.error.main,
      color: theme.palette.error.main
    },
    ListSubheader: {},
    Button: {},
    List: {},
    showList: {
      height: 'auto',
      overflow: 'visible'
    },
    hideList: {
      height: 0,
      overflow: 'hidden'
    },
    ListItemAvatar: {},
    Avatar: {},
    Radio: {},
    DialogActions: {},
    acceptedFile: {
      display: 'flex',
      alignItems: 'center'
    },
    rejectedFile: {
      display: 'flex',
      alignItems: 'center'
    }
  };
};
function ItemSidecarUpload(_ref11) {
  var classes = _ref11.classes,
      className = _ref11.className,
      itemId = _ref11.itemId,
      onSuccess = _ref11.onSuccess,
      onFailure = _ref11.onFailure,
      subtitleOptions = _ref11.subtitleOptions,
      dropText = _ref11.dropText,
      chooseText = _ref11.chooseText,
      uploadText = _ref11.uploadText,
      defaultSelectedSubtitle = _ref11.defaultSelectedSubtitle,
      ItemSidecarUploadDropzoneComponent = _ref11.ItemSidecarUploadDropzoneComponent,
      ItemSidecarUploadDropzoneProps = _ref11.ItemSidecarUploadDropzoneProps,
      ItemSidecarUploadListComponent = _ref11.ItemSidecarUploadListComponent,
      ItemSidecarUploadListProps = _ref11.ItemSidecarUploadListProps,
      ItemSidecarUploadActionsComponent = _ref11.ItemSidecarUploadActionsComponent,
      ItemSidecarUploadActionsProps = _ref11.ItemSidecarUploadActionsProps,
      ItemSidecarUploadListItemComponent = _ref11.ItemSidecarUploadListItemComponent,
      ItemSidecarUploadListItemProps = _ref11.ItemSidecarUploadListItemProps;

  var _React$useState = React__default.useState(defaultSelectedSubtitle),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedSubtitle = _React$useState2[0],
      setSelectedSubtitle = _React$useState2[1];

  var _React$useState3 = React__default.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      acceptedFile = _React$useState4[0],
      setAcceptedFile = _React$useState4[1];

  var _React$useState5 = React__default.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      rejectedFile = _React$useState6[0],
      setRejectedFile = _React$useState6[1];

  var onDrop = function onDrop() {
    var acceptedFiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var fileRejections = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var _acceptedFiles = _slicedToArray(acceptedFiles, 1),
        newAcceptedFile = _acceptedFiles[0];

    var _fileRejections = _slicedToArray(fileRejections, 1),
        newRejectedFile = _fileRejections[0];

    if (newRejectedFile) {
      setAcceptedFile();
      setRejectedFile(newRejectedFile);
    } else if (newAcceptedFile) {
      setAcceptedFile(newAcceptedFile);
      setRejectedFile();
      var newName = newAcceptedFile.name;

      var _newName$split = newName.split('.'),
          _newName$split2 = _slicedToArray(_newName$split, 2),
          newExtension = _newName$split2[1];

      if (newExtension) {
        var newSelectedSubtitle = subtitleOptions.find(function (_ref12) {
          var subtitleName = _ref12.name;
          return subtitleName === newExtension;
        });
        if (newSelectedSubtitle) setSelectedSubtitle(newSelectedSubtitle);
      }
    } else {
      setAcceptedFile();
      setRejectedFile();
    }
  };

  var onReset = function onReset(event) {
    event.stopPropagation();
    setAcceptedFile();
    setRejectedFile();
    setSelectedSubtitle();
  };

  var onChangeSubtitle = function onChangeSubtitle(newSubtitle) {
    return setSelectedSubtitle(newSubtitle);
  };

  var onClickUpload = function onClickUpload() {
    try {
      var onUpload = selectedSubtitle.onUpload;
      if (!onUpload) throw new Error('No upload handler');
      if (!acceptedFile) throw new Error('No file specified');
      onUpload({
        itemId: itemId,
        file: acceptedFile
      }).then(function () {
        if (onSuccess) onSuccess({
          name: acceptedFile.name
        });
      })["catch"](function (error) {
        if (onFailure) onFailure(error);
      });
    } catch (error) {
      if (onFailure) onFailure(error);
    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(ItemSidecarUploadDropzoneComponent, _extends({
    className: classes.dropzoneRoot,
    classes: classes,
    accept: subtitleOptions.map(function (_ref13) {
      var name = _ref13.name;
      return ".".concat(name);
    }).toString(),
    dropText: dropText,
    onDrop: onDrop,
    onReset: onReset,
    acceptedFile: acceptedFile,
    rejectedFile: rejectedFile // eslint-disable-next-line react/jsx-props-no-spreading

  }, ItemSidecarUploadDropzoneProps)), acceptedFile && /*#__PURE__*/React__default.createElement(ItemSidecarUploadListComponent, _extends({
    className: classes.List,
    classes: classes,
    onChange: onChangeSubtitle,
    options: subtitleOptions,
    selected: selectedSubtitle,
    chooseText: chooseText,
    ItemSidecarUploadListItemComponent: ItemSidecarUploadListItemComponent,
    ItemSidecarUploadListItemProps: ItemSidecarUploadListItemProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, ItemSidecarUploadListProps)), /*#__PURE__*/React__default.createElement(ItemSidecarUploadActionsComponent, _extends({
    onClickUpload: onClickUpload,
    className: classes.DialogActions,
    classes: classes,
    uploadDisabled: !selectedSubtitle || !acceptedFile,
    uploadText: uploadText // eslint-disable-next-line react/jsx-props-no-spreading

  }, ItemSidecarUploadActionsProps)));
}
ItemSidecarUpload.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  itemId: propTypes.string.isRequired,
  onSuccess: propTypes.func,
  onFailure: propTypes.func,
  subtitleOptions: propTypes.arrayOf(propTypes.shape({
    name: propTypes.string,
    avatar: propTypes.string,
    primary: propTypes.string,
    onUpload: propTypes.func
  })),
  defaultSelectedSubtitle: propTypes.shape({
    name: propTypes.string,
    avatar: propTypes.string,
    primary: propTypes.string,
    onUpload: propTypes.func
  }),
  dropText: propTypes.string,
  chooseText: propTypes.string,
  uploadText: propTypes.string,
  ItemSidecarUploadDropzoneComponent: propTypes.elementType,
  ItemSidecarUploadDropzoneProps: propTypes.objectOf(propTypes.any),
  ItemSidecarUploadListComponent: propTypes.elementType,
  ItemSidecarUploadListProps: propTypes.objectOf(propTypes.any),
  ItemSidecarUploadListItemComponent: propTypes.elementType,
  ItemSidecarUploadListItemProps: propTypes.objectOf(propTypes.any),
  ItemSidecarUploadActionsComponent: propTypes.elementType,
  ItemSidecarUploadActionsProps: propTypes.objectOf(propTypes.any)
};
ItemSidecarUpload.defaultProps = {
  className: undefined,
  classes: {},
  onSuccess: undefined,
  onFailure: undefined,
  subtitleOptions: SUBTITLE_OPTIONS$1,
  defaultSelectedSubtitle: undefined,
  dropText: 'Drop file or click to browse',
  chooseText: 'Choose Subtitle Format',
  uploadText: 'Upload',
  ItemSidecarUploadDropzoneComponent: ItemSidecarUploadDropzone,
  ItemSidecarUploadDropzoneProps: {},
  ItemSidecarUploadListComponent: ItemSidecarUploadList,
  ItemSidecarUploadListProps: {},
  ItemSidecarUploadListItemComponent: ItemSidecarUploadListItem,
  ItemSidecarUploadListItemProps: {},
  ItemSidecarUploadActionsComponent: ItemSidecarUploadActions,
  ItemSidecarUploadActionsProps: {}
};

var ItemSidecarUpload$1 = withStyles(styles$12, {
  name: 'VdtItemSidecarUpload'
})(ItemSidecarUpload);

var ITEM_SIDECAR_UPLOAD_TAB = 'ITEM_SIDECAR_UPLOAD_TAB';
var ITEM_SIDECAR_DOWNLOAD_TAB = 'ITEM_SIDECAR_DOWNLOAD_TAB';
var styles$13 = function styles(theme) {
  return {
    root: {},
    DialogTitle: {},
    DialogContent: {},
    Tabs: {
      marginBottom: theme.spacing(2)
    },
    Tab: {},
    ItemSidecarDownload: {},
    ItemSidecarUpload: {}
  };
};
function ItemSidecarDialog(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      itemId = _ref.itemId,
      onClose = _ref.onClose,
      onSuccessDownload = _ref.onSuccessDownload,
      onFailureDownload = _ref.onFailureDownload,
      onSuccessUpload = _ref.onSuccessUpload,
      onFailureUpload = _ref.onFailureUpload,
      titleText = _ref.titleText,
      subtitleGroup = _ref.subtitleGroup,
      subtitleField = _ref.subtitleField,
      uploadText = _ref.uploadText,
      downloadText = _ref.downloadText,
      defaultTab = _ref.defaultTab,
      ItemSidecarDownloadComponent = _ref.ItemSidecarDownloadComponent,
      ItemSidecarDownloadProps = _ref.ItemSidecarDownloadProps,
      ItemSidecarUploadComponent = _ref.ItemSidecarUploadComponent,
      ItemSidecarUploadProps = _ref.ItemSidecarUploadProps;

  var _React$useState = React__default.useState(defaultTab),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      tab = _React$useState2[0],
      setTab = _React$useState2[1];

  var onChangeTab = function onChangeTab(e, newTab) {
    return newTab && setTab(newTab);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtItemSidecarDialog-root', className)
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    className: classes.DialogTitle
  }, titleText), /*#__PURE__*/React__default.createElement(DialogContent$1, {
    className: classes.DialogContent
  }, /*#__PURE__*/React__default.createElement(Tabs$1, {
    value: tab,
    onChange: onChangeTab,
    variant: "fullWidth",
    textColor: "primary",
    indicatorColor: "primary",
    className: classes.Tabs
  }, ItemSidecarDownloadComponent && /*#__PURE__*/React__default.createElement(Tab$1, {
    className: classes.Tab,
    value: ITEM_SIDECAR_DOWNLOAD_TAB,
    label: downloadText
  }), ItemSidecarUploadComponent && /*#__PURE__*/React__default.createElement(Tab$1, {
    className: classes.Tab,
    value: ITEM_SIDECAR_UPLOAD_TAB,
    label: uploadText
  })), {
    ITEM_SIDECAR_DOWNLOAD_TAB: ItemSidecarDownloadComponent ? /*#__PURE__*/React__default.createElement(ItemSidecarDownloadComponent, _extends({
      className: classes.ItemSidecarDownload,
      onSuccess: function onSuccess() {
        if (onClose) onClose();
        if (onSuccessDownload) onSuccessDownload.apply(void 0, arguments);
      },
      onFailure: onFailureDownload,
      subtitleGroup: subtitleGroup,
      subtitleField: subtitleField,
      onClose: onClose,
      itemId: itemId // eslint-disable-next-line react/jsx-props-no-spreading

    }, ItemSidecarDownloadProps)) : null,
    ITEM_SIDECAR_UPLOAD_TAB: ItemSidecarUploadComponent ? /*#__PURE__*/React__default.createElement(ItemSidecarUploadComponent, _extends({
      itemId: itemId,
      className: classes.ItemSidecarUpload,
      onSuccess: function onSuccess() {
        if (onClose) onClose();
        if (onSuccessUpload) onSuccessUpload.apply(void 0, arguments);
      },
      onFailure: onFailureUpload // eslint-disable-next-line react/jsx-props-no-spreading

    }, ItemSidecarUploadProps)) : null
  }[tab]));
}
ItemSidecarDialog.propTypes = {
  classes: propTypes.objectOf(propTypes.string),
  className: propTypes.string,
  itemId: propTypes.string.isRequired,
  onClose: propTypes.func,
  onSuccessDownload: propTypes.func,
  onFailureDownload: propTypes.func,
  onSuccessUpload: propTypes.func,
  onFailureUpload: propTypes.func,
  closeText: propTypes.string,
  titleText: propTypes.string,
  subtitleGroup: propTypes.string,
  subtitleField: propTypes.string,
  uploadText: propTypes.string,
  downloadText: propTypes.string,
  defaultTab: propTypes.oneOf([ITEM_SIDECAR_UPLOAD_TAB, ITEM_SIDECAR_DOWNLOAD_TAB]),
  ItemSidecarDownloadComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  ItemSidecarDownloadProps: propTypes.objectOf(propTypes.any),
  ItemSidecarUploadComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  ItemSidecarUploadProps: propTypes.objectOf(propTypes.any)
};
ItemSidecarDialog.defaultProps = {
  classes: {},
  className: undefined,
  onClose: undefined,
  onSuccessDownload: undefined,
  onFailureDownload: undefined,
  onSuccessUpload: undefined,
  onFailureUpload: undefined,
  closeText: 'Close',
  titleText: 'Item Sidecar',
  subtitleGroup: 'stl_subtitle',
  subtitleField: 'stl_text',
  uploadText: 'Upload',
  downloadText: 'Download',
  defaultTab: ITEM_SIDECAR_DOWNLOAD_TAB,
  ItemSidecarDownloadComponent: ItemSidecarDownload$1,
  ItemSidecarDownloadProps: {},
  ItemSidecarUploadComponent: ItemSidecarUpload$1,
  ItemSidecarUploadProps: {}
};

var index$1 = withStyles(styles$13, {
  name: 'VdtItemSidecarDialog'
})(ItemSidecarDialog);

var styles$14 = function styles(theme) {
  return {
    root: {
      border: '2px solid transparent'
    },
    thumbnail: {
      pointerEvents: 'none'
    },
    active: {
      animation: '$active 5s'
    },
    '@keyframes active': {
      '0%': {
        borderColor: fade(theme.palette.primary.main, 1)
      },
      '100%': {
        borderColor: fade(theme.palette.primary.main, 0)
      }
    }
  };
};
function Event(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      isActive = _ref.isActive,
      EventContentComponent = _ref.EventContentComponent,
      EventContentProps = _ref.EventContentProps,
      scrollIntoViewOpts = _ref.scrollIntoViewOpts,
      props = _objectWithoutProperties(_ref, ["classes", "className", "isActive", "EventContentComponent", "EventContentProps", "scrollIntoViewOpts"]);

  var eventRef = React__default.useRef();
  React__default.useEffect(function () {
    if (isActive && eventRef && eventRef.current) {
      eventRef.current.scrollIntoView(scrollIntoViewOpts);
    }
  }, [isActive, scrollIntoViewOpts]);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: eventRef,
    className: clsx(classes.root, className, _defineProperty({}, classes.active, isActive))
  }, EventContentComponent && /*#__PURE__*/React__default.createElement(EventContentComponent // eslint-disable-next-line react/jsx-props-no-spreading
  , _extends({}, props, EventContentProps)));
}
Event.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * See [`scrollIntoView`](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
   */
  scrollIntoViewOpts: propTypes.objectOf(propTypes.any),

  /**
   * Highlight and scroll to event.
   */
  isActive: propTypes.bool,

  /**
   * The component containing the event.
   */
  EventContentComponent: propTypes.elementType,

  /**
   * Props for the EventContentComponent.
   */
  EventContentProps: propTypes.objectOf(propTypes.any)
};
Event.defaultProps = {
  className: undefined,
  classes: {},
  scrollIntoViewOpts: {
    behavior: 'smooth',
    inline: 'center',
    block: 'nearest'
  },
  isActive: undefined,
  EventContentComponent: null,
  EventContentProps: {}
};

var Event$1 = withStyles(styles$14, {
  name: 'VdtEvent'
})(Event);

var styles$15 = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      overflowX: 'auto',
      '&::-webkit-scrollbar': {
        '-webkit-appearance': 'none'
      },
      '&::-webkit-scrollbar:horizontal': {
        height: 11
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: 1,
        borderColor: theme.palette.divider,
        borderStyle: 'solid',
        borderWidth: 1,
        backgroundColor: 'rgba(0, 0, 0, .3)'
      },
      '& > *': {
        marginLeft: '10px',
        flexShrink: 0
      }
    }
  };
};
function EventContainer(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, children);
}
EventContainer.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * Events wrapped in the `DragScroll`
   */
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.element), propTypes.element]).isRequired
};
EventContainer.defaultProps = {
  className: undefined,
  classes: {}
};

var EventContainer$1 = withStyles(styles$15, {
  name: 'VdtEventContainer'
})(EventContainer);

var styles$16 = function styles() {
  return {
    root: {
      position: 'absolute',
      '&:hover': {
        transform: 'scale(1.2)'
      }
    }
  };
};
function EventMarker(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      position = _ref.position,
      length = _ref.length,
      onClick = _ref.onClick,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement(ButtonBase, {
    disableRipple: true,
    onClick: onClick,
    className: clsx(classes.root, 'VdtTimelineEvent-root', className),
    style: {
      left: "".concat(100 * position / length, "%")
    }
  }, children);
}
EventMarker.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * Prop for button
   */
  onClick: propTypes.func,

  /**
   * Typically the `EventMarkerThumbnail`
   */
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.element), propTypes.element]).isRequired,

  /**
   * The duration in seconds of the item, set by the `EventMarkerTimeline`.
   */
  length: propTypes.number.isRequired,

  /**
   * The offset in seconds of the event.
   */
  position: propTypes.number.isRequired
};
EventMarker.defaultProps = {
  className: undefined,
  classes: {},
  onClick: undefined
};

var EventMarker$1 = withStyles(styles$16, {
  name: 'VdtEventMarker'
})(EventMarker);

var styles$17 = {};
function EventMarkerThumbnail(_ref) {
  var className = _ref.className,
      itemType = _ref.itemType,
      timespan = _ref.timespan,
      MissingThumbnailIcon = _ref.MissingThumbnailIcon,
      AvatarComponent = _ref.AvatarComponent,
      AvatarProps = _ref.AvatarProps,
      TooltipComponent = _ref.TooltipComponent,
      TooltipProps = _ref.TooltipProps;
  var thumbnail = findNearestThumbnail(itemType, timespan.start || 0);
  var startSmpte = formatTimeCodeText(timespan.start).toSmpte();
  return /*#__PURE__*/React__default.createElement(TooltipComponent, _extends({
    className: className,
    title: startSmpte,
    arrow: true,
    placement: "right" // eslint-disable-next-line react/jsx-props-no-spreading

  }, TooltipProps), thumbnail ?
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-props-no-spreading
  React__default.createElement(AvatarComponent, _extends({
    variant: "circular",
    src: thumbnail
  }, AvatarProps)) :
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-props-no-spreading
  React__default.createElement(AvatarComponent, _extends({
    variant: "circular"
  }, AvatarProps), /*#__PURE__*/React__default.createElement(MissingThumbnailIcon, null)));
}
EventMarkerThumbnail.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * See [`ItemDocument`](https://apidoc.vidispine.com/latest/ref/xml-schema.html#schema-element-ItemDocument).
   */
  itemType: propTypes.objectOf(propTypes.any).isRequired,

  /**
   * The specific timespan corresponding to this event.
   */
  timespan: propTypes.shape({
    start: propTypes.string
  }).isRequired,

  /**
   * Icon if there are no thumbnails.
   */
  MissingThumbnailIcon: propTypes.elementType,

  /**
   * The component for the avatar.
   */
  AvatarComponent: propTypes.elementType,

  /**
   * Props for the AvatarComponent.
   */
  AvatarProps: propTypes.objectOf(propTypes.any),

  /**
   * The component for the tooltip.
   */
  TooltipComponent: propTypes.elementType,

  /**
   * Props for the TooltipComponent.
   */
  TooltipProps: propTypes.objectOf(propTypes.any)
};
EventMarkerThumbnail.defaultProps = {
  classes: {},
  className: undefined,
  MissingThumbnailIcon: ImageIcon,
  AvatarComponent: Avatar,
  AvatarProps: {},
  TooltipComponent: Tooltip,
  TooltipProps: {}
};

var EventMarkerThumbnail$1 = withStyles(styles$17, {
  name: 'VdtEventMarkerThumbnail'
})(EventMarkerThumbnail);

var styles$18 = function styles(theme) {
  return {
    root: {
      backgroundColor: fade(theme.palette.primary.main, 0.25),
      height: '5px',
      width: '100%',
      borderRadius: '2px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      position: 'relative',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    }
  };
};
function EventMarkerTimeline(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      length = _ref.length,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtTimeline-root', className)
  }, React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      length: length
    });
  }));
}
EventMarkerTimeline.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * A list of `EventMarker` components.
   */
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.element), propTypes.element]).isRequired,

  /**
   * The duration of the item in seconds.
   */
  length: propTypes.number
};
EventMarkerTimeline.defaultProps = {
  classes: {},
  className: undefined,
  length: undefined
};

var EventMarkerTimeline$1 = withStyles(styles$18, {
  name: 'VdtEventMarkerTimeline'
})(EventMarkerTimeline);

var styles$19 = function styles(theme) {
  return {
    timelineEventContent: {
      height: theme.spacing(3),
      width: theme.spacing(3)
    },
    event: {},
    eventContainer: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    timeline: {},
    timelineEvent: {}
  };
};
function EventTimeline(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      matchHighlights = _ref.matchHighlights,
      itemType = _ref.itemType,
      eventFilter = _ref.eventFilter,
      noEventsText = _ref.noEventsText,
      EventContainerComponent = _ref.EventContainerComponent,
      EventContainerProps = _ref.EventContainerProps,
      EventComponent = _ref.EventComponent,
      EventProps = _ref.EventProps,
      EventContentComponent = _ref.EventContentComponent,
      EventContentProps = _ref.EventContentProps,
      EventMarkerThumbnailComponent = _ref.EventMarkerThumbnailComponent,
      EventMarkerThumbnailProps = _ref.EventMarkerThumbnailProps,
      EventMarkerTimelineComponent = _ref.EventMarkerTimelineComponent,
      EventMarkerTimelineProps = _ref.EventMarkerTimelineProps,
      EventMarkerComponent = _ref.EventMarkerComponent,
      EventMarkerProps = _ref.EventMarkerProps,
      EventListComponent = _ref.EventListComponent,
      EventListProps = _ref.EventListProps;

  var _parseMetadataType = parseMetadataType(itemType.metadata, {
    arrayOnSingle: false,
    flat: true
  }),
      durationSeconds = _parseMetadataType.durationSeconds;

  var length = formatTimeCodeText(durationSeconds).toSeconds();
  var events = React__default.useMemo(function () {
    var _itemType$timespan = itemType.timespan,
        highlightTimespanList = _itemType$timespan === void 0 ? [] : _itemType$timespan,
        _itemType$metadata = itemType.metadata;
    _itemType$metadata = _itemType$metadata === void 0 ? {} : _itemType$metadata;
    var _itemType$metadata$ti = _itemType$metadata.timespan,
        metadataTimespanList = _itemType$metadata$ti === void 0 ? [] : _itemType$metadata$ti,
        id = itemType.id;

    if (matchHighlights === true) {
      return highlightTimespanList.sort(function (_ref2, _ref3) {
        var startFirst = _ref2.start;
        var startSecond = _ref3.start;
        return formatTimeCodeText(startFirst).samples - formatTimeCodeText(startSecond).samples;
      }).filter(eventFilter);
    }

    return metadataTimespanList.sort(function (_ref4, _ref5) {
      var startFirst = _ref4.start;
      var startSecond = _ref5.start;
      return formatTimeCodeText(startFirst).toSeconds() - formatTimeCodeText(startSecond).toSeconds();
    }).filter(function (ts) {
      return highlightTimespanList.some(function (_ref6) {
        var start = _ref6.start,
            end = _ref6.end;
        return ts.start === start && ts.end === end;
      });
    }).filter(eventFilter);
  }, [itemType, eventFilter, matchHighlights]);

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      active = _React$useState2[0],
      setActive = _React$useState2[1];

  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, events.length > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, EventMarkerTimelineComponent && /*#__PURE__*/React__default.createElement(EventMarkerTimelineComponent, _extends({
    className: classes.timeline,
    length: length // eslint-disable-next-line react/jsx-props-no-spreading

  }, EventMarkerTimelineProps), events.map(function (ts, i) {
    return /*#__PURE__*/React__default.createElement(EventMarkerComponent, _extends({
      className: classes.timelineEvent,
      key: ts.start,
      position: formatTimeCodeText(ts.start).toSeconds(),
      onClick: function onClick() {
        return setActive(i);
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, EventMarkerProps), EventMarkerThumbnailComponent && /*#__PURE__*/React__default.createElement(EventMarkerThumbnailComponent, _extends({
      className: classes.timelineEventContent,
      itemType: itemType,
      timespan: ts // eslint-disable-next-line react/jsx-props-no-spreading

    }, EventMarkerThumbnailProps)));
  })), EventListComponent && /*#__PURE__*/React__default.createElement(EventListComponent, _extends({
    classes: classes,
    events: events,
    active: active,
    itemType: itemType,
    EventProps: EventProps,
    EventContentComponent: EventContentComponent,
    EventContentProps: EventContentProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, EventListProps)), EventContainerComponent && /*#__PURE__*/React__default.createElement(EventContainerComponent, _extends({
    className: classes.eventContainer // eslint-disable-next-line react/jsx-props-no-spreading

  }, EventContainerProps), events.map(function (ts, i) {
    return /*#__PURE__*/React__default.createElement(EventComponent, _extends({
      key: [id, ts.start, ts.end].join(),
      className: classes.event,
      isActive: i === active,
      timespan: ts,
      itemType: itemType,
      EventContentComponent: EventContentComponent,
      EventContentProps: EventContentProps // eslint-disable-next-line react/jsx-props-no-spreading

    }, EventProps));
  }))) : noEventsText);
}
EventTimeline.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * See [`ItemDocument`](https://apidoc.vidispine.com/latest/ref/xml-schema.html#schema-element-ItemDocument).
   */
  itemType: index.ItemType.isRequired,

  /**
   * Whether highlight timespane contain metadata or should be fuzzy matched with item metadata.
   */
  matchHighlights: propTypes.bool,

  /**
   * Filter events eg based on field-name.
   */
  eventFilter: propTypes.func,

  /**
   * Show text when no events found.
   */
  noEventsText: propTypes.string,

  /**
   * The component wrapping the events.
   */
  EventContainerComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),

  /**
   * Props for the EventContainerComponent.
   */
  EventContainerProps: propTypes.objectOf(propTypes.any),

  /**
   * The component for each event.
   */
  EventComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),

  /**
   * Props for the EventComponent.
   */
  EventProps: propTypes.objectOf(propTypes.any),

  /**
   * The component to display the event.
   */
  EventContentComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),

  /**
   * Props for the EventContentProps.
   */
  EventContentProps: propTypes.objectOf(propTypes.any),

  /**
   * The component for each timeline event.
   */
  EventMarkerThumbnailComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),

  /**
   * Props for the EventMarkerThumbnail.
   */
  EventMarkerThumbnailProps: propTypes.objectOf(propTypes.any),

  /**
   * The component wrapping timeline event.
   */
  EventMarkerTimelineComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),

  /**
   * Props for the EventMarkerTimeline.
   */
  EventMarkerTimelineProps: propTypes.objectOf(propTypes.any),

  /**
   * The component wrapping timeline.
   */
  EventMarkerComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),

  /**
   * Props for the EventMarker.
   */
  EventMarkerProps: propTypes.objectOf(propTypes.any),
  EventListComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  EventListProps: propTypes.objectOf(propTypes.any)
};
EventTimeline.defaultProps = {
  className: undefined,
  classes: {},
  matchHighlights: true,
  eventFilter: function eventFilter() {
    return true;
  },
  noEventsText: null,
  EventContainerComponent: EventContainer$1,
  EventContainerProps: {},
  EventComponent: Event$1,
  EventProps: {},
  EventContentComponent: null,
  EventContentProps: {},
  EventMarkerThumbnailComponent: EventMarkerThumbnail$1,
  EventMarkerThumbnailProps: {},
  EventMarkerTimelineComponent: EventMarkerTimeline$1,
  EventMarkerTimelineProps: {},
  EventMarkerComponent: EventMarker$1,
  EventMarkerProps: {},
  EventListComponent: false,
  EventListProps: {}
};

var index$2 = withStyles(styles$19, {
  name: 'VdtEventTimeline'
})(EventTimeline);

var styles$1a = {
  root: {
    '& > *': {
      marginTop: '20px',
      width: '100%'
    }
  },
  rootNoMargin: {
    '& > *': {
      marginTop: '0px',
      width: '100%',
      lineHeight: '40px'
    }
  },
  editorContainer: {
    padding: '24px'
  },
  editorTitle: {
    "float": 'left',
    width: '90%'
  },
  closeEditor: {
    "float": 'right',
    padding: '4px'
  },
  deleteField: {
    marginLeft: '8px'
  }
};

function useDebounce(value, delay) {
  var _React$useState = React__default.useState(value),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      debouncedValue = _React$useState2[0],
      setDebouncedValue = _React$useState2[1];

  React__default.useEffect(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}

var fieldTypes = [{
  value: 'date',
  label: 'Date'
}, {
  value: 'float',
  label: 'Float'
}, {
  value: 'integer',
  label: 'Integer'
}, {
  value: 'long',
  label: 'Long'
}, {
  value: 'string',
  label: 'String'
}, {
  value: 'string-exact',
  label: 'String Exact'
}, {
  value: 'boolean',
  label: 'Boolean'
}, {
  value: 'timeCode',
  label: 'Time-Code'
}];
var fieldDisplayTypes = {
  string: [{
    value: 'text',
    label: 'Text'
  }, {
    value: 'select',
    label: 'Select'
  }, {
    value: 'textArea',
    label: 'Text area'
  }],
  "boolean": [{
    value: 'checkbox',
    label: 'Checkbox'
  }, {
    value: 'switch',
    label: 'Switch'
  }]
};
var displayTypesWithOptions = ['select'];

function Editor(_ref) {
  var classes = _ref.classes,
      item = _ref.item,
      onClose = _ref.onClose,
      onDelete = _ref.onDelete,
      onEdit = _ref.onEdit,
      isNewItem = _ref.isNewItem,
      _ref$autoAdd = _ref.autoAdd,
      autoAdd = _ref$autoAdd === void 0 ? true : _ref$autoAdd;
  var newFieldData = {
    name: '',
    data: [{
      key: 'displayType',
      value: 'text'
    }, {
      key: 'label',
      value: ''
    }],
    type: 'string',
    values: {
      field: []
    }
  };

  var _React$useState3 = React__default.useState(newFieldData),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      editedItem = _React$useState4[0],
      setEditedItem = _React$useState4[1];

  var _React$useState5 = React__default.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      open = _React$useState6[0],
      setDialog = _React$useState6[1];

  var _React$useState7 = React__default.useState(''),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      displayType = _React$useState8[0],
      setDisplayType = _React$useState8[1];

  var _React$useState9 = React__default.useState(editedItem.name),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      label = _React$useState10[0],
      setLabel = _React$useState10[1];

  var _React$useState11 = React__default.useState(editedItem.type),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      type = _React$useState12[0],
      setType = _React$useState12[1];

  var _React$useState13 = React__default.useState([]),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      options = _React$useState14[0],
      setOptions = _React$useState14[1];

  var _React$useState15 = React__default.useState({
    key: '',
    value: ''
  }),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      optionToAdd = _React$useState16[0],
      setOptionToAdd = _React$useState16[1];

  React__default.useEffect(function () {
    return setEditedItem(item);
  }, [item]);

  var initEditedItem = function initEditedItem() {
    var itemCopy = _objectSpread2({}, editedItem);

    itemCopy.data = [];

    if (editedItem.type === 'boolean') {
      itemCopy.data.push({
        key: 'displayType',
        value: 'checkbox'
      });
      setDisplayType('checkbox');
    } else if (['date', 'timecode'].includes(editedItem.type)) {
      itemCopy.data.push({
        key: 'displayType',
        value: 'datePicker'
      });
      setDisplayType('datePicker');
    } else {
      itemCopy.data.push({
        key: 'displayType',
        value: 'text'
      });
      itemCopy.data.push({
        key: 'label',
        value: ''
      });
      setDisplayType('text');
    }

    setEditedItem(itemCopy);
  };

  React__default.useEffect(function () {
    if (typeof editedItem.data === 'undefined') {
      initEditedItem();
    } else {
      var _editedItem$data$find = editedItem.data.find(function (element) {
        return element.key === 'label';
      }),
          labelValue = _editedItem$data$find.value;

      var _editedItem$data$find2 = editedItem.data.find(function (element) {
        return element.key === 'displayType';
      }),
          displayTypeValue = _editedItem$data$find2.value;

      setLabel(labelValue);
      setDisplayType(displayTypeValue);
    }

    if (!isNewItem) {
      if (typeof editedItem.values.field === 'undefined') {
        var itemCopy = _objectSpread2({}, editedItem);

        itemCopy.values = {
          field: []
        };
        setEditedItem(itemCopy);
      } else {
        setOptions(editedItem.values.field);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [editedItem]);

  var onNameChange = function onNameChange(event) {
    var _event$target = event.target,
        value = _event$target.value,
        name = _event$target.name;

    var field = _defineProperty({}, name, value);

    var newItem = _objectSpread2(_objectSpread2({}, editedItem), field);

    setEditedItem(newItem);
  };

  var onTypeChange = function onTypeChange(event) {
    var value = event.target.value;
    setType(value);
    setOptions([]);

    var itemCopy = _objectSpread2({}, editedItem);

    itemCopy.type = value;
    setEditedItem(itemCopy);
  };

  var onLabelChange = function onLabelChange(event) {
    var value = event.target.value;
    setLabel(value);

    var itemCopy = _objectSpread2({}, editedItem);

    var index = itemCopy.data.findIndex(function (e) {
      return e.key === 'label';
    });
    itemCopy.data[index].value = value;
    setEditedItem(itemCopy);
  };

  var displayTypeHandle = function displayTypeHandle(event) {
    var value = event.target.value;
    setDisplayType(value);

    var itemCopy = _objectSpread2({}, editedItem);

    var index = itemCopy.data.findIndex(function (e) {
      return e.key === 'displayType';
    });
    itemCopy.data[index].value = value;
    setEditedItem(itemCopy);
  };

  var selectHandle = function selectHandle(event) {
    setOptionToAdd(_objectSpread2(_objectSpread2({}, optionToAdd), {}, _defineProperty({}, event.target.name, event.target.value)));
  };

  var addOption = function addOption(newOption) {
    var itemCopy = _objectSpread2({}, editedItem);

    if (typeof itemCopy.values.field === 'undefined') {
      itemCopy.values = {
        field: []
      };
    }

    itemCopy.values.field.unshift(newOption);
    setEditedItem(itemCopy);
    setOptionToAdd({
      key: '',
      value: ''
    });
    setOptions(itemCopy.values.field);
  };

  React__default.useEffect(function () {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var autoAddOption = useDebounce(optionToAdd.value, 1000);

    if (autoAdd) {
      if (autoAddOption) {
        addOption(optionToAdd);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  var removeOption = function removeOption(index) {
    var newOptions = options;
    var optionToRemove = index;
    newOptions.splice(optionToRemove, 1);
    setOptions(newOptions);

    var itemCopy = _objectSpread2({}, editedItem);

    itemCopy.values.field = newOptions;
    setEditedItem(itemCopy);
  };

  var openDialog = function openDialog() {
    setDialog(true);
  };

  var closeDialog = function closeDialog() {
    setDialog(false);
  };

  var onSave = function onSave() {
    onEdit(item, editedItem);
    onClose();
  };

  var handleDelete = function handleDelete() {
    setEditedItem(newFieldData);
    closeDialog();
    onClose();
    onDelete(item);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.editorContainer
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    align: "center",
    className: classes.editorTitle
  }, "Editor - ".concat(editedItem.name)), /*#__PURE__*/React__default.createElement(IconButton, {
    className: classes.closeEditor,
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(ClearIcon, null))), /*#__PURE__*/React__default.createElement(FormControl, {
    className: classes.root,
    autoComplete: "off",
    fullWidth: true
  }, isNewItem && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TextField$2, {
    name: "name",
    label: "Name",
    value: editedItem.name,
    onChange: onNameChange,
    disabled: !isNewItem
  }), /*#__PURE__*/React__default.createElement(Select, {
    name: "type",
    label: "Type",
    value: type,
    onChange: onTypeChange
  }, fieldTypes.map(function (t) {
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      key: t.value,
      value: t.value
    }, t.label);
  }))), /*#__PURE__*/React__default.createElement(TextField$2, {
    name: "label",
    label: "Label",
    value: label,
    onChange: onLabelChange
  })), Object.keys(fieldDisplayTypes).includes(editedItem.type) && /*#__PURE__*/React__default.createElement(FormControl, {
    className: classes.rootNoMargin,
    autoComplete: "off",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(InputLabel, {
    id: "displayType"
  }, "Select display type"), /*#__PURE__*/React__default.createElement(Select, {
    labelId: "displayType",
    value: displayType,
    onChange: displayTypeHandle
  }, fieldDisplayTypes[editedItem.type].map(function (dt) {
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      key: dt.value,
      value: dt.value
    }, dt.label);
  }))), displayTypesWithOptions.includes(displayType) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FormControl, {
    className: classes.root,
    autoComplete: "off",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: autoAdd ? 6 : 5
  }, /*#__PURE__*/React__default.createElement(TextField$2, {
    name: "key",
    label: "Add option label",
    value: optionToAdd.key,
    onChange: selectHandle,
    fullWidth: true
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: autoAdd ? 6 : 5
  }, /*#__PURE__*/React__default.createElement(TextField$2, {
    id: "optionValue",
    name: "value",
    label: "Add option value",
    value: optionToAdd.value,
    onChange: selectHandle,
    fullWidth: true
  })), !autoAdd && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 2,
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: function onClick() {
      return addOption(optionToAdd);
    },
    variant: "outlined",
    color: "primary"
  }, "Add option")))), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(List$1, null, options.map(function (option, index) {
    return /*#__PURE__*/React__default.createElement(ListItem$1, {
      key: option.key
    }, /*#__PURE__*/React__default.createElement(ListItemText, {
      primary: "Label:".concat(option.key),
      secondary: "Value:".concat(option.value)
    }), /*#__PURE__*/React__default.createElement(ListItemSecondaryAction$1, null, /*#__PURE__*/React__default.createElement(IconButton, {
      edge: "end",
      "aria-label": "delete",
      onClick: function onClick() {
        return removeOption(index);
      }
    }, /*#__PURE__*/React__default.createElement(DeleteIcon, null))));
  }))))), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: openDialog,
    color: "secondary"
  }, "Delete"), false , /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: onSave,
    variant: "contained",
    color: "primary"
  }, "Update"))))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: open,
    onClose: closeDialog
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    id: "alert-dialog-title"
  }, "Delete Field?"), /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement(DialogContentText, null, "Are you sure that you want to delete ".concat(item.name))), /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: closeDialog,
    color: "primary"
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "contained",
    onClick: handleDelete,
    color: "secondary"
  }, "Delete"))));
}

var Editor$1 = withStyles(styles$1a, {
  name: 'VdtFieldGroupEditor'
})(Editor);

var styles$1b = {
  iconContainer: {
    width: '40px',
    height: '40px',
    backgroundColor: 'rgba(0, 0, 0, 0.10)',
    "float": 'left'
  },
  iconStyle: {
    marginTop: 8,
    marginLeft: 8
  }
};
var DEFAULT_ICONS = {
  date: TodayIcon,
  "float": FormatListNumberedIcon,
  integer: LooksOneIcon,
  "long": Filter9PlusIcon,
  string: TextFieldsIcon,
  'string-exact': AssignmentIcon,
  "boolean": ThumbsUpDownIcon,
  timeCode: ScheduleIcon
};

function FieldIcon(_ref) {
  var fieldType = _ref.fieldType,
      classes = _ref.classes,
      _ref$icons = _ref.icons,
      icons = _ref$icons === void 0 ? DEFAULT_ICONS : _ref$icons;
  var _icons$fieldType = icons[fieldType],
      IconComponent = _icons$fieldType === void 0 ? null : _icons$fieldType;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.iconContainer
  }, /*#__PURE__*/React__default.createElement(IconComponent, {
    className: classes.iconStyle
  }));
}

var FieldIcon$1 = withStyles(styles$1b, {
  name: 'VdtFieldGroupIcon'
})(FieldIcon);

var styles$1c = function styles(theme) {
  return {
    fieldTitle: {
      lineHeight: '40px',
      marginLeft: 10,
      width: '30%'
    },
    fieldInfo: {
      lineHeight: '40px',
      marginLeft: 10,
      width: '60%'
    },
    item: {
      backgroundColor: theme.palette.background.paper,
      boxSizing: 'border-box',
      fontSize: '14px',
      userSelect: 'none',
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
      height: '40px'
    },
    activeItem: {
      backgroundColor: emphasize(theme.palette.background.paper, 0.1),
      boxSizing: 'border-box',
      fontSize: '14px',
      userSelect: 'none',
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
      height: '40px'
    },
    "delete": {
      marginLeft: 'auto'
    },
    edit: {
      marginLeft: ''
    }
  };
};

function getStyle(_ref) {
  var draggableStyle = _ref.draggableStyle,
      virtualStyle = _ref.virtualStyle,
      isDragging = _ref.isDragging;

  var combined = _objectSpread2(_objectSpread2({}, virtualStyle), draggableStyle);

  var grid = 8;

  var result = _objectSpread2(_objectSpread2({}, combined), {}, {
    height: 40,
    width: isDragging ? draggableStyle.width : "calc(".concat(combined.width, " - ").concat(grid * 2, "px)"),
    marginBottom: grid
  });

  return result;
}

var NO_LABEL = '-';
var NO_DISPLAY_TYPE = '-';

function MyField(_ref2) {
  var classes = _ref2.classes,
      provided = _ref2.provided,
      item = _ref2.item,
      style = _ref2.style,
      isDragging = _ref2.isDragging,
      _ref2$setSelectedItem = _ref2.setSelectedItem,
      setSelectedItem = _ref2$setSelectedItem === void 0 ? function () {
    return null;
  } : _ref2$setSelectedItem,
      openEditor = _ref2.openEditor,
      openDeleteDialog = _ref2.openDeleteDialog;
  var itemId = item.name,
      _item$data = item.data,
      data = _item$data === void 0 ? [] : _item$data,
      fieldType = item.type;

  var _ref3 = data.find(function (e) {
    return e.key === 'label';
  }) || {},
      labelDataValue = _ref3.value;

  var label = labelDataValue || NO_LABEL;

  var _ref4 = data.find(function (e) {
    return e.key === 'displayType';
  }) || {},
      displayTypeDataValue = _ref4.value;

  var displayType = displayTypeDataValue || NO_DISPLAY_TYPE;

  var handleClickEdit = function handleClickEdit() {
    setSelectedItem(itemId);
    openEditor();
  };

  var handleClickRemove = function handleClickRemove(event) {
    event.stopPropagation();
    setSelectedItem(itemId);
    openDeleteDialog();
  };

  return /*#__PURE__*/React__default.createElement(Card$1 // eslint-disable-next-line react/jsx-props-no-spreading
  , _extends({}, provided.draggableProps, provided.dragHandleProps, {
    ref: provided.innerRef,
    style: getStyle({
      draggableStyle: provided.draggableProps.style,
      virtualStyle: style,
      isDragging: isDragging
    }),
    className: classes.item,
    onClick: handleClickEdit
  }), /*#__PURE__*/React__default.createElement(FieldIcon$1, {
    fieldType: fieldType
  }), /*#__PURE__*/React__default.createElement("span", {
    className: classes.fieldTitle
  }, itemId), /*#__PURE__*/React__default.createElement("span", {
    className: classes.fieldInfo
  }, "Label: ".concat(label, " | Display Type: ").concat(displayType)), /*#__PURE__*/React__default.createElement(IconButton, {
    "aria-label": "delete",
    className: classes.edit,
    onClick: handleClickEdit
  }, /*#__PURE__*/React__default.createElement(EditIcon, {
    fontSize: "small"
  })), /*#__PURE__*/React__default.createElement(IconButton, {
    "aria-label": "delete",
    className: classes["delete"],
    onClick: handleClickRemove
  }, /*#__PURE__*/React__default.createElement(DeleteIcon, {
    fontSize: "small"
  })));
}

var MyField$1 = withStyles(styles$1c, {
  name: 'VdtFieldGroupMyField'
})(MyField);

var styles$1d = {
  droppable: {
    height: 600
  }
};

function MyFieldList(_ref) {
  var classes = _ref.classes,
      items = _ref.items,
      setSelectedItem = _ref.setSelectedItem,
      droppableId = _ref.droppableId,
      selectedItem = _ref.selectedItem,
      openEditor = _ref.openEditor,
      onDelete = _ref.onDelete,
      onUpdateFieldGroup = _ref.onUpdateFieldGroup,
      openDeleteDialog = _ref.openDeleteDialog;
  return /*#__PURE__*/React__default.createElement(Droppable, {
    droppableId: droppableId,
    renderClone: function renderClone(provided, snapshot, rubric) {
      return /*#__PURE__*/React__default.createElement(MyField$1, {
        provided: provided,
        isDragging: snapshot.isDragging,
        item: items[rubric.source.index]
      });
    }
  }, function (provided) {
    return /*#__PURE__*/React__default.createElement("div", {
      ref: provided.innerRef,
      className: classes.droppable
    }, items.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement(Draggable, {
        draggableId: item.name,
        index: index,
        key: item.name
      }, function (itemProvided) {
        return /*#__PURE__*/React__default.createElement(MyField$1, {
          provided: itemProvided,
          item: item,
          setSelectedItem: setSelectedItem,
          selectedItem: selectedItem,
          openEditor: openEditor,
          onDelete: onDelete,
          onUpdateGroup: onUpdateFieldGroup,
          openDeleteDialog: openDeleteDialog
        });
      });
    }), provided.placeholder);
  });
}

var MyFieldList$1 = withStyles(styles$1d, {
  name: 'VdtFieldGroupMyFieldList'
})(MyFieldList);

var vFetch = utils.vFetch,
    isRequired = utils.isRequired;
function updateGroupFieldOrder(_ref) {
  var _ref$groupName = _ref.groupName,
      groupName = _ref$groupName === void 0 ? isRequired() : _ref$groupName,
      _ref$orderedFieldIds = _ref.orderedFieldIds,
      orderedFieldIds = _ref$orderedFieldIds === void 0 ? isRequired() : _ref$orderedFieldIds,
      props = _objectWithoutProperties(_ref, ["groupName", "orderedFieldIds"]);

  var path = "/API/metadata-field/field-group/".concat(groupName, "/metadata/order");
  return vFetch(_objectSpread2({
    path: path,
    method: 'PUT',
    headers: {
      contentType: 'text/plain',
      accept: 'text/plain'
    },
    body: orderedFieldIds.join(',')
  }, props));
}
var filter = createFilterOptions();

function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (// eslint-disable-next-line
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  });
}

var styles$1e = {
  data: {
    display: 'flex',
    width: '100%'
  },
  margin: {
    margin: 20
  },
  button: {
    width: '100%'
  },
  addNewField: {
    "float": 'right'
  },
  title: {
    '&:hover': {
      cursor: 'pointer'
    }
  }
};
var MY_FIELDS = 'MY_FIELDS';

var initialData = _defineProperty({}, MY_FIELDS, []);

function FieldGroupDesigner(_ref2) {
  var classes = _ref2.classes,
      groupName = _ref2.groupName,
      groups = _ref2.groups,
      _ref2$metadataFieldGr = _ref2.metadataFieldGroupDocument,
      metadataFieldGroupDocument = _ref2$metadataFieldGr === void 0 ? {} : _ref2$metadataFieldGr,
      setNotification = _ref2.setNotification,
      onChangeGroup = _ref2.onChangeGroup,
      isLoading = _ref2.isLoading;

  var _React$useState = React__default.useState(initialData),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      data = _React$useState2[0],
      setData = _React$useState2[1];

  var _React$useState3 = React__default.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      selectedItem = _React$useState4[0],
      setSelectedItem = _React$useState4[1];

  var _React$useState5 = React__default.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      update = _React$useState6[0],
      setUpdate = _React$useState6[1];

  var _React$useState7 = React__default.useState(),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      displayLabel = _React$useState8[0],
      setDisplayLabel = _React$useState8[1];

  var _React$useState9 = React__default.useState(null),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      fieldToAdd = _React$useState10[0],
      setFieldToAdd = _React$useState10[1];

  var _React$useState11 = React__default.useState([]),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      existingFields = _React$useState12[0],
      setExistingFields = _React$useState12[1];

  var _React$useState13 = React__default.useState([]),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      childGroups = _React$useState14[0],
      setChildGroups = _React$useState14[1];

  var _React$useState15 = React__default.useState(false),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      showLabelEditorDialog = _React$useState16[0],
      setShowLabelEditorDialog = _React$useState16[1];

  var _React$useState17 = React__default.useState(false),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      showExistingFieldDialog = _React$useState18[0],
      setShowExistingFieldDialog = _React$useState18[1];

  var _React$useState19 = React__default.useState(false),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      showFieldEditorDialog = _React$useState20[0],
      setShowFieldEditorDialog = _React$useState20[1];

  var _React$useState21 = React__default.useState(false),
      _React$useState22 = _slicedToArray(_React$useState21, 2),
      showDeleteFieldDialog = _React$useState22[0],
      setShowDeleteFieldDialog = _React$useState22[1];

  var _React$useState23 = React__default.useState(false),
      _React$useState24 = _slicedToArray(_React$useState23, 2),
      showGroupDialog = _React$useState24[0],
      setShowGroupDialog = _React$useState24[1];

  var _React$useState25 = React__default.useState(false),
      _React$useState26 = _slicedToArray(_React$useState25, 2),
      showAddChildDialog = _React$useState26[0],
      setShowAddChildDialog = _React$useState26[1];

  var openFieldEditorDialog = function openFieldEditorDialog() {
    setShowFieldEditorDialog(true);
  };

  var closeFieldEditorDialog = function closeFieldEditorDialog() {
    setShowFieldEditorDialog(false);
  };

  var openAddChildGroupDialog = function openAddChildGroupDialog() {
    setShowAddChildDialog(true);
  };

  var closeAddChildGroupDialog = function closeAddChildGroupDialog() {
    setShowAddChildDialog(false);
  };

  var openLabelEditorDialog = function openLabelEditorDialog() {
    setShowLabelEditorDialog(true);
  };

  var closeLabelEditorDialog = function closeLabelEditorDialog() {
    setShowLabelEditorDialog(false);
  };

  var openExistingFieldDialog = function openExistingFieldDialog() {
    setShowExistingFieldDialog(true);
  };

  var closeExistingFieldDialog = function closeExistingFieldDialog() {
    setShowExistingFieldDialog(false);
  };

  var openDeleteFieldDialog = function openDeleteFieldDialog() {
    setShowDeleteFieldDialog(true);
  };

  var closeDeleteFieldDialog = function closeDeleteFieldDialog() {
    setShowDeleteFieldDialog(false);
  };

  var openGroupDialog = function openGroupDialog() {
    setShowGroupDialog(true);
  };

  var closeGroupDialog = function closeGroupDialog() {
    setShowGroupDialog(false);
  };

  var onLabelChange = function onLabelChange(event) {
    setDisplayLabel(event.target.value);
  };

  React__default.useEffect(function () {
    if (!groupName) return;
    var _metadataFieldGroupDo = metadataFieldGroupDocument.field,
        field = _metadataFieldGroupDo === void 0 ? [] : _metadataFieldGroupDo;

    if (metadataFieldGroupDocument) {
      if (typeof metadataFieldGroupDocument.data === 'undefined') {
        setDisplayLabel(groupName);
      } else {
        var labelIndex = metadataFieldGroupDocument.data.findIndex(function (label) {
          return label.key === 'label';
        });
        if (labelIndex > -1) setDisplayLabel(metadataFieldGroupDocument.data[labelIndex].value);
      } // sort the fields using the arbitrary "order" key


      if (metadataFieldGroupDocument.data) {
        var orderKeyValue = metadataFieldGroupDocument.data.find(function (item) {
          return item.key === 'order';
        });

        if (orderKeyValue) {
          var order = orderKeyValue.value.split(',');
          field.sort(function (a, b) {
            return order.indexOf(a.name) - order.indexOf(b.name);
          });
        }
      }

      if (metadataFieldGroupDocument.group) {
        setChildGroups(metadataFieldGroupDocument.group);
      }

      if (field) {
        setData(_defineProperty({}, MY_FIELDS, field));
      }
    }
  }, [groupName, metadataFieldGroupDocument]);

  var onUpdateFieldGroup = function onUpdateFieldGroup() {
    if (!groupName) return;
    fieldgroup.updateFieldGroup({
      groupName: groupName,
      metadataFieldGroupDocument: _objectSpread2(_objectSpread2({}, metadataFieldGroupDocument), {}, {
        field: _toConsumableArray(data[MY_FIELDS]),
        data: [{
          key: 'label',
          value: displayLabel
        }]
      })
    }).then(function (response) {
      if (response.ok) {
        setNotification({
          open: true,
          message: "".concat(groupName, " has been saved"),
          severity: 'success'
        });
      }
    })["catch"](function (error) {
      return setNotification({
        open: true,
        message: error.message,
        severity: 'error'
      });
    });
  };

  React__default.useEffect(function () {
    if (update) {
      onUpdateFieldGroup();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [data]);

  var addNewItem = function addNewItem() {
    var newFieldData = {
      data: [{
        key: 'displayType',
        value: 'text'
      }, {
        key: 'label',
        value: ''
      }],
      type: 'string',
      values: {
        field: []
      }
    };

    var destinationItems = _toConsumableArray(data[MY_FIELDS]);

    var newData = _objectSpread2({}, data);

    var _uuidv4$split = uuidv4().split('-'),
        _uuidv4$split2 = _slicedToArray(_uuidv4$split, 1),
        newId = _uuidv4$split2[0];

    var _groupName$split = groupName.split('_'),
        _groupName$split2 = _slicedToArray(_groupName$split, 1),
        groupPrefix = _groupName$split2[0];

    var newName = "".concat(groupPrefix, "_meta").concat(newId);

    var newItem = _objectSpread2(_objectSpread2({}, newFieldData), {}, {
      name: newName
    });

    destinationItems.splice(0, 0, newItem);
    newData[MY_FIELDS] = destinationItems;
    setData(newData);
    setSelectedItem(newName);
    openFieldEditorDialog();
  };

  var isNewItem = function isNewItem(item) {
    if (!metadataFieldGroupDocument || !item) return true;
    var fieldName = item.name;
    var _metadataFieldGroupDo2 = metadataFieldGroupDocument.field,
        field = _metadataFieldGroupDo2 === void 0 ? [] : _metadataFieldGroupDo2;
    var itemIndex = field.findIndex(function (_ref3) {
      var name = _ref3.name;
      return name === fieldName;
    });
    return itemIndex === -1;
  };

  var onDragEnd = function onDragEnd(_ref4) {
    var source = _ref4.source,
        destination = _ref4.destination;

    if (!destination) {
      return;
    }

    var sourceId = source.droppableId,
        sourceIndex = source.index;
    var destinationId = destination.droppableId,
        destinationIndex = destination.index;

    var destinationItems = _toConsumableArray(data[destinationId]);

    var newData = _objectSpread2({}, data);

    if (sourceId === destinationId) {
      var _destinationItems$spl = destinationItems.splice(sourceIndex, 1),
          _destinationItems$spl2 = _slicedToArray(_destinationItems$spl, 1),
          removed = _destinationItems$spl2[0];

      destinationItems.splice(destinationIndex, 0, removed);
      newData[destinationId] = destinationItems;
    }

    setData(newData);
    var orderedFieldIds = newData[MY_FIELDS].map(function (field) {
      return field.name;
    });
    updateGroupFieldOrder({
      groupName: groupName,
      orderedFieldIds: orderedFieldIds
    }).then(function (response) {
      if (response.ok) {
        setNotification({
          open: false,
          message: "".concat(groupName, " has been saved"),
          severity: 'success'
        });
      }
    })["catch"](function (error) {
      return setNotification({
        open: true,
        message: error.message,
        severity: 'error'
      });
    });
  };

  var onEdit = function onEdit(destinationId) {
    return function (prevItem, newItem) {
      var prevName = prevItem.name;
      var newName = newItem.name;

      var destinationItems = _toConsumableArray(data[destinationId]);

      var destinationIndex = destinationItems.findIndex(function (_ref5) {
        var name = _ref5.name;
        return name === prevName;
      });
      destinationItems.splice(destinationIndex, 1, newItem);

      var newData = _objectSpread2({}, data);

      newData[destinationId] = destinationItems;
      setData(newData);
      setUpdate(true);
      setSelectedItem(newName);
    };
  };

  var myFields = data[MY_FIELDS];

  var _React$useState27 = React__default.useState({}),
      _React$useState28 = _slicedToArray(_React$useState27, 2),
      editItem = _React$useState28[0],
      setEditItem = _React$useState28[1];

  React__default.useEffect(function () {
    setEditItem(myFields.find(function (_ref6) {
      var name = _ref6.name;
      return name === selectedItem;
    })); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);

  var onDelete = function onDelete() {
    var destinationItems = _toConsumableArray(data[MY_FIELDS]);

    var destinationIndex = destinationItems.findIndex(function (field) {
      return field.name === selectedItem;
    });
    destinationItems.splice(destinationIndex, 1);

    var newData = _objectSpread2({}, data);

    newData[MY_FIELDS] = destinationItems;

    if (metadataFieldGroupDocument) {
      fieldgroup.removeFieldGroupField({
        groupName: groupName,
        fieldName: selectedItem
      }).then(function (response) {
        if (response.ok) {
          setNotification({
            open: true,
            message: "".concat(selectedItem, " has been deleted"),
            severity: 'success'
          });
        }
      })["catch"](function (error) {
        return setNotification({
          open: true,
          message: error.message,
          severity: 'error'
        });
      });
    }

    setData(newData);
    setUpdate(true);
  };

  var onGetMetadataFields = function onGetMetadataFields() {
    metadatafield.listMetadataField().then(function (response) {
      setExistingFields(response.data.field);
    });
  };

  function addExistingField() {
    var destinationItems = _toConsumableArray(data[MY_FIELDS]);

    var newData = _objectSpread2({}, data);

    destinationItems.splice(0, 0, fieldToAdd);
    newData[MY_FIELDS] = destinationItems;
    setData(newData);
    setUpdate(true);
  }

  var _React$useState29 = React__default.useState(''),
      _React$useState30 = _slicedToArray(_React$useState29, 2),
      childGroupName = _React$useState30[0],
      setChildGroupName = _React$useState30[1];

  function addChildGroup(child) {
    setChildGroupName(child);
  }

  var _React$useState31 = React__default.useState(null),
      _React$useState32 = _slicedToArray(_React$useState31, 2),
      value = _React$useState32[0],
      setValue = _React$useState32[1];

  var onUpdateFieldGroupChild = function onUpdateFieldGroupChild() {
    try {
      fieldgroup.updateFieldGroupChild({
        groupName: groupName,
        childGroupName: childGroupName
      }).then(function (response) {
        if (response.ok) {
          setNotification({
            open: true,
            message: "".concat(childGroupName, " has been added to ").concat(groupName),
            severity: 'success'
          });
        }
      })["catch"](function (error) {
        return setNotification({
          open: true,
          message: error.message,
          severity: 'error'
        });
      });
    } catch (error) {
      setNotification({
        open: true,
        message: error.message,
        severity: 'error'
      });
    }
  };

  var handleEditLabelClick = function handleEditLabelClick(event) {
    event.stopPropagation();
    openLabelEditorDialog();
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    className: classes.title
  }, "Field-group: ".concat(displayLabel), /*#__PURE__*/React__default.createElement(IconButton, {
    "aria-label": "edit label",
    onClick: handleEditLabelClick
  }, /*#__PURE__*/React__default.createElement(EditIcon, {
    fontSize: "small"
  })))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "contained",
    color: "default",
    style: {
      marginLeft: '10px'
    },
    className: classes.addNewField,
    onClick: openGroupDialog
  }, "Child groups"), /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "contained",
    color: "primary",
    onClick: addNewItem,
    style: {
      marginLeft: '10px'
    },
    className: classes.addNewField
  }, "Add new field"), /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "outlined",
    color: "default",
    onClick: function onClick() {
      openExistingFieldDialog();
      onGetMetadataFields();
    },
    className: classes.addNewField
  }, "Add existing field"))), /*#__PURE__*/React__default.createElement(DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.data
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.margin
  }, /*#__PURE__*/React__default.createElement(MyFieldList$1, {
    items: myFields,
    setSelectedItem: setSelectedItem,
    selectedItem: selectedItem,
    droppableId: MY_FIELDS,
    openEditor: openFieldEditorDialog,
    closeEditor: closeFieldEditorDialog,
    onDelete: onDelete,
    onUpdateGroup: onUpdateFieldGroup,
    openDeleteDialog: openDeleteFieldDialog
  }))))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    onClose: closeFieldEditorDialog,
    open: showFieldEditorDialog,
    maxWidth: "md",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(Editor$1, {
    item: editItem,
    isNewItem: isNewItem(editItem),
    onClose: closeFieldEditorDialog,
    onEdit: onEdit(MY_FIELDS),
    onDelete: onDelete,
    onUpdateGroup: onUpdateFieldGroup
  })), /*#__PURE__*/React__default.createElement(Dialog$1, {
    onClose: closeLabelEditorDialog,
    open: showLabelEditorDialog,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, null, "Edit group label"), /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement(TextField$2, {
    name: "label",
    label: "Label",
    value: displayLabel,
    onChange: onLabelChange,
    fullWidth: true
  })), /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: closeLabelEditorDialog,
    color: "primary"
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: function onClick() {
      onUpdateFieldGroup();
      closeLabelEditorDialog();
    },
    color: "primary",
    autoFocus: true
  }, "Save"))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    onClose: closeExistingFieldDialog,
    open: showExistingFieldDialog,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, null, "Choose existing field to add"), /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement(Autocomplete, {
    options: existingFields,
    value: fieldToAdd,
    onChange: function onChange(event, newValue) {
      if (newValue && newValue.inputValue) {
        setFieldToAdd({
          name: newValue.inputValue
        });
        return;
      }

      setFieldToAdd(newValue);
    },
    filterOptions: function filterOptions(options, params) {
      var filtered = filter(options, params);
      return filtered;
    },
    getOptionLabel: function getOptionLabel(option) {
      if (typeof option === 'string') {
        return option;
      }

      if (option.inputValue) {
        setFieldToAdd(option);
        return option.inputValue;
      }

      return option.name;
    },
    renderOption: function renderOption(option) {
      return option.name;
    },
    renderInput: function renderInput(params) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-props-no-spreading
        React__default.createElement(TextField$2, _extends({}, params, {
          label: "Select field",
          variant: "outlined"
        }))
      );
    }
  })), /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: closeExistingFieldDialog,
    color: "primary"
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: function onClick() {
      closeExistingFieldDialog();
      addExistingField();
    },
    color: "primary",
    autoFocus: true
  }, "Add"))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: showDeleteFieldDialog,
    onClose: closeDeleteFieldDialog,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, null, "Delete Field?"), /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement(DialogContentText, null, "Are you sure that you want to delete ".concat(selectedItem))), /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: closeDeleteFieldDialog,
    color: "primary"
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "contained",
    onClick: function onClick() {
      closeDeleteFieldDialog();
      onDelete();
    },
    color: "secondary"
  }, "Delete"))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    onClose: closeGroupDialog,
    open: showGroupDialog,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    className: classes.title
  }, "Child groups")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "contained",
    color: "primary",
    style: {
      marginLeft: '10px'
    },
    className: classes.addNewField,
    onClick: openAddChildGroupDialog
  }, "Add Child Group")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(List$1, null, childGroups.map(function (_ref7) {
    var name = _ref7.name;
    return /*#__PURE__*/React__default.createElement(ListItem$1, {
      key: name,
      button: true,
      onClick: function onClick() {
        onChangeGroup(name);
        closeGroupDialog();
      }
    }, /*#__PURE__*/React__default.createElement(ListItemText, {
      primary: name
    }));
  }))))), /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: closeGroupDialog,
    color: "primary"
  }, "Close"))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    onClose: closeAddChildGroupDialog,
    open: showAddChildDialog,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, null, "Choose child group to add"), /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement(Autocomplete, {
    options: groups,
    value: value,
    onChange: function onChange(_, newValue) {
      if (newValue && newValue.inputValue) {
        setValue({
          name: newValue.inputValue
        });
        return;
      }

      setValue(newValue);

      if (newValue) {
        addChildGroup(newValue.name);
      }
    },
    filterOptions: function filterOptions(options, params) {
      var filtered = filter(options, params);
      return filtered;
    },
    getOptionLabel: function getOptionLabel(option) {
      if (typeof option === 'string') {
        return option;
      }

      if (option.inputValue) {
        addChildGroup(option.inputValue);
        return option.inputValue;
      }

      return option.name;
    },
    renderOption: function renderOption(option) {
      return option.name;
    },
    renderInput: function renderInput(params) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-props-no-spreading
        React__default.createElement(TextField$2, _extends({}, params, {
          label: "Select group",
          variant: "outlined"
        }))
      );
    }
  })), /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: closeAddChildGroupDialog,
    color: "primary"
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: function onClick() {
      closeAddChildGroupDialog();
      onUpdateFieldGroupChild();
    },
    color: "primary",
    autoFocus: true
  }, "Add"))));
}

var FieldGroupDesigner$1 = withStyles(styles$1e, {
  name: 'VdtFieldGroupDesigner'
})(FieldGroupDesigner);

var STORAGE = 'STORAGE';
var FILE = 'FILE';
var PREFIX = 'PREFIX';
var LOAD_MORE$1 = 'LOAD_MORE';
var JOIN_CHARACTER$1 = '_';
var SelectedFile = withStyles({}, {
  name: 'VdtSelectedFile'
})(function (_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'VdtSelectedFile' : _ref$className,
      styles = _ref.styles,
      fileId = _ref.fileId,
      fileType = _ref.fileType,
      _ref$SelectedFileActi = _ref.SelectedFileActionsComponent,
      SelectedFileActionsComponent = _ref$SelectedFileActi === void 0 ? null : _ref$SelectedFileActi,
      _ref$SelectedFileActi2 = _ref.SelectedFileActionsProps,
      SelectedFileActionsProps = _ref$SelectedFileActi2 === void 0 ? {} : _ref$SelectedFileActi2,
      _ref$fileText = _ref.fileText,
      fileText = _ref$fileText === void 0 ? 'File' : _ref$fileText;
  var path = fileType.path;
  var fileName = path.split('/').pop();
  var fileExtension = fileName.split('.').length > 1 ? fileName.split('.').pop() : undefined;
  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    styles: styles
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4"
  }, fileName), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: fileExtension ? 'space-between' : 'flex-start',
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5"
  }, "".concat(fileText, " \u2022 ").concat(fileId)), fileExtension && /*#__PURE__*/React__default.createElement(MediaBadge$1, null, fileExtension)), SelectedFileActionsComponent && /*#__PURE__*/React__default.createElement(SelectedFileActionsComponent, _extends({
    fileId: fileId,
    fileType: fileType // eslint-disable-next-line react/jsx-props-no-spreading

  }, SelectedFileActionsProps)));
});
function SelectedFileWrapper(_ref2) {
  var entityId = _ref2.entityId,
      _ref2$SelectedFileCom = _ref2.SelectedFileComponent,
      SelectedFileComponent = _ref2$SelectedFileCom === void 0 ? SelectedFile : _ref2$SelectedFileCom,
      props = _objectWithoutProperties(_ref2, ["entityId", "SelectedFileComponent"]);

  var _React$useState = React__default.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      fileType = _React$useState2[0],
      setFileType = _React$useState2[1];

  var onGetFile = function onGetFile() {
    file.getFile({
      fileId: entityId,
      matrixParams: {
        includeItem: true
      }
    }).then(function (_ref3) {
      var data = _ref3.data;
      return setFileType(data);
    });
  };

  React__default.useEffect(onGetFile, [entityId]);
  return fileType ? /*#__PURE__*/React__default.createElement(SelectedFileComponent, _extends({
    fileType: fileType,
    fileId: fileType.id // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)) : null;
}
var SelectedStorage = withStyles({}, {
  name: 'VdtSelectedStorage'
})(function (_ref4) {
  var _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? 'VdtSelectedStorage' : _ref4$className,
      styles = _ref4.styles,
      storageId = _ref4.storageId,
      storageType = _ref4.storageType,
      _ref4$SelectedStorage = _ref4.SelectedStorageActionsComponent,
      SelectedStorageActionsComponent = _ref4$SelectedStorage === void 0 ? null : _ref4$SelectedStorage,
      _ref4$SelectedStorage2 = _ref4.SelectedStorageActionsProps,
      SelectedStorageActionsProps = _ref4$SelectedStorage2 === void 0 ? {} : _ref4$SelectedStorage2,
      _ref4$storageText = _ref4.storageText,
      storageText = _ref4$storageText === void 0 ? 'Storage' : _ref4$storageText;

  var _React$useMemo = React__default.useMemo(function () {
    var _storageType$method = storageType.method,
        methodList = _storageType$method === void 0 ? [] : _storageType$method;

    var _methodList = _slicedToArray(methodList, 1),
        defaultMethod = _methodList[0];

    if (defaultMethod && defaultMethod.uri) {
      var uriString = defaultMethod.uri;
      var uri = new URL(uriString);
      var pathname = uri.pathname;
      var protocol = uri.protocol;
      var folder = pathname.split('@').pop();
      if (folder.endsWith('/')) folder = folder.slice(0, -1);
      if (protocol.endsWith(':')) protocol = protocol.slice(0, -1);
      return [protocol, folder];
    }

    return [];
  }, [storageType]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      methodType = _React$useMemo2[0],
      path = _React$useMemo2[1];

  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    styles: styles
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4"
  }, path || ''), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5"
  }, "".concat(storageText, " \u2022 ").concat(storageId)), /*#__PURE__*/React__default.createElement(MediaBadge$1, null, methodType)), SelectedStorageActionsComponent && /*#__PURE__*/React__default.createElement(SelectedStorageActionsComponent, _extends({
    storageId: storageId,
    storageType: storageType // eslint-disable-next-line react/jsx-props-no-spreading

  }, SelectedStorageActionsProps)));
});
function SelectedStorageWrapper(_ref5) {
  var entityId = _ref5.entityId,
      _ref5$SelectedStorage = _ref5.SelectedStorageComponent,
      SelectedStorageComponent = _ref5$SelectedStorage === void 0 ? SelectedStorage : _ref5$SelectedStorage,
      props = _objectWithoutProperties(_ref5, ["entityId", "SelectedStorageComponent"]);

  var _React$useState3 = React__default.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      storageType = _React$useState4[0],
      setStorageType = _React$useState4[1];

  var onGetStorage = function onGetStorage() {
    storage.getStorage({
      storageId: entityId
    }).then(function (_ref6) {
      var data = _ref6.data;
      return setStorageType(data);
    });
  };

  React__default.useEffect(onGetStorage, [entityId]);
  return storageType ? /*#__PURE__*/React__default.createElement(SelectedStorageComponent, _extends({
    storageType: storageType,
    storageId: storageType.id // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)) : null;
}
function SelectedEntityWrapper(_ref7) {
  var _ref8;

  var _ref7$selected = _ref7.selected,
      selected = _ref7$selected === void 0 ? '' : _ref7$selected,
      _ref7$SelectedEntitie = _ref7.SelectedEntities,
      SelectedEntities = _ref7$SelectedEntitie === void 0 ? (_ref8 = {}, _defineProperty(_ref8, STORAGE, SelectedStorageWrapper), _defineProperty(_ref8, FILE, SelectedFileWrapper), _ref8) : _ref7$SelectedEntitie,
      props = _objectWithoutProperties(_ref7, ["selected", "SelectedEntities"]);

  var _selected$split = selected.split(JOIN_CHARACTER$1),
      _selected$split2 = _slicedToArray(_selected$split, 2),
      entity = _selected$split2[0],
      entityId = _selected$split2[1];

  var SelectedEntity = SelectedEntities[entity];
  return SelectedEntity ? /*#__PURE__*/React__default.createElement(SelectedEntity, _extends({
    entityId: entityId // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)) : null;
}

function FileTree(_ref9) {
  var _ref9$className = _ref9.className,
      className = _ref9$className === void 0 ? 'VdtFile' : _ref9$className,
      styles = _ref9.styles,
      fileType = _ref9.fileType,
      storageId = _ref9.storageId;
  var fileId = fileType.id,
      path = fileType.path;
  var label = path.split('/').pop();
  return /*#__PURE__*/React__default.createElement(TreeItem, {
    nodeId: [FILE, fileId, storageId].join(JOIN_CHARACTER$1),
    label: label,
    className: className,
    styles: styles
  });
}

function FolderTree(_ref10) {
  var _ref10$className = _ref10.className,
      className = _ref10$className === void 0 ? 'VdtFolderTree' : _ref10$className,
      styles = _ref10.styles,
      path = _ref10.path,
      storageId = _ref10.storageId,
      fileListType = _ref10.fileListType,
      onListFilesMore = _ref10.onListFilesMore,
      _ref10$FolderComponen = _ref10.FolderComponent,
      FolderComponent = _ref10$FolderComponen === void 0 ? FolderListTree : _ref10$FolderComponen,
      _ref10$FolderProps = _ref10.FolderProps,
      FolderProps = _ref10$FolderProps === void 0 ? {} : _ref10$FolderProps,
      _ref10$FileComponent = _ref10.FileComponent,
      FileComponent = _ref10$FileComponent === void 0 ? FileTree : _ref10$FileComponent,
      _ref10$FileProps = _ref10.FileProps,
      FileProps = _ref10$FileProps === void 0 ? {} : _ref10$FileProps,
      _ref10$LoadMoreProps = _ref10.LoadMoreProps,
      LoadMoreProps = _ref10$LoadMoreProps === void 0 ? {} : _ref10$LoadMoreProps;
  var label = path.slice(0, -1).split('/').pop();
  var _fileListType$prefixe = fileListType.prefixes;
  _fileListType$prefixe = _fileListType$prefixe === void 0 ? {} : _fileListType$prefixe;
  var _fileListType$prefixe2 = _fileListType$prefixe.prefix,
      prefix = _fileListType$prefixe2 === void 0 ? [] : _fileListType$prefixe2,
      _fileListType$file = fileListType.file,
      fileList = _fileListType$file === void 0 ? [] : _fileListType$file,
      hits = fileListType.hits;
  var labelComponent = /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    alignItems: "flex-end",
    style: {
      fontWeight: 'inherit',
      color: 'inherit'
    }
  }, /*#__PURE__*/React__default.createElement(FolderIcon$1, {
    color: "inherit"
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    style: {
      fontWeight: 'inherit'
    }
  }, label));
  return /*#__PURE__*/React__default.createElement(TreeItem, {
    nodeId: [PREFIX, path, storageId].join(JOIN_CHARACTER$1),
    label: labelComponent,
    className: className,
    styles: styles
  }, prefix.map(function (subPath) {
    return /*#__PURE__*/React__default.createElement(FolderComponent, _extends({
      key: subPath,
      path: subPath,
      storageId: storageId // eslint-disable-next-line react/jsx-props-no-spreading

    }, FolderProps));
  }), fileList.map(function (fileType) {
    return /*#__PURE__*/React__default.createElement(FileComponent, _extends({
      key: fileType.id,
      fileId: fileType.id,
      fileType: fileType,
      storageId: storageId // eslint-disable-next-line react/jsx-props-no-spreading

    }, FileProps));
  }), hits !== undefined && hits > fileList.length && /*#__PURE__*/React__default.createElement(TreeItem, _extends({
    className: "loadMore",
    nodeId: "".concat(LOAD_MORE$1, "_").concat(path, "_").concat(storageId),
    label: "Load More",
    onClick: onListFilesMore // eslint-disable-next-line react/jsx-props-no-spreading

  }, LoadMoreProps)));
}
function FolderListTree(_ref11) {
  var path = _ref11.path,
      storageId = _ref11.storageId,
      _ref11$FolderTreeComp = _ref11.FolderTreeComponent,
      FolderTreeComponent = _ref11$FolderTreeComp === void 0 ? FolderTree : _ref11$FolderTreeComp,
      _ref11$FolderTreeProp = _ref11.FolderTreeProps,
      FolderTreeProps = _ref11$FolderTreeProp === void 0 ? {} : _ref11$FolderTreeProp;

  var _React$useState5 = React__default.useState([]),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      fileListType = _React$useState6[0],
      setFileListType = _React$useState6[1];

  React__default.useEffect(function () {
    file.listFileStorage({
      storageId: storageId,
      queryParams: {
        prefix: true,
        path: path,
        recursive: false
      },
      matrixParams: {
        first: 0,
        number: 10
      }
    }).then(function (_ref12) {
      var data = _ref12.data;
      return setFileListType(data);
    });
  }, [path, storageId]);
  var onListFilesMore = React__default.useCallback(function () {
    var _fileListType$file2 = fileListType.file,
        fileList = _fileListType$file2 === void 0 ? [] : _fileListType$file2,
        hits = fileListType.hits;
    var first = fileList.length;
    if (first === hits) return;
    file.listFileStorage({
      storageId: storageId,
      queryParams: {
        prefix: true,
        path: path,
        recursive: false
      },
      matrixParams: {
        first: first,
        number: 10
      }
    }).then(function (_ref13) {
      var _ref13$data = _ref13.data;
      _ref13$data = _ref13$data === void 0 ? {} : _ref13$data;

      var _ref13$data$file = _ref13$data.file,
          newFileList = _ref13$data$file === void 0 ? [] : _ref13$data$file,
          newFileProps = _objectWithoutProperties(_ref13$data, ["file"]);

      var newFileType = _objectSpread2(_objectSpread2({}, newFileProps), {}, {
        file: [].concat(_toConsumableArray(fileList), _toConsumableArray(newFileList))
      });

      setFileListType(newFileType);
    });
  }, [fileListType, path, storageId]);
  return /*#__PURE__*/React__default.createElement(FolderTreeComponent, _extends({
    path: path,
    storageId: storageId,
    fileListType: fileListType,
    onListFilesMore: onListFilesMore // eslint-disable-next-line react/jsx-props-no-spreading

  }, FolderTreeProps));
}
var StorageTree = withStyles({}, {
  name: 'VdtStorageTree'
})(function (_ref14) {
  var _ref14$className = _ref14.className,
      className = _ref14$className === void 0 ? 'VdtStorageTree' : _ref14$className,
      styles = _ref14.styles,
      storageType = _ref14.storageType,
      storageId = _ref14.storageId,
      fileListType = _ref14.fileListType,
      onListFilesMore = _ref14.onListFilesMore,
      _ref14$FolderComponen = _ref14.FolderComponent,
      FolderComponent = _ref14$FolderComponen === void 0 ? FolderListTree : _ref14$FolderComponen,
      _ref14$FolderProps = _ref14.FolderProps,
      FolderProps = _ref14$FolderProps === void 0 ? {} : _ref14$FolderProps,
      _ref14$FileComponent = _ref14.FileComponent,
      FileComponent = _ref14$FileComponent === void 0 ? FileTree : _ref14$FileComponent,
      _ref14$FileProps = _ref14.FileProps,
      FileProps = _ref14$FileProps === void 0 ? {} : _ref14$FileProps,
      _ref14$LoadMoreProps = _ref14.LoadMoreProps,
      LoadMoreProps = _ref14$LoadMoreProps === void 0 ? {} : _ref14$LoadMoreProps,
      _ref14$storageText = _ref14.storageText,
      storageText = _ref14$storageText === void 0 ? 'Storage' : _ref14$storageText,
      _ref14$loadMoreText = _ref14.loadMoreText,
      loadMoreText = _ref14$loadMoreText === void 0 ? 'Load more' : _ref14$loadMoreText;
  var label = React__default.useMemo(function () {
    var _storageType$method2 = storageType.method,
        methodList = _storageType$method2 === void 0 ? [] : _storageType$method2;

    var _methodList2 = _slicedToArray(methodList, 1),
        defaultMethod = _methodList2[0];

    if (defaultMethod && defaultMethod.uri) {
      var uriString = defaultMethod.uri;
      var uri = new URL(uriString);
      var pathname = uri.pathname;
      var protocol = uri.protocol;
      var folder = pathname.split('@').pop();
      if (folder.endsWith('/')) folder = folder.slice(0, -1);
      if (protocol.endsWith(':')) protocol = protocol.slice(0, -1);
      return "".concat(protocol, " ").concat(folder);
    }

    return "".concat(storageText, " ").concat(storageId); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storageType, storageId]);
  var _fileListType$prefixe3 = fileListType.prefixes;
  _fileListType$prefixe3 = _fileListType$prefixe3 === void 0 ? {} : _fileListType$prefixe3;
  var _fileListType$prefixe4 = _fileListType$prefixe3.prefix,
      prefix = _fileListType$prefixe4 === void 0 ? [] : _fileListType$prefixe4,
      _fileListType$file3 = fileListType.file,
      fileList = _fileListType$file3 === void 0 ? [] : _fileListType$file3,
      hits = fileListType.hits;
  return /*#__PURE__*/React__default.createElement(TreeItem, {
    nodeId: [STORAGE, storageId].join(JOIN_CHARACTER$1),
    label: label,
    className: className,
    styles: styles
  }, prefix.map(function (path) {
    return /*#__PURE__*/React__default.createElement(FolderComponent, _extends({
      key: path,
      path: path,
      storageId: storageId // eslint-disable-next-line react/jsx-props-no-spreading

    }, FolderProps));
  }), fileList.map(function (fileType) {
    return /*#__PURE__*/React__default.createElement(FileComponent, _extends({
      key: fileType.id,
      fileId: fileType.id,
      fileType: fileType,
      storageId: storageId // eslint-disable-next-line react/jsx-props-no-spreading

    }, FileProps));
  }), hits !== undefined && hits > fileList.length && /*#__PURE__*/React__default.createElement(TreeItem, _extends({
    className: "loadMore",
    nodeId: [LOAD_MORE$1, storageId].join(JOIN_CHARACTER$1),
    label: loadMoreText,
    onClick: onListFilesMore // eslint-disable-next-line react/jsx-props-no-spreading

  }, LoadMoreProps)));
});
function Storage(_ref15) {
  var storageId = _ref15.storageId,
      storageType = _ref15.storageType,
      _ref15$StorageTreeCom = _ref15.StorageTreeComponent,
      StorageTreeComponent = _ref15$StorageTreeCom === void 0 ? StorageTree : _ref15$StorageTreeCom,
      _ref15$StorageTreePro = _ref15.StorageTreeProps,
      StorageTreeProps = _ref15$StorageTreePro === void 0 ? {} : _ref15$StorageTreePro;

  var _React$useState7 = React__default.useState({}),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      fileListType = _React$useState8[0],
      setFileListType = _React$useState8[1];

  React__default.useEffect(function () {
    file.listFileStorage({
      storageId: storageId,
      queryParams: {
        prefix: true,
        path: '/',
        recursive: false
      },
      matrixParams: {
        first: 0,
        number: 10
      }
    }).then(function (_ref16) {
      var data = _ref16.data;
      return setFileListType(data);
    });
  }, [storageId]);
  var onListFilesMore = React__default.useCallback(function () {
    var _fileListType$file4 = fileListType.file,
        fileList = _fileListType$file4 === void 0 ? [] : _fileListType$file4,
        hits = fileListType.hits;
    var first = fileList.length;
    if (first === hits) return;
    file.listFileStorage({
      storageId: storageId,
      queryParams: {
        prefix: true,
        path: '/',
        recursive: false
      },
      matrixParams: {
        first: first,
        number: 10
      }
    }).then(function (_ref17) {
      var _ref17$data = _ref17.data;
      _ref17$data = _ref17$data === void 0 ? {} : _ref17$data;

      var _ref17$data$file = _ref17$data.file,
          newFileList = _ref17$data$file === void 0 ? [] : _ref17$data$file,
          newFileProps = _objectWithoutProperties(_ref17$data, ["file"]);

      var newFileType = _objectSpread2(_objectSpread2({}, newFileProps), {}, {
        file: [].concat(_toConsumableArray(fileList), _toConsumableArray(newFileList))
      });

      setFileListType(newFileType);
    });
  }, [fileListType, storageId]);
  return /*#__PURE__*/React__default.createElement(StorageTreeComponent, _extends({
    onListFilesMore: onListFilesMore,
    fileListType: fileListType,
    storageId: storageId,
    storageType: storageType // eslint-disable-next-line react/jsx-props-no-spreading

  }, StorageTreeProps));
}
function StorageList(_ref18) {
  var _ref18$StorageCompone = _ref18.StorageComponent,
      StorageComponent = _ref18$StorageCompone === void 0 ? Storage : _ref18$StorageCompone,
      _ref18$StorageProps = _ref18.StorageProps,
      StorageProps = _ref18$StorageProps === void 0 ? {} : _ref18$StorageProps;

  var _React$useState9 = React__default.useState({}),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      storageListType = _React$useState10[0],
      setStorageListType = _React$useState10[1];

  var onListStorages = function onListStorages() {
    storage.listStorage().then(function (_ref19) {
      var data = _ref19.data;
      return setStorageListType(data);
    });
  };

  React__default.useEffect(onListStorages, []);
  var _storageListType$stor = storageListType.storage,
      storageList = _storageListType$stor === void 0 ? [] : _storageListType$stor;
  if (storageList.length === 0) return null;
  return storageList.map(function (storageType) {
    return /*#__PURE__*/React__default.createElement(StorageComponent, _extends({
      key: storageType.id,
      storageId: storageType.id,
      storageType: storageType // eslint-disable-next-line react/jsx-props-no-spreading

    }, StorageProps));
  });
}
function StorageListTree(_ref20) {
  var _ref20$className = _ref20.className,
      className = _ref20$className === void 0 ? 'VdtStorageListTree' : _ref20$className,
      styles = _ref20.styles,
      _ref20$StorageListCom = _ref20.StorageListComponent,
      StorageListComponent = _ref20$StorageListCom === void 0 ? StorageList : _ref20$StorageListCom,
      _ref20$StorageListPro = _ref20.StorageListProps,
      StorageListProps = _ref20$StorageListPro === void 0 ? {} : _ref20$StorageListPro,
      selected = _ref20.selected,
      _ref20$onChange = _ref20.onChange,
      onChange = _ref20$onChange === void 0 ? function () {
    return null;
  } : _ref20$onChange;

  var _React$useState11 = React__default.useState([]),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      expanded = _React$useState12[0],
      setExpanded = _React$useState12[1];

  var onNodeSelect = function onNodeSelect(event, nodeIds) {
    if (typeof nodeIds === 'string') {
      if (nodeIds.startsWith(PREFIX) || nodeIds.startsWith(LOAD_MORE$1)) return;
    }

    onChange(nodeIds);
  };

  var onNodeToggle = function onNodeToggle(event, nodeIds) {
    setExpanded(nodeIds);
  };

  return /*#__PURE__*/React__default.createElement(TreeView, {
    className: className,
    defaultCollapseIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    defaultExpandIcon: /*#__PURE__*/React__default.createElement(ChevronRightIcon, null),
    onNodeSelect: onNodeSelect,
    onNodeToggle: onNodeToggle,
    selected: selected,
    expanded: expanded,
    styles: styles
  }, /*#__PURE__*/React__default.createElement(StorageListComponent // eslint-disable-next-line react/jsx-props-no-spreading
  , StorageListProps));
}

var styles$1f = function styles(theme) {
  return {
    popper: {
      backgroundColor: theme.palette.background["default"],
      zIndex: 100
    },
    focused: {
      backgroundColor: theme.palette.action.hover
    }
  };
};

function SearchSuggestions(_ref) {
  var _ref$suggestions = _ref.suggestions,
      suggestions = _ref$suggestions === void 0 ? [] : _ref$suggestions,
      focused = _ref.focused,
      onHover = _ref.onHover,
      onSelected = _ref.onSelected,
      anchorEl = _ref.anchorEl,
      classes = _ref.classes,
      className = _ref.className,
      _ref$MenuProps = _ref.MenuProps,
      MenuProps = _ref$MenuProps === void 0 ? {} : _ref$MenuProps,
      _ref$MenuItemProps = _ref.MenuItemProps,
      MenuItemProps = _ref$MenuItemProps === void 0 ? {} : _ref$MenuItemProps;
  return suggestions.length > 0 ? /*#__PURE__*/React__default.createElement(Popper, {
    anchorEl: anchorEl,
    open: true,
    style: {
      width: anchorEl ? anchorEl.clientWidth : null
    },
    className: clsx(classes.popper, className)
  }, /*#__PURE__*/React__default.createElement(MenuList, _extends({
    onMouseLeave: function onMouseLeave() {
      return onHover(-1);
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, MenuProps), suggestions.map(function (suggestion, i) {
    return /*#__PURE__*/React__default.createElement(MenuItem, _extends({
      key: suggestion,
      onMouseEnter: function onMouseEnter() {
        return onHover(i);
      },
      onMouseDown: function onMouseDown(e) {
        return onSelected(e, suggestion);
      },
      className: clsx(_defineProperty({}, classes.focused, focused === i)) // eslint-disable-next-line react/jsx-props-no-spreading

    }, MenuItemProps), suggestion);
  }))) : null;
}

var SearchSuggestions$1 = withStyles(styles$1f, {
  name: 'VdtSearchSuggestions'
})(SearchSuggestions);

var metadataToProps$4 = function metadataToProps(_ref) {
  var searchResultEntryType = _ref.searchResultEntryType,
      parseMetadataOpts = _ref.parseMetadataOpts,
      options = _ref.options,
      innerProps = _ref.innerProps;

  var _ref2 = searchResultEntryType.item || searchResultEntryType.collection,
      _ref2$metadata = _ref2.metadata,
      metadata = _ref2$metadata === void 0 ? {} : _ref2$metadata;

  var parsedMetadata = parseMetadataType(metadata, parseMetadataOpts);
  return options.map(function (_ref3) {
    var value = _ref3.value,
        valueComponent = _ref3.valueComponent;
    var parsedValue = parsedMetadata[value];
    if (valueComponent) return valueComponent({
      value: parsedValue,
      innerProps: innerProps
    });
    return parsedValue;
  });
};

function SearchResultRow(_ref4) {
  var _ref4$options = _ref4.options,
      options = _ref4$options === void 0 ? [] : _ref4$options,
      _ref4$metadataToProps = _ref4.metadataToProps,
      handleMetadataToProps = _ref4$metadataToProps === void 0 ? metadataToProps$4 : _ref4$metadataToProps,
      _ref4$parseMetadataOp = _ref4.parseMetadataOpts,
      parseMetadataOpts = _ref4$parseMetadataOp === void 0 ? {
    joinValue: ', ',
    flat: true
  } : _ref4$parseMetadataOp,
      selected = _ref4.selected,
      onCheck = _ref4.onCheck,
      onClick = _ref4.onClick,
      innerProps = _objectWithoutProperties(_ref4, ["options", "metadataToProps", "parseMetadataOpts", "selected", "onCheck", "onClick"]);

  var searchResultEntryType = innerProps.searchResultEntryType;
  var rowValues = React__default.useMemo(function () {
    return handleMetadataToProps({
      searchResultEntryType: searchResultEntryType,
      parseMetadataOpts: parseMetadataOpts,
      options: options,
      innerProps: innerProps
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [searchResultEntryType, options, metadataToProps$4]);

  var handleChecked = function handleChecked(event) {
    event.preventDefault();
    if (onCheck) onCheck(event, !selected, innerProps);
  };

  return /*#__PURE__*/React__default.createElement(TableRow$3$1, {
    hover: true,
    selected: selected,
    onClick: onClick,
    style: {
      cursor: 'pointer'
    }
  }, onCheck && /*#__PURE__*/React__default.createElement(TableCell$1, {
    padding: "checkbox"
  }, /*#__PURE__*/React__default.createElement(MediaCardCheckbox, {
    checked: selected,
    handleChecked: handleChecked
  })), rowValues.map(function (cellValue, index) {
    return /*#__PURE__*/React__default.createElement(Hidden, {
      key: options[index].value || options[index].label,
      only: options[index].hide
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, cellValue));
  }));
}

function SearchResultTable(_ref) {
  var _ref$searchResultType = _ref.searchResultType,
      searchResultType = _ref$searchResultType === void 0 ? {} : _ref$searchResultType,
      _ref$RowComponent = _ref.RowComponent,
      RowComponent = _ref$RowComponent === void 0 ? SearchResultRow : _ref$RowComponent,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      onCheck = _ref.onCheck,
      onRowClick = _ref.onRowClick,
      innerProps = _objectWithoutProperties(_ref, ["searchResultType", "RowComponent", "options", "onCheck", "onRowClick"]);

  var _searchResultType$ent = searchResultType.entry,
      entryList = _searchResultType$ent === void 0 ? [] : _searchResultType$ent;
  return /*#__PURE__*/React__default.createElement(Table$1, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead$1$1, null, /*#__PURE__*/React__default.createElement(TableRow$3$1, null, onCheck && /*#__PURE__*/React__default.createElement(TableCell$1, {
    padding: "checkbox"
  }), options.map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value,
        hide = _ref2.hide;
    return /*#__PURE__*/React__default.createElement(Hidden, {
      key: [label, value].join('_'),
      only: hide
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, label));
  }))), /*#__PURE__*/React__default.createElement(TableBody$1, null, entryList && entryList.map(function (searchResultEntryType) {
    return /*#__PURE__*/React__default.createElement(RowComponent, _extends({
      key: [searchResultEntryType.type, searchResultEntryType.id].join('_'),
      searchResultEntryType: searchResultEntryType,
      options: options,
      onCheck: onCheck,
      onClick: function onClick() {
        return onRowClick(searchResultEntryType);
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, innerProps));
  })));
}

function SavedSearchAccessList(_ref) {
  var collectionId = _ref.collectionId,
      props = _objectWithoutProperties(_ref, ["collectionId"]);

  var _useEntityAccess = useEntityAccess({
    entityId: collectionId,
    entityType: 'collection'
  }),
      accessControlList = _useEntityAccess.accessControlList,
      onList = _useEntityAccess.onList,
      onRemove = _useEntityAccess.onRemove;

  React__default.useEffect(function () {
    onList(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collectionId]);

  var handleRemove = function handleRemove(removeProps) {
    return onRemove(removeProps).then(onList);
  };

  return /*#__PURE__*/React__default.createElement(EntityAccessTable$1, _extends({
    entityType: "collection",
    entityId: collectionId,
    accessControlList: accessControlList,
    onRemove: handleRemove // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

var styles$1g = {
  actionsSubmit: {
    width: '100%'
  },
  root: {
    width: '100%'
  }
};

function ShareSearch(_ref) {
  var classes = _ref.classes,
      collectionId = _ref.collectionId,
      props = _objectWithoutProperties(_ref, ["classes", "collectionId"]);

  var handleSubmit = function handleSubmit(args) {
    return access.createEntityAccess(_objectSpread2(_objectSpread2({}, args), {}, {
      queryParams: {
        allowDuplicate: false
      }
    }));
  };

  return /*#__PURE__*/React__default.createElement(EntityAccessEdit$1, _extends({
    classes: classes,
    entityType: "collection",
    entityId: collectionId,
    onSubmit: handleSubmit,
    initialAccessControlDocument: {
      user: null,
      permission: 'READ'
    },
    PermissionPickerComponent: null // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

var ShareSearch$1 = withStyles(styles$1g, {
  name: 'VdtShareSearch'
})(ShareSearch);

var SHARE_MENU = 'SHARE_MENU';
var LISTACCESS_MENU = 'LISTACCESS_MENU';

var styles$1h = function styles(theme) {
  return {
    root: {
      '&:hover $SubmitSearchIcon': {
        visibility: 'visible'
      }
    },
    SubmitSearchIcon: {
      visibility: 'hidden'
    },
    inputDisabled: {
      cursor: 'pointer'
    },
    disabled: {
      opacity: 1
    },
    menuExpand: {
      minWidth: theme.breakpoints.values.sm / 2
    },
    CancelEditIcon: {
      marginRight: theme.spacing(0.5),
      '&:hover': {
        color: 'red'
      }
    },
    SubmitTitleIcon: {
      marginRight: theme.spacing(0.5),
      '&:hover': {
        color: 'green'
      }
    },
    OptionsIcon: {
      marginRight: theme.spacing(0.5)
    }
  };
};

function SavedSearchRow(_ref) {
  var classes = _ref.classes,
      collectionType = _ref.collectionType,
      onSelect = _ref.onSelect,
      onDelete = _ref.onDelete,
      onUpdateSearchMetadata = _ref.onUpdateSearchMetadata,
      _ref$allowDelete = _ref.allowDelete,
      allowDelete = _ref$allowDelete === void 0 ? function () {
    return true;
  } : _ref$allowDelete,
      _ref$allowShare = _ref.allowShare,
      allowShare = _ref$allowShare === void 0 ? function () {
    return true;
  } : _ref$allowShare,
      _ref$allowListAccess = _ref.allowListAccess,
      allowListAccess = _ref$allowListAccess === void 0 ? function () {
    return true;
  } : _ref$allowListAccess,
      _ref$allowEditTitle = _ref.allowEditTitle,
      allowEditTitle = _ref$allowEditTitle === void 0 ? function () {
    return true;
  } : _ref$allowEditTitle,
      _ref$ListAccessCompon = _ref.ListAccessComponent,
      ListAccessComponent = _ref$ListAccessCompon === void 0 ? SavedSearchAccessList : _ref$ListAccessCompon,
      _ref$ListAccessProps = _ref.ListAccessProps,
      ListAccessProps = _ref$ListAccessProps === void 0 ? {} : _ref$ListAccessProps,
      _ref$ShareComponent = _ref.ShareComponent,
      ShareComponent = _ref$ShareComponent === void 0 ? ShareSearch$1 : _ref$ShareComponent,
      _ref$ShareProps = _ref.ShareProps,
      ShareProps = _ref$ShareProps === void 0 ? {} : _ref$ShareProps,
      _ref$editTitleText = _ref.editTitleText,
      editTitleText = _ref$editTitleText === void 0 ? 'Edit' : _ref$editTitleText,
      _ref$shareText = _ref.shareText,
      shareText = _ref$shareText === void 0 ? 'Share' : _ref$shareText,
      _ref$listAccessText = _ref.listAccessText,
      listAccessText = _ref$listAccessText === void 0 ? 'Access' : _ref$listAccessText,
      _ref$deleteText = _ref.deleteText,
      deleteText = _ref$deleteText === void 0 ? 'Delete' : _ref$deleteText,
      _ref$backText = _ref.backText,
      backText = _ref$backText === void 0 ? 'Back' : _ref$backText,
      _ref$SubmitSearchIcon = _ref.SubmitSearchIcon,
      SubmitSearchIcon = _ref$SubmitSearchIcon === void 0 ? YoutubeSearchedForIcon : _ref$SubmitSearchIcon,
      _ref$ListAccessIcon = _ref.ListAccessIcon,
      ListAccessIcon = _ref$ListAccessIcon === void 0 ? LockIcon : _ref$ListAccessIcon,
      _ref$SubmitTitleIcon = _ref.SubmitTitleIcon,
      SubmitTitleIcon = _ref$SubmitTitleIcon === void 0 ? CheckIcon : _ref$SubmitTitleIcon,
      _ref$CancelEditIcon = _ref.CancelEditIcon,
      CancelEditIcon = _ref$CancelEditIcon === void 0 ? CloseIcon : _ref$CancelEditIcon,
      _ref$EditTitleIcon = _ref.EditTitleIcon,
      EditTitleIcon = _ref$EditTitleIcon === void 0 ? EditIcon : _ref$EditTitleIcon,
      _ref$ShareSearchIcon = _ref.ShareSearchIcon,
      ShareSearchIcon = _ref$ShareSearchIcon === void 0 ? ShareIcon : _ref$ShareSearchIcon,
      _ref$DeleteSearchIcon = _ref.DeleteSearchIcon,
      DeleteSearchIcon = _ref$DeleteSearchIcon === void 0 ? DeleteIcon : _ref$DeleteSearchIcon,
      _ref$OptionsIcon = _ref.OptionsIcon,
      OptionsIcon = _ref$OptionsIcon === void 0 ? MoreVertIcon : _ref$OptionsIcon;
  var _collectionType$metad = collectionType.metadata,
      metadata = _collectionType$metad === void 0 ? {} : _collectionType$metad;
  var searchMetadata = parseMetadataType(metadata, {
    joinValue: ',',
    flat: true
  });
  var inputRef = React__default.useRef();

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expandedView = _React$useState2[0],
      setExpandedView = _React$useState2[1];

  var _React$useState3 = React__default.useState(searchMetadata.title || ''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      title = _React$useState4[0],
      setTitle = _React$useState4[1];

  var _React$useState5 = React__default.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      anchorEl = _React$useState6[0],
      setAnchorEl = _React$useState6[1];

  var _React$useState7 = React__default.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      isEditing = _React$useState8[0],
      setIsEditing = _React$useState8[1];

  var handleOpenMenu = function handleOpenMenu(e) {
    if (e.stopPropagation) e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  var handleMenuAction = function handleMenuAction(action) {
    return function (e) {
      if (e.stopPropagation) e.stopPropagation();
      setAnchorEl(null);
      action();
    };
  };

  var handleSubmitTitle = function handleSubmitTitle() {
    return onUpdateSearchMetadata(createMetadataType({
      title: title
    })).then(function () {
      return setIsEditing(false);
    });
  };

  var handleEditTitle = handleMenuAction(function () {
    setIsEditing(true);
    inputRef.current.focus();
  });

  var handleEditCancel = function handleEditCancel() {
    setTitle(searchMetadata.title);
    setIsEditing(false);
  };

  var handleOnSelect = handleMenuAction(onSelect);
  var handleDelete = handleMenuAction(onDelete);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ListItem$1, {
    disableGutters: true,
    dense: true,
    className: classes.root,
    button: true
  }, SubmitSearchIcon ? /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(IconButton, {
    size: "small",
    onClick: handleOnSelect
  }, /*#__PURE__*/React__default.createElement(SubmitSearchIcon, {
    className: classes.SubmitSearchIcon
  }))) : null, /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: /*#__PURE__*/React__default.createElement(TextField$2, {
      fullWidth: true,
      value: title,
      onChange: isEditing ? function (e) {
        return setTitle(e.target.value);
      } : undefined,
      onClick: isEditing ? function (e) {
        return e.stopPropagation();
      } : handleOnSelect,
      onKeyPress: function onKeyPress(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleSubmitTitle();
        }
      },
      InputProps: {
        inputProps: {
          disabled: !isEditing,
          ref: inputRef,
          className: clsx(classes.input, _defineProperty({}, classes.inputDisabled, !isEditing))
        },
        disableUnderline: !isEditing,
        endAdornment: /*#__PURE__*/React__default.createElement(InputAdornment$1, {
          position: "end"
        }, isEditing ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ButtonBase, {
          size: "small",
          onClick: handleEditCancel
        }, /*#__PURE__*/React__default.createElement(CancelEditIcon, {
          className: classes.CancelEditIcon
        })), /*#__PURE__*/React__default.createElement(ButtonBase, {
          size: "small",
          onClick: handleSubmitTitle
        }, /*#__PURE__*/React__default.createElement(SubmitTitleIcon, {
          className: classes.SubmitTitleIcon
        }))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, [allowShare, allowListAccess, allowDelete, allowEditTitle].some(function (f) {
          return f(searchMetadata);
        }) ? /*#__PURE__*/React__default.createElement(ButtonBase, {
          size: "small",
          onClick: handleOpenMenu
        }, /*#__PURE__*/React__default.createElement(OptionsIcon, {
          className: classes.OptionsIcon
        })) : null))
      }
    })
  })), /*#__PURE__*/React__default.createElement(Menu, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    keepMounted: true,
    onClose: function onClose() {
      return setAnchorEl(null);
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, expandedView == null ? /*#__PURE__*/React__default.createElement("div", null, allowEditTitle(searchMetadata) && /*#__PURE__*/React__default.createElement(MenuItem, {
    dense: true,
    key: 1,
    onClick: handleEditTitle
  }, EditTitleIcon ? /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(EditTitleIcon, null)) : null, /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: editTitleText
  })), allowListAccess(searchMetadata) && /*#__PURE__*/React__default.createElement(MenuItem, {
    dense: true,
    key: 2,
    onClick: function onClick() {
      return setExpandedView(LISTACCESS_MENU);
    }
  }, ListAccessIcon ? /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(ListAccessIcon, null)) : null, /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: listAccessText
  })), allowShare(searchMetadata) && /*#__PURE__*/React__default.createElement(MenuItem, {
    dense: true,
    key: 3,
    onClick: function onClick() {
      return setExpandedView(SHARE_MENU);
    }
  }, ShareSearchIcon ? /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(ShareSearchIcon, null)) : null, /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: shareText
  })), allowDelete(searchMetadata) && /*#__PURE__*/React__default.createElement(MenuItem, {
    dense: true,
    key: 4,
    onClick: handleDelete
  }, DeleteSearchIcon ? /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(DeleteSearchIcon, null)) : null, /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: deleteText
  }))) : /*#__PURE__*/React__default.createElement("div", {
    className: classes.menuExpand
  }, /*#__PURE__*/React__default.createElement(MenuItem, {
    dense: true,
    key: 4,
    onClick: function onClick() {
      return setExpandedView(null);
    }
  }, /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(ChevronLeftIcon, null)), /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: backText
  })), /*#__PURE__*/React__default.createElement(Divider$1, null), expandedView === SHARE_MENU && /*#__PURE__*/React__default.createElement(ShareComponent, _extends({
    collectionId: searchMetadata.collectionId,
    onSuccess: function onSuccess() {
      return setExpandedView(LISTACCESS_MENU);
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, ShareProps)), expandedView === LISTACCESS_MENU && /*#__PURE__*/React__default.createElement(ListAccessComponent, _extends({
    collectionId: searchMetadata.collectionId // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListAccessProps)))));
}

var SavedSearchRow$1 = withStyles(styles$1h, {
  name: 'VdtSavedSearchRow'
})(SavedSearchRow);

var styles$1i = {};

function SavedSearchList(_ref) {
  var searchProps = _ref.searchProps,
      _ref$searchPlaceholde = _ref.searchPlaceholderText,
      searchPlaceholderText = _ref$searchPlaceholde === void 0 ? 'Find searches' : _ref$searchPlaceholde,
      _onSelect = _ref.onSelect,
      _onDelete = _ref.onDelete,
      _onUpdateSearchMetadata = _ref.onUpdateSearchMetadata,
      _ref$RowComponent = _ref.RowComponent,
      RowComponent = _ref$RowComponent === void 0 ? SavedSearchRow$1 : _ref$RowComponent,
      _ref$RowProps = _ref.RowProps,
      RowProps = _ref$RowProps === void 0 ? {} : _ref$RowProps,
      props = _objectWithoutProperties(_ref, ["searchProps", "searchPlaceholderText", "onSelect", "onDelete", "onUpdateSearchMetadata", "RowComponent", "RowProps"]);

  return /*#__PURE__*/React__default.createElement(CollectionSearchPicker$1, _extends({
    searchProps: searchProps,
    searchPlaceholder: searchPlaceholderText,
    CollectionTableComponent: function CollectionTableComponent(_ref2) {
      var collectionListType = _ref2.collectionListType,
          onRefresh = _ref2.onRefresh;
      return /*#__PURE__*/React__default.createElement(List$1, null, collectionListType && collectionListType.collection && collectionListType.collection.map(function (collectionType) {
        return /*#__PURE__*/React__default.createElement(RowComponent, _extends({
          key: collectionType.id,
          collectionType: collectionType,
          onSelect: function onSelect() {
            return _onSelect({
              collectionId: collectionType.id
            });
          },
          onDelete: function onDelete() {
            return Promise.resolve(_onDelete({
              collectionId: collectionType.id
            }).then(onRefresh));
          },
          onUpdateSearchMetadata: function onUpdateSearchMetadata(metadataDocument) {
            return Promise.resolve(_onUpdateSearchMetadata({
              collectionId: collectionType.id,
              metadataDocument: metadataDocument
            }).then(onRefresh));
          } // eslint-disable-next-line react/jsx-props-no-spreading

        }, RowProps));
      }));
    },
    PaginationProps: {
      rowsPerPageOptions: [5, 10]
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

var SavedSearchList$1 = withStyles(styles$1i, {
  name: 'VdtSavedSearchList'
})(SavedSearchList);

var styles$1j = function styles(theme) {
  return {
    root: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },
    TextField: {},
    Button: {
      borderRadius: 0
    }
  };
};

function SaveSearchForm(_ref) {
  var classes = _ref.classes,
      itemSearchDocument = _ref.itemSearchDocument,
      onSaveSearch = _ref.onSaveSearch,
      _ref$onSuccess = _ref.onSuccess,
      onSuccess = _ref$onSuccess === void 0 ? function () {} : _ref$onSuccess,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? function () {} : _ref$onError,
      _ref$nameText = _ref.nameText,
      nameText = _ref$nameText === void 0 ? 'New Saved Search' : _ref$nameText,
      _ref$saveText = _ref.saveText,
      saveText = _ref$saveText === void 0 ? 'Save' : _ref$saveText;

  var _React$useState = React__default.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      saveSearchName = _React$useState2[0],
      setSaveSearchName = _React$useState2[1];

  var onSubmit = function onSubmit(e) {
    e.preventDefault();

    if (!saveSearchName) {
      onError('No Name specified');
      return;
    }

    onSaveSearch({
      metadata: {
        title: saveSearchName.trim()
      },
      itemSearchDocument: itemSearchDocument
    }).then(onSuccess)["catch"](onError);
  };

  return /*#__PURE__*/React__default.createElement("form", {
    className: classes.root,
    onSubmit: onSubmit
  }, /*#__PURE__*/React__default.createElement(InputBase$1, {
    className: classes.TextField,
    onChange: function onChange(e) {
      return setSaveSearchName(e.target.value);
    },
    fullWidth: true,
    placeholder: nameText
  }), /*#__PURE__*/React__default.createElement(Button$1, {
    className: classes.Button,
    disabled: !saveSearchName || saveSearchName.trim() === '',
    fullWidth: true,
    color: "primary",
    variant: "contained",
    disableElevation: true,
    type: "submit"
  }, saveText));
}

var SaveSearchForm$1 = withStyles(styles$1j, {
  name: 'VdtSaveSearchForm'
})(SaveSearchForm);

var styles$1k = function styles(theme) {
  return {
    root: {
      padding: theme.spacing(2)
    }
  };
};

function SavedSearch(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      markerField = _ref.markerField,
      markerValue = _ref.markerValue,
      itemSearchDocument = _ref.itemSearchDocument,
      onSelect = _ref.onSelect,
      _ref$onSaveSuccess = _ref.onSaveSuccess,
      onSaveSuccess = _ref$onSaveSuccess === void 0 ? function () {} : _ref$onSaveSuccess,
      _ref$onSaveError = _ref.onSaveError,
      onSaveError = _ref$onSaveError === void 0 ? function () {} : _ref$onSaveError,
      _ref$SearchListCompon = _ref.SearchListComponent,
      SearchListComponent = _ref$SearchListCompon === void 0 ? SavedSearchList$1 : _ref$SearchListCompon,
      _ref$SearchListProps = _ref.SearchListProps,
      SearchListProps = _ref$SearchListProps === void 0 ? {} : _ref$SearchListProps,
      _ref$SearchFormCompon = _ref.SearchFormComponent,
      SearchFormComponent = _ref$SearchFormCompon === void 0 ? SaveSearchForm$1 : _ref$SearchFormCompon,
      _ref$SearchFormProps = _ref.SearchFormProps,
      SearchFormProps = _ref$SearchFormProps === void 0 ? {} : _ref$SearchFormProps;

  var _useSavedSearch = useSavedSearch({
    markerField: markerField,
    markerValue: markerValue,
    initialSearchState: {
      rowsPerPage: 5
    }
  }),
      onDeleteSearch = _useSavedSearch.onDeleteSearch,
      onUpdateSearchMetadata = _useSavedSearch.onUpdateSearchMetadata,
      onGetSavedSearchSettings = _useSavedSearch.onGetSavedSearchSettings,
      onSaveSearch = _useSavedSearch.onSaveSearch,
      searchProps = _useSavedSearch.searchProps;

  var handleSelect = function handleSelect(_ref2) {
    var collectionId = _ref2.collectionId;
    return onGetSavedSearchSettings({
      collectionId: collectionId
    }).then(function (response) {
      return onSelect(response, collectionId);
    });
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtSavedSearch-root', className)
  }, SearchFormComponent && /*#__PURE__*/React__default.createElement(SearchFormComponent, _extends({
    itemSearchDocument: itemSearchDocument,
    onSuccess: onSaveSuccess,
    onError: onSaveError,
    onSaveSearch: onSaveSearch // eslint-disable-next-line react/jsx-props-no-spreading

  }, SearchFormProps)), SearchListComponent && /*#__PURE__*/React__default.createElement(SearchListComponent, _extends({
    onSelect: handleSelect,
    onDelete: onDeleteSearch,
    onUpdateSearchMetadata: onUpdateSearchMetadata,
    searchProps: searchProps // eslint-disable-next-line react/jsx-props-no-spreading

  }, SearchListProps)));
}

var SavedSearch$1 = withStyles(styles$1k, {
  name: 'VdtSavedSearchList'
})(SavedSearch);

var styles$1l = function styles(theme) {
  return {
    suggestion: {
      '&:hover': {
        textFillColor: theme.palette.text.primary,
        textStrokeColor: theme.palette.text.primary,
        textStrokeWidth: 0.5
      },
      userSelect: 'text'
    },
    suggested: {
      fontStyle: 'italic'
    },
    suggestionButton: {
      '&:hover': {
        backgroundColor: 'transparent'
      },
      paddingTop: 0,
      paddingBottom: 0
    },
    didYouMean: {
      color: theme.palette.secondary.main
    }
  };
};

var cartesian = function cartesian() {
  for (var _len = arguments.length, arrs = new Array(_len), _key = 0; _key < _len; _key++) {
    arrs[_key] = arguments[_key];
  }

  return arrs.length === 1 ? arrs[0].map(function (a) {
    return [a];
  }) : arrs.reduce(function (a, b) {
    return a.flatMap(function (c) {
      return b.map(function (d) {
        return [c, d].flat();
      });
    });
  });
};

var termsRegex = function termsRegex(suggestions) {
  return new RegExp(suggestions.map(function (_ref) {
    var term = _ref.term;
    return "(".concat(term, ")");
  }).join('|'));
};

function replaceWithSuggestions(searchText, suggestions) {
  return searchText.split(termsRegex(suggestions)).filter(function (term) {
    return term && term.length > 0;
  }).map(function (term) {
    var matchingSuggestion = suggestions.find(function (s) {
      return s.term === term;
    });
    return matchingSuggestion ? {
      term: matchingSuggestion.suggestion,
      replaced: true
    } : {
      term: term,
      replaced: false
    };
  }).filter(function (_ref2) {
    var term = _ref2.term;
    return term !== searchText;
  });
}

function getSuggestions(searchText, suggestions, maxSuggestions) {
  var suggestionCombinations = cartesian.apply(void 0, _toConsumableArray(suggestions.map(function (_ref3) {
    var term = _ref3.term,
        suggestion = _ref3.suggestion;
    return suggestion.map(function (s) {
      return {
        term: term,
        suggestion: s
      };
    });
  }))).slice(0, maxSuggestions);
  return suggestionCombinations.map(function (suggestionsCombination) {
    return replaceWithSuggestions(searchText, suggestionsCombination);
  }).filter(function (suggestion) {
    return suggestion.length > 0;
  });
}

function SpellCheck(_ref4) {
  var className = _ref4.className,
      classes = _ref4.classes,
      searchText = _ref4.searchText,
      suggestions = _ref4.suggestions,
      _onClick = _ref4.onClick,
      maxSuggestions = _ref4.maxSuggestions,
      _ref4$didYouMeanText = _ref4.didYouMeanText,
      didYouMeanText = _ref4$didYouMeanText === void 0 ? 'Did you mean' : _ref4$didYouMeanText;
  if (!(suggestions && suggestions.length > 0) || !searchText) return null;
  var displayedSuggestions = getSuggestions(searchText, suggestions, maxSuggestions);
  if (displayedSuggestions.length === 0) return null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(className, classes.root, 'VdtSpellCheck-root')
  }, /*#__PURE__*/React__default.createElement(Typography, {
    classes: {
      root: classes.didYouMean
    },
    display: "inline"
  }, "".concat(didYouMeanText, ":")), displayedSuggestions.map(function (suggestionTerms, i) {
    return /*#__PURE__*/React__default.createElement(Button$1 // eslint-disable-next-line react/no-array-index-key
    , {
      key: "".concat(i, "-root"),
      disableRipple: true,
      classes: {
        root: classes.suggestionButton,
        label: classes.suggestion
      },
      onClick: function onClick() {
        return _onClick(suggestionTerms.map(function (_ref5) {
          var term = _ref5.term;
          return term;
        }).join(''));
      }
    }, suggestionTerms.map(function (_ref6) {
      var replaced = _ref6.replaced,
          term = _ref6.term;
      return /*#__PURE__*/React__default.createElement("span", {
        key: term
      }, replaced ? /*#__PURE__*/React__default.createElement("span", {
        className: clsx(classes.suggested, 'VdtSpellCheck-suggested')
      }, term) : term, "\xA0");
    }));
  }));
}

var SpellCheck$1 = withStyles(styles$1l, {
  name: 'VdtSpellCheck'
})(SpellCheck);

var styles$1m = function styles() {
  return {
    root: {
      '& .MuiFormHelperText-root': {
        display: 'none'
      },
      '& .MuiInputLabel-root': {
        display: 'none'
      },
      '& .MuiInputBase-root': {
        marginTop: '0px'
      },
      marginTop: '0px'
    }
  };
}; // Make sure input click is captured

var onClick = function onClick(e) {
  return e.stopPropagation();
}; // HOC to delay input updates until the input is blured to prevent too frequent renders


function withUpdateOnBlur(InputComponent) {
  return function (_ref) {
    var value = _ref.value,
        onChange = _ref.onChange,
        props = _objectWithoutProperties(_ref, ["value", "onChange"]);

    var _React$useState = React__default.useState(value),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        localValue = _React$useState2[0],
        setLocalValue = _React$useState2[1];

    React__default.useEffect(function () {
      return setLocalValue(value);
    }, [value]);

    var emitChange = function emitChange() {
      if (value !== localValue) {
        onChange({
          target: {
            value: localValue
          }
        });
      }
    };

    return /*#__PURE__*/React__default.createElement(InputComponent, _extends({
      value: localValue,
      onChange: function onChange(e) {
        return setLocalValue(e.target.value);
      },
      onBlur: emitChange,
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') {
          emitChange();
        }
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, props));
  };
}

var QueryBuilderTextField = withUpdateOnBlur(TextField$1);

var QueryBuilderCounterField = function QueryBuilderCounterField(_ref2) {
  var props = _extends({}, _ref2);

  return /*#__PURE__*/React__default.createElement(TextField$1, _extends({
    type: "number"
  }, props));
};

function QueryInput(_ref3) {
  var displayType = _ref3.displayType,
      type = _ref3.type,
      props = _objectWithoutProperties(_ref3, ["displayType", "type"]);

  var QueryInputComponent;

  if (displayType === 'select') {
    QueryInputComponent = SelectField$1;
  } else {
    switch (type) {
      case 'date':
        QueryInputComponent = DateField$1;
        break;

      case 'boolean':
        QueryInputComponent = CheckboxField$1;
        break;

      case 'integer':
      case 'long':
      case 'float':
        QueryInputComponent = QueryBuilderCounterField;
        break;

      default:
        QueryInputComponent = QueryBuilderTextField;
        break;
    }
  }

  return /*#__PURE__*/React__default.createElement(QueryInputComponent, _extends({
    onClick: onClick
  }, props));
}
QueryInput.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  displayType: propTypes.oneOf(['select']),
  type: propTypes.oneOf(['string', 'date', 'boolean', 'integer', 'long', 'float'])
};
QueryInput.defaultProps = {
  className: undefined,
  classes: {},
  displayType: undefined,
  type: undefined
};

var QueryInput$1 = withStyles(styles$1m, {
  name: 'VdtQueryInput'
})(QueryInput);

var styles$1n = function styles(theme) {
  return {
    root: {
      width: '50%'
    },
    and: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5)
    },
    input: {}
  };
};
function QueryBetween(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      field = _ref.field,
      _onChange = _ref.onChange,
      InputComponent = _ref.InputComponent,
      props = _objectWithoutProperties(_ref, ["classes", "className", "field", "onChange", "InputComponent"]);

  var betweenField = function betweenField(min, max) {
    return {
      name: field.name,
      range: [{
        value: [{
          value: min
        }, {
          value: max
        }]
      }]
    };
  };

  var min = get$1(field, 'range.0.value.0.value', '');
  var max = get$1(field, 'range.0.value.1.value', '');
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(InputComponent, _extends({
    className: classes.input,
    value: min,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return _onChange(betweenField(value, max));
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)), /*#__PURE__*/React__default.createElement(InputComponent, _extends({
    className: classes.input,
    value: max,
    onChange: function onChange(_ref3) {
      var value = _ref3.target.value;
      return _onChange(betweenField(min, value));
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)));
}
QueryBetween.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * Override the InputComponent.
   */
  InputComponent: propTypes.elementType,

  /**
   * Input change function.
   */
  onChange: propTypes.func.isRequired,

  /**
   * Search Field with name and value/range.
   */
  field: index.SearchFieldType.isRequired
};
QueryBetween.defaultProps = {
  className: undefined,
  classes: {},
  InputComponent: QueryInput$1
};

var QueryBetween$1 = withStyles(styles$1n, {
  name: 'VdtQueryBetween'
})(QueryBetween);

var styles$1o = function styles() {
  return {
    root: {}
  };
};
function QueryEquals(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      field = _ref.field,
      _onChange = _ref.onChange,
      InputComponent = _ref.InputComponent,
      props = _objectWithoutProperties(_ref, ["classes", "className", "field", "onChange", "InputComponent"]);

  var equalsField = function equalsField(value) {
    return {
      name: field.name,
      value: [{
        value: value
      }]
    };
  };

  var value = get$1(field, 'value.0.value', '');
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(InputComponent, _extends({
    value: value,
    onChange: function onChange(e) {
      return _onChange(equalsField(e.target.value));
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)));
}
QueryEquals.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * Override the InputComponent.
   */
  InputComponent: propTypes.elementType,

  /**
   * Input change function.
   */
  onChange: propTypes.func.isRequired,

  /**
   * Search Field with name and value/range.
   */
  field: index.SearchFieldType.isRequired
};
QueryEquals.defaultProps = {
  className: undefined,
  classes: {},
  InputComponent: QueryInput$1
};

var QueryEquals$1 = withStyles(styles$1o, {
  name: 'VdtQueryEquals'
})(QueryEquals);

var styles$1p = function styles() {
  return {
    root: {}
  };
};
function QueryContains(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      field = _ref.field,
      _onChange = _ref.onChange,
      InputComponent = _ref.InputComponent,
      props = _objectWithoutProperties(_ref, ["classes", "className", "field", "onChange", "InputComponent"]);

  var equalsField = function equalsField(value) {
    return {
      name: field.name,
      value: [{
        value: "*".concat(value, "*")
      }]
    };
  };

  var value = get$1(field, 'value.0.value', '');
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(InputComponent, _extends({
    value: value.replaceAll('*', ''),
    onChange: function onChange(e) {
      return _onChange(equalsField(e.target.value));
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)));
}
QueryContains.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * Override the InputComponent.
   */
  InputComponent: propTypes.elementType,

  /**
   * Input change function.
   */
  onChange: propTypes.func.isRequired,

  /**
   * Search Field with name and value/range.
   */
  field: index.SearchFieldType.isRequired
};
QueryContains.defaultProps = {
  className: undefined,
  classes: {},
  InputComponent: QueryInput$1
};

var QueryContains$1 = withStyles(styles$1p, {
  name: 'VdtQueryContains'
})(QueryContains);

var defaultPredicates = {
  equals: {
    label: 'Equals',
    component: QueryEquals$1,
    props: {},
    shape: function shape(name) {
      return {
        name: name,
        value: [{
          value: ''
        }]
      };
    }
  },
  contains: {
    label: 'Contains',
    component: QueryContains$1,
    props: {},
    shape: function shape(name) {
      return {
        name: name,
        value: [{
          value: ''
        }]
      };
    }
  },
  between: {
    label: 'Between',
    component: QueryBetween$1,
    props: {},
    shape: function shape(name) {
      return {
        name: name,
        range: [{
          value: [{
            value: ''
          }, {
            value: ''
          }]
        }]
      };
    }
  }
};

var defaultGetPredicateOptions = function defaultGetPredicateOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      type = _ref.type;

  switch (type) {
    case 'boolean':
      return [defaultPredicates.equals];

    case 'date':
    case 'integer':
    case 'long':
    case 'float':
      return [defaultPredicates.equals, defaultPredicates.between];

    default:
      return [defaultPredicates.equals, defaultPredicates.contains];
  }
};

function PredicatePicker(_ref2) {
  var value = _ref2.value,
      options = _ref2.options,
      _onChange = _ref2.onChange,
      props = _objectWithoutProperties(_ref2, ["value", "options", "onChange"]);

  return /*#__PURE__*/React__default.createElement(Select, _extends({
    value: value,
    onChange: function onChange(e) {
      return _onChange(options.find(function (o) {
        return o.label === e.target.value;
      }));
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, props), options.map(function (o) {
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      key: o.label,
      value: o.label
    }, o.label);
  }));
}

var styles$1q = function styles(theme) {
  return {
    root: {
      '& > *': {
        marginRight: '15px'
      }
    },
    errorButton: {
      color: theme.palette.error.light
    },
    successButton: {
      color: theme.palette.success.light
    },
    fieldPicker: {
      width: '250px'
    },
    predicatePicker: {
      width: '100px'
    }
  };
};
function QueryField(_ref3) {
  var classes = _ref3.classes,
      className = _ref3.className,
      field = _ref3.field,
      fields = _ref3.fields,
      getFieldLabel = _ref3.getFieldLabel,
      getFieldName = _ref3.getFieldName,
      InputComponent = _ref3.InputComponent,
      not = _ref3.not,
      onRemove = _ref3.onRemove,
      _onChange2 = _ref3.onChange,
      setNot = _ref3.setNot,
      PredicatePickerComponent = _ref3.PredicatePickerComponent,
      PredicatePickerProps = _ref3.PredicatePickerProps,
      getPredicateOptions = _ref3.getPredicateOptions,
      NotIcon = _ref3.NotIcon,
      OkIcon = _ref3.OkIcon,
      RemoveIcon = _ref3.RemoveIcon,
      includeText = _ref3.includeText,
      excludeText = _ref3.excludeText,
      removeText = _ref3.removeText;
  var selectedField = fields.find(function (f) {
    return getFieldName(f) === getFieldName(field);
  });
  var predicateOptions = getPredicateOptions(selectedField);

  var _React$useState = React__default.useState(predicateOptions ? predicateOptions[0] : {}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentPredicate = _React$useState2[0],
      setCurrentPredicate = _React$useState2[1];

  var predicate = currentPredicate.label,
      PredicateComponent = currentPredicate.component,
      _currentPredicate$pro = currentPredicate.props,
      PredicateProps = _currentPredicate$pro === void 0 ? {} : _currentPredicate$pro;

  var getValidNewPredicate = function getValidNewPredicate(f) {
    var newOptions = getPredicateOptions(f);
    setCurrentPredicate(newOptions ? newOptions[0] : {});
    return newOptions.find(function (o) {
      return o.label === predicate;
    }) || newOptions[0];
  };

  var handleToggleNot = function handleToggleNot() {
    return setNot(!not);
  };

  var onChangePredicate = function onChangePredicate(newPredicate) {
    var newShape = newPredicate.shape(getFieldName(field));

    _onChange2(newShape);

    setCurrentPredicate(newPredicate);
  };

  return /*#__PURE__*/React__default.createElement(ListItem$1, {
    ContainerComponent: "div",
    component: "div",
    className: clsx(className, classes.root, 'VdtQueryField-root'),
    alignItems: "flex-start"
  }, /*#__PURE__*/React__default.createElement(ListItemAvatar$1, null, setNot && /*#__PURE__*/React__default.createElement(Button$1, {
    className: not ? classes.errorButton : classes.successButton,
    startIcon: not ? /*#__PURE__*/React__default.createElement(NotIcon, null) : /*#__PURE__*/React__default.createElement(OkIcon, null),
    edge: "end",
    onClick: handleToggleNot,
    size: "small"
  }, not ? excludeText : includeText)), /*#__PURE__*/React__default.createElement(Autocomplete, {
    onChange: function onChange(_, f) {
      return _onChange2(getValidNewPredicate(f).shape(getFieldName(f)));
    },
    value: fields.find(function (f) {
      return getFieldName(field) === getFieldName(f);
    }),
    disableClearable: true,
    options: fields,
    getOptionLabel: getFieldLabel,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$2, _extends({
        onClick: function onClick(e) {
          return e.stopPropagation();
        } // eslint-disable-next-line react/jsx-props-no-spreading

      }, params));
    },
    classes: {
      root: classes.fieldPicker
    }
  }), /*#__PURE__*/React__default.createElement(PredicatePickerComponent, _extends({
    value: predicate,
    options: predicateOptions,
    onChange: onChangePredicate,
    classes: {
      root: classes.predicatePicker
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, PredicatePickerProps)), /*#__PURE__*/React__default.createElement(PredicateComponent, _extends({
    field: field,
    onChange: _onChange2,
    InputComponent: InputComponent // eslint-disable-next-line react/jsx-props-no-spreading

  }, selectedField, PredicateProps)), onRemove && /*#__PURE__*/React__default.createElement(Button$1, {
    edge: "end",
    onClick: onRemove,
    startIcon: /*#__PURE__*/React__default.createElement(RemoveIcon, null),
    size: "small"
  }, removeText));
}
QueryField.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  PredicatePickerComponent: propTypes.elementType,
  PredicatePickerProps: propTypes.objectOf(propTypes.any),
  getPredicateOptions: propTypes.func,
  NotIcon: propTypes.elementType,
  OkIcon: propTypes.elementType,
  RemoveIcon: propTypes.elementType,
  includeText: propTypes.string,
  excludeText: propTypes.string,
  removeText: propTypes.string,
  InputComponent: propTypes.elementType,

  /**
   * Search Field with name and value/range.
   */
  field: index.SearchFieldType.isRequired,
  onRemove: propTypes.func,
  onChange: propTypes.func.isRequired,
  fields: propTypes.arrayOf(propTypes.any),
  getFieldLabel: propTypes.func,
  getFieldName: propTypes.func,
  not: propTypes.bool,
  setNot: propTypes.func
};
QueryField.defaultProps = {
  className: undefined,
  classes: {},
  PredicatePickerComponent: PredicatePicker,
  PredicatePickerProps: {},
  getPredicateOptions: defaultGetPredicateOptions,
  NotIcon: function NotIcon() {
    return null;
  },
  OkIcon: function OkIcon() {
    return null;
  },
  RemoveIcon: DeleteIcon,
  includeText: 'Include',
  excludeText: 'Exclude',
  removeText: 'Remove',
  onRemove: undefined,
  fields: [],
  InputComponent: undefined,
  not: false,
  setNot: undefined,
  getFieldLabel: function getFieldLabel(f) {
    return f.label;
  },
  getFieldName: function getFieldName(f) {
    return f.name;
  }
};

var QueryField$1 = withStyles(styles$1q, {
  name: 'VdtQueryField'
})(QueryField);

var stopProp = function stopProp(f) {
  return function (e) {
    e.stopPropagation();
    f(e.target.value);
  };
};

var styles$1r = function styles(theme) {
  return {
    root: {},
    errorButton: {
      color: theme.palette.error.light
    },
    successButton: {
      color: theme.palette.success.light
    },
    groupSelect: {
      width: '20%',
      marginLeft: theme.spacing(2)
    }
  };
};
function QueryGroup(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      group = _ref.group,
      groups = _ref.groups,
      onAddEntry = _ref.onAddEntry,
      onRemove = _ref.onRemove,
      onChange = _ref.onChange,
      setNot = _ref.setNot,
      not = _ref.not,
      defaultField = _ref.defaultField,
      defaultGroup = _ref.defaultGroup,
      getGroupName = _ref.getGroupName,
      getGroupLabel = _ref.getGroupLabel,
      fieldText = _ref.fieldText,
      groupText = _ref.groupText,
      includeText = _ref.includeText,
      excludeText = _ref.excludeText,
      removeText = _ref.removeText,
      addText = _ref.addText,
      NotIcon = _ref.NotIcon,
      OkIcon = _ref.OkIcon,
      RemoveIcon = _ref.RemoveIcon;
  var handleAddField = stopProp(function () {
    return onAddEntry({
      name: defaultField,
      value: [{
        value: ''
      }]
    });
  });
  var handleAddGroup = stopProp(function () {
    return onAddEntry({
      name: defaultGroup,
      entry: []
    });
  });
  var handleToggleNot = stopProp(function () {
    return setNot(!not);
  });

  var handleChangeGroup = function handleChangeGroup(g) {
    onChange({
      name: getGroupName(g),
      entry: []
    });
  };

  return /*#__PURE__*/React__default.createElement(ListItem$1, {
    ContainerComponent: "div",
    className: clsx(className, classes.root, 'VdtQueryOperator-root')
  }, /*#__PURE__*/React__default.createElement(ListItemAvatar$1, null, /*#__PURE__*/React__default.createElement("div", null, setNot && /*#__PURE__*/React__default.createElement(Button$1, {
    className: not ? classes.errorButton : classes.successButton,
    startIcon: not ? /*#__PURE__*/React__default.createElement(NotIcon, null) : /*#__PURE__*/React__default.createElement(OkIcon, null),
    edge: "end",
    onClick: handleToggleNot,
    size: "small"
  }, not ? excludeText : includeText))), /*#__PURE__*/React__default.createElement(Autocomplete, {
    className: classes.groupSelect,
    onChange: function onChange(_, g) {
      return handleChangeGroup(g);
    },
    value: groups.find(function (g) {
      return getGroupName(group) === getGroupName(g);
    }),
    disableClearable: true,
    options: groups,
    getOptionLabel: getGroupLabel,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$2, _extends({
        onClick: function onClick(e) {
          return e.stopPropagation();
        } // eslint-disable-next-line react/jsx-props-no-spreading

      }, params));
    },
    classes: {
      root: classes.fieldPicker
    }
  }), /*#__PURE__*/React__default.createElement(ListItemSecondaryAction$1, null, /*#__PURE__*/React__default.createElement(ButtonGroup, {
    variant: "outlined",
    size: "small"
  }, defaultField && /*#__PURE__*/React__default.createElement(Button$1, {
    className: "VdtQueryOperator-addFieldBtn",
    onClick: handleAddField
  }, "".concat(addText, " ").concat(fieldText)), defaultGroup && /*#__PURE__*/React__default.createElement(Button$1, {
    className: "VdtQueryOperator-addGroupBtn",
    onClick: handleAddGroup
  }, "".concat(addText, " ").concat(groupText)), onRemove && /*#__PURE__*/React__default.createElement(Button$1, {
    edge: "end",
    onClick: onRemove,
    startIcon: /*#__PURE__*/React__default.createElement(RemoveIcon, null),
    size: "small"
  }, removeText))));
}
QueryGroup.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  NotIcon: propTypes.elementType,
  OkIcon: propTypes.elementType,
  RemoveIcon: propTypes.elementType,
  includeText: propTypes.string,
  excludeText: propTypes.string,
  removeText: propTypes.string,
  addText: propTypes.string,
  fieldText: propTypes.string,
  groupText: propTypes.string,
  group: propTypes.shape({
    name: propTypes.string,
    entry: propTypes.arrayOf(propTypes.any)
  }).isRequired,
  groups: propTypes.arrayOf(propTypes.any),
  onAddEntry: propTypes.func.isRequired,
  onRemove: propTypes.func,
  onChange: propTypes.func.isRequired,
  not: propTypes.bool,
  setNot: propTypes.func,
  defaultField: propTypes.string,
  defaultGroup: propTypes.string,
  getGroupName: propTypes.func,
  getGroupLabel: propTypes.func
};
QueryGroup.defaultProps = {
  className: undefined,
  classes: {},
  NotIcon: function NotIcon() {
    return null;
  },
  OkIcon: function OkIcon() {
    return null;
  },
  RemoveIcon: DeleteIcon,
  includeText: 'Include',
  excludeText: 'Exclude',
  removeText: 'Remove',
  addText: 'Add',
  fieldText: 'Field',
  groupText: 'Group',
  onRemove: undefined,
  groups: [],
  defaultField: undefined,
  defaultGroup: undefined,
  not: false,
  setNot: undefined,
  getGroupLabel: function getGroupLabel(g) {
    return g.label;
  },
  getGroupName: function getGroupName(g) {
    return g.name;
  }
};

var QueryGroup$1 = withStyles(styles$1r, {
  name: 'VdtQueryGroup'
})(QueryGroup);

var stopProp$1 = function stopProp(f) {
  return function (e) {
    e.stopPropagation();
    f(e.target.value);
  };
};

var styles$1s = function styles(theme) {
  return {
    root: {},
    errorButton: {
      color: theme.palette.error.light
    },
    successButton: {
      color: theme.palette.success.light
    }
  };
};
function QueryOperator(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      operator = _ref.operator,
      onAddEntry = _ref.onAddEntry,
      onRemove = _ref.onRemove,
      onChangeOperation = _ref.onChangeOperation,
      setNot = _ref.setNot,
      not = _ref.not,
      defaultField = _ref.defaultField,
      defaultGroup = _ref.defaultGroup,
      operatorText = _ref.operatorText,
      fieldText = _ref.fieldText,
      groupText = _ref.groupText,
      includeText = _ref.includeText,
      excludeText = _ref.excludeText,
      removeText = _ref.removeText,
      andText = _ref.andText,
      orText = _ref.orText,
      addText = _ref.addText,
      _ref$NotIcon = _ref.NotIcon,
      NotIcon = _ref$NotIcon === void 0 ? BlockIcon : _ref$NotIcon,
      _ref$OkIcon = _ref.OkIcon,
      OkIcon = _ref$OkIcon === void 0 ? CheckIcon : _ref$OkIcon,
      _ref$RemoveIcon = _ref.RemoveIcon,
      RemoveIcon = _ref$RemoveIcon === void 0 ? DeleteIcon : _ref$RemoveIcon,
      _ref$AndIcon = _ref.AndIcon,
      AndIcon = _ref$AndIcon === void 0 ? CallMergeIcon : _ref$AndIcon,
      _ref$OrIcon = _ref.OrIcon,
      OrIcon = _ref$OrIcon === void 0 ? CallSplitIcon : _ref$OrIcon;
  var operation = operator.operation;
  var handleAddField = stopProp$1(function () {
    return onAddEntry({
      name: defaultField,
      value: [{
        value: ''
      }]
    });
  });
  var handleAddGroup = stopProp$1(function () {
    return onAddEntry({
      name: defaultGroup,
      entry: []
    });
  });
  var handleAddOperator = stopProp$1(function () {
    return onAddEntry({
      operation: 'AND',
      entry: []
    });
  });
  var handleToggleNot = stopProp$1(function () {
    return setNot(!not);
  });
  var handleToggleOperation = stopProp$1(function () {
    onChangeOperation(operation === 'AND' ? 'OR' : 'AND');
  });
  return /*#__PURE__*/React__default.createElement(ListItem$1, {
    ContainerComponent: "div",
    className: clsx(className, classes.root, 'VdtQueryOperator-root')
  }, /*#__PURE__*/React__default.createElement(ListItemAvatar$1, null, /*#__PURE__*/React__default.createElement("div", null, onChangeOperation && /*#__PURE__*/React__default.createElement(Button$1, {
    className: operation === 'AND' ? classes.successButton : classes.errorButton,
    startIcon: operation === 'AND' ? /*#__PURE__*/React__default.createElement(AndIcon, null) : /*#__PURE__*/React__default.createElement(OrIcon, null),
    edge: "end",
    onClick: handleToggleOperation,
    size: "small"
  }, operation === 'AND' ? andText : orText), setNot && /*#__PURE__*/React__default.createElement(Button$1, {
    className: not ? classes.errorButton : classes.successButton,
    startIcon: not ? /*#__PURE__*/React__default.createElement(NotIcon, null) : /*#__PURE__*/React__default.createElement(OkIcon, null),
    edge: "end",
    onClick: handleToggleNot,
    size: "small"
  }, not ? excludeText : includeText))), /*#__PURE__*/React__default.createElement(ListItemSecondaryAction$1, null, /*#__PURE__*/React__default.createElement(ButtonGroup, {
    variant: "outlined",
    size: "small"
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    className: "VdtQueryOperator-addFieldBtn",
    onClick: handleAddField
  }, "".concat(addText, " ").concat(fieldText)), defaultGroup && /*#__PURE__*/React__default.createElement(Button$1, {
    className: "VdtQueryOperator-addGroupBtn",
    onClick: handleAddGroup
  }, "".concat(addText, " ").concat(groupText)), /*#__PURE__*/React__default.createElement(Button$1, {
    className: "VdtQueryOperator-addOperatorBtn",
    onClick: handleAddOperator
  }, "".concat(addText, " ").concat(operatorText)), onRemove && /*#__PURE__*/React__default.createElement(Button$1, {
    edge: "end",
    onClick: onRemove,
    startIcon: /*#__PURE__*/React__default.createElement(RemoveIcon, null),
    size: "small"
  }, removeText))));
}
QueryOperator.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  operatorText: propTypes.string,
  includeText: propTypes.string,
  excludeText: propTypes.string,
  removeText: propTypes.string,
  addText: propTypes.string,
  andText: propTypes.string,
  orText: propTypes.string,
  fieldText: propTypes.string,
  groupText: propTypes.string,
  NotIcon: propTypes.elementType,
  OkIcon: propTypes.elementType,
  RemoveIcon: propTypes.elementType,
  AndIcon: propTypes.elementType,
  OrIcon: propTypes.elementType,
  defaultField: propTypes.string,
  defaultGroup: propTypes.string,
  not: propTypes.bool,
  setNot: propTypes.func,
  onAddEntry: propTypes.func.isRequired,
  onRemove: propTypes.func,
  onChangeOperation: propTypes.func,
  operator: propTypes.shape({
    operation: index.SearchOperationType,
    entry: propTypes.arrayOf(propTypes.any)
  }).isRequired
};
QueryOperator.defaultProps = {
  className: undefined,
  classes: {},
  operatorText: 'Operator',
  includeText: 'Include',
  excludeText: 'Exclude',
  removeText: 'Remove',
  addText: 'Add',
  andText: 'And',
  orText: 'Or',
  fieldText: 'Field',
  groupText: 'Group',
  NotIcon: function NotIcon() {
    return null;
  },
  OkIcon: function OkIcon() {
    return null;
  },
  RemoveIcon: DeleteIcon,
  AndIcon: function AndIcon() {
    return null;
  },
  OrIcon: function OrIcon() {
    return null;
  },
  defaultField: undefined,
  defaultGroup: undefined,
  onRemove: undefined,
  not: false,
  setNot: undefined,
  onChangeOperation: undefined
};

var QueryOperator$1 = withStyles(styles$1s, {
  name: 'VdtQueryOperator'
})(QueryOperator);

var QueryBuilderContext = /*#__PURE__*/React__default.createContext(undefined);
var QueryBuilderContextProvider = function QueryBuilderContextProvider(_ref) {
  var query = _ref.query,
      onChange = _ref.onChange,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement(QueryBuilderContext.Provider, {
    value: {
      query: query,
      onChange: onChange
    }
  }, children);
};
var useQueryBuilder = function useQueryBuilder(path) {
  var context = React__default.useContext(QueryBuilderContext);

  if (context === undefined) {
    throw new Error('useQueryBuilder must be used within a QueryBuilderContextProvider');
  }

  var query = context.query,
      onChange = context.onChange;
  var updateTreeWith = React__default.useCallback(function (newPath, f) {
    onChange(updateWith(cloneDeep(query), newPath, f));
  }, [onChange, query]);
  var updateTree = React__default.useCallback(function (newPath, value) {
    return updateTreeWith(newPath, constant(value));
  }, [updateTreeWith]);
  return {
    getEntry: function getEntry() {
      return get$1(query, path);
    },
    addEntry: function addEntry(entry) {
      updateTreeWith("".concat(path, ".entry"), function (curr) {
        return [entry].concat(_toConsumableArray(curr));
      });
    },
    removeEntry: function removeEntry() {
      var index = Number(path[path.length - 1]);
      updateTreeWith(path.substring(0, path.length - '.x'.length), function (c) {
        return c.filter(function (_, i) {
          return i !== index;
        });
      });
    },
    changeOperation: function changeOperation(operation) {
      return updateTree("".concat(path, ".operation"), operation);
    },
    changeEntry: function changeEntry(entry) {
      return updateTree(path, entry);
    },
    setNot: function setNot(not) {
      var entry = get$1(query, path);

      if (not) {
        updateTree(path, {
          operation: 'NOT',
          entry: [entry]
        });
      } else {
        updateTree(path.substring(0, path.length - '.entry.0'.length), entry);
      }
    }
  };
};

var styles$1t = function styles(theme) {
  return {
    root: {
      '&:focus > .MuiTreeItem-content .MuiTreeItem-label': {
        backgroundColor: 'transparent'
      },
      '&:hover > .MuiTreeItem-content .MuiTreeItem-label': {
        backgroundColor: 'transparent'
      },
      padding: '5px'
    },
    queryGroup: {
      position: 'relative',
      border: "1px solid ".concat(fade(theme.palette.text.primary, 0.05)),
      backgroundColor: fade(theme.palette.text.primary, 0.02),
      borderRadius: '4px',
      margin: '1rem 1rem 1rem 0',
      '& .MuiTreeItem-iconContainer': {
        position: 'absolute',
        left: '12px'
      }
    }
  };
};

function getEntryType(entry) {
  if (entry.operation) {
    return 'operator';
  }

  if (entry.value || entry.range) {
    return 'field';
  }

  return 'group';
}

function QueryEntry(_ref) {
  var canExpandpath = _ref.canExpandpath,
      path = _ref.path,
      fields = _ref.fields,
      groups = _ref.groups,
      defaultField = _ref.defaultField,
      defaultGroup = _ref.defaultGroup,
      not = _ref.not,
      nodeId = _ref.nodeId,
      canExpand = _ref.canExpand,
      parentGroup = _ref.parentGroup,
      props = _objectWithoutProperties(_ref, ["canExpandpath", "path", "fields", "groups", "defaultField", "defaultGroup", "not", "nodeId", "canExpand", "parentGroup"]);

  var expandNode = props.expandNode,
      OperatorComponent = props.OperatorComponent,
      OperatorProps = props.OperatorProps,
      FieldComponent = props.FieldComponent,
      FieldProps = props.FieldProps,
      GroupComponent = props.GroupComponent,
      GroupProps = props.GroupProps,
      getFieldLabel = props.getFieldLabel,
      getFieldName = props.getFieldName,
      getGroupLabel = props.getGroupLabel,
      getGroupName = props.getGroupName,
      getGroupFields = props.getGroupFields,
      getGroupGroups = props.getGroupGroups,
      classes = props.classes;

  var _useQueryBuilder = useQueryBuilder(path),
      getEntry = _useQueryBuilder.getEntry,
      addEntry = _useQueryBuilder.addEntry,
      removeEntry = _useQueryBuilder.removeEntry,
      changeOperation = _useQueryBuilder.changeOperation,
      changeEntry = _useQueryBuilder.changeEntry,
      setNot = _useQueryBuilder.setNot;

  var entry = getEntry(path);
  var entryType = getEntryType(entry);
  var currNodeId = nodeId || path;
  var initialField = defaultField || fields.length > 0 ? getFieldName(fields[0]) : undefined;
  var allowedFields = entryType === 'group' ? getGroupFields(groups.find(function (g) {
    return getGroupName(g) === getGroupName(entry);
  }) || {}) : fields;
  var allowedDefaultField = entryType === 'group' ? getFieldName(allowedFields[0]) : initialField;
  var subGroups = entryType === 'group' ? getGroupGroups(groups.find(function (g) {
    return getGroupName(g) === entry.name;
  }) || {}) : groups;
  var defaultSubGroup = subGroups && subGroups.length > 0 ? subGroups[0].name : undefined;
  var addEntryAndExpand = React__default.useCallback(function () {
    addEntry.apply(void 0, arguments);
    if (expandNode) expandNode(currNodeId);
  }, [addEntry, currNodeId, expandNode]);

  if (entry.operation && entry.operation === 'NOT') {
    return /*#__PURE__*/React__default.createElement(QueryEntry // nodeId is the path without the not-operators,
    // which ensures that tree nodes have the same id regardless if not is toggled
    , _extends({
      nodeId: currNodeId,
      path: "".concat(path, ".entry.0"),
      fields: allowedFields,
      defaultField: allowedDefaultField,
      groups: groups,
      parentGroup: entryType === 'group' ? entry.name : undefined,
      not: true // eslint-disable-next-line react/jsx-props-no-spreading

    }, props));
  }

  return /*#__PURE__*/React__default.createElement(TreeItem, {
    nodeId: currNodeId,
    className: clsx(entryType !== 'field' && classes.queryGroup, classes.root),
    expandIcon: canExpand ? /*#__PURE__*/React__default.createElement(ChevronRightIcon, null) : null,
    collapseIcon: canExpand ? /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null) : null,
    label: {
      operator: /*#__PURE__*/React__default.createElement(OperatorComponent, _extends({
        operator: entry,
        not: not,
        onAddEntry: addEntryAndExpand,
        onRemove: currNodeId !== 'operator' ? removeEntry : undefined,
        onChangeOperation: currNodeId !== 'operator' ? changeOperation : undefined,
        onChange: changeEntry,
        setNot: currNodeId !== 'operator' ? setNot : undefined,
        defaultField: allowedDefaultField,
        defaultGroup: groups && groups.length > 0 ? groups[0].name : undefined // eslint-disable-next-line react/jsx-props-no-spreading

      }, OperatorProps)),
      field: /*#__PURE__*/React__default.createElement(FieldComponent, _extends({
        field: entry,
        fields: allowedFields,
        getFieldLabel: getFieldLabel,
        getFieldName: getFieldName,
        not: not,
        onRemove: removeEntry,
        onChange: changeEntry,
        setNot: setNot // eslint-disable-next-line react/jsx-props-no-spreading

      }, FieldProps)),
      group: /*#__PURE__*/React__default.createElement(GroupComponent, _extends({
        group: entry,
        groups: groups,
        not: not,
        onAddEntry: addEntryAndExpand,
        onRemove: removeEntry,
        setNot: setNot,
        defaultField: allowedDefaultField,
        defaultGroup: defaultSubGroup,
        getGroupLabel: getGroupLabel,
        getGroupName: getGroupName,
        onChange: changeEntry // eslint-disable-next-line react/jsx-props-no-spreading

      }, GroupProps))
    }[entryType]
  }, entry.entry && entry.entry.map(function (e, i) {
    return /*#__PURE__*/React__default.createElement(QueryEntry // eslint-disable-next-line react/no-array-index-key
    , _extends({
      key: "".concat(path, ".entry.").concat(i),
      nodeId: "".concat(currNodeId, ".entry.").concat(i),
      path: "".concat(path, ".entry.").concat(i),
      fields: allowedFields,
      groups: subGroups,
      defaultField: allowedDefaultField,
      parentEntryType: entryType,
      parentGroup: entryType === 'group' ? entry.name : undefined // eslint-disable-next-line react/jsx-props-no-spreading

    }, props));
  }));
}
QueryEntry.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  OperatorComponent: propTypes.elementType,
  OperatorProps: propTypes.objectOf(propTypes.any),
  FieldComponent: propTypes.elementType,
  FieldProps: propTypes.objectOf(propTypes.any),
  GroupComponent: propTypes.elementType,
  GroupProps: propTypes.objectOf(propTypes.any),
  not: propTypes.bool,
  nodeId: propTypes.string,
  canExpand: propTypes.bool,
  getFieldLabel: propTypes.func,
  getFieldName: propTypes.func,
  getGroupLabel: propTypes.func,
  getGroupName: propTypes.func,
  getGroupFields: propTypes.func,
  getGroupGroups: propTypes.func,
  defaultField: propTypes.string,
  defaultGroup: propTypes.string,
  canExpandpath: propTypes.bool,
  path: propTypes.string,
  expandNode: propTypes.func,
  groups: propTypes.arrayOf(propTypes.any),
  fields: propTypes.arrayOf(propTypes.any),
  parentEntryType: propTypes.string,
  parentGroup: propTypes.string
};
QueryEntry.defaultProps = {
  className: undefined,
  classes: {},
  FieldComponent: QueryField$1,
  FieldProps: {},
  GroupComponent: QueryGroup$1,
  GroupProps: {},
  OperatorComponent: QueryOperator$1,
  OperatorProps: {},
  not: false,
  nodeId: undefined,
  canExpand: true,
  getFieldLabel: function getFieldLabel() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        label = _ref2.label;

    return label;
  },
  getFieldName: function getFieldName() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        name = _ref3.name;

    return name;
  },
  getGroupLabel: function getGroupLabel() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        label = _ref4.label;

    return label;
  },
  getGroupName: function getGroupName() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        name = _ref5.name;

    return name;
  },
  getGroupFields: function getGroupFields() {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref6$fields = _ref6.fields,
        fields = _ref6$fields === void 0 ? [] : _ref6$fields;

    return fields;
  },
  getGroupGroups: function getGroupGroups() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref7$groups = _ref7.groups,
        groups = _ref7$groups === void 0 ? [] : _ref7$groups;

    return groups;
  },
  defaultField: undefined,
  defaultGroup: undefined,
  canExpandpath: undefined,
  path: undefined,
  expandNode: undefined,
  groups: [],
  fields: [],
  parentEntryType: undefined,
  parentGroup: undefined
};

var QueryEntry$1 = withStyles(styles$1t, {
  name: 'VdtQueryEntry'
})(QueryEntry);

var styles$1u = function styles(theme) {
  return {
    root: {},
    treeRoot: {
      backgroundColor: theme.palette.background.paper,
      '& > .MuiTreeItem-root:first-child': {
        backgroundColor: 'transparent',
        margin: '0',
        border: 'none'
      }
    }
  };
};

var queryToItemSearchDocument = function queryToItemSearchDocument(query) {
  function toGroupOrOperator(entry) {
    var isOperator = entry.operation;

    var getEntryType = function getEntryType() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          operation = _ref.operation,
          value = _ref.value,
          range = _ref.range;

      if (operation) return 'operator';
      if (value || range) return 'field';
      return 'group';
    };

    return _objectSpread2(_objectSpread2({}, isOperator ? {
      operation: entry.operation,
      operator: entry.entry.filter(function (e) {
        return e.operation;
      }).map(function (e) {
        return toGroupOrOperator(e);
      })
    } : {
      name: entry.name
    }), {}, {
      field: entry.entry.filter(function (e) {
        return getEntryType(e) === 'field';
      }),
      group: entry.entry.filter(function (e) {
        return getEntryType(e) === 'group';
      }).map(function (e) {
        return toGroupOrOperator(e);
      })
    });
  }

  return query && query.operator && {
    operator: toGroupOrOperator(query.operator)
  };
};

var toQuery = function toQuery(isdOrQuery) {
  var toEntry = function toEntry() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        operation = _ref2.operation,
        name = _ref2.name,
        operator = _ref2.operator,
        field = _ref2.field,
        group = _ref2.group,
        entry = _ref2.entry;

    return _objectSpread2(_objectSpread2({}, operation ? {
      operation: operation
    } : {
      name: name
    }), {}, {
      entry: [].concat(_toConsumableArray((operator || []).map(function (o) {
        return toEntry(o);
      })), _toConsumableArray(field || []), _toConsumableArray((group || []).map(function (g) {
        return toEntry(g);
      })), _toConsumableArray(entry || []))
    });
  };

  return isdOrQuery && isdOrQuery.operator && {
    operator: toEntry(isdOrQuery.operator)
  };
};

function QueryBuilder(_ref3) {
  var classes = _ref3.classes,
      className = _ref3.className,
      query = _ref3.query,
      fields = _ref3.fields,
      groups = _ref3.groups,
      defaultField = _ref3.defaultField,
      defaultGroup = _ref3.defaultGroup,
      onChange = _ref3.onChange,
      QueryEntryComponent = _ref3.QueryEntryComponent,
      QueryEntryProps = _ref3.QueryEntryProps;
  var validQuery = React__default.useMemo(function () {
    return toQuery(query);
  }, [query]);
  var handleChange = React__default.useCallback(function (newQuery) {
    onChange(_objectSpread2(_objectSpread2({}, newQuery), {}, {
      toItemSearchDocument: function toItemSearchDocument() {
        return queryToItemSearchDocument(this);
      }
    }));
  }, [onChange]);

  var _React$useState = React__default.useState(['operator']),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  var handleToggle = function handleToggle(_, nodeIds) {
    setExpanded(nodeIds);
  };

  var expandNode = function expandNode(nodeId) {
    if (!expanded.includes(nodeId)) {
      setExpanded(function (curr) {
        return [].concat(_toConsumableArray(curr), [nodeId]);
      });
    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(className, classes.root, 'VdtQueryBuilder-root')
  }, validQuery ? /*#__PURE__*/React__default.createElement(QueryBuilderContextProvider, {
    query: validQuery,
    onChange: handleChange
  }, /*#__PURE__*/React__default.createElement(TreeView, {
    classes: {
      root: classes.treeRoot
    },
    disableSelection: true,
    expanded: expanded,
    onNodeToggle: handleToggle
  }, /*#__PURE__*/React__default.createElement(QueryEntryComponent, _extends({
    expandNode: expandNode,
    path: "operator",
    defaultField: defaultField,
    defaultGroup: defaultGroup,
    fields: fields,
    groups: groups,
    canExpand: false // eslint-disable-next-line react/jsx-props-no-spreading

  }, QueryEntryProps)))) : null);
}
QueryBuilder.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  query: propTypes.oneOfType([propTypes.shape({
    operation: index.SearchOperationType,
    entry: propTypes.arrayOf(propTypes.oneOfType([index.SearchOperatorType, index.SearchFieldType, index.SearchGroupType]))
  }), index.ItemSearchType]).isRequired,
  groups: propTypes.arrayOf(propTypes.any),
  fields: propTypes.arrayOf(propTypes.any),
  defaultField: propTypes.string,
  defaultGroup: propTypes.string,
  onChange: propTypes.func.isRequired,
  QueryEntryComponent: propTypes.elementType,
  QueryEntryProps: propTypes.objectOf(propTypes.any)
};
QueryBuilder.defaultProps = {
  className: undefined,
  classes: {},
  fields: [],
  groups: [],
  defaultField: undefined,
  defaultGroup: undefined,
  QueryEntryComponent: QueryEntry$1,
  QueryEntryProps: {}
};

var QueryBuilder$1 = withStyles(styles$1u, {
  name: 'VdtQueryBuilder'
})(QueryBuilder);

var styles$1v = function styles(theme) {
  return {
    root: {
      padding: theme.spacing(1)
    },
    resetButton: {},
    searchButton: {},
    DialogActions: {}
  };
};
function QueryBuilderCard(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      resetText = _ref.resetText,
      searchText = _ref.searchText,
      onSubmit = _ref.onSubmit,
      itemSearchDocument = _ref.itemSearchDocument,
      initialOperator = _ref.initialOperator,
      fields = _ref.fields,
      groups = _ref.groups,
      QueryBuilderProps = _ref.QueryBuilderProps,
      PaperProps = _ref.PaperProps,
      resetButtonProps = _ref.resetButtonProps,
      searchButtonProps = _ref.searchButtonProps;

  var _React$useState = React__default.useState(_objectSpread2({
    operator: initialOperator
  }, itemSearchDocument)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      queryBuilderQuery = _React$useState2[0],
      setQueryBuilderQuery = _React$useState2[1];

  var onReset = function onReset() {
    var newItemSearchDocument = _objectSpread2(_objectSpread2({}, itemSearchDocument), {}, {
      operator: initialOperator
    });

    setQueryBuilderQuery(newItemSearchDocument);
    onSubmit(newItemSearchDocument);
  };

  var onSearch = function onSearch() {
    var newItemSearchDocument = _objectSpread2(_objectSpread2({}, itemSearchDocument), queryBuilderQuery.toItemSearchDocument ? queryBuilderQuery.toItemSearchDocument() : queryBuilderQuery);

    onSubmit(newItemSearchDocument);
  };

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React__default.createElement(Paper, _extends({
      className: clsx(classes.root, className),
      onKeyPress: function onKeyPress(e) {
        if (e.key === 'Enter') {
          onSearch();
        }
      },
      variant: "outlined",
      elevation: 0,
      square: true // eslint-disable-next-line react/jsx-props-no-spreading

    }, PaperProps), /*#__PURE__*/React__default.createElement(QueryBuilder$1, _extends({
      query: queryBuilderQuery,
      fields: fields,
      groups: groups,
      onChange: setQueryBuilderQuery // eslint-disable-next-line react/jsx-props-no-spreading

    }, QueryBuilderProps)), /*#__PURE__*/React__default.createElement(DialogActions$1, {
      className: classes.DialogActions
    }, /*#__PURE__*/React__default.createElement(Button$1, _extends({
      className: classes.resetButton,
      onClick: onReset // eslint-disable-next-line react/jsx-props-no-spreading

    }, resetButtonProps), resetText), /*#__PURE__*/React__default.createElement(Button$1, _extends({
      className: classes.searchButton,
      variant: "contained",
      color: "primary",
      onClick: onSearch // eslint-disable-next-line react/jsx-props-no-spreading

    }, searchButtonProps), searchText)))
  );
}
QueryBuilderCard.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  resetText: propTypes.string,
  searchText: propTypes.string,
  onSubmit: propTypes.func.isRequired,
  itemSearchDocument: index.ItemSearchType,
  initialOperator: propTypes.objectOf(propTypes.any),
  fields: propTypes.arrayOf(propTypes.shape({
    name: propTypes.string,
    label: propTypes.string,
    type: propTypes.string
  })),
  groups: propTypes.arrayOf(propTypes.shape({
    name: propTypes.string
  })),
  PaperProps: propTypes.objectOf(propTypes.any),
  QueryBuilderProps: propTypes.objectOf(propTypes.any),
  resetButtonProps: propTypes.objectOf(propTypes.any),
  searchButtonProps: propTypes.objectOf(propTypes.any)
};
QueryBuilderCard.defaultProps = {
  className: undefined,
  classes: {},
  resetText: 'Reset',
  searchText: 'Search',
  fields: undefined,
  groups: undefined,
  itemSearchDocument: {},
  initialOperator: {
    operation: 'AND'
  },
  PaperProps: {},
  QueryBuilderProps: {},
  resetButtonProps: {},
  searchButtonProps: {}
};

var index$3 = withStyles(styles$1v, {
  name: 'VdtQueryBuilderCard'
})(QueryBuilderCard);

function BinListMenu(_ref) {
  var anchorEl = _ref.anchorEl,
      _ref$allowDuplicates = _ref.allowDuplicates,
      allowDuplicates = _ref$allowDuplicates === void 0 ? false : _ref$allowDuplicates,
      onMenuClick = _ref.onMenuClick,
      onMenuClose = _ref.onMenuClose,
      onEmptyBinClick = _ref.onEmptyBinClick,
      onAddToCollectionClick = _ref.onAddToCollectionClick,
      onAllowDuplicatesClick = _ref.onAllowDuplicatesClick,
      _ref$emptyBinText = _ref.emptyBinText,
      emptyBinText = _ref$emptyBinText === void 0 ? 'Empty Bin' : _ref$emptyBinText,
      _ref$addCollectionTex = _ref.addCollectionText,
      addCollectionText = _ref$addCollectionTex === void 0 ? 'Add to collection' : _ref$addCollectionTex,
      _ref$allowDuplicatesT = _ref.allowDuplicatesText,
      allowDuplicatesText = _ref$allowDuplicatesT === void 0 ? 'Allow duplicates' : _ref$allowDuplicatesT;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IconButton, {
    "aria-label": "options",
    onClick: onMenuClick,
    component: ButtonBase,
    disableRipple: true
  }, /*#__PURE__*/React__default.createElement(MoreVertIcon, null)), /*#__PURE__*/React__default.createElement(Menu, {
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: onMenuClose,
    elevation: 1,
    PaperProps: {
      square: true
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: onEmptyBinClick
  }, /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(DeleteIcon, null)), /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: emptyBinText
  })), /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: onAddToCollectionClick
  }, /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(AddCircleIcon, null)), /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: addCollectionText
  })), /*#__PURE__*/React__default.createElement(MenuItem, null, /*#__PURE__*/React__default.createElement(FormGroup, {
    row: true
  }, /*#__PURE__*/React__default.createElement(FormControlLabel, {
    control: /*#__PURE__*/React__default.createElement(Switch, {
      checked: allowDuplicates,
      onChange: onAllowDuplicatesClick,
      name: "checked",
      color: "primary"
    }),
    label: allowDuplicatesText
  })))));
}

var BinListMenu$1 = withStyles({}, {
  name: 'VdtBinListMenu'
})(BinListMenu);

var _defaultEntityCompone;
var ITEM$1 = 'item';
var COLLECTION$2 = 'collection';
var defaultEntityComponents = (_defaultEntityCompone = {}, _defineProperty(_defaultEntityCompone, ITEM$1, ItemCard), _defineProperty(_defaultEntityCompone, COLLECTION$2, CollectionCard), _defaultEntityCompone);
function EntityCard(_ref) {
  var entityType = _ref.entityType,
      entity = _ref.entity,
      _ref$entityComponents = _ref.entityComponents,
      entityComponents = _ref$entityComponents === void 0 ? defaultEntityComponents : _ref$entityComponents,
      props = _objectWithoutProperties(_ref, ["entityType", "entity", "entityComponents"]);

  if (!entityType) return null;

  var entityProps = _objectSpread2({}, props);

  var EntityCardComponent = entityComponents[entityType.toLowerCase()];
  if (!EntityCardComponent) return null;

  if (entityType.toLowerCase() === ITEM$1.toLowerCase()) {
    entityProps.itemId = entity.id;
    entityProps.itemType = entity;
  } else if (entityType.toLowerCase() === COLLECTION$2.toLowerCase()) {
    entityProps.collectionId = entity.id;
    entityProps.collectionType = entity;
  }

  return /*#__PURE__*/React__default.createElement(EntityCardComponent // eslint-disable-next-line react/jsx-props-no-spreading
  , entityProps);
}

var BIN_ENTITY_TYPE = 'BIN';

var BinItemMenu = function BinItemMenu(_ref) {
  var _ref$innerProps = _ref.innerProps,
      onDelete = _ref$innerProps.onDelete,
      binId = _ref$innerProps.id;
  return /*#__PURE__*/React__default.createElement(IconButton, {
    "aria-label": "Remove",
    onClick: function onClick() {
      return onDelete(binId);
    }
  }, /*#__PURE__*/React__default.createElement(DeleteIcon, null));
};

var BinContent = function BinContent(_ref2) {
  var children = _ref2.children,
      classes = _ref2.classes,
      className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ["children", "classes", "className"]);

  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: clsx(className, classes.root)
  }, props), children);
};

var binContentDroppableStyles = function binContentDroppableStyles(theme) {
  return {
    root: {
      transition: 'background-color 0.3s ease',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      minHeight: 60,
      minWidth: 300
    },
    canDrop: {
      boxShadow: "inset 0px 0px 1px 1px ".concat(theme.palette.primary.main),
      '&.VdtDroppable-isOver': {
        backgroundColor: emphasize(theme.palette.background.paper, 0.05)
      }
    }
  };
};

var BinContentDroppable = compose(withStyles(binContentDroppableStyles, {
  name: 'VdtBinContentDroppable'
}), withDrop)(BinContent);
var entityCardDraggableStyles = {
  isDragging: {
    opacity: 0
  }
};
var EntityCardDraggable = compose(withStyles(entityCardDraggableStyles, {
  name: 'VdtEntityCardDraggable'
}), withDrag)(EntityCard);
var styles$1w = {
  root: {
    minWidth: 340
  }
};

function BinList(_ref3) {
  var className = _ref3.className,
      classes = _ref3.classes,
      _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? 'Bin' : _ref3$title,
      _ref3$bin = _ref3.bin,
      bin = _ref3$bin === void 0 ? [] : _ref3$bin,
      allowDuplicates = _ref3.allowDuplicates,
      onDelete = _ref3.onDelete,
      onEmptyBin = _ref3.onEmptyBin,
      onDrop = _ref3.onDrop,
      onSort = _ref3.onSort,
      _ref3$onAddToCollecti = _ref3.onAddToCollectionSuccess,
      onAddToCollectionSuccess = _ref3$onAddToCollecti === void 0 ? function () {
    return null;
  } : _ref3$onAddToCollecti,
      onAllowDuplicates = _ref3.onAllowDuplicates,
      _ref3$ActionComponent = _ref3.ActionComponent,
      ActionComponent = _ref3$ActionComponent === void 0 ? BinListMenu$1 : _ref3$ActionComponent,
      _ref3$ActionProps = _ref3.ActionProps,
      ActionProps = _ref3$ActionProps === void 0 ? {} : _ref3$ActionProps,
      _ref3$AddToCollection = _ref3.AddToCollectionDialogComponent,
      AddToCollectionDialogComponent = _ref3$AddToCollection === void 0 ? AddToCollectionDialog$1 : _ref3$AddToCollection,
      _ref3$AddToCollection2 = _ref3.AddToCollectionDialogProps,
      AddToCollectionDialogProps = _ref3$AddToCollection2 === void 0 ? {} : _ref3$AddToCollection2,
      _ref3$BinContentCompo = _ref3.BinContentComponent,
      BinContentComponent = _ref3$BinContentCompo === void 0 ? BinContentDroppable : _ref3$BinContentCompo,
      _ref3$BinContentProps = _ref3.BinContentProps,
      BinContentProps = _ref3$BinContentProps === void 0 ? {} : _ref3$BinContentProps,
      _ref3$BinItemComponen = _ref3.BinItemComponent,
      BinItemComponent = _ref3$BinItemComponen === void 0 ? EntityCardDraggable : _ref3$BinItemComponen,
      _ref3$BinItemProps = _ref3.BinItemProps,
      BinItemProps = _ref3$BinItemProps === void 0 ? {} : _ref3$BinItemProps,
      _ref3$BinItemMenuComp = _ref3.BinItemMenuComponent,
      BinItemMenuComponent = _ref3$BinItemMenuComp === void 0 ? BinItemMenu : _ref3$BinItemMenuComp,
      _ref3$BinItemMenuProp = _ref3.BinItemMenuProps,
      BinItemMenuProps = _ref3$BinItemMenuProp === void 0 ? {} : _ref3$BinItemMenuProp,
      _ref3$BinProps = _ref3.BinProps,
      BinProps = _ref3$BinProps === void 0 ? {} : _ref3$BinProps;

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var _React$useState3 = React__default.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showAddToCollectionDialog = _React$useState4[0],
      setShowAddToCollectionDialog = _React$useState4[1];

  var _useConfirmationDialo = useConfirmationDialog({
    throwOnReject: false
  }),
      _useConfirmationDialo2 = _slicedToArray(_useConfirmationDialo, 2),
      ConfirmationDialog = _useConfirmationDialo2[0],
      confirm = _useConfirmationDialo2[1];

  var binEntities = React__default.useMemo(function () {
    return bin && bin.map(function (_ref4) {
      var id = _ref4.entity.id,
          type = _ref4.entityType,
          _ref4$entityTimespan = _ref4.entityTimespan;
      _ref4$entityTimespan = _ref4$entityTimespan === void 0 ? {} : _ref4$entityTimespan;
      var start = _ref4$entityTimespan.start,
          end = _ref4$entityTimespan.end;
      return {
        id: id,
        type: type,
        metadata: {
          field: start ? [{
            key: 'start',
            value: start
          }, {
            key: 'end',
            value: end
          }] : []
        }
      };
    });
  }, [bin]);

  var handleMenuClick = function handleMenuClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleMenuClose = function handleMenuClose() {
    setAnchorEl(null);
  };

  var onResetWithConfirmation = function onResetWithConfirmation() {
    confirm().then(function (confirmed) {
      if (confirmed) {
        handleMenuClose();
        onEmptyBin();
      }
    });
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Paper, _extends({
    className: clsx(className, classes.root, 'VdtBinList-root')
  }, BinProps), /*#__PURE__*/React__default.createElement(CardHeader$1, {
    title: title,
    titleTypographyProps: {
      variant: 'button',
      color: 'textSecondary'
    },
    action: ActionComponent ? /*#__PURE__*/React__default.createElement(ActionComponent, _extends({
      anchorEl: anchorEl,
      allowDuplicates: allowDuplicates,
      onMenuClick: handleMenuClick,
      onMenuClose: handleMenuClose,
      onEmptyBinClick: onResetWithConfirmation,
      onAddToCollectionClick: function onAddToCollectionClick() {
        return setShowAddToCollectionDialog(true);
      },
      onAllowDuplicatesClick: function onAllowDuplicatesClick(_ref5) {
        var _ref5$target = _ref5.target;
        _ref5$target = _ref5$target === void 0 ? {} : _ref5$target;
        var checked = _ref5$target.checked;
        return onAllowDuplicates(checked);
      }
    }, ActionProps)) : undefined
  }), /*#__PURE__*/React__default.createElement(BinContentComponent, _extends({
    onDrop: onDrop,
    dropInfo: {
      entityType: BIN_ENTITY_TYPE
    },
    ignoreDropOnExitingIds: true
  }, BinContentProps), bin && bin.map(function (binItem, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: binItem.binId,
      style: {
        marginBottom: 10
      }
    }, /*#__PURE__*/React__default.createElement(BinItemComponent, _extends({}, binItem, {
      id: binItem.binId,
      index: index,
      onSort: onSort,
      onDelete: onDelete,
      CardProps: {
        elevation: 1
      },
      titleTypographyProps: {
        noWrap: true,
        style: {
          width: 160
        }
      },
      subheaderTypographyProps: {
        noWrap: true,
        style: {
          width: 160
        }
      },
      MenuComponent: BinItemMenuComponent,
      MenuProps: BinItemMenuProps
    }, BinItemProps)));
  }))), ConfirmationDialog && /*#__PURE__*/React__default.createElement(ConfirmationDialog, {
    titleText: "Empty bin",
    confirmText: "Empty",
    rejectText: "Close"
  }, /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(DialogContentText$1, null, "Are you sure you want to empty the bin?"))), AddToCollectionDialogComponent && /*#__PURE__*/React__default.createElement(Dialog, {
    open: showAddToCollectionDialog,
    onClose: function onClose() {
      return setShowAddToCollectionDialog(false);
    }
  }, /*#__PURE__*/React__default.createElement(AddToCollectionDialogComponent, _extends({
    onSuccess: function onSuccess() {
      var collectionIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _response$data = response.data;
      _response$data = _response$data === void 0 ? {} : _response$data;
      var createdCollectionId = _response$data.id;
      onAddToCollectionSuccess(collectionIds.length ? collectionIds : [createdCollectionId]);
      setShowAddToCollectionDialog(false);
    },
    entities: binEntities
  }, AddToCollectionDialogProps))));
}

var BinList$1 = withStyles(styles$1w, {
  name: 'VdtBinList'
})(BinList);

function EntityGridItem(_ref) {
  var entityType = _ref.entityType,
      entityId = _ref.entityId,
      entity = _ref.entity,
      index = _ref.index,
      _ref$CollectionCardCo = _ref.CollectionCardComponent,
      CollectionCardComponent = _ref$CollectionCardCo === void 0 ? CollectionCard : _ref$CollectionCardCo,
      _ref$ItemCardComponen = _ref.ItemCardComponent,
      ItemCardComponent = _ref$ItemCardComponen === void 0 ? ItemCard : _ref$ItemCardComponen,
      _ref$CollectionCardPr = _ref.CollectionCardProps,
      CollectionCardProps = _ref$CollectionCardPr === void 0 ? {} : _ref$CollectionCardPr,
      _ref$ItemCardProps = _ref.ItemCardProps,
      ItemCardProps = _ref$ItemCardProps === void 0 ? {} : _ref$ItemCardProps,
      props = _objectWithoutProperties(_ref, ["entityType", "entityId", "entity", "index", "CollectionCardComponent", "ItemCardComponent", "CollectionCardProps", "ItemCardProps"]);

  var isCollection = entityType === 'COLLECTION';
  var isItem = entityType === 'ITEM';
  return /*#__PURE__*/React__default.createElement(Grid, _extends({
    item: true,
    xs: "auto" // eslint-disable-next-line react/jsx-props-no-spreading

  }, props), isCollection && /*#__PURE__*/React__default.createElement(CollectionCardComponent, _extends({
    index: index,
    collectionId: entityId,
    collectionType: entity // eslint-disable-next-line react/jsx-props-no-spreading

  }, CollectionCardProps)), isItem && /*#__PURE__*/React__default.createElement(ItemCardComponent, _extends({
    index: index,
    itemId: entityId,
    itemType: entity // eslint-disable-next-line react/jsx-props-no-spreading

  }, ItemCardProps)));
}

var styles$1x = {
  root: {},
  rootIsDragging: {
    opacity: 0.5,
    cursor: 'move'
  }
};

var EntityGridItemDraggable = function EntityGridItemDraggable(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      isDragging = _ref.isDragging,
      props = _objectWithoutProperties(_ref, ["className", "classes", "isDragging"]);

  return /*#__PURE__*/React__default.createElement(EntityGridItem, _extends({
    className: clsx(classes.root, 'VdtEntityGridItemDraggable-root', isDragging && classes.rootIsDragging, isDragging && 'VdtEntityGridItemDraggable-rootIsDragging', className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
};

var EntityGridItemDraggable$1 = compose(withDrag, withStyles$1(styles$1x, {
  name: 'VdtEntityGridItemDraggable'
}))(EntityGridItemDraggable);

var COLLECTION$3 = 'COLLECTION';
var ITEM$2 = 'ITEM';
function EntityGrid(_ref) {
  var _ref$entries = _ref.entries,
      entries = _ref$entries === void 0 ? [] : _ref$entries,
      _ref$EntityGridItemCo = _ref.EntityGridItemComponent,
      EntityGridItemComponent = _ref$EntityGridItemCo === void 0 ? EntityGridItemDraggable$1 : _ref$EntityGridItemCo,
      _ref$CollectionCardCo = _ref.CollectionCardComponent,
      CollectionCardComponent = _ref$CollectionCardCo === void 0 ? CollectionCard : _ref$CollectionCardCo,
      _ref$ItemCardComponen = _ref.ItemCardComponent,
      ItemCardComponent = _ref$ItemCardComponen === void 0 ? ItemCard : _ref$ItemCardComponen,
      _ref$CollectionCardPr = _ref.CollectionCardProps,
      CollectionCardProps = _ref$CollectionCardPr === void 0 ? {} : _ref$CollectionCardPr,
      _ref$ItemCardProps = _ref.ItemCardProps,
      ItemCardProps = _ref$ItemCardProps === void 0 ? {} : _ref$ItemCardProps,
      _ref$GridContainerPro = _ref.GridContainerProps,
      GridContainerProps = _ref$GridContainerPro === void 0 ? {} : _ref$GridContainerPro,
      _ref$GridItemProps = _ref.GridItemProps,
      GridItemProps = _ref$GridItemProps === void 0 ? {} : _ref$GridItemProps;
  var entityEntries = React__default.useMemo(function () {
    return entries.map(function (e) {
      return e.collection && _objectSpread2(_objectSpread2({}, e.collection), {}, {
        type: COLLECTION$3
      }) || e.item && _objectSpread2(_objectSpread2({}, e.item), {}, {
        type: ITEM$2
      }) || undefined;
    });
  }, [entries]);
  return /*#__PURE__*/React__default.createElement(Grid, _extends({
    container: true // eslint-disable-next-line react/jsx-props-no-spreading

  }, GridContainerProps), entityEntries && entityEntries.length && entityEntries.map(function (entity, index) {
    return /*#__PURE__*/React__default.createElement(EntityGridItemComponent, _extends({
      key: "".concat(entity.type, "_").concat(entity.id),
      index: index,
      entity: entity,
      entityType: entity.type,
      entityId: entity.id,
      CollectionCardComponent: CollectionCardComponent,
      ItemCardComponent: ItemCardComponent,
      CollectionCardProps: CollectionCardProps,
      ItemCardProps: ItemCardProps // eslint-disable-next-line react/jsx-props-no-spreading

    }, GridItemProps));
  }));
}

function EntityTableRow(_ref) {
  var entityType = _ref.entityType,
      entityId = _ref.entityId,
      entity = _ref.entity,
      _ref$collectionOption = _ref.collectionOptions,
      collectionOptions = _ref$collectionOption === void 0 ? [] : _ref$collectionOption,
      _ref$itemOptions = _ref.itemOptions,
      itemOptions = _ref$itemOptions === void 0 ? [] : _ref$itemOptions,
      onCollectionClick = _ref.onCollectionClick,
      onItemClick = _ref.onItemClick,
      props = _objectWithoutProperties(_ref, ["entityType", "entityId", "entity", "collectionOptions", "itemOptions", "onCollectionClick", "onItemClick"]);

  var isCollection = entityType === 'COLLECTION';
  var isItem = entityType === 'ITEM';
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isCollection && /*#__PURE__*/React__default.createElement(CollectionRow, _extends({
    collectionId: entityId,
    collectionType: entity,
    options: collectionOptions,
    onClick: onCollectionClick // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)), isItem && /*#__PURE__*/React__default.createElement(ItemRow, _extends({
    itemId: entityId,
    itemType: entity,
    options: itemOptions,
    onClick: onItemClick // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)));
}

var styles$1y = {
  root: {},
  rootIsDragging: {
    opacity: 0.5,
    cursor: 'move'
  }
};

var EntityTableRowDraggable = function EntityTableRowDraggable(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      isDragging = _ref.isDragging,
      props = _objectWithoutProperties(_ref, ["className", "classes", "isDragging"]);

  return /*#__PURE__*/React__default.createElement(EntityTableRow, _extends({
    className: clsx(classes.root, 'VdtEntityTableRowDraggable-root', isDragging && classes.rootIsDragging, isDragging && 'VdtEntityTableRowDraggable-rootIsDragging', className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
};

var EntityTableRowDraggable$1 = compose(withDrag, withStyles$1(styles$1y, {
  name: 'VdtEntityTableRowDraggable'
}))(EntityTableRowDraggable);

var COLLECTION$4 = 'COLLECTION';
var ITEM$3 = 'ITEM';
function EntityTable(_ref) {
  var _ref$entries = _ref.entries,
      entries = _ref$entries === void 0 ? [] : _ref$entries,
      _ref$EntityTableRowCo = _ref.EntityTableRowComponent,
      EntityTableRowComponent = _ref$EntityTableRowCo === void 0 ? EntityTableRowDraggable$1 : _ref$EntityTableRowCo,
      _ref$optionLabels = _ref.optionLabels,
      optionLabels = _ref$optionLabels === void 0 ? [] : _ref$optionLabels,
      _ref$collectionOption = _ref.collectionOptions,
      collectionOptions = _ref$collectionOption === void 0 ? [] : _ref$collectionOption,
      _ref$itemOptions = _ref.itemOptions,
      itemOptions = _ref$itemOptions === void 0 ? [] : _ref$itemOptions,
      onCheck = _ref.onCheck,
      _ref$onCollectionClic = _ref.onCollectionClick,
      _onCollectionClick = _ref$onCollectionClic === void 0 ? function () {
    return null;
  } : _ref$onCollectionClic,
      _ref$onItemClick = _ref.onItemClick,
      _onItemClick = _ref$onItemClick === void 0 ? function () {
    return null;
  } : _ref$onItemClick,
      _ref$TableRowProps = _ref.TableRowProps,
      TableRowProps = _ref$TableRowProps === void 0 ? {} : _ref$TableRowProps;

  var entityEntries = React__default.useMemo(function () {
    return entries.map(function (e) {
      return (// eslint-disable-next-line no-nested-ternary
        e.collection ? _objectSpread2(_objectSpread2({}, e.collection), {}, {
          type: COLLECTION$4
        }) : e.item ? _objectSpread2(_objectSpread2({}, e.item), {}, {
          type: ITEM$3
        }) : undefined
      );
    });
  }, [entries]);
  return /*#__PURE__*/React__default.createElement(Table$1, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead$1$1, null, /*#__PURE__*/React__default.createElement(TableRow$3$1, null, onCheck && /*#__PURE__*/React__default.createElement(TableCell$1, {
    padding: "checkbox"
  }), optionLabels.map(function (_ref2, index) {
    var label = _ref2.label,
        key = _ref2.key,
        hide = _ref2.hide;
    return /*#__PURE__*/React__default.createElement(Hidden, {
      key: key || label || index,
      only: hide
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, label));
  }))), /*#__PURE__*/React__default.createElement(TableBody$1, null, entityEntries && entityEntries.length ? entityEntries.map(function (entity) {
    return /*#__PURE__*/React__default.createElement(EntityTableRowComponent, _extends({
      key: "".concat(entity.type, "_").concat(entity.id),
      entity: entity,
      entityType: entity.type,
      entityId: entity.id,
      wrapDragInDiv: false,
      collectionOptions: collectionOptions,
      itemOptions: itemOptions,
      onCheck: onCheck,
      onCollectionClick: function onCollectionClick() {
        return _onCollectionClick(entity);
      },
      onItemClick: function onItemClick() {
        return _onItemClick(entity);
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, TableRowProps));
  }) : null));
}

var styles$1z = function styles() {
  return {
    root: {},
    entityCard: {
      display: 'flex',
      justifyContent: 'center'
    }
  };
};

var useDeleteHook = function useDeleteHook(entity, entityId) {
  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      validation = _React$useState2[0],
      setValidation = _React$useState2[1];

  var handleValidation = function handleValidation(value) {
    return setValidation(value);
  };

  var onDelete = function onDelete() {
    if (entity.toLowerCase() === 'item') return item.removeItem({
      itemId: entityId
    });
    if (entity.toLowerCase() === 'collection') return collection.removeCollection({
      collectionId: entityId
    });
    return new Promise(function (res, rej) {
      return rej(new Error("Unknown entity type, is ".concat(entity)));
    });
  };

  return {
    validation: validation,
    handleValidation: handleValidation,
    onDelete: onDelete
  };
};

function EntityDeleteDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      entity = _ref.entity,
      entityId = _ref.entityId,
      onSuccess = _ref.onSuccess,
      onFailure = _ref.onFailure,
      className = _ref.className,
      title = _ref.title,
      subtitle = _ref.subtitle,
      validationText = _ref.validationText,
      closeButtonText = _ref.closeButtonText,
      confirmButtonText = _ref.confirmButtonText,
      queryParams = _ref.queryParams,
      DialogProps = _ref.DialogProps,
      CollectionCardComponent = _ref.CollectionCardComponent,
      CollectionCardProps = _ref.CollectionCardProps,
      ItemCardComponent = _ref.ItemCardComponent,
      ItemCardProps = _ref.ItemCardProps,
      showEntityPreview = _ref.showEntityPreview,
      classes = _ref.classes;

  var _useDeleteHook = useDeleteHook(entity, entityId),
      onDelete = _useDeleteHook.onDelete,
      validation = _useDeleteHook.validation,
      handleValidation = _useDeleteHook.handleValidation;

  var onClick = function onClick() {
    return onDelete().then(function (resp) {
      onClose();
      onSuccess(resp);
    })["catch"](onFailure);
  };

  if (!open) return null;
  return /*#__PURE__*/React__default.createElement(Dialog$1, _extends({
    open: open,
    onClose: onClose,
    className: clsx(classes.root, 'VdtEntityDeleteDialog-root', className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, DialogProps), /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    disableTypography: true
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6"
  }, title), subtitle && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2"
  }, subtitle)), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(DialogContent$1, null, showEntityPreview && /*#__PURE__*/React__default.createElement("div", {
    className: classes.entityCard
  }, entity === 'item' ? /*#__PURE__*/React__default.createElement(GetItem, {
    itemId: entityId,
    queryParams: queryParams
  }, /*#__PURE__*/React__default.createElement(ItemCardComponent, _extends({
    titleSelector: function titleSelector(_ref2) {
      var name = _ref2.title,
          itemId = _ref2.itemId;
      return name || itemId;
    },
    subheaderSelector: function subheaderSelector(_ref3) {
      var created = _ref3.created;
      return created ? moment(created).format('ll') : '';
    },
    ContentComponent: null,
    ActionsComponent: null // eslint-disable-next-line react/jsx-props-no-spreading

  }, ItemCardProps))) : /*#__PURE__*/React__default.createElement(GetCollection, {
    collectionId: entityId,
    queryParams: queryParams
  }, /*#__PURE__*/React__default.createElement(CollectionCardComponent, _extends({
    titleSelector: function titleSelector(_ref4) {
      var name = _ref4.title,
          collectionId = _ref4.collectionId;
      return name || collectionId;
    },
    subheaderSelector: function subheaderSelector(_ref5) {
      var created = _ref5.created;
      return created ? moment(created).format('ll') : '';
    },
    avatar: entity // eslint-disable-next-line react/jsx-props-no-spreading

  }, CollectionCardProps)))), /*#__PURE__*/React__default.createElement(FormControlLabel, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: validation,
      onChange: function onChange() {
        return handleValidation(!validation);
      }
    }),
    label: validationText
  })), /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: onClose
  }, closeButtonText), /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "contained",
    color: "primary",
    onClick: onClick,
    disabled: !validation
  }, confirmButtonText)));
}

var EntityDeleteDialog$1 = withStyles(styles$1z, 'VdtEntityDeleteDialog')(EntityDeleteDialog);
EntityDeleteDialog.propTypes = {
  open: propTypes.bool,
  onClose: propTypes.func,
  entityId: propTypes.string.isRequired,
  entity: propTypes.string.isRequired,
  onSuccess: propTypes.func,
  onFailure: propTypes.func,
  className: propTypes.string,
  title: propTypes.string,
  subtitle: propTypes.string,
  validationText: propTypes.string,
  closeButtonText: propTypes.string,
  confirmButtonText: propTypes.string,
  queryParams: propTypes.objectOf(propTypes.any),
  DialogProps: propTypes.objectOf(propTypes.any),
  CollectionCardComponent: propTypes.elementType,
  CollectionCardProps: propTypes.objectOf(propTypes.any),
  ItemCardComponent: propTypes.elementType,
  ItemCardProps: propTypes.objectOf(propTypes.any),
  showEntityPreview: propTypes.bool,
  classes: propTypes.objectOf(propTypes.any)
};
EntityDeleteDialog.defaultProps = {
  open: false,
  onClose: function onClose() {
    return null;
  },
  onSuccess: function onSuccess() {
    return null;
  },
  onFailure: function onFailure() {
    return null;
  },
  className: 'VdtEntityDeleteDialog',
  title: 'Delete entity',
  subtitle: '',
  validationText: "I understand that deleting is permanent and can't be undone",
  closeButtonText: 'Close',
  confirmButtonText: 'Permanently delete entity',
  queryParams: {
    field: ['created', 'title', 'mimeType', 'durationSeconds', 'itemId', 'collectionId'],
    content: ['metadata', 'thumbnail'],
    'noauth-url': true
  },
  DialogProps: {},
  CollectionCardComponent: CollectionCard,
  CollectionCardProps: {},
  ItemCardComponent: ItemCard,
  ItemCardProps: {},
  showEntityPreview: true,
  classes: {}
};

var getPlayerFromRef = function getPlayerFromRef(playerRef) {
  if (!playerRef || !playerRef.current) return undefined;
  if (playerRef.current.currentTime) return playerRef.current;
  if (playerRef.current.player.currentTime) return playerRef.current.player;
  if (playerRef.current.player.videojs.currentTime) return playerRef.current.player.videojs;
  return undefined;
};

var useComments = function useComments(_ref) {
  var entity = _ref.entity,
      entityId = _ref.entityId,
      initialMetadataType = _ref.metadataType,
      _ref$commentField = _ref.commentField,
      commentField = _ref$commentField === void 0 ? 'co' : _ref$commentField,
      _ref$playerRef = _ref.playerRef,
      playerRef = _ref$playerRef === void 0 ? {} : _ref$playerRef,
      _ref$timeBase = _ref.timeBase,
      timeBase = _ref$timeBase === void 0 ? {
    numerator: 1,
    denominator: 25
  } : _ref$timeBase,
      _ref$getEntityMetadat = _ref.getEntityMetadata,
      getEntityMetadata = _ref$getEntityMetadat === void 0 ? metadata.getEntityMetadata : _ref$getEntityMetadat,
      _ref$updateEntityMeta = _ref.updateEntityMetadata,
      updateEntityMetadata = _ref$updateEntityMeta === void 0 ? metadata.updateEntityMetadata : _ref$updateEntityMeta,
      _ref$removeGlobalMeta = _ref.removeGlobalMetadata,
      removeGlobalMetadata = _ref$removeGlobalMeta === void 0 ? globalmetadata.removeGlobalMetadata : _ref$removeGlobalMeta;

  var _React$useState = React__default.useState(initialMetadataType),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      metadataType = _React$useState2[0],
      setMetadataType = _React$useState2[1];

  var _React$useState3 = React__default.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      newComment = _React$useState4[0],
      setNewComment = _React$useState4[1];

  var _React$useState5 = React__default.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      commentTimecode = _React$useState6[0],
      setCommentTimecode = _React$useState6[1];

  var smpteTimecode = commentTimecode ? formatSeconds(commentTimecode, timeBase).toSmpte() : undefined;
  var commentList = React__default.useMemo(function () {
    if (!metadataType || !metadataType.timespan) return undefined;
    var _metadataType$timespa = metadataType.timespan,
        timespanList = _metadataType$timespa === void 0 ? [] : _metadataType$timespa;
    return timespanList.reduce(function (acc, timespan) {
      var fieldList = timespan.field,
          start = timespan.start;
      if (fieldList.length === 0) return acc;

      var newAcc = _toConsumableArray(acc);

      fieldList.forEach(function (_ref2) {
        var name = _ref2.name,
            _ref2$value = _ref2.value,
            valueList = _ref2$value === void 0 ? [] : _ref2$value,
            fieldUuid = _ref2.uuid;
        if (name !== commentField || valueList.length === 0) return;
        valueList.forEach(function (_ref3) {
          var value = _ref3.value,
              uuid = _ref3.uuid,
              user = _ref3.user,
              timestamp = _ref3.timestamp;
          newAcc.push({
            value: value,
            uuid: valueList.length > 1 ? uuid : fieldUuid,
            user: user,
            start: start,
            timestamp: timestamp
          });
        });
      });
      return newAcc;
    }, []).sort(function (a, b) {
      return new Date(b.timestamp) - new Date(a.timestamp);
    });
  }, [metadataType, commentField]);

  var onRefreshComments = function onRefreshComments() {
    getEntityMetadata({
      entity: entity,
      entityId: entityId,
      queryParams: {
        field: commentField
      }
    }).then(function (_ref4) {
      var data = _ref4.data;
      if (entity === 'item') setMetadataType(data.item[0].metadata);else setMetadataType(data);
    });
  };

  var onChangeComment = function onChangeComment(event) {
    return setNewComment(event.target.value || '');
  };

  var onChangeTimecode = function onChangeTimecode() {
    var player = getPlayerFromRef(playerRef);
    if (!player) return;

    if (commentTimecode !== undefined || !player) {
      setCommentTimecode();
    } else {
      var currentTime = player.currentTime();
      setCommentTimecode(currentTime);
    }
  };

  var onFocusComment = function onFocusComment() {
    var player = getPlayerFromRef(playerRef);
    if (!player) return;
    player.pause();
    var currentTime = player.currentTime();
    if (commentTimecode) setCommentTimecode(currentTime);
  };

  var onCancelComment = function onCancelComment() {
    setNewComment('');
    setCommentTimecode();
  };

  var onSubmitComment = function onSubmitComment() {
    var metadataDocument = createMetadataType(_defineProperty({}, commentField, newComment));

    if (commentTimecode) {
      var start = formatSeconds(commentTimecode, timeBase);
      start.samples = Math.round(start.samples);
      metadataDocument.timespan[0].start = start.toText();
      start.samples += 1;
      metadataDocument.timespan[0].end = start.toText();
    }

    metadataDocument.timespan[0].field[0].value[0].mode = 'add';
    updateEntityMetadata({
      entity: entity,
      entityId: entityId,
      metadataDocument: metadataDocument
    }).then(function () {
      onRefreshComments();
      onCancelComment();
    });
  };

  var onClickCommentTimecode = function onClickCommentTimecode(timecodeText) {
    var player = getPlayerFromRef(playerRef);
    if (!player) return;
    var seconds = formatTimeCodeText(timecodeText).toSeconds();
    player.currentTime(seconds);
    if (player.played().length === 0) player.play();
  };

  var onDeleteComment = function onDeleteComment(uuid) {
    removeGlobalMetadata({
      uuid: uuid
    }).then(onRefreshComments);
  };

  return {
    newComment: newComment,
    commentTimecode: commentTimecode,
    smpteTimecode: smpteTimecode,
    commentList: commentList,
    onRefreshComments: onRefreshComments,
    onChangeTimecode: onChangeTimecode,
    onChangeComment: onChangeComment,
    onFocusComment: onFocusComment,
    onCancelComment: onCancelComment,
    onSubmitComment: onSubmitComment,
    onClickCommentTimecode: onClickCommentTimecode,
    onDeleteComment: onDeleteComment
  };
};

var styles$1A = function styles(theme) {
  return {
    root: {
      display: 'flex',
      '&:hover': {
        '& $commentAction': {
          visibility: 'visible'
        }
      }
    },
    commentBody: {
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      flexGrow: 1
    },
    commentHeader: {
      display: 'flex',
      '& div': {
        marginRight: theme.spacing(1)
      }
    },
    comments: {
      '& $root': {
        marginTop: theme.spacing(2)
      }
    },
    commentUser: {
      fontWeight: 'bold'
    },
    commentContent: {
      whiteSpace: 'pre-line'
    },
    commentTimecode: {
      color: theme.palette.info.dark,
      marginRight: theme.spacing(1),
      verticalAlign: 'unset'
    },
    commentAction: {
      visibility: 'hidden'
    },
    menuPaper: {
      backgroundColor: theme.palette.background["default"]
    }
  };
};

function EntityCommentCard(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      user = _ref.user,
      timestamp = _ref.timestamp,
      start = _ref.start,
      value = _ref.value,
      onDelete = _ref.onDelete,
      onClick = _ref.onClick,
      deleteText = _ref.deleteText,
      MenuIconComponent = _ref.MenuIconComponent,
      DeleteIconComponent = _ref.DeleteIconComponent,
      UserIconComponent = _ref.UserIconComponent;

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);

  var openMenu = function openMenu(event) {
    setAnchorEl(event.currentTarget);
  };

  var closeMenu = function closeMenu() {
    setAnchorEl(null);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.commentAvatar
  }, /*#__PURE__*/React__default.createElement(Avatar, null, user ? user[0] : UserIconComponent)), /*#__PURE__*/React__default.createElement("div", {
    className: classes.commentBody
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.commentHeader
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.commentUser
  }, user), /*#__PURE__*/React__default.createElement("div", {
    className: classes.commentTimestamp
  }, moment(timestamp).fromNow())), /*#__PURE__*/React__default.createElement("div", {
    className: classes.commentContent
  }, start !== '-INF' && /*#__PURE__*/React__default.createElement(ButtonBase, {
    className: classes.commentTimecode,
    onClick: onClick
  }, formatTimeCodeText(start).toSmpte()), value)), /*#__PURE__*/React__default.createElement("div", {
    className: classes.commentAction
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: openMenu
  }, /*#__PURE__*/React__default.createElement(MenuIconComponent, null)), /*#__PURE__*/React__default.createElement(Menu, {
    className: classes.Menu,
    elevation: 0,
    getContentAnchorEl: null,
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    variant: "menu",
    keepMounted: true,
    open: open,
    PaperProps: {
      className: classes.menuPaper,
      elevation: 1
    },
    onClose: closeMenu
  }, /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: onDelete
  }, /*#__PURE__*/React__default.createElement(ListItemIcon$1, null, /*#__PURE__*/React__default.createElement(DeleteIconComponent, {
    fontSize: "small"
  })), /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: deleteText
  })))));
}

var EntityCommentCard$1 = withStyles(styles$1A, {
  name: 'VdtEntityCommentCard'
})(EntityCommentCard);
EntityCommentCard.propTypes = {
  classes: propTypes.objectOf(propTypes.string),
  className: propTypes.string,
  user: propTypes.string.isRequired,
  timestamp: propTypes.string.isRequired,
  start: propTypes.string.isRequired,
  value: propTypes.string.isRequired,
  onDelete: propTypes.func,
  onClick: propTypes.func,
  deleteText: propTypes.string,
  MenuIconComponent: propTypes.elementType,
  DeleteIconComponent: propTypes.elementType,
  UserIconComponent: propTypes.elementType
};
EntityCommentCard.defaultProps = {
  classes: {},
  className: undefined,
  onDelete: undefined,
  onClick: undefined,
  deleteText: 'Delete',
  MenuIconComponent: MoreVertIcon,
  DeleteIconComponent: DeleteIcon,
  UserIconComponent: UserIcon
};

var styles$1B = function styles(theme) {
  return {
    root: {
      paddingTop: theme.spacing(2)
    },
    header: _objectSpread2(_objectSpread2({}, theme.typography.h6), {}, {
      paddingBottom: theme.spacing(2)
    }),
    label: {
      fontFamily: 'Monaco',
      fontWeight: 100,
      fontSize: '0.75rem',
      fontStyle: 'italic'
    },
    labelWithTimecode: {
      fontWeight: 600,
      fontStyle: 'normal'
    },
    buttons: {
      minHeight: theme.spacing(4.25),
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      marginTop: theme.spacing(1),
      '& button': {
        marginLeft: theme.spacing(1)
      }
    },
    comments: {
      '& > div': {
        marginTop: theme.spacing(2)
      }
    }
  };
};

function EntityComment(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      entity = _ref.entity,
      entityId = _ref.entityId,
      EntityCommentCardComponent = _ref.EntityCommentCardComponent,
      EntityCommentCardProps = _ref.EntityCommentCardProps,
      metadataType = _ref.metadataType,
      commentField = _ref.commentField,
      playerRef = _ref.playerRef,
      timeBase = _ref.timeBase,
      getEntityMetadata = _ref.getEntityMetadata,
      updateEntityMetadata = _ref.updateEntityMetadata,
      removeGlobalMetadata = _ref.removeGlobalMetadata,
      noTimecodeText = _ref.noTimecodeText,
      addCommentText = _ref.addCommentText,
      cancelText = _ref.cancelText,
      commentText = _ref.commentText,
      commentPluralText = _ref.commentPluralText,
      loadingText = _ref.loadingText;

  var _useComments = useComments({
    entity: entity,
    entityId: entityId,
    metadataType: metadataType,
    commentField: commentField,
    playerRef: playerRef,
    timeBase: timeBase,
    getEntityMetadata: getEntityMetadata,
    updateEntityMetadata: updateEntityMetadata,
    removeGlobalMetadata: removeGlobalMetadata
  }),
      newComment = _useComments.newComment,
      commentTimecode = _useComments.commentTimecode,
      smpteTimecode = _useComments.smpteTimecode,
      commentList = _useComments.commentList,
      onChangeTimecode = _useComments.onChangeTimecode,
      onChangeComment = _useComments.onChangeComment,
      onFocusComment = _useComments.onFocusComment,
      onCancelComment = _useComments.onCancelComment,
      onSubmitComment = _useComments.onSubmitComment,
      onClickCommentTimecode = _useComments.onClickCommentTimecode,
      onDeleteComment = _useComments.onDeleteComment,
      onRefreshComments = _useComments.onRefreshComments;

  React__default.useEffect(function () {
    if (metadataType === undefined) onRefreshComments(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.header
  }, commentList ? /*#__PURE__*/React__default.createElement("span", null, "".concat(commentList.length, " ").concat(commentList.length === 1 ? commentText.toLowerCase() : commentPluralText.toLowerCase())) : /*#__PURE__*/React__default.createElement("span", null, loadingText)), /*#__PURE__*/React__default.createElement(TextField$2, {
    className: classes.TextField,
    value: newComment,
    onChange: onChangeComment,
    fullWidth: true,
    variant: "standard",
    placeholder: addCommentText,
    multiline: true,
    InputProps: {
      onFocus: onFocusComment,
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment$1, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(FormControlLabel, {
        control: /*#__PURE__*/React__default.createElement(Switch, {
          size: "small",
          color: "primary",
          checked: commentTimecode !== undefined,
          onChange: onChangeTimecode
        }),
        label: smpteTimecode || noTimecodeText,
        classes: {
          label: clsx(classes.label, _defineProperty({}, classes.labelWithTimecode, commentTimecode !== undefined))
        }
      }))
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classes.buttons
  }, newComment && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$1, {
    className: classes.commentButton,
    color: "primary",
    variant: "contained",
    disableElevation: true,
    onClick: onSubmitComment
  }, commentText), /*#__PURE__*/React__default.createElement(Button$1, {
    className: classes.cancelButton,
    variant: "text",
    disableElevation: true,
    onClick: onCancelComment
  }, cancelText))), /*#__PURE__*/React__default.createElement("div", {
    className: classes.comments
  }, commentList ? commentList.map(function (_ref2) {
    var uuid = _ref2.uuid,
        value = _ref2.value,
        start = _ref2.start,
        user = _ref2.user,
        timestamp = _ref2.timestamp;
    return /*#__PURE__*/React__default.createElement(EntityCommentCardComponent, _extends({
      key: uuid,
      uuid: uuid,
      value: value,
      start: start,
      user: user,
      timestamp: timestamp,
      onDelete: function onDelete() {
        return onDeleteComment(uuid);
      },
      onClick: function onClick() {
        return onClickCommentTimecode(start);
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, EntityCommentCardProps));
  }) : null));
}

var EntityComment$1 = withStyles(styles$1B, {
  name: 'VdtEntityComment'
})(EntityComment);
EntityComment.propTypes = {
  classes: propTypes.objectOf(propTypes.string),
  className: propTypes.string,
  entityId: propTypes.string.isRequired,
  entity: propTypes.oneOf(['item', 'collection']).isRequired,
  EntityCommentCardComponent: propTypes.elementType,
  EntityCommentCardProps: propTypes.objectOf(propTypes.any),
  metadataType: propTypes.objectOf(propTypes.any),
  commentField: propTypes.string,
  playerRef: propTypes.shape({
    current: propTypes.instanceOf(Element)
  }),
  timeBase: propTypes.shape({
    numerator: propTypes.number,
    denominator: propTypes.number
  }),
  getEntityMetadata: propTypes.func,
  updateEntityMetadata: propTypes.func,
  removeGlobalMetadata: propTypes.func,
  noTimecodeText: propTypes.string,
  addCommentText: propTypes.string,
  cancelText: propTypes.string,
  commentText: propTypes.string,
  commentPluralText: propTypes.string,
  loadingText: propTypes.string
};
EntityComment.defaultProps = {
  classes: {},
  className: undefined,
  EntityCommentCardComponent: EntityCommentCard$1,
  EntityCommentCardProps: {},
  metadataType: undefined,
  commentField: 'co',
  playerRef: undefined,
  timeBase: {
    numerator: 1,
    denominator: 25
  },
  getEntityMetadata: metadata.getEntityMetadata,
  updateEntityMetadata: metadata.updateEntityMetadata,
  removeGlobalMetadata: globalmetadata.removeGlobalMetadata,
  noTimecodeText: 'No Timecode',
  addCommentText: 'Add a comment',
  cancelText: 'Cancel',
  commentText: 'Comment',
  commentPluralText: 'Comments',
  loadingText: ''
};

var LoadMoreTreeItem = withStyles$1({}, {
  name: 'VdtLoadMoreTreeItem'
})(function (_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return null;
  } : _ref$onClick,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'Load more' : _ref$text,
      _ref$LoadMoreProps = _ref.LoadMoreProps,
      LoadMoreProps = _ref$LoadMoreProps === void 0 ? {} : _ref$LoadMoreProps;
  var label = /*#__PURE__*/React__default.createElement(Box, {
    className: clsx(classes.label, 'VdtLoadMoreTreeItem-label')
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, text));
  return /*#__PURE__*/React__default.createElement(TreeItem, _extends({
    className: clsx(className, classes.root, 'VdtLoadMoreTreeItem-root'),
    nodeId: LOAD_MORE,
    label: label,
    onClick: onClick
  }, LoadMoreProps));
});

var droppableLoadMoreStyles = function droppableLoadMoreStyles(theme) {
  return {
    isOver: {
      '& .VdtLoadMoreTreeItem-label': {
        backgroundColor: theme.palette.primary.main
      }
    }
  };
};

var LoadMoreTreeItemDroppable = compose(withStyles$1(droppableLoadMoreStyles, {
  name: 'VdtLoadMoreDroppable'
}), withDrop)(LoadMoreTreeItem);
var dropZoneStyles = {
  root: {},
  label: {
    minHeight: '24px'
  }
};
var DropZoneTreeItem = withStyles$1(dropZoneStyles, {
  name: 'VdtDropZoneTreeItem'
})(function (_ref2) {
  var className = _ref2.className,
      classes = _ref2.classes,
      _ref2$DropZoneProps = _ref2.DropZoneProps,
      DropZoneProps = _ref2$DropZoneProps === void 0 ? {} : _ref2$DropZoneProps;
  var label = /*#__PURE__*/React__default.createElement(Box, {
    className: clsx(classes.label, 'VdtDropZoneTreeItem-label')
  });
  return /*#__PURE__*/React__default.createElement(TreeItem, _extends({
    className: clsx(className, classes.root, 'VdtDropZoneTreeItem-root'),
    nodeId: DROP_ZONE_ROOT,
    label: label,
    disabled: true
  }, DropZoneProps));
});

var droppableDropZoneStyles = function droppableDropZoneStyles(theme) {
  return {
    isOver: {
      backgroundColor: theme.palette.primary.main
    }
  };
};

var DropZoneTreeItemDroppable = compose(withStyles$1(droppableDropZoneStyles, {
  name: 'VdtDropZoneDroppable'
}), withDrop)(DropZoneTreeItem);

var EntityTreeList = function EntityTreeList(_ref3) {
  var _ref3$entries = _ref3.entries,
      entries = _ref3$entries === void 0 ? [] : _ref3$entries,
      hits = _ref3.hits,
      collectionId = _ref3.collectionId,
      _ref3$nodeId = _ref3.nodeId,
      nodeId = _ref3$nodeId === void 0 ? [COLLECTION$1, collectionId].join(JOIN_CHARACTER) : _ref3$nodeId,
      onLoadMore = _ref3.onLoadMore,
      onError = _ref3.onError,
      _ref3$onMoveEntity = _ref3.onMoveEntity,
      onMoveEntity = _ref3$onMoveEntity === void 0 ? handleMoveEntity : _ref3$onMoveEntity,
      _ref3$onMoved = _ref3.onMoved,
      onMoved = _ref3$onMoved === void 0 ? function () {
    return null;
  } : _ref3$onMoved,
      _ref3$onAdjustHits = _ref3.onAdjustHits,
      onAdjustHits = _ref3$onAdjustHits === void 0 ? function () {
    return null;
  } : _ref3$onAdjustHits,
      _ref3$CollectionListC = _ref3.CollectionListComponent,
      CollectionListComponent = _ref3$CollectionListC === void 0 ? CollectionTreeList$1 : _ref3$CollectionListC,
      _ref3$ItemComponent = _ref3.ItemComponent,
      ItemComponent = _ref3$ItemComponent === void 0 ? ItemTreeItem$1 : _ref3$ItemComponent,
      _ref3$LoadMoreCompone = _ref3.LoadMoreComponent,
      LoadMoreComponent = _ref3$LoadMoreCompone === void 0 ? LoadMoreTreeItemDroppable : _ref3$LoadMoreCompone,
      _ref3$DropZoneCompone = _ref3.DropZoneComponent,
      DropZoneComponent = _ref3$DropZoneCompone === void 0 ? DropZoneTreeItemDroppable : _ref3$DropZoneCompone,
      _ref3$CollectionListP = _ref3.CollectionListProps,
      CollectionListProps = _ref3$CollectionListP === void 0 ? {} : _ref3$CollectionListP,
      _ref3$ItemProps = _ref3.ItemProps,
      ItemProps = _ref3$ItemProps === void 0 ? {} : _ref3$ItemProps,
      _ref3$LoadMoreProps = _ref3.LoadMoreProps,
      LoadMoreProps = _ref3$LoadMoreProps === void 0 ? {} : _ref3$LoadMoreProps,
      _ref3$DropZoneProps = _ref3.DropZoneProps,
      DropZoneProps = _ref3$DropZoneProps === void 0 ? {} : _ref3$DropZoneProps;

  var _useContext = useContext(EntityTreeContext),
      addOrUpdateCollections = _useContext.addOrUpdateCollections,
      addOrUpdateItems = _useContext.addOrUpdateItems,
      addAsChildrenToCollection = _useContext.addAsChildrenToCollection,
      removeAsChildrenToCollection = _useContext.removeAsChildrenToCollection,
      getChildCollections = _useContext.getChildCollections,
      getChildItems = _useContext.getChildItems;

  var childCollections = getChildCollections(collectionId);
  var childItems = getChildItems(collectionId);
  React__default.useEffect(function () {
    var rootCollections = entries.filter(function (e) {
      return e.collection;
    }).map(function (e) {
      return e.collection;
    });
    var rootItems = entries.filter(function (e) {
      return e.item;
    }).map(function (e) {
      return e.item;
    });

    if (rootCollections.length) {
      addOrUpdateCollections(collectionId, rootCollections);
      var existingChildCollectionIds = childCollections.map(function (i) {
        return i.id;
      });
      var newChildCollectionIds = rootCollections.map(function (i) {
        return i.id;
      }).filter(function (id) {
        return !existingChildCollectionIds.includes(id);
      });

      if (newChildCollectionIds.length) {
        addAsChildrenToCollection(newChildCollectionIds, COLLECTION$1, collectionId);
      }
    }

    if (rootItems.length) {
      addOrUpdateItems(collectionId, rootItems);
      var existingChildItemIds = childItems.map(function (i) {
        return i.id;
      });
      var newChildItemIds = rootItems.map(function (i) {
        return i.id;
      }).filter(function (id) {
        return !existingChildItemIds.includes(id);
      });

      if (newChildItemIds.length) {
        addAsChildrenToCollection(newChildItemIds, ITEM, collectionId);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [entries]);
  var amountOfLocalEntries = childCollections.length + childItems.length;
  var amountOfFetchedEntries = entries.length;
  var amountOfEntries = Math.min(amountOfLocalEntries, amountOfFetchedEntries);

  var handleDrop = function handleDrop(_ref4) {
    var dragInfo = _ref4.dragInfo,
        dropInfo = _ref4.dropInfo;
    if (!dragInfo || !dropInfo) return;
    var entityId = dragInfo.entityId,
        entityType = dragInfo.entityType,
        removeFromCollectionId = dragInfo.entityParentId;
    var dropId = dropInfo.entityId,
        dropType = dropInfo.entityType,
        dropParentId = dropInfo.entityParentId;
    var addToCollectionId = dropType === COLLECTION$1 ? dropId : dropParentId;

    if (addToCollectionId && addToCollectionId === removeFromCollectionId || entityType === COLLECTION$1 && entityId === addToCollectionId) {
      return;
    }

    var handleMoved = function handleMoved() {
      addAsChildrenToCollection(entityId, entityType, addToCollectionId);
      if (addToCollectionId === collectionId) onAdjustHits(1);
      removeAsChildrenToCollection(entityId, entityType, removeFromCollectionId);
      if (removeFromCollectionId === collectionId) onAdjustHits(-1);
      onMoved();
    };

    onMoveEntity({
      entityId: entityId,
      entityType: entityType,
      addToCollectionId: addToCollectionId,
      removeFromCollectionId: removeFromCollectionId,
      rootParentId: ROOT,
      onMoved: handleMoved,
      onError: onError
    });
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, childCollections.length ? childCollections.map(function (collection) {
    return /*#__PURE__*/React__default.createElement(CollectionListComponent, _extends({
      key: [COLLECTION$1, collection.id, COLLECTION$1, collectionId].join(JOIN_CHARACTER),
      parentCollectionId: collectionId,
      collection: collection,
      onDrop: handleDrop,
      ItemProps: ItemProps
    }, CollectionListProps));
  }) : undefined, childItems.length ? childItems.map(function (item) {
    return /*#__PURE__*/React__default.createElement(ItemComponent, _extends({
      key: [ITEM, item.id, COLLECTION$1, collectionId].join(JOIN_CHARACTER),
      item: item,
      parentCollectionId: collectionId,
      onDrop: handleDrop
    }, ItemProps));
  }) : undefined, hits !== undefined && hits > amountOfEntries ? /*#__PURE__*/React__default.createElement(LoadMoreComponent, _extends({
    nodeId: nodeId,
    onClick: function onClick() {
      return onLoadMore(amountOfEntries);
    },
    onDrop: handleDrop,
    dropInfo: {
      entityParentId: collectionId
    }
  }, LoadMoreProps)) : !childItems.length && /*#__PURE__*/React__default.createElement(DropZoneComponent, _extends({
    nodeId: nodeId,
    onDrop: handleDrop,
    dropInfo: {
      entityParentId: collectionId
    },
    disabled: true
  }, DropZoneProps)));
};

var defaultSearchState = {
  interval: 'generic',
  queryParams: {
    field: ['mimeType'],
    content: ['metadata']
  },
  itemSearchDocument: {
    operator: {
      field: [{
        name: '__parent_collection',
        value: [{
          value: ''
        }]
      }, {
        name: '__collection',
        value: [{
          value: ''
        }]
      }],
      operation: 'OR'
    },
    sort: [{
      field: '_type',
      order: 'ascending'
    }, {
      field: 'title',
      order: 'descending'
    }]
  }
};
var styles$1C = {
  root: {}
};

var EntityTree = function EntityTree(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      _ref$searchState = _ref.searchState,
      searchState = _ref$searchState === void 0 ? defaultSearchState : _ref$searchState,
      _ref$rootCollectionId = _ref.rootCollectionId,
      rootCollectionId = _ref$rootCollectionId === void 0 ? ROOT : _ref$rootCollectionId,
      _ref$first = _ref.first,
      first = _ref$first === void 0 ? 1 : _ref$first,
      _ref$number = _ref.number,
      number = _ref$number === void 0 ? 5 : _ref$number,
      selected = _ref.selected,
      expanded = _ref.expanded,
      _ref$selectOnToggle = _ref.selectOnToggle,
      selectOnToggle = _ref$selectOnToggle === void 0 ? true : _ref$selectOnToggle,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      _ref$onExpanded = _ref.onExpanded,
      onExpanded = _ref$onExpanded === void 0 ? function () {
    return null;
  } : _ref$onExpanded,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? function (_ref2) {
    var message = _ref2.message,
        error = _ref2.error;
    return console.error("".concat(message, "\n").concat(error));
  } : _ref$onError,
      _ref$EntityTreeListCo = _ref.EntityTreeListComponent,
      EntityTreeListComponent = _ref$EntityTreeListCo === void 0 ? EntityTreeList : _ref$EntityTreeListCo,
      _ref$EntityTreeListPr = _ref.EntityTreeListProps,
      EntityTreeListProps = _ref$EntityTreeListPr === void 0 ? {} : _ref$EntityTreeListPr,
      _ref$TreeViewProps = _ref.TreeViewProps,
      TreeViewProps = _ref$TreeViewProps === void 0 ? {} : _ref$TreeViewProps;

  var _React$useState = React__default.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      searchResultType = _React$useState2[0],
      setSearchResultType = _React$useState2[1];

  var _React$useState3 = React__default.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      hits = _React$useState4[0],
      setHits = _React$useState4[1];

  var _searchResultType$ent = searchResultType.entry,
      entries = _searchResultType$ent === void 0 ? [] : _searchResultType$ent;

  var onRootSearch = function onRootSearch() {
    try {
      search.searchItemCollection(_objectSpread2(_objectSpread2({}, searchState), {}, {
        matrixParams: {
          first: first,
          number: number
        }
      })).then(function (_ref3) {
        var data = _ref3.data;
        setSearchResultType(data);
        setHits(data.hits);
      })["catch"](function (error) {
        onError({
          message: 'Could not search',
          error: error
        });
      });
    } catch (error) {
      onError({
        message: 'Could not search',
        error: error
      });
    }
  };

  var onRootSearchMore = React__default.useCallback(function (amountOfRootEntries) {
    var nextFirst = amountOfRootEntries + 1;
    if (nextFirst > hits) return;

    try {
      search.searchItemCollection(_objectSpread2(_objectSpread2({}, searchState), {}, {
        matrixParams: {
          first: nextFirst,
          number: number
        }
      })).then(function (_ref4) {
        var data = _ref4.data;

        var _data$entry = data.entry,
            newEntries = _data$entry === void 0 ? [] : _data$entry,
            newEntryProps = _objectWithoutProperties(data, ["entry"]);

        setSearchResultType(function (old) {
          return _objectSpread2(_objectSpread2({}, newEntryProps), {}, {
            entry: [].concat(_toConsumableArray(newEntries), _toConsumableArray(old.entry))
          });
        });
        setHits(data.hits);
      })["catch"](function (error) {
        onError({
          message: 'Could not search for more',
          error: error
        });
      });
    } catch (error) {
      onError({
        message: 'Could not search for more',
        error: error
      });
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [searchResultType]);

  var isToggleTarget = function isToggleTarget(event) {
    var _event$target = event.target;
    _event$target = _event$target === void 0 ? {} : _event$target;
    var _event$target$parentE = _event$target.parentElement,
        parentElement = _event$target$parentE === void 0 ? {} : _event$target$parentE;
    var grandParentElement = parentElement.parentElement || {};
    return parentElement.className === 'MuiTreeItem-iconContainer' || grandParentElement.className === 'MuiTreeItem-iconContainer';
  };

  var onNodeSelect = function onNodeSelect(event, nodeId) {
    if (!selectOnToggle && isToggleTarget(event)) return;

    if (typeof nodeId === 'string') {
      if (nodeId.startsWith(LOAD_MORE) || nodeId.startsWith(DROP_ZONE_ROOT)) return;
    }

    onChange(nodeId);
  };

  var onNodeToggle = function onNodeToggle(_, nodeIds) {
    onExpanded(nodeIds);
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  React__default.useEffect(onRootSearch, [rootCollectionId]);
  return /*#__PURE__*/React__default.createElement(TreeView, _extends({
    className: clsx(classes.root, 'VdtEntityTree-root', className),
    defaultCollapseIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    defaultExpandIcon: /*#__PURE__*/React__default.createElement(ChevronRightIcon, null),
    onNodeSelect: onNodeSelect,
    onNodeToggle: onNodeToggle,
    selected: selected,
    expanded: expanded // eslint-disable-next-line react/jsx-props-no-spreading

  }, TreeViewProps), /*#__PURE__*/React__default.createElement(EntityTreeProvider, null, /*#__PURE__*/React__default.createElement(EntityTreeListComponent, _extends({
    hits: hits,
    entries: entries,
    collectionId: rootCollectionId,
    onLoadMore: onRootSearchMore,
    onAdjustHits: function onAdjustHits(amount) {
      return setHits(function (old) {
        return old + amount;
      });
    },
    onError: onError // eslint-disable-next-line react/jsx-props-no-spreading

  }, EntityTreeListProps))));
};

var EntityTree$1 = withStyles$1(styles$1C, {
  name: 'VdtEntityTree'
})(EntityTree);

function LinearProgressWithLabel(props) {
  var value = props.value;
  return /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    width: "100%",
    mr: 1
  }, /*#__PURE__*/React__default.createElement(LinearProgress$1, _extends({
    variant: "determinate" // eslint-disable-next-line react/jsx-props-no-spreading

  }, props))), /*#__PURE__*/React__default.createElement(Box, {
    minWidth: 35
  }, value && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, "".concat(Math.round(value), "%"))));
}

var styles$1D = function styles(theme) {
  return {
    fileListItemSecondaryAction: {
      visibility: 'hidden'
    },
    fileListItemContainer: {
      cursor: 'pointer',
      '&:not(:first-of-type)': {
        marginTop: theme.spacing(0.5)
      },
      backgroundColor: emphasize(theme.palette.background.paper, 0.05),
      '&:hover $fileListItemSecondaryAction': {
        visibility: 'visible'
      },
      '&:hover $successIcon': {
        visibility: 'hidden'
      },
      '&:hover $progressIcon': {
        visibility: 'hidden'
      }
    },
    fileListItemContainerComplete: {
      cursor: 'default'
    },
    fileListItemContainerHover: {
      '&:hover': {
        backgroundColor: emphasize(theme.palette.background.paper, 0.1)
      }
    },
    successIcon: {
      color: theme.palette.success.main,
      visibility: 'visible'
    },
    progressIcon: {
      visibility: 'visible'
    },
    errorIcon: {
      color: theme.palette.error.main
    },
    progressRoot: {
      minHeight: 16
    },
    thumbsContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginTop: 16
    },
    thumb: {
      display: 'inline-flex',
      borderRadius: 2,
      border: '1px solid #eaeaea',
      marginBottom: 8,
      marginRight: 8,
      width: 80,
      height: 80,
      padding: 4,
      boxSizing: 'border-box'
    },
    thumbInner: {
      display: 'flex',
      width: '100%',
      overflow: 'hidden'
    },
    media: {
      display: 'block',
      width: 'auto',
      height: '100%'
    },
    full: {
      width: '100%',
      height: '100%'
    }
  };
};

function UploadListItem(_ref) {
  var classes = _ref.classes,
      file = _ref.file,
      progress = _ref.progress,
      onRemove = _ref.onRemove,
      onClick = _ref.onClick,
      selected = _ref.selected,
      isUploading = _ref.isUploading,
      _ref$ProgressComponen = _ref.ProgressComponent,
      ProgressComponent = _ref$ProgressComponen === void 0 ? LinearProgressWithLabel : _ref$ProgressComponen,
      _ref$ProgressProps = _ref.ProgressProps,
      ProgressProps = _ref$ProgressProps === void 0 ? {} : _ref$ProgressProps,
      _ref$CompleteIcon = _ref.CompleteIcon,
      CompleteIcon = _ref$CompleteIcon === void 0 ? CheckCircleIcon : _ref$CompleteIcon,
      _ref$ProgressIcon = _ref.ProgressIcon,
      ProgressIcon = _ref$ProgressIcon === void 0 ? QueryBuilderIcon : _ref$ProgressIcon,
      _ref$DeleteIcon = _ref.DeleteIcon,
      DeleteIcon$1 = _ref$DeleteIcon === void 0 ? DeleteIcon : _ref$DeleteIcon,
      _ref$MimeTypeAvatarIc = _ref.MimeTypeAvatarIcon,
      MimeTypeAvatarIcon = _ref$MimeTypeAvatarIc === void 0 ? MimeTypeIcon$1 : _ref$MimeTypeAvatarIc;
  var mimeType = file.type,
      size = file.size,
      name = file.name,
      preview = file.preview;
  var progressPercent = progress && progress.transferedBytes ? Math.floor(progress.transferedBytes / progress.totalBytes * 100) : 0;
  var isComplete = progressPercent === 100;
  var fileSizeHuman = size ? parseFileSize(size) : undefined;
  var previewType;

  if (mimeType.includes('image')) {
    previewType = 'image';
  } else if (mimeType.includes('video')) {
    previewType = 'video';
  } else {
    previewType = 'other';
  }

  return /*#__PURE__*/React__default.createElement(ListItem$1, {
    ContainerComponent: "div",
    ContainerProps: {
      className: clsx(classes.fileListItemContainer, _defineProperty({}, classes.fileListItemContainerHover, !selected), _defineProperty({}, classes.fileListItemContainerComplete, isComplete))
    },
    onClick: isComplete ? undefined : onClick,
    selected: selected
  }, /*#__PURE__*/React__default.createElement("aside", {
    className: classes.thumbsContainer
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.thumb,
    key: name
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.thumbInner
  }, previewType === 'image' && /*#__PURE__*/React__default.createElement("img", {
    src: preview,
    className: classes.media,
    alt: name
  }), previewType === 'video' && /*#__PURE__*/React__default.createElement("video", {
    className: classes.media,
    autoPlay: true,
    muted: true
  }, /*#__PURE__*/React__default.createElement("source", {
    src: preview,
    type: mimeType
  })), previewType === 'other' && /*#__PURE__*/React__default.createElement(ListItemAvatar$1, {
    className: classes.full
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    variant: "square",
    className: classes.full
  }, /*#__PURE__*/React__default.createElement(MimeTypeAvatarIcon, {
    mimeType: mimeType,
    fontSize: "large"
  })))))), /*#__PURE__*/React__default.createElement(ListItemText, {
    disableTypography: true,
    primary: /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body1",
      component: "span",
      display: "block",
      noWrap: true
    }, name), size && /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body2",
      component: "span",
      display: "block",
      noWrap: true
    }, fileSizeHuman), /*#__PURE__*/React__default.createElement("div", {
      className: classes.progressRoot
    }, progress && /*#__PURE__*/React__default.createElement(ProgressComponent, _extends({
      value: progressPercent // eslint-disable-next-line react/jsx-props-no-spreading

    }, ProgressProps))))
  }), progress && /*#__PURE__*/React__default.createElement(ListItemSecondaryAction$1, null, isComplete ? /*#__PURE__*/React__default.createElement(CompleteIcon, {
    className: classes.successIcon
  }) : /*#__PURE__*/React__default.createElement(ProgressIcon, {
    className: classes.progressIcon
  })), /*#__PURE__*/React__default.createElement(ListItemSecondaryAction$1, {
    classes: {
      root: classes.fileListItemSecondaryAction
    }
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    edge: "end",
    onClick: onRemove,
    disabled: isUploading
  }, /*#__PURE__*/React__default.createElement(DeleteIcon$1, null))));
}

var UploadListItem$1 = withStyles(styles$1D, {
  name: 'VdtUploadListItem'
})(UploadListItem);

function UploadListFolder(_ref) {
  var path = _ref.path,
      descendants = _ref.files,
      props = _objectWithoutProperties(_ref, ["path", "files"]);

  var totalBytes = descendants.reduce(function (total, f) {
    return total + f.file.size || 0;
  }, 0);
  var transferedBytes = descendants.reduce(function (total, f) {
    return total + (f.progress && f.progress.transferedBytes || 0);
  }, 0);
  var started = descendants.some(function (c) {
    return c.progress;
  });
  var dummyProgress = (started || undefined) && {
    transferedBytes: transferedBytes,
    totalBytes: totalBytes
  };
  var dummyFile = {
    size: totalBytes,
    type: 'collection',
    name: path.split('/').pop()
  };
  return /*#__PURE__*/React__default.createElement(UploadListItem$1, _extends({
    file: dummyFile,
    progress: dummyProgress // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

var styles$1E = function styles(theme) {
  return {
    form: {
      '& > *': {
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5)
      }
    }
  };
};

function UploadForm(_ref) {
  var classes = _ref.classes,
      onChange = _ref.onChange,
      values = _ref.values;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.form
  }, /*#__PURE__*/React__default.createElement(TextField$2, {
    onChange: onChange('title'),
    value: values.title,
    label: "Title",
    variant: "outlined",
    required: true,
    fullWidth: true,
    InputLabelProps: {
      shrink: true
    }
  }), /*#__PURE__*/React__default.createElement(TextField$2, {
    onChange: onChange('dsc'),
    value: values.dsc,
    label: "Description",
    variant: "outlined",
    rows: "8",
    multiline: true,
    fullWidth: true,
    InputLabelProps: {
      shrink: true
    }
  }), /*#__PURE__*/React__default.createElement(Autocomplete, {
    onChange: onChange('tcd') // eslint-disable-next-line no-nested-ternary
    ,
    value: Array.isArray(values.tcd) ? values.tcd : values.tcd ? [values.tcd] : [],
    multiple: true,
    freeSolo: true,
    selectOnFocus: true,
    clearOnBlur: true,
    handleHomeEndKeys: true,
    options: [],
    onInputChange: function onInputChange(event, value) {
      if (value.endsWith(',')) {
        var _value$split = value.split(','),
            _value$split2 = _slicedToArray(_value$split, 1),
            newValue = _value$split2[0]; // eslint-disable-next-line no-nested-ternary


        var currentArray = Array.isArray(values.tcd) ? values.tcd : values.tcd ? [values.tcd] : [];
        var newArray = [].concat(_toConsumableArray(currentArray), [newValue]);
        onChange('tcd')(event, newArray);
      }
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$2 // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, params, {
        variant: "outlined",
        label: "Tags",
        InputLabelProps: {
          shrink: true
        }
      }));
    }
  })));
}

var UploadForm$1 = withStyles(styles$1E, {
  name: 'VdtUploadForm'
})(UploadForm);

var styles$1F = function styles(theme) {
  return {
    root: {
      backgroundColor: theme.palette.action.selected,
      height: '100%',
      padding: theme.spacing(2)
    },
    title: _objectSpread2(_objectSpread2({}, theme.typography.body1), {}, {
      paddingLeft: theme.spacing(2),
      marginBottom: theme.spacing(1),
      fontStyle: 'italic',
      fontWeight: 600,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }),
    form: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background["default"]
    }
  };
};

function UploadEditor(_ref) {
  var classes = _ref.classes,
      file = _ref.file,
      _ref$metadata = _ref.metadata,
      metadata = _ref$metadata === void 0 ? {} : _ref$metadata,
      handleOnChange = _ref.onChange,
      _ref$UploadFormCompon = _ref.UploadFormComponent,
      UploadFormComponent = _ref$UploadFormCompon === void 0 ? UploadForm$1 : _ref$UploadFormCompon,
      _ref$UploadFormProps = _ref.UploadFormProps,
      UploadFormProps = _ref$UploadFormProps === void 0 ? {} : _ref$UploadFormProps;
  var name = file.name;

  var onChange = function onChange(key) {
    return function (event, arrayValue) {
      var value = event.target.value;

      var newValues = _defineProperty({}, key, arrayValue || value);

      handleOnChange(newValues);
    };
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.title
  }, name), /*#__PURE__*/React__default.createElement("div", {
    className: classes.form
  }, /*#__PURE__*/React__default.createElement(UploadFormComponent, _extends({
    values: metadata,
    onChange: onChange // eslint-disable-next-line react/jsx-props-no-spreading

  }, UploadFormProps))));
}

var UploadEditor$1 = withStyles(styles$1F, {
  name: 'VdtUploadEditor'
})(UploadEditor);

function fileToPathTree(file) {
  var result = {};
  var pathComponents = file.file.path.split('/').filter(function (p) {
    return p.length > 0;
  });
  pathComponents[0] = "/".concat(pathComponents[0]);
  var subPaths = pathComponents.map(function (_, idx) {
    return pathComponents.slice(0, idx + 1).join('/');
  });
  subPaths.reduce( // eslint-disable-next-line no-return-assign, no-param-reassign
  function (obj, key, index, arr) {
    return obj[key] = arr.length === index + 1 ? file : {};
  }, result);
  return result;
}

function parseFilesIntoTree(files) {
  return merge.apply(void 0, _toConsumableArray(files.map(function (f) {
    return fileToPathTree(f);
  })));
}

function FileTreeNode(_ref) {
  var fileTree = _ref.fileTree,
      files = _ref.files,
      props = _objectWithoutProperties(_ref, ["fileTree", "files"]);

  var clickFile = props.clickFile,
      removeFile = props.removeFile,
      removeFolder = props.removeFolder,
      selectedFilePath = props.selectedFilePath,
      FileComponent = props.FileComponent,
      FileProps = props.FileProps,
      FolderComponent = props.FolderComponent,
      FolderProps = props.FolderProps;
  return Object.entries(fileTree).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        path = _ref3[0],
        child = _ref3[1];

    if (child.file instanceof File) {
      return /*#__PURE__*/React__default.createElement(TreeItem, {
        nodeId: path,
        key: path,
        label: /*#__PURE__*/React__default.createElement(FileComponent, _extends({
          key: path,
          file: child.file,
          progress: child.progress,
          onRemove: removeFile(child.file.path),
          onClick: clickFile(child.file.path),
          selected: selectedFilePath === child.file.path // eslint-disable-next-line react/jsx-props-no-spreading

        }, FileProps))
      });
    }

    return /*#__PURE__*/React__default.createElement(TreeItem, {
      key: "".concat(path),
      nodeId: "".concat(path),
      label: /*#__PURE__*/React__default.createElement(FolderComponent, _extends({
        path: path,
        files: files.filter(function (f) {
          return f.file.path.startsWith("".concat(path, "/"));
        }),
        onRemove: removeFolder(path) // eslint-disable-next-line react/jsx-props-no-spreading

      }, FolderProps))
    }, /*#__PURE__*/React__default.createElement(FileTreeNode, _extends({
      fileTree: child,
      files: files // eslint-disable-next-line react/jsx-props-no-spreading

    }, props)));
  });
}

function FileTree$1(_ref4) {
  var files = _ref4.files,
      removeFiles = _ref4.removeFiles,
      onClickFile = _ref4.onClickFile,
      selectedFile = _ref4.selectedFile,
      FileComponent = _ref4.FileComponent,
      _ref4$FileProps = _ref4.FileProps,
      FileProps = _ref4$FileProps === void 0 ? {} : _ref4$FileProps,
      FolderComponent = _ref4.FolderComponent,
      _ref4$FolderProps = _ref4.FolderProps,
      FolderProps = _ref4$FolderProps === void 0 ? {} : _ref4$FolderProps;
  var fileTree = React__default.useMemo(function () {
    return parseFilesIntoTree(files);
  }, [files]);

  var removeFolder = function removeFolder(path) {
    return function () {
      var idxsToRemove = files.map(function (f, i) {
        return f.file.path.startsWith("".concat(path, "/")) && i;
      }).filter(function (i) {
        return i !== false;
      });
      removeFiles(idxsToRemove)();
    };
  };

  var removeFile = function removeFile(path) {
    return function () {
      var idx = files.findIndex(function (f) {
        return f.file.path === path;
      });
      removeFiles([idx])();
    };
  };

  var clickFile = function clickFile(path) {
    return function () {
      var idx = files.findIndex(function (f) {
        return f.file.path === path;
      });
      onClickFile(idx)();
    };
  };

  var selectedFilePath = React__default.useMemo(function () {
    if (Number.isNaN(selectedFile)) return undefined;
    if (selectedFile < 0 || selectedFile >= files.length) return undefined;
    if (!files[selectedFile]) return undefined;
    return files[selectedFile].file.path;
  }, [selectedFile, files]);
  return fileTree && /*#__PURE__*/React__default.createElement(TreeView, null, /*#__PURE__*/React__default.createElement(FileTreeNode, {
    fileTree: fileTree,
    files: files,
    clickFile: clickFile,
    removeFile: removeFile,
    removeFolder: removeFolder,
    onClickFile: onClickFile,
    selectedFilePath: selectedFilePath,
    FileComponent: FileComponent,
    FileProps: FileProps,
    FolderComponent: FolderComponent,
    FolderProps: FolderProps
  }));
}

function SplitButton(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      value = _ref.value,
      defaultOption = _ref.defaultOption,
      options = _ref.options,
      onChange = _ref.onChange,
      _ref$getOptionLabel = _ref.getOptionLabel,
      getOptionLabel = _ref$getOptionLabel === void 0 ? function (o) {
    return o.label;
  } : _ref$getOptionLabel,
      _ref$getOptionOnClick = _ref.getOptionOnClick,
      getOptionOnClick = _ref$getOptionOnClick === void 0 ? function (o) {
    return o.onClick;
  } : _ref$getOptionOnClick,
      _ref$getOptionDisable = _ref.getOptionDisabled,
      getOptionDisabled = _ref$getOptionDisable === void 0 ? function (o) {
    return o.disabled || false;
  } : _ref$getOptionDisable,
      _ref$getOptionSelecte = _ref.getOptionSelected,
      getOptionSelected = _ref$getOptionSelecte === void 0 ? function (o, val) {
    return o.label === val.label;
  } : _ref$getOptionSelecte;

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var anchorRef = React__default.useRef(null);

  var _React$useState3 = React__default.useState(defaultOption || options[0]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      selectedOption = _React$useState4[0],
      setSelectedOption = _React$useState4[1];

  var selected = value || options.find(function (o) {
    return getOptionSelected(o, selectedOption);
  });

  var handleMenuItemClick = function handleMenuItemClick(option) {
    if (onChange) onChange(option);
    setSelectedOption(option);
    setOpen(false);
  };

  var handleToggle = function handleToggle() {
    setOpen(function (prevOpen) {
      return !prevOpen;
    });
  };

  var handleClose = function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, 'VdtSplitButton-root', className)
  }, /*#__PURE__*/React__default.createElement(ButtonGroup, {
    variant: "contained",
    color: "primary",
    ref: anchorRef
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: getOptionOnClick(selected),
    disabled: getOptionDisabled(selected)
  }, getOptionLabel(selected)), options.length > 1 && /*#__PURE__*/React__default.createElement(Button$1, {
    color: "primary",
    size: "small",
    onClick: handleToggle,
    disabled: options.every(function (o) {
      return o.disabled;
    })
  }, /*#__PURE__*/React__default.createElement(ArrowDropDownIcon, null))), /*#__PURE__*/React__default.createElement(Popper, {
    open: open,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true,
    disablePortal: true
  }, /*#__PURE__*/React__default.createElement(Paper, null, /*#__PURE__*/React__default.createElement(ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/React__default.createElement(MenuList, null, options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      key: getOptionLabel(option),
      disabled: getOptionDisabled(option),
      selected: option === selected,
      onClick: function onClick() {
        return handleMenuItemClick(option);
      }
    }, getOptionLabel(option));
  }))))));
}

var SplitButton$1 = withStyles({}, {
  name: 'VdtSplitButton'
})(SplitButton);

var styles$1G = function styles(theme) {
  return {
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    dropzoneRoot: {
      cursor: 'pointer',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5)
    },
    dropzoneLabel: _objectSpread2({
      color: theme.palette.text.secondary
    }, theme.typography.body1),
    dropzoneInput: {
      marginTop: theme.spacing(0.5),
      minHeight: '50vh',
      minWidth: theme.spacing(4),
      borderWidth: 2,
      borderColor: 'grey',
      borderRadius: 3,
      borderStyle: 'dotted',
      backgroundColor: 'rgba(0,0,0,0.05)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'min-height 0.3s'
    },
    dropzoneDrag: {
      borderStyle: 'solid',
      backgroundColor: 'rgba(0,0,0,0.1)'
    },
    dropzoneHasFiles: {
      minHeight: theme.spacing(8)
    },
    dialogContentRoot: {
      display: 'flex'
    },
    filesRoot: {
      width: '100%',
      transition: 'width 0.3s'
    },
    editorRoot: {
      width: 0,
      transition: 'width 0.3s',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    editorOpen: {
      backgroundColor: emphasize(theme.palette.background.paper, 0.05)
    },
    isEditing: {
      width: '50%'
    },
    uploadToCollectionDialog: {
      position: 'absolute',
      top: '20%'
    },
    divider: {
      margin: '20px 0 20px 0'
    }
  };
};

function ExtendedFileTree(_ref) {
  var _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? -1 : _ref$selected,
      _ref$startIndex = _ref.startIndex,
      startIndex = _ref$startIndex === void 0 ? 0 : _ref$startIndex,
      onClickFile = _ref.onClickFile,
      removeFiles = _ref.removeFiles,
      rest = _objectWithoutProperties(_ref, ["selected", "startIndex", "onClickFile", "removeFiles"]);

  var handleClickFile = function handleClickFile(idx) {
    return onClickFile(idx + startIndex);
  };

  var handleRemoveFiles = function handleRemoveFiles(idx) {
    return removeFiles(idx.map(function (v) {
      return v + startIndex;
    }));
  };

  return /*#__PURE__*/React__default.createElement(FileTree$1, _extends({
    selectedFile: selected - startIndex,
    onClickFile: handleClickFile,
    removeFiles: handleRemoveFiles // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest));
}

function UploadCollectionPicker(_ref2) {
  var onSubmit = _ref2.onSubmit,
      props = _objectWithoutProperties(_ref2, ["onSubmit"]);

  var onCreate = function onCreate(_, collectionDocument) {
    return collection.createCollection({
      collectionDocument: collectionDocument
    }).then(function (_ref3) {
      var id = _ref3.data.id;
      return [id];
    });
  };

  return /*#__PURE__*/React__default.createElement(AddToCollectionDialog$1, _extends({
    className: "VdtUploadCollectionPicker-root",
    entities: [],
    titleText: "Upload To Collection",
    submitText: "Upload",
    onSubmit: function onSubmit(_, ids) {
      return ids;
    },
    onCreate: onCreate,
    onSuccess: function onSuccess(_, ids) {
      return onSubmit(ids);
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

function Upload(_ref4) {
  var _clsx2, _clsx3;

  var classes = _ref4.classes,
      onSuccess = _ref4.onSuccess,
      _ref4$useUploadFiles = _ref4.useUploadFiles,
      useUploadFiles$1 = _ref4$useUploadFiles === void 0 ? useUploadFiles : _ref4$useUploadFiles,
      _ref4$uploadProps = _ref4.uploadProps,
      uploadProps = _ref4$uploadProps === void 0 ? {} : _ref4$uploadProps,
      _ref4$UploadListItemC = _ref4.UploadListItemComponent,
      UploadListItemComponent = _ref4$UploadListItemC === void 0 ? UploadListItem$1 : _ref4$UploadListItemC,
      _ref4$UploadListItemP = _ref4.UploadListItemProps,
      UploadListItemProps = _ref4$UploadListItemP === void 0 ? {} : _ref4$UploadListItemP,
      _ref4$tree = _ref4.tree,
      tree = _ref4$tree === void 0 ? false : _ref4$tree,
      _ref4$responseTimeout = _ref4.responseTimeout,
      responseTimeout = _ref4$responseTimeout === void 0 ? 5000 : _ref4$responseTimeout,
      _ref4$UploadListFileC = _ref4.UploadListFileComponent,
      UploadListFileComponent = _ref4$UploadListFileC === void 0 ? UploadListItem$1 : _ref4$UploadListFileC,
      _ref4$UploadListFileP = _ref4.UploadListFileProps,
      UploadListFileProps = _ref4$UploadListFileP === void 0 ? {} : _ref4$UploadListFileP,
      _ref4$UploadListFolde = _ref4.UploadListFolderComponent,
      UploadListFolderComponent = _ref4$UploadListFolde === void 0 ? UploadListFolder : _ref4$UploadListFolde,
      _ref4$UploadListFolde2 = _ref4.UploadListFolderProps,
      UploadListFolderProps = _ref4$UploadListFolde2 === void 0 ? {} : _ref4$UploadListFolde2,
      _ref4$FileTreeCompone = _ref4.FileTreeComponent,
      FileTreeComponent = _ref4$FileTreeCompone === void 0 ? ExtendedFileTree : _ref4$FileTreeCompone,
      _ref4$FileTreeProps = _ref4.FileTreeProps,
      FileTreeProps = _ref4$FileTreeProps === void 0 ? {} : _ref4$FileTreeProps,
      _ref4$UploadEditorCom = _ref4.UploadEditorComponent,
      UploadEditorComponent = _ref4$UploadEditorCom === void 0 ? UploadEditor$1 : _ref4$UploadEditorCom,
      _ref4$UploadEditorPro = _ref4.UploadEditorProps,
      UploadEditorProps = _ref4$UploadEditorPro === void 0 ? {} : _ref4$UploadEditorPro,
      _ref4$UploadCollectio = _ref4.UploadCollectionPickerComponent,
      UploadCollectionPickerComponent = _ref4$UploadCollectio === void 0 ? UploadCollectionPicker : _ref4$UploadCollectio,
      _ref4$UploadCollectio2 = _ref4.UploadCollectionPickerProps,
      UploadCollectionPickerProps = _ref4$UploadCollectio2 === void 0 ? {} : _ref4$UploadCollectio2,
      _ref4$UploadCollectio3 = _ref4.UploadCollectionDialogProps,
      UploadCollectionDialogProps = _ref4$UploadCollectio3 === void 0 ? {} : _ref4$UploadCollectio3,
      _ref4$allowUploadToCo = _ref4.allowUploadToCollection,
      allowUploadToCollection = _ref4$allowUploadToCo === void 0 ? true : _ref4$allowUploadToCo,
      _ref4$allowUpload = _ref4.allowUpload,
      allowUpload = _ref4$allowUpload === void 0 ? true : _ref4$allowUpload,
      _ref4$UploadButtonDis = _ref4.UploadButtonDisabledText,
      UploadButtonDisabledText = _ref4$UploadButtonDis === void 0 ? 'Uploading' : _ref4$UploadButtonDis,
      _ref4$UploadButtonTex = _ref4.UploadButtonText,
      UploadButtonText = _ref4$UploadButtonTex === void 0 ? 'Upload' : _ref4$UploadButtonTex,
      _ref4$UploadToCollect = _ref4.UploadToCollectionButtonText,
      UploadToCollectionButtonText = _ref4$UploadToCollect === void 0 ? 'Upload To Collection' : _ref4$UploadToCollect,
      _ref4$DragActiveText = _ref4.DragActiveText,
      DragActiveText = _ref4$DragActiveText === void 0 ? 'Drop files here' : _ref4$DragActiveText,
      _ref4$DragInactiveTex = _ref4.DragInactiveText,
      DragInactiveText = _ref4$DragInactiveTex === void 0 ? 'Drop files or click to open' : _ref4$DragInactiveTex;

  var _React$useState = React__default.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isEditing = _React$useState2[0],
      setIsEditing = _React$useState2[1];

  var _React$useState3 = React__default.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isUploading = _React$useState4[0],
      setIsUploading = _React$useState4[1];

  var _useUploadFiles = useUploadFiles$1(uploadProps),
      onAddFiles = _useUploadFiles.onAddFiles,
      onChangeMetadata = _useUploadFiles.onChangeMetadata,
      onUpload = _useUploadFiles.onUpload,
      onRemoveFiles = _useUploadFiles.onRemoveFiles,
      onRemoveFile = _useUploadFiles.onRemoveFile,
      files = _useUploadFiles.files;

  var queue = files.filter(function (file) {
    return !file.progress;
  });
  var uploaded = files.filter(function (file) {
    return file.progress;
  });

  var handleRemoveFiles = function handleRemoveFiles(idxs) {
    return function () {
      if (idxs.includes(isEditing)) setIsEditing();
      onRemoveFiles(idxs)();
    };
  };

  var handleRemoveFile = function handleRemoveFile(idx) {
    return function () {
      if (isEditing === idx) setIsEditing();
      onRemoveFile(idx)();
    };
  };

  var onOpenEdit = function onOpenEdit(idx) {
    return function () {
      return setIsEditing(function (curr) {
        return curr === idx ? undefined : idx;
      });
    };
  };

  var _useDropzone = useDropzone({
    onDrop: function onDrop(acceptedFiles) {
      onAddFiles(acceptedFiles.map(function (file) {
        return Object.assign(file, {
          preview: URL.createObjectURL(file)
        });
      }));
    }
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive;

  var _onSubmit = React__default.useCallback(function (submitProps) {
    setIsEditing();
    setIsUploading(true);
    onUpload(submitProps).then(function (result) {
      setIsUploading(false);
      setTimeout(function () {
        if (onSuccess) onSuccess(result);
      }, responseTimeout);
    })["catch"](function () {
      setIsUploading(false);
    });
  }, [onSuccess, onUpload, responseTimeout]);

  var disableUpload = queue.length === 0 || isUploading;

  var _React$useState5 = React__default.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      openUploadCollection = _React$useState6[0],
      setOpenUploadCollection = _React$useState6[1];

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.dialogContentRoot
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.filesRoot, _defineProperty({}, classes.isEditing, isEditing !== undefined))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.dropzoneRoot
  }, /*#__PURE__*/React__default.createElement("div", _extends({}, getRootProps(), {
    className: clsx(classes.dropzoneInput, (_clsx2 = {}, _defineProperty(_clsx2, classes.dropzoneDrag, isDragActive), _defineProperty(_clsx2, classes.dropzoneHasFiles, files.length > 0), _clsx2))
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classes.dropzoneLabel
  }, isDragActive ? DragActiveText : DragInactiveText), /*#__PURE__*/React__default.createElement("input", getInputProps()))), queue.length > 0 && (tree ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h3", null, "Queue"), /*#__PURE__*/React__default.createElement(FileTreeComponent, _extends({
    files: queue,
    FileComponent: UploadListFileComponent,
    FileProps: _objectSpread2({
      isUploading: isUploading
    }, UploadListFileProps),
    FolderComponent: UploadListFolderComponent,
    FolderProps: UploadListFolderProps,
    removeFiles: handleRemoveFiles,
    onClickFile: onOpenEdit,
    selected: isEditing // eslint-disable-next-line react/jsx-props-no-spreading

  }, FileTreeProps)), /*#__PURE__*/React__default.createElement(Divider$1, {
    className: classes.divider
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(List$1, {
    dense: true
  }, /*#__PURE__*/React__default.createElement("h3", null, "Queue"), queue.map(function (file, idx) {
    return /*#__PURE__*/React__default.createElement(UploadListItemComponent, _extends({
      key: file.file.name,
      file: file.file,
      progress: file.progress,
      onRemove: handleRemoveFile(idx),
      onClick: onOpenEdit(idx),
      selected: isEditing === idx,
      isUploading: isUploading // eslint-disable-next-line react/jsx-props-no-spreading

    }, UploadListItemProps));
  })), /*#__PURE__*/React__default.createElement(Divider$1, {
    className: classes.divider
  }))), uploaded.length > 0 && (tree ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h3", null, "Uploaded"), /*#__PURE__*/React__default.createElement(FileTreeComponent, _extends({
    files: uploaded,
    FileComponent: UploadListFileComponent,
    FileProps: _objectSpread2({
      isUploading: isUploading
    }, UploadListFileProps),
    FolderComponent: UploadListFolderComponent,
    FolderProps: UploadListFolderProps,
    removeFiles: handleRemoveFiles,
    onClickFile: onOpenEdit,
    selected: isEditing,
    startIndex: queue.length // eslint-disable-next-line react/jsx-props-no-spreading

  }, FileTreeProps)), /*#__PURE__*/React__default.createElement(Divider$1, {
    className: classes.divider
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(List$1, {
    dense: true
  }, /*#__PURE__*/React__default.createElement("h3", null, "Uploaded"), uploaded.map(function (file, idx) {
    return /*#__PURE__*/React__default.createElement(UploadListItemComponent, _extends({
      key: file.file.name,
      file: file.file,
      progress: file.progress,
      onRemove: handleRemoveFile(queue.length + idx),
      onClick: onOpenEdit(queue.length + idx),
      selected: isEditing === queue.length + idx,
      isUploading: isUploading // eslint-disable-next-line react/jsx-props-no-spreading

    }, UploadListItemProps));
  })), /*#__PURE__*/React__default.createElement(Divider$1, {
    className: classes.divider
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.editorRoot, (_clsx3 = {}, _defineProperty(_clsx3, classes.isEditing, isEditing !== undefined), _defineProperty(_clsx3, classes.editorOpen, isEditing !== undefined), _clsx3))
  }, isEditing !== undefined && /*#__PURE__*/React__default.createElement(UploadEditorComponent, _extends({
    onChange: onChangeMetadata(isEditing),
    file: files[isEditing].file,
    metadata: files[isEditing].metadata // eslint-disable-next-line react/jsx-props-no-spreading

  }, UploadEditorProps)))), /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(SplitButton$1, {
    options: [].concat(_toConsumableArray(allowUpload ? [{
      value: 'upload',
      label: isUploading ? UploadButtonDisabledText : UploadButtonText,
      onClick: function onClick(e) {
        e.preventDefault();

        _onSubmit();
      },
      disabled: disableUpload
    }] : []), _toConsumableArray(allowUploadToCollection ? [{
      value: 'upload-to-collection',
      label: isUploading ? UploadButtonDisabledText : UploadToCollectionButtonText,
      onClick: function onClick() {
        return setOpenUploadCollection(true);
      },
      disabled: disableUpload
    }] : [])),
    getOptionSelected: function getOptionSelected(o, val) {
      return o.value === val.value;
    }
  })), /*#__PURE__*/React__default.createElement(Dialog$1, _extends({
    fullWidth: true,
    open: openUploadCollection,
    onClose: function onClose() {
      return setOpenUploadCollection(false);
    },
    classes: {
      paper: classes.uploadToCollectionDialog
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, UploadCollectionDialogProps), /*#__PURE__*/React__default.createElement(UploadCollectionPickerComponent, _extends({
    onSubmit: function onSubmit(ids) {
      _onSubmit({
        collectionId: ids
      });

      setOpenUploadCollection(false);
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, UploadCollectionPickerProps))));
}

var Upload$1 = withStyles(styles$1G, {
  name: 'VdtUpload'
})(Upload);

var MediaCardContext = /*#__PURE__*/React__default.createContext();
var MediaCardProvider = function MediaCardProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React__default.createElement(MediaCardContext.Provider, {
    value: props
  }, children);
};
var useMediaCardContext = function useMediaCardContext() {
  var context = React__default.useContext(MediaCardContext);

  if (context === undefined) {
    throw new Error('useMediaCardContext must be used within a MediaCardProvider');
  }

  return context;
};

var styles$1H = function styles(theme) {
  return {
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      overflow: 'hidden'
    },
    content: {
      overflow: 'hidden'
    }
  };
};

function MediaCardFullWidthHeader(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      title = _ref.title,
      _ref$titleTypographyP = _ref.titleTypographyProps,
      titleTypographyProps = _ref$titleTypographyP === void 0 ? {
    noWrap: true
  } : _ref$titleTypographyP,
      subheader = _ref.subheader,
      _ref$subheaderTypogra = _ref.subheaderTypographyProps,
      subheaderTypographyProps = _ref$subheaderTypogra === void 0 ? {
    noWrap: true
  } : _ref$subheaderTypogra,
      props = _objectWithoutProperties(_ref, ["classes", "className", "title", "titleTypographyProps", "subheader", "subheaderTypographyProps"]);

  return /*#__PURE__*/React__default.createElement(CardHeader$1, _extends({
    className: className,
    title: title,
    titleTypographyProps: titleTypographyProps,
    subheader: subheader,
    subheaderTypographyProps: subheaderTypographyProps,
    classes: {
      root: classes.root,
      content: classes.content
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

var MediaCardFullWidthHeader$1 = withStyles(styles$1H, {
  name: 'MediaCardFullWidthHeader'
})(MediaCardFullWidthHeader);

var styles$1I = function styles(theme) {
  return {
    root: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
      '&:last-child': {
        paddingBottom: theme.spacing(1)
      }
    },
    Typography: _objectSpread2(_objectSpread2({}, theme.typography.body2), {}, {
      color: theme.palette.text.secondary
    }),
    truncate: {
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    Tooltip: {}
  };
};

function MediaCardFullWidthContent(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      content = _ref.content,
      _ref$truncateContentR = _ref.truncateContentRows,
      truncateContentRows = _ref$truncateContentR === void 0 ? 3 : _ref$truncateContentR,
      _ref$TooltipProps = _ref.TooltipProps,
      TooltipProps = _ref$TooltipProps === void 0 ? {} : _ref$TooltipProps,
      _ref$TypographyProps = _ref.TypographyProps,
      TypographyProps = _ref$TypographyProps === void 0 ? {} : _ref$TypographyProps,
      _ref$enterDelay = _ref.enterDelay,
      enterDelay = _ref$enterDelay === void 0 ? 500 : _ref$enterDelay,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'p' : _ref$component;
  return /*#__PURE__*/React__default.createElement(CardContent$1, {
    className: clsx(className, classes.root)
  }, /*#__PURE__*/React__default.createElement(Tooltip, _extends({
    className: classes.Tooltip,
    title: content,
    enterDelay: enterDelay // eslint-disable-next-line react/jsx-props-no-spreading

  }, TooltipProps), /*#__PURE__*/React__default.createElement(Typography, _extends({
    className: clsx(classes.Typography, _defineProperty({}, classes.truncate, truncateContentRows)),
    component: component,
    style: {
      WebkitLineClamp: truncateContentRows === false ? undefined : truncateContentRows
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, TypographyProps), content)));
}

var MediaCardFullWidthContent$1 = withStyles(styles$1I, {
  name: 'VdtMediaCardFullWidthContent'
})(MediaCardFullWidthContent);

var styles$1J = function styles(theme) {
  return {
    root: {
      width: '100%',
      borderColor: 'transparent',
      borderWidth: 0.7,
      borderStyle: 'solid',
      transition: 'border-color .2s ease-out'
    },
    selected: {
      borderColor: theme.palette.secondary.main
    }
  };
};

function MediaCardFullWidthCard(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      selected = _ref.selected,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "classes", "selected", "children"]);

  return /*#__PURE__*/React__default.createElement(Card$1, _extends({
    className: clsx(classes.root, _defineProperty({}, classes.selected, selected), 'VdtMediaCardFullWidthCard-root', className),
    elevation: 2 // eslint-disable-next-line react/jsx-props-no-spreading

  }, props), children);
}

var MediaCardFullWidthCard$1 = withStyles(styles$1J, {
  name: 'VdtMediaCardFullWidthCard'
})(MediaCardFullWidthCard);

var styles$1K = function styles(theme) {
  return {
    root: {
      height: '100%',
      display: 'flex',
      alignItems: 'flex-end'
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    expanded: {
      transform: 'rotate(180deg)'
    },
    IconComponent: {}
  };
};

function MediaCardExpand(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      expanded = _ref.expanded,
      onExpand = _ref.onExpand,
      _ref$IconComponent = _ref.IconComponent,
      IconComponent = _ref$IconComponent === void 0 ? ExpandMoreIcon : _ref$IconComponent;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(className, classes.root)
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    className: clsx(classes.expand, _defineProperty({}, classes.expanded, expanded)),
    onClick: onExpand
  }, /*#__PURE__*/React__default.createElement(IconComponent, {
    className: classes.IconComponent
  })));
}

var MediaCardExpand$1 = withStyles(styles$1K, {
  name: 'VdtMediaCardExpand'
})(MediaCardExpand);

var styles$1L = function styles(theme) {
  return {
    root: {
      width: '100%',
      padding: theme.spacing(1)
    },
    overflow: {
      overflow: 'hidden'
    },
    grow: {
      flexGrow: 1
    },
    pushRight: {
      marginLeft: 'auto'
    }
  };
};
function MediaCardFullWidth(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      onClick = _ref.onClick,
      onExpand = _ref.onExpand,
      controlledExpanded = _ref.expanded,
      defaultExpanded = _ref.defaultExpanded,
      onSelect = _ref.onSelect,
      controlledSelected = _ref.selected,
      defaultSelected = _ref.defaultSelected,
      title = _ref.title,
      subheader = _ref.subheader,
      image = _ref.image,
      content = _ref.content,
      expandedContent = _ref.expandedContent,
      CardComponent = _ref.CardComponent,
      CardProps = _ref.CardProps,
      HeaderComponent = _ref.HeaderComponent,
      HeaderProps = _ref.HeaderProps,
      ThumbnailComponent = _ref.ThumbnailComponent,
      ThumbnailProps = _ref.ThumbnailProps,
      ContentComponent = _ref.ContentComponent,
      ContentProps = _ref.ContentProps,
      ExpandedContentComponent = _ref.ExpandedContentComponent,
      ExpandedContentProps = _ref.ExpandedContentProps,
      ExpandComponent = _ref.ExpandComponent,
      ExpandProps = _ref.ExpandProps,
      ActionsComponent = _ref.ActionsComponent,
      ActionsProps = _ref.ActionsProps,
      props = _objectWithoutProperties(_ref, ["className", "classes", "onClick", "onExpand", "expanded", "defaultExpanded", "onSelect", "selected", "defaultSelected", "title", "subheader", "image", "content", "expandedContent", "CardComponent", "CardProps", "HeaderComponent", "HeaderProps", "ThumbnailComponent", "ThumbnailProps", "ContentComponent", "ContentProps", "ExpandedContentComponent", "ExpandedContentProps", "ExpandComponent", "ExpandProps", "ActionsComponent", "ActionsProps"]);

  var _useToggleOnClick = useToggleOnClick(defaultExpanded, onExpand, controlledExpanded),
      _useToggleOnClick2 = _slicedToArray(_useToggleOnClick, 2),
      expanded = _useToggleOnClick2[0],
      toggleExpanded = _useToggleOnClick2[1];

  var _useToggleOnClick3 = useToggleOnClick(defaultSelected, onSelect, controlledSelected),
      _useToggleOnClick4 = _slicedToArray(_useToggleOnClick3, 2),
      selected = _useToggleOnClick4[0],
      toggleSelected = _useToggleOnClick4[1];

  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React__default.createElement(MediaCardProvider, _extends({
      expanded: expanded,
      selected: selected
    }, props), /*#__PURE__*/React__default.createElement(CardComponent, _extends({
      className: clsx(className, classes.root),
      selected: selected // eslint-disable-next-line react/jsx-props-no-spreading

    }, CardProps), /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      wrap: "nowrap"
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true
    }, ThumbnailComponent && /*#__PURE__*/React__default.createElement(ThumbnailComponent, _extends({
      image: image,
      onClick: onClick,
      height: 150,
      width: 200 // eslint-disable-next-line react/jsx-props-no-spreading

    }, ThumbnailProps))), /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      wrap: "nowrap",
      classes: {
        root: classes.overflow
      },
      direction: "column"
    }, /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      wrap: "nowrap",
      justify: "space-between"
    }, HeaderComponent && /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      classes: {
        root: classes.overflow
      }
    }, /*#__PURE__*/React__default.createElement(HeaderComponent, _extends({
      title: title,
      subheader: subheader // innerProps={innerProps}
      // eslint-disable-next-line react/jsx-props-no-spreading

    }, HeaderProps))), ActionsComponent && /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      classes: {
        root: classes.pushRight
      }
    }, /*#__PURE__*/React__default.createElement(ActionsComponent, _extends({
      onSelect: toggleSelected,
      selected: selected // eslint-disable-next-line react/jsx-props-no-spreading

    }, ActionsProps)))), /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      wrap: "nowrap",
      justify: "space-between",
      classes: {
        root: classes.grow
      }
    }, ContentComponent && /*#__PURE__*/React__default.createElement(Grid, {
      item: true
    }, /*#__PURE__*/React__default.createElement(ContentComponent, _extends({
      content: content // eslint-disable-next-line react/jsx-props-no-spreading

    }, ContentProps), content)), ExpandComponent && /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      classes: {
        root: classes.pushRight
      }
    }, /*#__PURE__*/React__default.createElement(ExpandComponent, _extends({
      expanded: expanded,
      onExpand: toggleExpanded // eslint-disable-next-line react/jsx-props-no-spreading

    }, ExpandProps)))))), ExpandedContentComponent && /*#__PURE__*/React__default.createElement(Collapse, {
      className: classes.expandedContent,
      "in": expanded,
      timeout: "auto",
      unmountOnExit: true
    }, /*#__PURE__*/React__default.createElement(ExpandedContentComponent, _extends({
      content: expandedContent,
      truncateContentRows: 0 // eslint-disable-next-line react/jsx-props-no-spreading

    }, ExpandedContentProps)))))
  );
}
MediaCardFullWidth.propTypes = {
  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.any),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  onClick: propTypes.func,
  onExpand: propTypes.func,
  expanded: propTypes.bool,
  defaultExpanded: propTypes.bool,
  selected: propTypes.bool,
  defaultSelected: propTypes.bool,
  onSelect: propTypes.func,
  title: propTypes.string,
  subheader: propTypes.string,
  image: propTypes.string,
  content: propTypes.string,
  expandedContent: propTypes.string,
  CardComponent: propTypes.elementType,
  HeaderComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  ThumbnailComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  ContentComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  ActionsComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  ExpandComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  ExpandedContentComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  CardProps: propTypes.objectOf(propTypes.any),
  HeaderProps: propTypes.objectOf(propTypes.any),
  ThumbnailProps: propTypes.objectOf(propTypes.any),
  ContentProps: propTypes.objectOf(propTypes.any),
  ExpandProps: propTypes.objectOf(propTypes.any),
  ExpandedContentProps: propTypes.objectOf(propTypes.any),
  ActionsProps: propTypes.objectOf(propTypes.any)
};
MediaCardFullWidth.defaultProps = {
  className: 'VdtMediaCardFullWidth',
  classes: {},
  onClick: undefined,
  onExpand: undefined,
  expanded: undefined,
  defaultExpanded: false,
  selected: undefined,
  onSelect: undefined,
  defaultSelected: false,
  title: undefined,
  subheader: undefined,
  image: undefined,
  content: undefined,
  expandedContent: undefined,
  CardComponent: MediaCardFullWidthCard$1,
  HeaderComponent: MediaCardFullWidthHeader$1,
  ThumbnailComponent: MediaCardThumbnail$1,
  ContentComponent: MediaCardFullWidthContent$1,
  ExpandComponent: MediaCardExpand$1,
  ExpandedContentComponent: MediaCardFullWidthContent$1,
  ActionsComponent: false,
  CardProps: {},
  HeaderProps: {},
  ThumbnailProps: {},
  ContentProps: {},
  ExpandProps: {},
  ExpandedContentProps: {},
  ActionsProps: {}
};

var index$4 = withStyles(styles$1L, {
  name: 'VdtMediaCardFullWidth'
})(MediaCardFullWidth);

var DragAndDropContext = /*#__PURE__*/React__default.createContext({
  DraggedComponent: null,
  setDraggedComponent: function setDraggedComponent() {
    return undefined;
  }
});
var DragAndDropProvider = function DragAndDropProvider(_ref) {
  var children = _ref.children,
      initialDraggedComponent = _ref.DraggedComponent;

  var _React$useState = React__default.useState(function () {
    return initialDraggedComponent;
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      DraggedComponent = _React$useState2[0],
      setDraggedComponent = _React$useState2[1];

  return /*#__PURE__*/React__default.createElement(DragAndDropContext.Provider, {
    value: {
      DraggedComponent: DraggedComponent,
      setDraggedComponent: setDraggedComponent
    }
  }, /*#__PURE__*/React__default.createElement(DndProvider, {
    backend: HTML5Backend
  }, DraggedComponent && /*#__PURE__*/React__default.createElement(DragLayer, {
    Component: DraggedComponent
  }), children));
};

var initialState = Object.freeze({
  oldPassword: '',
  password: '',
  passwordAgain: '',
  errors: [],
  loading: false,
  success: false
});
var actions$1 = {
  SET_LOADING: 'SET_LOADING',
  SET_ERRORS: 'SET_ERRORS',
  SET_INPUT_VALUE: 'SET_INPUT_VALUE',
  SET_SUCCESS: 'SET_SUCCESS'
};

function reducer(state, action) {
  switch (action.type) {
    case actions$1.SET_LOADING:
      {
        var newState = _objectSpread2(_objectSpread2({}, state), {}, {
          loading: action.payload
        });

        if (action.payload) {
          newState.errors = [];
          newState.success = false;
        }

        return newState;
      }

    case actions$1.SET_ERRORS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        loading: false,
        errors: action.payload,
        success: false
      });

    case actions$1.SET_INPUT_VALUE:
      {
        var _newState = _objectSpread2({}, state);

        _newState[action.payload.input] = action.payload.value;
        return _newState;
      }

    case actions$1.SET_SUCCESS:
      return _objectSpread2(_objectSpread2({}, initialState), {}, {
        success: true
      });

    default:
      throw new Error();
  }
}

var styles$1M = function styles(theme) {
  return {
    root: {},
    FormControl: {
      display: 'flex',
      marginBottom: theme.spacing(3)
    },
    alert: {
      marginBottom: theme.spacing(2)
    }
  };
};

function ChangePasswordForm(_ref) {
  var classes = _ref.classes,
      onSuccess = _ref.onSuccess,
      initialUserName = _ref.username,
      validateOldPassword = _ref.validateOldPassword,
      changePwdTxt = _ref.changePwdTxt,
      changePwdSuccessTxt = _ref.changePwdSuccessTxt,
      usernameErrTxt = _ref.usernameErrTxt,
      identicalPwdErrTxt = _ref.identicalPwdErrTxt,
      oldPwdTxt = _ref.oldPwdTxt,
      oldPwdErrTxt = _ref.oldPwdErrTxt,
      newPwdTxt = _ref.newPwdTxt,
      repeatPwdTxt = _ref.repeatPwdTxt,
      noPwdTxt = _ref.noPwdTxt,
      noUserTxt = _ref.noUserTxt;

  var _React$useReducer = React__default.useReducer(reducer, initialState),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showPassword = _React$useState2[0],
      setShowPassword = _React$useState2[1];

  var handleClickShowPassword = function handleClickShowPassword() {
    return setShowPassword(!showPassword);
  };

  var _React$useState3 = React__default.useState(initialUserName),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      userName = _React$useState4[0],
      setUserName = _React$useState4[1]; // if no username is provided, most likely changing own password


  React__default.useEffect(function () {
    if (!userName) {
      dispatch({
        type: actions$1.SET_LOADING,
        payload: true
      });
      user.whoAmI().then(function (_ref2) {
        var newUserName = _ref2.data;
        setUserName(newUserName);
        dispatch({
          type: actions$1.SET_LOADING,
          payload: false
        });
      })["catch"](function () {
        dispatch({
          type: actions$1.SET_ERRORS,
          payload: [usernameErrTxt]
        });
      });
    }
  }, [userName, usernameErrTxt]);

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var oldPassword = state.oldPassword,
        password = state.password,
        passwordAgain = state.passwordAgain;

    if (!password || password === '') {
      dispatch({
        type: actions$1.SET_ERRORS,
        payload: [noPwdTxt]
      });
      return;
    }

    if (!(password === passwordAgain)) {
      dispatch({
        type: actions$1.SET_ERRORS,
        payload: [identicalPwdErrTxt]
      });
      return;
    }

    if (!userName) {
      dispatch({
        type: actions$1.SET_ERRORS,
        payload: [noUserTxt]
      });
      return;
    }

    dispatch({
      type: actions$1.SET_LOADING,
      payload: true
    });

    var verifyOldPassword = function verifyOldPassword() {
      if (validateOldPassword === false) {
        return Promise.resolve();
      }

      return user.validateUserPassword({
        userName: userName,
        password: oldPassword,
        queryParams: {
          type: 'raw'
        }
      });
    };

    verifyOldPassword().then(function () {
      user.updateUserPassword({
        userName: userName,
        password: password,
        queryParams: {
          type: 'raw'
        }
      }).then(function () {
        dispatch({
          type: actions$1.SET_SUCCESS
        });
        if (onSuccess) onSuccess({
          userName: userName,
          password: password
        });
      })["catch"](function (err) {
        dispatch({
          type: actions$1.SET_ERRORS,
          payload: [err.message]
        });
      });
    })["catch"](function () {
      dispatch({
        type: actions$1.SET_ERRORS,
        payload: [oldPwdErrTxt]
      });
    });
  };

  var handleChange = function handleChange(prop) {
    return function (event) {
      dispatch({
        type: actions$1.SET_INPUT_VALUE,
        payload: {
          input: prop,
          value: event.target.value
        }
      });
    };
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, state.errors.map(function (errorStr) {
    return /*#__PURE__*/React__default.createElement(Grow, {
      key: errorStr.substring(1, 5),
      "in": true
    }, /*#__PURE__*/React__default.createElement(Alert, {
      className: classes.alert,
      severity: "error"
    }, errorStr));
  }), state.success && /*#__PURE__*/React__default.createElement(Grow, {
    "in": true
  }, /*#__PURE__*/React__default.createElement(Alert, {
    className: classes.alert,
    severity: "success"
  }, changePwdSuccessTxt)), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit
  }, validateOldPassword && /*#__PURE__*/React__default.createElement(FormControl, {
    variant: "filled",
    className: classes.FormControl
  }, /*#__PURE__*/React__default.createElement(InputLabel, null, oldPwdTxt), /*#__PURE__*/React__default.createElement(FilledInput, {
    inputProps: {
      tabIndex: 1
    },
    type: showPassword ? 'text' : 'password',
    value: state.oldPassword,
    onChange: handleChange('oldPassword'),
    endAdornment: /*#__PURE__*/React__default.createElement(InputAdornment$1, {
      position: "end"
    }, /*#__PURE__*/React__default.createElement(IconButton, {
      onClick: handleClickShowPassword
    }, showPassword ? /*#__PURE__*/React__default.createElement(Visibility, null) : /*#__PURE__*/React__default.createElement(VisibilityOff, null)))
  })), /*#__PURE__*/React__default.createElement(FormControl, {
    variant: "filled",
    className: classes.FormControl
  }, /*#__PURE__*/React__default.createElement(InputLabel, null, newPwdTxt), /*#__PURE__*/React__default.createElement(FilledInput, {
    inputProps: {
      tabIndex: 2
    },
    type: showPassword ? 'text' : 'password',
    value: state.password,
    onChange: handleChange('password'),
    endAdornment: /*#__PURE__*/React__default.createElement(InputAdornment$1, {
      position: "end"
    }, /*#__PURE__*/React__default.createElement(IconButton, {
      onClick: handleClickShowPassword
    }, showPassword ? /*#__PURE__*/React__default.createElement(Visibility, null) : /*#__PURE__*/React__default.createElement(VisibilityOff, null)))
  })), /*#__PURE__*/React__default.createElement(FormControl, {
    variant: "filled",
    className: classes.FormControl
  }, /*#__PURE__*/React__default.createElement(InputLabel, null, repeatPwdTxt), /*#__PURE__*/React__default.createElement(FilledInput, {
    inputProps: {
      tabIndex: 3
    },
    type: showPassword ? 'text' : 'password',
    value: state.passwordAgain,
    onChange: handleChange('passwordAgain'),
    endAdornment: /*#__PURE__*/React__default.createElement(InputAdornment$1, {
      position: "end"
    }, /*#__PURE__*/React__default.createElement(IconButton, {
      onClick: handleClickShowPassword
    }, showPassword ? /*#__PURE__*/React__default.createElement(Visibility, null) : /*#__PURE__*/React__default.createElement(VisibilityOff, null)))
  }))), /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "contained",
    color: "primary",
    onClick: handleSubmit,
    disabled: !(state.password && state.passwordAgain && !state.loading)
  }, state.loading ? /*#__PURE__*/React__default.createElement(CircularProgress, {
    size: 20,
    color: "inherit"
  }) : changePwdTxt));
}

ChangePasswordForm.propTypes = {
  classes: propTypes.objectOf(propTypes.string),
  username: propTypes.string,
  onSuccess: propTypes.func,
  validateOldPassword: propTypes.bool,
  changePwdTxt: propTypes.string,
  changePwdSuccessTxt: propTypes.string,
  usernameErrTxt: propTypes.string,
  identicalPwdErrTxt: propTypes.string,
  oldPwdTxt: propTypes.string,
  oldPwdErrTxt: propTypes.string,
  newPwdTxt: propTypes.string,
  repeatPwdTxt: propTypes.string,
  noPwdTxt: propTypes.string,
  noUserTxt: propTypes.string
};
ChangePasswordForm.defaultProps = {
  classes: {},
  username: undefined,
  onSuccess: null,
  validateOldPassword: true,
  changePwdTxt: 'Change Password',
  changePwdSuccessTxt: 'Password successfully changed!',
  usernameErrTxt: 'Unable to verify username.',
  identicalPwdErrTxt: 'Passwords are not identical.',
  oldPwdTxt: 'Old password',
  oldPwdErrTxt: 'Unable to verify the old password.',
  newPwdTxt: 'New password',
  repeatPwdTxt: 'Repeat password',
  noPwdTxt: 'No password set',
  noUserTxt: 'Cannot determine username'
};
var ChangePasswordForm$1 = withStyles(styles$1M, {
  name: 'VdtChangePasswordForm'
})(ChangePasswordForm);

var styles$1N = function styles(theme) {
  return {
    DialogTitle: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  };
};

function ChangePasswordDialog(_ref) {
  var classes = _ref.classes,
      username = _ref.username,
      onClose = _ref.onClose,
      _onSuccess = _ref.onSuccess,
      _ref$changePasswordTx = _ref.changePasswordTxt,
      changePasswordTxt = _ref$changePasswordTx === void 0 ? 'Change Password' : _ref$changePasswordTx,
      props = _objectWithoutProperties(_ref, ["classes", "username", "onClose", "onSuccess", "changePasswordTxt"]);

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    disableTypography: true,
    className: classes.DialogTitle
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6"
  }, changePasswordTxt, username ? ":  ".concat(username) : ''), onClose ? /*#__PURE__*/React__default.createElement(IconButton, {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)) : null), /*#__PURE__*/React__default.createElement(DialogContent$1, {
    dividers: true
  }, /*#__PURE__*/React__default.createElement(ChangePasswordForm$1, _extends({
    username: username,
    onSuccess: function onSuccess(args) {
      if (_onSuccess) _onSuccess(args);
      onClose();
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, props))));
}

var ChangePasswordDialog$1 = withStyles(styles$1N, {
  name: 'VdtChangePasswordDialog'
})(ChangePasswordDialog);

function UserRow(_ref) {
  var _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      onClick = _ref.onClick,
      TableRowProps = _objectWithoutProperties(_ref, ["user", "columns", "onClick"]);

  return /*#__PURE__*/React__default.createElement(TableRow$3, _extends({
    onClick: onClick !== undefined ? function () {
      return onClick(user);
    } : undefined,
    style: {
      cursor: onClick !== undefined ? 'pointer' : 'initial'
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, TableRowProps), columns.map(function (_ref2) {
    var value = _ref2.value,
        valueComponent = _ref2.valueComponent;
    return /*#__PURE__*/React__default.createElement(TableCell, {
      key: value
    }, valueComponent ? valueComponent(user[value], user) : user[value]);
  }));
}

var UserRow$1 = withStyles({}, {
  name: 'VdtUserRow'
})(UserRow);

var disabledValueComponent = function disabledValueComponent(value) {
  return value ? 'Disabled' : 'Active';
};

var DEFAULT_COLUMNS$1 = [{
  value: 'userName'
}, {
  value: 'realName'
}, {
  value: 'disabled',
  valueComponent: disabledValueComponent
}];
var DEFAULT_COLUMN_LABELS$2 = {
  userName: 'Username',
  realName: 'Real name',
  disabled: 'Status'
};
var styles$1O = function styles() {
  return {
    root: {}
  };
};
function UserTable(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      users = _ref.users,
      columns = _ref.columns,
      hideHeader = _ref.hideHeader,
      UserRowComponent = _ref.UserRowComponent,
      UserRowProps = _ref.UserRowProps,
      userColumnLabels = _ref.userColumnLabels;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(TableContainer, null, /*#__PURE__*/React__default.createElement(Table, null, !hideHeader && /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$3, null, columns.map(function (_ref2) {
    var value = _ref2.value;
    return /*#__PURE__*/React__default.createElement(TableCell, {
      key: userColumnLabels[value]
    }, userColumnLabels[value]);
  }))), /*#__PURE__*/React__default.createElement(TableBody, null, users.map(function (user) {
    return /*#__PURE__*/React__default.createElement(UserRowComponent, _extends({
      key: user.userName,
      user: user,
      columns: columns // eslint-disable-next-line react/jsx-props-no-spreading

    }, UserRowProps));
  })))));
}
UserTable.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  users: propTypes.arrayOf(propTypes.any),
  columns: propTypes.arrayOf(propTypes.any),
  hideHeader: propTypes.bool,
  UserRowComponent: propTypes.elementType,
  UserRowProps: propTypes.objectOf(propTypes.any),
  userColumnLabels: propTypes.objectOf(propTypes.string)
};
UserTable.defaultProps = {
  className: undefined,
  classes: {},
  users: [],
  columns: DEFAULT_COLUMNS$1,
  hideHeader: false,
  UserRowComponent: UserRow$1,
  UserRowProps: {},
  userColumnLabels: DEFAULT_COLUMN_LABELS$2
};

var index$5 = withStyles(styles$1O, {
  name: 'VdtUserTable'
})(UserTable);

var styles$1P = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column'
    },
    groupListItem: {
      '& .MuiListItemSecondaryAction-root': {
        visibility: 'hidden'
      },
      '&:hover': {
        backgroundColor: emphasize(theme.palette.background.paper, 0.1),
        '& .MuiListItemSecondaryAction-root': {
          visibility: 'visible'
        }
      }
    },
    toggleIcon: {
      color: theme.palette.primary.main,
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    toggleIconActive: {
      transform: 'rotate(45deg)'
    },
    addGroupListItem: {
      color: theme.palette.primary.main
    },
    addButton: {
      alignSelf: 'flex-end'
    },
    inputGroup: {
      paddingBottom: theme.spacing(2),
      display: 'grid',
      gridAutoFlow: 'column',
      gridTemplateColumns: '1fr auto',
      alignItems: 'end',
      gridGap: theme.spacing(4)
    },
    subHeader: {
      display: 'grid',
      gridAutoFlow: 'column',
      gridTemplateColumns: 'auto 1fr',
      alignItems: 'center',
      gridGap: theme.spacing(1),
      backgroundColor: theme.palette.background.paper,
      top: "-".concat(theme.spacing(2), "px")
    }
  };
};
function GroupRelationList(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      onClick = _ref.onClick,
      existingGroups = _ref.existingGroups,
      groups = _ref.groups,
      onAddGroups = _ref.onAddGroups,
      onRemoveGroup = _ref.onRemoveGroup,
      removeTooltip = _ref.removeTooltip,
      subHeaderText = _ref.subHeaderText,
      inputLabel = _ref.inputLabel,
      SubHeaderIcon = _ref.SubHeaderIcon,
      emptyText = _ref.emptyText,
      addText = _ref.addText,
      disableEdit = _ref.disableEdit,
      lockedGroups = _ref.lockedGroups,
      showRoles = _ref.showRoles,
      showGroups = _ref.showGroups,
      AddIcon = _ref.AddIcon,
      RemoveIcon = _ref.RemoveIcon,
      ListProps = _ref.ListProps,
      ListSubheaderProps = _ref.ListSubheaderProps,
      ListItemProps = _ref.ListItemProps,
      ListItemTextProps = _ref.ListItemTextProps,
      EmptyListItemProps = _ref.EmptyListItemProps,
      EmptyListItemTextProps = _ref.EmptyListItemTextProps,
      RemoveTooltipProps = _ref.RemoveTooltipProps,
      RemoveIconButtonProps = _ref.RemoveIconButtonProps,
      AddListItemProps = _ref.AddListItemProps,
      AddListItemTextProps = _ref.AddListItemTextProps,
      CollapseProps = _ref.CollapseProps,
      AutocompleteProps = _ref.AutocompleteProps,
      AutocompleteTextFieldProps = _ref.AutocompleteTextFieldProps,
      AddButtonProps = _ref.AddButtonProps,
      addButtonText = _ref.addButtonText;

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      addActive = _React$useState2[0],
      setAddActive = _React$useState2[1];

  var _existingGroups$group = existingGroups.group,
      existingList = _existingGroups$group === void 0 ? [] : _existingGroups$group;
  var existingGroupList = existingList.filter(function (group) {
    return group.role && showRoles || !group.role && showGroups;
  });
  var _groups$group = groups.group,
      groupList = _groups$group === void 0 ? [] : _groups$group;
  var availableGroupList = groupList.filter(function (group) {
    return group.role && showRoles || !group.role && showGroups;
  }).map(function (g) {
    return g.groupName;
  });

  var _React$useState3 = React__default.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      value = _React$useState4[0],
      setValue = _React$useState4[1];

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(List, _extends({
    dense: true,
    className: classes.List,
    subheader:
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React__default.createElement(ListSubheader$1, _extends({
      disableGutters: true,
      className: classes.subHeader
    }, ListSubheaderProps), SubHeaderIcon && /*#__PURE__*/React__default.createElement(SubHeaderIcon, null), subHeaderText) // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListProps), existingGroupList.length ? existingGroupList.map(function (group) {
    return /*#__PURE__*/React__default.createElement(ListItem, _extends({
      key: group.groupName,
      classes: {
        container: classes.groupListItem
      },
      disabled: lockedGroups.includes(group.groupName),
      onClick: onClick ? function (event) {
        return onClick(event, {
          groupName: group.groupName,
          groupType: group
        });
      } : undefined,
      button: !!onClick // eslint-disable-next-line react/jsx-props-no-spreading

    }, ListItemProps), /*#__PURE__*/React__default.createElement(ListItemText$1, _extends({
      primary: group.groupName,
      primaryTypographyProps: {
        variant: 'body2'
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, ListItemTextProps)), onRemoveGroup && !disableEdit && !lockedGroups.includes(group.groupName) && /*#__PURE__*/React__default.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React__default.createElement(Tooltip$1, _extends({
      title: removeTooltip // eslint-disable-next-line react/jsx-props-no-spreading

    }, RemoveTooltipProps), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(IconButton$1, _extends({
      size: "small",
      onClick: function onClick() {
        return onRemoveGroup(group.groupName);
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, RemoveIconButtonProps), /*#__PURE__*/React__default.createElement(RemoveIcon, null))))));
  }) :
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-props-no-spreading
  React__default.createElement(ListItem, EmptyListItemProps, /*#__PURE__*/React__default.createElement(ListItemText$1, _extends({
    primary: emptyText,
    primaryTypographyProps: {
      variant: 'caption'
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, EmptyListItemTextProps))), onAddGroups && !disableEdit && /*#__PURE__*/React__default.createElement(ListItem, _extends({
    button: true,
    className: classes.addGroupListItem,
    onClick: function onClick() {
      return setAddActive(function (prev) {
        return !prev;
      });
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, AddListItemProps), /*#__PURE__*/React__default.createElement(ListItemIcon, null, /*#__PURE__*/React__default.createElement(AddIcon, {
    className: clsx(classes.toggleIcon, _defineProperty({}, classes.toggleIconActive, addActive))
  })), /*#__PURE__*/React__default.createElement(ListItemText$1, _extends({
    primary: addText,
    primaryTypographyProps: {
      variant: 'body1'
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, AddListItemTextProps)))), onAddGroups && !disableEdit &&
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-props-no-spreading
  React__default.createElement(Collapse$1, _extends({
    "in": addActive,
    timeout: "auto"
  }, CollapseProps), /*#__PURE__*/React__default.createElement("div", {
    className: classes.inputGroup
  }, /*#__PURE__*/React__default.createElement(Autocomplete$1, _extends({
    onChange: function onChange(_, val) {
      return setValue(val);
    },
    value: value,
    multiple: true,
    options: availableGroupList // getOptionLabel={(option) => option.groupName}
    ,
    getOptionDisabled: function getOptionDisabled(option) {
      return existingGroupList.findIndex(function (g) {
        return g.groupName === option;
      }) !== -1 || lockedGroups.includes(option);
    },
    filterSelectedOptions: true,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$3 // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, params, {
        autoFocus: true,
        label: inputLabel // eslint-disable-next-line react/jsx-props-no-spreading

      }, AutocompleteTextFieldProps));
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, AutocompleteProps)), /*#__PURE__*/React__default.createElement(Button, _extends({
    variant: "outlined",
    color: "primary",
    onClick: function onClick() {
      onAddGroups({
        groups: value
      }).then(function () {
        setAddActive(false);
        setTimeout(function () {
          setValue([]);
        }, 500);
      });
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, AddButtonProps), addButtonText))));
}
GroupRelationList.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  existingGroups: index.GroupListType,
  groups: index.GroupListType,
  onClick: propTypes.func,
  onAddGroups: propTypes.func,
  onRemoveGroup: propTypes.func,
  removeTooltip: propTypes.string,
  subHeaderText: propTypes.string,
  inputLabel: propTypes.string,
  SubHeaderIcon: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  emptyText: propTypes.string,
  addText: propTypes.string,
  disableEdit: propTypes.bool,
  lockedGroups: propTypes.arrayOf(propTypes.string),
  showRoles: propTypes.bool,
  showGroups: propTypes.bool,
  RemoveIcon: propTypes.elementType,
  ListProps: propTypes.objectOf(propTypes.any),
  ListSubheaderProps: propTypes.objectOf(propTypes.any),
  ListItemProps: propTypes.objectOf(propTypes.any),
  ListItemTextProps: propTypes.objectOf(propTypes.any),
  EmptyListItemProps: propTypes.objectOf(propTypes.any),
  EmptyListItemTextProps: propTypes.objectOf(propTypes.any),
  RemoveTooltipProps: propTypes.objectOf(propTypes.any),
  RemoveIconButtonProps: propTypes.objectOf(propTypes.any),
  AddListItemProps: propTypes.objectOf(propTypes.any),
  AddIcon: propTypes.elementType,
  AddListItemTextProps: propTypes.objectOf(propTypes.any),
  CollapseProps: propTypes.objectOf(propTypes.any),
  AutocompleteProps: propTypes.objectOf(propTypes.any),
  AutocompleteTextFieldProps: propTypes.objectOf(propTypes.any),
  AddButtonProps: propTypes.objectOf(propTypes.any),
  addButtonText: propTypes.string
};
GroupRelationList.defaultProps = {
  className: undefined,
  classes: {},
  existingGroups: {},
  groups: {},
  onClick: undefined,
  onAddGroups: undefined,
  onRemoveGroup: undefined,
  removeTooltip: 'Remove',
  subHeaderText: 'Groups',
  inputLabel: 'Select groups',
  SubHeaderIcon: false,
  emptyText: 'No groups',
  addText: 'Add groups',
  disableEdit: false,
  lockedGroups: [],
  showRoles: true,
  showGroups: true,
  RemoveIcon: Cancel,
  ListProps: {},
  ListSubheaderProps: {},
  ListItemProps: {},
  ListItemTextProps: {},
  EmptyListItemProps: {},
  EmptyListItemTextProps: {},
  RemoveTooltipProps: {},
  RemoveIconButtonProps: {},
  AddListItemProps: {},
  AddIcon: Add,
  AddListItemTextProps: {},
  CollapseProps: {},
  AutocompleteProps: {},
  AutocompleteTextFieldProps: {},
  AddButtonProps: {},
  addButtonText: 'Add'
};

var GroupRealtionList = withStyles(styles$1P, {
  name: 'VdtGroupRelationList'
})(GroupRelationList);

var styles$1Q = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column'
    },
    ListSubheader: {
      display: 'grid',
      gridAutoFlow: 'column',
      gridTemplateColumns: 'auto 1fr',
      alignItems: 'center',
      gridGap: theme.spacing(1)
    },
    List: {}
  };
};

var getDisabledValue = function getDisabledValue(_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'Disabled' : 'Active';
};

function UserData(_ref2) {
  var className = _ref2.className,
      classes = _ref2.classes,
      user = _ref2.user,
      _ref2$SubHeaderText = _ref2.SubHeaderText,
      SubHeaderText = _ref2$SubHeaderText === void 0 ? 'Details' : _ref2$SubHeaderText,
      _ref2$SubHeaderIcon = _ref2.SubHeaderIcon,
      SubHeaderIcon = _ref2$SubHeaderIcon === void 0 ? false : _ref2$SubHeaderIcon;
  var userName = user.userName,
      realName = user.realName;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(List, {
    className: classes.List,
    dense: true,
    subheader: /*#__PURE__*/React__default.createElement(ListSubheader$1, {
      disableGutters: true,
      className: classes.ListSubheader
    }, SubHeaderIcon && /*#__PURE__*/React__default.createElement(SubHeaderIcon, null), SubHeaderText)
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText$1, {
    primary: "Username",
    secondary: userName
  })), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText$1, {
    primary: "Real name",
    secondary: realName || '-'
  })), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText$1, {
    primary: "Status",
    secondary: getDisabledValue(user)
  }))));
}

var UserData$1 = withStyles(styles$1Q, {
  name: 'VdtUserData'
})(UserData);

function UserMenu(_ref) {
  var user = _ref.user,
      onToggleDisabled = _ref.onToggleDisabled,
      onEdit = _ref.onEdit,
      onChangePassword = _ref.onChangePassword,
      onDelete = _ref.onDelete,
      _ref$editUserText = _ref.editUserText,
      editUserText = _ref$editUserText === void 0 ? 'Edit User' : _ref$editUserText,
      _ref$changePasswordTe = _ref.changePasswordText,
      changePasswordText = _ref$changePasswordTe === void 0 ? 'Change Password' : _ref$changePasswordTe,
      _ref$deleteUserText = _ref.deleteUserText,
      deleteUserText = _ref$deleteUserText === void 0 ? 'Delete User' : _ref$deleteUserText,
      _ref$enableUsertext = _ref.enableUsertext,
      enableUsertext = _ref$enableUsertext === void 0 ? 'Enable User' : _ref$enableUsertext,
      _ref$disableUsertext = _ref.disableUsertext,
      disableUsertext = _ref$disableUsertext === void 0 ? 'Disable User' : _ref$disableUsertext,
      props = _objectWithoutProperties(_ref, ["user", "onToggleDisabled", "onEdit", "onChangePassword", "onDelete", "editUserText", "changePasswordText", "deleteUserText", "enableUsertext", "disableUsertext"]);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React__default.createElement(Menu$1, props, /*#__PURE__*/React__default.createElement(MenuItem$1, {
      onClick: function onClick() {
        return onToggleDisabled(user);
      },
      disabled: onToggleDisabled === undefined
    }, user.disabled ? enableUsertext : disableUsertext), /*#__PURE__*/React__default.createElement(MenuItem$1, {
      onClick: onEdit,
      disabled: onEdit === undefined
    }, editUserText), /*#__PURE__*/React__default.createElement(MenuItem$1, {
      onClick: onChangePassword,
      disabled: onChangePassword === undefined
    }, changePasswordText), /*#__PURE__*/React__default.createElement(MenuItem$1, {
      onClick: function onClick() {
        return onDelete(user);
      },
      disabled: onDelete === undefined
    }, deleteUserText))
  );
}

var styles$1R = function styles(theme) {
  return {
    root: {
      display: 'grid',
      gridGap: theme.spacing(2),
      '& .MuiListItem-gutters': {
        paddingLeft: '30px'
      }
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  };
};
function UserDetails(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      userType = _ref.userType,
      groupListType = _ref.groupListType,
      onEdit = _ref.onEdit,
      onDelete = _ref.onDelete,
      onAddToGroups = _ref.onAddToGroups,
      onRemoveFromGroup = _ref.onRemoveFromGroup,
      onToggleDisabled = _ref.onToggleDisabled,
      onChangePassword = _ref.onChangePassword,
      DetailsComponent = _ref.DetailsComponent,
      DetailsProps = _ref.DetailsProps,
      GroupsComponent = _ref.GroupsComponent,
      GroupsProps = _ref.GroupsProps,
      RolesComponent = _ref.RolesComponent,
      RolesProps = _ref.RolesProps,
      MenuComponent = _ref.MenuComponent,
      MenuProps = _ref.MenuProps,
      lockedUsers = _ref.lockedUsers;

  var _ref2 = userType || {},
      userName = _ref2.userName,
      _ref2$groupList = _ref2.groupList,
      groupList = _ref2$groupList === void 0 ? {} : _ref2$groupList;

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var locked = lockedUsers.includes(userName);

  var handleMenuClick = function handleMenuClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleMenuClose = function handleMenuClose() {
    setAnchorEl(null);
  }; // TODO fix prettier formatter for ternary

  /* eslint-disable prettier/prettier */


  var handleClickClose = function handleClickClose(onClick) {
    return onClick ? function (args) {
      onClick(args);
      handleMenuClose();
    } : undefined;
  };
  /* eslint-enable prettier/prettier */


  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h5"
  }, userName), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: handleMenuClick,
    disabled: lockedUsers.includes(userName)
  }, /*#__PURE__*/React__default.createElement(MoreVertIcon, null)), MenuComponent && /*#__PURE__*/React__default.createElement(MenuComponent, _extends({
    user: userType,
    open: Boolean(anchorEl),
    onClose: handleMenuClose,
    anchorEl: anchorEl,
    onDelete: handleClickClose(onDelete),
    onEdit: handleClickClose(onEdit),
    onToggleDisabled: handleClickClose(onToggleDisabled),
    onChangePassword: handleClickClose(onChangePassword) // eslint-disable-next-line react/jsx-props-no-spreading

  }, MenuProps))), DetailsComponent && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DetailsComponent, _extends({
    user: userType,
    SubHeaderIcon: DescriptionIcon // eslint-disable-next-line react/jsx-props-no-spreading

  }, DetailsProps)), /*#__PURE__*/React__default.createElement(Divider, null)), GroupsComponent && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(GroupsComponent, _extends({
    existingGroups: groupList,
    groups: groupListType,
    onRemoveGroup: onRemoveFromGroup,
    onAddGroups: onAddToGroups,
    SubHeaderIcon: GroupIcon,
    disableEdit: locked,
    showRoles: false // eslint-disable-next-line react/jsx-props-no-spreading

  }, GroupsProps)), /*#__PURE__*/React__default.createElement(Divider, null)), RolesComponent && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(RolesComponent, _extends({
    existingGroups: groupList,
    groups: groupListType,
    onRemoveGroup: onRemoveFromGroup,
    onAddGroups: onAddToGroups,
    removeTooltip: "Remove role",
    subHeaderText: "Roles",
    SubHeaderIcon: RoleIcon,
    inputLabel: "Select roles",
    addText: "Add roles",
    emptyText: "No roles added",
    disableEdit: locked,
    showGroups: false // eslint-disable-next-line react/jsx-props-no-spreading

  }, RolesProps)), /*#__PURE__*/React__default.createElement(Divider, null)));
}
UserDetails.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  userType: index.UserType,
  groupListType: index.GroupListType,
  onEdit: propTypes.func,
  onDelete: propTypes.func,
  onAddToGroups: propTypes.func,
  onRemoveFromGroup: propTypes.func,
  onToggleDisabled: propTypes.func,
  onChangePassword: propTypes.func,
  DetailsComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  DetailsProps: propTypes.objectOf(propTypes.any),
  GroupsComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  GroupsProps: propTypes.objectOf(propTypes.any),
  RolesComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  RolesProps: propTypes.objectOf(propTypes.any),
  MenuComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  MenuProps: propTypes.objectOf(propTypes.any),
  lockedUsers: propTypes.arrayOf(propTypes.string)
};
UserDetails.defaultProps = {
  classes: {},
  className: undefined,
  userType: {},
  groupListType: {},
  onEdit: undefined,
  onDelete: undefined,
  onAddToGroups: undefined,
  onRemoveFromGroup: undefined,
  onToggleDisabled: undefined,
  onChangePassword: undefined,
  DetailsComponent: UserData$1,
  DetailsProps: {},
  GroupsComponent: GroupRealtionList,
  GroupsProps: {},
  RolesComponent: GroupRealtionList,
  RolesProps: {},
  MenuComponent: UserMenu,
  MenuProps: {},
  lockedUsers: ['admin', 'vidinetviewer']
};

var index$6 = withStyles(styles$1R, {
  name: 'VdtUserDetails'
})(UserDetails);

function PasswordField$1(props) {
  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showPassword = _React$useState2[0],
      setShowPassword = _React$useState2[1];

  return /*#__PURE__*/React__default.createElement(TextField$3, _extends({
    type: showPassword ? 'text' : 'password',
    InputProps: {
      endAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        onClick: function onClick() {
          return setShowPassword(function (prev) {
            return !prev;
          });
        }
      }, showPassword ? /*#__PURE__*/React__default.createElement(Visibility$1, null) : /*#__PURE__*/React__default.createElement(VisibilityOff$1, null)))
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

var styles$1S = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
      }
    },
    action: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  };
};

function CreateUserForm(_ref) {
  var classes = _ref.classes,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? 'Create' : _ref$submitText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
      groups = _ref.groups,
      roles = _ref.roles;
  var userNameRef = React__default.useRef();
  var realNameRef = React__default.useRef();
  var passwordRef = React__default.useRef();

  var _React$useState = React__default.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      userGroups = _React$useState2[0],
      setUserGroups = _React$useState2[1];

  var _React$useState3 = React__default.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      userRoles = _React$useState4[0],
      setUserRoles = _React$useState4[1];

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var userDocument = {
      userName: userNameRef.current.value,
      realName: realNameRef.current.value,
      password: passwordRef.current.value,
      groupList: {
        group: userGroups.concat(userRoles).map(function (g) {
          return {
            groupName: g
          };
        })
      }
    };
    onSubmit({
      userDocument: userDocument
    });
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("form", {
    className: classes.root,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    required: true,
    name: "userName",
    label: "Username",
    inputRef: userNameRef
  }), /*#__PURE__*/React__default.createElement(TextField$3, {
    name: "realName",
    label: "Real name",
    inputRef: realNameRef
  }), /*#__PURE__*/React__default.createElement(PasswordField$1, {
    name: "password",
    required: true,
    fullWidth: true,
    label: "Password",
    inputRef: passwordRef
  }), /*#__PURE__*/React__default.createElement(Autocomplete$1, {
    name: "groups",
    multiple: true,
    options: groups,
    getOptionLabel: function getOptionLabel(option) {
      return option;
    },
    filterSelectedOptions: true,
    value: userGroups,
    onChange: function onChange(_, val) {
      return setUserGroups(val);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$3 // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, params, {
        label: "Add to groups"
      }));
    }
  }), /*#__PURE__*/React__default.createElement(Autocomplete$1, {
    name: "roles",
    multiple: true,
    options: roles,
    getOptionLabel: function getOptionLabel(option) {
      return option;
    },
    filterSelectedOptions: true,
    value: userRoles,
    onChange: function onChange(_, val) {
      return setUserRoles(val);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$3 // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, params, {
        label: "Add roles"
      }));
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classes.action
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: onCancel
  }, cancelText), /*#__PURE__*/React__default.createElement(Button, {
    variant: "contained",
    color: "primary",
    type: "submit"
  }, submitText))));
}

var CreateUserForm$1 = withStyles$1(styles$1S, {
  name: 'VdtCreateUserForm'
})(CreateUserForm);

var styles$1T = function styles() {
  return {
    root: {},
    DialogTitle: {},
    DialogContent: {}
  };
};
function CreateUserDialog(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      groupListType = _ref.groupListType,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      titleText = _ref.titleText,
      CreateUserFormProps = _ref.CreateUserFormProps;

  var _React$useMemo = React__default.useMemo(function () {
    var _groupListType$group = groupListType.group,
        allGroups = _groupListType$group === void 0 ? [] : _groupListType$group;
    return allGroups.reduce(function (_ref2, c) {
      var _ref3 = _slicedToArray(_ref2, 2),
          isTrue = _ref3[0],
          isFalse = _ref3[1];

      return c.role ? [[].concat(_toConsumableArray(isTrue), [c]), isFalse] : [isTrue, [].concat(_toConsumableArray(isFalse), [c])];
    }, [[], []]).map(function (gr) {
      return gr.map(function (g) {
        return g.groupName;
      });
    });
  }, [groupListType]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      roles = _React$useMemo2[0],
      groups = _React$useMemo2[1];

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, titleText && /*#__PURE__*/React__default.createElement(DialogTitle, {
    className: classes.DialogTitle
  }, titleText), /*#__PURE__*/React__default.createElement(DialogContent, {
    className: classes.DialogContent
  }, /*#__PURE__*/React__default.createElement(CreateUserForm$1, _extends({
    onSubmit: onSubmit,
    onCancel: onClose,
    roles: roles,
    groups: groups // eslint-disable-next-line react/jsx-props-no-spreading

  }, CreateUserFormProps))));
}
CreateUserDialog.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  titleText: propTypes.string,
  onClose: propTypes.func,
  onSubmit: propTypes.func,
  groupListType: index.GroupListType,
  CreateUserFormProps: propTypes.objectOf(propTypes.any)
};
CreateUserDialog.defaultProps = {
  className: undefined,
  classes: {},
  titleText: 'Create User',
  onClose: undefined,
  onSubmit: undefined,
  groupListType: {},
  CreateUserFormProps: {}
};

var index$7 = withStyles(styles$1T, {
  name: 'VdtCreateUserDialog'
})(CreateUserDialog);

var styles$1U = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
      }
    },
    action: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  };
};

function EditUserForm(_ref) {
  var classes = _ref.classes,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? 'Save' : _ref$submitText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
      _ref$userNameText = _ref.userNameText,
      userNameText = _ref$userNameText === void 0 ? 'Username' : _ref$userNameText,
      _ref$realNameText = _ref.realNameText,
      realNameText = _ref$realNameText === void 0 ? 'Real name' : _ref$realNameText,
      user = _ref.user;
  var userNameRef = React__default.useRef();
  var realNameRef = React__default.useRef();

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var userDocument = {
      userName: userNameRef.current.value,
      realName: realNameRef.current.value
    };
    onSubmit({
      userDocument: userDocument
    });
  };

  return /*#__PURE__*/React__default.createElement("form", {
    className: classes.root,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    required: true,
    name: "userName",
    defaultValue: user.userName,
    label: userNameText,
    inputRef: userNameRef
  }), /*#__PURE__*/React__default.createElement(TextField$3, {
    defaultValue: user.realName,
    name: "realName",
    label: realNameText,
    inputRef: realNameRef
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classes.action
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: onCancel
  }, cancelText), /*#__PURE__*/React__default.createElement(Button, {
    variant: "contained",
    color: "primary",
    type: "submit"
  }, submitText)));
}

var EditUserForm$1 = withStyles$1(styles$1U, {
  name: 'VdtEditUserForm'
})(EditUserForm);

var styles$1V = function styles() {
  return {
    root: {}
  };
};
function CreateUserDialog$1(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      user = _ref.user,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(DialogTitle, null, "Edit User"), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(EditUserForm$1, {
    onSubmit: onSubmit,
    onCancel: onClose,
    user: user
  })));
}
CreateUserDialog$1.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string
};
CreateUserDialog$1.defaultProps = {
  className: undefined,
  classes: {}
};

var index$8 = withStyles(styles$1V, {
  name: 'VdtEditUserDialog'
})(CreateUserDialog$1);

var styles$1W = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
      }
    },
    action: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    fields: {
      display: 'flex',
      alignItems: 'center'
    }
  };
};

function UserPasswordForm(_ref) {
  var classes = _ref.classes,
      userName = _ref.userName,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? 'Change' : _ref$submitText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
      _ref$passwordText = _ref.passwordText,
      passwordText = _ref$passwordText === void 0 ? 'New Password' : _ref$passwordText;
  var passwordRef = React__default.useRef();

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var password = passwordRef.current.value;
    onSubmit({
      userName: userName,
      password: password
    });
  };

  return /*#__PURE__*/React__default.createElement("form", {
    className: classes.root,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.fields
  }, /*#__PURE__*/React__default.createElement(PasswordField$1, {
    required: true,
    fullWidth: true,
    name: "password",
    label: passwordText,
    inputRef: passwordRef
  })), /*#__PURE__*/React__default.createElement("div", {
    className: classes.action
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: onCancel
  }, cancelText), /*#__PURE__*/React__default.createElement(Button, {
    variant: "contained",
    color: "primary",
    type: "submit"
  }, submitText)));
}

var UserPasswordForm$1 = withStyles$1(styles$1W, {
  name: 'VdtUserPasswordForm'
})(UserPasswordForm);

var styles$1X = function styles() {
  return {
    root: {}
  };
};
function CreateUserDialog$2(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      user = _ref.user,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit;
  var userName = user.userName;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(DialogTitle, null, "Change password for ", userName || 'user'), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(UserPasswordForm$1, {
    onSubmit: onSubmit,
    onCancel: onClose,
    userName: userName
  })));
}
CreateUserDialog$2.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  onClose: propTypes.func,
  onSubmit: propTypes.func,
  user: index.UserType.isRequired
};
CreateUserDialog$2.defaultProps = {
  className: undefined,
  classes: {},
  onClose: undefined,
  onSubmit: undefined
};

var index$9 = withStyles(styles$1X, {
  name: 'VdtChangeUserPasswordDialog'
})(CreateUserDialog$2);

var styles$1Y = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column'
    },
    groupListItem: {
      '& .MuiListItemSecondaryAction-root': {
        visibility: 'hidden'
      },
      '&:hover': {
        backgroundColor: emphasize(theme.palette.background.paper, 0.1),
        '& .MuiListItemSecondaryAction-root': {
          visibility: 'visible'
        }
      }
    },
    toggleIcon: {
      color: theme.palette.primary.main,
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    toggleIconActive: {
      transform: 'rotate(45deg)'
    },
    addGroupListItem: {
      color: theme.palette.primary.main
    },
    addButton: {
      alignSelf: 'flex-end'
    },
    inputGroup: {
      paddingBottom: theme.spacing(2),
      display: 'grid',
      gridAutoFlow: 'column',
      gridTemplateColumns: '1fr auto',
      alignItems: 'end',
      gridGap: theme.spacing(4)
    },
    subHeader: {
      display: 'grid',
      gridAutoFlow: 'column',
      gridTemplateColumns: 'auto 1fr',
      alignItems: 'center',
      gridGap: theme.spacing(1),
      backgroundColor: theme.palette.background.paper,
      top: "-".concat(theme.spacing(2), "px")
    }
  };
};
function UserRelationList(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      onClick = _ref.onClick,
      existingUsers = _ref.existingUsers,
      users = _ref.users,
      onAddUsers = _ref.onAddUsers,
      onRemoveUser = _ref.onRemoveUser,
      removeTooltip = _ref.removeTooltip,
      subHeaderText = _ref.subHeaderText,
      inputLabel = _ref.inputLabel,
      SubHeaderIcon = _ref.SubHeaderIcon,
      emptyText = _ref.emptyText,
      addText = _ref.addText,
      disableEdit = _ref.disableEdit,
      lockedUsers = _ref.lockedUsers,
      AddIcon = _ref.AddIcon,
      RemoveIcon = _ref.RemoveIcon,
      ListProps = _ref.ListProps,
      ListSubheaderProps = _ref.ListSubheaderProps,
      ListItemProps = _ref.ListItemProps,
      ListItemTextProps = _ref.ListItemTextProps,
      EmptyListItemProps = _ref.EmptyListItemProps,
      EmptyListItemTextProps = _ref.EmptyListItemTextProps,
      RemoveTooltipProps = _ref.RemoveTooltipProps,
      RemoveIconButtonProps = _ref.RemoveIconButtonProps,
      AddListItemProps = _ref.AddListItemProps,
      AddListItemTextProps = _ref.AddListItemTextProps,
      CollapseProps = _ref.CollapseProps,
      AutocompleteProps = _ref.AutocompleteProps,
      AutocompleteTextFieldProps = _ref.AutocompleteTextFieldProps,
      AddButtonProps = _ref.AddButtonProps,
      addButtonText = _ref.addButtonText;

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      addActive = _React$useState2[0],
      setAddActive = _React$useState2[1];

  var _existingUsers$user = existingUsers.user,
      existingUserList = _existingUsers$user === void 0 ? [] : _existingUsers$user;
  var _users$user = users.user,
      userList = _users$user === void 0 ? [] : _users$user;
  var availableUsers = userList.map(function (u) {
    return u.userName;
  });

  var _React$useState3 = React__default.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      value = _React$useState4[0],
      setValue = _React$useState4[1];

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(List, _extends({
    dense: true,
    className: classes.List,
    subheader:
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React__default.createElement(ListSubheader$1, _extends({
      disableGutters: true,
      className: classes.subHeader
    }, ListSubheaderProps), SubHeaderIcon && /*#__PURE__*/React__default.createElement(SubHeaderIcon, null), subHeaderText) // eslint-disable-next-line react/jsx-props-no-spreading

  }, ListProps), existingUserList.length ? existingUserList.map(function (user) {
    return /*#__PURE__*/React__default.createElement(ListItem, _extends({
      key: user.userName,
      classes: {
        container: classes.groupListItem
      },
      disabled: lockedUsers.includes(user.userName),
      onClick: onClick ? function (event) {
        return onClick(event, {
          userName: user.userName,
          userType: user
        });
      } : undefined,
      button: !!onClick // eslint-disable-next-line react/jsx-props-no-spreading

    }, ListItemProps), /*#__PURE__*/React__default.createElement(ListItemText$1, _extends({
      primary: user.userName,
      primaryTypographyProps: {
        variant: 'body2'
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, ListItemTextProps)), onRemoveUser && !disableEdit && !lockedUsers.includes(user.userName) && /*#__PURE__*/React__default.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React__default.createElement(Tooltip$1, _extends({
      title: removeTooltip // eslint-disable-next-line react/jsx-props-no-spreading

    }, RemoveTooltipProps), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(IconButton$1, _extends({
      size: "small",
      onClick: function onClick() {
        return onRemoveUser(user.userName);
      } // eslint-disable-next-line react/jsx-props-no-spreading

    }, RemoveIconButtonProps), /*#__PURE__*/React__default.createElement(RemoveIcon, null))))));
  }) :
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-props-no-spreading
  React__default.createElement(ListItem, EmptyListItemProps, /*#__PURE__*/React__default.createElement(ListItemText$1, _extends({
    primary: emptyText,
    primaryTypographyProps: {
      variant: 'caption'
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, EmptyListItemTextProps))), onAddUsers && !disableEdit && /*#__PURE__*/React__default.createElement(ListItem, _extends({
    button: true,
    className: classes.addGroupListItem,
    onClick: function onClick() {
      return setAddActive(function (prev) {
        return !prev;
      });
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, AddListItemProps), /*#__PURE__*/React__default.createElement(ListItemIcon, null, /*#__PURE__*/React__default.createElement(AddIcon, {
    className: clsx(classes.toggleIcon, _defineProperty({}, classes.toggleIconActive, addActive))
  })), /*#__PURE__*/React__default.createElement(ListItemText$1, _extends({
    primary: addText,
    primaryTypographyProps: {
      variant: 'body1'
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, AddListItemTextProps)))), onAddUsers && !disableEdit &&
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-props-no-spreading
  React__default.createElement(Collapse$1, _extends({
    "in": addActive,
    timeout: "auto"
  }, CollapseProps), /*#__PURE__*/React__default.createElement("div", {
    className: classes.inputGroup
  }, /*#__PURE__*/React__default.createElement(Autocomplete$1, _extends({
    onChange: function onChange(_, val) {
      return setValue(val);
    },
    value: value,
    multiple: true,
    options: availableUsers,
    getOptionDisabled: function getOptionDisabled(option) {
      return existingUserList.findIndex(function (u) {
        return u.userName === option;
      }) !== -1 || lockedUsers.includes(option);
    },
    filterSelectedOptions: true,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$3 // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, params, {
        autoFocus: true,
        label: inputLabel // eslint-disable-next-line react/jsx-props-no-spreading

      }, AutocompleteTextFieldProps));
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, AutocompleteProps)), /*#__PURE__*/React__default.createElement(Button, _extends({
    variant: "outlined",
    color: "primary",
    onClick: function onClick() {
      onAddUsers({
        users: value
      }).then(function () {
        setAddActive(false);
        setTimeout(function () {
          setValue([]);
        }, 500);
      });
    } // eslint-disable-next-line react/jsx-props-no-spreading

  }, AddButtonProps), addButtonText))));
}
UserRelationList.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  existingUsers: index.UserListType,
  onClick: propTypes.func,
  users: index.UserListType,
  onAddUsers: propTypes.func,
  onRemoveUser: propTypes.func,
  removeTooltip: propTypes.string,
  subHeaderText: propTypes.string,
  inputLabel: propTypes.string,
  SubHeaderIcon: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  emptyText: propTypes.string,
  addText: propTypes.string,
  disableEdit: propTypes.bool,
  lockedUsers: propTypes.arrayOf(propTypes.string),
  RemoveIcon: propTypes.elementType,
  ListProps: propTypes.objectOf(propTypes.any),
  ListSubheaderProps: propTypes.objectOf(propTypes.any),
  ListItemProps: propTypes.objectOf(propTypes.any),
  ListItemTextProps: propTypes.objectOf(propTypes.any),
  EmptyListItemProps: propTypes.objectOf(propTypes.any),
  EmptyListItemTextProps: propTypes.objectOf(propTypes.any),
  RemoveTooltipProps: propTypes.objectOf(propTypes.any),
  RemoveIconButtonProps: propTypes.objectOf(propTypes.any),
  AddListItemProps: propTypes.objectOf(propTypes.any),
  AddIcon: propTypes.elementType,
  AddListItemTextProps: propTypes.objectOf(propTypes.any),
  CollapseProps: propTypes.objectOf(propTypes.any),
  AutocompleteProps: propTypes.objectOf(propTypes.any),
  AutocompleteTextFieldProps: propTypes.objectOf(propTypes.any),
  AddButtonProps: propTypes.objectOf(propTypes.any),
  addButtonText: propTypes.string
};
UserRelationList.defaultProps = {
  className: undefined,
  classes: {},
  existingUsers: {},
  users: {},
  onClick: undefined,
  onAddUsers: undefined,
  onRemoveUser: undefined,
  removeTooltip: 'Remove',
  subHeaderText: 'Users',
  inputLabel: 'Select users',
  SubHeaderIcon: false,
  emptyText: 'No users',
  addText: 'Add users',
  disableEdit: false,
  lockedUsers: [],
  RemoveIcon: Cancel,
  ListProps: {},
  ListSubheaderProps: {},
  ListItemProps: {},
  ListItemTextProps: {},
  EmptyListItemProps: {},
  EmptyListItemTextProps: {},
  RemoveTooltipProps: {},
  RemoveIconButtonProps: {},
  AddListItemProps: {},
  AddIcon: Add,
  AddListItemTextProps: {},
  CollapseProps: {},
  AutocompleteProps: {},
  AutocompleteTextFieldProps: {},
  AddButtonProps: {},
  addButtonText: 'Add'
};

var UserRelationList$1 = withStyles(styles$1Y, {
  name: 'VdtUserRelationList'
})(UserRelationList);

var styles$1Z = function styles() {
  return {
    TableRow: {},
    TableCell: {}
  };
};

function GroupRow(_ref) {
  var classes = _ref.classes,
      _ref$group = _ref.group,
      group = _ref$group === void 0 ? {} : _ref$group,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      onClick = _ref.onClick,
      TableRowProps = _objectWithoutProperties(_ref, ["classes", "group", "columns", "onClick"]);

  return /*#__PURE__*/React__default.createElement(TableRow$3, _extends({
    onClick: onClick !== undefined ? function () {
      return onClick(group);
    } : undefined,
    style: {
      cursor: onClick !== undefined ? 'pointer' : 'initial'
    },
    className: classes.TableRow // eslint-disable-next-line react/jsx-props-no-spreading

  }, TableRowProps), columns.map(function (_ref2) {
    var value = _ref2.value,
        valueComponent = _ref2.valueComponent;
    return /*#__PURE__*/React__default.createElement(TableCell, {
      key: value,
      className: classes.TableCell
    }, valueComponent ? valueComponent(group[value], group) : group[value]);
  }));
}

var GroupRow$1 = withStyles(styles$1Z, {
  name: 'VdtGroupRow'
})(GroupRow);

var styles$1_ = function styles() {
  return {
    root: {},
    TableContainer: {},
    Table: {},
    TableHead: {},
    TableHeadRow: {},
    TableHeadCell: {},
    TableBody: {}
  };
};
function GroupTable(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      groups = _ref.groups,
      columns = _ref.columns,
      hideHeader = _ref.hideHeader,
      GroupRowComponent = _ref.GroupRowComponent,
      GroupRowProps = _ref.GroupRowProps,
      groupColumnLabels = _ref.groupColumnLabels;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(TableContainer, {
    className: classes.TableContainer
  }, /*#__PURE__*/React__default.createElement(Table, {
    className: classes.Table
  }, !hideHeader && /*#__PURE__*/React__default.createElement(TableHead$1, {
    className: classes.TableHead
  }, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.TableHeadRow
  }, columns.map(function (_ref2) {
    var value = _ref2.value;
    return /*#__PURE__*/React__default.createElement(TableCell, {
      key: groupColumnLabels[value],
      className: classes.TableHeadCell
    }, groupColumnLabels[value]);
  }))), /*#__PURE__*/React__default.createElement(TableBody, {
    className: classes.TableBody
  }, groups.map(function (group) {
    return /*#__PURE__*/React__default.createElement(GroupRowComponent, _extends({
      key: group.groupName,
      group: group,
      columns: columns // eslint-disable-next-line react/jsx-props-no-spreading

    }, GroupRowProps));
  })))));
}
GroupTable.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  groups: propTypes.arrayOf(propTypes.any),
  columns: propTypes.arrayOf(propTypes.any),
  hideHeader: propTypes.bool,
  GroupRowComponent: propTypes.elementType,
  GroupRowProps: propTypes.objectOf(propTypes.any),
  groupColumnLabels: propTypes.objectOf(propTypes.string)
};
GroupTable.defaultProps = {
  className: undefined,
  classes: {},
  groups: [],
  columns: [{
    value: 'groupName'
  }, {
    value: 'role',
    valueComponent: function valueComponent(value) {
      return value ? 'Role' : 'Group';
    }
  }],
  hideHeader: false,
  GroupRowComponent: GroupRow$1,
  GroupRowProps: {},
  groupColumnLabels: {
    groupName: 'Groupname',
    role: 'Type'
  }
};

var index$a = withStyles(styles$1_, {
  name: 'VdtGroupTable'
})(GroupTable);

var styles$1$ = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column'
    },
    ListSubheader: {
      display: 'grid',
      gridAutoFlow: 'column',
      gridTemplateColumns: 'auto 1fr',
      alignItems: 'center',
      gridGap: theme.spacing(1)
    },
    List: {}
  };
};

var getRoleValue = function getRoleValue(role) {
  return role ? 'Role' : 'Group';
};

function GroupData(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      groupType = _ref.groupType,
      _ref$SubHeaderText = _ref.SubHeaderText,
      SubHeaderText = _ref$SubHeaderText === void 0 ? 'Details' : _ref$SubHeaderText,
      _ref$SubHeaderIcon = _ref.SubHeaderIcon,
      SubHeaderIcon = _ref$SubHeaderIcon === void 0 ? false : _ref$SubHeaderIcon,
      _ref$groupNameText = _ref.groupNameText,
      groupNameText = _ref$groupNameText === void 0 ? 'Group name' : _ref$groupNameText,
      _ref$descriptionText = _ref.descriptionText,
      descriptionText = _ref$descriptionText === void 0 ? 'Description' : _ref$descriptionText,
      _ref$typeText = _ref.typeText,
      typeText = _ref$typeText === void 0 ? 'Type' : _ref$typeText;
  var groupName = groupType.groupName,
      description = groupType.description,
      role = groupType.role,
      _groupType$metadata = groupType.metadata;
  _groupType$metadata = _groupType$metadata === void 0 ? {} : _groupType$metadata;
  var _groupType$metadata$f = _groupType$metadata.field,
      metadataFields = _groupType$metadata$f === void 0 ? [] : _groupType$metadata$f;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement(List, {
    className: classes.List,
    dense: true,
    subheader: /*#__PURE__*/React__default.createElement(ListSubheader$1, {
      disableGutters: true,
      className: classes.ListSubheader
    }, SubHeaderIcon && /*#__PURE__*/React__default.createElement(SubHeaderIcon, null), SubHeaderText)
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText$1, {
    primary: groupNameText,
    secondary: groupName
  })), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText$1, {
    primary: descriptionText,
    secondary: description || '-'
  })), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText$1, {
    primary: typeText,
    secondary: getRoleValue(role)
  })), metadataFields && metadataFields.map(function (field) {
    return /*#__PURE__*/React__default.createElement(ListItem, {
      key: field.key
    }, /*#__PURE__*/React__default.createElement(ListItemText$1, {
      primary: field.key,
      secondary: field.value
    }));
  })));
}

var GroupData$1 = withStyles(styles$1$, {
  name: 'VdtGroupData'
})(GroupData);

function GroupMenu(_ref) {
  var groupType = _ref.groupType,
      onEdit = _ref.onEdit,
      onDelete = _ref.onDelete,
      _ref$editGroupText = _ref.editGroupText,
      editGroupText = _ref$editGroupText === void 0 ? 'Edit Group' : _ref$editGroupText,
      _ref$deleteGroupText = _ref.deleteGroupText,
      deleteGroupText = _ref$deleteGroupText === void 0 ? 'Delete Group' : _ref$deleteGroupText,
      props = _objectWithoutProperties(_ref, ["groupType", "onEdit", "onDelete", "editGroupText", "deleteGroupText"]);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React__default.createElement(Menu$1, props, /*#__PURE__*/React__default.createElement(MenuItem$1, {
      onClick: onEdit,
      disabled: onEdit === undefined
    }, editGroupText), /*#__PURE__*/React__default.createElement(MenuItem$1, {
      onClick: function onClick() {
        return onDelete(groupType);
      },
      disabled: onDelete === undefined
    }, deleteGroupText))
  );
}

var styles$20 = function styles(theme) {
  return {
    root: {
      display: 'grid',
      gridGap: theme.spacing(2),
      '& .MuiListItem-gutters': {
        paddingLeft: '30px'
      }
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  };
};
function GroupDetails(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      groupType = _ref.groupType,
      groupListType = _ref.groupListType,
      userListType = _ref.userListType,
      onEdit = _ref.onEdit,
      onDelete = _ref.onDelete,
      onAddChildGroups = _ref.onAddChildGroups,
      onAddParentGroups = _ref.onAddParentGroups,
      onAddUsersToGroup = _ref.onAddUsersToGroup,
      onRemoveUser = _ref.onRemoveUser,
      onRemoveChildGroup = _ref.onRemoveChildGroup,
      onRemoveFromParent = _ref.onRemoveFromParent,
      DetailsComponent = _ref.DetailsComponent,
      DetailsProps = _ref.DetailsProps,
      UsersComponent = _ref.UsersComponent,
      UsersProps = _ref.UsersProps,
      RolesComponent = _ref.RolesComponent,
      RolesProps = _ref.RolesProps,
      ParentGroupsComponent = _ref.ParentGroupsComponent,
      ParentGroupsProps = _ref.ParentGroupsProps,
      ChildGroupsComponent = _ref.ChildGroupsComponent,
      ChildGroupsProps = _ref.ChildGroupsProps,
      MenuComponent = _ref.MenuComponent,
      MenuProps = _ref.MenuProps,
      lockedGroups = _ref.lockedGroups,
      lockedUsers = _ref.lockedUsers;

  var _ref2 = groupType || {},
      groupName = _ref2.groupName,
      role = _ref2.role,
      _ref2$parentGroupList = _ref2.parentGroupList,
      parentGroupList = _ref2$parentGroupList === void 0 ? {} : _ref2$parentGroupList,
      _ref2$childGroupList = _ref2.childGroupList,
      childGroupList = _ref2$childGroupList === void 0 ? {} : _ref2$childGroupList,
      _ref2$userList = _ref2.userList,
      userList = _ref2$userList === void 0 ? {} : _ref2$userList;

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var locked = lockedGroups.includes(groupName);

  var handleMenuClick = function handleMenuClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleMenuClose = function handleMenuClose() {
    setAnchorEl(null);
  }; // TODO fix prettier formatter for ternary

  /* eslint-disable prettier/prettier */


  var handleClickClose = function handleClickClose(onClick) {
    return onClick ? function (args) {
      onClick(args);
      handleMenuClose();
    } : undefined;
  };
  /* eslint-enable prettier/prettier */


  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h5"
  }, groupName), MenuComponent && !role && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: handleMenuClick,
    disabled: lockedGroups.includes(groupName)
  }, /*#__PURE__*/React__default.createElement(MoreVertIcon, null)), /*#__PURE__*/React__default.createElement(MenuComponent, _extends({
    groupType: groupType,
    open: Boolean(anchorEl),
    onClose: handleMenuClose,
    anchorEl: anchorEl,
    onDelete: handleClickClose(onDelete),
    onEdit: handleClickClose(onEdit) // eslint-disable-next-line react/jsx-props-no-spreading

  }, MenuProps)))), DetailsComponent && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DetailsComponent, _extends({
    groupType: groupType,
    SubHeaderIcon: DescriptionIcon // eslint-disable-next-line react/jsx-props-no-spreading

  }, DetailsProps)), /*#__PURE__*/React__default.createElement(Divider, null)), UsersComponent && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(UsersComponent, _extends({
    existingUsers: userList,
    users: userListType,
    onRemoveUser: onRemoveUser,
    onAddUsers: onAddUsersToGroup,
    lockedUsers: lockedUsers,
    SubHeaderIcon: UserIcon // eslint-disable-next-line react/jsx-props-no-spreading

  }, UsersProps)), /*#__PURE__*/React__default.createElement(Divider, null)), RolesComponent && !role && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(RolesComponent, _extends({
    existingGroups: parentGroupList,
    groups: groupListType,
    onRemoveGroup: onRemoveFromParent,
    onAddGroups: onAddParentGroups,
    SubHeaderIcon: RoleIcon,
    disableEdit: locked,
    showGroups: false,
    removeTooltip: "Remove from role",
    subHeaderText: "Roles",
    inputLabel: "Select roles",
    emptyText: "Not member of any roles",
    addText: "Add roles" // eslint-disable-next-line react/jsx-props-no-spreading

  }, RolesProps)), /*#__PURE__*/React__default.createElement(Divider, null)), ParentGroupsComponent && !role && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ParentGroupsComponent, _extends({
    existingGroups: parentGroupList,
    groups: groupListType,
    onRemoveGroup: onRemoveFromParent,
    onAddGroups: onAddParentGroups,
    SubHeaderIcon: GroupIcon,
    disableEdit: locked,
    showRoles: false,
    removeTooltip: "Remove from group",
    subHeaderText: "Parent groups",
    emptyText: "Not member of any groups",
    addText: "Add parents",
    lockedGroups: lockedGroups // eslint-disable-next-line react/jsx-props-no-spreading

  }, ParentGroupsProps)), /*#__PURE__*/React__default.createElement(Divider, null)), ChildGroupsComponent && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChildGroupsComponent, _extends({
    existingGroups: childGroupList,
    groups: groupListType,
    onRemoveGroup: onRemoveChildGroup,
    onAddGroups: onAddChildGroups,
    SubHeaderIcon: GroupIcon,
    disableEdit: locked,
    showRoles: false,
    subHeaderText: "Child groups",
    addText: "Add children",
    lockedGroups: lockedGroups // eslint-disable-next-line react/jsx-props-no-spreading

  }, ChildGroupsProps)), /*#__PURE__*/React__default.createElement(Divider, null)));
}
GroupDetails.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  groupType: index.GroupType,
  groupListType: index.GroupListType,
  userListType: index.UserListType,
  onEdit: propTypes.func,
  onDelete: propTypes.func,
  onAddChildGroups: propTypes.func,
  onAddParentGroups: propTypes.func,
  onAddUsersToGroup: propTypes.func,
  onRemoveUser: propTypes.func,
  onRemoveChildGroup: propTypes.func,
  onRemoveFromParent: propTypes.func,
  DetailsComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  DetailsProps: propTypes.objectOf(propTypes.any),
  UsersComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  UsersProps: propTypes.objectOf(propTypes.any),
  RolesComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  RolesProps: propTypes.objectOf(propTypes.any),
  ParentGroupsComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  ParentGroupsProps: propTypes.objectOf(propTypes.any),
  ChildGroupsComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  ChildGroupsProps: propTypes.objectOf(propTypes.any),
  MenuComponent: propTypes.oneOfType([propTypes.elementType, propTypes.oneOf([false])]),
  MenuProps: propTypes.objectOf(propTypes.any),
  lockedGroups: propTypes.arrayOf(propTypes.string),
  lockedUsers: propTypes.arrayOf(propTypes.string)
};
GroupDetails.defaultProps = {
  classes: {},
  className: undefined,
  groupType: {},
  groupListType: {},
  userListType: {},
  onEdit: undefined,
  onDelete: undefined,
  onAddChildGroups: undefined,
  onAddParentGroups: undefined,
  onAddUsersToGroup: undefined,
  onRemoveUser: undefined,
  onRemoveChildGroup: undefined,
  onRemoveFromParent: undefined,
  DetailsComponent: GroupData$1,
  DetailsProps: {},
  UsersComponent: UserRelationList$1,
  UsersProps: {},
  RolesComponent: GroupRealtionList,
  RolesProps: {},
  ParentGroupsComponent: GroupRealtionList,
  ParentGroupsProps: {},
  ChildGroupsComponent: GroupRealtionList,
  ChildGroupsProps: {},
  MenuComponent: GroupMenu,
  MenuProps: {},
  lockedGroups: ['_special_all', 'vidinetGroup'],
  lockedUsers: ['admin', 'vidinetviewer']
};

var index$b = withStyles(styles$20, {
  name: 'VdtGroupDetails'
})(GroupDetails);

var styles$21 = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
      }
    },
    action: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  };
};

function CreateGroupForm(_ref) {
  var classes = _ref.classes,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? 'Create' : _ref$submitText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
      users = _ref.users,
      groups = _ref.groups,
      roles = _ref.roles,
      _ref$groupNameLabel = _ref.groupNameLabel,
      groupNameLabel = _ref$groupNameLabel === void 0 ? 'Group name' : _ref$groupNameLabel,
      _ref$descriptionLabel = _ref.descriptionLabel,
      descriptionLabel = _ref$descriptionLabel === void 0 ? 'Description' : _ref$descriptionLabel,
      _ref$usersLabel = _ref.usersLabel,
      usersLabel = _ref$usersLabel === void 0 ? 'Add users' : _ref$usersLabel,
      _ref$rolesLabel = _ref.rolesLabel,
      rolesLabel = _ref$rolesLabel === void 0 ? 'Add roles' : _ref$rolesLabel,
      _ref$parentGroupsLabe = _ref.parentGroupsLabel,
      parentGroupsLabel = _ref$parentGroupsLabe === void 0 ? 'Add parent groups' : _ref$parentGroupsLabe,
      _ref$childGroupsLabel = _ref.childGroupsLabel,
      childGroupsLabel = _ref$childGroupsLabel === void 0 ? 'Add child groups' : _ref$childGroupsLabel;
  var groupNameRef = React__default.useRef();
  var descriptionRef = React__default.useRef();

  var _React$useState = React__default.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      userList = _React$useState2[0],
      setUserList = _React$useState2[1];

  var _React$useState3 = React__default.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      parentGroups = _React$useState4[0],
      setParentGroups = _React$useState4[1];

  var _React$useState5 = React__default.useState([]),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      childGroups = _React$useState6[0],
      setChildGroups = _React$useState6[1];

  var _React$useState7 = React__default.useState([]),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      roleList = _React$useState8[0],
      setRoleList = _React$useState8[1];

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();

    var groupDocument = _objectSpread2(_objectSpread2({
      groupName: groupNameRef.current.value
    }, descriptionRef.current.value && {
      description: descriptionRef.current.value
    }), {}, {
      parentGroupList: {
        group: parentGroups.concat(roleList).map(function (g) {
          return {
            groupName: g
          };
        })
      },
      childGroupList: {
        group: childGroups.map(function (g) {
          return {
            groupName: g
          };
        })
      },
      userList: {
        user: userList.map(function (u) {
          return {
            userName: u
          };
        })
      }
    });

    onSubmit({
      groupDocument: groupDocument
    });
  };

  var optionInChildGroups = function optionInChildGroups(option) {
    return childGroups.includes(option);
  };

  var optionInParentGroups = function optionInParentGroups(option) {
    return parentGroups.includes(option);
  };

  return /*#__PURE__*/React__default.createElement("form", {
    className: classes.root,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    required: true,
    name: "groupName",
    label: groupNameLabel,
    inputRef: groupNameRef
  }), /*#__PURE__*/React__default.createElement(TextField$3, {
    name: "description",
    label: descriptionLabel,
    inputRef: descriptionRef
  }), /*#__PURE__*/React__default.createElement(Autocomplete$1, {
    name: "users",
    multiple: true,
    options: users,
    filterSelectedOptions: true,
    value: userList,
    onChange: function onChange(_, val) {
      return setUserList(val);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$3 // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, params, {
        label: usersLabel
      }));
    }
  }), /*#__PURE__*/React__default.createElement(Autocomplete$1, {
    name: "roles",
    multiple: true,
    options: roles,
    filterSelectedOptions: true,
    value: roleList,
    onChange: function onChange(_, val) {
      return setRoleList(val);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$3 // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, params, {
        label: rolesLabel
      }));
    }
  }), /*#__PURE__*/React__default.createElement(Autocomplete$1, {
    name: "parentGroups",
    multiple: true,
    options: groups,
    filterSelectedOptions: true,
    value: parentGroups,
    getOptionDisabled: optionInChildGroups,
    onChange: function onChange(_, val) {
      return setParentGroups(val);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$3 // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, params, {
        label: parentGroupsLabel
      }));
    }
  }), /*#__PURE__*/React__default.createElement(Autocomplete$1, {
    name: "childGroups",
    multiple: true,
    options: groups,
    filterSelectedOptions: true,
    value: childGroups,
    getOptionDisabled: optionInParentGroups,
    onChange: function onChange(_, val) {
      return setChildGroups(val);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$3 // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, params, {
        label: childGroupsLabel
      }));
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classes.action
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: onCancel
  }, cancelText), /*#__PURE__*/React__default.createElement(Button, {
    variant: "contained",
    color: "primary",
    type: "submit"
  }, submitText)));
}

var CreateGroupForm$1 = withStyles$1(styles$21, {
  name: 'VdtCreateGroupForm'
})(CreateGroupForm);

var styles$22 = function styles() {
  return {
    root: {},
    DialogTitle: {},
    DialogContent: {}
  };
};
function CreateGroupDialog(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      groupListType = _ref.groupListType,
      userListType = _ref.userListType,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      titleText = _ref.titleText,
      CreateGroupFormProps = _ref.CreateGroupFormProps;

  var _React$useMemo = React__default.useMemo(function () {
    var _groupListType$group = groupListType.group,
        allGroups = _groupListType$group === void 0 ? [] : _groupListType$group;
    return allGroups.reduce(function (_ref2, c) {
      var _ref3 = _slicedToArray(_ref2, 2),
          isTrue = _ref3[0],
          isFalse = _ref3[1];

      return c.role ? [[].concat(_toConsumableArray(isTrue), [c]), isFalse] : [isTrue, [].concat(_toConsumableArray(isFalse), [c])];
    }, [[], []]).map(function (gr) {
      return gr.map(function (g) {
        return g.groupName;
      });
    });
  }, [groupListType]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      roles = _React$useMemo2[0],
      groups = _React$useMemo2[1];

  var users = React__default.useMemo(function () {
    var _userListType$user = userListType.user,
        userList = _userListType$user === void 0 ? [] : _userListType$user;
    return userList.map(function (u) {
      return u.userName;
    });
  }, [userListType]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, titleText && /*#__PURE__*/React__default.createElement(DialogTitle, {
    className: classes.DialogTitle
  }, titleText), /*#__PURE__*/React__default.createElement(DialogContent, {
    className: classes.DialogContent
  }, /*#__PURE__*/React__default.createElement(CreateGroupForm$1, _extends({
    onSubmit: onSubmit,
    onCancel: onClose,
    users: users,
    roles: roles,
    groups: groups // eslint-disable-next-line react/jsx-props-no-spreading

  }, CreateGroupFormProps))));
}
CreateGroupDialog.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  titleText: propTypes.string,
  onClose: propTypes.func,
  onSubmit: propTypes.func,
  groupListType: index.GroupListType,
  userListType: index.UserListType,
  CreateGroupFormProps: propTypes.objectOf(propTypes.any)
};
CreateGroupDialog.defaultProps = {
  classes: {},
  className: undefined,
  titleText: 'Create Group',
  onClose: undefined,
  onSubmit: undefined,
  groupListType: {},
  userListType: {},
  CreateGroupFormProps: {}
};

var index$c = withStyles(styles$22, {
  name: 'VdtCreateGroupDialog'
})(CreateGroupDialog);

var styles$23 = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
      }
    },
    action: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  };
};

function EditGroupForm(_ref) {
  var classes = _ref.classes,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? 'Save' : _ref$submitText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
      _ref$descriptionLabel = _ref.descriptionLabel,
      descriptionLabel = _ref$descriptionLabel === void 0 ? 'Description' : _ref$descriptionLabel,
      groupType = _ref.groupType;
  var descriptionRef = React__default.useRef();

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var groupDocument = {
      description: descriptionRef.current.value
    };
    onSubmit({
      groupDocument: groupDocument
    });
  };

  return /*#__PURE__*/React__default.createElement("form", {
    className: classes.root,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React__default.createElement(TextField$3, {
    defaultValue: groupType.description,
    name: "description",
    label: descriptionLabel,
    inputRef: descriptionRef
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classes.action
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: onCancel
  }, cancelText), /*#__PURE__*/React__default.createElement(Button, {
    variant: "contained",
    color: "primary",
    type: "submit"
  }, submitText)));
}

var EditGroupForm$1 = withStyles$1(styles$23, {
  name: 'VdtEditGroupForm'
})(EditGroupForm);

var styles$24 = function styles() {
  return {
    root: {},
    DialogTitle: {},
    DialogContent: {}
  };
};
function CreateUserDialog$3(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      groupType = _ref.groupType,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      titleText = _ref.titleText,
      EditGroupFormProps = _ref.EditGroupFormProps;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.root, className)
  }, titleText && /*#__PURE__*/React__default.createElement(DialogTitle, {
    className: classes.DialogTitle
  }, titleText), /*#__PURE__*/React__default.createElement(DialogContent, {
    className: classes.DialogContent
  }, /*#__PURE__*/React__default.createElement(EditGroupForm$1, _extends({
    onSubmit: onSubmit,
    onCancel: onClose,
    groupType: groupType // eslint-disable-next-line react/jsx-props-no-spreading

  }, EditGroupFormProps))));
}
CreateUserDialog$3.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: propTypes.objectOf(propTypes.string),

  /**
   * @ignore
   */
  className: propTypes.string,
  titleText: propTypes.string,
  groupType: index.GroupType,
  onClose: propTypes.func,
  onSubmit: propTypes.func,
  EditGroupFormProps: propTypes.objectOf(propTypes.any)
};
CreateUserDialog$3.defaultProps = {
  classes: {},
  className: undefined,
  titleText: 'Edit Group',
  groupType: {},
  onClose: undefined,
  onSubmit: undefined,
  EditGroupFormProps: {}
};

var index$d = withStyles(styles$24, {
  name: 'VdtEditGroupDialog'
})(CreateUserDialog$3);

export { AddRelationDialog$1 as AddRelationDialog, AddToCollectionDialog$1 as AddToCollectionDialog, AutocompleteField$1 as AutocompleteField, BatonAnalysisDialog$1 as BatonAnalysisDialog, BatonFormComponent as BatonAnalysisForm, BinList$1 as BinList, BinListMenu$1 as BinListMenu, ChangePasswordDialog$1 as ChangePasswordDialog, ChangePasswordForm$1 as ChangePasswordForm, index$9 as ChangeUserPasswordDialog, CheckboxField$1 as CheckboxField, CheckboxGroupField$1 as CheckboxGroupField, CollectionAccessTab$1 as CollectionAccessTab, CollectionCard, CollectionContent$1 as CollectionContent, CollectionCreateDialog$1 as CollectionCreateDialog, CollectionGrid, CollectionList$1 as CollectionList, CollectionMetadataEdit, CollectionMetadataTab$1 as CollectionMetadataTab, CollectionRow, CollectionSearchPicker$1 as CollectionSearchPicker, CollectionTable, CollectionTreeList$1 as CollectionTreeList, index$c as CreateGroupDialog, index$7 as CreateUserDialog, DateField$1 as DateField, DragAndDropContext, DragAndDropProvider, DragLayer, COLLECTION$1 as ENTITY_TREE_COLLECTION, ITEM as ENTITY_TREE_ITEM, JOIN_CHARACTER as ENTITY_TREE_JOIN_CHARACTER, ROOT as ENTITY_TREE_ROOT, index$d as EditGroupDialog, index$8 as EditUserDialog, EntityCard, EntityComment$1 as EntityComment, EntityDeleteDialog$1 as EntityDeleteDialog, EntityGrid, EntityGridItemDraggable$1 as EntityGridItemDraggable, EntityTable, EntityTableRowDraggable$1 as EntityTableRowDraggable, EntityTree$1 as EntityTree, EntityTreeContext, EntityTreeList, Event$1 as Event, EventContainer$1 as EventContainer, EventMarker$1 as EventMarker, EventMarkerThumbnail$1 as EventMarkerThumbnail, EventMarkerTimeline$1 as EventMarkerTimeline, index$2 as EventTimeline, ExpandedFormControlLabel$1 as ExpandedFormControlLabel, FILE, FieldGroupDesigner$1 as FieldGroupDesigner, FieldIcon$1 as FieldIcon, FilterCard$1 as FilterCard, FilterForm, FilterFormLabel$1 as FilterFormLabel, FolderListTree, FolderTree, index$b as GroupDetails, GroupRealtionList as GroupRelationList, index$a as GroupTable, ItemAccessTab$1 as ItemAccessTab, ItemCard, ItemFieldGroupTab$1 as ItemFieldGroupTab, ItemGrid, ItemGridDroppable, ItemImagePlayer$1 as ItemImagePlayer, ItemList$1 as ItemList, ItemListItem$1 as ItemListItem, ItemMetadataFieldGroupRow, ItemMetadataFieldRow$1 as ItemMetadataFieldRow, ItemMetadataFieldRow$1 as ItemMetadataFormRow, ItemMetadataFormTable, ItemMetadataTab$1 as ItemMetadataTab, ItemParentsTab$1 as ItemParentsTab, ItemPlayer, ItemPoster, ItemPosterTab, ItemRelationRemoveDialog$1 as ItemRelationRemoveDialog, ItemRelationsTab$1 as ItemRelationsTab, ItemRow, ItemSearchPicker$1 as ItemSearchPicker, ItemShapeTab, ItemShapeTable$1 as ItemShapeTable, index$1 as ItemSidecarDialog, ItemSidecarDownload$1 as ItemSidecarDownload, ItemSidecarUpload$1 as ItemSidecarUpload, ItemSourceTab, ItemSourceTable$1 as ItemSourceTable, ItemTable, ItemTabs, ItemTimespanBox$1 as ItemTimespanBox, ItemTimespanEdit$1 as ItemTimespanEdit, ItemTimespanFilter$1 as ItemTimespanFilter, ItemTimespanForm$1 as ItemTimespanForm, ItemTimespanInterval, ItemTimespanIntervalBox$1 as ItemTimespanIntervalBox, ItemTimespanTab, ItemTreeItem$1 as ItemTreeItem, ItemVideoPlayer$1 as ItemVideoPlayer, JOIN_CHARACTER$1 as JOIN_CHARACTER, JobCard$1 as JobCard, JobDataTable$1 as JobDataTable, JobFooter, JobFooterContext, JobFooterContextProvider, JobList$1 as JobList, JobRow$1 as JobRow, JobRowButton, JobTable$1 as JobTable, JobTaskTable$1 as JobTaskTable, LOAD_MORE$1 as LOAD_MORE, LayoutButtonGroup$1 as LayoutButtonGroup, LoginForm, MediaBadge$1 as MediaBadge, MediaBadges$1 as MediaBadges, MediaCard$1 as MediaCard, MediaCardActions, MediaCardAvatar$1 as MediaCardAvatar, MediaCardCard$1 as MediaCardCard, MediaCardCheckbox, MediaCardContent, MediaCardDurationLabel, index$4 as MediaCardFullWidth, MediaCardHeader, MediaCardMenu, MediaCardThumbnail$1 as MediaCardThumbnail, MediaCardThumbnailLabel$1 as MediaCardThumbnailLabel, MimeTypeIcon$1 as MimeTypeIcon, PREFIX, SearchPagination as Pagination, SearchPaginationActions as PaginationActions, QueryBetween$1 as QueryBetween, QueryBuilder$1 as QueryBuilder, index$3 as QueryBuilderCard, QueryContains$1 as QueryContains, QueryEntry$1 as QueryEntry, QueryEquals$1 as QueryEquals, QueryField$1 as QueryField, QueryGroup$1 as QueryGroup, QueryInput$1 as QueryInput, QueryOperator$1 as QueryOperator, RadioField$1 as RadioField, RemoveFromCollectionDialog, STORAGE, SavedSearch$1 as SavedSearch, SearchInput$1 as SearchInput, SearchInputFieldSelect$1 as SearchInputFieldSelect, SearchResultRow, SearchResultTable, SearchSuggestions$1 as SearchSuggestions, SelectField$1 as SelectField, SelectedEntityWrapper, SelectedFile, SelectedFileWrapper, SelectedStorage, SelectedStorageWrapper, SelectedToolbar$1 as SelectedToolbar, ShapeTagCard$1 as ShapeTagCard, ShapeTagListAccordion$1 as ShapeTagListAccordion, SliderField, Sort$1 as Sort, SortMenuItem, SpellCheck$1 as SpellCheck, Storage, StorageList, StorageListTree, StorageTree, SubmitButton, SwitchField$1 as SwitchField, TagField$1 as TagField, TextField$1 as TextField, ThemeContext, ThemeProvider, TranscodeDialog$1 as TranscodeDialog, Upload$1 as Upload, UploadEditor$1 as UploadEditor, UploadForm$1 as UploadForm, UploadListItem$1 as UploadListItem, UserAvatarButton$1 as UserAvatarButton, index$6 as UserDetails, UserRelationList$1 as UserRelationList, index$5 as UserTable, extractEntityInfo, onGetToken, useConfirmationDialog, useMediaCardContext, useMenu, useSnackbarAlert, useThemeContext, withDrag, withDrop };
